import { currentTheme, smetaStore } from "../../atoms";

function StyleSmartWebcomponents() {
  const theme = smetaStore.get(currentTheme);
  return (
    <style>
      {`
   :root {
    // --indicatorColor: #faf9f5;
    --accent-blue: rgb(98, 142, 184);
    --bg-blue:#f8f8f8;
    --accent-light:#faf9f5;
    --font-color-blue:#ffffff;
    --bg-light:#faf9f5;
    --selected-light:#dcd8cc;
    --font-color-light:#616161;
    --accordion-light: #dcd8cc;
    --header-light: #dcd8cc;
    --iconButtonColor: #ffffff;
    --iconButtonColor-light:#616161;
    --iconColorStimate: rgb(4, 4, 4);
    --iconColorStimate-light: rgb(179, 173, 151);
    --darker-light:#c6ba97;
    --toastify-color-light: #fff;
    --toastify-color-dark: #121212;
    --toastify-color-info: #3498db;
    --toastify-color-success: #07bc0c;
    --toastify-color-warning: #f1c40f;
    --toastify-color-error: #e74c3c;
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
    --toastify-toast-width: 320px;
    --toastify-toast-background: #fff;
    --toastify-toast-min-height: 64px;
    --toastify-toast-max-height: 800px;
    --toastify-font-family: sans-serif;
    --toastify-z-index: 9999;
    --toastify-text-color-light: #757575;
    --toastify-text-color-dark: #fff;
    --toastify-text-color-info: #fff;
    --toastify-text-color-success: #fff;
    --toastify-text-color-warning: #fff;
    --toastify-text-color-error: #fff;
    --toastify-spinner-color: #616161;
    --toastify-spinner-color-empty-area: #e0e0e0;
    --toastify-color-progress-light: linear-gradient(
      to right,
      #4cd964,
      #5ac8fa,
      #007aff,
      #34aadc,
      #5856d6,
      #ff2d55
    );
    --toastify-color-progress-dark: #bb86fc;
    --toastify-color-progress-info: var(--toastify-color-info);
    --toastify-color-progress-success: var(--toastify-color-success);
    --toastify-color-progress-warning: var(--toastify-color-warning);
    --toastify-color-progress-error: var(--toastify-color-error);
    --smart-primary-rgb: 99,159,230;
    --smart-primary: #dcd8cc;
    --smart-primary-color: #616161;
    --smart-secondary-rgb: 45, 45, 48;
    --smart-secondary: rgb(var(--smart-secondary-rgb));
    --smart-secondary-color: #fff;
    --smart-error-rgb: 176, 0, 32;
    --smart-error: rgb(var(--smart-error-rgb));
    --smart-error-color: #fff;
    --smart-success-rgb: 139, 195, 74;
    --smart-success: rgb(var(--smart-success-rgb));
    --smart-success-color: #fff;
    --smart-info-rgb: 92, 192, 222;
    --smart-info: rgb(var(--smart-info-rgb));
    --smart-info-color: #fff;
    --smart-warning-rgb: 240, 173, 78;
    --smart-warning: rgb(var(--smart-warning-rgb));
    --smart-warning-color: #fff;
    --smart-light-rgb: 255, 255, 255;
    --smart-light: rgb(var(--smart-light-rgb));
    --smart-light-color: #222;
    --smart-dark-rgb: 34, 34, 34;
    --smart-dark: rgb(var(--smart-dark-rgb));
    --smart-dark-color: #fff;
    --smart-background: #fefefe;
    --smart-background-color: #212529;
    --smart-surface: #f5f5f5;
    --smart-surface-color: #323232;
    --smart-disabled: #ccc;
    --smart-disabled-color: #555;
    --smart-ui-state-hover: #ebebeb;
    --smart-ui-state-color-hover: #333;
    --smart-ui-state-border-hover: var(--smart-ui-state-hover);
    --smart-ui-state-active: var(--smart-primary);
    --smart-ui-state-color-active: var(--smart-primary-color);
    --smart-ui-state-border-active: var(--smart-primary);
    --smart-ui-state-focus: #e2e0e0;
    --smart-ui-state-color-focus: #333;
    --smart-ui-state-border-focus: var(--smart-ui-state-focus);
    --smart-ui-state-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-primary);
    --smart-ui-state-border-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-item-border-width: 1px;
    --smart-item-border-radius: var(--smart-border-radius);
    --smart-item-border-top-left-radius: var(--smart-border-radius);
    --smart-item-border-top-right-radius: var(--smart-border-radius);
    --smart-item-border-bottom-left-radius: var(--smart-border-radius);
    --smart-item-border-bottom-right-radius: var(--smart-border-radius);
    --smart-font-size: 14px;
    --smart-font-weight: inherit;
    --smart-font-style: inherit;
    --smart-font-family: Roboto, "Helvetica Neue", sans-serif;
    --smart-font-family-icon: smart-icons;
    --smart-font-family-icon-src: local("fonts/smart-icons"), url(fonts/smart-icons.woff2) format("woff2"), url(fonts/smart-icons.woff) format("woff"), url(fonts/smart-icons.ttf) format("truetype"), url(fonts/smart-icons.eot) format("embedded-opentype");
    --smart-border-width: 1px;
    --smart-border-radius: 4px;
    --smart-border-top-left-radius: var(--smart-border-radius);
    --smart-border-top-right-radius: var(--smart-border-radius);
    --smart-border-bottom-left-radius: var(--smart-border-radius);
    --smart-border-bottom-right-radius: var(--smart-border-radius);
    --smart-border: #e0e0e0;
    --smart-border-rgb: 244, 224, 224;
    --smart-outline: #b2b2b2;
    --smart-editor-selection: var(--smart-primary);
    --smart-editor-selection-color: var(--smart-primary-color);
    --smart-alternation-index0-color: var(--smart-surface-color);
    --smart-alternation-index0-border: var(--smart-surface);
    --smart-alternation-index0-background: var(--smart-surface);
    --smart-alternation-index1-color: #111;
    --smart-alternation-index1-border: #9bbb59;
    --smart-alternation-index1-background: #9bbb59;
    --smart-alternation-index2-color: #fff;
    --smart-alternation-index2-border: #fc3752;
    --smart-alternation-index2-background: #fc3752;
    --smart-tick-color: var(--smart-border);
    --smart-tick-label-color: var(--smart-background-color);
    --smart-box-height: 450px;
    --smart-box-width: 450px;
    --smart-bar-height: 48px;
    --smart-bar-width: 400px;
    --smart-editor-height: 30px;
    --smart-editor-width: 250px;
    --smart-editor-drop-down-width: 300px;
    --smart-editor-drop-down-height: 400px;
    --smart-editor-drop-down-padding-size: 3px;
    --smart-editor-drop-down-max-width: 800px;
    --smart-editor-drop-down-min-width: 100px;
    --smart-editor-drop-down-max-height: 400px;
    --smart-editor-drop-down-min-height: 50px;
    --smart-editor-drop-down-resize-bar-height: 15px;
    --smart-editor-drop-down-vertical-offset: 5px;
    --smart-editor-drop-down-z-index: 9999;
    --smart-editor-label-padding: 4px;
    --smart-editor-addon-width: 27px;
    --smart-column-icon-size: 30px;
    --smart-icon-table: "\\e800";
    --smart-icon-star: "\\e801";
    --smart-icon-star-empty: "\\e802";
    --smart-icon-plus: "\\e803";
    --smart-icon-minus: "\\e804";
    --smart-icon-attention-circled: "\\e805";
    --smart-icon-align-left: "\\e806";
    --smart-icon-align-right: "\\e807";
    --smart-icon-align-center: "\\e808";
    --smart-icon-align-justify: "\\e813";
    --smart-icon-reload: "\\e809";
    --smart-icon-cancel: "\\1F5D9";
    --smart-icon-close: "\\1F5D9";
    --smart-icon-cancel-circled: "\\e80e";
    --smart-icon-plus-circled: "\\e810";
    --smart-icon-power: "\\e811";
    --smart-icon-minus-circled: "\\e814";
    --smart-icon-arrow-up-alt: "\\e817";
    --smart-icon-radio: "\\e818";
    --smart-icon-refresh: "\\e819";
    --smart-icon-chart: "\\e81a";
    --smart-icon-check-squared: "\\e81b";
    --smart-icon-resize-full: "\\e81c";
    --smart-icon-resize-small: "\\e81d";
    --smart-icon-resize-vertical: "\\e80c";
    --smart-icon-resize-horizontal: "\\e80f";
    --smart-icon-lock: "\\e821";
    --smart-icon-sort: "\\e823";
    --smart-icon-delete: "\\e826";
    --smart-icon-search: "\\1F50D";
    --smart-icon-calendar: "\\e829";
    --smart-icon-edit: "\\e82a";
    --smart-icon-popup: "\\e82c";
    --smart-icon-lock-open: "\\e82e";
    --smart-icon-add-filter: "\\e82f";
    --smart-icon-block: "\\e832";
    --smart-icon-settings: "\\e833";
    --smart-icon-duplicate: "\\e834";
    --smart-icon-copy-record: "\\e835";
    --smart-icon-download-alt: "\\e836";
    --smart-icon-clock: "\\e837";
    --smart-icon-attention: "\\e838";
    --smart-icon-help-circled: "\\e839";
    --smart-icon-mail: "\\e83c";
    --smart-icon-up: "\\e83f";
    --smart-icon-first-page: "\\e900";
    --smart-icon-arrow-down: "\\2BC6";
    --smart-icon-arrow-left: "\\e902";
    --smart-icon-arrow-right: "\\e903";
    --smart-icon-arrow-up: "\\2BC5";
    --smart-icon-arrow-down-filled: "\\e812";
    --smart-icon-arrow-left-filled: "\\e816";
    --smart-icon-arrow-right-filled: "\\e81e";
    --smart-icon-arrow-up-filled: "\\e815";
    --smart-icon-last-page: "\\e905";
    --smart-icon-more-horiz: "\\e906";
    --smart-icon-skip-next: "\\e907";
    --smart-icon-check: "\\1F5F8";
    --smart-icon-mode-edit: "\\e909";
    --smart-icon-replay: "\\e90c";
    --smart-icon-visibility: "\\e90d";
    --smart-icon-visibility-off: "\\e90e";
    --smart-icon-link: "\\e831";
    --smart-icon-unlink: "\\f127";
    --smart-icon-link-ext: "\\f08e";
    --smart-icon-check-empty: "\\f096";
    --smart-icon-filter: "\\f0b0";
    --smart-icon-resize-full-alt: "\\f0b2";
    --smart-icon-menu: "\\f0c9";
    --smart-icon-sort-1: "\\f0dc";
    --smart-icon-paste: "\\f0ea";
    --smart-icon-circle-empty: "\\f10c";
    --smart-icon-circle: "\\f111";
    --smart-icon-ellipsis: "\\f141";
    --smart-icon-minus-squared: "\\f146";
    --smart-icon-ok-squared: "\\f14a";
    --smart-icon-sort-name-up: "\\f15d";
    --smart-icon-sort-name-down: "\\f15e";
    --smart-icon-sort-alt-up: "\\f160";
    --smart-icon-sort-alt-down: "\\f161";
    --smart-icon-sort-number-up: "\\f162";
    --smart-icon-sort-number-down: "\\f163";
    --smart-icon-dot-circled: "\\f192";
    --smart-icon-toggle-off: "\\f204";
    --smart-icon-toggle-on: "\\f205";
    --smart-icon-group: "\\f247";
    --smart-icon-ungroup: "\\f248";
    --smart-icon-window-maximize: "\\1F5D6";
    --smart-icon-window-minimize: "\\1F5D5";
    --smart-icon-window-restore: "\\1F5D7";
    --smart-icon-window-pin-alt: "\\e82d";
    --smart-icon-window-pin: "\\e80a";
    --smart-icon-docs: "\\f0c5";
    --smart-icon-math: "\\f01a";
    --smart-icon-spin: "\\e80b";
    --smart-icon-user: "\\e81f";
    --smart-icon-font: "\\f031";
    --smart-icon-fontsize: "\\f088";
    --smart-icon-contains: "\\f063";
    --smart-icon-starts_with: "\\f064";
    --smart-icon-ends_with: "\\f065";
    --smart-icon-does_not_contain: "\\f066";
    --smart-icon-equals: "\\f52c";
    --smart-icon-greater-than: "\\f531";
    --smart-icon-greater-than-equal: "\\f532";
    --smart-icon-less-than: "\\f536";
    --smart-icon-less-than-equal: "\\f537";
    --smart-icon-not-equal: "\\f53e";
    --smart-icon-percentage: "\\f541";
    --smart-icon-grip-vertical: "\\f58e";
    --smart-icon-between: "\\f06a";
    --smart-icon-bold: "\\e820";
    --smart-icon-italic: "\\e822";
    --smart-icon-underline: "\\f0cd";
    --smart-icon-strike-through: "\\f0cc";
    --smart-icon-list-ordered: "\\f0cb";
    --smart-icon-list-unordered: "\\f0ca";
    --smart-icon-subscript: "\\f12c";
    --smart-icon-superscript: "\\f12b";
    --smart-icon-color-background: "\\e830";
    --smart-icon-indent-right: "\\e824";
    --smart-icon-indent-left: "\\e825";
    --smart-icon-image: "\\e827";
    --smart-icon-case-lower: "aa";
    --smart-icon-case-upper: "AA";
    --smart-icon-print: "\\e82b";
    --smart-icon-format-clear: "T";
    --smart-icon-source-code: "\\f121";
    --smart-icon-split-mode: "\\e83b";
    --smart-icon-cut: "\\e83a";
    --smart-icon-video: "\\f16a";
    --smart-icon-header: "\\f1dc";
    --smart-icon-row: "\\f0db";
    --smart-icon-row-before: "\\f2d0";
    --smart-icon-row-after: "\\f2d0";
    --smart-icon-row-delete: var(--smart-icon-cancel-circled);
    --smart-icon-column: "\\f0db";
    --smart-icon-column-left: "\\f2d0";
    --smart-icon-column-right: "\\f2d0";
    --smart-icon-column-delete: var(--smart-icon-cancel-circled);
    --smart-icon-vertical-align: "\\f06a \\e80c";
    --smart-icon-styles: "\\f1fc";
    --smart-icon-comment: "\\f0E5";
    --smart-icon-card: "\\e83E";
    --smart-icon-tasks: "\\f0AE";
    --smart-icon-phone: "\\e83D";
    --smart-icon-kanban: "\\f181";
    --smart-icon-table-alt: "\\f0CE";
    --smart-accordion-animation-duration: 225ms;
    --smart-accordion-default-width: var(--smart-box-width);
    --smart-accordion-default-height: var(--smart-box-height);
    --smart-accordion-expanded-content-height: 0px;
    --smart-accordion-expanded-content-local-height: 0px;
    --smart-accordion-item-header-height: var(--smart-bar-height);
    --smart-accordion-item-expanded-offset: 20px;
    --smart-array-default-width: var(--smart-box-width);
    --smart-array-default-height: var(--smart-box-height);
    --smart-array-element-gap: 3px;
    --smart-breadcrumb-default-width: 400px;
    --smart-breadcrumb-default-height: auto;
    --smart-breadcrumb-padding: 10px;
    --smart-breadcrumb-drop-down-width: var(--smart-editor-drop-down-width);
    --smart-breadcrumb-item-height: 40px;
    --smart-breadcrumb-horizontal-offset: 10px;
    --smart-button-text-transform: uppercase;
    --smart-button-padding: 8px 16px;
    --smart-button-large-padding: 10px 16px;
    --smart-button-large-font-size: 18px;
    --smart-button-small-padding: 5px 10px;
    --smart-button-small-font-size: 12px;
    --smart-button-very-small-padding: 3px 5px;
    --smart-button-very-small-font-size: 10px;
    --smart-button-flat-color: var(--smart-background-color);
    --smart-button-outlined-color: var(--smart-background-color);
    --smart-button-outlined-border: var(--smart-border);
    --smart-button-group-default-width: auto;
    --smart-button-group-default-height: auto;
    --smart-calendar-header-height: calc(var(--smart-bar-height)*0.75);
    --smart-calendar-footer-height: calc(var(--smart-bar-height)*0.75);
    --smart-calendar-title-height: calc(var(--smart-bar-height)*1.25);
    --smart-calendar-cell-size: 30px;
    --smart-calendar-cell-spacing: 4px;
    --smart-calendar-default-width: calc(50px + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7);
    --smart-calendar-default-height: calc(var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height));
    --smart-calendar-title-text-transform: initial;
    --smart-calendar-week-title-text-transform: uppercase;
    --smart-calendar-header-text-transform: uppercase;
    --smart-calendar-footer-text-transform: uppercase;
    --smart-calendar-cell-border-top-right-radius: 15px;
    --smart-calendar-cell-border-top-left-radius: 15px;
    --smart-calendar-cell-border-bottom-left-radius: 15px;
    --smart-calendar-cell-border-bottom-right-radius: 15px;
    --smart-calendar-title-padding: 10px;
    --smart-calendar-important-date-background: var(--smart-ui-state-hover);
    --smart-calendar-important-date-color: var(--smart-ui-state-color-hover);
    --smart-calendar-important-date-border-color: var(--smart-ui-state-border-hover);
    --smart-calendar-navigation-button-size: 30px;
    --smart-card-view-default-width: 1200px;
    --smart-card-view-default-height: 800px;
    --smart-card-view-header-height: 30px;
    --smart-card-view-cover-height: var(--smart-carousel-default-height);
    --smart-card-view-vertical-offset: 15px;
    --smart-card-view-column-min-width: 250px;
    --smart-card-view-gap: 10px;
    --smart-card-view-add-new-button-size: 60px;
    --smart-carousel-default-width: 600px;
    --smart-carousel-default-height: 200px;
    --smart-carousel-3d-mode-slide-width: 400px;
    --smart-carousel-3d-mode-slide-height: 400px;
    --smart-carousel-multiple-mode-slide-width: 200px;
    --smart-chart-default-width: 850px;
    --smart-chart-default-height: 500px;
    --smart-check-box-default-size: calc(1px + var(--smart-editor-height)*0.5);
    --smart-color-panel-default-width: auto;
    --smart-color-panel-default-height: auto;
    --smart-color-panel-palette-size: 300px;
    --smart-color-panel-grid-mode-item-size: 20px;
    --smart-color-panel-grid-mode-column-count: 8;
    --smart-color-panel-grid-mode-columns-gap: 1px;
    --smart-color-panel-brightness: 0;
    --smart-color-panel-default-mode-sections-gap: 8px;
    --smart-color-panel-palette-width: var(--smart-color-panel-palette-size);
    --smart-color-panel-palette-height: var(--smart-color-panel-palette-size);
    --smart-color-panel-alpha-channel-color: #fff;
    --smart-color-picker-default-width: var(--smart-editor-width);
    --smart-color-picker-default-height: var(--smart-editor-height);
    --smart-color-picker-drop-down-width: auto;
    --smart-color-picker-drop-down-height: auto;
    --smart-combo-box-default-width: var(--smart-editor-width);
    --smart-combo-box-default-height: var(--smart-editor-height);
    --smart-combo-box-drop-down-width: auto;
    --smart-combo-box-drop-down-height: auto;
    --smart-chip-default-height: var(--smart-editor-height);
    --smart-chip-avatar-background: var(--smart-secondary);
    --smart-currency-format-panel-currency-holder-width: 1fr;
    --smart-currency-format-panel-apply-button-width: 125px;
    --smart-currency-format-panel-header-holder-offset: 2%;
    --smart-currency-format-panel-currency-holder-input-width: 1fr;
    --smart-currency-format-panel-currency-holder-dropdown-width: 165px;
    --smart-currency-format-panel-currency-holder-dropdown-button-width: 95%;
    --smart-currency-format-panel-border-size: 1px;
    --smart-currency-format-panel-border-color: #ccc;
    --smart-currency-format-panel-border-radius: 4px;
    --smart-currency-format-panel-currencies-margin-top: 15px;
    --smart-currency-format-panel-currencies-max-height: 400px;
    --smart-currency-format-panel-currencies-item-padding: 12px;
    --smart-currency-format-panel-currency-holder-padding-left: 5px;
    --smart-currency-format-panel-currency-holder-padding-top: 3px;
    --smart-currency-format-panel-currency-holder-padding-bottom: 3px;
    --smart-currency-format-panel-currency-input-width: 100%;
    --smart-currency-format-panel-currencies-left-padding: 10px;
    --smart-currency-format-panel-currencies-hover-background: #f1f1f1;
    --smart-currency-format-panel-currencies-example-format-color: #777;
    --smart-data-view-padding: 10px;
    --smart-data-view-customize-panel-width: 320px;
    --smart-data-view-filter-panel-width: 550px;
    --smart-data-view-sort-panel-width: 450px;
    --smart-data-view-search-panel-width: 250px;
    --smart-date-format-panel-main-container-width: 960px;
    --smart-date-format-panel-main-container-padding: 15px;
    --smart-date-format-panel-border-radius: 4px;
    --smart-date-format-panel-border-size: 1px;
    --smart-date-format-panel-border-color: #ccc;
    --smart-date-format-panel-smart-inputs-container-width: 1fr;
    --smart-date-format-panel-apply-container-width: 150px;
    --smart-date-format-panel-smart-input-buttons-column-gap: 2%;
    --smart-date-format-panel-smart-inputs-holder-width: 94%;
    --smart-date-format-panel-add-format-holder-width: 6%;
    --smart-date-format-panel-smart-inputs-list-holder-offset: 2px;
    --smart-date-format-panel-smart-input-format-width: 150px;
    --smart-date-format-panel-smart-input-sign-width: 80px;
    --smart-date-format-panel-smart-input-height: 25px;
    --smart-date-format-panel-each-smart-input-offset: 4px;
    --smart-date-format-panel-all-format-holders-width: 255px;
    --smart-date-format-panel-add-format-holder-button: 120px;
    --smart-date-format-panel-each-add-format-holder-width: 120px;
    --smart-date-format-panel-add-new-format-dropdown-offset: 5px;
    --smart-date-format-panel-date-time-format-list-offset-top: 15px;
    --smart-date-format-panel-date-time-format-list-max-height: 400px;
    --smart-date-format-panel-each-date-time-format-offset: 12px;
    --smart-date-time-picker-default-width: var(--smart-editor-width);
    --smart-date-time-picker-default-height: var(--smart-editor-height);
    --smart-date-time-picker-header-opacity: 0.8;
    --smart-date-time-picker-header-opacity-active: 1;
    --smart-date-time-picker-drop-down-width: var(--smart-editor-drop-down-height);
    --smart-date-time-picker-drop-down-height: auto;
    --smart-docking-layout-default-width: 1000px;
    --smart-docking-layout-default-height: 800px;
    --smart-docking-layout-feedback-background-secondary-size: 7px;
    --smart-drop-down-list-default-width: var(--smart-editor-width);
    --smart-drop-down-list-default-height: var(--smart-editor-height);
    --smart-drop-down-list-drop-down-width: initial;
    --smart-drop-down-list-drop-down-height: auto;
    --smart-drop-down-button-default-width: auto;
    --smart-drop-down-button-default-height: var(--smart-editor-height);
    --smart-drop-down-button-drop-down-width: var(--smart-editor-drop-down-width);
    --smart-drop-down-button-drop-down-height: var(--smart-editor-drop-down-height);
    --smart-editor-default-width: 100%;
    --smart-editor-default-height: 600px;
    --smart-editor-input-min-height: 100px;
    --smart-editor-padding: 15px;
    --smart-editor-toolbar-item-margin: 5px;
    --smart-editor-toolbar-button-width: 30px;
    --smart-editor-toolbar-delimiter-width: 5px;
    --smart-editor-toolbar-drop-down-width-large: 100px;
    --smart-editor-toolbar-drop-down-width-small: 65px;
    --smart-editor-window-header-height: var(--smart-scheduler-window-header-height);
    --smart-editor-window-footer-height: var(--smart-scheduler-window-footer-height);
    --smart-editor-inline-toolbar-max-width: 80vw;
    --smart-editor-table-column-width: initial;
    --smart-editor-table-cell-min-height: 20px;
    --smart-editor-table-cell-min-width: var(--smart-editor-table-cell-min-height);
    --smart-editor-char-counter-offset: 30px;
    --smart-editor-toolbar-item-height: 30px;
    --smart-editor-toolbar-item-border-radius: var(--smart-border-radius);
    --smart-editor-toolbar-height: calc(var(--smart-editor-toolbar-item-height) + var(--smart-editor-toolbar-item-margin)*2);
    --smart-editor-highlight: var(--smart-primary);
    --smart-editor-highlight-color: var(--smart-primary-color);
    --smart-editor-search-bar-offset: 5px;
    --smart-editor-search-bar-padding: 5px;
    --smart-filter-builder-default-width: var(--smart-box-width);
    --smart-filter-builder-default-height: var(--smart-box-height);
    --smart-filter-builder-row-height: var(--smart-editor-height);
    --smart-filter-builder-item-width: var(--smart-editor-width);
    --smart-filter-builder-group-container-border: 4px;
    --smart-filter-builder-item-margin: 20px;
    --smart-filter-builder-group-condition-margin: 5px;
    --smart-filter-builder-group-margin: 15px;
    --smart-filter-panel-default-width: 300px;
    --smart-filter-panel-default-height: auto;
    --smart-filter-panel-padding: 10px;
    --smart-filter-panel-border-top-right-radius: var(--smart-border-radius);
    --smart-filter-panel-border-top-left-radius: var(--smart-border-radius);
    --smart-filter-panel-border-bottom-left-radius: var(--smart-border-radius);
    --smart-filter-panel-border-bottom-right-radius: var(--smart-border-radius);
    --smart-filter-panel-border-width: var(--smart-border-width);
    --smart-filter-panel-border: var(--smart-border);
    --smart-filter-panel-background: var(--smart-background);
    --smart-filter-panel-color: var(--smart-background-color);
    --smart-filter-panel-vertical-offset: 10px;
    --smart-filter-panel-main-element-height: 400px;
    --smart-file-upload-default-width: var(--smart-editor-width);
    --smart-file-upload-browse-button-width: auto;
    --smart-file-upload-browse-button-height: auto;
    --smart-file-upload-footer-button-width: auto;
    --smart-file-upload-footer-button-height: auto;
    --smart-file-upload-text-content-uploading-start: "Connecting ...";
    --smart-file-upload-text-content-uploading: "Uploading ...";
    --smart-file-upload-text-content-error: "Upload error!";
    --smart-file-upload-text-content-pause: "Upload paused!";
    --smart-file-upload-text-content-drop-zone: "Drag files here";
    --smart-file-upload-text-content-drop-zone-over: "Drop here \\e824";
    --smart-file-upload-container-min-height: 60px;
    --smart-file-upload-total-files-min-height: 20px;
    --smart-file-upload-drop-zone-height: 100%;
    --smart-gantt-chart-resource-splitter-bar-fit-size: calc(var(--smart-gantt-chart-resource-timeline-content-height) + var(--smart-gantt-chart-task-default-height));
    --smart-gantt-chart-task-splitter-bar-fit-size: var(--smart-gantt-chart-task-timeline-content-height);
    --smart-gantt-chart-task-default-height: 30px;
    --smart-gantt-chart-header-height: var(--smart-gantt-chart-task-default-height);
    --smart-gantt-chart-task-bar-fill-padding: 5px;
    --smart-gantt-chart-task-label-padding: 2px var(--smart-gantt-chart-task-bar-fill-padding);
    --smart-gantt-chart-task-thumb-color: rgba(0, 0, 0, .55);
    --smart-gantt-chart-task-progress-color: rgba(0, 0, 0, .15);
    --smart-gantt-chart-project-color: #ffa558;
    --smart-gantt-chart-project-label-color: #333;
    --smart-gantt-chart-project-label-color-selected: #000;
    --smart-gantt-chart-project-progress-color: var(--smart-gantt-chart-task-progress-color);
    --smart-gantt-chart-task-color: #2bc3be;
    --smart-gantt-chart-milestone-color: purple;
    --smart-gantt-chart-timeline-task-background-color: transparent;
    --smart-gantt-chart-timeline-task-connection-feedback-color: #e6510a;
    --smart-gantt-chart-timeline-task-connection-feedback-width: 1px;
    --smart-gantt-chart-timeline-task-connection-feedback-style: dashed;
    --smart-gantt-chart-timeline-task-connection-color: var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    --smart-gantt-chart-timeline-task-connection-color-hover: var(--smart-gantt-chart-timeline-task-connection-color);
    --smart-gantt-chart-timeline-task-connection-width: var(--smart-gantt-chart-timeline-task-connection-feedback-width);
    --smart-gantt-chart-timeline-task-connection-style: solid;
    --smart-gantt-chart-timeline-task-connection-arrow-type: solid;
    --smart-gantt-chart-timeline-task-connection-arrow-width: 5px;
    --smart-gantt-chart-timeline-task-resize-indicator-width: 4px;
    --smart-gantt-chart-timeline-task-resize-indicator-color: #fff;
    --smart-gantt-chart-timeline-task-resize-indicator-border-color: #333;
    --smart-gantt-chart-timeline-task-progress-thumb-size: 10px;
    --smart-gantt-chart-timeline-cell-size: auto;
    --smart-gantt-chart-timeline-cell-min-size: 70px;
    --smart-gantt-chart-timeline-task-min-width: 5px;
    --smart-gantt-chart-timeline-weekend-color: #eff5fd;
    --smart-gantt-chart-timeline-nonworking-color: #f5f5f5;
    --smart-gantt-chart-default-width: auto;
    --smart-gantt-chart-default-height: 600px;
    --smart-gantt-chart-task-popup-window-default-width: 60vw;
    --smart-gantt-chart-connection-popup-window-default-width: 300px;
    --smart-gantt-chart-confirm-popup-window-default-width: var(--smart-gantt-chart-connection-popup-default-width);
    --smart-gantt-chart-popup-window-header-height: 35px;
    --smart-gantt-chart-popup-window-footer-height: 50px;
    --smart-gantt-chart-header-placeholder: " - ";
    --smart-gantt-chart-progress-label-padding: 0 10px 0 10px;
    --smart-gantt-chart-filter-row-height: 30px;
    --smart-gantt-chart-task-fill-border-radius: 0;
    --smart-gantt-chart-segment-link-color: var(--smart-gantt-chart-task-color);
    --smart-gantt-chart-segment-link-size: var(--smart-border-width);
    --smart-gantt-chart-date-marker-height: 25px;
    --smart-gantt-chart-date-marker-width: var(--smart-border-width);
    --smart-gantt-chart-date-marker-background: var(--smart-primary);
    --smart-gantt-chart-date-marker-color: var(--smart-primary-color);
    --smart-gantt-chart-date-marker-v-offset: 15%;
    --smart-gantt-chart-date-marker-h-offset: 10px;
    --smart-gantt-chart-indicator-icon: initial;
    --smart-gantt-chart-deadline-icon: var(--smart-icon-attention-circled);
    --smart-gantt-chart-deadline-color: var(--smart-error);
    --smart-gantt-chart-baseline-proportion: 2;
    --smart-gantt-chart-baseline-background: rgba(166, 205, 87, .5);
    --smart-gantt-chart-progress-label-width: 60px;
    --smart-gantt-chart-current-time-indicator-size: 1px;
    --smart-gantt-chart-current-time-indicator-background: var(--smart-primary);
    --smart-gantt-chart-current-time-indicator-arrow-size: 7px;
    --smart-gantt-chart-current-time-indicator-header-size: 2px;
    --smart-gantt-chart-shader-background: rgba(var(--smart-border-rgb), .5);
    --smart-gauge-default-width: var(--smart-box-width);
    --smart-gauge-default-height: var(--smart-box-height);
    --smart-gauge-track-border: var(--smart-border);
    --smart-gauge-track-background: var(--smart-background);
    --smart-gauge-needle-background: var(--smart-primary);
    --smart-gauge-label-fill-state: initial;
    --smart-gauge-label-stroke: initial;
    --smart-grid-default-width: 800px;
    --smart-grid-default-height: 400px;
    --smart-grid-footer-height: var(--smart-bar-height);
    --smart-grid-header-height: var(--smart-bar-height);
    --smart-grid-group-header-height: var(--smart-bar-height);
    --smart-grid-row-height: 30px;
    --smart-grid-column-header-height: var(--smart-bar-height);
    --smart-grid-filter-footer-height: var(--smart-bar-height);
    --smart-grid-aggregate-footer-height: var(--smart-bar-height);
    --smart-grid-header-background-freeze: var(--smart-surface);
    --smart-grid-header-color-freeze: var(--smart-surface-color);
    --smart-grid-column-menu-width: 200px;
    --smart-grid-column-menu-height: auto;
    --smart-grid-column-buttons-width: 23px;
    --smart-grid-cell-color-freeze: var(--smart-surface-color);
    --smart-grid-cell-background-freeze: var(--smart-surface);
    --smart-grid-cell-color-delete: #333;
    --smart-grid-cell-background-delete: #ffdcdc;
    --smart-grid-cell-color-update: #333;
    --smart-grid-cell-background-update: #d7f9c7;
    --smart-grid-cell-color-add: #333;
    --smart-grid-cell-background-add: #fed59b;
    --smart-grid-cell-color-unbound: var(--smart-surface-color);
    --smart-grid-cell-background-unbound: var(--smart-surface);
    --smart-grid-cell-color-sort: var(--smart-surface-color);
    --smart-grid-cell-background-sort: var(--smart-surface);
    --smart-grid-cell-color-filter: var(--smart-surface-color);
    --smart-grid-cell-background-filter: var(--smart-surface);
    --smart-grid-group-row-vertical-offset: 5;
    --smart-grid-group-row-horizontal-offset: 1;
    --smart-grid-template-columns: none;
    --smart-grid-column-gap: 0px;
    --smart-grid-row-gap: 0px;
    --smart-grid-freeze-splitter-size: 1px;
    --smart-grid-resize-line-size: 1px;
    --smart-grid-layout-col-gap: 10px;
    --smart-grid-layout-row-gap: 10px;
    --smart-grid-layout-width: 100%;
    --smart-grid-layout-rows: none;
    --smart-grid-panel-default-width: 450px;
    --smart-grid-panel-default-height: auto;
    --smart-grid-panel-padding: 10px;
    --smart-grid-panel-vertical-offset: 10px;
    --smart-grid-panel-item-height: 30px;
    --smart-column-panel-drop-down-height: 350px;
    --smart-multi-column-filter-panel-template-columns: 15px 60px 2fr 3fr 3fr;
    --smart-formatting-panel-default-width: 600px;
    --smart-formatting-panel-row-height: 30px;
    --smart-formatting-panel-add-new-button-size: 40px;
    --smart-formatting-panel-popup-width: 300px;
    --smart-formatting-panel-color-box-height: 20px;
    --smart-kanban-default-width: 1200px;
    --smart-kanban-default-height: 500px;
    --smart-kanban-header-size: 35px;
    --smart-kanban-task-min-width: 150px;
    --smart-kanban-task-min-height: 80px;
    --smart-kanban-text-max-height: 200px;
    --smart-kanban-user-icon-size: 30px;
    --smart-kanban-user-list-width: 150px;
    --smart-kanban-user-list-max-height: 400px;
    --smart-kanban-comments-list-width: 350px;
    --smart-kanban-comments-list-height: 400px;
    --smart-kanban-new-comment-height: 50px;
    --smart-kanban-new-comment-height-expanded: 175px;
    --smart-kanban-send-button-height: 30px;
    --smart-kanban-color-band-width: 3px;
    --smart-kanban-add-new-column-width: 1fr;
    --smart-list-box-default-width: var(--smart-editor-width);
    --smart-list-box-default-height: var(--smart-editor-width);
    --smart-list-item-group-header-text-transform: uppercase;
    --smart-list-item-horizontal-offset: 3px;
    --smart-list-item-vertical-offset: 3px;
    --smart-list-item-height: 36px;
    --smart-list-item-check-box-radius: 2px;
    --smart-list-item-label-padding: 0;
    --smart-list-item-label-border-radius: 0;
    --smart-list-item-padding: 9px 12px;
    --smart-loader-size: var(--smart-editor-height);
    --smart-led-default-width: var(--smart-editor-height);
    --smart-led-default-height: var(--smart-editor-height);
    --smart-list-menu-default-width: var(--smart-box-width);
    --smart-list-menu-default-height: var(--smart-box-height);
    --smart-list-menu-filter-input-vertical-offset: 5px;
    --smart-list-menu-filter-input-horizontal-offset: 5px;
    --smart-masked-text-box-default-width: var(--smart-editor-width);
    --smart-masked-text-box-default-height: var(--smart-editor-height);
    --smart-menu-default-width: var(--smart-bar-width);
    --smart-menu-default-height: var(--smart-bar-height);
    --smart-menu-vertical-default-width: calc(var(--smart-bar-width)/2);
    --smart-menu-vertical-default-height: var(--smart-bar-width);
    --smart-menu-scroll-button-size: calc(var(--smart-bar-height)/1.5);
    --smart-multiline-text-box-default-width: var(--smart-editor-width);
    --smart-multiline-text-box-default-height: calc(var(--smart-editor-height)*10);
    --smart-multi-split-button-default-width: var(--smart-editor-width);
    --smart-multi-split-button-default-height: var(--smart-editor-height);
    --smart-number-format-panel-selected-format-width: 1fr;
    --smart-number-format-panel-apply-button-width: 125px;
    --smart-number-format-panel-header-holder-offset: 10px;
    --smart-number-format-panel-border-size: 1px;
    --smart-number-format-panel-border-color: #ccc;
    --smart-number-format-panel-border-radius: 4px;
    --smart-number-format-panel-sample-container-vertical-offset: 15px;
    --smart-number-format-panel-sample-container-horizontal-offset: 5px;
    --smart-number-format-panel-formats-list-margin-top: 15px;
    --smart-number-format-panel-formats-list-max-height: 400px;
    --smart-number-format-panel-formats-item-padding: 12px;
    --smart-number-format-panel-selected-format-padding-left: 5px;
    --smart-number-format-panel-selected-format-padding-top: 3px;
    --smart-number-format-panel-selected-format-padding-bottom: 3px;
    --smart-number-format-panel-header-input-width: 100%;
    --smart-number-format-panel-formats-item-left-padding: 10px;
    --smart-number-format-panel-formats-item-hover-background: #f1f1f1;
    --smart-number-format-panel-formats-item-example-format-color: #777;
    --smart-numeric-text-box-default-width: var(--smart-editor-width);
    --smart-numeric-text-box-default-height: var(--smart-editor-height);
    --smart-numeric-text-box-default-radix-display-width: 12%;
    --smart-numeric-text-box-default-unit-display-width: var(--smart-editor-addon-width);
    --smart-numeric-text-box-text-align: right;
    --smart-path-default-width: var(--smart-editor-width);
    --smart-path-default-height: var(--smart-editor-height);
    --smart-path-drop-down-width: auto;
    --smart-path-drop-down-height: auto;
    --smart-path-button-gap: 5px;
    --smart-path-text-align: start;
    --smart-power-button-default-width: var(--smart-editor-height);
    --smart-power-button-default-height: var(--smart-editor-height);
    --smart-progress-bar-default-width: var(--smart-editor-width);
    --smart-progress-bar-default-height: var(--smart-editor-height);
    --smart-circular-progress-bar-default-size: var(--smart-editor-width);
    --smart-circular-progress-bar-fill-size: 20%;
    --smart-query-builder-default-width: auto;
    --smart-query-builder-default-height: auto;
    --smart-query-builder-min-width: 100px;
    --smart-query-builder-content-padding: 5px;
    --smart-query-builder-editor-width: 125px;
    --smart-radio-button-default-size: calc(1px + var(--smart-editor-height)*0.5);
    --smart-sortable-handle-size: 25px;
    --smart-splitter-default-width: var(--smart-box-width);
    --smart-splitter-default-height: var(--smart-box-height);
    --smart-splitter-bar-size: 7px;
    --smart-splitter-bar-fit-size: 100%;
    --smart-splitter-item-padding: 0;
    --smart-splitter-item-content-padding: 0;
    --smart-splitter-item-size: auto;
    --smart-switch-button-default-width: calc(var(--smart-editor-height) + 10px);
    --smart-switch-button-default-height: var(--smart-editor-height);
    --smart-switch-button-thumb-size: calc(var(--smart-switch-button-default-height) - 8px);
    --smart-slider-default-width: var(--smart-editor-width);
    --smart-slider-default-height: 35px;
    --smart-slider-track-size: 1px;
    --smart-slider-thumb-width: 20px;
    --smart-slider-thumb-height: 20px;
    --smart-slider-tooltip-width: 60px;
    --smart-slider-tooltip-height: 30px;
    --smart-slider-spin-button-width: 30px;
    --smart-slider-spin-button-height: 30px;
    --smart-slider-tick-size: 10px;
    --smart-slider-minor-tick-size: 5px;
    --smart-slider-thumb-border-top-right-radius: 15px;
    --smart-slider-thumb-border-top-left-radius: 15px;
    --smart-slider-thumb-border-bottom-left-radius: 15px;
    --smart-slider-thumb-border-bottom-right-radius: 15px;
    --smart-scroll-button-size: 16px;
    --smart-scroll-bar-size: 18px;
    --smart-scroll-bar-default-width: var(--smart-editor-width);
    --smart-scroll-bar-default-height: var(--smart-scroll-bar-size);
    --smart-scroll-bar-background: #f1f1f1;
    --smart-scroll-bar-track-background: var(--smart-scroll-bar-background);
    --smart-scroll-bar-border: #f1f1f1;
    --smart-scroll-bar-thumb-border-top-right-radius: 0px;
    --smart-scroll-bar-thumb-border-top-left-radius: 0px;
    --smart-scroll-bar-thumb-border-bottom-left-radius: 0px;
    --smart-scroll-bar-thumb-border-bottom-right-radius: 0px;
    --smart-scroll-bar-thumb-background: #c1c1c1;
    --smart-scroll-bar-thumb-border: transparent;
    --smart-scroll-bar-thumb-size: 100%;
    --smart-scroll-bar-thumb-padding: 1px;
    --smart-scroll-bar-thumb-background-hover: #a8a8a8;
    --smart-scroll-bar-thumb-border-hover: transparent;
    --smart-scroll-bar-thumb-background-active: #787878;
    --smart-scroll-bar-thumb-border-active: transparent;
    --smart-scroll-bar-button-background: #f1f1f1;
    --smart-scroll-bar-button-border: #f1f1f1;
    --smart-scroll-bar-button-color: #505050;
    --smart-scroll-bar-button-background-hover: #d2d2d2;
    --smart-scroll-bar-button-border-hover: #f1f1f1;
    --smart-scroll-bar-button-color-hover: #505050;
    --smart-scroll-bar-button-background-active: #787878;
    --smart-scroll-bar-button-border-active: #f1f1f1;
    --smart-scroll-bar-button-color-active: #fff;
    --smart-table-default-width: 100%;
    --smart-table-default-height: auto;
    --smart-table-header-footer-height: 56px;
    --smart-table-column-header-height: var(--smart-table-header-footer-height);
    --smart-table-row-height: 48px;
    --smart-table-cell-padding: 12px;
    --smart-table-row-detail-height: var(--smart-table-row-height);
    --smart-table-indent: 30px;
    --smart-table-arrow-size: 16px;
    --smart-table-arrow-margin: 5px;
    --smart-table-group-name-display: unset;
    --smart-table-group-count-display: unset;
    --smart-pivot-table-cell-width: 200px;
    --smart-pivot-table-secondary-group-width: calc(var(--smart-pivot-table-cell-width)*1.25);
    --smart-pivot-panel-width: 300px;
    --smart-pivot-panel-default-height: 800px;
    --smart-pivot-panel-tab-item-height: 150px;
    --smart-pivot-panel-padding: 10px;
    --smart-tank-default-width: var(--smart-editor-width);
    --smart-tank-default-height: calc(var(--smart-editor-height)*10);
    --smart-tank-scale-size: 105px;
    --smart-tank-thumb-width: 25px;
    --smart-tank-thumb-height: var(--smart-tank-thumb-width);
    --smart-tank-tooltip-width: 80px;
    --smart-tank-tooltip-height: 30px;
    --smart-tank-tick-size: 10px;
    --smart-tank-minor-tick-size: 5px;
    --smart-tank-minimum-track-size: 6px;
    --smart-tabs-header-button-size: 20px;
    --smart-tabs-animation-duration: 0.5s;
    --smart-tabs-default-width: var(--smart-box-width);
    --smart-tabs-default-height: var(--smart-box-height);
    --smart-tabs-header-padding: 0px;
    --smart-tabs-header-offset: 0px;
    --smart-tab-item-padding: 12px 16px;
    --smart-tab-item-offset: 5px;
    --smart-tab-item-initial-offset: 5px;
    --smart-tab-item-text-transform: uppercase;
    --smart-time-picker-default-width: var(--smart-editor-width);
    --smart-time-picker-default-height: calc(var(--smart-editor-height)*12);
    --smart-tooltip-arrow-width: 6px;
    --smart-tooltip-arrow-color: var(--smart-secondary);
    --smart-tooltip-arrow-translate: 0;
    --smart-tooltip-padding: 4px 8px;
    --smart-tooltip-content-shadow: none;
    --smart-toast-item-icon: "";
    --smart-toast-container-default-width: var(--smart-bar-width);
    --smart-toast-header-height: 20px;
    --smart-toast-info-background: var(--smart-info);
    --smart-toast-info-color: var(--smart-info-color);
    --smart-toast-warning-background: var(--smart-warning);
    --smart-toast-warning-color: var(--smart-warning-color);
    --smart-toast-error-background: var(--smart-error);
    --smart-toast-error-color: var(--smart-error-color);
    --smart-toast-success-background: var(--smart-success);
    --smart-toast-success-color: var(--smart-success-color);
    --smart-tree-default-width: var(--smart-box-width);
    --smart-tree-default-height: var(--smart-box-height);
    --smart-tree-scroll-button-size: 20px;
    --smart-tree-lines-style: dashed;
    --smart-tree-indent: 16px;
    --smart-tree-lines-color: var(--smart-border);
    --smart-tree-lines-width: 1px;
    --smart-tree-item-label-height: 36px;
    --smart-tree-item-padding: 9px 12px;
    --smart-tree-item-vertical-offset: 3px;
    --smart-tree-item-horizontal-offset: 3px;
    --smart-text-box-default-width: var(--smart-editor-width);
    --smart-text-box-default-height: var(--smart-editor-height);
    --smart-validation-panel-description-width: 20%;
    --smart-validation-panel-content-width: 80%;
    --smart-validation-panel-appearance-vertical-offset: 10px;
    --smart-validation-panel-appearance-reset-button-left-offset: 5px;
    --smart-validation-panel-appearance-textbox-vertical-offset: 5px;
    --smart-validation-panel-appearance-reset-button-color: var(--smart-primary);
    --smart-validation-panel-criteria-row-margin-top: 10px;
    --smart-validation-panel-criteria-container-vertical-offset: 10px;
    --smart-validation-panel-criteria-container-input-width: 180px;
    --smart-validation-panel-criteria-container-input-horizontal-offset: 2px;
    --smart-validation-panel-criteria-container-textbox-width: 80px;
    --smart-validation-panel-criteria-container-textbox-horizontal-offset: 2px;
    --smart-validation-panel-criteria-container-text-between-inputs-offset: 5px;
    --smart-validation-panel-invalid-data-vertical-offset: 10px;
    --smart-validation-panel-footer-button-color: #188038;
    --smart-validation-panel-footer-button-background: #fff;
    --smart-validation-panel-footer-vertical-offset: 20px;
    --smart-validation-panel-footer-button-horizontal-offset: 5px;
    --smart-validation-panel-footer-remove-validation-button-color: var(--smart-validation-panel-footer-button-color);
    --smart-validation-panel-footer-cancel-button-color: var(--smart-validation-panel-footer-button-color);
    --smart-validation-panel-footer-save-button-color: var(--smart-validation-panel-footer-button-background);
    --smart-validation-panel-footer-save-button-background: var(--smart-validation-panel-footer-button-color);
    --smart-password-text-box-default-width: var(--smart-editor-width);
    --smart-password-text-box-default-height: var(--smart-editor-height);
    --smart-pager-default-width: var(--smart-bar-width);
    --smart-pager-default-height: var(--smart-bar-height);
    --smart-pager-button-width: "auto";
    --smart-pager-button-height: 32px;
    --smart-pager-page-size-selector-width: 60px;
    --smart-pager-page-index-selector-width: 32px;
    --smart-pager-page-index-selector-height: 32px;
    --smart-pager-page-index-ellipsis-selector-width: 32px;
    --smart-pager-page-index-ellipsis-selector-height: 32px;
    --smart-pager-page-index-selector-horizontal-offset: 8px;
    --smart-pager-padding: 2px;
    --smart-pager-input-width: 50px;
    --smart-scroll-viewer-min-width: none;
    --smart-scroll-viewer-max-width: none;
    --smart-scroll-viewer-min-height: none;
    --smart-scroll-viewer-max-height: none;
    --smart-scheduler-default-height: auto;
    --smart-scheduler-default-width: auto;
    --smart-scheduler-item-size: auto;
    --smart-scheduler-timeline-cell-width: auto;
    --smart-scheduler-timeline-cell-height: 50px;
    --smart-scheduler-timeline-cell-min-width: 70px;
    --smart-scheduler-timeline-cell-min-height: 35px;
    --smart-scheduler-header-height: 50px;
    --smart-scheduler-header-today-button-size: 70px;
    --smart-scheduler-header-date-button-max-size: auto;
    --smart-scheduler-header-navigation-button-size: 30px;
    --smart-scheduler-footer-height: var(--smart-scheduler-header-height);
    --smart-scheduler-header-box-shadow: initial;
    --smart-scheduler-header-padding: 10px;
    --smart-scheduler-timeline-header-cell-padding: 5px;
    --smart-scheduler-header-menu-button-size: auto;
    --smart-scheduler-timeline-weekend-color: var(--smart-background);
    --smart-scheduler-timeline-nonworking-color: var(--smart-gantt-chart-timeline-nonworking-color);
    --smart-scheduler-timeline-all-day-label-font-weight: 600;
    --smart-scheduler-timeline-header-horizontal-cells-size: 40px;
    --smart-scheduler-timeline-header-horizontal-label-padding: initial;
    --smart-scheduler-timeline-header-horizontal-details-size: var(--smart-scheduler-timeline-header-horizontal-cells-size);
    --smart-scheduler-timeline-header-horizontal-group-size: var(--smart-scheduler-timeline-header-horizontal-cells-size);
    --smart-scheduler-timeline-header-vertical-cells-size: 100px;
    --smart-scheduler-timeline-header-vertical-label-padding: initial;
    --smart-scheduler-timeline-header-vertical-details-size: var(--smart-scheduler-timeline-header-vertical-cells-size);
    --smart-scheduler-timeline-header-vertical-group-size: var(--smart-scheduler-timeline-header-vertical-cells-size);
    --smart-scheduler-timeline-header-all-day-cells-size: 75px;
    --smart-scheduler-timeline-group-separator-background: var(--smart-outline);
    --smart-scheduler-timeline-group-separator-size: var(--smart-border-width);
    --smart-scheduler-timeline-group-white-space: nowrap;
    --smart-scheduler-timeline-group-header-offset: calc(-50% - var(--smart-scheduler-timeline-header-cell-padding));
    --smart-scheduler-current-time-indicator-background: var(--smart-primary);
    --smart-scheduler-current-time-indicator-size: 1px;
    --smart-scheduler-current-time-indicator-header-size: 2px;
    --smart-scheduler-current-time-indicator-arrow-size: 7px;
    --smart-scheduler-shader-background: rgba(var(--smart-border-rgb), .5);
    --smart-scheduler-view-background: transparent;
    --smart-scheduler-view-line-size: var(--smart-border-width);
    --smart-scheduler-view-horizontal-line-color: var(--smart-border);
    --smart-scheduler-view-vertical-line-color: var(--smart-border);
    --smart-scheduler-day-week-view-vertical-line-size: var(--smart-scheduler-view-line-size);
    --smart-scheduler-day-week-view-vertical-line-color: var(--smart-border);
    --smart-scheduler-day-week-view-hour-size: var(--smart-scheduler-view-line-size);
    --smart-scheduler-day-week-view-hour-color: var(--smart-border);
    --smart-scheduler-time-ruler-tick-size: 10px;
    --smart-scheduler-event-background-rgb: 52, 121, 186;
    --smart-scheduler-event-background: rgba(var(--smart-scheduler-event-background-rgb), 1);
    --smart-scheduler-legend-item-background: var(--smart-scheduler-event-background);
    --smart-scheduler-event-color: var(--smart-primary-color);
    --smart-scheduler-event-focus: rgba(var(--smart-scheduler-event-background-rgb), .9);
    --smart-scheduler-event-color-focus: var(--smart-scheduler-event-color);
    --smart-scheduler-event-hover: rgba(var(--smart-scheduler-event-background-rgb), .8);
    --smart-scheduler-event-color-hover: var(--smart-scheduler-event-color);
    --smart-scheduler-event-padding-agenda: 5px;
    --smart-scheduler-event-padding-basic: 2px;
    --smart-scheduler-event-padding-timeline: 2px;
    --smart-scheduler-event-padding-all-day: 2px;
    --smart-scheduler-event-content-padding: 5px;
    --smart-scheduler-event-label-font-size: var(--smart-font-size);
    --smart-scheduler-event-time-font-size: calc(var(--smart-font-size) - 3px);
    --smart-scheduler-event-time-font-size-agenda: var(--smart-font-size);
    --smart-scheduler-event-time-font-weight-agenda: 600;
    --smart-scheduler-event-time-opacity-agenda: 1;
    --smart-scheduler-event-time-opacity: 0.7;
    --smart-scheduler-event-icon-size: 30px;
    --smart-scheduler-event-size: 30px;
    --smart-scheduler-event-size-basic: var(--smart-scheduler-event-size);
    --smart-scheduler-event-size-timeline: 60px;
    --smart-scheduler-event-collector-size: 24px;
    --smart-scheduler-event-collector-mobile-size: 28px;
    --smart-scheduler-event-collector-background: rgba(var(--smart-primary-rgb), 1);
    --smart-scheduler-event-collector-color: var(--smart-primary-color);
    --smart-scheduler-event-collector-focus: rgba(var(--smart-primary-rgb), .9);
    --smart-scheduler-event-collector-color-focus: var(--smart-scheduler-event-collector-color);
    --smart-scheduler-event-collector-hover: rgba(var(--smart-primary-rgb), .8);
    --smart-scheduler-event-collector-color-hover: var(--smart-scheduler-event-collector-color);
    --smart-scheduler-month-view-number-size: 24px;
    --smart-scheduler-status-size: 7px;
    --smart-scheduler-status-padding: 5px;
    --smart-scheduler-status-background: transparent;
    --smart-scheduler-status-free-background: #fff;
    --smart-scheduler-status-tentative-background: 0 -244rem/5rem 5rem linear-gradient(45deg, #fd7e14 25%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 50%, #fd7e14 0, #fd7e14 75%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2));
    --smart-scheduler-status-busy-background: #dc3545;
    --smart-scheduler-status-out-of-office-background: #00a9e6;
    --smart-scheduler-cell-feedback-background: transparent;
    --smart-scheduler-event-resize-indicator-size: var(--smart-gantt-chart-timeline-task-resize-indicator-width);
    --smart-scheduler-event-resize-indicator-color: var(--smart-gantt-chart-timeline-task-resize-indicator-color);
    --smart-scheduler-event-resize-indicator-border-color: var(--smart-gantt-chart-timeline-task-resize-indicator-border-color);
    --smart-scheduler-restricted-background: 0 -245rem/12px 12px linear-gradient(135deg, rgba(255, 0, 0, .15) 25%, transparent 0, transparent 50%, rgba(255, 0, 0, .15) 0, rgba(255, 0, 0, .15) 75%, transparent 0, transparent);
    --smart-scheduler-event-item-size: 50px;
    --smart-scheduler-event-button-size: 30px;
    --smart-scheduler-event-border-radius: initial;
    --smart-scheduler-event-collector-border-radius: 20px;
    --smart-scheduler-context-menu-max-height: calc(var(--smart-scheduler-event-item-size)*4);
    --smart-scheduler-context-menu-max-width: 300px;
    --smart-scheduler-window-header-height: var(--smart-gantt-chart-popup-window-header-height);
    --smart-scheduler-window-footer-height: var(--smart-gantt-chart-popup-window-footer-height);
    --smart-scheduler-event-label-font-weight: 300;
    --smart-scheduler-event-time-font-weight: 300;
    --smart-scheduler-event-item-label-font-weight: 600;
    --smart-scheduler-toast-default-width: 400px;
    --smart-scheduler-toast-default-height: 50px;
    --smart-scheduler-shortcut-size: 28px;
    --smart-window-default-height: var(--smart-box-height);
    --smart-window-default-width: var(--smart-box-width);
    --smart-window-header-height: var(--smart-bar-height);
    --smart-window-footer-height: var(--smart-bar-height);
    --smart-window-min-width: 250px;
    --smart-window-header-padding: 10px;
    --smart-window-footer-padding: 6.5px;
    --smart-window-header-button-size: 24px;
    --smart-window-header-icon-size: var(--smart-font-size);
    --smart-window-header-background: var(--smart-surface);
    --smart-window-footer-background: var(--smart-surface);
    --smart-window-footer-button-width: 100px;
    --smart-window-content-padding: 10px;
    --smart-elevation-24: 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12), 0 11px 15px 0 rgba(0, 0, 0, .2);
    --smart-elevation-16: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px 0 rgba(0, 0, 0, .2);
    --smart-elevation-12: 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12), 0 7px 8px 0 rgba(0, 0, 0, .2);
    --smart-elevation-8: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    --smart-elevation-6: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    --smart-elevation-4: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    --smart-elevation-2: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    --smart-elevation-1: 0 0 2px 0 rgba(0, 0, 0, .14), 0 2px 2px 0 rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .2);
    --smart-elevation-0: none;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --pseudo-element-height: 0
}

.smart-ui-component[theme=dark],
body[theme=dark] {
    --smart-primary-rgb: 122, 202, 255;
    --smart-primary: rgb(var(--smart-primary-rgb));
    --smart-primary-color: #242424;
    --smart-background: #242424;
    --smart-background-color: #fff;
    --smart-surface: #333;
    --smart-surface-color: #fff;
    --smart-disabled: #535353;
    --smart-disabled-color: #fff;
    --smart-border: #464646;
    --smart-editor-selection: var(--smart-primary);
    --smart-editor-selection-color: var(--smart-primary-color);
    --smart-ui-state-hover: #444;
    --smart-ui-state-color-hover: #fff;
    --smart-ui-state-border-hover: var(--smart-ui-state-hover);
    --smart-ui-state-active: var(--smart-primary);
    --smart-ui-state-color-active: var(--smart-primary-color);
    --smart-ui-state-border-active: var(--smart-primary);
    --smart-ui-state-focus: #555;
    --smart-ui-state-color-focus: #fff;
    --smart-ui-state-border-focus: #555;
    --smart-ui-state-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-primary);
    --smart-ui-state-border-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-alternation-index0-color: var(--smart-surface-color);
    --smart-alternation-index0-border: var(--smart-surface);
    --smart-alternation-index0-background: var(--smart-surface);
    --smart-alternation-index1-color: #111;
    --smart-alternation-index1-border: #9bbb59;
    --smart-alternation-index1-background: #9bbb59;
    --smart-alternation-index2-color: #fff;
    --smart-alternation-index2-border: #fc3752;
    --smart-alternation-index2-background: #fc3752;
    --smart-grid-cell-background-freeze: #242424;
    --smart-grid-cell-color-freeze: #fff;
    --smart-scroll-bar-background: #3e3e42;
    --smart-scroll-bar-track-background: var(--smart-scroll-bar-background);
    --smart-scroll-bar-border: #3e3e42;
    --smart-scroll-bar-thumb-background: #686868;
    --smart-scroll-bar-thumb-border: #686868;
    --smart-scroll-bar-thumb-background-hover: #9e9e9e;
    --smart-scroll-bar-thumb-border-hover: #9e9e9e;
    --smart-scroll-bar-thumb-background-active: #444;
    --smart-scroll-bar-thumb-border-active: #444;
    --smart-scroll-bar-button-background: #3e3e42;
    --smart-scroll-bar-button-border: #3e3e42;
    --smart-scroll-bar-button-color: #999;
    --smart-scroll-bar-button-background-hover: #3e3e42;
    --smart-scroll-bar-button-border-hover: #3e3e42;
    --smart-scroll-bar-button-color-hover: var(--smart-primary);
    --smart-scroll-bar-button-background-active: #3e3e42;
    --smart-scroll-bar-button-border-active: #3e3e42;
    --smart-scroll-bar-button-color-active: var(--smart-primary);
    --smart-gantt-chart-timeline-nonworking-color: #3e3e42;
    --smart-scheduler-timeline-weekend-color: var(--smart-background);
    --smart-scheduler-timeline-nonworking-color: var(--smart-gantt-chart-timeline-nonworking-color);
    --smart-scheduler-event-background-rgb: 103, 176, 245;
    --smart-scheduler-event-background: rgba(var(--smart-scheduler-event-background-rgb), 1);
    --smart-scheduler-event-color: var(--smart-primary-color);
    --smart-scheduler-event-focus: rgba(var(--smart-scheduler-event-background-rgb), .9);
    --smart-scheduler-event-color-focus: var(--smart-scheduler-event-color);
    --smart-scheduler-event-hover: rgba(var(--smart-scheduler-event-background-rgb), .8);
    --smart-scheduler-event-color-hover: var(--smart-scheduler-event-color);
    --smart-scheduler-event-collector-background: rgba(var(--smart-primary-rgb), 1);
    --smart-scheduler-event-collector-color: var(--smart-primary-color);
    --smart-scheduler-event-collector-focus: rgba(var(--smart-primary-rgb), .9);
    --smart-scheduler-event-collector-color-focus: var(--smart-scheduler-event-collector-color);
    --smart-scheduler-event-collector-hover: rgba(var(--smart-primary-rgb), .8);
    --smart-scheduler-event-collector-color-hover: var(--smart-scheduler-event-collector-color);
    --smart-scheduler-status-free-background: #fff;
    --smart-scheduler-status-tentative-background: 0 -244rem/5rem 5rem linear-gradient(45deg, #fd7e14 25%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 50%, #fd7e14 0, #fd7e14 75%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2));
    --smart-scheduler-status-busy-background: #dc3545;
    --smart-scheduler-status-out-of-office-background: #00a9e6;
    --smart-scheduler-event-resize-indicator-color: var(--smart-gantt-chart-timeline-task-resize-indicator-color);
    --smart-scheduler-event-resize-indicator-border-color: var(--smart-gantt-chart-timeline-task-resize-indicator-border-color);
    --smart-scheduler-restricted-background: 0 -245rem/12px 12px linear-gradient(135deg, rgba(255, 0, 0, .15) 25%, transparent 0, transparent 50%, rgba(255, 0, 0, .15) 0, rgba(255, 0, 0, .15) 75%, transparent 0, transparent)
}
smart-check-box .smart-input {
    background-position:center;

}
smart-check-box.Checked span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAY0lEQVQokeXOoQ2DQABG4U8gQMIAJGyCRbBH12Cj2rIICsIYh8Nf2uZ6aTA8//73cxseaHLECQF9jnhg/LtYo/wgBgzf1p94RQNJIrTYMKNKuRrTYceaWnz3YPmlGFPkitdwAlkxErvJMxxXAAAAAElFTkSuQmCC)
}
smart-check-box.LeftArrow span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAUUlEQVQokWNgGFZAkIGBoZ4cjYYMDAx3GBgYnpKqMY6BgeEbAwPDf1I0czMwMCyBaiIGH0PWPJ8Ejf8ZGBjOUGLzUar5GRmQHdowQHY8DwEAAEi9LqoZcEUOAAAAAElFTkSuQmCC)
}
smart-check-box.UpArrow span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAd0lEQVQokeXPMQrCUAyA4c9ScHARPEgHL6UeSnDqTbxFi6cQHaQOvooEbH1Ip/4QAkl+kjARKxxTzuaEDnWuuE9iH7tfxQrXIN+wHRPXaILYxwWbz+EiyIeU21Bv8fB6581i4IpubC5uzmKOcjnQO2OJ+z8LvvIExvYZVSJjKmIAAAAASUVORK5CYII=)
}
smart-check-box.Horizontal span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAjElEQVQokd3RMQ4BQRyF8d8Wyw10duMmDqHZytlUShUNCQchQesGFDT/STayI7IdXzLVl5n3Xoa/YIAi44rwnVQ4YpbxTfjqXYxDbDDMXC6xwhmTVGWMPa7x+j1XLWovUWMKWzx7nF1KPuCGOR4fkkssMErJ7c3rLzZf0uY2NU6xu4smfJ2r1fuff4gXahUi5bfUpsIAAAAASUVORK5CYII=)
}
smart-check-box.Vertical span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAk0lEQVQokd3SSwrCMBRG4a9CXURBW9ck2GWK8wrSdbTiwIG70IFXEGzSjj2T8Cc5N0/SbHDGLjMnKQ544pYqsEqIFzwi39FFf5Z1rHhCEys3kQeUOblAG0WqkKvIbYwv4lueZOrMi/kTucDe75OUOJi57RIjjqi9b7uOPHo/WZYtruhD7iPXc+KHRX97bgddtJO8AC8rHItGG/0wAAAAAElFTkSuQmCC)
}
smart-check-box.RightArrow span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAT0lEQVQokWNgGLagnoGBQZBczU8ZGBgeMjAwmJOr+T8DA8MPBgaGfGwKjkEVEIOXMDAwcCNrPkOC5v8MDAzzqWYzRX4mpJns0KYongchAABsAC7n0QjPxwAAAABJRU5ErkJggg==)
}
smart-check-box.DownArrow span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAcklEQVQokWNgoAAw4pE7xsDAwMbAwPCTgYHBmlTN/wmpYyLkNHxgVDMDQw0DA8NdKEYGMLEqfIYJQBX9x4IfMDAwCBNyjT4DA8M3NI0/GBgYjAlphIEMNM3pxGqEgYVQjctJ1cjAwMDAzcDAMB9KUx8AALHdGmkOx7M9AAAAAElFTkSuQmCC)
}
smart-check-box.Bullet span.smart-input{
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABmJLR0QA/wD/AP+gvaeTAAAAWUlEQVQYlX2PUQqAMAxDo+dwnkiK59d5FJ0/KcRuNvBgH28hBfoU8psdwAWgkQrARtIjknOrPIWmyOnimkhOmbPRkuaPmrQd+sM4fHTMFuuNw7WpkzQL+eQFxVQu0d8mj+cAAAAASUVORK5CYII=)
}
smart-check-box.Required span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAANUlEQVQokWNgGCjAiMTmZGBgUCdCz00GBobv6IIGDAwM/4nABjANTOQ6eVTzkNJMtRRGXwAAhc8NauSW/JMAAAAASUVORK5CYII=)
}
smart-check-box.LeftArrowBlue span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAq0lEQVQokWNgGJ6AKWZrPUPUFkGscoQ0MzIxpjEzM15gjd1qTrJmKJD7x8BwkClmaz6KwQwMDAzMsduOMTD8tyTOnP9L/zKwpjMsdv/KAhVgI9IFDAwMjNHMDH9+/2VgSIQ6m/EX8Zr/L/3LwJIDdzY+wBy37SnD//9SDAwMP///Zyj/t8R7IkyOhUjrHjExMIT9XuJ9ElmQYGj///d/1t+//w1+L0bVOIQBAKmcMNWgTlTtAAAAAElFTkSuQmCC)
}
smart-check-box.RightArrowRed span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAkUlEQVQokd2RsQlCQRBE3xwfcxuwhR+KjZgYmWgiWILVWIiJYHZnCYIlCKJwY+APRETXUCfc3Tezy8J/qsBqD/1XvfQJtjSzlAsMv4YBDANLmwLLx7oAirQ1jCJGSGvVOm/h1HTOvRAIYE+c0pVap6mLv4The/IiNJulY5acpfPzzU0oDA7Y4xZ24Q3h/Z9/VDeRPSpapGpugQAAAABJRU5ErkJggg==)
}
smart-check-box.Unknown span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAAwUlEQVQokeXRPQrCQBCG4XdUgoUI2gqCF/AIXkEFPUGy4A1MGW9gFQjZkDOIhaUeRPAOKcV1rQzxJ2IqC79y4Jn5YOA/kiTJQmvdBahVgVrrFdaurbVDgEYVKOBbmCmlDgBSFXqet73P89phGHbSNG2WwCUikyJ8wI7jpFdjNsUFBTh1XXf3vDivHUVRv1GvHwSOrXZ7nGWZ/67qWwwQx/GgJrIHDNAru/hSG0ApdboYM0LkbGH+CZYmCIKvX/ib3ACBFEg+iHRLAAAAAABJRU5ErkJggg==)
}
smart-check-box.Reject span.smart-input{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAABE0lEQVQokc2SO07DQBBA39hNEKk4QSokROhgnSaSlb0BV0BKEKfIGSBA+PUUSJwAKVKaYEhBFYkKOACV7TTYQ0FimWQpqGC6ndn3RjO78C9iGjZqCuKqKcg0bNTKOa8MZn7+GNud/qJAQWJrTjM/H5cFBVwZjF4FvRaknVhzod2vmoKkNugJdIDbSjh6mzNLHVIb9BQ9AK5W16JO+h4cFudm1JYuuRN2CCbAhgt0wjOBl7TME0Jd4bnajDaly8fiPc8BSmqDI4Q6yERgPRma/nwHP8LLM99vCXIC7CVDc+4SFGBig+PYGo2tuSxv25X/NvPsnceK3lTvHvYFtCyOW8GZiO76mbe9Mhi9LHX/7Q/7u/gEmuuBZpiHMdwAAAAASUVORK5CYII=)
}
.setfont
{
    font: 300 13px/19px 'Open Sans','Helvetica Neue',helvetica,arial,verdana,sans-serif;
    letter-spacing :0px;
}
.ellipsis
{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
smart-accordion,
smart-alert-window,
smart-array,
smart-breadcrumb,
smart-button,
smart-calendar,
smart-card,
smart-card-view,
smart-carousel,
smart-check-box,
smart-circular-progress-bar,
smart-color-panel,
smart-color-picker,
smart-column-panel,
smart-combo-box,
smart-date-time-picker,
smart-dialog-window,
smart-docking-layout,
smart-drop-down-button,
smart-drop-down-list,
smart-filter-panel,
smart-gantt-chart,
smart-gauge,
smart-grid,
smart-group-panel,
smart-kanban,
smart-layout,
smart-led,
smart-list-box,
smart-list-menu,
smart-masked-text-box,
smart-menu,
smart-multi-column-filter-panel,
smart-multi-split-button,
smart-multiline-prompt-window,
smart-multiline-text-box,
smart-numeric-text-box,
smart-pager,
smart-password-text-box,
smart-path,
smart-pivot-panel,
smart-power-button,
smart-progress-bar,
smart-progress-window,
smart-prompt-window,
smart-query-builder,
smart-radio-button,
smart-repeat-button,
smart-scroll-bar,
smart-sheduler,
smart-slider,
smart-sort-panel,
smart-splitter,
smart-switch-button,
smart-tabs,
smart-tabs-window,
smart-tank,
smart-text-box,
smart-time-picker,
smart-toggle-button,
smart-tooltip,
smart-tree,
smart-wait-window,
smart-window {
    display: block;
    margin: 0;
    overflow: hidden;
    padding: 0
}

.smart-element {
    -webkit-tap-highlight-color: transparent;
    background: #fefefe;
    background: var(--smart-background);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: inherit;
    font-weight: var(--smart-font-weight);
    outline: 0
}

.smart-root {
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%
}

smart-alert-window[disabled],
smart-breadcrumb[disabled],
smart-button-group[disabled],
smart-button[disabled],
smart-calendar[disabled],
smart-card-view[disabled],
smart-card[disabled],
smart-check-box[disabled],
smart-check-input[disabled],
smart-chip[disabled],
smart-circular-progress-bar[disabled],
smart-color-input[disabled],
smart-color-panel[disabled],
smart-color-picker[disabled],
smart-column-panel[disabled],
smart-combo-box[disabled],
smart-date-input[disabled],
smart-date-range-input[disabled],
smart-date-time-picker[disabled],
smart-dialog-window[disabled],
smart-docking-layout[disabled],
smart-drop-down-button[disabled],
smart-drop-down-list[disabled],
smart-editor[disabled],
smart-filter-panel[disabled],
smart-formatting-panel[disabled],
smart-gantt-chart[disabled],
smart-gantt[disabled],
smart-gauge[disabled],
smart-grid[disabled],
smart-group-panel[disabled],
smart-input[disabled],
smart-kanban[disabled],
smart-layout[disabled],
smart-led[disabled],
smart-list-box[disabled],
smart-list-item[disabled],
smart-list-menu[disabled],
smart-menu-item[disabled],
smart-menu-items-group[disabled],
smart-menu[disabled],
smart-multi-column-filter-panel[disabled],
smart-multi-combo-input[disabled],
smart-multi-input[disabled],
smart-multi-split-button[disabled],
smart-multiline-prompt-window[disabled],
smart-multiline-text-box[disabled],
smart-notification-panel[disabled],
smart-number-input[disabled],
smart-numeric-text-box[disabled],
smart-pager .smart-pager-button[disabled],
smart-pager[disabled],
smart-password-input[disabled],
smart-password-text-box[disabled],
smart-path[disabled],
smart-pivot-table[disabled],
smart-power-button[disabled],
smart-progress-bar[disabled],
smart-progress-window[disabled],
smart-prompt-window[disabled],
smart-query-builder[disabled],
smart-radio-button[disabled],
smart-repeat-button[disabled],
smart-scheduler[disabled],
smart-scroll-bar[disabled],
smart-slider[disabled],
smart-sort-panel[disabled],
smart-splitter[disabled],
smart-switch-button[disabled],
smart-tab[disabled],
smart-table[disabled],
smart-tabs[disabled],
smart-tank[disabled],
smart-text-area[disabled],
smart-text-box[disabled],
smart-time-input[disabled],
smart-time-picker[disabled],
smart-toggle-button[disabled],
smart-tree-item[disabled]>.smart-tree-item-label-container,
smart-tree-items-group[disabled]>.smart-tree-item-label-container,
smart-tree[disabled],
smart-wait-window[disabled],
smart-window[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-window,
smart-accordion,
smart-button,
smart-button-group,
smart-calendar,
smart-card-view,
smart-color-panel,
smart-column-panel,
smart-date-time-picker,
smart-docking-layout,
smart-formatting-panel,
smart-gantt-chart,
smart-grid,
smart-group-panel,
smart-kanban,
smart-layout,
smart-list-box,
smart-list-menu,
smart-menu,
smart-multi-column-filter-panel,
smart-multiline-text-box,
smart-pager,
smart-progress-bar,
smart-scheduler,
smart-scroll-viewer,
smart-sort-panel,
smart-tank,
smart-text-box,
smart-time-picker
 {
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 10px;

    border-bottom-right-radius: 10px;

    border-color: #e0e0e0;
    border-top-left-radius: 10px;

    border-top-right-radius: 10px;

    border-width: 1px
}
smart-tree
{
    border: var(--smart-border-width) solid var(--smart-border);
    border-width: 1px
}
smart-card-view.smart-element,
smart-color-panel.smart-element,
smart-color-picker.smart-element,
smart-combo-box.smart-element,
smart-date-time-picker.smart-element,
smart-drop-down-button.smart-element,
smart-drop-down-list.smart-element,
smart-filter-panel.smart-element,
smart-kanban.smart-element,
smart-masked-text-box.smart-element,
smart-menu.smart-element,
smart-multi-split-button.smart-element,
smart-multiline-text-box.smart-element,
smart-numeric-text-box.smart-element,
smart-pager.smart-element,
smart-password-text-box.smart-element,
smart-path.smart-element,
smart-query-builder.smart-element,
smart-slider.smart-element,
smart-switch-button.smart-element,
smart-tabs.smart-element,
smart-tank.smart-element,
smart-text-box.smart-element {
    overflow: visible
}

.smart-element input::selection,
.smart-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

@media (hover:hover) {

    .smart-element[theme=dark],
    body[theme=dark] {
        scrollbar-color: #c1c1c1 #f1f1f1;
        scrollbar-color: var(--smart-scroll-bar-thumb-background) var(--smart-scroll-bar-track-background)
    }

    body[theme=dark] ::-webkit-scrollbar,
    body[theme=dark]::-webkit-scrollbar {
        background-color: #fefefe;
        background-color: var(--smart-background)
    }

    body[theme=dark] ::-webkit-scrollbar-track,
    body[theme=dark] ::-webkit-scrollbar-track-piece,
    body[theme=dark]::-webkit-scrollbar-track,
    body[theme=dark]::-webkit-scrollbar-track-piece {
        background-color: #f1f1f1;
        background-color: var(--smart-scroll-bar-track-background)
    }

    body[theme=dark] ::-webkit-scrollbar-thumb,
    body[theme=dark]::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        background-color: var(--smart-scroll-bar-thumb-background);
        border: 1px solid transparent;
        border: 1px solid var(--smart-scroll-bar-thumb-border)
    }

    body[theme=dark] ::-webkit-scrollbar-thumb:hover,
    body[theme=dark]::-webkit-scrollbar-thumb:hover {
        background-color: #a8a8a8;
        background-color: var(--smart-scroll-bar-thumb-background-hover);
        border-color: transparent;
        border-color: var(--smart-scroll-bar-thumb-border-hover)
    }

    body[theme=dark] ::-webkit-scrollbar-button,
    body[theme=dark]::-webkit-scrollbar-button {
        background-color: #f1f1f1;
        background-color: var(--smart-scroll-bar-button-background)
    }
}

.hidden{
    display:none !important;
}

smart-accordion {
    border: 0;
    display: block;
    height: 450px;
    height: var(--smart-accordion-default-height);
    width: 450px;
    width: var(--smart-accordion-default-width)
}

smart-accordion.smart-element {
    background: 0 0
}

smart-accordion:not(.smart-element) {
    visibility: hidden
}

smart-accordion>.smart-container {
    overflow: auto;
    padding: 10px;
    touch-action: none
}

smart-accordion.smart-container {
    overflow: auto;
    touch-action: none
}

smart-accordion .smart-reordering * {
    cursor: move;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none
}

smart-accordion .smart-empty:after {
    align-items: center;
    content: "No accordion items.";
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%
}

smart-accordion .smart-accordion.smart-container {
    padding: 10px
}

smart-accordion smart-accordion-item {
    border: 0;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    box-sizing: border-box;
    display: block;
    font-family: inherit;
    font-size: inherit;
    overflow: hidden;
    width: 100%
}

smart-accordion smart-accordion-item:first-child {
    border-bottom-left-radius: --smart-item-border-bottom-left-radius;
    border-bottom-left-radius: var(--smart-first-item-border-bottom-left-radius, --smart-item-border-bottom-left-radius);
    border-bottom-right-radius: --smart-item-border-bottom-right-radius;
    border-bottom-right-radius: var(--smart-first-item-border-bottom-right-radius, --smart-item-border-bottom-right-radius);
    border-top-left-radius: --smart-item-border-top-left-radius;
    border-top-left-radius: var(--smart-first-item-border-top-left-radius, --smart-item-border-top-left-radius);
    border-top-right-radius: --smart-item-border-top-right-radius;
    border-top-right-radius: var(--smart-first-item-border-top-right-radius, --smart-item-border-top-right-radius)
}

smart-accordion smart-accordion-item:last-child {
    border-bottom-left-radius: --smart-item-border-bottom-left-radius;
    border-bottom-left-radius: var(--smart-last-item-border-bottom-left-radius, --smart-item-border-bottom-left-radius);
    border-bottom-right-radius: --smart-item-border-bottom-right-radius;
    border-bottom-right-radius: var(--smart-last-item-border-bottom-right-radius, --smart-item-border-bottom-right-radius);
    border-top-left-radius: --smart-item-border-top-left-radius;
    border-top-left-radius: var(--smart-last-item-border-top-left-radius, --smart-item-border-top-left-radius);
    border-top-right-radius: --smart-item-border-top-right-radius;
    border-top-right-radius: var(--smart-last-item-border-top-right-radius, --smart-item-border-top-right-radius)
}

smart-accordion smart-accordion-item>.smart-container {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-accordion smart-accordion-item .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-background-color);
    opacity: .5
}

smart-accordion smart-accordion-item .smart-accordion-item-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    box-sizing: border-box;
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: flex;
    font-family: inherit;
    font-size: inherit;
    height: 48px;
    height: var(--smart-accordion-item-header-height);
    overflow: hidden;
    padding: 0 24px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

smart-accordion smart-accordion-item .smart-accordion-item-header>.smart-arrow {
    align-items: center;
    display: flex;
    justify-content: center;
    order: 2;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-accordion smart-accordion-item .smart-accordion-item-header>.smart-arrow:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: var(--smart-ui-state);
    content: "\\e817";
    content: var(--smart-icon-arrow-up-alt);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 12px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    margin-left: 2px;
    text-decoration: inherit;
    text-transform: none;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transform-origin: center;
    transform-origin: center;
    vertical-align: middle;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-accordion smart-accordion-item .smart-accordion-item-header>.smart-label {
    display: block;
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

smart-accordion smart-accordion-item .smart-accordion-item-content {
    background: #fefefe;
    background: var(--smart-background);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: none;
    height: 0;
    height: var(--smart-accordion-expanded-content-height);
    overflow-y: auto;
    padding: 0 24px;
    width: 100%
}

smart-accordion smart-accordion-item .smart-accordion-item-content .smart-content-container {
    box-sizing: border-box;
    height: 100%;
    min-height: 5px;
    padding: 10px;
    width: 100%
}

smart-accordion smart-accordion-item[expanded]:not(:last-child) {
    margin-bottom: 20px;
    margin-bottom: var(--smart-accordion-item-expanded-offset)
}

smart-accordion smart-accordion-item[expanded]:last-child:not(:first-child) {
    margin-top: 20px;
    margin-top: var(--smart-accordion-item-expanded-offset)
}

smart-accordion smart-accordion-item[expanded] .smart-accordion-item-header {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-accordion smart-accordion-item[expanded] .smart-accordion-item-header>.smart-arrow:after {
    -webkit-transform: rotate(0);
    transform: rotate(0);
    -webkit-transform-origin: center;
    transform-origin: center
}

smart-accordion smart-accordion-item[expanded] .smart-accordion-item-content {
    display: block
}

smart-accordion smart-accordion-item[hover] .smart-accordion-item-header {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: vaR(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-accordion smart-accordion-item[focused] .smart-accordion-item-header {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    border-color: vaR(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-accordion smart-accordion-item[focused] .smart-accordion-item-header>.smart-arrow {
    opacity: .6
}

smart-accordion smart-accordion-item[dragged] {
    cursor: move;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-accordion smart-accordion-item[dragged] .smart-accordion-item-header {
    cursor: move
}

smart-accordion smart-accordion-item[disabled] {
    cursor: default;
    opacity: 1
}

smart-accordion smart-accordion-item[disabled] .smart-accordion-item-header {
    cursor: auto
}

smart-accordion[expand-mode=singleFitHeight] smart-accordion-item .smart-accordion-item-header {
    height: 48px;
    height: var(--smart-accordion-item-header-height)
}

smart-accordion[expand-mode=singleFitHeight] smart-accordion-item .smart-accordion-item-content {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: 0;
    height: var(--smart-accordion-expanded-content-height);
    overflow-y: auto;
    padding: 0 24px
}

smart-accordion[expand-mode=multiple] smart-accordion-item .smart-accordion-item-content,
smart-accordion[expand-mode=none] smart-accordion-item .smart-accordion-item-content,
smart-accordion[expand-mode=single] smart-accordion-item .smart-accordion-item-content,
smart-accordion[expand-mode=toggle] smart-accordion-item .smart-accordion-item-content {
    height: auto;
    overflow-y: hidden
}

smart-accordion[expand-mode=multiple].smart-container.smart-toggling,
smart-accordion[expand-mode=multiple]>.smart-container.smart-toggling {
    padding: 10px
}

smart-accordion[disabled],
smart-accordion[disabled] smart-accordion-item .smart-accordion-item-header {
    cursor: default
}

smart-accordion:focus,
smart-accordion:focus smart-accordion-item:focus {
    outline: 0
}

smart-accordion.smart-no-arrow .smart-accordion-item-header>.smart-arrow,
smart-accordion.smart-no-arrow .smart-accordion-item-header>.smart-arrow:after {
    visibility: hidden;
    width: 0
}

smart-accordion.smart-arrow-right smart-accordion-item .smart-accordion-item-header>.smart-arrow {
    float: right
}

smart-accordion.smart-arrow-right smart-accordion-item .smart-accordion-item-header>.smart-arrow:after {
    content: "\\e903";
    content: var(--smart-icon-arrow-right)
}

smart-accordion.smart-arrow-right smart-accordion-item[expanded] .smart-accordion-item-header>.smart-arrow:after {
    content: "\\e817";
    content: var(--smart-icon-arrow-up-alt)
}

smart-accordion .smart-toggled-item .smart-accordion-item-content {
    overflow: hidden
}

smart-accordion:not([animation=none]) {
    -webkit-animation-duration: 225ms;
    animation-duration: 225ms;
    -webkit-animation-duration: var(--smart-accordion-animation-duration);
    animation-duration: var(--smart-accordion-animation-duration)
}

smart-accordion:not([animation=none]) * {
    -webkit-animation-duration: inherit;
    animation-duration: inherit
}

smart-accordion:not([animation=none])[expand-mode=singleFitHeight] smart-accordion-item.smart-toggled-item .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation-default-mode ease-out;
    animation: smart-accordion-item-expand-animation-default-mode ease-out;
    animation-direction: reverse;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    display: block
}

smart-accordion:not([animation=none])[expand-mode=singleFitHeight].smart-toggled-item smart-accordion-item[expanded] .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation-default-mode ease-in;
    animation: smart-accordion-item-expand-animation-default-mode ease-in;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1
}

smart-accordion:not([animation=none])[expand-mode=multiple] smart-accordion-item.smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=none] smart-accordion-item.smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=single] smart-accordion-item.smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=toggle] smart-accordion-item.smart-toggled-item .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation ease-out;
    animation: smart-accordion-item-expand-animation ease-out;
    animation-direction: reverse;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    display: block
}

smart-accordion:not([animation=none])[expand-mode=multiple] smart-accordion-item[expanded].smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=none] smart-accordion-item[expanded].smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=single] smart-accordion-item[expanded].smart-toggled-item .smart-accordion-item-content,
smart-accordion:not([animation=none])[expand-mode=toggle] smart-accordion-item[expanded].smart-toggled-item .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation ease-in;
    animation: smart-accordion-item-expand-animation ease-in;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1
}

smart-accordion:not([animation=none]) smart-accordion-item .smart-accordion-item-header>.smart-arrow.smart-animate-trigger:after {
    transition: -webkit-transform .2s ease-out;
    transition: transform .2s ease-out;
    transition: transform .2s ease-out, -webkit-transform .2s ease-out
}

smart-accordion:not([animation=none]) smart-accordion-item.smart-toggled-item .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation-default-mode ease-out;
    animation: smart-accordion-item-expand-animation-default-mode ease-out;
    animation-direction: reverse;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    display: block
}

smart-accordion:not([animation=none]) smart-accordion-item[expanded].smart-toggled-item .smart-accordion-item-content {
    -webkit-animation: smart-accordion-item-expand-animation-default-mode ease-in;
    animation: smart-accordion-item-expand-animation-default-mode ease-in;
    -webkit-animation-duration: inherit;
    animation-duration: inherit;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1
}

smart-accordion[right-to-left]>.smart-container {
    direction: rtl
}

:host .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-background-color);
    opacity: .5
}

@-webkit-keyframes smart-accordion-item-expand-animation-default-mode {
    0% {
        height: 0
    }

    to {
        height: 0;
        height: var(--smart-accordion-expanded-content-height)
    }
}

@keyframes smart-accordion-item-expand-animation-default-mode {
    0% {
        height: 0
    }

    to {
        height: 0;
        height: var(--smart-accordion-expanded-content-height)
    }
}

@-webkit-keyframes smart-accordion-item-expand-animation {
    0% {
        height: 0
    }

    to {
        height: 0;
        height: var(--smart-accordion-expanded-content-local-height)
    }
}

@keyframes smart-accordion-item-expand-animation {
    0% {
        height: 0
    }

    to {
        height: 0;
        height: var(--smart-accordion-expanded-content-local-height)
    }
}

smart-array {
    display: block;
    height: 450px;
    height: var(--smart-array-default-height);
    overflow: visible;
    width: 450px;
    width: var(--smart-array-default-width)
}

smart-array .smart-big-container,
smart-array>.smart-container {
    display: flex
}

smart-array .smart-array-indexer {
    display: block;
    margin-bottom: 2px;
    width: 100%
}

smart-array .smart-big-container {
    background-color: #fefefe;
    background-color: var(--smart-background)
}

smart-array[show-index-display] .smart-big-container {
    margin-left: 2px
}

smart-array .smart-main-container,
smart-array .smart-scrollbar-container-horizontal {
    width: 100%
}

smart-array .smart-array-element-gap {
    border-spacing: 0
}

smart-array .smart-array-table-data {
    background-color: transparent;
    border: 2px solid transparent;
    min-width: 0;
    padding: 0;
    white-space: nowrap
}

smart-array .smart-array-table-data-gap {
    border-width: 3px;
    border-width: var(--smart-array-element-gap);
    padding: 3px;
    padding: var(--smart-array-element-gap)
}

smart-array .smart-scrollbar-container-horizontal {
    height: 20px
}

smart-array .smart-scrollbar-container-vertical {
    width: 20px
}

smart-array .smart-scrollbar-container-horizontal>smart-scroll-bar,
smart-array .smart-scrollbar-container-vertical>smart-scroll-bar {
    height: 100%;
    width: 100%
}

smart-array .smart-array-element {
    position: relative
}

smart-array .smart-array-element-selected {
    border-color: #00f
}

smart-array .smart-array-element-empty {
    border-color: #999;
    color: #999;
    opacity: .7
}

smart-array .smart-array-element>smart-check-box,
smart-array .smart-array-element>smart-led,
smart-array .smart-array-element>smart-numeric-text-box,
smart-array .smart-array-element>smart-power-button,
smart-array .smart-array-element>smart-radio-button,
smart-array .smart-array-element>smart-switch-button,
smart-array .smart-array-element>smart-toggle-button,
smart-array smart-switch-button.smart-array-element,
smart-array smart-text-box.smart-array-element {
    display: block
}

smart-array .smart-array-element>smart-check-box {
    padding: 0
}

.smart-badge {
    display: inline-block;
    font-weight: 700;
    line-height: 1;
    padding: .25em .4em
}

.smart-badge.smart-badge-primary {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-badge.smart-badge-secondary {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-badge.smart-badge-success {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

.smart-badge.smart-badge-error {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

.smart-badge.smart-badge-info {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

.smart-badge.smart-badge-warning {
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    color: #fff;
    color: var(--smart-warning-color)
}

.smart-badge.smart-badge-light {
    background-color: #fff;
    background-color: var(--smart-light);
    color: #222;
    color: var(--smart-light-color)
}

.smart-badge.smart-badge-dark {
    background-color: #222;
    background-color: var(--smart-dark);
    color: #fff;
    color: var(--smart-dark-color)
}

.smart-badge.smart-badge-danger {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

.smart-badge.smart-badge-pill {
    border-radius: 10rem
}

.smart-badge[right-to-left] {
    direction: rtl
}

.smart-breadcrumb-feedback,
.smart-breadcrumb-feedback *,
smart-breadcrumb {
    box-sizing: border-box
}

smart-breadcrumb {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: block;
    height: auto;
    height: var(--smart-breadcrumb-default-height);
    min-width: 62px;
    min-width: calc(var(--smart-breadcrumb-padding)*2 + var(--smart-border-width)*2 + 40px);
    padding: 10px;
    padding: var(--smart-breadcrumb-padding);
    padding-top: 0;
    width: 400px;
    width: var(--smart-breadcrumb-default-width)
}

smart-breadcrumb .smart-template-container {
    height: auto
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    width: 100%
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    flex-direction: row;
    height: 40px;
    height: var(--smart-breadcrumb-item-height);
    margin-right: 10px;
    margin-right: var(--smart-breadcrumb-horizontal-offset);
    margin-top: 10px;
    margin-top: var(--smart-breadcrumb-padding);
    padding: 5px;
    position: relative;
    width: auto
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item:not(:last-child):after {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    content: "";
    height: 2px;
    left: calc(100% + 1px);
    left: calc(100% + var(--smart-border-width));
    position: absolute;
    top: 50%;
    width: 10px;
    width: var(--smart-breadcrumb-horizontal-offset)
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item>.smart-close-button {
    cursor: pointer;
    display: none;
    font-family: smart-icons;
    margin-left: 10px;
    margin-right: 5px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: 1em
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item>.smart-close-button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close)
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item .smart-breadcrumb-item-label {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items>.afterTarget:last-child:after,
smart-breadcrumb .smart-template-container .smart-breadcrumb-items>.target:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    content: "";
    height: 100%;
    left: -6px;
    left: calc(var(--smart-breadcrumb-horizontal-offset)*-1/2 - 1px);
    position: absolute;
    width: 2px
}

smart-breadcrumb .smart-template-container .smart-breadcrumb-items>.afterTarget:last-child:after {
    left: calc(100% + 5px);
    left: calc(100% + var(--smart-breadcrumb-horizontal-offset)/2)
}

smart-breadcrumb .smart-breadcrumb-placeholder {
    display: flex;
    height: 100%;
    padding: 5px;
    width: 100%
}

smart-breadcrumb[allow-drag] .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item {
    cursor: pointer;
    touch-action: none
}

smart-breadcrumb[allow-drag] .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item.dragged {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em
}

smart-breadcrumb[add-new-item] .smart-template-container .smart-breadcrumb-items>smart-button {
    --smart-button-padding: 0;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 0;
    border-radius: initial;
    font-size: 25px;
    height: 40px;
    height: var(--smart-breadcrumb-item-height);
    margin-right: 10px;
    margin-right: var(--smart-breadcrumb-horizontal-offset);
    margin-top: 10px;
    margin-top: var(--smart-breadcrumb-padding);
    overflow: visible;
    position: relative;
    text-align: center;
    width: 40px;
    width: var(--smart-breadcrumb-item-height)
}

smart-breadcrumb[add-new-item] .smart-template-container .smart-breadcrumb-items>smart-button>button {
    overflow: hidden;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none
}

smart-breadcrumb[close-buttons] .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item>.smart-close-button {
    display: block
}

smart-breadcrumb[minimized] {
    overflow: visible;
    padding: 0
}

smart-breadcrumb[minimized] .smart-container {
    align-items: center;
    display: flex;
    padding: 10px;
    padding: var(--smart-breadcrumb-padding);
    position: relative
}

smart-breadcrumb[minimized] .smart-hamburger-icon {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    float: none;
    height: 40px;
    justify-content: center;
    width: 40px
}

smart-breadcrumb[minimized] .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-top {
    -webkit-transform: translateX(4px) rotate(45deg);
    transform: translateX(4px) rotate(45deg);
    width: 29px
}

smart-breadcrumb[minimized] .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-center {
    visibility: hidden
}

smart-breadcrumb[minimized] .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-bottom {
    -webkit-transform: translateX(4px) rotate(-45deg);
    transform: translateX(4px) rotate(-45deg);
    width: 29px
}

smart-breadcrumb[minimized] .smart-hamburger-icon-line {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 10px;
    height: 5px;
    margin-bottom: 5px;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 30px
}

smart-breadcrumb[minimized] .smart-hamburger-icon-line-bottom {
    margin-bottom: 0
}

smart-breadcrumb[minimized] .smart-template-container {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    left: -1px;
    left: calc(var(--smart-border-width)*-1);
    margin: calc(var(--smart-drop-down-vertical-offset) + var(--smart-drop-down-element-padding-size)) 0;
    padding: var(--smart-drop-down-element-padding-size);
    position: absolute;
    top: calc(100% + 3px);
    top: calc(100% + 2px + var(--smart-border-width));
    width: 300px;
    width: var(--smart-breadcrumb-drop-down-width);
    z-index: 1
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item {
    justify-content: space-between;
    margin: 0;
    width: 100%
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item:not(:last-child):after {
    content: none
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items>smart-button {
    margin: 0;
    width: 100%
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items>smart-button>button {
    justify-content: center;
    padding: 0
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items>.afterTarget:last-child:after,
smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items>.target:before {
    height: 4px;
    left: 0;
    top: -3px;
    width: 100%
}

smart-breadcrumb[minimized] .smart-template-container .smart-breadcrumb-items>.afterTarget:last-child:after {
    top: 100%
}

smart-breadcrumb[minimized][animation=none] .smart-template-container.smart-visibility-hidden {
    display: none
}

smart-breadcrumb[minimized]:not([animation=none]) .smart-template-container {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

smart-breadcrumb[minimized]:not([animation=none]) .smart-template-container.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

smart-breadcrumb[minimized]:not([animation=none]) .smart-template-container.smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

smart-breadcrumb[minimized]:not([animation=none]) .smart-hamburger-icon-line {
    transition: visibility 20ms ease-in, width .2s ease-in, -webkit-transform .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in, -webkit-transform .2s ease-in
}

smart-breadcrumb[right-to-left]>.smart-container {
    direction: rtl
}

smart-breadcrumb[right-to-left]>.smart-container .smart-template-container .smart-breadcrumb-items>.afterTarget:first-child:after {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    content: "";
    height: 100%;
    left: calc(100% + 5px);
    left: calc(100% + var(--smart-breadcrumb-horizontal-offset)/2);
    position: absolute;
    top: 0;
    width: 2px
}

smart-breadcrumb[right-to-left]>.smart-container .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item>.smart-close-button {
    margin-left: 5px;
    margin-right: 10px
}

smart-breadcrumb[right-to-left]>.smart-container .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item:not(:last-child):after {
    left: -10px;
    left: calc(var(--smart-breadcrumb-horizontal-offset)*-1)
}

smart-breadcrumb[right-to-left]:not([minimized]) .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item,
smart-breadcrumb[right-to-left]:not([minimized])[add-new-item]:not([minimized]) .smart-breadcrumb-items>smart-button {
    margin-left: 10px;
    margin-left: var(--smart-breadcrumb-horizontal-offset);
    margin-right: 0
}

smart-breadcrumb[right-to-left][minimized] .smart-container .smart-template-container {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-breadcrumb-feedback {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12), 0 7px 8px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-12);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: inline-flex;
    flex-direction: row;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 40px;
    height: var(--smart-breadcrumb-item-height);
    margin-right: 10px;
    margin-right: var(--smart-breadcrumb-horizontal-offset);
    margin-top: 10px;
    margin-top: var(--smart-breadcrumb-padding);
    opacity: .8;
    padding: 5px;
    position: absolute;
    white-space: nowrap;
    width: auto;
    z-index: 999
}

.smart-breadcrumb-feedback:after {
    align-items: center;
    background-color: #8bc34a;
    background-color: var(--smart-success);
    border-radius: 100%;
    color: #fff;
    color: var(--smart-success-color);
    content: "\\e908";
    content: var(--smart-icon-check);
    display: flex;
    font-family: smart-icons;
    font-size: 14px;
    height: 1.5em;
    justify-content: center;
    margin-left: 10px;
    width: 1.5em
}

.smart-breadcrumb-feedback.error:after {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color);
    content: "\\e805";
    content: var(--smart-icon-attention-circled)
}

.smart-breadcrumb-feedback.data:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    content: "\\f0c5";
    content: var(--smart-icon-docs)
}

.smart-breadcrumb-feedback[right-to-left] {
    direction: rtl;
    margin-left: 10px;
    margin-left: var(--smart-breadcrumb-horizontal-offset);
    margin-right: 0
}

.smart-breadcrumb-feedback[right-to-left]:after {
    margin-left: 0;
    margin-right: 10px;
    margin-right: var(--smart-breadcrumb-horizontal-offset)
}

smart-button,
smart-repeat-button,
smart-toggle-button {
    --smart-button-flat-color: var(--smart-background-color);
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    cursor: pointer;
    display: inline-flex;
    font-weight: 500;
    letter-spacing: .08929em;
    overflow: hidden;
    text-align: center;
    text-transform: uppercase;
    text-transform: var(--smart-button-text-transform);
    vertical-align: middle;
    visibility: hidden
}

smart-button.smart-element,
smart-repeat-button.smart-element,
smart-toggle-button.smart-element {
    display: inline-flex;
    visibility: inherit
}

smart-button button::-moz-focus-inner,
smart-repeat-button button::-moz-focus-inner,
smart-toggle-button button::-moz-focus-inner {
    border: 0
}

smart-button.primary,
smart-repeat-button.primary,
smart-toggle-button.primary {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-primary);
    --smart-border: var(--smart-primary);
    --smart-border-rgb: var(--smart-primary-rgb);
    --smart-background-color: var(--smart-primary-color);
    --smart-ui-state-hover: var(--smart-primary);
    --smart-ui-state-border-hover: var(--smart-primary);
    --smart-ui-state-color-hover: var(--smart-primary-color);
    --smart-ui-state-active: var(--smart-primary);
    --smart-ui-state-border-active: var(--smart-primary);
    --smart-ui-state-color-active: var(--smart-primary-color);
    --smart-ui-state-focus: var(--smart-primary);
    --smart-ui-state-border-focus: var(--smart-primary);
    --smart-ui-state-color-focus: var(--smart-primary-color);
    --smart-button-flat-color: var(--smart-primary);
    --smart-button-outlined-color: var(--smart-primary);
    --smart-button-outlined-border: var(--smart-primary)
}

smart-button.secondary,
smart-repeat-button.secondary,
smart-toggle-button.secondary {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-secondary);
    --smart-border: var(--smart-secondary);
    --smart-border-rgb: var(--smart-secondary-rgb);
    --smart-background-color: var(--smart-secondary-color);
    --smart-ui-state-hover: var(--smart-secondary);
    --smart-ui-state-border-hover: var(--smart-secondary);
    --smart-ui-state-color-hover: var(--smart-secondary-color);
    --smart-ui-state-active: var(--smart-secondary);
    --smart-ui-state-border-active: var(--smart-secondary);
    --smart-ui-state-color-active: var(--smart-secondary-color);
    --smart-ui-state-focus: var(--smart-secondary);
    --smart-ui-state-border-focus: var(--smart-secondary);
    --smart-ui-state-color-focus: var(--smart-secondary-color);
    --smart-button-flat-color: var(--smart-secondary);
    --smart-button-outlined-color: var(--smart-secondary);
    --smart-button-outlined-border: var(--smart-secondary)
}

smart-button.success,
smart-repeat-button.success,
smart-toggle-button.success {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-success);
    --smart-border: var(--smart-success);
    --smart-border-rgb: var(--smart-success-rgb);
    --smart-background-color: var(--smart-success-color);
    --smart-ui-state-hover: var(--smart-success);
    --smart-ui-state-border-hover: var(--smart-success);
    --smart-ui-state-color-hover: var(--smart-success-color);
    --smart-ui-state-active: var(--smart-success);
    --smart-ui-state-border-active: var(--smart-success);
    --smart-ui-state-color-active: var(--smart-success-color);
    --smart-ui-state-focus: var(--smart-success);
    --smart-ui-state-border-focus: var(--smart-success);
    --smart-ui-state-color-focus: var(--smart-success-color);
    --smart-button-flat-color: var(--smart-success);
    --smart-button-outlined-color: var(--smart-success);
    --smart-button-outlined-border: var(--smart-success)
}

smart-button.error,
smart-repeat-button.error,
smart-toggle-button.error {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-error);
    --smart-border: var(--smart-error);
    --smart-border-rgb: var(--smart-error-rgb);
    --smart-background-color: var(--smart-error-color);
    --smart-ui-state-hover: var(--smart-error);
    --smart-ui-state-border-hover: var(--smart-error);
    --smart-ui-state-color-hover: var(--smart-error-color);
    --smart-ui-state-active: var(--smart-error);
    --smart-ui-state-border-active: var(--smart-error);
    --smart-ui-state-color-active: var(--smart-error-color);
    --smart-ui-state-focus: var(--smart-error);
    --smart-ui-state-border-focus: var(--smart-error);
    --smart-ui-state-color-focus: var(--smart-error-color);
    --smart-button-flat-color: var(--smart-error);
    --smart-button-outlined-color: var(--smart-error);
    --smart-button-outlined-border: var(--smart-error)
}

smart-button.info,
smart-repeat-button.info,
smart-toggle-button.info {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-info);
    --smart-border: var(--smart-info);
    --smart-border-rgb: var(--smart-info-rgb);
    --smart-background-color: var(--smart-info-color);
    --smart-ui-state-hover: var(--smart-info);
    --smart-ui-state-border-hover: var(--smart-info);
    --smart-ui-state-color-hover: var(--smart-info-color);
    --smart-ui-state-active: var(--smart-info);
    --smart-ui-state-border-active: var(--smart-info);
    --smart-ui-state-color-active: var(--smart-info-color);
    --smart-ui-state-focus: var(--smart-info);
    --smart-ui-state-border-focus: var(--smart-info);
    --smart-ui-state-color-focus: var(--smart-info-color);
    --smart-button-flat-color: var(--smart-info);
    --smart-button-outlined-color: var(--smart-info);
    --smart-button-outlined-border: var(--smart-info)
}

smart-button.warning,
smart-repeat-button.warning,
smart-toggle-button.warning {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-warning);
    --smart-border: var(--smart-warning);
    --smart-border-rgb: var(--smart-warning-rgb);
    --smart-background-color: var(--smart-warning-color);
    --smart-ui-state-hover: var(--smart-warning);
    --smart-ui-state-border-hover: var(--smart-warning);
    --smart-ui-state-color-hover: var(--smart-warning-color);
    --smart-ui-state-active: var(--smart-warning);
    --smart-ui-state-border-active: var(--smart-warning);
    --smart-ui-state-color-active: var(--smart-warning-color);
    --smart-ui-state-focus: var(--smart-warning);
    --smart-ui-state-border-focus: var(--smart-warning);
    --smart-ui-state-color-focus: var(--smart-warning-color);
    --smart-button-flat-color: var(--smart-warning);
    --smart-button-outlined-color: var(--smart-warning);
    --smart-button-outlined-border: var(--smart-warning)
}

smart-button.light,
smart-repeat-button.light,
smart-toggle-button.light {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-light);
    --smart-border: var(--smart-light);
    --smart-border-rgb: var(--smart-light-rgb);
    --smart-background-color: var(--smart-light-color);
    --smart-ui-state-hover: var(--smart-light);
    --smart-ui-state-border-hover: var(--smart-light);
    --smart-ui-state-color-hover: var(--smart-light-color);
    --smart-ui-state-active: var(--smart-light);
    --smart-ui-state-border-active: var(--smart-light);
    --smart-ui-state-color-active: var(--smart-light-color);
    --smart-ui-state-focus: var(--smart-light);
    --smart-ui-state-border-focus: var(--smart-light);
    --smart-ui-state-color-focus: var(--smart-light-color);
    --smart-button-flat-color: var(--smart-light);
    --smart-button-outlined-color: var(--smart-light);
    --smart-button-outlined-border: var(--smart-light)
}

smart-button.dark,
smart-repeat-button.dark,
smart-toggle-button.dark {
    --smart-button-opacity-hover: 0.75;
    --smart-button-opacity-focus: 0.7;
    --smart-button-opacity-active: 0.65;
    --smart-background: var(--smart-dark);
    --smart-border: var(--smart-dark);
    --smart-border-rgb: var(--smart-dark-rgb);
    --smart-background-color: var(--smart-dark-color);
    --smart-ui-state-hover: var(--smart-dark);
    --smart-ui-state-border-hover: var(--smart-dark);
    --smart-ui-state-color-hover: var(--smart-dark-color);
    --smart-ui-state-active: var(--smart-dark);
    --smart-ui-state-border-active: var(--smart-dark);
    --smart-ui-state-color-active: var(--smart-dark-color);
    --smart-ui-state-focus: var(--smart-dark);
    --smart-ui-state-border-focus: var(--smart-dark);
    --smart-ui-state-color-focus: var(--smart-dark-color);
    --smart-button-flat-color: var(--smart-dark);
    --smart-button-outlined-color: var(--smart-dark);
    --smart-button-outlined-border: var(--smart-dark)
}

smart-button[hover],
smart-repeat-button[hover],
smart-toggle-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    opacity: var(--smart-button-opacity-hover);
    transition: background-color .1s linear, box-shadow .28s ease-in-out
}

smart-button[focus],
smart-repeat-button[focus],
smart-toggle-button[focus] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus);
    opacity: var(--smart-button-opacity-focus)
}

smart-button[active],
smart-repeat-button[active],
smart-toggle-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    opacity: var(--smart-button-opacity-active);
    transition: background-color .1s linear, box-shadow .28s ease-in-out
}

smart-button[disabled],
smart-repeat-button[disabled],
smart-toggle-button[disabled] {
    --smart-background: var(--smart-disabled);
    --smart-border: var(--smart-disabled);
    --smart-background-color: var(--smart-disabled-color);
    background-color: #ccc;
    background-color: var(--smart-disabled);
    border-color: #ccc;
    border-color: var(--smart-disabled);
    color: #555;
    color: var(--smart-disabled-color);
    cursor: default
}

smart-button.large button,
smart-repeat-button.large button,
smart-toggle-button.large button {
    font-size: 18px;
    font-size: var(--smart-button-large-font-size);
    padding: 10px 16px;
    padding: var(--smart-button-large-padding)
}

smart-button.small button,
smart-repeat-button.small button,
smart-toggle-button.small button {
    font-size: 12px;
    font-size: var(--smart-button-small-font-size);
    padding: 5px 10px;
    padding: var(--smart-button-small-padding)
}

smart-button.very-small button,
smart-repeat-button.very-small button,
smart-toggle-button.very-small button {
    font-size: 10px;
    font-size: var(--smart-button-very-small-font-size);
    padding: 3px 5px;
    padding: var(--smart-button-very-small-padding)
}

smart-button.rounded,
smart-repeat-button.rounded,
smart-toggle-button.rounded {
    --smart-border-top-left-radius: 50px;
    --smart-border-top-right-radius: 50px;
    --smart-border-bottom-left-radius: 50px;
    --smart-border-bottom-right-radius: 50px;
    border-radius: 4px !important;
    border-radius: var(--smart-border-bottom-left-radius) !important
}

smart-button.squared,
smart-repeat-button.squared,
smart-toggle-button.squared {
    --smart-border-top-left-radius: 0;
    --smart-border-top-right-radius: 0;
    --smart-border-bottom-left-radius: 0;
    --smart-border-bottom-right-radius: 0
}

smart-button.flat,
smart-button.flat[active],
smart-button.flat[hover],
smart-repeat-button.flat,
smart-repeat-button.flat[active],
smart-repeat-button.flat[hover],
smart-toggle-button.flat,
smart-toggle-button.flat[active],
smart-toggle-button.flat[hover] {
    background: 0 0;
    border-color: transparent;
    color: #5a5a5a;
    color: var(--smart-button-flat-color)
}

smart-button.outlined,
smart-button.outlined[active],
smart-button.outlined[hover],
smart-repeat-button.outlined,
smart-repeat-button.outlined[active],
smart-repeat-button.outlined[hover],
smart-toggle-button.outlined,
smart-toggle-button.outlined[active],
smart-toggle-button.outlined[hover] {
    background: 0 0;
    border-color: #e0e0e0;
    border-color: var(--smart-button-outlined-border);
    color: #5a5a5a;
    color: var(--smart-button-outlined-color)
}

smart-button.flat[focus],
smart-repeat-button.flat[focus],
smart-toggle-button.flat[focus] {
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-focus)
}

smart-button.flat[checked],
smart-repeat-button.flat[checked],
smart-toggle-button.flat[checked] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    text-decoration: underline
}

smart-button.flat .smart-ripple,
smart-repeat-button.flat .smart-ripple,
smart-toggle-button.flat .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-button-flat-color)
}

smart-button.outlined,
smart-repeat-button.outlined,
smart-toggle-button.outlined {
    border-width: 2px;
    border-width: calc(var(--smart-border-width)*2)
}

smart-button.outlined[focus],
smart-repeat-button.outlined[focus],
smart-toggle-button.outlined[focus] {
    background: 0 0;
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-focus);
    color: #5a5a5a;
    color: var(--smart-button-outlined-color)
}

smart-button.outlined[checked],
smart-repeat-button.outlined[checked],
smart-toggle-button.outlined[checked] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-button.outlined .smart-ripple,
smart-repeat-button.outlined .smart-ripple,
smart-toggle-button.outlined .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-button-outlined-color)
}

smart-button.outlined button.smart-button,
smart-repeat-button.outlined button.smart-button,
smart-toggle-button.outlined button.smart-button {
    border-radius: 0;
    border-radius: initial
}

smart-button.raised,
smart-repeat-button.raised,
smart-toggle-button.raised {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    transition: background-color .1s linear, box-shadow .28s ease-in-out
}

smart-button.raised[hover],
smart-repeat-button.raised[hover],
smart-toggle-button.raised[hover] {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4)
}

smart-button.raised button[active],
smart-button.raised[active],
smart-button.raised[checked],
smart-repeat-button.raised button[active],
smart-repeat-button.raised[active],
smart-repeat-button.raised[checked],
smart-toggle-button.raised button[active],
smart-toggle-button.raised[active],
smart-toggle-button.raised[checked] {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8)
}

smart-button.raised[focus],
smart-button.raised[focus]:not([checked]),
smart-repeat-button.raised[focus],
smart-repeat-button.raised[focus]:not([checked]),
smart-toggle-button.raised[focus],
smart-toggle-button.raised[focus]:not([checked]) {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6)
}

smart-button.floating,
smart-repeat-button.floating,
smart-toggle-button.floating {
    border-radius: 50%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    height: 48px;
    transition: background-color .1s linear, box-shadow .28s ease-in-out;
    width: 48px
}

smart-button.floating[hover],
smart-repeat-button.floating[hover],
smart-toggle-button.floating[hover] {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6)
}

smart-button.floating[active],
smart-button.floating[checked],
smart-repeat-button.floating[active],
smart-repeat-button.floating[checked],
smart-toggle-button.floating[active],
smart-toggle-button.floating[checked] {
    box-shadow: 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12), 0 7px 8px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-12)
}

smart-button.floating[focus],
smart-button.floating[focus]:not([checked]),
smart-repeat-button.floating[focus],
smart-repeat-button.floating[focus]:not([checked]),
smart-toggle-button.floating[focus],
smart-toggle-button.floating[focus]:not([checked]) {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6)
}

smart-button[right-to-left],
smart-repeat-button[right-to-left],
smart-toggle-button[right-to-left] {
    direction: rtl
}

button.smart-button {
    -webkit-font-smoothing: antialiased;
    background: inherit;
    border: none;
    border-radius: inherit;
    color: inherit;
    cursor: inherit;
    font-weight: inherit;
    letter-spacing: inherit;
    opacity: var(--smart-button-opacity);
    padding: 8px 16px;
    padding: var(--smart-button-padding);
    position: relative;
    text-align: inherit;
    text-transform: inherit;
    vertical-align: inherit;
    white-space: nowrap
}

.smart-button .smart-ripple {
    background: #5a5a5a;
    background: var(--smart-background-color)
}

[smart-toggle-button] .smart-container,
smart-toggle-button .smart-container {
    font-style: inherit;
    font-weight: inherit
}

[smart-toggle-button][checked],
smart-toggle-button[checked] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-scroll-button .smart-button {
    padding: 0
}

:host(.smart-button.flat) .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-button-flat-color)
}

:host(.smart-button.outlined) .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-button-outlined-color)
}

button.smart-button[type]:not(.smart-container) {
    background: #fefefe;
    background: var(--smart-background);
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    cursor: pointer;
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-style: inherit;
    font-style: var(--smart-font-style);
    font-weight: 500;
    letter-spacing: .08929em;
    outline: 0;
    overflow: hidden;
    text-align: center;
    text-transform: uppercase;
    text-transform: var(--smart-button-text-transform);
    vertical-align: middle
}

button.smart-button[type]:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

button.smart-button[type]:not([disabled]):active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-button-group {
    cursor: pointer;
    display: inline-flex;
    height: auto;
    height: var(--smart-button-group-default-height);
    letter-spacing: .08929em;
    overflow: hidden;
    text-transform: uppercase;
    text-transform: var(--smart-button-text-transform);
    vertical-align: middle;
    width: auto;
    width: var(--smart-button-group-default-width)
}

.smart-button-group .smart-button-group-items {
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%
}

.smart-button-group .smart-button-group-items .smart-button-group-item {
    -webkit-font-smoothing: antialiased;
    align-items: center;
    border-radius: inherit;
    cursor: inherit;
    display: flex;
    font-weight: inherit;
    height: 100%;
    justify-content: center;
    opacity: var(--smart-button-opacity);
    padding: 8px 16px;
    padding: var(--smart-button-padding);
    position: relative;
    white-space: nowrap;
    width: 100%
}

.smart-button-group .smart-button-group-items .smart-button-group-item>div {
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-button-group .smart-button-group-items .smart-button-group-item:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    opacity: var(--smart-button-opacity-hover)
}

.smart-button-group .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-button-group .smart-button-group-items .smart-button-group-item:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    opacity: var(--smart-button-opacity-active)
}

.smart-button-group.small .smart-button-group-items .smart-button-group-item {
    font-size: 12px;
    font-size: var(--smart-button-small-font-size);
    padding: 5px 10px;
    padding: var(--smart-button-small-padding)
}

.smart-button-group.large .smart-button-group-items .smart-button-group-item {
    font-size: 18px;
    font-size: var(--smart-button-large-font-size);
    padding: 10px 16px;
    padding: var(--smart-button-large-padding)
}

.smart-button-group:focus .smart-button-group-item[focus]:not(:active) {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus);
    opacity: var(--smart-button-opacity-focus)
}

.smart-button-group.primary {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-button-group.primary .smart-button-group-items .smart-button-group-item {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-button-group.primary .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(0, 92, 153, .8);
    background-color: rgba(var(--smart-primary-rgb), .8)
}

.smart-button-group.primary .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.primary .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(0, 92, 153, .2);
    background-color: rgba(var(--smart-primary-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-button-group.secondary {
    border-color: #2d2d30;
    border-color: var(--smart-secondary)
}

.smart-button-group.secondary .smart-button-group-items .smart-button-group-item {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-button-group.secondary .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(45, 45, 48, .8);
    background-color: rgba(var(--smart-secondary-rgb), .8)
}

.smart-button-group.secondary .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.secondary .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(45, 45, 48, .2);
    background-color: rgba(var(--smart-secondary-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #2d2d30;
    color: var(--smart-secondary)
}

.smart-button-group.success {
    border-color: #8bc34a;
    border-color: var(--smart-success)
}

.smart-button-group.success .smart-button-group-items .smart-button-group-item {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

.smart-button-group.success .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(139, 195, 74, .8);
    background-color: rgba(var(--smart-success-rgb), .8)
}

.smart-button-group.success .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.success .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(139, 195, 74, .2);
    background-color: rgba(var(--smart-success-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #8bc34a;
    color: var(--smart-success)
}

.smart-button-group.error {
    border-color: #b00020;
    border-color: var(--smart-error)
}

.smart-button-group.error .smart-button-group-items .smart-button-group-item {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

.smart-button-group.error .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(176, 0, 32, .8);
    background-color: rgba(var(--smart-error-rgb), .8)
}

.smart-button-group.error .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.error .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(176, 0, 32, .2);
    background-color: rgba(var(--smart-error-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #b00020;
    color: var(--smart-error)
}

.smart-button-group.info {
    border-color: #5cc0de;
    border-color: var(--smart-info)
}

.smart-button-group.info .smart-button-group-items .smart-button-group-item {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

.smart-button-group.info .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(92, 192, 222, .8);
    background-color: rgba(var(--smart-info-rgb), .8)
}

.smart-button-group.info .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.info .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(92, 192, 222, .2);
    background-color: rgba(var(--smart-info-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #5cc0de;
    color: var(--smart-info)
}

.smart-button-group.warning {
    border-color: #f0ad4e;
    border-color: var(--smart-warning)
}

.smart-button-group.warning .smart-button-group-items .smart-button-group-item {
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    color: #fff;
    color: var(--smart-warning-color)
}

.smart-button-group.warning .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(240, 173, 78, .8);
    background-color: rgba(var(--smart-warning-rgb), .8)
}

.smart-button-group.warning .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.warning .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(240, 173, 78, .2);
    background-color: rgba(var(--smart-warning-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #f0ad4e;
    color: var(--smart-warning)
}

.smart-button-group.light {
    border-color: #fff;
    border-color: var(--smart-light)
}

.smart-button-group.light .smart-button-group-items .smart-button-group-item {
    background-color: #fff;
    background-color: var(--smart-light);
    color: #222;
    color: var(--smart-light-color)
}

.smart-button-group.light .smart-button-group-items .smart-button-group-item:hover {
    background-color: hsla(0, 0%, 100%, .8);
    background-color: rgba(var(--smart-light-rgb), .8)
}

.smart-button-group.light .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.light .smart-button-group-items .smart-button-group-item[active] {
    background-color: hsla(0, 0%, 100%, .2);
    background-color: rgba(var(--smart-light-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #fff;
    color: var(--smart-light)
}

.smart-button-group.dark {
    border-color: #222;
    border-color: var(--smart-dark)
}

.smart-button-group.dark .smart-button-group-items .smart-button-group-item {
    background-color: #222;
    background-color: var(--smart-dark);
    color: #fff;
    color: var(--smart-dark-color)
}

.smart-button-group.dark .smart-button-group-items .smart-button-group-item:hover {
    background-color: rgba(34, 34, 34, .8);
    background-color: rgba(var(--smart-dark-rgb), .8)
}

.smart-button-group.dark .smart-button-group-items .smart-button-group-item:active,
.smart-button-group.dark .smart-button-group-items .smart-button-group-item[active] {
    background-color: rgba(34, 34, 34, .2);
    background-color: rgba(var(--smart-dark-rgb), .2);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #222;
    color: var(--smart-dark)
}

.smart-button-group:not([animation=none]) .smart-button-group-item {
    transition: background-color .1s linear, box-shadow .28s ease-in-out
}

.smart-button-group[right-to-left] .smart-button-group-items {
    direction: rtl
}


.smart-calendar[months="1"] {
    min-height: 278px;
    min-height: var(--smart-calendar-default-height);
    min-width: 292px;
    min-width: var(--smart-calendar-default-width)
}

.smart-calendar {
    height: 225px;
    width: 220px;

}

.smart-calendar:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-calendar>.smart-container {
    -ms-user-select: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none
}

.smart-calendar.smart-container,
.smart-calendar>.smart-container {
    display: flex;
    flex-direction: column;
    justify-content: center
}

.smart-calendar smart-drop-down-list {
    --smart-drop-down-list-default-min-height: initial
}

.smart-calendar smart-tooltip {
    top: 0
}

.smart-calendar smart-tooltip .smart-tooltip-content {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-calendar input {
    background: inherit;
    color: inherit
}

.smart-calendar button:focus {
    border: 1px solid #b2b2b2;
    border: 1px solid var(--smart-outline);
    outline: 0
}

.smart-calendar .smart-calendar-container {
    border: initial;
    height: 100%;
    padding: 0;
    width: 100%
}

.smart-calendar .smart-calendar-container>.smart-calendar-body {
    cursor: default;
    display: flex;
    height: calc(100% - 36px);
    height: calc(100% - var(--smart-calendar-header-height));
    margin-left: 2%;
    margin-right: 2%;
    outline: medium none invert;
    outline: initial;
    overflow: hidden;
    padding: 2px 0;
    position: relative;
    touch-action: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: 96%
}

.smart-calendar .smart-calendar-container>.smart-calendar-body:focus .smart-calendar-date-view-container .smart-calendar-cell:focus,
.smart-calendar .smart-calendar-container>.smart-calendar-body:focus .smart-calendar-date-view-container .smart-calendar-cell[focus] {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-calendar .smart-calendar-footer,
.smart-calendar .smart-calendar-header {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    outline: medium none invert;
    outline: initial;
    width: 100%
}

.smart-calendar .smart-calendar-container>.smart-calendar-body>div {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    font-size: inherit
}

.smart-calendar .smart-calendar-container>.smart-calendar-body .smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-header {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    box-sizing: border-box;
    display: flex;
    height: 36px;
    height: var(--smart-calendar-header-height);
    justify-content: center;
    text-transform: uppercase;
    text-transform: var(--smart-calendar-header-text-transform)
}

.smart-calendar .smart-calendar-header.smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-footer {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    box-sizing: border-box;
    display: flex;
    height: 36px;
    height: var(--smart-calendar-footer-height);
    justify-content: center;
    text-transform: uppercase;
    text-transform: var(--smart-calendar-footer-text-transform)
}

.smart-calendar .smart-calendar-footer.smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-title {
    background: #005c99;
    background: var(--smart-primary);
    border: none;
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    flex-direction: column;
    font-family: inherit;
    font-size: inherit;
    height: 60px;
    height: calc(var(--smart-calendar-title-height));
    justify-content: center;
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-calendar-title-padding);
    text-transform: none;
    text-transform: var(--smart-calendar-title-text-transform);
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: 100%
}

.smart-calendar .smart-calendar-title.smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-title div:first-of-type {
    font-size: 70%
}

.smart-calendar .smart-calendar-title .smart-calendar-selected {
    opacity: 1
}

.smart-calendar .smart-calendar-title div {
    border: 1px solid transparent;
    cursor: pointer;
    display: table;
    font-size: 125%;
    opacity: .5;
    position: relative
}

.smart-calendar .smart-calendar-cell[other-month] {
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    opacity: .5
}

.smart-calendar .smart-calendar-cell[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-calendar .smart-calendar-date-element {
    align-items: center;
    border: 1px solid transparent;
    cursor: default;
    display: flex;
    height: 100%;
    outline: medium none invert;
    outline: initial;
    overflow: hidden;
    position: relative;
    text-align: center;
    width: 80%
}

.smart-calendar .smart-calendar-date-element:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-calendar .smart-calendar-date-element>div {
    align-items: center;
    display: flex;
    font-size: inherit;
    height: 100%;
  /*  justify-content: center;*/
    outline: medium none invert;
    outline: initial;
    width: 100%
}

.smart-calendar .smart-calendar-date-element>div:first-of-type {
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    white-space: nowrap
}

.smart-calendar .smart-calendar-date-element div.smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-date-element .smart-ripple {
    background-color: var(--smart-button-color);
    opacity: .2
}

.smart-calendar .smart-calendar-button .smart-button {
    background: 0 0;
    border: none;
    border-radius: 0;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    min-height: 0;
    min-height: auto;
    padding: 0
}

.smart-calendar .smart-calendar-button[next-month],
.smart-calendar .smart-calendar-button[prev-month] {
    background: 0 0;
    border: none;
    border-radius: 100%;
    color: inherit;
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: medium;
    font-weight: inherit;
    height: 30px;
    height: var(--smart-calendar-navigation-button-size);
    min-width: 30px;
    min-width: var(--smart-calendar-navigation-button-size);
    position: relative;
    width: 30px;
    width: var(--smart-calendar-navigation-button-size)
}

.smart-calendar .smart-calendar-button[next-month][active] button,
.smart-calendar .smart-calendar-button[prev-month][active] button {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: 1px solid var(--smart-ui-state-hover);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-calendar .smart-calendar-button[next-year],
.smart-calendar .smart-calendar-button[prev-year] {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-left: none;
    border-radius: 0;
    cursor: default;
    display: block;
    font-size: 10px;
    margin: 0;
    padding: 0;
    position: relative
}

.smart-calendar .smart-calendar-button[next-year] span:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-calendar .smart-calendar-button[prev-year] {
    border-top-color: transparent
}

.smart-calendar .smart-calendar-button[prev-year] span:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-calendar [next-month][focus] button,
.smart-calendar [next-year][focus] button,
.smart-calendar [prev-month][focus] button,
.smart-calendar [prev-year][focus] button {
    background-color: var(--smart-background-focus);
    border: 1px solid var(--smart-border-focus);
    outline: 0
}

.smart-calendar .smart-calendar-list-view.smart-scroll-viewer {
    --smart-input-drop-down-menu-height: 100%;
    --smart-input-drop-down-menu-width: 100%;
    border: initial;
    box-shadow: none;
    color: inherit;
    float: none;
    height: 100%;
    left: 0;
    margin: initial;
    opacity: 1;
    padding: initial;
    position: absolute;
    text-align: center;
    top: 0;
    -webkit-transform: none;
    -webkit-transform: initial;
    transform: none;
    transition: none 0s ease 0s;
    transition: initial;
    width: 100%;
    z-index: auto
}

.smart-calendar .smart-calendar-week .smart-calendar-cell,
.smart-calendar .smart-calendar-week .smart-calendar-week-number {
    height: 18px;


    overflow: hidden;
    padding: 0;
    position: relative;
    text-overflow: ellipsis;
    width: 25px;

}

.smart-calendar .smart-calendar-list-view.smart-scroll-viewer>.smart-container {
    max-height: none
}

.smart-calendar .smart-calendar-list-view.smart-scroll-viewer a {
    pointer-events: none
}

.smart-calendar .smart-calendar-week {
    display: flex;
    justify-content: center;
    overflow: hidden;
    text-align: center
}

.smart-calendar .smart-calendar-week .smart-calendar-cell {
    border: 1px solid transparent;
    border-bottom-left-radius: 15px;
    border-bottom-left-radius: var(--smart-calendar-cell-border-bottom-left-radius);
    border-bottom-right-radius: 15px;
    border-bottom-right-radius: var(--smart-calendar-cell-border-bottom-right-radius);
    border-top-left-radius: 15px;
    border-top-left-radius: var(--smart-calendar-cell-border-top-left-radius);
    border-top-right-radius: 15px;
    border-top-right-radius: var(--smart-calendar-cell-border-top-right-radius);
 /*   margin-bottom: 4px;
    margin-bottom: var(--smart-calendar-cell-spacing);
    margin-right: 4px;
    margin-right: var(--smart-calendar-cell-spacing)*/
}

.smart-calendar .smart-calendar-week .smart-calendar-cell[selected],
.smart-calendar .smart-calendar-week .smart-calendar-cell[selected][hover] {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-calendar .smart-calendar-week .smart-calendar-cell[today],
.smart-calendar .smart-calendar-week .smart-calendar-cell[today][hover] {
    background: #2d2d30;
    background: var(--smart-secondary);
    border-color: #2d2d30;
    border-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-calendar .smart-calendar-week .smart-calendar-cell[selected][today] {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-calendar .smart-calendar-week .smart-calendar-cell:focus:not([selected]),
.smart-calendar .smart-calendar-week .smart-calendar-cell[focus]:not([selected]) {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-calendar .smart-calendar-week .smart-calendar-cell .smart-ripple {
    background-color: #fff;
    background-color: var(--smart-primary-color);
    opacity: .5
}

.smart-calendar .smart-calendar-week .smart-calendar-week-number {
    border: 1px solid transparent;
    border-bottom-left-radius: 15px;
    border-bottom-left-radius: var(--smart-calendar-cell-border-bottom-left-radius);
    border-bottom-right-radius: 15px;
    border-bottom-right-radius: var(--smart-calendar-cell-border-bottom-right-radius);
    border-top-left-radius: 15px;
    border-top-left-radius: var(--smart-calendar-cell-border-top-left-radius);
    border-top-right-radius: 15px;
    border-top-right-radius: var(--smart-calendar-cell-border-top-right-radius);
    margin: 0
}

.smart-calendar .smart-calendar-week.smart-hidden {
    display: none
}

.smart-calendar .smart-calendar-week div[restricted] {
    cursor: not-allowed;
    opacity: .55;
    text-decoration: line-through
}

.smart-calendar .smart-calendar-week div[hover]:not([restricted]) {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-calendar .smart-calendar-week div[important] {
    background: #ebebeb;
    background: var(--smart-calendar-important-date-background);
    border-color: #ebebeb;
    border-color: var(--smart-calendar-important-date-border-color);
    color: #333;
    color: var(--smart-calendar-important-date-color)
}

@-moz-document url-prefix() {
    .smart-calendar .smart-calendar-week div {
        padding: initial
    }
}

.smart-calendar .smart-calendar-week-number {
    display: none;
    margin: auto
}

.smart-calendar .smart-calendar-week-titles {
    display: flex;
    justify-content: center;
    overflow: hidden;
    text-align: center
}

.smart-calendar .smart-calendar-week-titles div:first-child {
    display: none;
    margin: auto
}

.smart-calendar .smart-calendar-week-titles .smart-calendar-week-title {
    border: 1px solid transparent;
    border-bottom-left-radius: 15px;
    border-bottom-left-radius: var(--smart-calendar-cell-border-bottom-left-radius);
    border-bottom-right-radius: 15px;
    border-bottom-right-radius: var(--smart-calendar-cell-border-bottom-right-radius);
    border-top-left-radius: 15px;
    border-top-left-radius: var(--smart-calendar-cell-border-top-left-radius);
    border-top-right-radius: 15px;
    border-top-right-radius: var(--smart-calendar-cell-border-top-right-radius);
    height: 23px;

   /* margin-bottom: 4px;
    margin-bottom: var(--smart-calendar-cell-spacing);
    margin-right: 4px;
    margin-right: var(--smart-calendar-cell-spacing);*/
    overflow: hidden;
    padding: 0;
    position: relative;
    text-overflow: ellipsis;
    text-transform: uppercase;
    text-transform: var(--smart-calendar-week-title-text-transform);
    width: 25px;

}

.smart-calendar .smart-calendar-months-container {
    align-items: center;
    height: 100%;
    order: 1;
    width: 100%
}

.smart-calendar .smart-calendar-month {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    max-width: 292px;
    max-width: var(--smart-calendar-default-width);
    overflow: hidden;
    text-align: center
}

.smart-calendar .smart-calendar-month-name {
    display: none
}

.smart-calendar .smart-calendar-month-separator {
    display: flex;
    justify-content: center;
    order: 2;
    overflow: hidden;
    text-align: center;
    width: 50%
}

.smart-calendar .smart-calendar-month-element {
    font-size: inherit;
    height: 80%;
    margin: 5% 0;
    position: relative;
    text-align: center;
    width: 60%
}

.smart-calendar .smart-calendar-year-container:focus {
    border: 1px solid #b2b2b2;
    border: 1px solid var(--smart-outline);
    outline: 0
}

.smart-calendar .smart-calendar-year-element {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-color: var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0;
    font-size: inherit;
    height: 80%;
    margin-left: 5%;
    outline: 0;
    padding: 2px;
    text-align: center;
    width: 25%
}

.smart-calendar .smart-calendar-year-element:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-calendar .smart-calendar-year-elements {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 80%;
    justify-content: space-around;
    width: 10%
}

.smart-calendar .smart-calendar-year-elements>smart-repeat-button {
    height: 50%;
    width: 100%
}

.smart-calendar .smart-calendar-year-selector {
    display: inline-block
}

.smart-calendar .smart-calendar-next-months-container {
    align-items: center;
    height: 100%;
    order: 3;
    width: 100%
}

@-moz-document url-prefix() {

    .smart-calendar .smart-calendar-months-container,
    .smart-calendar .smart-calendar-next-months-container {
        line-height: normal
    }
}

.smart-calendar .smart-calendar-date-container:focus {
    border: 1px solid #b2b2b2;
    border: 1px solid var(--smart-outline);
    outline: 0
}

.smart-calendar .smart-calendar-date-view-container {
    align-items: center;
    flex-direction: row;
    height: 100%;
    text-align: center;
    width: 100%
}

.smart-calendar .smart-calendar-date-view-container.smart-list-display-mode-view {
    flex-direction: column
}

.smart-calendar .smart-calendar-date-view-container .smart-calendar-cell {
    align-items: center;
    border: 1px solid transparent;
    border-bottom-left-radius: 15px;
    border-bottom-left-radius: var(--smart-calendar-cell-border-bottom-left-radius);
    border-bottom-right-radius: 15px;
    border-bottom-right-radius: var(--smart-calendar-cell-border-bottom-right-radius);
    border-top-left-radius: 15px;
    border-top-left-radius: var(--smart-calendar-cell-border-top-left-radius);
    border-top-right-radius: 15px;
    border-top-right-radius: var(--smart-calendar-cell-border-top-right-radius);
    display: flex;
    height: 23%;
    justify-content: center;
    margin: 0 1%;
    position: relative;
    width: 23%
}

.smart-calendar .smart-calendar-date-view-container .smart-calendar-cell[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-calendar .smart-calendar-date-view-container .smart-calendar-cell[other-month] {
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    opacity: .5
}

.smart-calendar .smart-calendar-date-view-container .smart-visibility-hidden {
    opacity: .55;
    visibility: visible
}

.smart-calendar .smart-calendar-animation-panel {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    justify-content: center;
    pointer-events: none;
    position: absolute
}

.smart-calendar[months] .smart-calendar-month {
    width: 50%
}

.smart-calendar[months] .smart-calendar-month-name {
    display: inline;
    display: initial
}

.smart-calendar[hide-day-names] .smart-calendar-week-titles,
.smart-calendar[months="1"] .smart-calendar-month-name {
    display: none
}

.smart-calendar[months]:not([months="1"]) {
    height: 374px;
    height: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height) + var(--smart-calendar-footer-height));
    width: 614px;
    width: calc(var(--smart-calendar-default-width)*2 + var(--smart-calendar-cell-size))
}

.smart-calendar[months="1"] {
    height: 278px;
    height: var(--smart-calendar-default-height);
    width: 292px;
    width: var(--smart-calendar-default-width)
}

.smart-calendar[months="1"] .smart-calendar-month {
    font-size: 100%;
    width: 100%
}

.smart-calendar[months="3"],
.smart-calendar[months="4"] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*2 + var(--smart-calendar-cell-spacing)*2 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*2 + var(--smart-calendar-header-height)*2)
}

.smart-calendar[months="5"],
.smart-calendar[months="6"] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*3 + var(--smart-calendar-cell-spacing)*3 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*3 + var(--smart-calendar-header-height)*3)
}

.smart-calendar[months="7"],
.smart-calendar[months="8"] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*4 + var(--smart-calendar-cell-spacing)*4 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*4 + var(--smart-calendar-header-height)*4)
}

.smart-calendar[months="10"],
.smart-calendar[months="9"] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*5 + var(--smart-calendar-cell-spacing)*5 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*5 + var(--smart-calendar-header-height)*5)
}

.smart-calendar[months="11"],
.smart-calendar[months="12"] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*6 + var(--smart-calendar-cell-spacing)*6 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*6 + var(--smart-calendar-header-height)*6)
}

@media only screen and (max-width:768px) {
    .smart-calendar[months] .smart-calendar-month {
        width: 100%
    }

    .smart-calendar[months="2"] {
        height: 374px;
        height: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height) + var(--smart-calendar-footer-height))
    }

    .smart-calendar[months="3"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*3 + var(--smart-calendar-cell-spacing)*3 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*3 + var(--smart-calendar-header-height)*3)
    }

    .smart-calendar[months="4"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*4 + var(--smart-calendar-cell-spacing)*4 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*4 + var(--smart-calendar-header-height)*4)
    }

    .smart-calendar[months="5"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*5 + var(--smart-calendar-cell-spacing)*5 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*5 + var(--smart-calendar-header-height)*5)
    }

    .smart-calendar[months="6"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*6 + var(--smart-calendar-cell-spacing)*6 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*6 + var(--smart-calendar-header-height)*6)
    }

    .smart-calendar[months="7"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*7 + var(--smart-calendar-cell-spacing)*7 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*7 + var(--smart-calendar-header-height)*7)
    }

    .smart-calendar[months="8"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*8 + var(--smart-calendar-cell-spacing)*8 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*8 + var(--smart-calendar-header-height)*8)
    }

    .smart-calendar[months="9"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*9 + var(--smart-calendar-cell-spacing)*9 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*9 + var(--smart-calendar-header-height)*9)
    }

    .smart-calendar[months="10"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*10 + var(--smart-calendar-cell-spacing)*10 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*10 + var(--smart-calendar-header-height)*10)
    }

    .smart-calendar[months="11"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*11 + var(--smart-calendar-cell-spacing)*11 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*11 + var(--smart-calendar-header-height)*11)
    }

    .smart-calendar[months="12"] {
        --smart-calendar-default-height: calc(var(--smart-calendar-title-height)*12 + var(--smart-calendar-cell-spacing)*12 + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7*12 + var(--smart-calendar-header-height)*12)
    }
}
.smart-calendar-cell
{
    vertical-align: middle;
    display: inline-table;
}
.smart-calendar[view-sections*=footer] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height) + var(--smart-calendar-footer-height))
}
smart-repeat-button.smart-calendar-button.smart-element.smart-repeat-button[next-month], smart-repeat-button.smart-calendar-button.smart-element.smart-repeat-button[prev-month]
{
    display: none
}
.smart-calendar[view-sections*=footer][view-sections*=header] .smart-calendar-container>.smart-calendar-body {
    height: calc(100% - 62px);
   /* height: calc(100% - var(--smart-calendar-header-height) - var(--smart-calendar-footer-height))*/
}

.smart-calendar[view-sections*=title] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height))
}

.smart-calendar[view-sections*=title] .smart-calendar-container {
    height: calc(100% - 60px);
    height: calc(100% - var(--smart-calendar-title-height));
    width: 100%
}

.smart-calendar[view-sections*=title][view-sections*=footer] {
    --smart-calendar-default-height: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height) + var(--smart-calendar-footer-height))
}

.smart-calendar[scroll-buttons-position=near] .smart-calendar-button[prev-month] {
    order: 1
}

.smart-calendar[scroll-buttons-position=near] .smart-calendar-button[next-month] {
    order: 2
}

.smart-calendar[scroll-buttons-position=near] .smart-calendar-date-element {
    order: 3
}

.smart-calendar[scroll-buttons-position=far] .smart-calendar-date-element {
    order: 1
}

.smart-calendar[scroll-buttons-position=far] .smart-calendar-button[prev-month] {
    order: 2
}

.smart-calendar[scroll-buttons-position=far] .smart-calendar-button[next-month] {
    order: 3
}

.smart-calendar[scroll-buttons-navigation-mode=portrait] .smart-calendar-month-separator {
    height: 50%;
    width: 100%
}

.smart-calendar[scroll-buttons-navigation-mode=portrait] .smart-calendar-container>.smart-calendar-body {
    flex-direction: column
}

.smart-calendar[calendar-mode=classic] .smart-calendar-title div {
    cursor: auto
}

.smart-calendar[calendar-mode=classic] .smart-calendar-date-element {
    align-items: normal;
    overflow: visible;
    overflow: initial
}

.smart-calendar[display-mode-view=list][display-mode=decade] .smart-calendar-container>.smart-calendar-body,
.smart-calendar[display-mode-view=list][display-mode=year] .smart-calendar-container>.smart-calendar-body {
    touch-action: auto
}

.smart-calendar[hide-other-month-days] .smart-calendar-cell[other-month] {
    visibility: hidden
}

.smart-calendar[week-numbers] {
    --smart-calendar-default-width: calc(var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*8)
}

.smart-calendar[week-numbers][view-sections*=title][view=landscape] {
    --smart-calendar-default-width: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*8)
}

.smart-calendar[week-numbers] .smart-calendar-week-number,
.smart-calendar[week-numbers] .smart-calendar-week-titles div:first-child {
    display: inline;
    display: initial
}

.smart-calendar[view=portrait].smart-container,
.smart-calendar[view=portrait]>.smart-container {
    display: flex;
    flex-direction: column;
    justify-content: center
}

.smart-calendar[view=landscape] {
    --smart-calendar-default-width: calc(var(--smart-calendar-title-height) + var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7);
    --smart-calendar-default-height: calc(var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height))
}

.smart-calendar[view=landscape].smart-container,
.smart-calendar[view=landscape]>.smart-container {
    flex-direction: row
}

.smart-calendar[view=landscape] .smart-calendar-container {
    height: 100%;
    width: calc(100% - 60px);
    width: calc(100% - var(--smart-calendar-title-height))
}

.smart-calendar[view=landscape] .smart-calendar-title {
    height: 100%;
    justify-content: flex-start;
    width: 60px;
    width: calc(var(--smart-calendar-title-height))
}

.smart-calendar[view=landscape][view-sections*=footer] {
    --smart-calendar-default-height: calc(var(--smart-calendar-cell-spacing) + (var(--smart-calendar-cell-spacing) + var(--smart-calendar-cell-size))*7 + var(--smart-calendar-header-height) + var(--smart-calendar-footer-height))
}

.smart-calendar[animation=none] .smart-calendar-body .smart-calendar-month-separator,
.smart-calendar[animation=none] .smart-calendar-body .smart-calendar-next-months-container {
    display: none
}

.smart-calendar[right-to-left] .smart-calendar-date-element>div,
.smart-calendar[right-to-left] .smart-calendar-date-view-container,
.smart-calendar[right-to-left] .smart-calendar-date-view-container .smart-calendar-cell,
.smart-calendar[right-to-left] .smart-calendar-footer,
.smart-calendar[right-to-left] .smart-calendar-title,
.smart-calendar[right-to-left] .smart-calendar-week .smart-calendar-cell,
.smart-calendar[right-to-left] .smart-calendar-week .smart-calendar-week-number,
.smart-calendar[right-to-left] .smart-calendar-week-titles .smart-calendar-week-title {
    direction: rtl
}

.smart-calendar[right-to-left] .smart-calendar-month-element {
    direction: ltr
}

.smart-calendar[right-to-left] .smart-calendar-year-element {
    margin-left: 0;
    margin-right: 5%
}

.smart-calendar[right-to-left][view=landscape]>.smart-container {
    flex-direction: row-reverse
}

.smart-cards {
    align-items: flex-start;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-left: auto;
    margin-right: auto;
    max-width: 1500px;
    width: 100%
}

@media only screen and (max-width:768px) {
    .smart-cards smart-card {
        margin: 0 10px 10px
    }
}

smart-card {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    box-sizing: border-box;
    display: inline-block;
    font-size: inherit;
    margin: 1%;
    min-height: 20px;
    width: 30.5%
}

@media only screen and (max-width:1024px) {
    smart-card {
        display: inline-block;
        width: 47%
    }
}

@media only screen and (max-width:768px) {
    smart-card {
        display: block;
        margin: 0;
        max-height: 100vh;
        overflow-y: auto;
        width: 100%
    }
}

smart-card:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4)
}

smart-card.simple {
    box-shadow: unset;
    margin: 0;
    width: auto
}

smart-card[right-to-left].smart-container,
smart-card[right-to-left]>.smart-container {
    direction: rtl
}

.smart-card-view {
    height: 800px;
    height: var(--smart-card-view-default-height);
    min-height: 100px;
    min-width: 250px;
    min-width: var(--smart-card-view-column-min-width);
    width: 1200px;
    width: var(--smart-card-view-default-width)
}

.smart-card-view.smart-container {
    contain: layout style;
    position: relative
}

.smart-card-view.smart-container>smart-scroll-viewer,
.smart-card-view>.smart-container>smart-scroll-viewer {
    background-color: transparent;
    border: none;
    contain: layout style;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-card-view.smart-container>smart-scroll-viewer .smart-scroll-viewer-content-container,
.smart-card-view>.smart-container>smart-scroll-viewer .smart-scroll-viewer-content-container {
    display: flex;
    padding: 0
}

.smart-card-view.smart-container[modal],
.smart-card-view>.smart-container[modal] {
    pointer-events: none;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-card-view.smart-container[modal]:after,
.smart-card-view>.smart-container[modal]:after {
    background-color: #000;
    content: "";
    cursor: default;
    height: 100%;
    left: 0;
    opacity: .3;
    pointer-events: none;
    position: absolute;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-card-view.smart-container[modal] .smart-indicator,
.smart-card-view>.smart-container[modal] .smart-indicator {
    pointer-events: none;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-card-view.smart-container[modal] .smart-carousel-item.smart-active,
.smart-card-view>.smart-container[modal] .smart-carousel-item.smart-active {
    pointer-events: none
}

.smart-card-view smart-card {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid;
    border: var(--smart-border-width) solid;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    overflow: auto;
    padding: 10px;
    padding: var(--smart-data-view-padding);
    width: unset
}

.smart-card-view smart-card>.smart-container {
    grid-row-gap: 15px;
    grid-row-gap: var(--smart-card-view-vertical-offset);
    display: grid;
    grid-template-rows: 1fr;
    overflow: auto
}

.smart-card-view smart-card .smart-arrow-up.collapsed {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg)
}

.smart-card-view smart-card .smart-card-view-content.smart-visibility-hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-card-view smart-card.collapsed {
    align-self: start;
    height: auto !important
}

.smart-card-view smart-card[updating] .smart-card-view-content,
.smart-card-view smart-card[updating] .smart-card-view-title .smart-arrow-up {
    transition: none
}

.smart-card-view smart-card.drop-target {
    position: relative
}

.smart-card-view smart-card.drop-target:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    content: "";
    height: 5000px;
    position: absolute;
    text-decoration: underline;
    top: 0;
    width: 10%
}

.smart-card-view smart-card.drop-target.left:after {
    left: 0
}

.smart-card-view smart-card.drop-target.right:after {
    right: 0
}

.smart-card-view smart-card.dragged {
    position: relative
}

.smart-card-view smart-card.dragged:after {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em;
    content: "";
    height: 5000px;
    left: 0;
    opacity: .8;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-card-view smart-carousel {
    width: 100%
}

.smart-card-view smart-carousel .smart-carousel-item {
    background-size: cover;
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border)
}

.smart-card-view smart-carousel .smart-carousel-item.smart-active {
    pointer-events: none
}

.smart-card-view smart-carousel .smart-indicator {
    pointer-events: all
}

.smart-card-view smart-carousel .smart-indicator:only-child {
    display: none
}

.smart-card-view smart-carousel * {
    pointer-events: none
}

.smart-card-view[header-position=bottom].smart-container>smart-scroll-viewer,
.smart-card-view[header-position=top].smart-container>smart-scroll-viewer {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-card-view-header-height))
}

.smart-card-view .smart-card-container {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-card-view-column-gap, var(--smart-card-view-gap));
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-card-view-row-gap, var(--smart-card-view-gap));
    border: none;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-template-columns: repeat(auto-fit, minmax(var(--smart-card-view-column-min-width), 1fr));
    height: 100%;
    width: 100%
}

.smart-card-view .smart-data-view-header {
    height: 30px;
    height: var(--smart-card-view-header-height)
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top {
    padding: 10px;
    padding: var(--smart-data-view-padding);
    padding-bottom: 0
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top>div {
    align-items: center;
    display: flex;
    justify-content: space-between
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top smart-switch-button {
    margin-left: 30px;
    margin-right: 30px;
    position: relative;
    z-index: 1
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top smart-switch-button:before {
    content: attr(crop);
    font-size: 11px;
    left: -30px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top smart-switch-button:after {
    content: attr(fit);
    font-size: 11px;
    left: calc(100% + 5px);
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-card-view .smart-data-view-header-drop-down .smart-card-view-customize-top smart-input {
    width: 100%
}

.smart-card-view .smart-scroll-viewer-container.vscroll .smart-card-container {
    padding-right: 3px
}

.smart-card-view .smart-card-data-container {
    display: grid;
    grid-template-rows: 1fr;
    padding: 0 .5rem
}

.smart-card-view .smart-card-view-value {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word
}

.smart-card-view .smart-card-view-title {
    align-items: center;
    display: grid;
    font-size: 17px;
    font-size: calc(var(--smart-font-size) + 3px);
    font-weight: 700;
    grid-template-columns: 1fr auto;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%
}

.smart-card-view .smart-card-view-title:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-card-view .smart-card-view-title .smart-arrow-up {
    background-color: #5a5a5a;
    background-color: var(--smart-background-color);
    border-radius: 50%;
    cursor: pointer;
    display: none;
    height: 16px;
    opacity: .7;
    width: 16px
}

.smart-card-view .smart-card-view-title .smart-arrow-up:after {
    color: #fefefe;
    color: var(--smart-background)
}

.smart-card-view .smart-card-view-title .smart-arrow-up:hover {
    opacity: 1
}

.smart-card-view .smart-card-view-label {
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-card-view-vertical-offset)/3);
    opacity: .7;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase
}

.smart-card-view .smart-card-view-label.icon {
    padding-left: 30px;
    position: relative
}

.smart-card-view[right-to-left] .smart-card-view-label.icon,
.smart-window.smart-card-view-window[right-to-left] .smart-card-view-label.icon {
    padding-left: 0;
    padding-right: 30px
}

.smart-card-view .smart-card-view-label.icon:after {
    background-position: 50%;
    background-repeat: no-repeat;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 30px
}

.smart-card-view .smart-card-view-content {
    margin-top: 15px;
    margin-top: var(--smart-card-view-vertical-offset);
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-card-view .smart-card-view-cell {
    margin-bottom: 15px;
    margin-bottom: var(--smart-card-view-vertical-offset)
}

.smart-card-view .smart-card-view-cell:last-child,
.smart-card-view[cell-orientation=horizontal] .smart-card-view-label {
    margin-bottom: 0
}

.smart-card-view .smart-add-new-button {
    display: none
}

.smart-card-view[cell-orientation=horizontal] .smart-card-view-cell {
    align-items: center;
    display: flex;
    justify-content: space-between
}

.smart-card-view[cell-orientation=horizontal] .smart-card-view-value {
    text-align: right
}

.smart-card-view[cover-mode=fit] .smart-carousel-item {
    background-size: contain
}

.smart-card-view[editable] smart-card {
    cursor: pointer
}

.smart-card-view[add-new-button] .smart-add-new-button {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 50%;
    bottom: 20px;
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: block;
    height: 60px;
    height: var(--smart-card-view-add-new-button-size);
    position: absolute;
    right: 41px;
    right: calc(23px + var(--smart-scroll-bar-size));
    width: 60px;
    width: var(--smart-card-view-add-new-button-size)
}

.smart-card-view[add-new-button] .smart-add-new-button:after {
    align-items: center;
    content: "\\e803";
    content: var(--smart-icon-plus);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 20px;
    height: 100%;
    justify-content: center;
    margin-top: 2px;
    width: 100%
}

.smart-card-view[add-new-button] .smart-add-new-button:hover {
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
}

.smart-card-view[add-new-button]:not([animation=none]) .smart-add-new-button {
    transition: -webkit-transform .5s cubic-bezier(.81, .27, 0, .93);
    transition: transform .5s cubic-bezier(.81, .27, 0, .93);
    transition: transform .5s cubic-bezier(.81, .27, 0, .93), -webkit-transform .5s cubic-bezier(.81, .27, 0, .93)
}

.smart-card-view[empty] .smart-card-view-header {
    opacity: .55;
    pointer-events: none
}

.smart-card-view[empty] .smart-card-container:after {
    content: attr(no-data)
}

.smart-card-view[no-matches] .smart-card-container:after {
    content: attr(no-matches)
}

.smart-card-view[empty] .smart-card-container,
.smart-card-view[empty] .smart-scroll-viewer-content-container,
.smart-card-view[no-matches] .smart-card-container,
.smart-card-view[no-matches] .smart-scroll-viewer-content-container {
    height: 100%
}

.smart-card-view[empty] .smart-card-container:after,
.smart-card-view[no-matches] .smart-card-container:after {
    align-items: center;
    display: flex;
    font-style: italic;
    justify-content: center
}

.smart-card-view[loading] smart-card>.smart-container {
    visibility: hidden
}

.smart-card-view[loading] smart-card.smart-hidden {
    display: flex !important
}

.smart-card-view[loading] .smart-card-view-content {
    transition: none
}

.smart-card-view[cover-field]:not([cover-field=null]) smart-card>.smart-container {
    grid-template-rows: 200px 1fr;
    grid-template-rows: var(--smart-card-view-cover-height) 1fr
}

.smart-card-view[collapsible] .smart-card-data-container,
.smart-card-view[title-field] .smart-card-data-container {
    grid-template-rows: auto 1fr
}

.smart-card-view:not([collapsible]) .smart-card-view-title.empty {
    display: none
}

.smart-card-view:not([collapsible]) .smart-card-view-title.empty:first-child+.smart-card-view-content {
    margin-top: 0
}

.smart-card-view:not([animation=none]) .smart-card-view-title .smart-arrow-up {
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-card-view:not([animation=none]) .smart-card-view-content {
    transition-duration: .2s;
    transition-property: margin-top, height, visibility, opacity, -webkit-transform;
    transition-property: margin-top, height, transform, visibility, opacity;
    transition-property: margin-top, height, transform, visibility, opacity, -webkit-transform;
    transition-timing-function: ease-in
}

.smart-card-view[collapsible] .smart-card-view-title .smart-arrow-up {
    display: block
}

.smart-card-view[dragging] smart-card {
    overflow: hidden
}

.smart-card-view[allow-drag] .smart-card-data-container {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-card-view[allow-drag] .smart-card-view-content {
    pointer-events: none
}

.smart-card-view[right-to-left] .smart-card-view-label.icon:after {
    left: auto;
    right: 0
}

.smart-card-view[right-to-left] .smart-card-view-customize-top {
    direction: rtl
}

.smart-card-view[right-to-left] .smart-scroll-viewer-container.vscroll .smart-card-container {
    padding-left: 3px;
    padding-right: 0
}

.smart-window.smart-card-view-window {
    --smart-numeric-text-box-text-align: left;
    --smart-window-default-height: 75%;
    cursor: auto;
    z-index: 999
}

.smart-window.smart-card-view-window .smart-header {
    font-size: 21px;
    font-size: calc(var(--smart-font-size)*1.5)
}

.smart-window.smart-card-view-window .smart-next-button:after,
.smart-window.smart-card-view-window .smart-prev-button:after {
    font-size: calc(100% - 2px)
}

.smart-window.smart-card-view-window .smart-prev-button:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-window.smart-card-view-window .smart-next-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-window.smart-card-view-window .smart-card-view-label {
    display: flex;
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    justify-content: space-between;
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-card-view-vertical-offset)/3);
    opacity: .7;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase
}

.smart-window.smart-card-view-window .smart-card-view-label .toggle-visibility {
    color: var(--smart-color);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-window.smart-card-view-window .smart-card-view-label .toggle-visibility:after {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-window.smart-card-view-window .smart-card-view-label .toggle-visibility.hidden:after {
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

.smart-window.smart-card-view-window .smart-card-view-label:not(:first-child) {
    margin-top: 15px;
    margin-top: var(--smart-card-view-vertical-offset)
}

.smart-window.smart-card-view-window .smart-card-view-label.icon {
    padding-left: 30px;
    position: relative
}

.smart-window.smart-card-view-window .smart-card-view-label.icon:after {
    background-position: 50%;
    background-repeat: no-repeat;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 30px
}

.smart-window.smart-card-view-window .smart-content-container>.smart-content {
    display: block;
    padding: 20px
}

.smart-window.smart-card-view-window .smart-content-container>.smart-footer {
    align-items: center;
    display: flex;
    justify-content: space-evenly
}

.smart-window.smart-card-view-window .smart-footer smart-button {
    --smart-button-padding: 0;
    height: 100%;
    width: 25%
}

.smart-window.smart-card-view-window .smart-card-view-editor {
    width: 100%
}

.smart-window.smart-card-view-window .smart-card-view-editor.image .thumbnail {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    cursor: pointer;
    display: inline-block;
    height: 75px;
    margin-right: 5px;
    position: relative;
    width: 75px
}

.smart-window.smart-card-view-window .smart-card-view-editor.image .thumbnail:hover:after {
    align-items: center;
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 50px;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: .4;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-window.smart-card-view-window .smart-card-view-editor.image .label {
    font-size: 11px;
    font-size: calc(var(--smart-font-size) - 3px);
    margin-top: 3px;
    opacity: .7;
    text-transform: uppercase
}

.smart-window.smart-card-view-window .smart-card-view-editor.image .container {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    height: 30px;
    justify-content: space-between;
    margin-top: 5px
}

.smart-window.smart-card-view-window .smart-card-view-editor.image smart-input {
    height: 100%;
    width: calc(100% - 40px)
}

.smart-window.smart-card-view-window .smart-card-view-editor.image smart-button {
    --smart-button-padding: 0;
    font-size: 20px;
    height: 100%;
    width: 30px
}

.smart-window.smart-card-view-window textarea.smart-card-view-editor {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    font-family: inherit;
    font-size: inherit;
    min-height: 150px;
    resize: vertical
}

.smart-window.smart-card-view-window textarea.smart-card-view-editor:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-window.smart-card-view-window textarea.smart-card-view-editor:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-window.smart-card-view-window[right-to-left] .smart-card-view-label.icon:after {
    left: auto;
    right: 0
}

.smart-card-view-drag-feedback {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 20px;
    opacity: .85;
    padding: 5px;
    position: absolute;
    white-space: nowrap;
    z-index: 10000
}

.smart-card-view-drag-feedback>.drag-feedback-thumbnail {
    background-size: cover;
    height: 50px;
    width: 50px
}

.smart-card-view-drag-feedback:nth-child(2) {
    margin-left: 10px
}

.smart-card-view-drag-feedback[right-to-left] {
    direction: rtl
}

.smart-card-view-drag-feedback[right-to-left]:nth-child(2) {
    margin-left: 0;
    margin-right: 10px
}

.smart-column-panel[right-to-left] .smart-grid-panel-container-footer,
.smart-group-panel[right-to-left] .smart-grid-panel-container-footer,
.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-container-footer,
.smart-sort-panel[right-to-left] .smart-grid-panel-container-footer {
    flex-direction: row-reverse
}

.smart-column-panel[right-to-left] .smart-grid-panel-buttons-container .smart-grid-panel-apply-button,
.smart-group-panel[right-to-left] .smart-grid-panel-buttons-container .smart-grid-panel-apply-button,
.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-buttons-container .smart-grid-panel-apply-button,
.smart-sort-panel[right-to-left] .smart-grid-panel-buttons-container .smart-grid-panel-apply-button {
    margin-left: 0;
    margin-right: 15px
}

smart-carousel .smart-carousel-item,
smart-carousel .smart-carousel-item .smart-carousel-item-container {
    background-position: 50%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    height: 100%;
    pointer-events: none
}

smart-carousel {
    height: 200px;
    height: var(--smart-carousel-default-height);
    width: 600px;
    width: var(--smart-carousel-default-width)
}

smart-carousel.smart-container,
smart-carousel>.smart-container {
    display: block;
    height: 100%;
    position: relative;
    width: 100%
}

smart-carousel .smart-items-container {
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-carousel[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none
}

smart-carousel .smart-carousel-item,
smart-carousel[swipe] {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-carousel .smart-carousel-item {
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0
}

smart-carousel .smart-carousel-item .smart-carousel-item-container {
    background-size: cover;
    padding-top: 50px;
    position: relative;
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
    width: 100%;
    z-index: 1
}

smart-carousel .smart-carousel-item .smart-carousel-item-content,
smart-carousel .smart-carousel-item .smart-carousel-item-label {
    box-sizing: border-box;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 30%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

smart-carousel .smart-carousel-item .smart-carousel-item-content {
    top: 40%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%)
}

smart-carousel .smart-carousel-item .smart-carousel-html-content {
    box-sizing: border-box;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0
}

smart-carousel .smart-carousel-item.smart-active {
    opacity: 1;
    pointer-events: all;
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text
}

smart-carousel .smart-arrow {
    cursor: pointer;
    display: block;
    height: 100%;
    opacity: .6;
    position: absolute;
    top: 0;
    width: 30px
}

smart-carousel[hide-arrows] .smart-arrow,
smart-carousel[hide-indicators] .smart-indicators-container {
    display: none
}

smart-carousel .smart-arrow:after {
    font-size: 20px;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-carousel .smart-arrow:focus,
smart-carousel .smart-arrow:hover {
    opacity: .8
}

smart-carousel .smart-arrow:active {
    opacity: 1
}

smart-carousel .smart-arrow>.smart-button {
    border-width: 0
}

smart-carousel .smart-arrow>.smart-button:active {
    background-color: transparent
}

smart-carousel .smart-arrow[disabled] {
    opacity: .4;
    pointer-events: none
}

smart-carousel .smart-arrow.smart-arrow-left {
    left: 0
}

smart-carousel .smart-arrow.smart-arrow-right {
    right: 0
}

smart-carousel .smart-indicators-container {
    align-items: center;
    bottom: 10px;
    display: flex;
    flex-direction: row;
    left: 50%;
    position: absolute;
    -webkit-transform: translate(-50%);
    transform: translate(-50%)
}

smart-carousel .smart-indicators-container .smart-indicator {
    background-color: #fff;
    border: 1px solid gray;
    box-sizing: content-box;
    cursor: pointer;
    height: 10px;
    margin: 2px;
    opacity: .5;
    width: 10px
}

smart-carousel .smart-indicators-container .smart-indicator.smart-active {
    border-width: 3px;
    opacity: .9
}

smart-carousel .smart-indicators-container .smart-indicator:hover {
    opacity: .7
}

smart-carousel:not([animation=none]) .smart-carousel-item {
    -webkit-animation-duration: 1s;
    animation-duration: 1s
}

smart-carousel:not([animation=none]) .smart-carousel-item.smart-active.smart-animate-trigger,
smart-carousel:not([animation=none]).fade .smart-carousel-item.smart-active.smart-animate-trigger {
    -webkit-animation-name: carousel-active-fade;
    animation-name: carousel-active-fade
}

smart-carousel:not([animation=none]) .smart-carousel-item.smart-out.smart-animate-trigger,
smart-carousel:not([animation=none]).fade .smart-carousel-item.smart-out.smart-animate-trigger {
    -webkit-animation-name: carousel-out-fade;
    animation-name: carousel-out-fade
}

smart-carousel:not([animation=none]).slide .smart-carousel-item.smart-active.smart-animate-trigger,
smart-carousel:not([animation=none]).slide-left .smart-carousel-item.smart-active.smart-animate-trigger {
    -webkit-animation-name: carousel-active-slide;
    animation-name: carousel-active-slide
}

smart-carousel:not([animation=none]).slide .smart-carousel-item.smart-out.smart-animate-trigger,
smart-carousel:not([animation=none]).slide-left .smart-carousel-item.smart-out.smart-animate-trigger {
    -webkit-animation-name: carousel-out-slide;
    animation-name: carousel-out-slide
}

smart-carousel:not([animation=none]).slide-right .smart-carousel-item.smart-active.smart-animate-trigger {
    -webkit-animation-name: carousel-active-slide-right;
    animation-name: carousel-active-slide-right
}

smart-carousel:not([animation=none]).slide-right .smart-carousel-item.smart-out.smart-animate-trigger {
    -webkit-animation-name: carousel-out-slide-right;
    animation-name: carousel-out-slide-right
}

smart-carousel:not([animation=none]).slide-top .smart-carousel-item.smart-active.smart-animate-trigger {
    -webkit-animation-name: carousel-active-slide-top;
    animation-name: carousel-active-slide-top
}

smart-carousel:not([animation=none]).slide-top .smart-carousel-item.smart-out.smart-animate-trigger {
    -webkit-animation-name: carousel-out-slide-top;
    animation-name: carousel-out-slide-top
}

smart-carousel:not([animation=none]).slide-bottom .smart-carousel-item.smart-active.smart-animate-trigger {
    -webkit-animation-name: carousel-active-slide-bottom;
    animation-name: carousel-active-slide-bottom
}

smart-carousel:not([animation=none]).slide-bottom .smart-carousel-item.smart-out.smart-animate-trigger {
    -webkit-animation-name: carousel-out-slide-bottom;
    animation-name: carousel-out-slide-bottom
}

smart-carousel[display-mode="3d"] .smart-carousel-html-content {
    padding-left: 30px;
    padding-right: 20px
}

smart-carousel[display-mode="3d"] .smart-carousel-item {
    border: 20px solid #fff;
    box-sizing: border-box;
    height: 400px;
    height: var(--smart-carousel-3d-mode-slide-height);
    left: 50%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%) rotateX(1deg) scale(1);
    transform: translateX(-50%) translateY(-50%) rotateX(1deg) scale(1);
    transition-duration: 0s;
    width: 400px;
    width: var(--smart-carousel-3d-mode-slide-width);
    z-index: 10
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="-3"] {
    opacity: .1;
    -webkit-transform: perspective(800px) translateX(calc(-50% - 340px)) translateY(-50%) scale(.4);
    transform: perspective(800px) translateX(calc(-50% - 340px)) translateY(-50%) scale(.4);
    z-index: 1
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="-2"] {
    opacity: .2;
    -webkit-transform: perspective(800px) translateX(calc(-50% - 300px)) translateY(-50%) scale(.5);
    transform: perspective(800px) translateX(calc(-50% - 300px)) translateY(-50%) scale(.5);
    z-index: 8
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="-1"] {
    opacity: .3;
    -webkit-transform: perspective(800px) translateX(calc(-50% - 260px)) translateY(-50%) scale(.6);
    transform: perspective(800px) translateX(calc(-50% - 260px)) translateY(-50%) scale(.6);
    z-index: 9
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="1"] {
    opacity: .3;
    -webkit-transform: perspective(800px) translateX(calc(-50% + 260px)) translateY(-50%) scale(.6);
    transform: perspective(800px) translateX(calc(-50% + 260px)) translateY(-50%) scale(.6);
    z-index: 9
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="2"] {
    opacity: .2;
    -webkit-transform: perspective(800px) translateX(calc(-50% + 300px)) translateY(-50%) scale(.5);
    transform: perspective(800px) translateX(calc(-50% + 300px)) translateY(-50%) scale(.5);
    z-index: 8
}

smart-carousel[display-mode="3d"] .smart-carousel-item[position="3"] {
    opacity: .1;
    -webkit-transform: perspective(800px) translateX(calc(-50% + 340px)) translateY(-50%) scale(.4);
    transform: perspective(800px) translateX(calc(-50% + 340px)) translateY(-50%) scale(.4);
    z-index: 1
}

smart-carousel[display-mode="3d"]:not([animation=none]) .smart-carousel-item {
    transition-duration: .7s
}

smart-carousel[display-mode="3d"]:not([animation=none]) .smart-carousel-item,
smart-carousel[display-mode="3d"]:not([animation=none]) .smart-carousel-item.smart-active,
smart-carousel[display-mode="3d"]:not([animation=none]) .smart-carousel-item.smart-out {
    -webkit-animation-name: unset;
    animation-name: unset
}

smart-carousel[display-mode="3d"].circle .smart-carousel-item {
    border-radius: 50%
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="-3"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 210px)) scale(.4);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 210px)) scale(.4)
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="-2"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 180px)) scale(.5);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 180px)) scale(.5)
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="-1"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 150px)) scale(.6);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% - 150px)) scale(.6)
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="1"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 150px)) scale(.6);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 150px)) scale(.6)
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="2"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 180px)) scale(.5);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 180px)) scale(.5)
}

smart-carousel[display-mode="3d"].vertical .smart-carousel-item[position="3"] {
    -webkit-transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 210px)) scale(.4);
    transform: perspective(800px) translateX(-50%) translateY(calc(-50% + 210px)) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="-3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 395px)) translateY(-50%) scale(.4);
    transform: perspective(800px) translateX(calc(-50% - 395px)) translateY(-50%) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="-2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 355px)) translateY(-50%) scale(.5);
    transform: perspective(800px) translateX(calc(-50% - 355px)) translateY(-50%) scale(.5)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="-1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(-50%) scale(.6);
    transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(-50%) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(-50%) scale(.6);
    transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(-50%) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 355px)) translateY(-50%) scale(.5);
    transform: perspective(800px) translateX(calc(-50% + 355px)) translateY(-50%) scale(.5)
}

smart-carousel[display-mode="3d"]:not([animation=none]).horizontal-stacked .smart-carousel-item[position="3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 395px)) translateY(-50%) scale(.4);
    transform: perspective(800px) translateX(calc(-50% + 395px)) translateY(-50%) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="-3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 450px)) translateY(calc(-50% + 150px)) scale(.2);
    transform: perspective(800px) translateX(calc(-50% - 450px)) translateY(calc(-50% + 150px)) scale(.2)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="-2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 380px)) translateY(calc(-50% + 100px)) scale(.4);
    transform: perspective(800px) translateX(calc(-50% - 380px)) translateY(calc(-50% + 100px)) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="-1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(calc(-50% + 30px)) scale(.6);
    transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(calc(-50% + 30px)) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(calc(-50% - 30px)) scale(.6);
    transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(calc(-50% - 30px)) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 380px)) translateY(calc(-50% - 100px)) scale(.4);
    transform: perspective(800px) translateX(calc(-50% + 380px)) translateY(calc(-50% - 100px)) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).bottom-top .smart-carousel-item[position="3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 450px)) translateY(calc(-50% - 150px)) scale(.2);
    transform: perspective(800px) translateX(calc(-50% + 450px)) translateY(calc(-50% - 150px)) scale(.2)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="-3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 450px)) translateY(calc(-50% - 150px)) scale(.2);
    transform: perspective(800px) translateX(calc(-50% - 450px)) translateY(calc(-50% - 150px)) scale(.2)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="-2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 380px)) translateY(calc(-50% - 100px)) scale(.4);
    transform: perspective(800px) translateX(calc(-50% - 380px)) translateY(calc(-50% - 100px)) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="-1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(calc(-50% - 30px)) scale(.6);
    transform: perspective(800px) translateX(calc(-50% - 280px)) translateY(calc(-50% - 30px)) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="1"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(calc(-50% + 30px)) scale(.6);
    transform: perspective(800px) translateX(calc(-50% + 280px)) translateY(calc(-50% + 30px)) scale(.6)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="2"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 380px)) translateY(calc(-50% + 100px)) scale(.4);
    transform: perspective(800px) translateX(calc(-50% + 380px)) translateY(calc(-50% + 100px)) scale(.4)
}

smart-carousel[display-mode="3d"]:not([animation=none]).top-bottom .smart-carousel-item[position="3"] {
    -webkit-transform: perspective(800px) translateX(calc(-50% + 450px)) translateY(calc(-50% + 150px)) scale(.2);
    transform: perspective(800px) translateX(calc(-50% + 450px)) translateY(calc(-50% + 150px)) scale(.2)
}

smart-carousel[display-mode=multiple]:not([animation=none]).smart-carousel-item.smart-active,
smart-carousel[display-mode=multiple]:not([animation=none]).smart-carousel-item.smart-animate-trigger.smart-active,
smart-carousel[display-mode=multiple]:not([animation=none]).smart-carousel-item.smart-animate-trigger.smart-out,
smart-carousel[display-mode=multiple]:not([animation=none]).smart-carousel-item.smart-out {
    -webkit-animation-name: none;
    animation-name: none
}

smart-carousel[display-mode=multiple]:not([animation=none]) .smart-items-container {
    transition-duration: 1s
}

smart-carousel[display-mode=multiple] .smart-items-container {
    overflow: hidden;
    transition: margin-left ease-in-out;
    width: -webkit-max-content;
    width: max-content
}

smart-carousel[display-mode=multiple] .smart-carousel-item {
    display: inline-block;
    float: left;
    opacity: 1;
    position: relative;
    width: 200px;
    width: var(--smart-carousel-multiple-mode-slide-width)
}

smart-carousel[display-mode=multiple] .smart-carousel-item.smart-active {
    background-color: #d3d3d3;
    transition: background-color 1s ease-in-out
}

smart-carousel[display-mode=multiple] .smart-carousel-item.smart-out {
    transition: background-color 1s ease-in-out
}

smart-carousel smart-repeat-button[hover] button {
    background-color: transparent
}

smart-carousel[adaptive-auto-height],
smart-carousel[adaptive-height] {
    height: 100%;
    margin: 0 auto 70px;
    overflow: visible;
    transition: height .6s ease-out
}

smart-carousel[adaptive-auto-height].smart-container,
smart-carousel[adaptive-auto-height]>.smart-container,
smart-carousel[adaptive-height].smart-container,
smart-carousel[adaptive-height]>.smart-container {
    position: relative
}

smart-carousel[adaptive-auto-height] .smart-container,
smart-carousel[adaptive-height] .smart-container {
    overflow: visible
}

smart-carousel[adaptive-auto-height] .smart-carousel-item,
smart-carousel[adaptive-height] .smart-carousel-item {
    height: auto
}

smart-carousel[adaptive-auto-height] .smart-slide-wrapper,
smart-carousel[adaptive-height] .smart-slide-wrapper {
    align-items: center;
    display: flex;
    height: 100%;
    padding: 0 65px;
    position: relative
}

smart-carousel[adaptive-auto-height] .smart-indicators-container,
smart-carousel[adaptive-height] .smart-indicators-container {
    align-items: center;
    bottom: 0;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    position: relative
}

smart-carousel[adaptive-auto-height] .smart-arrow,
smart-carousel[adaptive-height] .smart-arrow {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    display: flex;
    height: 50px;
    justify-content: center;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 50px
}

smart-carousel[adaptive-auto-height].smart-calculated-height .smart-carousel-item,
smart-carousel[adaptive-height].smart-calculated-height .smart-carousel-item {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center
}

smart-carousel[adaptive-auto-height].smart-calculated-height .smart-slide-wrapper,
smart-carousel[adaptive-height].smart-calculated-height .smart-slide-wrapper {
    height: auto
}

smart-carousel[right-to-left] .smart-carousel-item,
smart-carousel[right-to-left] .smart-indicators-container {
    direction: rtl
}

[disabled] .smart-carousel-item.smart-active {
    pointer-events: none
}

@-webkit-keyframes carousel-active-fade {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes carousel-active-fade {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@-webkit-keyframes carousel-out-fade {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

@keyframes carousel-out-fade {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

@-webkit-keyframes carousel-active-slide {
    0% {
        left: 100%;
        opacity: 1
    }

    to {
        left: 0;
        opacity: 1
    }
}

@keyframes carousel-active-slide {
    0% {
        left: 100%;
        opacity: 1
    }

    to {
        left: 0;
        opacity: 1
    }
}

@-webkit-keyframes carousel-out-slide {
    0% {
        left: 0;
        opacity: 1
    }

    to {
        left: -100%;
        opacity: 1
    }
}

@keyframes carousel-out-slide {
    0% {
        left: 0;
        opacity: 1
    }

    to {
        left: -100%;
        opacity: 1
    }
}

@-webkit-keyframes carousel-active-slide-right {
    0% {
        left: -100%;
        opacity: 1
    }

    to {
        left: 0;
        opacity: 1
    }
}

@keyframes carousel-active-slide-right {
    0% {
        left: -100%;
        opacity: 1
    }

    to {
        left: 0;
        opacity: 1
    }
}

@-webkit-keyframes carousel-out-slide-right {
    0% {
        left: 0;
        opacity: 1
    }

    to {
        left: 100%;
        opacity: 1
    }
}

@keyframes carousel-out-slide-right {
    0% {
        left: 0;
        opacity: 1
    }

    to {
        left: 100%;
        opacity: 1
    }
}

@-webkit-keyframes carousel-active-slide-top {
    0% {
        opacity: 1;
        top: 100%
    }

    to {
        opacity: 1;
        top: 0
    }
}

@keyframes carousel-active-slide-top {
    0% {
        opacity: 1;
        top: 100%
    }

    to {
        opacity: 1;
        top: 0
    }
}

@-webkit-keyframes carousel-out-slide-top {
    0% {
        opacity: 1;
        top: 0
    }

    to {
        opacity: 1;
        top: -100%
    }
}

@keyframes carousel-out-slide-top {
    0% {
        opacity: 1;
        top: 0
    }

    to {
        opacity: 1;
        top: -100%
    }
}

@-webkit-keyframes carousel-active-slide-bottom {
    0% {
        opacity: 1;
        top: -100%
    }

    to {
        opacity: 1;
        top: 0
    }
}

@keyframes carousel-active-slide-bottom {
    0% {
        opacity: 1;
        top: -100%
    }

    to {
        opacity: 1;
        top: 0
    }
}

@-webkit-keyframes carousel-out-slide-bottom {
    0% {
        opacity: 1;
        top: 0
    }

    to {
        opacity: 1;
        top: 100%
    }
}

@keyframes carousel-out-slide-bottom {
    0% {
        opacity: 1;
        top: 0
    }

    to {
        opacity: 1;
        top: 100%
    }
}

.smart-chart-tooltip .smart-chart-tooltip-text,
smart-chart .smart-chart-annotation-text,
smart-chart .smart-chart-axis-description,
smart-chart .smart-chart-axis-text,
smart-chart .smart-chart-label-text,
smart-chart .smart-chart-legend-text,
smart-chart .smart-chart-title-description,
smart-chart .smart-chart-title-text {
    fill: #5a5a5a;
    fill: var(--smart-background-color);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family)
}

.smart-chart-tooltip[right-to-left] .smart-chart-tooltip-text,
smart-chart[right-to-left] .smart-chart-annotation-text,
smart-chart[right-to-left] .smart-chart-axis-description,
smart-chart[right-to-left] .smart-chart-axis-text,
smart-chart[right-to-left] .smart-chart-label-text,
smart-chart[right-to-left] .smart-chart-legend-text,
smart-chart[right-to-left] .smart-chart-title-text {
    text-anchor: end;
    direction: rtl
}

smart-chart {
    display: block;
    height: 500px;
    height: var(--smart-chart-default-height);
    width: 850px;
    width: var(--smart-chart-default-width)
}

smart-chart .smart-chart-annotation-text,
smart-chart .smart-chart-axis-description,
smart-chart .smart-chart-axis-text,
smart-chart .smart-chart-label-text,
smart-chart .smart-chart-legend-text {
    box-sizing: content-box;
    font-size: 13px;
    font-size: calc(var(--smart-font-size) - 1px)
}

smart-chart .smart-chart-title-text {
    font-size: 16px;
    font-size: calc(var(--smart-font-size) + 2px);
    font-weight: 700
}

smart-chart .smart-chart-title-description {
    font-size: 14px;
    font-size: var(--smart-font-size)
}

smart-chart[theme=dark] .smart-chart-annotation-text,
smart-chart[theme=dark] .smart-chart-axis-description .smart-chart-label-text,
smart-chart[theme=dark] .smart-chart-axis-text,
smart-chart[theme=dark] .smart-chart-legend-text,
smart-chart[theme=dark] .smart-chart-title-description,
smart-chart[theme=dark] .smart-chart-title-text {
    fill: #5a5a5a;
    fill: var(--smart-background-color);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-chart-range-selector>smart-chart {
    height: 100%;
    touch-action: none;
    width: 100%
}

.smart-chart-range-selector .slider {
    box-sizing: content-box;
    pointer-events: none
}

.smart-chart-tooltip {
    cursor: default;
    opacity: 1;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: .3s ease-in, -webkit-transform .3s ease-in;
    transition: .3s ease-in, transform .3s ease-in;
    transition: .3s ease-in, transform .3s ease-in, -webkit-transform .3s ease-in;
    z-index: 10000000
}

.smart-chart-tooltip .smart-chart-tooltip-content {
    border: 1px solid transparent;
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-sizing: content-box;
    cursor: default;
    left: 0;
    margin: 0;
    outline: 0;
    padding: 3px;
    position: absolute;
    text-align: center;
    top: 0;
    vertical-align: middle
}

.smart-chart-tooltip .smart-chart-tooltip-text {
    box-sizing: content-box;
    font-size: 13px;
    font-size: calc(var(--smart-font-size) - 1px)
}

.smart-chart-tooltip .smart-chart-tooltip-arrow-outer {
    box-sizing: content-box;
    height: 0;
    position: absolute;
    width: 0;
    z-index: 10000001
}

.smart-chart-tooltip .smart-chart-tooltip-arrow-inner {
    box-sizing: content-box;
    height: 0;
    position: absolute;
    width: 0;
    z-index: 10000002
}

.smart-chart-tooltip[animation=none] {
    transition: none
}

.smart-chart-tooltip.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

[theme=dark] .smart-chart-tooltip:not([theme=dark]) .smart-chart-tooltip-text {
    fill: #fefefe;
    fill: var(--smart-background);
    color: #fefefe;
    color: var(--smart-background)
}

.smart-chip .smart-avatar,
.smart-chip .smart-value {
    display: none;
    text-overflow: ellipsis;
    vertical-align: middle
}

.smart-chip .smart-avatar,
.smart-chip .smart-close-button {
    height: 30px;
    height: var(--smart-chip-default-height);
    vertical-align: middle;
    width: 30px;
    width: var(--smart-chip-default-height)
}

.smart-chip .smart-value,
.smart-chip.smart-container,
smart-chip .smart-container {
    white-space: nowrap
}

smart-chip:focus,
smart-chip:hover {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    outline: 0
}

smart-chip.smart-element {
    display: inline-block
}

smart-chip[disabled]:hover {
    box-shadow: none
}

.smart-chip {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 15px;
    border-radius: calc(var(--smart-chip-default-height)/2);
    box-sizing: border-box;
    color: #fff;
    color: var(--smart-primary-color);
    margin: 2px;
    min-height: 30px;
    min-height: var(--smart-chip-default-height);
    min-width: 30px;
    min-width: var(--smart-chip-default-height);
    position: relative
}

.smart-chip .smart-avatar {
    border-radius: 50%;
    box-sizing: border-box;
    font-size: 20px;
    text-align: center
}

.smart-chip .smart-avatar,
.smart-chip .smart-value {
    line-height: 30px;
    line-height: var(--smart-chip-default-height);
    overflow: hidden
}

.smart-chip .smart-value {
    cursor: default;
    margin: 0;
    padding: 0 15px
}

.smart-chip .smart-close-button {
    display: none;
    position: relative
}

.smart-chip .smart-close-button:after,
.smart-chip[avatar] .smart-avatar,
.smart-chip[close-button] .smart-close-button,
.smart-chip[value] .smart-value {
    display: inline-block
}

.smart-chip .smart-close-button:after {
    color: inherit;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    line-height: 30px;
    line-height: var(--smart-chip-default-height);
    text-align: center;
    width: 100%
}

.smart-chip .smart-close-button:hover:after {
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer
}

.smart-chip[avatar] .smart-avatar img {
    border-radius: 50%;
    height: 100%;
    width: 100%
}

.smart-chip[avatar] .smart-value {
    padding-left: 5px
}

.smart-chip[avatar] .smart-value,
.smart-chip[close-button] .smart-value {
    width: calc(100% - 30px);
    width: calc(100% - var(--smart-chip-default-height))
}

.smart-chip[close-button] .smart-value {
    padding-right: 5px
}

.smart-chip[avatar][close-button] .smart-value {
    width: calc(100% - 60px);
    width: calc(100% - var(--smart-chip-default-height)*2)
}

.smart-chip[right-to-left]>.smart-container {
    direction: rtl
}

smart-combo-box {
    cursor: pointer;
    height: 30px;
    height: var(--smart-combo-box-default-height);
    overflow: visible;
    overflow: initial;
    visibility: hidden;
    width: 250px;
    width: var(--smart-combo-box-default-width)
}

smart-combo-box.smart-element {
    border-width: 0;
    overflow: visible;
    visibility: inherit
}

.smart-combo-box smart-list-box {
    border: initial;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    outline: 0;
    overflow: hidden;
    padding: initial;
    position: relative;
    width: 100%
}

.smart-combo-box .smart-action-button input.smart-input {
    align-self: center;
    flex-grow: 1;
    margin: 0;
    max-height: 1rem;
    min-height: 100%;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    vertical-align: middle;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-combo-box .smart-buttons-container .smart-token {
    cursor: pointer;
    margin: 0 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-combo-box .smart-buttons-container .smart-combo-box-auto-complete-string {
    align-items: center;
    display: flex;
    opacity: .5;
    overflow: hidden;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 1
}

.smart-combo-box .smart-buttons-container .smart-combo-box-auto-complete-string:empty {
    display: none
}

.smart-combo-box.smart-element .smart-drop-down.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top 0;
    transform-origin: left top 0;
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

smart-color-panel {
    height: auto;
    height: var(--smart-color-panel-default-height);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: auto;
    width: var(--smart-color-panel-default-width)
}

smart-color-panel .no-touch {
    touch-action: none
}

smart-color-panel.smart-element {
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: inline-block;
    overflow: visible;
    overflow: initial
}

smart-color-panel[disabled] {
    opacity: .55;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-color-panel .smart-content {
    cursor: pointer;
    display: flex;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-color-panel label {
    display: inline-block;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-color-panel smart-tooltip .smart-tooltip-content {
    box-shadow: 0 0 20px 0 #8b8b8b
}

.smart-color-panel input[type=number]::-webkit-inner-spin-button,
.smart-color-panel input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0
}

.smart-color-panel input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: textfied
}

.smart-color-panel .color-input {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    color: var(--smart-color);
    height: 30px;
    height: var(--smart-editor-height);
    margin: 5px;
    outline: 0;
    padding: 5px;
    width: 70px
}

.smart-color-panel .color-input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-color-panel .color-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

.smart-color-panel .grid-mode-container,
.smart-color-panel .palette-mode-container {
    max-height: 100%;
    position: relative;
    width: 100%
}

.smart-color-panel .custom-color-selection .buttons-container {
    align-items: center;
    display: flex;
    justify-content: flex-end
}

.smart-color-panel .custom-colors-box,
.smart-color-panel .gray-shades-box,
.smart-color-panel .grid-samples-container,
.smart-color-panel .spectrum-box {
    display: grid;
    grid-template-columns: repeat(8, auto);
    grid-template-columns: repeat(var(--smart-color-panel-grid-mode-column-count), auto)
}

.smart-color-panel .hue-scale {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    background-image: linear-gradient(red, #f0f, #00f, #0ff, #0f0, #ff0, red);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    display: block;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    margin-left: 15px;
    margin-right: 15px;
    max-width: 100px;
    padding: 1px;
    position: relative;
    width: 20px
}

.smart-color-panel .hue-scale-thumb {
    border-color: #fff;
    border-style: solid;
    border-width: 3px 10px;
    box-shadow: 0 0 5px #666, inset 0 0 2px 0 #999, inset 0 0 2px 0 #999;
    box-sizing: content-box;
    cursor: pointer;
    height: 10px;
    left: -10px;
    opacity: .8;
    position: absolute;
    top: -3px;
    width: 100%
}

.smart-color-panel .color-palette-thumb {
    height: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 0;
    z-index: 10
}

.smart-color-panel .color-palette-thumb:after {
    border: 5px solid #fff;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    content: " ";
    height: 16px;
    left: -14px;
    position: absolute;
    top: -14px;
    width: 16px
}

.smart-color-panel .color-palette {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    background-color: red;
    border: 1px solid #d3d3d3;
    cursor: crosshair;
    display: block;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    overflow: hidden;
    padding: 1px;
    position: relative;
    width: 300px;
    width: var(--smart-color-panel-palette-size)
}

.smart-color-panel .color-palette:after,
.smart-color-panel .color-palette:before {
    content: " ";
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0
}

.smart-color-panel .color-palette:before {
    background-image: linear-gradient(90deg, #fff, transparent)
}

.smart-color-panel .color-palette:after {
    background-image: linear-gradient(transparent, #000)
}

.smart-color-panel .color-controls-container {
    display: block;
    max-width: 100px;
    overflow: hidden
}

.smart-color-panel .color-palette-container {
    display: flex;
    flex-direction: row;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    width: 100%
}

.smart-color-panel .preview-container {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: 100px;
    margin-bottom: 20px;
    min-width: 100px;
    padding: 1px;
    position: relative;
    width: 100%
}

.smart-color-panel .preview-container-bottom,
.smart-color-panel .preview-container-top {
    background-color: #fff;
    display: block;
    height: 50%;
    width: 100%
}

.smart-color-panel .alpha-channel-container {
    align-content: space-around;
    align-items: center;
    display: none;
    flex-direction: row;
    margin-top: 5px;
    width: 100%
}

.smart-color-panel .alpha-channel-container label {
    width: 48px
}

.smart-color-panel .alpha-channel-scale {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: 20px;
    margin-bottom: 15px;
    margin-right: 20px;
    margin-top: 15px;
    position: relative;
    width: 300px;
    width: var(--smart-color-panel-palette-size)
}

.smart-color-panel .alpha-channel-scale:after,
.smart-color-panel .alpha-channel-scale:before {
    content: " ";
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-color-panel .alpha-channel-scale:before {
    background-image: linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc);
    background-position: 0 6px, 8px 14px;
    background-size: 16px 16px
}

.smart-color-panel .alpha-channel-scale:after {
    background-image: linear-gradient(90deg, #fff, transparent);
    background-image: linear-gradient(90deg, var(--smart-color-panel-alpha-channel-color), transparent);
    box-shadow: inset 1px -1px 0 0 #fff, inset -1px 1px 0 0 #fff
}

.smart-color-panel .alpha-channel-thumb {
    border-color: #fff;
    border-style: solid;
    border-width: 10px 3px;
    box-shadow: 0 0 5px #666, inset 0 0 2px 0 #999, inset 0 0 2px 0 #999;
    box-sizing: content-box;
    cursor: pointer;
    height: 100%;
    left: -3px;
    opacity: .8;
    position: absolute;
    top: -10px;
    width: 10px;
    z-index: 1
}

.smart-color-panel .buttons-container {
    display: none;
    flex-direction: row;
    justify-content: flex-end;
    padding: 10px 0 0
}

.smart-color-panel .buttons-container smart-button {
    width: 100px
}

.smart-color-panel .color-sample,
.smart-color-panel .user-color-container {
    height: 20px;
    height: var(--smart-color-panel-grid-mode-item-size);
    width: 20px;
    width: var(--smart-color-panel-grid-mode-item-size)
}

.smart-color-panel .buttons-container smart-button:last-of-type {
    margin-left: 20px
}

.smart-color-panel .gradient-background {
    background-position: 0 6px, 8px 14px;
    background-size: 16px 16px
}

.smart-color-panel .color-sample.user-color:before,
.smart-color-panel .gradient-background,
.smart-color-panel .user-color-container {
    background-image: linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc)
}

.smart-color-panel .color-sample.user-color:before,
.smart-color-panel .user-color-container {
    background-position: 0 5px, 5px 10px;
    background-size: 10px 10px
}

.smart-color-panel .material-grid-samples-container {
    display: grid;
    grid-template-columns: 80px repeat(14, auto)
}

.smart-color-panel .button-custom-color {
    margin: 5px 0
}

.smart-color-panel .color-sample {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    border: 1px solid rgba(0, 0, 0, .1);
    border: var(--smart-border-width) solid rgba(0, 0, 0, .1);
    box-sizing: border-box;
    cursor: pointer;
    margin: 1px;
    margin: var(--smart-color-panel-grid-mode-columns-gap);
    text-overflow: ellipsis
}

.smart-color-panel .color-sample.user-color {
    background-clip: padding-box;
    -webkit-background-clip: padding-box;
    position: relative
}

.smart-color-panel .color-sample.user-color:before {
    content: "";
    height: 100%;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%;
    z-index: -1
}

.smart-color-panel .color-sample.selected {
    border: 2px solid #005c99;
    border: 2px solid var(--smart-ui-state-color-selected);
    padding: 1px
}

.smart-color-panel .color-sample.empty {
    visibility: hidden
}

.smart-color-panel .color-sample.header,
.smart-color-panel .color-sample.label-column {
    align-items: center;
    border-width: 0;
    display: flex;
    font-size: 11px;
    justify-content: center;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-color-panel .color-sample.label-column {
    justify-content: flex-start;
    width: 100%
}

.smart-color-panel .color-sample.color-sample-column,
.smart-color-panel .color-sample.color-sample-row {
    background: repeating-linear-gradient(-55deg, #fff, #fff 10px, #eee 0, #eee 20px);
    border: 2px solid rgba(0, 0, 0, .2);
    height: 16px;
    padding: 1px;
    width: 16px
}

.smart-color-panel .color-sample[transparent] {
    position: relative
}

.smart-color-panel .color-sample[transparent]:after {
    border: 1px solid red;
    border-radius: 5px;
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%) rotate(-45deg);
    transform: translate(-50%, -50%) rotate(-45deg);
    width: 150%
}

.smart-color-panel .user-color.empty {
    background: repeating-linear-gradient(-55deg, #fff, #fff 10px, #eee 0, #eee 20px);
    background-origin: content-box;
    border-color: #d3d3d3
}

.smart-color-panel .default-samples-container div {
    display: grid;
    grid-template-columns: repeat(10, auto);
    justify-items: center
}

.smart-color-panel .default-samples-container .theme-shades-box {
    margin-bottom: 8px;
    margin-bottom: var(--smart-color-panel-default-mode-sections-gap);
    margin-top: 8px;
    margin-top: var(--smart-color-panel-default-mode-sections-gap)
}

.smart-color-panel .default-samples-container .standard-colors-label,
.smart-color-panel .default-samples-container .theme-colors-label {
    display: block;
    font-weight: 600;
    margin-bottom: 4px;
    margin-bottom: calc(var(--smart-color-panel-default-mode-sections-gap)/2);
    margin-left: 2px;
    margin-top: 8px;
    margin-top: var(--smart-color-panel-default-mode-sections-gap)
}

.smart-color-panel .hex-mode-resize-trigger {
    left: 0;
    position: absolute;
    top: 0;
    visibility: hidden
}

.smart-color-panel[edit-alpha-channel] .alpha-channel-container {
    display: flex
}

.smart-color-panel[enable-custom-colors] .button-custom-color,
.smart-color-panel[enable-custom-colors] .user-samples-container {
    align-items: center;
    display: flex;
    width: 100%
}

.smart-color-panel[enable-custom-colors]:not([display-mode=palette]):not([display-mdoe=radial]) .custom-color-selection .palette-mode-container {
    display: block
}

.smart-color-panel:not([display-mode=radial]) .canvas-radial {
    display: none
}

.smart-color-panel[display-mode=hexagonal] .brightness-scale,
.smart-color-panel[display-mode=radial] .brightness-scale {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    background-image: linear-gradient(red, #f0f, #00f, #0ff, #0f0, #ff0, red);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    display: block;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    margin-left: 15px;
    margin-right: 15px;
    max-width: 100px;
    padding: 1px;
    position: relative;
    width: 20px
}

.smart-color-panel[display-mode=hexagonal] .brightness-scale-thumb,
.smart-color-panel[display-mode=radial] .brightness-scale-thumb {
    border-color: #fff;
    border-style: solid;
    border-width: 3px 10px;
    box-shadow: 0 0 5px #666, inset 0 0 2px 0 #999, inset 0 0 2px 0 #999;
    box-sizing: content-box;
    cursor: pointer;
    height: 10px;
    left: -10px;
    opacity: .8;
    position: absolute;
    top: -3px;
    width: 100%
}

.smart-color-panel[display-mode=hexagonal] .alpha-channel-scale {
    width: 300px;
    width: var(--smart-color-panel-palette-width)
}

.smart-color-panel[display-mode=hexagonal] .brightness-scale {
    background-image: linear-gradient(#fff, #000);
    display: block;
    height: 300px;
    height: var(--smart-color-panel-palette-height)
}

.smart-color-panel[display-mode=hexagonal] .selected {
    stroke: #fff;
    stroke-width: 4px
}

.smart-color-panel[display-mode=hexagonal] .color-palette-container {
    height: 300px;
    height: var(--smart-color-panel-palette-height)
}

.smart-color-panel[display-mode=hexagonal] .color-palette-hexagonal,
.smart-color-panel[display-mode=hexagonal] .palette-mode-container {
    display: block
}

.smart-color-panel[display-mode=radial] .hue-scale {
    display: none
}

.smart-color-panel[display-mode=radial] .brightness-scale {
    background-image: linear-gradient(#fff, #000)
}

.smart-color-panel[display-mode=radial] .color-palette-radial {
    background-clip: content-box;
    -webkit-background-clip: content-box;
    background: conic-gradient(from 90deg, red, #ff0, #0f0, #0ff, #00f, #f0f, red) #ff005a;
    border: 1px solid #d3d3d3;
    border-radius: 50%;
    cursor: crosshair;
    display: block;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    overflow: hidden;
    padding: 1px;
    position: relative;
    width: 300px;
    width: var(--smart-color-panel-palette-size)
}

.smart-color-panel[display-mode=radial] .color-palette-radial:after {
    background: #000;
    border-radius: 50%;
    content: " ";
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    opacity: var(--smart-color-panel-brightness);
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0
}

.smart-color-panel[display-mode=radial] .color-palette-radial-thumb {
    height: 0;
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    width: 0;
    z-index: 10
}

.smart-color-panel[display-mode=radial] .color-palette-radial-thumb:after {
    border: 5px solid #fff;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    content: " ";
    height: 16px;
    left: -14px;
    position: absolute;
    top: -14px;
    width: 16px
}

.smart-color-panel[display-mode=radial] .white-radial-gradient {
    background-image: radial-gradient(circle, #fff, transparent);
    border-radius: 50%;
    height: 300px;
    height: var(--smart-color-panel-palette-size);
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 300px;
    width: var(--smart-color-panel-palette-size);
    z-index: 2
}

.smart-color-panel[display-mode=radial] .palette-mode-container {
    display: block
}

.smart-color-panel[display-mode=radial] canvas {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-color-panel[display-mode=radial][inverted] .color-palette-radial:after {
    background: #fff
}

.smart-color-panel[display-mode=radial][inverted] .white-radial-gradient {
    background: radial-gradient(#000, transparent)
}

.smart-color-panel[display-mode=default] .default-samples-container,
.smart-color-panel[display-mode=materialGrid] .color-palette,
.smart-color-panel[display-mode=palette] .color-palette,
.smart-color-panel[display-mode=palette] .palette-mode-container,
.smart-color-panel[display-mode=spectrumGrid] .spectrum-grid-samples-container {
    display: block
}

.smart-color-panel[apply-value-mode=useButtons] .buttons-container {
    align-items: center;
    display: flex;
    justify-content: flex-end
}

.smart-color-panel[right-to-left] .alpha-channel-container,
.smart-color-panel[right-to-left] .color-palette-container,
.smart-color-panel[right-to-left] .grid-mode-container {
    direction: rtl
}

.smart-color-panel[right-to-left] .alpha-channel-scale {
    margin: 0 0 0 20px
}

.smart-color-panel[right-to-left] .alpha-channel-scale:after {
    background-image: linear-gradient(90deg, transparent, #fff);
    background-image: linear-gradient(90deg, transparent, var(--smart-color-panel-alpha-channel-color))
}

.smart-color-panel[right-to-left] .buttons-container {
    flex-direction: row-reverse
}

.smart-color-panel[right-to-left] .buttons-container smart-button:last-of-type {
    margin: 0 0 0 20px
}

.smart-color-panel .button-custom-color,
.smart-color-panel .color-palette-hexagonal,
.smart-color-panel .custom-color-selection .grid-mode-container,
.smart-color-panel .palette-mode-container,
.smart-color-panel .spectrum-grid-samples-container,
.smart-color-panel .user-samples-container,
.smart-color-panel[display-mode=default] .grid-samples-container,
.smart-color-panel[display-mode=default] .material-grid-samples-container,
.smart-color-panel[display-mode=default] .palette-mode-container,
.smart-color-panel[display-mode=grid] .default-samples-container,
.smart-color-panel[display-mode=grid] .material-grid-samples-container,
.smart-color-panel[display-mode=grid] .palette-mode-container,
.smart-color-panel[display-mode=hexagonal] .color-palette,
.smart-color-panel[display-mode=hexagonal] .default-samples-container,
.smart-color-panel[display-mode=hexagonal] .grid-samples-container,
.smart-color-panel[display-mode=hexagonal] .hue-scale,
.smart-color-panel[display-mode=hexagonal] .spectrum-grid-samples-container,
.smart-color-panel[display-mode=materialGrid] .default-samples-container,
.smart-color-panel[display-mode=materialGrid] .grid-samples-container,
.smart-color-panel[display-mode=materialGrid] .palette-mode-container,
.smart-color-panel[display-mode=palette] .color-palette-radial,
.smart-color-panel[display-mode=palette] .grid-mode-container,
.smart-color-panel[display-mode=radial] .color-palette,
.smart-color-panel[display-mode=radial] .grid-mode-container,
.smart-color-panel[display-mode=spectrumGrid] .default-samples-container,
.smart-color-panel[display-mode=spectrumGrid] .grid-samples-container,
.smart-color-panel[display-mode=spectrumGrid] .material-grid-samples-container,
.smart-color-panel[display-mode=spectrumGrid] .palette-mode-container,
.smart-color-panel[enable-custom-colors][display-mode=hexagonal] .button-custom-color,
.smart-color-panel[enable-custom-colors][display-mode=hexagonal] .user-samples-container,
.smart-color-panel[hide-alpha-editor] .a-channel,
.smart-color-panel[hide-h-e-x-editor] .hex,
.smart-color-panel[hide-preview-container] .preview-container,
.smart-color-panel[hide-r-g-b-editor] .b-channel,
.smart-color-panel[hide-r-g-b-editor] .g-channel,
.smart-color-panel[hide-r-g-b-editor] .r-channel {
    display: none
}

smart-color-picker {
    height: 30px;
    height: var(--smart-color-picker-default-height);
    width: 250px;
    width: var(--smart-color-picker-default-width)
}

smart-color-picker.smart-element {
    border: none;
    overflow: visible;
    overflow: initial
}

.smart-color-picker smart-color-panel {
    border: none;
    display: flex;
    height: 100%;
    padding: 5px;
    position: relative;
    width: 100%
}

.smart-color-picker .smart-color-box {
    background-color: #fefefe;
    background-color: var(--smart-background);
    background-image: linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 0, transparent 74%, #ccc 75%, #ccc);
    background-position: 0 5px, 5px 10px;
    background-size: 10px 10px;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: 20px;
    margin-right: 5px;
    overflow: hidden;
    position: relative;
    width: 20px
}

.smart-color-picker .smart-color-box.no-color {
    background-image: linear-gradient(45deg, transparent 47.5%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 52.5%, transparent 0), linear-gradient(-45deg, transparent 47.5%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 52.5%, transparent 0);
    background-position: 0 0;
    background-size: auto auto;
    background-size: initial
}

.smart-color-picker .smart-color-box>div {
    height: 100%;
    width: 100%
}

.smart-color-picker .smart-color-input {
    background-color: transparent;
    border: 0;
    color: inherit;
    outline: 0
}

.smart-color-picker .smart-ripple {
    background: #fff;
    background: var(--smart-primary-color)
}

.smart-color-picker .smart-drop-down.smart-drop-down-color-picker.smart-drop-down-container {
    box-sizing: content-box;
    height: auto;
    height: var(--smart-color-picker-drop-down-height);
    max-height: none;
    max-width: none;
    overflow: hidden;
    width: auto;
    width: var(--smart-color-picker-drop-down-width)
}

.smart-color-picker:not([opened]) .smart-color-input {
    color: inherit
}

.smart-color-picker:not([editable]) .smart-color-input {
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-color-picker[value-display-mode=none] .smart-color-box,
.smart-color-picker[value-display-mode=none] .smart-color-input {
    display: none
}

.smart-color-picker[value-display-mode=none] .smart-color-input.smart-input {
    opacity: 0;
    padding: initial;
    width: 0
}

.smart-color-picker[value-display-mode=none] .smart-action-button {
    border: none;
    padding: initial
}

.smart-color-picker[value-display-mode=none] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-left-style: solid;
    border-left-width: 1px;
    border-left-width: var(--smart-border-width);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-color-picker[value-display-mode=none]:not([opened]):not([drop-down-open-mode=dropDownButton]) .smart-drop-down-button {
    border-left-color: #e0e0e0;
    border-left-color: var(--smart-border)
}

.smart-color-picker[value-display-mode=colorCode] .smart-color-box {
    display: none
}

.smart-color-picker[value-display-mode=colorBox] .smart-color-box,
.smart-color-picker[value-display-mode=colorCode] .smart-color-input {
    display: block
}

.smart-color-picker[value-display-mode=colorBox] .smart-input {
    display: none
}

.smart-color-picker[editable] .smart-action-button {
    cursor: auto
}

.smart-color-picker[editable]:not([opened]):not([drop-down-open-mode=dropDownButton])[hover] .smart-action-button {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-color-picker[opened][editable] .smart-action-button {
    background-color: var(--smart-backgroud);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-color-panel .color-sample.no-color {
    background-image: linear-gradient(45deg, transparent 47.5%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 52.5%, transparent 0), linear-gradient(-45deg, transparent 47.5%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 52.5%, transparent 0);
    background-position: 0 0;
    background-size: auto auto;
    background-size: initial
}

.smart-drop-down-repositioned smart-color-panel {
    border: none;
    height: 100%;
    padding: 5px;
    width: 100%
}

.smart-drop-down.smart-drop-down-color-picker.smart-drop-down-container,
.smart-drop-down.smart-drop-down-color-picker.smart-drop-down-container.smart-drop-down-repositioned {
    box-sizing: content-box;
    height: auto;
    height: var(--smart-color-picker-drop-down-height);
    max-height: none;
    max-width: none;
    overflow: hidden;
    width: auto;
    width: var(--smart-color-picker-drop-down-width)
}

smart-date-time-picker {
    height: 30px;
    height: var(--smart-date-time-picker-default-height);
    min-height: 30px;
    min-height: var(--smart-editor-height);
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    width: 250px;
    width: var(--smart-date-time-picker-default-width)
}

smart-date-time-picker.smart-element {
    overflow: visible
}

smart-date-time-picker[hover] {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-date-time-picker.smart-container,
smart-date-time-picker>.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-date-time-picker.smart-container>.smart-content,
smart-date-time-picker>.smart-container>.smart-content {
    display: flex;
    height: 100%;
    width: 100%
}

.smart-date-time-picker.smart-container>input,
smart-date-time-picker>.smart-container>input {
    height: 100%
}

.smart-date-time-picker .smart-input.smart-date-time-input {
    background: inherit;
    border: none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    outline: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    text-align: inherit;
    width: 100%
}

.smart-date-time-picker>.smart-container>.smart-hint,
.smart-date-time-picker>.smart-container>.smart-label {
    display: none;
    position: absolute
}

.smart-date-time-picker .smart-spin-buttons-container {
    border-radius: 0;
    display: none;
    height: 100%;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-date-time-picker .smart-spin-button {
    --smart-button-padding: 0;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: solid;
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-width: 0 0 0 1px;
    border-left-width: var(--smart-border-width);
    border-radius: 0;
    color: #323232;
    color: var(--smart-surface-color);
    display: block;
    font-weight: 500;
    height: 50%;
    min-height: 0;
    width: 100%
}

.smart-date-time-picker .smart-spin-button:first-child {
    border-bottom-width: 1px
}

.smart-date-time-picker .smart-spin-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-date-time-picker .smart-spin-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 0 solid #e0e0e0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: var(--smart-border);
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: none;
    height: 100%;
    overflow: hidden;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    content: "\\e829";
    content: var(--smart-icon-calendar);
    display: flex;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    text-decoration: inherit;
    text-transform: none;
    width: 100%
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button.time:after {
    content: "\\e837";
    content: var(--smart-icon-clock)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button.smart-drop-down-button-pressed {
    color: var(--smart-ui-state-color)
}

.smart-date-time-picker .smart-drop-down-button.smart-calendar-button.smart-drop-down-button-pressed[hover]:after {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-date-time-picker .smart-drop-down.smart-date-time-drop-down {
    padding: 0 !important
}

.smart-date-time-picker .smart-ripple {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-date-time-picker[focus],
.smart-date-time-picker[focus] .smart-drop-down-button.smart-calendar-button {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-date-time-picker[disabled] .smart-input.smart-date-time-input {
    background-color: transparent;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-date-time-picker[disabled] .smart-drop-down-button.smart-calendar-button,
.smart-date-time-picker[readonly] .smart-drop-down-button.smart-calendar-button {
    cursor: default
}

.smart-date-time-picker[label]>.smart-container>.smart-label {
    bottom: 100%;
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    width: 100%
}

.smart-date-time-picker[calendar-button] .smart-input.smart-date-time-input,
.smart-date-time-picker[spin-buttons] .smart-input.smart-date-time-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-date-time-picker[spin-buttons-position=left] .smart-spin-button {
    border-left-width: 0;
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-date-time-picker[spin-buttons-position=left] .smart-spin-button:first-child {
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-date-time-picker[spin-buttons-position=left] .smart-spin-button:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius)
}

.smart-date-time-picker[spin-buttons] {
    min-width: 27px;
    min-width: calc(var(--smart-editor-addon-width))
}

.smart-date-time-picker[spin-buttons] .smart-spin-buttons-container {
    display: block
}

.smart-date-time-picker[spin-buttons]:not([spin-buttons-position=left]) .smart-input.smart-date-time-input {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-date-time-picker[calendar-button] {
    min-width: 27px;
    min-width: var(--smart-editor-addon-width)
}

.smart-date-time-picker[calendar-button] .smart-drop-down-button.smart-calendar-button {
    display: block;
    position: relative
}

.smart-date-time-picker[spin-buttons][calendar-button] {
    min-width: 54px;
    min-width: calc(var(--smart-editor-addon-width) + var(--smart-editor-addon-width))
}

.smart-date-time-picker[spin-buttons][calendar-button] .smart-input.smart-date-time-input {
    width: calc(100% - 54px);
    width: calc(100% - var(--smart-editor-addon-width) - var(--smart-editor-addon-width))
}

.smart-date-time-picker[spin-buttons][calendar-button][calendar-button-position=left][spin-buttons-position=left] .smart-spin-button:first-child {
    border-top-left-radius: 0
}

.smart-date-time-picker[spin-buttons][calendar-button][calendar-button-position=left][spin-buttons-position=left] .smart-spin-button:last-child {
    border-bottom-left-radius: 0
}

.smart-date-time-picker:not([spin-buttons]) .smart-input.smart-date-time-input,
.smart-date-time-picker[calendar-button-position=left] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-date-time-picker[calendar-button-position=left] .smart-drop-down-button {
    border-bottom-right-radius: 0;
    border-left: none;
    border-right-width: 1px;
    border-right-width: var(--smart-border-width);
    border-top-right-radius: 0
}

.smart-date-time-picker[calendar-button-position=left][spin-buttons]:not([spin-buttons-position=left]) .smart-spin-button:first-child {
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-date-time-picker[calendar-button-position=left][spin-buttons]:not([spin-buttons-position=left]) .smart-spin-button:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius)
}

.smart-date-time-picker:not([calendar-button])[spin-buttons-position=left] .smart-input.smart-date-time-input,
.smart-date-time-picker[calendar-button-position=left][spin-buttons-position=left] .smart-input.smart-date-time-input {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-date-time-picker:not([calendar-button])[spin-buttons]:not([spin-buttons-position=left]) .smart-spin-button:first-child {
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-date-time-picker:not([calendar-button])[spin-buttons]:not([spin-buttons-position=left]) .smart-spin-button:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius)
}

.smart-date-time-picker:not([spin-buttons]):not([calendar-button]) .smart-input.smart-date-time-input,
.smart-date-time-picker:not([spin-buttons])[calendar-button-position=left] .smart-input.smart-date-time-input {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-date-time-picker.underlined {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0 0 1px
}

.smart-date-time-picker.underlined .smart-drop-down-button,
.smart-date-time-picker.underlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0
}

.smart-date-time-picker.underlined .smart-drop-down-button.smart-calendar-button[active],
.smart-date-time-picker.underlined .smart-drop-down-button.smart-calendar-button[hover],
.smart-date-time-picker.underlined .smart-spin-button[active],
.smart-date-time-picker.underlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-date-time-picker.underlined .smart-hint {
    bottom: 0;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block !important;
    font-size: 75%;
    left: 0;
    margin-top: -14px;
    margin-top: calc(0px - var(--smart-font-size));
    opacity: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: color .2s, font-size .2s, line-height .2s, margin-top .2s, opacity .1s, top .2s
}

.smart-date-time-picker.underlined .smart-hint:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    bottom: -2px;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: bottom center;
    transform-origin: bottom center;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s;
    width: 100%
}

.smart-date-time-picker.underlined:not([focus]) .smart-hint {
    margin-top: 0
}

.smart-date-time-picker.underlined[focus] .smart-drop-down-button.smart-calendar-button,
.smart-date-time-picker.underlined[focus] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-date-time-picker.underlined[focus] .smart-hint:after {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-date-time-picker.outlined {
    background: inherit;
    border: none;
    height: auto;
    min-height: 0;
    padding-top: 6px
}

.smart-date-time-picker.outlined input {
    border: none !important;
    padding: 0;
    z-index: auto
}

.smart-date-time-picker.outlined .smart-content {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: auto;
    padding: 4px 3px;
    z-index: 5
}

.smart-date-time-picker.outlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0
}

.smart-date-time-picker.outlined .smart-spin-button[active],
.smart-date-time-picker.outlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-date-time-picker.outlined .smart-drop-down-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0;
    padding: 8px 0
}

.smart-date-time-picker.outlined .smart-drop-down-button.smart-calendar-button[active],
.smart-date-time-picker.outlined .smart-drop-down-button.smart-calendar-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-date-time-picker.outlined .smart-hint {
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: text;
    display: flex !important;
    font-size: 75%;
    left: 0;
    line-height: 15px;
    margin-top: -6px;
    max-height: 100%;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: color .2s, font-size .2s, opacity .1s, font-size .2s, line-height .2s;
    width: 100%;
    z-index: 5
}

.smart-date-time-picker.outlined .smart-hint:after,
.smart-date-time-picker.outlined .smart-hint:before {
    border-top: 1px solid;
    border-top-color: #e0e0e0 !important;
    border-top-color: var(--smart-border) !important;
    box-shadow: inset 0 1px transparent;
    box-sizing: border-box;
    content: "";
    display: block;
    height: 8px;
    margin-top: 6px;
    min-width: 10px;
    pointer-events: none;
    transition: border-color .2s, box-shadow .2s
}

.smart-date-time-picker.outlined .smart-hint:before {
    border-left: 1px solid transparent;
    border-radius: 4px 0;
    margin-right: 4px
}

.smart-date-time-picker.outlined .smart-hint:after {
    border-radius: 0 4px;
    border-right: 1px solid transparent;
    flex-grow: 1;
    margin-left: 4px
}

.smart-date-time-picker.outlined:not([focus]) .smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 48px;
    opacity: 0
}

.smart-date-time-picker.outlined[focus] .smart-content {
    border-color: #005c99;
    border-color: var(--smart-primary);
    border-top-color: transparent !important
}

.smart-date-time-picker.outlined[focus] .smart-drop-down-button {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-date-time-picker.outlined[focus] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-date-time-picker.outlined[focus] .smart-hint:after,
.smart-date-time-picker.outlined[focus] .smart-hint:before {
    border-top-color: #005c99 !important;
    border-top-color: var(--smart-primary) !important
}

.smart-date-time-picker.outlined.smart-element-init .smart-hint {
    display: none !important;
    visibility: hidden
}

.smart-date-time-picker[right-to-left]>.smart-container {
    direction: ltr
}

.smart-date-time-picker[right-to-left] .smart-hint,
.smart-date-time-picker[right-to-left] .smart-input.smart-date-time-input,
.smart-date-time-picker[right-to-left]>.smart-container>.smart-label {
    direction: rtl
}

.smart-drop-down.smart-date-time-drop-down {
    padding: 0 !important
}

.smart-drop-down.smart-date-time-drop-down[footer] {
    height: 430px;
    height: calc(30px + var(--smart-editor-drop-down-height));
    max-height: 430px;
    max-height: calc(30px + var(--smart-editor-drop-down-height))
}

.smart-drop-down.smart-date-time-drop-down smart-calendar,
.smart-drop-down.smart-date-time-drop-down smart-time-picker {
    border: none;
    border-radius: 0;
    height: 100%;
    min-height: 0;
    min-width: 0;
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down smart-time-picker {
    min-width: auto
}

.smart-drop-down.smart-date-time-drop-down smart-time-picker .smart-hour-minute-container {
    font-size: 40px
}

.smart-drop-down.smart-date-time-drop-down .smart-footer,
.smart-drop-down.smart-date-time-drop-down .smart-header {
    cursor: auto
}

.smart-drop-down.smart-date-time-drop-down .smart-date-time-picker-footer {
    display: flex;
    height: 100%;
    padding: 1px;
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-am-pm-element {
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component {
    display: flex;
    padding: 1px
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component>input {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    outline: 0;
    text-align: center
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component>input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component>span {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 30%
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-today {
    align-items: center;
    border: 1px solid transparent;
    border: var(--smart-border-width) solid transparent;
    display: flex;
    flex-direction: column;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    justify-content: center;
    overflow: hidden;
    padding: 1px;
    width: 30%
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-today:focus {
    outline: 0
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-hour,
.smart-drop-down.smart-date-time-drop-down .smart-footer-component-minute {
    width: 30%
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-hour smart-repeat-button,
.smart-drop-down.smart-date-time-drop-down .smart-footer-component-minute smart-repeat-button {
    border-radius: 0;
    height: 50%;
    margin: 0 0 0 -1px;
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-hour smart-repeat-button:last-child,
.smart-drop-down.smart-date-time-drop-down .smart-footer-component-minute smart-repeat-button:last-child {
    border-top-color: transparent
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-hour button,
.smart-drop-down.smart-date-time-drop-down .smart-footer-component-minute button {
    border-radius: 0;
    padding: 0
}

.smart-drop-down.smart-date-time-drop-down .smart-footer-component-ampm {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 30%
}

.smart-drop-down.smart-date-time-drop-down .smart-hour-element,
.smart-drop-down.smart-date-time-drop-down .smart-minute-element {
    width: 60%
}

.smart-drop-down.smart-date-time-drop-down .smart-today-element {
    cursor: pointer;
    outline: 0
}

.smart-drop-down.smart-date-time-drop-down .smart-today-element:after {
    content: "\\e829";
    content: var(--smart-icon-calendar)
}

.smart-drop-down.smart-date-time-drop-down .smart-today-element:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-header {
    align-items: center;
    display: flex;
    height: 48px;
    height: var(--smart-bar-height);
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-header:focus {
    outline: 0
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-header>div {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    opacity: .8;
    opacity: var(--smart-date-time-picker-header-opacity);
    outline: unset;
    width: 50%
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-header>div:focus {
    text-decoration: underline
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-header>.smart-selected {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    opacity: 1;
    opacity: var(--smart-date-time-picker-header-opacity-active)
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-content {
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-bar-height));
    width: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-drop-down-content.partial,
.smart-drop-down.smart-date-time-drop-down[drop-down-display-mode=classic] .smart-calendar-container,
.smart-drop-down.smart-date-time-drop-down[drop-down-display-mode=timePicker] .smart-calendar-container {
    height: 100%
}

.smart-drop-down.smart-date-time-drop-down .smart-date-time-picker .smart-hidden {
    display: none
}

.smart-drop-down.smart-date-time-drop-down.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

smart-docking-layout {
    height: 800px;
    height: var(--smart-docking-layout-default-height);
    width: 1000px;
    width: var(--smart-docking-layout-default-width)
}

.smart-docking-layout .smart-items-container,
smart-docking-layout .smart-horizontal-hidden-items-container,
smart-docking-layout .smart-items-container,
smart-docking-layout .smart-vertical-hidden-items-container {
    background-color: transparent;
    height: 100%;
    width: 100%
}

smart-docking-layout.smart-element {
    overflow: visible;
    overflow: initial
}

smart-docking-layout:not([animation=none]) .smart-window .smart-dock-button:after {
    transition: -webkit-transform .2s ease;
    transition: transform .2s ease;
    transition: transform .2s ease, -webkit-transform .2s ease
}

.smart-docking-layout>.smart-container {
    overflow: hidden
}

.smart-docking-layout .smart-tabs-window-feedback.smart-window {
    max-height: 400px;
    max-width: 400px;
    opacity: 0;
    pointer-events: none;
    position: absolute
}

.smart-docking-layout .smart-tabs-window-feedback.smart-window:not([animation=none]) {
    transition: opacity .2s ease-out, visibility .2s ease-out, -webkit-transform .2s ease-out;
    transition: transform .2s ease-out, opacity .2s ease-out, visibility .2s ease-out;
    transition: transform .2s ease-out, opacity .2s ease-out, visibility .2s ease-out, -webkit-transform .2s ease-out
}

.smart-docking-layout .smart-tabs-window-feedback[tabs-window-dragged] {
    min-height: 400px;
    min-width: 400px;
    opacity: .9;
    -webkit-transform: scale(.2);
    transform: scale(.2);
    z-index: 10001
}

.smart-docking-layout .smart-window .smart-content-container>.smart-content {
    align-items: stretch
}

.smart-docking-layout .smart-window .smart-dock-button:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up);
    font-size: .8rem
}

.smart-docking-layout .smart-window .smart-buttons-container .smart-dock-button:after {
    content: "\\e82d";
    content: var(--smart-icon-window-pin-alt);
    font-size: .8rem
}

.smart-docking-layout .smart-window .smart-buttons-container .smart-menu-button:after {
    content: "\\f0c9";
    content: var(--smart-icon-menu);
    font-size: .8rem;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-docking-layout .smart-window .smart-buttons-container .smart-auto-hide-button:after {
    content: "\\e80a";
    content: var(--smart-icon-window-pin);
    font-size: .8rem
}

.smart-docking-layout .smart-window[focused] {
    box-shadow: none
}

.smart-docking-layout .smart-placeholder .smart-window .smart-content-container>.smart-header-section {
    height: 0;
    min-height: 0;
    padding: 0
}

.smart-docking-layout .smart-docking-layout-item-holder {
    height: 100%;
    width: 100%
}

.smart-docking-layout .smart-horizontal-hidden-items-container,
.smart-docking-layout .smart-vertical-hidden-items-container {
    background-color: transparent;
    height: 100%;
    width: 100%
}

.smart-docking-layout .smart-horizontal-hidden-items-container>.smart-container>smart-splitter-item,
.smart-docking-layout .smart-vertical-hidden-items-container>.smart-container>smart-splitter-item {
    background-color: transparent
}

.smart-docking-layout .smart-docking-layout-auto-hide-window:focus,
.smart-docking-layout .smart-docking-layout-auto-hide-window[focused] {
    box-shadow: none
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right] {
    -webkit-animation: leftToRightOut .2s cubic-bezier(.4, 0, 1, 1);
    animation: leftToRightOut .2s cubic-bezier(.4, 0, 1, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right],
.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right][opened] {
    -webkit-transform-origin: left;
    transform-origin: left;
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right][opened] {
    -webkit-animation: leftToRightIn .2s cubic-bezier(0, 0, .2, 1);
    animation: leftToRightIn .2s cubic-bezier(0, 0, .2, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right]:not([animation=none]) {
    -webkit-transform: scaleX(1);
    transform: scaleX(1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=right]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: scaleX(0);
    transform: scaleX(0)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left] {
    -webkit-animation: rightToLeftOut .2s cubic-bezier(.4, 0, 1, 1);
    animation: rightToLeftOut .2s cubic-bezier(.4, 0, 1, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left],
.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left][opened] {
    -webkit-transform-origin: right;
    transform-origin: right;
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left][opened] {
    -webkit-animation: rightToLeftIn .2s cubic-bezier(0, 0, .2, 1);
    animation: rightToLeftIn .2s cubic-bezier(0, 0, .2, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left]:not([animation=none]) {
    -webkit-transform: scaleX(1);
    transform: scaleX(1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=left]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: scaleX(0);
    transform: scaleX(0)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top] {
    -webkit-animation: bottomToTopOut .2s cubic-bezier(.4, 0, 1, 1);
    animation: bottomToTopOut .2s cubic-bezier(.4, 0, 1, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top],
.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top][opened] {
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top][opened] {
    -webkit-animation: bottomToTopIn .2s cubic-bezier(0, 0, .2, 1);
    animation: bottomToTopIn .2s cubic-bezier(0, 0, .2, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top]:not([animation=none]) {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=top]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom] {
    -webkit-animation: topToBottomOut .2s cubic-bezier(.4, 0, 1, 1);
    animation: topToBottomOut .2s cubic-bezier(.4, 0, 1, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom],
.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom][opened] {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom][opened] {
    -webkit-animation: topToBottomIn .2s cubic-bezier(0, 0, .2, 1);
    animation: topToBottomIn .2s cubic-bezier(0, 0, .2, 1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom]:not([animation=none]) {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window[resize-mode=bottom]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-docking-layout .smart-docking-layout-auto-hide-window.smart-window {
    border: 1px solid #a9a9a9;
    border-radius: 0;
    box-shadow: none;
    height: 200px;
    min-height: 100px;
    min-width: 100px;
    position: absolute;
    width: 200px
}

.smart-docking-layout .smart-docking-layout-auto-hide-window.smart-window .smart-content-container:not([class*=smart-window-resizing])>.smart-header-section {
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-docking-layout .smart-window-resize-feedback {
    border: 2.5px solid #d3d3d3
}

.smart-docking-layout smart-tabs-window.smart-window {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 0;
    box-shadow: none;
    height: 100%;
    left: auto;
    max-width: 100%;
    min-height: 0;
    min-width: 0;
    position: relative;
    top: auto;
    -webkit-transform: none;
    -webkit-transform: initial;
    transform: none;
    width: 100%;
    z-index: auto
}

.smart-docking-layout smart-tabs-window.smart-window smart-tabs {
    height: 100%;
    min-height: 0;
    min-width: 0
}

.smart-docking-layout smart-tabs-window.smart-window .smart-maximize-button,
.smart-docking-layout smart-tabs-window.smart-window .smart-minimize-button,
.smart-docking-layout smart-tabs-window.smart-window .smart-pin-button {
    display: none
}

.smart-docking-layout smart-tabs-window.smart-window:not(.smart-docking-layout-auto-hide-window) .smart-content-container,
.smart-docking-layout smart-tabs-window.smart-window[pinned]:not(.smart-docking-layout-auto-hide-window) .smart-content-container {
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-docking-layout smart-tabs-window.smart-window:not([animation=none]):not(.smart-docking-layout-auto-hide-window) {
    transition: -webkit-transform .2s ease-out;
    transition: transform .2s ease-out;
    transition: transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-docking-layout smart-tabs-window.smart-window[collapsed] {
    height: 100%
}

.smart-docking-layout smart-tabs-window.smart-window[tabs-window-dragged]:not(.smart-tabs-window-feedback) {
    -webkit-transform: scale(.75);
    transform: scale(.75)
}

.smart-docking-layout smart-tabs-window.smart-window[ontop]:not([tabs-window-dragged]) {
    z-index: auto
}

.smart-docking-layout smart-tabs-window.smart-window[auto-hide] {
    border: none;
    height: 100%;
    width: 100%
}

.smart-docking-layout smart-tabs-window.smart-window[auto-hide] smart-tabs {
    height: 100%;
    width: 100%
}

.smart-docking-layout smart-tabs-window.smart-window[auto-hide] .smart-content-container>.smart-content {
    overflow: hidden;
    padding: 0
}

.smart-docking-layout smart-placeholder .smart-window .smart-content {
    height: 100%
}

.smart-docking-layout smart-splitter {
    border: none
}

.smart-docking-layout smart-splitter smart-splitter-bar .smart-splitter-resize-button {
    display: none
}

.smart-docking-layout smart-splitter[show-locked-items] smart-splitter-item[locked].auto-hide-bottom>.smart-container:after,
.smart-docking-layout smart-splitter[show-locked-items] smart-splitter-item[locked].auto-hide-left>.smart-container:after,
.smart-docking-layout smart-splitter[show-locked-items] smart-splitter-item[locked].auto-hide-right>.smart-container:after,
.smart-docking-layout smart-splitter[show-locked-items] smart-splitter-item[locked].auto-hide-top>.smart-container:after {
    content: ""
}

.smart-docking-layout smart-splitter-item smart-tabs-window.smart-window[auto-hide] .smart-content-container>.smart-content {
    height: 100%
}

.smart-docking-layout smart-splitter-item smart-tabs-window.smart-window:not([animation=none]) {
    -webkit-animation: none;
    animation: none;
    border: none;
    transition: none
}

.smart-docking-layout smart-splitter-item.smart-placeholder smart-tab-item .smart-container:after {
    color: gray;
    content: "Drop Items Here";
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 20px;
    left: 50%;
    opacity: .75;
    padding: 15px;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

@-moz-document url-prefix() {
    .smart-docking-layout smart-splitter-item[locked].auto-hide-top {
        line-height: 100%
    }
}

@supports (-ms-ime-align:auto) {
    .smart-docking-layout smart-tabs[vertical]>.smart-container {
        display: table-cell
    }
}

.smart-docking-layout[dragged] {
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-docking-layout[dragged]>.smart-container {
    overflow: visible
}

.smart-docking-layout[snap-mode=advanced] smart-splitter-item .smart-content {
    overflow: hidden
}

smart-tabs-window[tabs-window-dragged]:not(.smart-tabs-window-feedback) {
    -webkit-transform: scale(.2);
    transform: scale(.2)
}

smart-tabs-window.smart-window .smart-buttons-container .smart-auto-hide-button:after {
    content: "\\e80a";
    content: var(--smart-icon-window-pin);
    font-size: .8rem
}

smart-tabs-window.smart-window[auto-hide] .smart-content-container>.smart-content {
    padding: 5px
}

smart-tabs-window.smart-window[tabs-window-dragged] {
    -webkit-animation: none;
    animation: none;
    min-height: 400px;
    min-width: 400px;
    opacity: .5;
    pointer-events: none;
    position: absolute;
    -webkit-transform: scale(.2);
    transform: scale(.2);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    z-index: 10001
}

smart-tabs-window.smart-window[tabs-window-dragged]:not([animation=none]) {
    -webkit-animation: scaleInNo .2s cubic-bezier(.4, 0, .2, 1);
    animation: scaleInNo .2s cubic-bezier(.4, 0, .2, 1);
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-docking-snap-bottom-feedback,
.smart-docking-snap-left-feedback,
.smart-docking-snap-right-feedback,
.smart-docking-snap-top-feedback {
    -webkit-animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    border-radius: 2px;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-right-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 0 1px 1px #5a5a5a;
    box-shadow: 0 0 1px 1px var(--smart-background-color);
    opacity: .65;
    pointer-events: none;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: all 50ms cubic-bezier(.4, 0, .6, 1);
    z-index: 10001
}

.smart-docking-snap-bottom-feedback[disabled]:after,
.smart-docking-snap-left-feedback[disabled]:after,
.smart-docking-snap-right-feedback[disabled]:after,
.smart-docking-snap-top-feedback[disabled]:after {
    color: red;
    content: "\\e832";
    content: var(--smart-icon-block);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 35px;
    left: 50%;
    opacity: .25;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-docking-snap-right-feedback {
    left: calc(50% - 5px);
    width: 50%
}

.smart-docking-snap-header-feedback,
.smart-docking-snap-layout-bottom-feedback,
.smart-docking-snap-layout-left-feedback,
.smart-docking-snap-layout-right-feedback,
.smart-docking-snap-layout-top-feedback {
    -webkit-animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 0 1px 1px #5a5a5a;
    box-shadow: 0 0 1px 1px var(--smart-background-color);
    cursor: pointer;
    opacity: .65;
    pointer-events: none;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: width 50ms cubic-bezier(.4, 0, .2, 1), height 50ms cubic-bezier(.4, 0, .2, 1), top 50ms cubic-bezier(.4, 0, .6, 1), left 50ms cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1);
    transition: width 50ms cubic-bezier(.4, 0, .2, 1), height 50ms cubic-bezier(.4, 0, .2, 1), top 50ms cubic-bezier(.4, 0, .6, 1), animation .2s cubic-bezier(.4, 0, .6, 1), left 50ms cubic-bezier(.4, 0, .2, 1);
    transition: width 50ms cubic-bezier(.4, 0, .2, 1), height 50ms cubic-bezier(.4, 0, .2, 1), top 50ms cubic-bezier(.4, 0, .6, 1), animation .2s cubic-bezier(.4, 0, .6, 1), left 50ms cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1);
    z-index: 10001
}

.smart-docking-snap-header-feedback.smart-visibility-hidden,
.smart-docking-snap-layout-bottom-feedback.smart-visibility-hidden,
.smart-docking-snap-layout-left-feedback.smart-visibility-hidden,
.smart-docking-snap-layout-right-feedback.smart-visibility-hidden,
.smart-docking-snap-layout-top-feedback.smart-visibility-hidden {
    -webkit-animation: scaleOut .2s cubic-bezier(.4, 0, .6, 1);
    animation: scaleOut .2s cubic-bezier(.4, 0, .6, 1);
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .1s cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1);
    transition: animation .2s cubic-bezier(.4, 0, .6, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .1s cubic-bezier(.4, 0, .2, 1);
    transition: animation .2s cubic-bezier(.4, 0, .6, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .1s cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-docking-snap-header-feedback[disabled]:after,
.smart-docking-snap-layout-bottom-feedback[disabled]:after,
.smart-docking-snap-layout-left-feedback[disabled]:after,
.smart-docking-snap-layout-right-feedback[disabled]:after,
.smart-docking-snap-layout-top-feedback[disabled]:after {
    color: red;
    content: "\\e832";
    content: var(--smart-icon-block);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 35px;
    left: 50%;
    opacity: .25;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-docking-snap-layout-left-feedback,
.smart-docking-snap-layout-right-feedback {
    max-width: 50px;
    -webkit-transform-origin: left;
    transform-origin: left
}

.smart-docking-snap-layout-bottom-feedback,
.smart-docking-snap-layout-top-feedback {
    max-height: 50px;
    -webkit-transform-origin: left;
    transform-origin: left
}

.smart-docking-layout-auto-hide-window,
.smart-docking-layout-auto-hide-window[ontop] {
    z-index: 9999 !important
}

.smart-docking-layout-snap {
    height: 110px;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 110px
}

.smart-docking-layout-snap>div {
    align-items: center;
    display: flex;
    height: 33.33333%;
    justify-content: center;
    width: 100%
}

.smart-docking-layout-snap .header {
    background-color: #005c99;
    background-color: var(--smart-primary);
    position: absolute
}

.smart-docking-layout-snap .bottom,
.smart-docking-layout-snap .center,
.smart-docking-layout-snap .left,
.smart-docking-layout-snap .right,
.smart-docking-layout-snap .top {
    float: left;
    height: 35px;
    opacity: .25;
    overflow: hidden;
    padding: 2px;
    width: 35px
}

.smart-docking-layout-snap .bottom>div,
.smart-docking-layout-snap .center>div,
.smart-docking-layout-snap .left>div,
.smart-docking-layout-snap .right>div,
.smart-docking-layout-snap .top>div {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-top: 6px solid var(--smart-border);
    box-sizing: border-box;
    display: flex;
    height: 100%;
    pointer-events: none;
    width: 100%
}

.smart-docking-layout-snap .bottom>div div,
.smart-docking-layout-snap .center>div div,
.smart-docking-layout-snap .left>div div,
.smart-docking-layout-snap .right>div div,
.smart-docking-layout-snap .top>div div {
    background-color: #005c99;
    background-color: var(--smart-primary);
    height: 50%;
    width: 100%
}

.smart-docking-layout-snap .bottom[show],
.smart-docking-layout-snap .center[show],
.smart-docking-layout-snap .left[show],
.smart-docking-layout-snap .right[show],
.smart-docking-layout-snap .top[show] {
    opacity: 1
}

.smart-docking-layout-snap .left>div div,
.smart-docking-layout-snap .right>div div {
    height: 100%;
    width: 50%
}

.smart-docking-layout-snap .right>div {
    align-items: flex-end;
    flex-direction: column
}

.smart-docking-layout-snap .bottom>div {
    align-items: flex-end
}

.smart-docking-layout-snap .center>div div {
    height: 100%
}

.smart-docking-layout-snap.layout-bottom,
.smart-docking-layout-snap.layout-left,
.smart-docking-layout-snap.layout-right,
.smart-docking-layout-snap.layout-top {
    height: 30px;
    opacity: .25;
    overflow: hidden;
    position: absolute;
    width: 30px
}

.smart-docking-layout-snap.layout-bottom>div,
.smart-docking-layout-snap.layout-left>div,
.smart-docking-layout-snap.layout-right>div,
.smart-docking-layout-snap.layout-top>div {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-top: 6px solid var(--smart-border);
    box-sizing: border-box;
    display: flex;
    height: 100%;
    pointer-events: none;
    width: 100%
}

.smart-docking-layout-snap.layout-bottom>div div,
.smart-docking-layout-snap.layout-left>div div,
.smart-docking-layout-snap.layout-right>div div,
.smart-docking-layout-snap.layout-top>div div {
    background-color: #005c99;
    background-color: var(--smart-primary);
    height: 100%;
    width: 100%
}

.smart-docking-layout-snap.layout-bottom.smart-hidden,
.smart-docking-layout-snap.layout-left.smart-hidden,
.smart-docking-layout-snap.layout-right.smart-hidden,
.smart-docking-layout-snap.layout-top.smart-hidden {
    display: none
}

.smart-docking-layout-snap.layout-bottom[show],
.smart-docking-layout-snap.layout-left[show],
.smart-docking-layout-snap.layout-right[show],
.smart-docking-layout-snap.layout-top[show] {
    opacity: 1
}

.smart-docking-layout-snap.layout-top {
    left: 50%;
    top: 5px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%)
}

.smart-docking-layout-snap.layout-top>div {
    height: 50%;
    position: relative
}

.smart-docking-layout-snap.layout-bottom>div:after,
.smart-docking-layout-snap.layout-top>div:after {
    border-left: 7px solid transparent;
    border-left: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    height: 0;
    position: absolute
}

.smart-docking-layout-snap.layout-top>div:after {
    border-bottom: 7px solid #e0e0e0;
    border-bottom: var(--smart-docking-layout-feedback-background-secondary-size) solid var(--smart-border);
    border-right: 7px solid transparent;
    border-right: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    border-top: none;
    content: "";
    left: 50%;
    top: 180%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 0
}

.smart-docking-layout-snap.layout-bottom {
    align-items: flex-end;
    bottom: 5px;
    display: flex;
    left: 50%;
    top: auto;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%)
}

.smart-docking-layout-snap.layout-bottom>div {
    height: 50%;
    position: relative
}

.smart-docking-layout-snap.layout-bottom>div:after {
    border-bottom: none;
    border-right: 7px solid transparent;
    border-right: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    border-top: 7px solid #e0e0e0;
    border-top: var(--smart-docking-layout-feedback-background-secondary-size) solid var(--smart-border);
    content: "";
    left: 50%;
    top: -100%;
    -webkit-transform: translate(-50%, -150%);
    transform: translate(-50%, -150%);
    width: 0
}

.smart-docking-layout-snap.layout-left>div:after,
.smart-docking-layout-snap.layout-right>div:after {
    border-top: 7px solid transparent;
    border-top: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    content: "";
    height: 0
}

.smart-docking-layout-snap.layout-left {
    left: 5px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-docking-layout-snap.layout-left>div {
    position: relative;
    width: 50%
}

.smart-docking-layout-snap.layout-left>div:after {
    border-bottom: 7px solid transparent;
    border-bottom: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    border-left: none;
    border-right: 7px solid #e0e0e0;
    border-right: var(--smart-docking-layout-feedback-background-secondary-size) solid var(--smart-border);
    left: 155%;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 0
}

.smart-docking-layout-snap.layout-right {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    left: auto;
    right: 5px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-docking-layout-snap.layout-right>div {
    position: relative;
    width: 50%
}

.smart-docking-layout-snap.layout-right>div:after {
    border-bottom: 7px solid transparent;
    border-bottom: var(--smart-docking-layout-feedback-background-secondary-size) solid transparent;
    border-left: 7px solid #e0e0e0;
    border-left: var(--smart-docking-layout-feedback-background-secondary-size) solid var(--smart-border);
    border-right: none;
    left: calc(-100% - 1px);
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 0
}

.smart-docking-layout-snap-highlighter {
    background-color: #005c99;
    background-color: var(--smart-primary);
    opacity: .5;
    pointer-events: none;
    position: absolute;
    z-index: 10001
}

.smart-docking-layout-snap-highlighter[position=header] {
    height: 100%;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=center] {
    height: 100%;
    left: 0;
    top: 0;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=top] {
    height: 50%;
    max-height: 50%;
    top: 0;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=bottom] {
    bottom: 0;
    height: 50%;
    max-height: 50%;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=left] {
    height: 100%;
    left: 0;
    max-width: 50%;
    top: 0;
    width: 50%
}

.smart-docking-layout-snap-highlighter[position=right] {
    height: 100%;
    max-width: 50%;
    right: 0;
    top: 0;
    width: 50%
}

.smart-docking-layout-snap-highlighter[position=layout-top] {
    height: 10%;
    max-height: 50%;
    top: 0;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=layout-bottom] {
    bottom: 0;
    height: 10%;
    max-height: 50%;
    width: 100%
}

.smart-docking-layout-snap-highlighter[position=layout-left] {
    bottom: 0;
    height: 100%;
    left: 0;
    max-width: 50%;
    width: 10%
}

.smart-docking-layout-snap-highlighter[position=layout-right] {
    bottom: 0;
    height: 100%;
    max-width: 50%;
    right: 0;
    width: 10%
}

.smart-docking-layout-snap-highlighter-header {
    background-color: #005c99;
    background-color: var(--smart-primary);
    opacity: .5;
    pointer-events: none;
    position: absolute;
    -webkit-transform: none;
    transform: none;
    z-index: 10001
}

@-webkit-keyframes scaleInNo {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    to {
        -webkit-transform: scale(.2);
        transform: scale(.2)
    }
}

@keyframes scaleInNo {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    to {
        -webkit-transform: scale(.2);
        transform: scale(.2)
    }
}

@-webkit-keyframes leftToRightIn {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@keyframes leftToRightIn {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@-webkit-keyframes leftToRightOut {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }

    to {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@keyframes leftToRightOut {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }

    to {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@-webkit-keyframes rightToLeftIn {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@keyframes rightToLeftIn {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@-webkit-keyframes rightToLeftOut {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }

    to {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@keyframes rightToLeftOut {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }

    to {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }
}

@-webkit-keyframes bottomToTopIn {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@keyframes bottomToTopIn {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@-webkit-keyframes bottomToTopOut {
    0% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    to {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@keyframes bottomToTopOut {
    0% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    to {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@-webkit-keyframes topToBottomIn {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@keyframes topToBottomIn {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@-webkit-keyframes topToBottomOut {
    0% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    to {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@keyframes topToBottomOut {
    0% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    to {
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

smart-drop-down-list {
    cursor: pointer;
    height: 30px;
    height: var(--smart-drop-down-list-default-height);
    overflow: visible;
    overflow: initial;
    visibility: hidden;
    width: 250px;
    width: var(--smart-drop-down-list-default-width)
}

smart-drop-down-list.smart-element {
    border-width: 0;
    overflow: visible;
    visibility: inherit
}

smart-drop-down-list.smart-element .smart-drop-down.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top 0;
    transform-origin: left top 0;
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-drop-down-list smart-list-box {
    border: initial;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    outline: 0;
    overflow: hidden;
    padding: initial;
    position: relative;
    width: 100%
}

.smart-drop-down-list .smart-buttons-container .smart-action-button .smart-token {
    cursor: pointer;
    margin: 0 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-drop-down-list .smart-drop-down-list-unselect-button {
    pointer-events: none
}

.smart-drop-down-list .smart-drop-down-list-unselect-button:not(:empty) {
    margin-right: 2px
}

.smart-drop-down-list[selection-display-mode=tokens] .smart-drop-down-list-unselect-button {
    pointer-events: auto
}

smart-drop-down-button {
    height: 30px;
    height: var(--smart-drop-down-button-default-height);
    visibility: hidden;
    width: auto;
    width: var(--smart-drop-down-button-default-width)
}

smart-drop-down-button.smart-element {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border: none;
    display: inline-block;
    overflow: visible;
    visibility: inherit
}

smart-drop-down-button .smart-ripple {
    background: #fff;
    background: var(--smart-primary-color)
}

smart-drop-down-button .smart-buttons-container>.smart-action-button:empty {
    padding: 0;
    width: 0
}

smart-drop-down-button .smart-drop-down-container>smart-scroll-viewer {
    --smart-scroll-viewer-min-width: calc(var(--smart-editor-drop-down-min-width) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2);
    --smart-scroll-viewer-max-width: calc(var(--smart-editor-drop-down-max-width) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2);
    --smart-scroll-viewer-min-height: calc(var(--smart-editor-drop-down-min-height) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2);
    --smart-scroll-viewer-max-height: calc(var(--smart-editor-drop-down-max-height) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2);
    border: none;
    height: 100%;
    overflow: hidden;
    padding: 0;
    width: 100%
}

smart-drop-down-button .smart-drop-down-container>smart-scroll-viewer>.smart-container>.smart-scroll-viewer-container>.smart-scroll-viewer-content-container {
    padding: 0;
    vertical-align: top
}

smart-drop-down-button .smart-drop-down-container:not([resize-mode=none])>smart-scroll-viewer {
    --smart-scroll-viewer-min-height: calc(var(--smart-editor-drop-down-min-height) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2 - var(--smart-editor-drop-down-resize-bar-height));
    --smart-scroll-viewer-max-height: calc(var(--smart-editor-drop-down-max-height) - var(--smart-border-width)*2 - var(--smart-editor-drop-down-padding-size)*2 - var(--smart-editor- drop-down-resize-bar-height));
    height: calc(100% - 15px);
    height: calc(100% - var(--smart-editor-drop-down-resize-bar-height))
}

smart-drop-down-button .smart-drop-down-container[empty]>smart-scroll-viewer>.smart-container>.smart-scroll-viewer-container {
    align-items: center;
    display: flex;
    font-style: italic;
    justify-content: center
}

smart-drop-down-button .smart-drop-down-container smart-tree {
    border: 0
}

smart-drop-down-button.primary {
    --smart-editor-selection: var(--smart-primary);
    --smart-editor-selection-color: var(--smart-primary-color);
    --smart-ui-state-active: var(--smart-primary);
    --smart-ui-state-color-active: var(--smart-primary-color);
    --smart-ui-state-border-active: var(--smart-primary);
    --smart-ui-state-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-primary);
    --smart-ui-state-border-selected: rgba(var(--smart-primary-rgb), .1);
    --smart-border: rgba(var(--smart-primary-rgb), .9)
}

smart-drop-down-button.primary:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-primary-rgb), .9);
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-drop-down-button.primary .smart-action-button,
smart-drop-down-button.primary .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-primary-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-primary-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-primary-color);
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-drop-down-button.secondary {
    --smart-editor-selection: var(--smart-secondary);
    --smart-editor-selection-color: var(--smart-secondary-color);
    --smart-ui-state-active: var(--smart-secondary);
    --smart-ui-state-color-active: var(--smart-secondary-color);
    --smart-ui-state-border-active: var(--smart-secondary);
    --smart-ui-state-selected: rgba(var(--smart-secondary-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-secondary);
    --smart-ui-state-border-selected: rgba(var(--smart-secondary-rgb), .1);
    --smart-border: rgba(var(--smart-secondary-rgb), .9)
}

smart-drop-down-button.secondary:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-secondary-rgb), .9);
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

smart-drop-down-button.secondary .smart-action-button,
smart-drop-down-button.secondary .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-secondary-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-secondary-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-secondary-color);
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

smart-drop-down-button.success {
    --smart-editor-selection: var(--smart-success);
    --smart-editor-selection-color: var(--smart-success-color);
    --smart-ui-state-active: var(--smart-success);
    --smart-ui-state-color-active: var(--smart-success-color);
    --smart-ui-state-border-active: var(--smart-success);
    --smart-ui-state-selected: rgba(var(--smart-success-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-success);
    --smart-ui-state-border-selected: rgba(var(--smart-success-rgb), .1);
    --smart-border: rgba(var(--smart-success-rgb), .9)
}

smart-drop-down-button.success:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-success-rgb), .9);
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

smart-drop-down-button.success .smart-action-button,
smart-drop-down-button.success .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-success-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-success-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-success-color);
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

smart-drop-down-button.info {
    --smart-editor-selection: var(--smart-info);
    --smart-editor-selection-color: var(--smart-info-color);
    --smart-ui-state-active: var(--smart-info);
    --smart-ui-state-color-active: var(--smart-info-color);
    --smart-ui-state-border-active: var(--smart-info);
    --smart-ui-state-selected: rgba(var(--smart-info-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-info);
    --smart-ui-state-border-selected: rgba(var(--smart-info-rgb), .1);
    --smart-border: rgba(var(--smart-info-rgb), .9)
}

smart-drop-down-button.info:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-info-rgb), .9);
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

smart-drop-down-button.info .smart-action-button,
smart-drop-down-button.info .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-info-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-info-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-info-color);
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

smart-drop-down-button.warning {
    --smart-editor-selection: var(--smart-warning);
    --smart-editor-selection-color: var(--smart-warning-color);
    --smart-ui-state-active: var(--smart-warning);
    --smart-ui-state-color-active: var(--smart-warning-color);
    --smart-ui-state-border-active: var(--smart-warning);
    --smart-ui-state-selected: rgba(var(--smart-warning-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-warning);
    --smart-ui-state-border-selected: rgba(var(--smart-warning-rgb), .1);
    --smart-border: rgba(var(--smart-warning-rgb), .9)
}

smart-drop-down-button.warning:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-warning-rgb), .9);
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    color: #fff;
    color: var(--smart-warning-color)
}

smart-drop-down-button.warning .smart-action-button,
smart-drop-down-button.warning .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-warning-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-warning-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-warning-color);
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    color: #fff;
    color: var(--smart-warning-color)
}

smart-drop-down-button.error {
    --smart-editor-selection: var(--smart-error);
    --smart-editor-selection-color: var(--smart-error-color);
    --smart-ui-state-active: var(--smart-error);
    --smart-ui-state-color-active: var(--smart-error-color);
    --smart-ui-state-border-active: var(--smart-error);
    --smart-ui-state-selected: rgba(var(--smart-error-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-error);
    --smart-ui-state-border-selected: rgba(var(--smart-error-rgb), .1);
    --smart-border: rgba(var(--smart-error-rgb), .9)
}

smart-drop-down-button.error:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-error-rgb), .9);
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

smart-drop-down-button.error .smart-action-button,
smart-drop-down-button.error .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-error-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-error-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-error-color);
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

smart-drop-down-button.light {
    --smart-editor-selection: var(--smart-light);
    --smart-editor-selection-color: var(--smart-light-color);
    --smart-ui-state-active: var(--smart-light);
    --smart-ui-state-color-active: var(--smart-light-color);
    --smart-ui-state-border-active: var(--smart-light);
    --smart-ui-state-selected: rgba(var(--smart-light-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-light);
    --smart-ui-state-border-selected: rgba(var(--smart-light-rgb), .1);
    --smart-border: rgba(var(--smart-light-rgb), .9)
}

smart-drop-down-button.light:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-light-rgb), .9);
    background-color: #fff;
    background-color: var(--smart-light);
    color: #222;
    color: var(--smart-light-color)
}

smart-drop-down-button.light .smart-action-button,
smart-drop-down-button.light .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-light-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-light-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-light-color);
    background-color: #fff;
    background-color: var(--smart-light);
    color: #222;
    color: var(--smart-light-color)
}

smart-drop-down-button.dark {
    --smart-editor-selection: var(--smart-dark);
    --smart-editor-selection-color: var(--smart-dark-color);
    --smart-ui-state-active: var(--smart-dark);
    --smart-ui-state-color-active: var(--smart-dark-color);
    --smart-ui-state-border-active: var(--smart-dark);
    --smart-ui-state-selected: rgba(var(--smart-dark-rgb), .1);
    --smart-ui-state-color-selected: var(--smart-dark);
    --smart-ui-state-border-selected: rgba(var(--smart-dark-rgb), .1);
    --smart-border: rgba(var(--smart-dark-rgb), .9)
}

smart-drop-down-button.dark:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    --smart-border: rgba(var(--smart-dark-rgb), .9);
    background-color: #222;
    background-color: var(--smart-dark);
    color: #fff;
    color: var(--smart-dark-color)
}

smart-drop-down-button.dark .smart-action-button,
smart-drop-down-button.dark .smart-drop-down-button {
    --smart-ui-state-border-hover: rgba(var(--smart-dark-rgb), .9);
    --smart-ui-state-hover: rgba(var(--smart-dark-rgb), .9);
    --smart-ui-state-color-hover: var(--smart-dark-color);
    background-color: #222;
    background-color: var(--smart-dark);
    color: #fff;
    color: var(--smart-dark-color)
}

.smart-drop-down-box,
.smart-drop-down-box .smart-action-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-drop-down-box {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 30px;
    height: var(--smart-editor-height);
    outline: 0;
    overflow: visible;
    overflow: initial
}

.smart-drop-down-box.smart-container,
.smart-drop-down-box>.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-drop-down-box.smart-container>.smart-content,
.smart-drop-down-box>.smart-container>.smart-content {
    display: flex;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-drop-down-box .smart-buttons-container {
    cursor: inherit;
    display: inherit;
    flex-direction: inherit;
    height: inherit;
    min-height: inherit;
    overflow: hidden;
    position: inherit;
    width: inherit
}

.smart-drop-down-box .smart-action-button {
    align-content: center;
    align-items: center;
    border-style: solid;
    border-width: 1px;
    border-width: var(--smart-border-width);
    border-right: none;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    outline: 1px solid transparent;
    overflow: hidden;
    padding-left: 4px;
    padding-left: var(--smart-editor-label-padding);
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-drop-down-box .smart-action-button .smart-input {
    background: inherit;
    border: none;
    color: inherit;
    height: 100%;
    outline: 0;
    text-overflow: ellipsis;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-drop-down-box .smart-action-button .smart-input::-webkit-input-placeholder {
    color: inherit
}

.smart-drop-down-box .smart-action-button .smart-input:-ms-input-placeholder {
    color: inherit
}

.smart-drop-down-box .smart-action-button .smart-input::placeholder {
    color: inherit
}

.smart-drop-down-box .smart-drop-down-button {
    align-items: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-left: none;
    color: inherit;
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: flex;
    justify-content: center;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    outline: 1px solid transparent;
    overflow: hidden;
    position: relative;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-drop-down-box .smart-drop-down-button .smart-drop-down-button-icon {
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    pointer-events: none;
    -webkit-transform-origin: center;
    transform-origin: center;
    width: 100%
}

.smart-drop-down-box .smart-drop-down-button .smart-drop-down-button-icon:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    font-size: var(--smart-arrow-size)
}

.smart-drop-down-box .smart-drop-down-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box .smart-drop-down-button[center-top] .smart-drop-down-button-icon:after,
.smart-drop-down-box .smart-drop-down-button[top] .smart-drop-down-button-icon:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-drop-down-box .smart-drop-down {
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.smart-drop-down-box .smart-drop-down.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top 0;
    transform-origin: left top 0;
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-drop-down-box[drop-down-button-position=bottom] .smart-action-button,
.smart-drop-down-box[drop-down-button-position=top] .smart-action-button {
    min-height: 30px;
    min-height: var(--smart-editor-height);
    padding-left: 0
}

.smart-drop-down-box[drop-down-button-position=bottom] .smart-action-button,
.smart-drop-down-box[drop-down-button-position=bottom] .smart-drop-down-button,
.smart-drop-down-box[drop-down-button-position=top] .smart-action-button,
.smart-drop-down-box[drop-down-button-position=top] .smart-drop-down-button {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: 50%;
    justify-content: center;
    width: 100%
}

.smart-drop-down-box[drop-down-button-position=bottom]:not([drop-down-open-mode=dropDownButton]) .smart-drop-down-button,
.smart-drop-down-box[drop-down-button-position=top]:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    border-top: initial
}

.smart-drop-down-box[drop-down-button-position=top] {
    min-height: 60px;
    min-height: calc(var(--smart-editor-height)*2)
}

.smart-drop-down-box[drop-down-button-position=top] .smart-content {
    flex-direction: column-reverse
}

.smart-drop-down-box[drop-down-button-position=top] .smart-drop-down-button {
    border-bottom: initial;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-drop-down-box[drop-down-button-position=top] .smart-action-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.smart-drop-down-box[drop-down-button-position=bottom] {
    min-height: 60px;
    min-height: calc(var(--smart-editor-height)*2)
}

.smart-drop-down-box[drop-down-button-position=bottom] .smart-content {
    flex-direction: column
}

.smart-drop-down-box[drop-down-button-position=bottom] .smart-action-button {
    border-bottom: initial;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-drop-down-box[drop-down-button-position=bottom] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.smart-drop-down-box[drop-down-button-position=left].smart-container>.smart-content,
.smart-drop-down-box[drop-down-button-position=left]>.smart-container>.smart-content {
    flex-direction: row-reverse
}

.smart-drop-down-box[drop-down-button-position=left] .smart-action-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    flex-direction: row-reverse;
    padding-left: 0;
    padding-right: 4px;
    padding-right: var(--smart-editor-label-padding)
}

.smart-drop-down-box[drop-down-button-position=left] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-right: initial;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.smart-drop-down-box[drop-down-button-position=left] .smart-drop-down-button[selected] {
    border-right: initial
}

.smart-drop-down-box[drop-down-button-position=left]:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    border-left: initial
}

.smart-drop-down-box[drop-down-button-position=right] .smart-action-button {
    padding-left: 4px;
    padding-left: var(--smart-editor-label-padding)
}

.smart-drop-down-box[drop-down-button-position=none] .smart-action-button {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    padding-right: 4px;
    padding-right: var(--smart-editor-label-padding);
    width: 100%
}

.smart-drop-down-box[drop-down-button-position=none] .smart-drop-down-button {
    display: none
}

.smart-drop-down-box:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton] .smart-action-button {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton] .smart-action-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton] .smart-drop-down-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-left-width: 1px;
    border-left: var(--smart-border-width) solid;
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton][drop-down-button-position=left]:not([hover]) .smart-drop-down-button:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    box-shadow: 1px 0 0 0 #b2b2b2;
    box-shadow: var(--smart-border-width) 0 0 0 var(--smart-outline)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton][drop-down-button-position=left]:not([hover]) .smart-action-button:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    box-shadow: -1px 0 0 0 #b2b2b2;
    box-shadow: calc(var(--smart-border-width)*-1) 0 0 0 var(--smart-outline)
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton]:not([drop-down-button-position]):not([hover]) .smart-action-button:focus,
.smart-drop-down-box[drop-down-open-mode=dropDownButton][drop-down-button-position=right]:not([hover]) .smart-action-button:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    box-shadow: 1px 0 0 0 #b2b2b2;
    box-shadow: var(--smart-border-width) 0 0 0 var(--smart-outline);
    z-index: 1
}

.smart-drop-down-box[drop-down-open-mode=dropDownButton]:not([drop-down-button-position]):not([hover]) .smart-drop-down-button:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down-box[resizing] {
    touch-action: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-drop-down-box[readonly] input {
    -ms-user-select: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none
}

.smart-drop-down-box[hover] .smart-drop-down-button,
.smart-drop-down-box[hover]:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-drop-down-box[focus]:not([opened]) .smart-action-button,
.smart-drop-down-box[focus]:not([opened]) .smart-action-button[focus],
.smart-drop-down-box[focus]:not([opened]) .smart-drop-down-button,
.smart-drop-down-box[focus]:not([opened]) .smart-drop-down-button[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: medium none invert;
    outline: initial
}

.smart-drop-down-box[active] .smart-action-button,
.smart-drop-down-box[active][drop-down-open-mode=dropDownButton] .smart-drop-down-button:focus,
.smart-drop-down-box[active][focus][drop-down-open-mode=dropDownButton] .smart-action-button,
.smart-drop-down-box[active][focus][drop-down-open-mode=dropDownButton] .smart-drop-down-button {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box[opened] .smart-drop-down-button .smart-drop-down-button-icon:after,
.smart-drop-down-box[opened] .smart-drop-down-button[bottom] .smart-drop-down-button-icon:after,
.smart-drop-down-box[opened] .smart-drop-down-button[center-bottom] .smart-drop-down-button-icon:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-drop-down-box[opened] .smart-drop-down-button[center-top] .smart-drop-down-button-icon:after,
.smart-drop-down-box[opened] .smart-drop-down-button[top] .smart-drop-down-button-icon:after {
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-drop-down-box[opened]:not(.outlined):not(.underlined) .smart-drop-down-button,
.smart-drop-down-box[opened]:not([drop-down-open-mode=dropDownButton]):not(.outlined):not(.underlined) .smart-action-button {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box.auto-height {
    height: auto;
    min-height: 30px;
    min-height: var(--smart-editor-height)
}

.smart-drop-down-box.auto-height .smart-action-button,
.smart-drop-down-box.auto-height .smart-content,
.smart-drop-down-box.auto-height.smart-container,
.smart-drop-down-box.auto-height>.smart-container {
    min-height: inherit
}

.smart-drop-down-box.auto-height .smart-action-button {
    padding: 3px
}

.smart-drop-down-box.auto-height[hint],
.smart-drop-down-box.auto-height[label] {
    height: auto
}

.smart-drop-down-box[label][hint]>.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-drop-down-box[label]>.smart-container {
    align-items: flex-end
}

.smart-drop-down-box[hint]>.smart-container {
    align-items: flex-start
}

.smart-drop-down-box[hint] .smart-hint {
    opacity: 0;
    top: 100%;
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-drop-down-box[hint][focus] .smart-hint {
    opacity: 1;
    transition: opacity .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-drop-down-box[hint] .smart-hint,
.smart-drop-down-box[label] .smart-label {
    bottom: 100%;
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    vertical-align: baseline;
    vertical-align: initial;
    width: 100%
}

.smart-drop-down-box[disabled] .smart-drop-down-button,
.smart-drop-down-box[disabled]>.smart-container {
    background-color: transparent;
    background-color: initial;
    cursor: default
}

.smart-drop-down-box[disabled][selection-display-mode=tokens] .smart-action-button>span {
    cursor: default
}

.smart-drop-down-box.underlined {
    background-color: transparent;
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-color: #e0e0e0;
    border-bottom-color: var(--smart-border);
    border-width: 0 0 1px
}

.smart-drop-down-box.underlined .smart-action-button {
    background-color: transparent;
    border-bottom-left-radius: 0;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-drop-down-box.underlined .smart-action-button input {
    border-color: transparent !important
}

.smart-drop-down-box.underlined .smart-action-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box.underlined .smart-drop-down-button[hover],
.smart-drop-down-box.underlined .smart-spin-button[active],
.smart-drop-down-box.underlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-drop-down-box.underlined .smart-drop-down-button,
.smart-drop-down-box.underlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0
}

.smart-drop-down-box.underlined .smart-drop-down-button {
    border-bottom: 1px solid #e0e0e0 !important;
    border-bottom: 1px solid var(--smart-border) !important;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent
}

.smart-drop-down-box.underlined .smart-drop-down-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-drop-down-box.underlined .smart-hint {
    bottom: 0;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block !important;
    font-size: 75%;
    left: 0;
    margin-top: -14px;
    margin-top: calc(0px - var(--smart-font-size));
    opacity: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: color .2s, opacity .1s, font-size .2s, line-height .2s, margin-top .2s, top .2s
}

.smart-drop-down-box.underlined .smart-hint:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    bottom: -2px;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: bottom center;
    transform-origin: bottom center;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s;
    width: 100%
}

.smart-drop-down-box.underlined:not([focus]) .smart-hint {
    margin-top: 0
}

.smart-drop-down-box.underlined[focus] .smart-action-button,
.smart-drop-down-box.underlined[focus] input {
    border-color: transparent !important
}

.smart-drop-down-box.underlined[focus] .smart-drop-down-button,
.smart-drop-down-box.underlined[focus] .smart-hint {
    border-color: transparent !important;
    color: #005c99 !important;
    color: var(--smart-primary) !important;
    opacity: 1
}

.smart-drop-down-box.underlined:not([opened]):not([hover]) .smart-drop-down-button,
.smart-drop-down-box.underlined[opened] .smart-action-button {
    background-color: transparent;
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-drop-down-box.underlined[drop-down-open-mode=dropDownButton][hover]:not([opened]) .smart-action-button[hover],
.smart-drop-down-box.underlined[hover]:not([opened]) .smart-action-button,
.smart-drop-down-box.underlined[hover]:not([opened]):not([drop-down-open-mode=dropDownButton]) .smart-action-button:not([active]),
.smart-drop-down-box.underlined[opened] .smart-action-button,
.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]) .smart-action-button,
.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]) .smart-drop-down-button,
.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]) .smart-drop-down-button[focus],
.smart-drop-down-box.underlined[right-to-left]:not([hover]) .smart-action-button[focus] {
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent
}

.smart-drop-down-box.underlined[focus] .smart-hint:after {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-drop-down-box.underlined:not([opened]):not([hover]) .smart-drop-down-button:not([hover]),
.smart-drop-down-box.underlined[opened] .smart-action-button {
    border-bottom-left-radius: 0
}

.smart-drop-down-box.underlined:not([opened]) .smart-action-button:not([active]):not([hover]),
.smart-drop-down-box.underlined:not([opened]):not([hover]) .smart-drop-down-button:not([active]):not([hover]) {
    border-radius: 0;
    border-radius: initial
}

.smart-drop-down-box.underlined[hover]:not([drop-down-open-mode=dropDownButton]):not([opened]) .smart-action-button {
    border-bottom-left-radius: 0
}

.smart-drop-down-box.underlined[hover]:not([drop-down-open-mode=dropDownButton]):not([opened]) .smart-action-button:not([active]) {
    background-color: transparent
}

.smart-drop-down-box.underlined[drop-down-open-mode=dropDownButton]:not([drop-down-button-position=left]):not([drop-down-button-position=top]):not([drop-down-button-position=bottom]):not([hover]) .smart-action-button:focus {
    box-shadow: none;
    z-index: auto
}

.smart-drop-down-box.underlined[drop-down-open-mode=dropDownButton][drop-down-button-position=left]:not([hover]) .smart-drop-down-button:focus {
    box-shadow: none
}

.smart-drop-down-box.underlined.smart-invalid .smart-drop-down-button {
    border-bottom-color: rgba(176, 0, 32, .5) !important;
    border-bottom-color: rgba(var(--smart-error-rgb), .5) !important
}

.smart-drop-down-box.underlined[right-to-left]:not([hover]) .smart-action-button[focus] {
    border-bottom-left-radius: 0
}

.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]) .smart-action-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]):not([opened]):not([hover]) .smart-drop-down-button:not([hover]),
.smart-drop-down-box.underlined[right-to-left]:not([drop-down-button-position]):not([opened]):not([hover]) .smart-drop-down-button[focus]:not([hover]) {
    border-bottom-left-radius: 0
}

.smart-drop-down-box.outlined {
    background: 0 0;
    border: none;
    height: auto;
    min-height: 0;
    padding-top: 6px
}

.smart-drop-down-box.outlined>.smart-container>.smart-content {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: auto;
    padding: 4px 3px;
    z-index: 5
}

.smart-drop-down-box.outlined .smart-action-button {
    background: #fefefe !important;
    background: var(--smart-background) !important;
    border: none;
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #5a5a5a !important;
    color: var(--smart-background-color) !important
}

.smart-drop-down-box.outlined .smart-action-button input {
    border: none !important;
    padding: 0;
    z-index: auto
}

.smart-drop-down-box.outlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0
}

.smart-drop-down-box.outlined .smart-spin-button[active],
.smart-drop-down-box.outlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-drop-down-box.outlined .smart-drop-down-button {
    background: #fefefe !important;
    background: var(--smart-background) !important;
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    border-width: 0;
    color: #5a5a5a !important;
    color: var(--smart-background-color) !important;
    padding: 8px 0
}

.smart-drop-down-box.outlined .smart-drop-down-button.smart-calendar-button[active],
.smart-drop-down-box.outlined .smart-drop-down-button.smart-calendar-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-drop-down-box.outlined:not([opened]) .smart-action-button:not([active]),
.smart-drop-down-box.outlined:not([opened]) .smart-drop-down-button,
.smart-drop-down-box.outlined[drop-down-open-mode=dropDownButton]:not([hover]) .smart-action-button:not([active]),
.smart-drop-down-box.outlined[focus],
.smart-drop-down-box.outlined[hover]:not([opened]):not([drop-down-open-mode=dropDownButton]) .smart-action-button:not([active]) {
    background-color: transparent
}

.smart-drop-down-box.outlined.smart-element-init .smart-hint {
    display: none !important;
    visibility: hidden
}

.smart-drop-down-box.outlined:not([focus])[hint] .smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 48px;
    opacity: 0
}

.smart-drop-down-box.outlined[hint] .smart-hint {
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: text;
    display: flex !important;
    font-size: 75%;
    left: 0;
    line-height: 15px;
    margin-top: -6px;
    max-height: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    transition: color .2s, font-size .2s, opacity .1s, font-size .2s, line-height .2s;
    width: 100%;
    z-index: 10
}

.smart-drop-down-box.outlined[hint] .smart-hint:after,
.smart-drop-down-box.outlined[hint] .smart-hint:before {
    border-top: 1px solid;
    border-top-color: #e0e0e0 !important;
    border-top-color: var(--smart-border) !important;
    box-shadow: inset 0 1px transparent;
    box-sizing: border-box;
    content: "";
    display: block;
    height: 8px;
    margin-top: 6px;
    min-width: 10px;
    pointer-events: none;
    transition: border-color .2s, box-shadow .2s
}

.smart-drop-down-box.outlined[hint] .smart-hint:before {
    border-left: 1px solid transparent;
    border-radius: 4px 0;
    margin-right: 4px
}

.smart-drop-down-box.outlined[hint] .smart-hint:after {
    border-radius: 0 4px;
    border-right: 1px solid transparent;
    flex-grow: 1;
    margin-left: 4px
}

.smart-drop-down-box[right-to-left]:not([drop-down-button-position])>.smart-container>.smart-content,
.smart-drop-down-box[right-to-left][drop-down-button-position=left] .smart-action-button,
.smart-drop-down-box[right-to-left][drop-down-button-position=left]>.smart-container>.smart-content {
    flex-direction: row
}

.smart-drop-down-box.outlined[focus]>.smart-container>.smart-content {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-drop-down-box.outlined[focus] .smart-drop-down-button {
    color: #005c99 !important;
    color: var(--smart-ui-state-active) !important
}

.smart-drop-down-box.outlined[focus][hint]>.smart-container>.smart-content {
    border-top-color: transparent !important
}

.smart-drop-down-box.outlined[focus][hint] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-drop-down-box.outlined[focus][hint] .smart-hint:after,
.smart-drop-down-box.outlined[focus][hint] .smart-hint:before {
    border-top-color: #005c99 !important;
    border-top-color: var(--smart-primary) !important
}

.smart-drop-down-box.outlined.smart-invalid>.smart-container>.smart-content {
    border-color: rgba(176, 0, 32, .5);
    border-color: rgba(var(--smart-error-rgb), .5)
}

.smart-drop-down-box:not([placeholder])[dropDownButtonPosition=none] .smart-drop-down-button,
.smart-drop-down-box[placeholder=""][dropDownButtonPosition=none] .smart-drop-down-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-left-style: solid;
    border-left-width: 1px;
    border-left-width: var(--smart-border-width);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-drop-down-box:not([placeholder]):not([opened])[dropDownButtonPosition=none] .smart-drop-down-button:not([focus]),
.smart-drop-down-box[placeholder=""]:not([opened])[dropDownButtonPosition=none] .smart-drop-down-button:not([focus]) {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.smart-drop-down-box:not([animation=none]) .smart-drop-down-button .smart-drop-down-button-icon:after {
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s
}

.smart-drop-down-box[drop-down-position=overlay-center] .smart-drop-down-button .smart-drop-down-button-icon:after {
    content: "\\e804";
    content: var(--smart-icon-minus)
}

.smart-drop-down-box.smart-invalid:not([drop-down-open-mode=dropDownButton]) .smart-action-button {
    border-bottom-color: rgba(176, 0, 32, .5) !important;
    border-bottom-color: rgba(var(--smart-error-rgb), .5) !important
}

.smart-drop-down-box[right-to-left],
.smart-drop-down-box[right-to-left] .smart-hint,
.smart-drop-down-box[right-to-left] .smart-label {
    direction: rtl
}

.smart-drop-down-box[right-to-left] .smart-drop-down-button:focus,
.smart-drop-down-box[right-to-left]:not([hover]) .smart-action-button[focus],
.smart-drop-down-box[right-to-left]:not([hover]) .smart-drop-down-button[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down-box[right-to-left][drop-down-button-position=right]>.smart-container>.smart-content {
    flex-direction: row-reverse
}

.smart-drop-down-box[right-to-left]:not([drop-down-button-position]) .smart-action-button,
.smart-drop-down-box[right-to-left][drop-down-button-position=left] .smart-action-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    padding: 0 4px 0 0;
    padding: 0 var(--smart-editor-label-padding) 0 0
}

.smart-drop-down-box[right-to-left]:not([drop-down-button-position]) .smart-drop-down-button,
.smart-drop-down-box[right-to-left][drop-down-button-position=left] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.smart-drop-down.smart-drop-down-container,
.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned {
    flex-direction: column;
    height: 400px;
    height: var(--smart-editor-drop-down-height);
    min-height: 50px;
    min-height: var(--smart-editor-drop-down-min-height)
}

.smart-drop-down-box[right-to-left]:not([drop-down-button-position]) .smart-action-button,
.smart-drop-down-box[right-to-left]:not([drop-down-open-mode=dropDownButton])[drop-down-button-position=left] .smart-action-button {
    border-left: initial
}

.smart-drop-down-box[right-to-left]:not([drop-down-open-mode=dropDownButton]):not([drop-down-button-position]) .smart-drop-down-button,
.smart-drop-down-box[right-to-left][drop-down-button-position=left] .smart-drop-down-button {
    border-right: initial
}

.smart-drop-down-box[right-to-left][opened] .smart-action-button,
.smart-drop-down-box[right-to-left][opened] .smart-drop-down-button {
    border-color: var(--smart-border-active)
}

.smart-drop-down-box[right-to-left][drop-down-open-mode=dropDownButton]:not([drop-down-button-position]):not([hover]) .smart-action-button:focus,
.smart-drop-down-box[right-to-left][drop-down-open-mode=dropDownButton][drop-down-button-position=right]:not([hover]) .smart-action-button:focus {
    box-shadow: -1px 0 0 0 #b2b2b2;
    box-shadow: calc(var(--smart-border-width)*-1) 0 0 0 var(--smart-outline)
}

.smart-drop-down.smart-drop-down-container {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    box-sizing: border-box;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + var(--smart-editor-drop-down-padding-size)) 0;
    max-height: 400px;
    max-height: var(--smart-editor-drop-down-max-height);
    max-width: 800px;
    max-width: var(--smart-editor-drop-down-max-width);
    min-width: 100px;
    min-width: var(--smart-editor-drop-down-min-width);
    outline: 0;
    padding: 3px 0 !important;
    padding: var(--smart-editor-drop-down-padding-size) 0 !important;
    width: 300px;
    width: var(--smart-editor-drop-down-width)
}

.smart-drop-down.smart-drop-down-container smart-list-box:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-drop-down.smart-date-time-drop-down.smart-drop-down-repositioned,
.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-sizing: border-box;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    max-height: 400px;
    max-height: var(--smart-editor-drop-down-max-height);
    max-width: 800px;
    max-width: var(--smart-editor-drop-down-max-width);
    min-width: 100px;
    min-width: var(--smart-editor-drop-down-min-width);
    outline: 0;
    padding: 3px 0 !important;
    padding: var(--smart-editor-drop-down-padding-size) 0 !important
}

.smart-drop-down.smart-drop-down-container .smart-drop-down-resize-bar {
    height: 12.5px;
    height: calc(var(--smart-editor-drop-down-resize-bar-height) - 2.5px);
    margin-top: 2.5px;
    position: relative;
    touch-action: none;
    width: 100%
}

.smart-drop-down.smart-drop-down-container.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned.smart-visibility-hidden {
    left: 0;
    top: 0
}

.smart-drop-down.smart-drop-down-container.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned {
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + var(--smart-editor-drop-down-padding-size)) 0;
    width: 300px;
    width: var(--smart-editor-drop-down-width)
}

.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned[center-top],
.smart-drop-down.smart-drop-down-container.smart-drop-down-repositioned[top] {
    margin: -8px 0;
    margin: calc((var(--smart-editor-drop-down-vertical-offset) + 3px)*-1) 0
}

.smart-drop-down.smart-date-time-drop-down,
.smart-drop-down.smart-date-time-drop-down.smart-drop-down-repositioned {
    height: 400px;
    height: var(--smart-editor-drop-down-height);
    width: 300px;
    width: var(--smart-editor-drop-down-width)
}

.smart-drop-down.smart-date-time-drop-down.smart-drop-down-repositioned {
    flex-direction: column;
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + var(--smart-editor-drop-down-padding-size)) 0;
    min-height: 50px;
    min-height: var(--smart-editor-drop-down-min-height)
}

.smart-drop-down.smart-date-time-drop-down[drop-down-display-mode=calendar] {
    height: 340px !important;
    height: calc(var(--smart-editor-drop-down-height) - var(--smart-calendar-title-height)) !important
}

.smart-drop-down.smart-drop-down-color-picker.smart-drop-down-repositioned {
    max-height: 450px;
    max-height: calc(var(--smart-editor-drop-down-max-height) + 50px)
}

.smart-drop-down[top] .smart-drop-down-resize-bar {
    margin-bottom: 2.5px;
    margin-top: 0
}

.smart-drop-down[top].smart-drop-down-container.smart-drop-down-repositioned,
.smart-drop-down[top].smart-drop-down-container.smart-drop-down-repositioned.smart-visibility-hidden {
    bottom: calc(100% - 1px);
    bottom: calc(100% - var(--smart-border-width));
    flex-direction: column-reverse;
    top: auto
}

.smart-drop-down[overlay-bottom],
.smart-drop-down[overlay-center],
.smart-drop-down[overlay-top] {
    margin: unset
}

.smart-drop-down:not([resize-mode=none]) smart-list-box {
    border: none;
    height: calc(100% - 15px);
    height: calc(100% - var(--smart-editor-drop-down-resize-bar-height));
    position: relative;
    width: 100%
}

.smart-drop-down:not([resize-mode=none]) .smart-drop-down-resize-bar {
    border-top: 1px solid #e0e0e0;
    border-top: 1px solid var(--smart-border)
}

.smart-drop-down:not([resize-mode=none])[top] .smart-drop-down-resize-bar {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-top: initial
}

.smart-drop-down[resize-mode][top] .smart-drop-down-resize-bar>div {
    top: calc(50% - 1px)
}

.smart-drop-down[resize-mode=none] smart-list-box {
    border: none;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-drop-down[resize-mode=none] .smart-drop-down-resize-bar {
    cursor: default;
    display: none
}

.smart-drop-down[resize-mode=none] .smart-drop-down-resize-bar>div {
    display: none
}

.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar>div,
.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar>div {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 50%;
    display: inline;
    display: initial;
    height: 5px;
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: calc(50% + 1px);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 5px
}

.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar>div:after,
.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar>div:before,
.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar>div:after,
.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar>div:before {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 50%;
    content: "";
    height: 100%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%
}

.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar>div:after,
.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar>div:after {
    left: 500%
}

.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar>div:before,
.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar>div:before {
    left: -400%
}

.smart-drop-down[resize-mode=both].smart-drop-down-container.smart-drop-down-repositioned .smart-drop-down-resize-bar>div,
.smart-drop-down[resize-mode=vertical].smart-drop-down-container.smart-drop-down-repositioned .smart-drop-down-resize-bar>div {
    height: 3px;
    width: 3px
}

.smart-drop-down[resize-mode=both][resize-indicator] .smart-drop-down-resize-bar:before,
.smart-drop-down[resize-mode=horizontal][resize-indicator] .smart-drop-down-resize-bar:before {
    content: "\\e80f";
    content: var(--smart-icon-resize-horizontal);
    cursor: se-resize;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    height: 5px;
    left: calc(100% - 8px);
    position: absolute;
    top: calc(100% - 8px);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    width: 8px
}

.smart-drop-down[resize-mode=both][resize-indicator] .smart-drop-down-resize-bar:after,
.smart-drop-down[resize-mode=horizontal][resize-indicator] .smart-drop-down-resize-bar:after {
    content: "\\e81c";
    content: var(--smart-icon-resize-full);
    cursor: e-resize;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    height: 12px;
    left: calc(100% - 7px);
    position: absolute;
    top: calc(100% - 12px);
    -webkit-transform: rotate(-45deg) scaleX(2.25);
    transform: rotate(-45deg) scaleX(2.25);
    width: 8px
}

.smart-color-picker .smart-drop-down,
.smart-combo-box .smart-drop-down,
.smart-date-time-picker .smart-drop-down,
.smart-drop-down-button .smart-drop-down,
.smart-drop-down-container.smart-drop-down-repositioned,
.smart-drop-down-list .smart-drop-down,
.smart-multi-split-button .smart-drop-down,
.smart-path .smart-drop-down,
.smart-text-box .smart-drop-down {
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 400px;
    height: var(--smart-editor-drop-down-height);
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + var(--smart-editor-drop-down-padding-size)) 0;
    max-height: 400px;
    max-height: var(--smart-editor-drop-down-max-height);
    max-width: 800px;
    max-width: var(--smart-editor-drop-down-max-width);
    min-height: 50px;
    min-height: var(--smart-editor-drop-down-min-height);
    min-width: 100px;
    min-width: var(--smart-editor-drop-down-min-width);
    outline: 0;
    padding: 3px 0 !important;
    padding: var(--smart-editor-drop-down-padding-size) 0 !important;
    width: 300px;
    width: var(--smart-editor-drop-down-width)
}

.smart-drop-down[resize-mode=both][top] .smart-drop-down-resize-bar:before,
.smart-drop-down[resize-mode=horizontal][top] .smart-drop-down-resize-bar:before {
    left: calc(100% - 4px);
    top: calc(100% - 13px);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg)
}

.smart-drop-down[resize-mode=vertical] .smart-drop-down-resize-bar {
    cursor: n-resize
}

.smart-drop-down[resize-mode=horizontal] .smart-drop-down-resize-bar {
    cursor: e-resize
}

.smart-drop-down[resize-mode=horizontal] .smart-drop-down-resize-bar>div {
    display: none
}

.smart-drop-down[resize-mode=both] .smart-drop-down-resize-bar {
    cursor: nwse-resize
}

.smart-drop-down[resize-mode=both][top] .smart-drop-down-resize-bar {
    cursor: sw-resize
}

.smart-drop-down-container.smart-drop-down-repositioned {
    background-color: #fefefe;
    background-color: var(--smart-background);
    box-sizing: border-box;
    display: flex;
    flex-direction: column
}

.smart-drop-down-container.smart-drop-down-repositioned.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-drop-down-container.smart-drop-down-repositioned:focus {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.smart-drop-down-container.smart-drop-down-repositioned[overlay-bottom],
.smart-drop-down-container.smart-drop-down-repositioned[overlay-center],
.smart-drop-down-container.smart-drop-down-repositioned[overlay-top] {
    margin: unset
}

.smart-drop-down-container.smart-drop-down-repositioned[overlay-bottom]:not([animation=none]),
.smart-drop-down-container.smart-drop-down-repositioned[overlay-center]:not([animation=none]),
.smart-drop-down-container.smart-drop-down-repositioned[overlay-top]:not([animation=none]) {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-drop-down-container.smart-drop-down-repositioned[overlay-bottom]:not([animation=none]).smart-visibility-hidden,
.smart-drop-down-container.smart-drop-down-repositioned[overlay-center]:not([animation=none]).smart-visibility-hidden,
.smart-drop-down-container.smart-drop-down-repositioned[overlay-top]:not([animation=none]).smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-drop-down-container.smart-drop-down-repositioned[center-top],
.smart-drop-down-container.smart-drop-down-repositioned[top] {
    margin: -8px 0;
    margin: calc((var(--smart-editor-drop-down-vertical-offset) + 3px)*-1) 0
}

.smart-drop-down-container.smart-drop-down-repositioned[center-top]:not([animation=none]),
.smart-drop-down-container.smart-drop-down-repositioned[top]:not([animation=none]) {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-drop-down-container.smart-drop-down-repositioned[center-top]:not([animation=none]).smart-visibility-hidden,
.smart-drop-down-container.smart-drop-down-repositioned[top]:not([animation=none]).smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-drop-down-container.smart-drop-down-repositioned[bottom]:not([animation=none]),
.smart-drop-down-container.smart-drop-down-repositioned[center-bottom]:not([animation=none]) {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-drop-down-container.smart-drop-down-repositioned[bottom]:not([animation=none]).smart-visibility-hidden,
.smart-drop-down-container.smart-drop-down-repositioned[center-bottom]:not([animation=none]).smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-drop-down-container.smart-drop-down-repositioned:not([animation=none]).smart-visibility-hidden {
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-drop-down-container[top].smart-drop-down-container.smart-drop-down-repositioned {
    bottom: auto
}

.smart-drop-down-container[top].smart-drop-down-container.smart-drop-down-repositioned.smart-visibility-hidden {
    bottom: calc(100% - 1px);
    bottom: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down,
.smart-combo-box .smart-drop-down,
.smart-date-time-picker .smart-drop-down,
.smart-drop-down-button .smart-drop-down,
.smart-drop-down-list .smart-drop-down,
.smart-multi-split-button .smart-drop-down,
.smart-path .smart-drop-down,
.smart-text-box .smart-drop-down {
    background-color: #fefefe;
    background-color: var(--smart-background);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    top: calc(100% - 1px);
    top: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down.smart-visibility-hidden,
.smart-combo-box .smart-drop-down.smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down.smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down.smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down.smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down.smart-visibility-hidden,
.smart-path .smart-drop-down.smart-visibility-hidden,
.smart-text-box .smart-drop-down.smart-visibility-hidden {
    top: calc(100% - 1px);
    top: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-combo-box .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-date-time-picker .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-drop-down-button .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-drop-down-list .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-multi-split-button .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-path .smart-drop-down.smart-visibility-hidden.not-in-view,
.smart-text-box .smart-drop-down.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-color-picker .smart-drop-down[overlay-bottom],
.smart-color-picker .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[overlay-bottom],
.smart-combo-box .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[overlay-bottom],
.smart-date-time-picker .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[overlay-bottom],
.smart-drop-down-button .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[overlay-bottom],
.smart-drop-down-list .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[overlay-bottom],
.smart-multi-split-button .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-path .smart-drop-down[overlay-bottom],
.smart-path .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-text-box .smart-drop-down[overlay-bottom],
.smart-text-box .smart-drop-down[overlay-bottom].smart-visibility-hidden {
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    top: 0
}

.smart-color-picker .smart-drop-down[overlay-center],
.smart-color-picker .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[overlay-center],
.smart-combo-box .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[overlay-center],
.smart-date-time-picker .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[overlay-center],
.smart-drop-down-button .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[overlay-center],
.smart-drop-down-list .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[overlay-center],
.smart-multi-split-button .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-path .smart-drop-down[overlay-center],
.smart-path .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-text-box .smart-drop-down[overlay-center],
.smart-text-box .smart-drop-down[overlay-center].smart-visibility-hidden {
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-color-picker .smart-drop-down[overlay-top],
.smart-color-picker .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[overlay-top],
.smart-combo-box .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[overlay-top],
.smart-date-time-picker .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[overlay-top],
.smart-drop-down-button .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[overlay-top],
.smart-drop-down-list .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[overlay-top],
.smart-multi-split-button .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-path .smart-drop-down[overlay-top],
.smart-path .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-text-box .smart-drop-down[overlay-top],
.smart-text-box .smart-drop-down[overlay-top].smart-visibility-hidden {
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    bottom: 0;
    top: auto
}

.smart-color-picker .smart-drop-down[top],
.smart-color-picker .smart-drop-down[top].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[top],
.smart-combo-box .smart-drop-down[top].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[top],
.smart-date-time-picker .smart-drop-down[top].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[top],
.smart-drop-down-button .smart-drop-down[top].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[top],
.smart-drop-down-list .smart-drop-down[top].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[top],
.smart-multi-split-button .smart-drop-down[top].smart-visibility-hidden,
.smart-path .smart-drop-down[top],
.smart-path .smart-drop-down[top].smart-visibility-hidden,
.smart-text-box .smart-drop-down[top],
.smart-text-box .smart-drop-down[top].smart-visibility-hidden {
    bottom: calc(100% - 1px);
    bottom: calc(100% - var(--smart-border-width));
    flex-direction: column-reverse;
    top: auto
}

.smart-color-picker .smart-drop-down[bottom],
.smart-combo-box .smart-drop-down[bottom],
.smart-date-time-picker .smart-drop-down[bottom],
.smart-drop-down-button .smart-drop-down[bottom],
.smart-drop-down-list .smart-drop-down[bottom],
.smart-multi-split-button .smart-drop-down[bottom],
.smart-path .smart-drop-down[bottom],
.smart-text-box .smart-drop-down[bottom] {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    box-sizing: border-box;
    cursor: default;
    display: flex;
    flex-direction: column;
    font-size: inherit;
    left: 0;
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + var(--smart-editor-drop-down-padding-size)) 0;
    padding: 3px;
    padding: var(--smart-editor-drop-down-padding-size);
    padding-left: 0;
    top: calc(100% - 1px);
    top: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical],
.smart-combo-box .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical],
.smart-drop-down-button .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical],
.smart-drop-down-list .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical],
.smart-multi-split-button .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical],
.smart-text-box .smart-drop-down .smart-list-items-container.vscroll[orientation=vertical] {
    padding-top: 0
}

.smart-color-picker .smart-drop-down[bottom].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[bottom].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[bottom].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[bottom].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[bottom].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[bottom].smart-visibility-hidden,
.smart-path .smart-drop-down[bottom].smart-visibility-hidden,
.smart-text-box .smart-drop-down[bottom].smart-visibility-hidden {
    top: calc(100% - 1px);
    top: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down[center-bottom],
.smart-color-picker .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[center-bottom],
.smart-combo-box .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[center-bottom],
.smart-date-time-picker .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[center-bottom],
.smart-drop-down-button .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[center-bottom],
.smart-drop-down-list .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[center-bottom],
.smart-multi-split-button .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-path .smart-drop-down[center-bottom],
.smart-path .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-text-box .smart-drop-down[center-bottom],
.smart-text-box .smart-drop-down[center-bottom].smart-visibility-hidden {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    left: 50%;
    top: calc(100% - 1px);
    top: calc(100% - var(--smart-border-width))
}

.smart-color-picker .smart-drop-down[center-top],
.smart-color-picker .smart-drop-down[center-top].smart-visibility-hidden,
.smart-combo-box .smart-drop-down[center-top],
.smart-combo-box .smart-drop-down[center-top].smart-visibility-hidden,
.smart-date-time-picker .smart-drop-down[center-top],
.smart-date-time-picker .smart-drop-down[center-top].smart-visibility-hidden,
.smart-drop-down-button .smart-drop-down[center-top],
.smart-drop-down-button .smart-drop-down[center-top].smart-visibility-hidden,
.smart-drop-down-list .smart-drop-down[center-top],
.smart-drop-down-list .smart-drop-down[center-top].smart-visibility-hidden,
.smart-multi-split-button .smart-drop-down[center-top],
.smart-multi-split-button .smart-drop-down[center-top].smart-visibility-hidden,
.smart-path .smart-drop-down[center-top],
.smart-path .smart-drop-down[center-top].smart-visibility-hidden,
.smart-text-box .smart-drop-down[center-top],
.smart-text-box .smart-drop-down[center-top].smart-visibility-hidden {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    bottom: calc(100% - 1px);
    bottom: calc(100% - var(--smart-border-width));
    left: 50%;
    top: auto
}

.smart-color-picker:not([animation=none]) .smart-drop-down,
.smart-combo-box:not([animation=none]) .smart-drop-down,
.smart-date-time-picker:not([animation=none]) .smart-drop-down,
.smart-drop-down-button:not([animation=none]) .smart-drop-down,
.smart-drop-down-list:not([animation=none]) .smart-drop-down,
.smart-multi-split-button:not([animation=none]) .smart-drop-down,
.smart-path:not([animation=none]) .smart-drop-down,
.smart-text-box:not([animation=none]) .smart-drop-down {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-color-picker:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down.smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down.smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: visibility .2s ease-in, -webkit-animation;
    transition: animation, visibility .2s ease-in;
    transition: animation, visibility .2s ease-in, -webkit-animation
}

.smart-color-picker:not([animation=none]) .smart-drop-down[bottom],
.smart-color-picker:not([animation=none]) .smart-drop-down[center-bottom],
.smart-combo-box:not([animation=none]) .smart-drop-down[bottom],
.smart-combo-box:not([animation=none]) .smart-drop-down[center-bottom],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[bottom],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[center-bottom],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[bottom],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[center-bottom],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[bottom],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[center-bottom],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[bottom],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[center-bottom],
.smart-path:not([animation=none]) .smart-drop-down[bottom],
.smart-path:not([animation=none]) .smart-drop-down[center-bottom],
.smart-text-box:not([animation=none]) .smart-drop-down[bottom],
.smart-text-box:not([animation=none]) .smart-drop-down[center-bottom] {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-color-picker:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-color-picker:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[bottom].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[center-bottom].smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-color-picker:not([animation=none]) .smart-drop-down[center-top],
.smart-color-picker:not([animation=none]) .smart-drop-down[top],
.smart-combo-box:not([animation=none]) .smart-drop-down[center-top],
.smart-combo-box:not([animation=none]) .smart-drop-down[top],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[center-top],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[top],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[center-top],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[top],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[center-top],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[top],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[center-top],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[top],
.smart-path:not([animation=none]) .smart-drop-down[center-top],
.smart-path:not([animation=none]) .smart-drop-down[top],
.smart-text-box:not([animation=none]) .smart-drop-down[center-top],
.smart-text-box:not([animation=none]) .smart-drop-down[top] {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-color-picker:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-color-picker:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[center-top].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[top].smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-top],
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-top],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-top],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-top],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-top],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-top],
.smart-path:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-path:not([animation=none]) .smart-drop-down[overlay-top],
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-bottom],
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-top] {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-bottom].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-top].smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-center],
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-center],
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-center],
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-center],
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-center],
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-center],
.smart-path:not([animation=none]) .smart-drop-down[overlay-center],
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-center] {
    -webkit-animation: smart-drop-down-list-smart-animate-overlay-center-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-overlay-center-opening .2s ease-out;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-color-picker:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-combo-box:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-date-time-picker:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-drop-down-button:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-drop-down-list:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-multi-split-button:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-path:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden,
.smart-text-box:not([animation=none]) .smart-drop-down[overlay-center].smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-overlay-center-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-overlay-center-closing .2s ease-in;
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-drop-down-button .smart-drop-down,
.smart-drop-down-list .smart-drop-down,
.smart-multi-split-button .smart-drop-down,
.smart-text-box .smart-drop-down {
    height: 18px;
    height: calc(var(--smart-scroll-bar-size))
}

.smart-drop-down-button .smart-drop-down smart-scroll-bar:before,
.smart-drop-down-list .smart-drop-down smart-scroll-bar:before,
.smart-multi-split-button .smart-drop-down smart-scroll-bar:before,
.smart-text-box .smart-drop-down smart-scroll-bar:before {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    display: none
}

.smart-drop-down-button .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner,
.smart-drop-down-list .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner,
.smart-multi-split-button .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner,
.smart-text-box .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-drop-down-button .smart-drop-down .smart-list-items-container.vscroll,
.smart-drop-down-button .smart-drop-down smart-scroll-bar.bottom-corner,
.smart-drop-down-list .smart-drop-down .smart-list-items-container.vscroll,
.smart-drop-down-list .smart-drop-down smart-scroll-bar.bottom-corner,
.smart-multi-split-button .smart-drop-down .smart-list-items-container.vscroll,
.smart-multi-split-button .smart-drop-down smart-scroll-bar.bottom-corner,
.smart-text-box .smart-drop-down .smart-list-items-container.vscroll,
.smart-text-box .smart-drop-down smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-drop-down-button .smart-drop-down input:focus,
.smart-drop-down-list .smart-drop-down input:focus,
.smart-multi-split-button .smart-drop-down input:focus,
.smart-text-box .smart-drop-down input:focus {
    outline: 0
}

.smart-drop-down-button.auto-height .smart-action-button,
.smart-drop-down-list.auto-height .smart-action-button,
.smart-multi-split-button.auto-height .smart-action-button {
    flex-wrap: wrap;
    line-height: 1rem;
    text-overflow: clip;
    white-space: normal
}

.smart-drop-down-button.auto-height[selection-display-mode=tokens] .smart-action-button>span:first-of-type,
.smart-drop-down-button.auto-height[selection-display-mode=tokens] smart-action-button>span,
.smart-drop-down-list.auto-height[selection-display-mode=tokens] .smart-action-button>span:first-of-type,
.smart-drop-down-list.auto-height[selection-display-mode=tokens] smart-action-button>span,
.smart-multi-split-button.auto-height[selection-display-mode=tokens] .smart-action-button>span:first-of-type,
.smart-multi-split-button.auto-height[selection-display-mode=tokens] smart-action-button>span {
    display: inline-block;
    margin: .2em
}

.smart-color-picker .smart-drop-down smart-scroll-bar:before,
.smart-combo-box .smart-drop-down smart-scroll-bar:before,
.smart-list-box smart-scroll-bar:before,
.smart-scroll-viewer smart-scroll-bar:before {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    display: none
}

.smart-color-picker .smart-drop-down {
    height: 400px;
    height: var(--smart-drop-down-button-drop-down-height);
    width: 300px;
    width: var(--smart-drop-down-button-drop-down-width)
}

.smart-color-picker .smart-drop-down.smart-drop-down-color-picker {
    max-height: 450px;
    max-height: calc(var(--smart-editor-drop-down-max-height) + 50px)
}

.smart-color-picker .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-color-picker .smart-drop-down .smart-list-items-container.vscroll {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-drop-down-list .smart-drop-down {
    height: auto;
    height: var(--smart-drop-down-list-drop-down-height);
    width: auto;
    width: var(--smart-drop-down-list-drop-down-width)
}

.smart-combo-box .smart-drop-down {
    height: auto;
    height: var(--smart-combo-box-drop-down-height);
    width: auto;
    width: var(--smart-combo-box-drop-down-width)
}

.smart-combo-box .smart-drop-down smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-combo-box .smart-drop-down .smart-list-items-container.vscroll,
.smart-combo-box .smart-drop-down smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-combo-box .smart-selection-field input {
    outline: 0
}

.smart-drop-down-button .smart-drop-down {
    height: 400px;
    height: var(--smart-drop-down-button-drop-down-height);
    width: 300px;
    width: var(--smart-drop-down-button-drop-down-width)
}

.smart-date-time-picker .smart-drop-down {
    border: none
}

.smart-drop-down-overlay {
    left: 0;
    position: absolute;
    top: 0;
    z-index: 9000
}

.smart-list-box input.vscroll {
    outline: 0
}

.smart-list-box smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-list-box .smart-list-items-container.vscroll,
.smart-list-box smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-scroll-viewer {
    border: 0;
    max-width: 100%
}

.smart-scroll-viewer smart-scroll-bar[orientation=vertical].bottom-corner {
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-scroll-viewer .smart-list-items-container.vscroll,
.smart-scroll-viewer smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

@-webkit-keyframes smart-drop-down-list-smart-animate-overlay-center-opening {
    0% {
        opacity: .2;
        -webkit-transform: scaleY(0) translateY(-50%);
        transform: scaleY(0) translateY(-50%)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: 1;
        -webkit-transform: scaleY(1) translateY(-50%);
        transform: scaleY(1) translateY(-50%)
    }
}

@keyframes smart-drop-down-list-smart-animate-overlay-center-opening {
    0% {
        opacity: .2;
        -webkit-transform: scaleY(0) translateY(-50%);
        transform: scaleY(0) translateY(-50%)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: 1;
        -webkit-transform: scaleY(1) translateY(-50%);
        transform: scaleY(1) translateY(-50%)
    }
}

@-webkit-keyframes smart-drop-down-list-smart-animate-overlay-center-closing {
    0% {
        opacity: 1;
        -webkit-transform: scaleY(1) translateY(-50%);
        transform: scaleY(1) translateY(-50%)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: .2;
        -webkit-transform: scaleY(0) translateY(-50%);
        transform: scaleY(0) translateY(-50%)
    }
}

@keyframes smart-drop-down-list-smart-animate-overlay-center-closing {
    0% {
        opacity: 1;
        -webkit-transform: scaleY(1) translateY(-50%);
        transform: scaleY(1) translateY(-50%)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: .2;
        -webkit-transform: scaleY(0) translateY(-50%);
        transform: scaleY(0) translateY(-50%)
    }
}

@-webkit-keyframes smart-drop-down-list-smart-animate-opening {
    0% {
        opacity: .2;
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: 1;
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }
}

@keyframes smart-drop-down-list-smart-animate-opening {
    0% {
        opacity: .2;
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }

    50% {
        opacity: .4
    }

    to {
        opacity: 1;
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }
}

@-webkit-keyframes smart-drop-down-list-smart-animate-closing {
    0% {
        opacity: 1;
        pointer-events: none;
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    50% {
        opacity: .4;
        pointer-events: none
    }

    to {
        opacity: .2;
        pointer-events: none;
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

@keyframes smart-drop-down-list-smart-animate-closing {
    0% {
        opacity: 1;
        pointer-events: none;
        -webkit-transform: scaleY(1);
        transform: scaleY(1)
    }

    50% {
        opacity: .4;
        pointer-events: none
    }

    to {
        opacity: .2;
        pointer-events: none;
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }
}

.smart-editor-drop-down-toolbar .smart-table-picker[right-to-left] .smart-table-picker-grid,
.smart-editor[right-to-left] .smart-editor-content-container,
.smart-editor[right-to-left] .smart-editor-toolbar-item[item-type=color-input],
.smart-editor[right-to-left] .smart-editor-toolbar-item[item-type=drop-down],
.smart-editor[right-to-left] .smart-editor-toolbar-items-primary,
.smart-editor[right-to-left] .smart-editor-toolbar-items-secondary {
    direction: rtl
}

.smart-editor .smart-editor-content-container .smart-editor-editable,
.smart-editor .smart-editor-content-container textarea {
    background: 0 0;
    height: 100%;
    outline: 0;
    padding: 15px;
    padding: var(--smart-editor-padding);
    width: 100%
}

.smart-editor-toolbar-item[item-type=button],
.smart-editor-toolbar-item[item-type=color-input],
.smart-editor-toolbar-item[item-type=delimiter],
.smart-editor-toolbar-item[item-type=drop-down],
.smart-editor-toolbar-item[item-type=toggle] {
    height: 30px;
    height: var(--smart-editor-toolbar-item-height);
    outline: 0;
    position: relative
}

.smart-editor-toolbar-item:not([item-type=drop-down]):before,
.smart-editor-toolbar-item[item-name=alignment]:before,
.smart-editor-toolbar-item[item-name=clearformat]:after,
.smart-editor-toolbar-item[item-type=color-input] .smart-editor-item-drop-down-button:before,
.smart-editor-toolbar-item[item-type=delimiter]:before,
.smart-editor-toolbar-item[item-type=drop-down]:after {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 100%;
    justify-content: center;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    pointer-events: none;
    width: 100%
}

.smart-editor-toolbar-item[item-type=color-input] .smart-editor-item-drop-down-button:before,
.smart-editor-toolbar-item[item-type=drop-down]:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-editor-toolbar-item[item-type=drop-down]:before {
    content: attr(item-value);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    overflow: hidden;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    padding-bottom: 0;
    padding-right: 0;
    padding-top: 0;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 30px)
}

.smart-editor .smart-editor-content-container .smart-editor-editable [alignment=left],
.smart-editor .smart-editor-image-container[display=block][alignment=left] .smart-editor-image-caption {
    text-align: left
}

[disabled].smart-editor-toolbar-item {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-editor {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    contain: content;
    display: block;
    height: 600px;
    height: var(--smart-editor-default-height);
    min-height: 100px;
    min-height: var(--smart-editor-input-min-height);
    width: 100%;
    width: var(--smart-editor-default-width)
}

.smart-editor.smart-editor-iframe-body {
    border: initial;
    border-radius: 0;
    border-radius: initial;
    height: 100%;
    margin: initial;
    min-height: 0;
    min-height: auto;
    width: 100%
}

.smart-editor.smart-editor-iframe-body table {
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: inherit;
    font-weight: var(--smart-font-weight)
}

.smart-editor.smart-editor-iframe-body * {
    box-sizing: border-box
}

.smart-editor>.smart-container {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto minmax(0, 1fr);
    min-height: inherit;
    position: relative
}

.smart-editor .smart-toast-container.smart-toast-container-custom {
    height: auto;
    max-height: 100%;
    position: absolute;
    right: 0;
    top: 0
}

.smart-editor.full-screen-mode {
    left: 0 !important;
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
    position: fixed !important;
    right: 0 !important;
    top: 0 !important;
    z-index: 9998;
    z-index: calc(var(--smart-editor-drop-down-z-index) - 1)
}

.smart-editor[readonly] .smart-editor-toolbar-items-primary,
.smart-editor[readonly] .smart-editor-toolbar-items-secondary {
    pointer-events: none
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar[toolbar-tab-selected]:not([expanded]) .smart-editor-toolbar-toggle-button:before {
    content: "\\e80a";
    content: var(--smart-icon-window-pin)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab-selection-bar {
    background-color: #005c99;
    background-color: var(--smart-primary);
    bottom: 0;
    height: 2px;
    height: calc(var(--smart-border-width)*2);
    position: absolute;
    -webkit-transform: scaleX(1);
    transform: scaleX(1)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab-selection-bar.smart-visibility-hidden {
    -webkit-transform: scaleX(0);
    transform: scaleX(0)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-primary {
    position: relative
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar[expanded] .smart-editor-toolbar-items-primary,
.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar[expanded] .smart-editor-toolbar-toggle-button {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar:not(.smart-tooltip) .smart-editor-toolbar-items-secondary .smart-editor-toolbar-item {
    margin-left: 0
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary {
    background-color: #fefefe;
    background-color: var(--smart-background);
    flex-wrap: nowrap;
    padding-bottom: 0
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary.smart-drop-down {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    overflow: hidden
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary .smart-editor-toolbar-item {
    margin-bottom: 5px;
    margin-bottom: var(--smart-editor-toolbar-item-margin)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary .smart-editor-toolbar-item:not(:last-of-type) {
    margin-right: 5px;
    margin-right: var(--smart-editor-toolbar-item-margin)
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab {
    padding: 12px 16px;
    padding: var(--smart-tab-item-padding);
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab:not([disabled]) {
    cursor: pointer
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar .smart-editor-toolbar-tab-group {
    padding-top: 0
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab-group {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    padding: 5px;
    padding: var(--smart-editor-toolbar-item-margin);
    padding-bottom: 0;
    position: relative
}

.smart-editor[hide-toolbar] .smart-editor-toolbar:not(.smart-tooltip),
.smart-editor[toolbar-view-mode=multiRow] .smart-editor-toolbar .smart-editor-toolbar-toggle-button,
.smart-editor[toolbar-view-mode=scroll] .smart-editor-toolbar .smart-editor-toolbar-toggle-button {
    display: none
}

.smart-editor[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-tab-group:not(:first-of-type) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border)
}

.smart-editor[toolbar-view-mode=multiRow] .smart-editor-toolbar,
.smart-editor[toolbar-view-mode=scroll] .smart-editor-toolbar {
    grid-template-areas: "primary primary","secondary secondary "
}

.smart-editor[toolbar-view-mode=multiRow] .smart-editor-toolbar-items-primary,
.smart-editor[toolbar-view-mode=scroll] .smart-editor-toolbar-items-primary {
    padding: 0 5px 5px 0
}

.smart-editor[toolbar-view-mode=multiRow] .smart-editor-toolbar-items-primary .smart-editor-toolbar-item,
.smart-editor[toolbar-view-mode=scroll] .smart-editor-toolbar-items-primary .smart-editor-toolbar-item {
    margin-bottom: 0
}

.smart-editor[toolbar-view-mode=multiRow]>.smart-container {
    grid-template-rows: auto minmax(0, 1fr)
}

.smart-editor[toolbar-view-mode=multiRow] .smart-editor-toolbar .smart-editor-toolbar-items-primary {
    height: auto
}

.smart-editor[toolbar-view-mode=scroll]>.smart-container {
    grid-template-rows: auto minmax(0, 1fr)
}

.smart-editor[toolbar-view-mode=scroll] .smart-editor-toolbar-items-primary {
    overflow-y: auto
}

.smart-editor:not([animation=none]) .smart-editor-toolbar-tab-selection-bar {
    transition: width .2s cubic-bezier(.35, 0, .25, 1), left .2s cubic-bezier(.35, 0, .25, 1), visibility .2s cubic-bezier(.35, 0, .25, 1), -webkit-transform .2s cubic-bezier(.35, 0, .25, 1);
    transition: width .2s cubic-bezier(.35, 0, .25, 1), left .2s cubic-bezier(.35, 0, .25, 1), visibility .2s cubic-bezier(.35, 0, .25, 1), transform .2s cubic-bezier(.35, 0, .25, 1);
    transition: width .2s cubic-bezier(.35, 0, .25, 1), left .2s cubic-bezier(.35, 0, .25, 1), visibility .2s cubic-bezier(.35, 0, .25, 1), transform .2s cubic-bezier(.35, 0, .25, 1), -webkit-transform .2s cubic-bezier(.35, 0, .25, 1)
}

.smart-editor:not([animation=none]) .smart-editor-search-bar,
.smart-editor:not([animation=none])[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out
}

.smart-editor:not([animation=none]) .smart-editor-search-bar.smart-visibility-hidden,
.smart-editor:not([animation=none])[toolbar-mode=singleLineRibbon] .smart-editor-toolbar-items-secondary.smart-visibility-hidden {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in
}

.smart-editor:not([animation=none]) .smart-editor-content-container,
.smart-editor:not([animation=none]) .smart-editor-toolbar:not(.smart-tooltip) {
    transition: height .2s ease-in-out
}

.smart-editor:not([animation=none]) .smart-editor-toolbar-item,
.smart-editor:not([animation=none]) .smart-editor-toolbar-toggle-button {
    transition: background-color 0s linear, border-color 0s ease-in-out, color 0s linear, box-shadow .2s ease-in-out
}

.smart-editor:not([animation=none]) .smart-editor-toolbar-toggle-button:before {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-editor[right-to-left] .smart-editor-toolbar:not(.smart-tooltip) {
    grid-template-areas: "toggleButton primary","secondary secondary";
    grid-template-columns: auto minmax(0, 1fr)
}

.smart-editor[right-to-left] .smart-editor-toolbar:not(.smart-tooltip) .smart-editor-toolbar-item {
    margin-left: 0;
    margin-right: 5px;
    margin-right: var(--smart-editor-toolbar-item-margin)
}

.smart-editor[right-to-left] .smart-editor-resize-frame span {
    -webkit-transform: translate(50%, -50%);
    transform: translate(50%, -50%)
}

.smart-editor[right-to-left] .smart-editor-resize-frame span[position=bottom-right],
.smart-editor[right-to-left] .smart-editor-resize-frame span[position=top-left] {
    cursor: sw-resize
}

.smart-editor[right-to-left] .smart-editor-resize-frame span[position=bottom-left],
.smart-editor[right-to-left] .smart-editor-resize-frame span[position=top-right] {
    cursor: se-resize
}

.smart-editor.preview-mode .smart-editor-toolbar-item:not([item-name=print]):not([item-name=sourcecode]):not([item-name=fullscreen]):not([item-name=splitmode]),
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=alignment],
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=indent],
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=lowercase],
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=outdent],
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=removelink],
.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=uppercase] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-editor[hide-toolbar]>.smart-container {
    grid-template-rows: minmax(auto, 1fr)
}

.smart-editor .smart-editor-toolbar:not(.smart-tooltip) {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    display: grid;
    grid-template-areas: "primary toggleButton","secondary secondary ";
    grid-template-columns: minmax(0, 1fr) auto;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-editor .smart-editor-toolbar:not(.smart-tooltip)[expanded] .smart-editor-toolbar-toggle-button:before {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-editor .smart-editor-toolbar:not(.smart-tooltip) .smart-editor-toolbar-item {
    margin-left: 5px;
    margin-left: var(--smart-editor-toolbar-item-margin);
    margin-top: 5px;
    margin-top: var(--smart-editor-toolbar-item-margin)
}

.smart-editor[toolbar-sticky] .smart-editor-toolbar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 9998;
    z-index: calc(var(--smart-editor-drop-down-z-index) - 1)
}

.smart-editor[edit-mode=markdown] .smart-editor-toolbar-item[item-name=sourcecode]:before {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-editor .smart-editor-toolbar-toggle-button {
    cursor: pointer;
    grid-area: toggleButton;
    height: 40px;
    height: var(--smart-editor-toolbar-height);
    position: relative;
    width: 30px;
    width: var(--smart-editor-toolbar-button-width)
}

.smart-editor .smart-editor-toolbar-toggle-button:before {
    align-items: center;
    box-sizing: border-box;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 100%;
    justify-content: center;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    pointer-events: none;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-editor .smart-editor-toolbar-items-primary {
    grid-area: primary;
    height: 40px;
    height: var(--smart-editor-toolbar-height);
    overflow: hidden
}

.smart-editor .smart-editor-toolbar-items-primary .smart-editor-toolbar-item {
    margin-bottom: 5px;
    margin-bottom: var(--smart-editor-toolbar-item-margin)
}

.smart-editor .smart-editor-toolbar-items-secondary {
    grid-area: secondary;
    padding-bottom: 5px;
    padding-bottom: var(--smart-editor-toolbar-item-margin)
}

.smart-editor .smart-editor-toolbar-items-secondary:empty {
    display: none
}

.smart-editor .smart-editor-toolbar-items-primary,
.smart-editor .smart-editor-toolbar-items-secondary {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    width: 100%
}

.smart-editor iframe {
    border: initial;
    height: 100%;
    min-height: 100px;
    min-height: var(--smart-editor-input-min-height);
    width: 100%
}

.smart-editor .smart-editor-content-container {
    background: 0 0;
    display: grid;
    height: 100%;
    outline: 0;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-editor .smart-editor-content-container[split-mode] {
    grid-column-gap: 2px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);
    grid-template-columns: minmax(0, 1fr) var(--smart-border-width) minmax(0, 1fr);
    grid-template-rows: 100%
}

.smart-editor .smart-editor-content-container[split-mode] .smart-editor-editable {
    order: 1
}

.smart-editor .smart-editor-content-container[split-mode]:before {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    content: "";
    height: 100%;
    order: 2;
    width: 100%
}

.smart-editor .smart-editor-content-container[split-mode] textarea,
.smart-editor[edit-mode=markdown] .smart-editor-content-container[split-mode] .smart-editor-editable {
    order: 3
}

.smart-editor .smart-editor-content-container textarea {
    border: initial;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    min-height: 100px;
    min-height: var(--smart-editor-input-min-height);
    outline: 0;
    resize: none
}

.smart-editor .smart-editor-content-container .smart-editor-editable {
    min-height: 100px;
    min-height: var(--smart-editor-input-min-height);
    overflow: auto
}

.smart-editor .smart-editor-content-container .smart-editor-editable[show-placeholder]:before {
    color: #555;
    color: var(--smart-disabled-color);
    content: attr(placeholder);
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    opacity: .9;
    pointer-events: none;
    position: absolute;
    width: 100%
}

.smart-editor .smart-editor-content-container .smart-editor-editable p:first-child {
    margin-top: 0
}

.smart-editor .smart-editor-content-container .smart-editor-editable p:last-child {
    margin-bottom: 0
}

.smart-editor .smart-editor-content-container .smart-editor-editable a {
    display: inline-block
}

.smart-editor .smart-editor-content-container .smart-editor-editable [alignment=center] {
    text-align: center
}

.smart-editor .smart-editor-content-container .smart-editor-editable [alignment=right] {
    text-align: right
}

.smart-editor .smart-editor-content-container .smart-editor-editable [alignment=justify] {
    text-align: justify
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] {
    cursor: col-resize
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] table {
    overflow: hidden
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] td[resizing],
.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] th[resizing] {
    position: relative
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] td[resizing]:after,
.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=horizontal] th[resizing]:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    content: "";
    display: flex;
    height: 100%;
    position: absolute;
    right: 0;
    -webkit-transform: scaleY(100);
    transform: scaleY(100);
    width: 1px;
    width: var(--smart-border-width)
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=vertical] {
    cursor: row-resize
}

.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=vertical] tr[resizing]>td,
.smart-editor .smart-editor-content-container .smart-editor-editable[table-cell-resize=vertical] tr[resizing]>th {
    border-bottom-color: #005c99;
    border-bottom-color: var(--smart-primary)
}

.smart-editor .smart-editor-content-container .smart-editor-editable[contenteditable=true] img {
    cursor: pointer
}

.smart-editor .smart-editor-content-container .smart-editor-editable font:empty {
    display: inline-block;
    min-height: 1px;
    min-width: 1px
}

.smart-editor .smart-editor-content-container .smart-editor-editable font:empty:before {
    content: "a";
    opacity: 0
}

.smart-editor .smart-editor-content-container .smart-editor-editable pre {
    background: #f5f5f5;
    background: var(--smart-surface);
    padding: 10px
}

.smart-editor .smart-editor-content-container .smart-editor-editable blockquote {
    border-left: 2px solid #e0e0e0;
    border-left: calc(var(--smart-border-width)*2) solid var(--smart-border);
    padding: 20px 10px
}

.smart-editor .smart-editor-content-container .smart-editor-editable .find-and-replace-match {
    background-color: #005c99;
    background-color: var(--smart-editor-highlight);
    color: #fff;
    color: var(--smart-editor-highlight-color);
    opacity: .75
}

.smart-editor .smart-editor-content-container .smart-editor-editable .find-and-replace-match.selected {
    background-color: #005c99;
    background-color: var(--smart-editor-highlight);
    opacity: 1
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe,
.smart-editor .smart-editor-content-container .smart-editor-video-container video,
.smart-editor .smart-editor-content-container img {
    float: none;
    margin: auto;
    min-height: 10px;
    min-width: 10px;
    vertical-align: baseline;
    vertical-align: initial
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe:not([display=block])[alignment=left],
.smart-editor .smart-editor-content-container .smart-editor-video-container video:not([display=block])[alignment=left],
.smart-editor .smart-editor-content-container img:not([display=block])[alignment=left],
.smart-editor .smart-editor-image-container:not([display=block])[alignment=left] {
    float: left
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe[display=block][alignment=left],
.smart-editor .smart-editor-content-container .smart-editor-video-container video[display=block][alignment=left],
.smart-editor .smart-editor-content-container img[display=block][alignment=left],
.smart-editor .smart-editor-image-container[display=block][alignment=left] img {
    margin-left: 0
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe[display=block][alignment=right],
.smart-editor .smart-editor-content-container .smart-editor-video-container video[display=block][alignment=right],
.smart-editor .smart-editor-content-container img[display=block][alignment=right],
.smart-editor .smart-editor-image-container[display=block][alignment=right] img {
    margin-right: 0
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe[display=block],
.smart-editor .smart-editor-content-container .smart-editor-video-container video[display=block],
.smart-editor .smart-editor-content-container img[display=block] {
    display: block
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe[show-resize-frame],
.smart-editor .smart-editor-content-container .smart-editor-video-container video[show-resize-frame],
.smart-editor .smart-editor-content-container img[show-resize-frame] {
    box-shadow: 0 0 0 1px #005c99;
    box-shadow: 0 0 0 var(--smart-border-width) var(--smart-primary)
}

.smart-editor .smart-editor-content-container .smart-editor-video-container iframe:not([display=block])[alignment=right],
.smart-editor .smart-editor-content-container .smart-editor-video-container video:not([display=block])[alignment=right],
.smart-editor .smart-editor-content-container img:not([display=block])[alignment=right] {
    float: right
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar {
    grid-column-gap: 5px;
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    display: grid;
    grid-template-columns: minmax(0, 1fr) repeat(3, auto);
    padding: 5px;
    padding: var(--smart-editor-search-bar-padding);
    position: absolute;
    right: 5px;
    right: var(--smart-editor-search-bar-offset);
    top: 5px;
    top: var(--smart-editor-search-bar-offset)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-input-container {
    align-items: center;
    display: flex;
    width: 250px;
    width: var(--smart-text-box-default-width)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-input-container:after {
    content: attr(selected) ,attr(matches);
    margin: 0 5px;
    margin: 0 var(--smart-editor-search-bar-offset)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-input {
    border: initial;
    height: 100%;
    outline: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-button {
    --smart-button-padding: 0;
    border: initial;
    height: 30px;
    height: var(--smart-editor-toolbar-button-width);
    width: 30px;
    width: var(--smart-editor-toolbar-button-width)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-button button:after {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    pointer-events: none
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-button.prev button:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-button.next button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-editor .smart-editor-content-container .smart-editor-search-bar .smart-search-button.close button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close)
}

.smart-editor[show-char-count] .smart-editor-content-container:after {
    background: #fefefe;
    background: var(--smart-background);
    background-clip: content-box;
    -webkit-background-clip: content-box;
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    bottom: 30px;
    bottom: var(--smart-editor-char-counter-offset);
    box-sizing: border-box;
    content: attr(char-count);
    display: flex;
    font-family: inherit;
    font-size: inherit;
    justify-content: flex-end;
    pointer-events: none;
    position: absolute;
    right: 30px;
    right: var(--smart-editor-char-counter-offset);
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-editor[show-char-count] .smart-editor-content-container.char-count-error:after {
    color: #b00020;
    color: var(--smart-error)
}

.smart-editor[show-char-count] .smart-editor-content-container.char-count-warning:after {
    color: #f0ad4e;
    color: var(--smart-warning)
}

.smart-editor[edit-mode=markdown] .smart-editor-content-container[split-mode] textarea {
    order: 1
}

.smart-editor .smart-editor-resize-frame {
    position: absolute;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-editor .smart-editor-resize-frame span {
    background: #005c99;
    background: var(--smart-primary);
    cursor: pointer;
    height: 10px;
    position: absolute;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 10px
}

.smart-editor .smart-editor-resize-frame span[position=bottom-right],
.smart-editor .smart-editor-resize-frame span[position=top-left] {
    cursor: se-resize
}

.smart-editor .smart-editor-resize-frame span[position=bottom-left],
.smart-editor .smart-editor-resize-frame span[position=top-right] {
    cursor: sw-resize
}

.smart-editor .smart-editor-resize-frame span[position=bottom-center],
.smart-editor .smart-editor-resize-frame span[position=top-center] {
    cursor: ns-resize
}

.smart-editor .smart-editor-resize-frame span[position=left-center],
.smart-editor .smart-editor-resize-frame span[position=right-center] {
    cursor: ew-resize
}

.smart-editor .smart-editor-image-container {
    display: inline-block
}

.smart-editor .smart-editor-image-container.smart-editor-video-container {
    position: relative
}

.smart-editor .smart-editor-image-container.smart-editor-video-container .smart-editor-video-white-space {
    opacity: 0;
    position: absolute
}

.smart-editor .smart-editor-image-container.smart-editor-video-container[dragged]:before {
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-editor .smart-editor-image-container.smart-editor-video-container iframe,
.smart-editor .smart-editor-image-container.smart-editor-video-container video {
    height: 100%;
    width: 100%
}

.smart-editor .smart-editor-image-container.smart-editor-video-container>br[class] {
    display: none
}

.smart-editor .smart-editor-image-container.smart-editor-video-container:after {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border-radius: 50%;
    content: "\\f0c9";
    content: var(--smart-icon-menu);
    display: inline-flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 30px;
    height: var(--smart-editor-toolbar-item-height);
    justify-content: center;
    left: calc(50% - 15px);
    left: calc(50% - var(--smart-editor-toolbar-item-height)/2);
    position: absolute;
    top: 0;
    -webkit-transform: scale(0) translateY(-100%);
    transform: scale(0) translateY(-100%);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: visibility .2s ease-in-out, -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out, visibility .2s ease-in-out;
    transition: transform .2s ease-in-out, visibility .2s ease-in-out, -webkit-transform .2s ease-in-out;
    visibility: hidden;
    width: 30px;
    width: var(--smart-editor-toolbar-item-height)
}

.smart-editor .smart-editor-image-container.smart-editor-video-container:hover:after {
    -webkit-transform: scale(1) translateY(25%);
    transform: scale(1) translateY(25%);
    visibility: visible
}

.smart-editor .smart-editor-image-container[display=block] {
    display: block
}

.smart-editor .smart-editor-image-container[display=block][alignment=right] .smart-editor-image-caption {
    text-align: right
}

.smart-editor .smart-editor-image-container:not([display=block])[alignment=right] {
    float: right
}

.smart-editor .smart-editor-image-container .smart-editor-image-caption {
    display: block;
    outline: 0;
    text-align: center
}

.smart-editor table {
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    table-layout: fixed;
    width: 100%
}

.smart-editor table td,
.smart-editor table th {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    min-height: 20px;
    min-height: var(--smart-editor-table-cell-min-height);
    min-width: 20px;
    min-width: var(--smart-editor-table-cell-min-width);
    padding: 2px 5px;
    vertical-align: middle;
    width: auto;
    width: var(--smart-editor-table-column-width)
}

.smart-editor table img {
    max-width: 100%
}

.smart-editor table table {
    width: 100%
}

.smart-editor table th {
    background: #f5f5f5;
    background: var(--smart-surface)
}

.smart-editor table td:empty:before,
.smart-editor table th:empty:before {
    content: "A";
    visibility: hidden
}

.smart-editor table[dashed-borders] td,
.smart-editor table[dashed-borders] th {
    border-style: dashed
}

.smart-editor table[alternation] tr:nth-child(2n) {
    background-color: #f5f5f5;
    background-color: var(--smart-alternation-index0-background)
}

.smart-editor table [selected] {
    box-shadow: inset 0 0 0 1px #005c99;
    box-shadow: 0 0 0 var(--smart-border-width) var(--smart-primary) inset
}

.smart-editor[focus] .smart-editor-toolbar-item[item-type=button][checked] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-editor-toolbar-item {
    border-radius: 4px;
    border-radius: var(--smart-editor-toolbar-item-border-radius);
    cursor: pointer;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-editor-toolbar-item:not([item-type=custom]):hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, .14), 0 2px 2px 0 rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-1);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-editor-toolbar-item:not([item-type=custom]):not([item-type=color-input]):not([disabled]):active,
.smart-editor-toolbar-item[item-type=toggle][checked] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-editor-toolbar-item[item-name=bold]:before {
    content: "\\e820";
    content: var(--smart-icon-bold)
}

.smart-editor-toolbar-item[item-name=italic]:before {
    content: "\\e822";
    content: var(--smart-icon-italic)
}

.smart-editor-toolbar-item[item-name=underline]:before {
    content: "\\f0cd";
    content: var(--smart-icon-underline)
}

.smart-editor-toolbar-item[item-name=strikethrough]:before {
    content: "\\f0cc";
    content: var(--smart-icon-strike-through)
}

.smart-editor-toolbar-item[item-name=caption]:before {
    content: "T";
    content: var(--smart-icon-format-clear);
    font-weight: 600
}

.smart-editor-toolbar-item[item-name=orderedlist]:before {
    content: "\\f0cb";
    content: var(--smart-icon-list-ordered)
}

.smart-editor-toolbar-item[item-name=unorderedlist]:before {
    content: "\\f0ca";
    content: var(--smart-icon-list-unordered)
}

.smart-editor-toolbar-item[item-name=subscript]:before {
    content: "\\f12c";
    content: var(--smart-icon-subscript)
}

.smart-editor-toolbar-item[item-name=superscript]:before {
    content: "\\f12b";
    content: var(--smart-icon-superscript)
}

.smart-editor-toolbar-item .smart-editor-item-action-button[item-name=backgroundcolor]:before {
    content: "\\e830";
    content: var(--smart-icon-color-background)
}

.smart-editor-toolbar-item .smart-editor-item-action-button[item-name=fontcolor]:before {
    content: "\\f031";
    content: var(--smart-icon-font)
}

.smart-editor-toolbar-item[item-name=delete]:before {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-editor-toolbar-item[item-name=redo]:before,
.smart-editor-toolbar-item[item-name=undo]:before {
    content: "\\e809";
    content: var(--smart-icon-reload)
}

.smart-editor-toolbar-item[item-name=indent]:before {
    content: "\\e825";
    content: var(--smart-icon-indent-left)
}

.smart-editor-toolbar-item[item-name=outdent]:before {
    content: "\\e824";
    content: var(--smart-icon-indent-right)
}

.smart-editor-toolbar-item[item-name=createlink]:before {
    content: "\\e831";
    content: var(--smart-icon-link)
}

.smart-editor-toolbar-item[item-name=removelink]:before {
    content: "\\f127";
    content: var(--smart-icon-unlink)
}

.smart-editor-toolbar-item[item-name=hyperlink]:before {
    content: "\\e831";
    content: var(--smart-icon-link)
}

.smart-editor-toolbar-item[item-name=openlink]:before {
    content: "\\f08e";
    content: var(--smart-icon-link-ext)
}

.smart-editor-toolbar-item[item-name=editlink]:before {
    content: "\\e909";
    content: var(--smart-icon-mode-edit)
}

.smart-editor-toolbar-item[item-name=image]:before {
    content: "\\e827";
    content: var(--smart-icon-image)
}

.smart-editor-toolbar-item[item-name=table]:before {
    content: "\\e800";
    content: var(--smart-icon-table)
}

.smart-editor-toolbar-item[item-name=lowercase]:before {
    content: "aa";
    content: var(--smart-icon-case-lower)
}

.smart-editor-toolbar-item[item-name=uppercase]:before {
    content: "AA";
    content: var(--smart-icon-case-upper)
}

.smart-editor-toolbar-item[item-name=print]:before {
    content: "\\e82b";
    content: var(--smart-icon-print)
}

.smart-editor-toolbar-item[item-name=copy]:before {
    content: "\\e835";
    content: var(--smart-icon-copy-record)
}

.smart-editor-toolbar-item[item-name=paste]:before {
    content: "\\f0ea";
    content: var(--smart-icon-paste)
}

.smart-editor-toolbar-item[item-name=cut]:before {
    content: "\\e83a";
    content: var(--smart-icon-cut);
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-editor-toolbar-item[item-name=clearformat]:before {
    content: "T";
    content: var(--smart-icon-format-clear);
    font-style: italic;
    font-weight: 600
}

.smart-editor-toolbar-item[item-name=fullscreen]:before {
    content: "\\e81c";
    content: var(--smart-icon-resize-full)
}

.smart-editor-toolbar-item[item-name=sourcecode]:before {
    content: "\\f121";
    content: var(--smart-icon-source-code)
}

.smart-editor-toolbar-item[item-name=preview]:before {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-editor-toolbar-item[item-name=splitmode]:before {
    content: "\\e83b";
    content: var(--smart-icon-split-mode)
}

.smart-editor-toolbar-item[item-name=tableheader]:before {
    content: "\\f1dc";
    content: var(--smart-icon-header)
}

.smart-editor-toolbar-item[item-name=tablerows]:before {
    content: "\\f0db";
    content: var(--smart-icon-row)
}

.smart-editor-toolbar-item[item-name=tablecolumns]:before {
    content: "\\f0db";
    content: var(--smart-icon-column)
}

.smart-editor-toolbar-item[item-name=tablevalign]:before {
    content: "\\f06a \e80c";
    content: var(--smart-icon-vertical-align)
}

.smart-editor-toolbar-item[item-name=tablestyle]:before {
    content: "\\f1fc";
    content: var(--smart-icon-styles)
}

.smart-editor-toolbar-item[item-name=findandreplace]:before {
    content: "\\e828";
    content: var(--smart-icon-search)
}

.smart-editor-toolbar-item[item-name=video]:before {
    content: "\\f16a";
    content: var(--smart-icon-video)
}

.smart-editor-toolbar-item[item-name=redo]:before {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1)
}

.smart-editor-toolbar-item[item-name=clearformat]:after {
    content: "-";
    font-weight: 600;
    position: absolute;
    top: 0;
    -webkit-transform: scaleX(1.5);
    transform: scaleX(1.5)
}

.smart-editor-toolbar-item[item-name=alignment][item-value=left]:before {
    content: "\\e806";
    content: var(--smart-icon-align-left)
}

.smart-editor-toolbar-item[item-name=alignment][item-value=center]:before {
    content: "\\e808";
    content: var(--smart-icon-align-center)
}

.smart-editor-toolbar-item[item-name=alignment][item-value=right]:before {
    content: "\\e807";
    content: var(--smart-icon-align-right)
}

.smart-editor-toolbar-item[item-name=alignment][item-value=justify]:before {
    content: "\\e813";
    content: var(--smart-icon-align-justify)
}

.smart-editor-toolbar-item[item-type=button],
.smart-editor-toolbar-item[item-type=toggle] {
    width: 30px;
    width: var(--smart-editor-toolbar-button-width)
}

.smart-editor-toolbar-item[item-type=color-input],
.smart-editor-toolbar-item[item-type=drop-down] {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 65px;
    width: var(--smart-editor-toolbar-drop-down-width-small)
}

.smart-editor-toolbar-item[item-type=drop-down][item-name=fontname],
.smart-editor-toolbar-item[item-type=drop-down][item-name=formats] {
    width: 100px;
    width: var(--smart-editor-toolbar-drop-down-width-large)
}

.smart-editor-toolbar-item[item-type=drop-down][item-name=tablerows]:before {
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.smart-editor-toolbar-item[item-type=color-input] .smart-editor-item-action-button {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    padding-bottom: 0;
    padding-top: 0;
    position: relative;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-editor-toolbar-item[item-type=color-input] .smart-editor-item-action-button:before {
    border-bottom: calc(var(--smart-border-width)*3) solid var(--item-value);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.smart-editor-toolbar-item[item-type=color-input] .smart-editor-item-drop-down-button {
    height: 100%;
    position: relative
}

.smart-editor-toolbar-item[item-type=custom]>:first-child {
    height: 30px;
    height: var(--smart-editor-toolbar-item-height);
    width: 100%
}

.smart-editor-toolbar-item .smart-editor-item-action-button:hover,
.smart-editor-toolbar-item .smart-editor-item-drop-down-button:hover {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-focus);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-editor-toolbar-item .smart-editor-item-action-button:not([disabled]):active,
.smart-editor-toolbar-item .smart-editor-item-drop-down-button:not([disabled]):active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-editor-toolbar-item[item-type=delimiter] {
    pointer-events: none;
    width: 5px;
    width: var(--smart-editor-toolbar-delimiter-width)
}

.smart-editor-toolbar-item[item-type=delimiter]:before {
    content: attr(item-name);
    min-width: 0;
    min-width: auto;
    -webkit-transform: scaleY(1.5);
    transform: scaleY(1.5)
}

.smart-editor-toolbar-item .smart-ripple {
    background-color: #5a5a5a;
    background-color: var(--smart-background-color)
}

.smart-editor-toolbar-item .smart-editor-item-drop-down {
    left: 0;
    position: absolute;
    top: 0;
    visibility: hidden
}

.smart-color-input-drop-down-menu.smart-editor-color-input .grid-samples-container {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.smart-color-input-drop-down-menu.smart-editor-color-input:not([animation=none]) .default-samples-container div {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-color-input-drop-down-menu.smart-editor-color-input .default-samples-container div {
    border: initial;
    border-radius: 50%;
    position: relative;
    -webkit-transform: scale(.95);
    transform: scale(.95)
}

.smart-color-input-drop-down-menu.smart-editor-color-input .default-samples-container div.selected {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-color-input-drop-down-menu.smart-editor-color-input .default-samples-container div.selected:not(.no-color):after {
    align-items: center;
    border-radius: inherit;
    color: #fff;
    color: var(--smart-secondary-color);
    content: "\\e908";
    content: var(--smart-icon-check);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-editor-color-input {
    --smart-input-drop-down-menu-width: auto
}

.smart-editor-color-input.smart-color-input-drop-down-menu .default-samples-container div.selected[value="#FFFFFF"]:after {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    box-sizing: border-box;
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-editor-input li .editor-icon:before {
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    left: 0;
    line-height: 1rem;
    position: absolute;
    width: 30px;
    width: var(--smart-column-icon-size)
}

.smart-editor-input li[value=left] .editor-icon:before {
    content: "\\e806";
    content: var(--smart-icon-align-left)
}

.smart-editor-input li[value=center] .editor-icon:before {
    content: "\\e808";
    content: var(--smart-icon-align-center)
}

.smart-editor-input li[value=right] .editor-icon:before {
    content: "\\e807";
    content: var(--smart-icon-align-right)
}

.smart-editor-input li[value=justify] .editor-icon:before {
    content: "\\e813";
    content: var(--smart-icon-align-justify)
}

.smart-editor-input li[value=insertRowBefore] .editor-icon:before {
    content: "\\f2d0";
    content: var(--smart-icon-row-before)
}

.smart-editor-input li[value=insertRowAfter] .editor-icon:before {
    content: "\\f2d0";
    content: var(--smart-icon-row-after);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-editor-input li[value=deleteRow] .editor-icon:before {
    content: "\\e80e";
    content: var(--smart-icon-row-delete)
}

.smart-editor-input li[value=insertColumnLeft] .editor-icon:before {
    content: "\\f2d0";
    content: var(--smart-icon-column-left);
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-editor-input li[value=insertColumnRight] .editor-icon:before {
    content: "\\f2d0";
    content: var(--smart-icon-column-right);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.smart-editor-input li[value=deleteColumn] .editor-icon:before {
    content: "\\e80e";
    content: var(--smart-icon-column-delete)
}

.smart-editor-input li[value=h1] a {
    font-size: 1.5rem;
    font-weight: 700
}

.smart-editor-input li[value=h2] a {
    font-size: 1.3rem;
    font-weight: 700
}

.smart-editor-input li[value=h3] a {
    font-size: 1.1rem;
    font-weight: 700
}

.smart-editor-input li[value=h4] a {
    font-size: .9rem;
    font-weight: 700
}

.smart-editor-input li[value=segueUi] a {
    font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif
}

.smart-editor-input li[value=arial] a {
    font-family: Arial, Helvetica, sans-serif
}

.smart-editor-input li[value=georgia] a {
    font-family: Georgia, Times New Roman, Times, serif
}

.smart-editor-input li[value=impact] a {
    font-family: Impact, Haettenschweiler, Arial Narrow Bold, sans-serif
}

.smart-editor-input li[value=tahoma] a {
    font-family: Tahoma, Geneva, Verdana, sans-serif
}

.smart-editor-input li[value=timesnewRoman] a {
    font-family: Times New Roman, Times, serif
}

.smart-editor-input li[value=verdana] a {
    font-family: Verdana, Geneva, Tahoma, sans-serif
}

.smart-editor-input[right-to-left] li .editor-icon:before {
    left: auto;
    right: 0
}

.smart-editor-window {
    --smart-window-default-width: auto;
    --smart-window-default-height: auto;
    --smart-window-header-height: var(--smart-editor-window-header-height);
    --smart-window-footer-height: var(--smart-editor-window-footer-height);
    --smart-window-header-footer-padding: 10px;
    --smart-window-header-background: transparent;
    --smart-window-footer-padding: 10px;
    --smart-window-content-padding: 20px;
    max-height: 95vh;
    max-width: 95vw
}

.smart-editor-window.smart-window .smart-content-container>.smart-content {
    align-items: flex-start;
    padding: initial
}

.smart-editor-window .smart-editor-window-button {
    --smart-button-padding: 0.2rem 16px;
    height: 100%;
    width: 100%
}

.smart-editor-window .smart-editor-window-button:not(:last-of-type) {
    margin-right: 2.5%
}

.smart-editor-window .smart-editor-window-content-wrapper {
    grid-template-rows: auto minmax(auto, 1fr);
    padding: 10px;
    padding: var(--smart-window-content-padding);
    width: 100%
}

.smart-editor-window .smart-editor-window-content-wrapper>div {
    grid-row-gap: 10px;
    display: grid;
    grid-template-columns: 100%;
    justify-content: center;
    width: 450px;
    width: var(--smart-box-width)
}

.smart-editor-window .smart-editor-window-editor {
    grid-row-gap: 5px;
    grid-column-gap: 10px;
    display: grid
}

.smart-editor-window .smart-editor-window-editor>.smart-input,
.smart-editor-window .smart-editor-window-editor>.smart-list-box {
    width: 100%
}

.smart-editor-window .smart-editor-window-editor>.smart-check-box {
    width: -webkit-max-content;
    width: max-content
}

.smart-editor-window .smart-editor-window-editor[multiple] .smart-editor-window-editor {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.smart-editor-window .smart-editor-window-editor[type=results] label {
    display: flex;
    justify-content: space-between
}

.smart-editor-window .smart-editor-window-editor[type=results] label[matches]:after {
    content: attr(selected) ,attr(matches)
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-drop-zone {
    border: 2px dashed #e0e0e0;
    border: calc(var(--smart-border-width)*2) dashed var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: 100px;
    width: 100%
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload {
    --smart-file-upload-drop-zone-height: 100px;
    min-height: 0;
    min-height: auto;
    order: 1;
    width: 100%
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-browse-button {
    margin: initial
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-item-upload-button {
    display: none
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-file-upload-header {
    margin-bottom: 5px;
    padding: initial
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-file-upload-container,
.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files {
    padding: initial
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files .smart-file {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    display: flex;
    margin: initial
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files .smart-item-cancel-button:after,
.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files .smart-item-pause-button:after,
.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files .smart-item-upload-button:after {
    align-items: center;
    display: flex;
    justify-content: center;
    left: auto;
    position: static;
    top: auto
}

.smart-editor-window .smart-editor-window-editor[type=file] .smart-file-upload .smart-selected-files .smart-item-name {
    width: 100%
}

.smart-tooltip .smart-tooltip-content {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #fefefe;
    border-color: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    opacity: 1
}

.smart-tooltip.smart-editor-context-menu:not([animation=none]) {
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-tooltip.smart-editor-toolbar {
    --smart-tooltip-padding: 5px;
    --smart-tooltip-arrow-color: var(--smart-surface)
}

.smart-tooltip.smart-editor-toolbar .smart-tooltip-content {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #f5f5f5;
    border-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-tooltip.smart-editor-toolbar.smart-editor-inline-toolbar .smart-tooltip-content {
    flex-wrap: wrap;
    max-width: 80vw;
    max-width: var(--smart-editor-inline-toolbar-max-width)
}

.smart-tooltip.smart-editor-toolbar:not([animation=none]) .smart-editor-toolbar-item {
    transition: background-color 0s linear, border-color 0s ease-in-out, color 0s linear, box-shadow .2s ease-in-out
}

.smart-tooltip.smart-editor-toolbar:not(.smart-editor-drop-down-toolbar) .smart-editor-toolbar-item:not(:first-of-type) {
    margin-left: 5px;
    margin-left: var(--smart-editor-toolbar-item-margin)
}

.smart-tooltip.smart-editor-toolbar[right-to-left]:not(.smart-editor-drop-down-toolbar) .smart-editor-toolbar-item:not(:first-of-type) {
    margin-left: 0;
    margin-right: 5px;
    margin-right: var(--smart-editor-toolbar-item-margin)
}

.smart-tooltip.smart-editor-context-menu {
    opacity: .2;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0
}

.smart-tooltip.smart-editor-context-menu[visible] {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-tooltip .smart-editor-context-menu-item-container {
    align-items: center;
    display: grid;
    height: 100%;
    justify-content: flex-start;
    width: 100%
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    height: 36px;
    height: var(--smart-list-item-height);
    padding: 9px 12px;
    padding: var(--smart-list-item-padding);
    padding-left: 30px;
    padding-left: var(--smart-column-icon-size);
    position: relative;
    text-overflow: ellipsis;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item:before {
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    left: 0;
    line-height: 1rem;
    position: absolute;
    width: 30px;
    width: var(--smart-column-icon-size)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=insertRowBefore]:before {
    content: "\\f2d0";
    content: var(--smart-icon-row-before)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=insertRowAfter]:before {
    content: "\\f2d0";
    content: var(--smart-icon-row-after);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteRow]:before {
    content: "\\e80e";
    content: var(--smart-icon-row-delete)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=insertColumnLeft]:before {
    content: "\\f2d0";
    content: var(--smart-icon-column-left);
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=insertColumnRight]:before {
    content: "\\f2d0";
    content: var(--smart-icon-column-right);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteColumn]:before {
    content: "\\e80e";
    content: var(--smart-icon-column-delete)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=tableProperties]:before {
    content: "\\e800";
    content: var(--smart-icon-table)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=imageProperties]:before {
    content: "\\e827";
    content: var(--smart-icon-image)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=linkProperties]:before,
.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=videoProperties]:before {
    content: "\\e831";
    content: var(--smart-icon-link)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteTable]:before {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=copyImage]:before,
.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=copyVideo]:before {
    content: "\\e835";
    content: var(--smart-icon-copy-record)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=cutImage]:before,
.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=cutVideo]:before {
    content: "\\e83a";
    content: var(--smart-icon-cut);
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteImage]:before,
.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteLink]:before,
.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteVideo]:before {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=createLink]:before {
    content: "\\e831";
    content: var(--smart-icon-link)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=deleteLink]:before {
    content: "\\f127";
    content: var(--smart-icon-unlink)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=caption]:before {
    content: "T";
    content: var(--smart-icon-format-clear)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=selectAll]:before {
    content: "\\f247";
    content: var(--smart-icon-group)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=cut]:before {
    content: "\\e83a";
    content: var(--smart-icon-cut);
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=copy]:before {
    content: "\\e835";
    content: var(--smart-icon-copy-record)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[value=paste]:before {
    content: "\\f0ea";
    content: var(--smart-icon-paste)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[selected] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-tooltip .smart-editor-context-menu-item-container .smart-editor-context-menu-item[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none
}

.smart-editor-drop-down-toolbar:not([animation=none]) {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in
}

.smart-editor-drop-down-toolbar:not([animation=none])[visible] {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    transition: opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out
}

.smart-editor-drop-down-toolbar:not([arrow-direction]),
.smart-editor-drop-down-toolbar[arrow-direction=bottom] {
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-editor-drop-down-toolbar:not([arrow]),
.smart-editor-drop-down-toolbar[arrow-direction=top] {
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-editor-drop-down-toolbar .smart-table-picker {
    background: 0 0;
    display: block;
    overflow: hidden
}

.smart-editor-drop-down-toolbar .smart-table-picker[right-to-left] .smart-table-picker-button>button.smart-button {
    align-items: center;
    display: flex;
    justify-content: center
}

.smart-editor-drop-down-toolbar .smart-table-picker[right-to-left] .smart-table-picker-button>button.smart-button:before {
    margin-left: 10px;
    margin-right: 0
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-grid {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-grid:before {
    align-items: center;
    box-sizing: border-box;
    content: attr(value);
    display: flex;
    justify-content: center;
    padding: .2rem 16px;
    width: 100%
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-grid>div {
    display: flex
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-cell {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    cursor: pointer;
    height: 15px;
    margin: 2px;
    width: 15px
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-cell[selected] {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-separator {
    background: #e0e0e0;
    background: var(--smart-border);
    height: 1px;
    height: var(--smart-border-width);
    margin: 10px 0;
    width: 100%
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-button {
    background: 0 0;
    border: initial;
    width: 100%
}

.smart-editor-drop-down-toolbar .smart-table-picker .smart-table-picker-button button:before {
    box-sizing: border-box;
    content: "\\e800";
    content: var(--smart-icon-table);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    margin-right: 10px
}

.smart-drop-zone[right-to-left],
.smart-file[right-to-left],
smart-file-upload[right-to-left]>.smart-container {
    direction: rtl
}

smart-file-upload {
    background-color: var(--smart-file-upload-background);
    border: var(--smart-file-upload-border-width) dashed var(--smart-file-upload-border);
    box-sizing: border-box;
    color: var(--smart-file-upload-color);
    display: inline-block;
    font-family: var(--smart-file-upload-font-family);
    font-size: var(--smart-file-upload-font-size);
    min-height: 100px;
    min-width: 200px;
    overflow: hidden;
    width: 250px;
    width: var(--smart-file-upload-default-width)
}

smart-file-upload .smart-selected-files .smart-file.smart-hidden,
smart-file-upload .smart-total-files.smart-hidden,
smart-file-upload[show-progress] .smart-file smart-progress-bar {
    display: none
}

smart-file-upload[disabled] {
    cursor: default;
    opacity: .55
}

smart-file-upload[show-progress] .smart-file smart-progress-bar[value] {
    display: block
}

.smart-file.smart-uploading-start:before {
    -webkit-animation: connecting 1s linear infinite;
    animation: connecting 1s linear infinite;
    background-color: #c1c1c169;
    color: #737373;
    content: "Connecting ...";
    content: var(--smart-file-upload-text-content-uploading-start);
    flex-direction: column;
    opacity: 1;
    width: 100%
}

.smart-file.smart-error:before,
.smart-file.smart-pause:before,
.smart-file.smart-uploading-start:before,
.smart-file.smart-uploading:before {
    box-sizing: border-box;
    display: flex;
    font-family: arial;
    font-size: 11px;
    height: 100%;
    justify-content: flex-end;
    left: 0;
    padding: 0 0 2px 5px;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: 1
}

.smart-file.smart-uploading:before {
    background-color: #c1c1c169;
    color: var(--smart-ui-state);
    content: "Uploading ...";
    content: var(--smart-file-upload-text-content-uploading);
    flex-direction: column;
    opacity: 1;
    width: 100%
}

.smart-file.smart-uploading .smart-item-upload-button {
    pointer-events: none
}

.smart-file.smart-uploading .smart-item-name {
    opacity: .2;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-file.smart-pause:before {
    background-color: #0f0030;
    border-radius: 3px;
    color: #8a0000;
    content: "Upload paused!";
    content: var(--smart-file-upload-text-content-pause);
    flex-direction: column;
    opacity: .8;
    width: 100%
}

.smart-file.smart-error:before {
    -webkit-animation: error 6s linear 1;
    animation: error 6s linear 1;
    background-color: #b00020;
    background-color: var(--smart-error);
    border-radius: var(--smart-error-border-radius);
    color: var(--smart-on-error);
    content: "Upload error!";
    content: var(--smart-file-upload-text-content-error);
    flex-direction: column;
    opacity: 0;
    width: 100%
}

.smart-file.smart-error smart-progress-bar,
.smart-selected-files .smart-uploading .smart-item-upload-button {
    opacity: .3
}

.smart-file smart-progress-bar {
    bottom: 0;
    display: none;
    height: 4px;
    left: 0;
    position: absolute;
    width: 100%
}

.smart-file smart-progress-bar .smart-container {
    border-style: none
}

.smart-file smart-progress-bar .smart-value {
    background-color: orange
}

.smart-file-upload .smart-file-upload-container,
.smart-file-upload .smart-file-upload-footer,
.smart-file-upload .smart-file-upload-header {
    box-sizing: border-box;
    padding: 5px;
    width: 100%
}

.smart-file-upload .smart-browse-button {
    display: block;
    height: auto;
    height: var(--smart-file-upload-browse-button-height);
    margin: 4px;
    width: auto;
    width: var(--smart-file-upload-browse-button-width)
}

.smart-file-upload .smart-cancel-all-button,
.smart-file-upload .smart-pause-all-button,
.smart-file-upload .smart-upload-all-button {
    height: auto;
    height: var(--smart-file-upload-footer-button-height);
    margin: 4px;
    width: auto;
    width: var(--smart-file-upload-footer-button-width)
}

.smart-file-upload .smart-browse-input {
    display: none
}

.smart-file-upload .smart-drop-zone {
    display: none;
    height: 100px;
    width: 100%
}

.smart-drop-zone,
.smart-drop-zone:after,
.smart-selected-files {
    box-sizing: border-box;
    height: 100%;
    width: 100%
}

.smart-file-upload .smart-total-files {
    box-sizing: border-box;
    color: gray;
    display: block;
    font-family: arial;
    font-size: 12px;
    padding: 0 0 2px 5px
}

.smart-file-upload .smart-total-files:empty,
.smart-file-upload[hide-footer] .smart-file-upload-footer {
    display: none
}

.smart-file-upload[disabled] .smart-file-upload-container {
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-file-upload[drop-zone] .smart-drop-zone {
    display: block
}

.smart-file-upload[drop-zone] .smart-overflow .smart-drop-zone {
    display: none
}

.smart-drop-zone {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px dotted #d3d3d3;
    position: relative
}

.smart-drop-zone:after {
    border: 5px dashed transparent;
    color: var(--smart-ui-state);
    content: "Drag files here";
    content: var(--smart-file-upload-text-content-drop-zone);
    display: flex;
    flex-direction: column;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    justify-content: center;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    transition: border .5s ease-out
}

.smart-drop-zone.smart-drag-over:after,
[data-theme=modern] .smart-drop-zone.smart-drag-over:after {
    -webkit-animation: drop-zone 1s ease-in infinite;
    animation: drop-zone 1s ease-in infinite;
    content: "Drop here \e824";
    content: var(--smart-file-upload-text-content-drop-zone-over);
    transition: border .5s ease-out
}

.smart-drop-zone.smart-drag-over:after {
    border: 3px dashed var(--smart-background-border);
    font-size: 50px
}

[data-theme=modern] {
    --smart-file-upload-text-content-drop-zone-over: "Drop here"
}

[data-theme=modern] .smart-drop-zone {
    align-items: center;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: contain;
    border: 2px dashed #f5f5f5;
    border: 2px dashed var(--smart-surface);
    display: flex;
    justify-content: center;
    padding: 10px;
    width: 100%
}

[data-theme=modern] .smart-drop-zone:after {
    font-family: Verdana;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5
}

[data-theme=modern] .smart-drop-zone:hover {
    background-color: rgba(0, 92, 153, .1);
    background-color: rgba(var(--smart-primary-rgb), .1);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

[data-theme=modern] .smart-drop-zone.smart-drag-over:after {
    border-color: transparent;
    font-size: 2.5rem
}

.smart-selected-files {
    display: block;
    padding: 2px
}

.smart-selected-files .smart-file {
    background-color: #fafafa;
    border: 1px solid #d3d3d3;
    border-radius: 3px;
    box-sizing: border-box;
    display: block;
    height: auto;
    margin-bottom: 1px;
    padding: 10px;
    position: relative;
    transition: border-color .5s ease
}

.smart-selected-files .smart-file:hover {
    border-color: gray;
    transition: border-color .5s ease
}

.smart-selected-files .smart-item-pause-button {
    box-sizing: border-box;
    color: #999;
    display: none;
    height: 16px;
    pointer-events: none;
    position: relative;
    transition: color .5s ease;
    width: 16px
}

.smart-selected-files .smart-item-pause-button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    left: 0;
    position: absolute;
    text-shadow: 2px 2px 2px #d3d3d3;
    top: 0
}

.smart-selected-files .smart-item-cancel-button {
    box-sizing: border-box;
    color: #999;
    display: inline-block;
    height: 16px;
    position: relative;
    transition: color .5s ease;
    width: 16px
}

.smart-selected-files .smart-item-cancel-button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    left: 0;
    position: absolute;
    text-shadow: 2px 2px 2px #d3d3d3;
    top: 0
}

.smart-selected-files .smart-item-cancel-button:hover {
    color: orange;
    cursor: pointer;
    transition: color .5s ease
}

.smart-selected-files .smart-item-upload-button {
    box-sizing: border-box;
    color: #999;
    display: inline-block;
    height: 16px;
    position: relative;
    transition: color .5s ease;
    width: 16px
}

.smart-selected-files .smart-item-upload-button:after {
    content: "\\e83f";
    content: var(--smart-icon-up);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    left: 0;
    position: absolute;
    text-shadow: 2px 2px 2px #d3d3d3;
    top: 0
}

.smart-selected-files .smart-item-upload-button:hover {
    color: #8bc34a;
    color: var(--smart-success);
    cursor: pointer;
    transition: color .5s ease
}

.smart-selected-files .smart-item-name {
    box-sizing: border-box;
    display: inline-block;
    height: auto;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    width: calc(100% - 40px)
}

.smart-selected-files .smart-uploading .smart-item-name {
    height: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 60px)
}

.smart-selected-files .smart-uploading .smart-item-pause-button {
    color: #dc1919;
    cursor: pointer;
    display: inline-block;
    opacity: .5;
    pointer-events: all;
    transition: color .5s, opacity .5s ease
}

.smart-selected-files .smart-uploading .smart-item-pause-button:hover {
    color: red;
    opacity: 1;
    transition: color .5s, opacity .5s ease
}

.smart-selected-files .smart-uploading .smart-item-cancel-button {
    color: #ff8c00;
    cursor: pointer;
    display: inline-block;
    opacity: .5;
    pointer-events: all;
    transition: color .5s, opacity .5s ease
}

.smart-selected-files .smart-uploading .smart-item-cancel-button:hover {
    color: orange;
    opacity: 1;
    transition: color .5s, opacity .5s ease
}

.smart-drop-zone-square {
    position: relative
}

.smart-drop-zone-square:before {
    content: "";
    display: block;
    padding-bottom: 100%
}

.smart-drop-zone-square .smart-drop-zone {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0
}

.smart-drop-zone-square.smart-drop-zone-small {
    min-width: 115px
}

.smart-drop-zone-small {
    display: inline-block;
    position: relative;
    width: auto
}

.smart-drop-zone-small .smart-drop-zone.smart-drag-over:after {
    font-size: 1.25rem
}

.smart-drop-zone-images-only .smart-drop-zone {
    align-items: center;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly
}

.smart-drop-zone-images-only .smart-drop-zone:after {
    height: auto
}

.smart-drop-zone-images-only .smart-drop-zone:before {
    background-image: url(../../static/media/dropable_zone_image.6c65f7db21c9520078a4.svg);
    background-position: 50%;
    background-size: contain;
    content: "";
    display: block;
    height: 55px;
    width: 70px
}

@-webkit-keyframes connecting {

    0%,
    to {
        color: #73737350
    }

    50% {
        color: #73737399
    }
}

@-webkit-keyframes drop-zone {

    0%,
    to {
        color: #b1b1b100
    }

    50% {
        color: #b1b1b199
    }
}

@-webkit-keyframes rotating {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0)
    }

    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@-webkit-keyframes error {
    0% {
        background-color: #0f0015;
        opacity: .8
    }

    3%,
    9% {
        background-color: #0f0040
    }

    12%,
    6% {
        background-color: #0f0015
    }

    80% {
        opacity: .8
    }

    to {
        opacity: 0
    }
}

.smart-filter-builder.smart-container,
smart-filter-builder,
smart-filter-builder>.smart-container {
    overflow: visible;
    position: relative
}

smart-filter-builder {
    background-color: transparent;
    box-sizing: border-box;
    display: inline-block;
    font-family: var(--smart-filter-builder-font-family);
    font-size: var(--smart-filter-builder-font-size);
    height: 450px;
    height: var(--smart-filter-builder-default-height);
    width: 450px;
    width: var(--smart-filter-builder-default-width)
}

smart-filter-builder[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-filter-builder.smart-container>.smart-inner-container,
smart-filter-builder>.smart-container>.smart-inner-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-filter-builder smart-menu[mode=dropDown] {
    height: auto;
    width: auto
}

.smart-filter-builder smart-scroll-viewer {
    height: 100%;
    position: relative;
    width: 100%
}

.smart-filter-builder .filter-builder-item {
    align-content: center;
    align-items: center;
    background-color: #add8e6;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    margin-right: 5px;
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height);
    padding: 5px;
    vertical-align: middle
}

.smart-filter-builder .smart-filter-builder-icon {
    border-right: 1px solid gray;
    display: inline-block;
    font-weight: 700;
    height: 100%;
    margin-right: 5px;
    padding: 0 2px;
    text-align: center;
    width: 40px
}

.smart-filter-builder .smart-filter-builder-menu-item {
    display: inline-block;
    height: 100%
}

.smart-filter-builder .smart-filter-add-btn,
.smart-filter-builder .smart-filter-delete-btn {
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height);
    min-width: 30px;
    min-width: var(--smart-filter-builder-row-height);
    opacity: .3;
    padding: 5px 0;
    vertical-align: middle
}

.smart-filter-builder .smart-filter-add-btn:after,
.smart-filter-builder .smart-filter-delete-btn:after {
    content: "+";
    cursor: pointer;
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 25px;
    text-align: center;
    vertical-align: middle;
    width: 100%
}

.smart-filter-builder .smart-filter-add-btn:hover,
.smart-filter-builder .smart-filter-delete-btn:hover {
    opacity: .6
}

.smart-filter-builder .smart-filter-add-btn:active,
.smart-filter-builder .smart-filter-delete-btn:active {
    opacity: 1
}

.smart-filter-builder .smart-filter-add-btn {
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-filter-builder .smart-filter-add-btn:after {
    font-weight: 700
}

.smart-filter-builder .smart-filter-delete-btn:after {
    content: "\\e81F";
    font-size: 10px
}

.smart-filter-builder .smart-filter-value {
    min-width: 100px;
    padding: 0
}

.smart-filter-builder .smart-filter-value .smart-value-container {
    align-content: center;
    color: gray;
    display: inline-flex;
    height: 100%;
    justify-content: center;
    margin: 0;
    padding: 5px;
    width: 100%
}

.smart-filter-builder .smart-filter-value[edited] {
    background-color: transparent;
    padding: 0
}

.smart-filter-builder .smart-filter-value[edited] .smart-value-container {
    display: none
}

.smart-filter-builder .smart-filter-group,
.smart-filter-builder .smart-filter-group-condition,
.smart-filter-builder .smart-filter-group-condition-container,
.smart-filter-builder .smart-filter-group-operator {
    box-sizing: border-box;
    display: block;
    white-space: nowrap;
    width: 100%
}

.smart-filter-builder .smart-filter-group-condition {
    margin-bottom: 5px
}

.smart-filter-builder .smart-filter-group-condition-container {
    padding-left: 30px
}

.smart-filter-builder .smart-filter-group-operation {
    min-width: 50px
}

.smart-filter-builder .smart-content-container>.smart-filter-group>.smart-filter-group-operator {
    margin-left: 30px
}

.smart-filter-builder .smart-content-container>.smart-filter-group>.smart-filter-group-operator .smart-filter-delete-btn {
    display: none
}

.smart-filter-builder .smart-editors-container {
    height: 20px;
    pointer-events: none;
    position: relative
}

.smart-filter-builder .smart-editors-container[open] {
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height);
    min-width: 100px;
    width: 250px;
    width: var(--smart-filter-builder-item-width)
}

.smart-filter-builder .smart-editors-container[open] .smart-check-box-editor {
    align-self: center;
    display: flex;
    height: 30px;
    justify-self: center;
    margin-left: auto;
    margin-right: auto;
    width: 30px
}

.smart-filter-builder .smart-editors-container[open] .smart-check-box-editor.smart-hidden,
.smart-filter-builder .smart-hidden {
    display: none
}

.smart-filter-builder .smart-editors-container .smart-check-box-editor,
.smart-filter-builder .smart-editors-container .smart-combo-box-editor,
.smart-filter-builder .smart-editors-container .smart-custom-editor>*,
.smart-filter-builder .smart-editors-container .smart-date-time-picker-editor,
.smart-filter-builder .smart-editors-container .smart-drop-down-list-editor,
.smart-filter-builder .smart-editors-container .smart-numeric-text-box-editor,
.smart-filter-builder .smart-editors-container .smart-text-box-editor {
    pointer-events: all;
    width: 100%
}

.smart-filter-builder .smart-filter-field-name,
.smart-filter-builder .smart-filter-operation {
    min-width: 100px
}

.smart-filter-builder .smart-selected-menu-item {
    background-color: #d3d3d3
}

.smart-filter-builder .smart-scrollable-outer-container {
    height: 100%;
    width: 100%
}

.smart-filter-builder .smart-filter-value:hover>* {
    background-color: transparent;
    background-color: initial;
    border-color: initial;
    color: #000;
    color: initial
}

.smart-filter-panel .smart-filter-panel-input,
.smart-filter-panel .smart-filter-panel-label,
.smart-filter-panel .smart-filter-panel-list,
.smart-filter-panel .smart-filter-panel-operator-list,
.smart-filter-panel smart-filter-builder,
.smart-filter-panel smart-tree {
    margin-bottom: 10px;
    margin-bottom: var(--smart-filter-panel-vertical-offset)
}

smart-filter-panel {
    height: auto;
    height: var(--smart-filter-panel-default-height);
    width: 300px;
    width: var(--smart-filter-panel-default-width)
}

smart-filter-panel.smart-element {
    border: none;
    padding: 10px;
    padding: var(--smart-filter-panel-padding)
}

.smart-filter-panel .smart-filter-panel-input:active,
.smart-filter-panel .smart-filter-panel-input:focus {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-filter-panel smart-numeric-text-box.smart-filter-panel-input input {
    text-align: right
}

.smart-filter-panel smart-filter-builder,
.smart-filter-panel smart-tree {
    height: 400px;
    height: var(--smart-filter-panel-main-element-height);
    width: 100%
}

.smart-filter-panel smart-tree.date-excel smart-tree-items-group[level="1"]>.smart-tree-item-label-container>.smart-tree-items-group-arrow,
.smart-filter-panel smart-tree.standard-excel .smart-tree-items-group-arrow {
    visibility: hidden
}

.smart-filter-panel smart-tree.standard-excel smart-tree-item:not([level="1"])>.smart-tree-item-label-container {
    margin-left: -30px
}

.smart-filter-panel smart-filter-builder {
    --smart-filter-builder-item-width: 150px;
    display: block
}

.smart-filter-panel smart-filter-builder .smart-filter-field-name,
.smart-filter-panel smart-menu-item[value=notand],
.smart-filter-panel smart-menu-item[value=notor] {
    display: none
}

.smart-filter-panel smart-filter-builder .smart-scroll-viewer-content-container {
    padding: 0
}

.smart-filter-panel smart-filter-builder .smart-content-container>.smart-filter-group>.smart-filter-group-operator {
    margin-left: 15px
}

.smart-filter-panel smart-filter-builder .smart-filter-group-condition-container {
    padding-left: 15px
}

.smart-filter-panel .smart-filter-panel-list {
    width: 100%
}

.smart-filter-panel .smart-filter-panel-operator-list {
    width: 80px
}

.smart-filter-panel .smart-filter-panel-button-container {
    display: flex;
    height: 30px;
    height: var(--smart-editor-height);
    justify-content: space-around;
    min-height: 33px;
    width: 100%
}

.smart-filter-panel .smart-filter-panel-button-container>smart-button {
    width: 80px
}

.smart-filter-panel .smart-filter-panel-button-container>smart-button button {
    padding: 8px
}

.smart-filter-panel .smart-filter-panel-input {
    display: block;
    height: 30px;
    height: var(--smart-editor-height);
    width: 100%
}

.smart-filter-panel .smart-filter-panel-input.case-sensitive {
    display: inline-block;
    width: calc(100% - 32px)
}

.smart-filter-panel[filter-type=string] smart-filter-builder {
    height: 370px;
    height: calc(var(--smart-filter-panel-main-element-height) - var(--smart-editor-height));
    margin-bottom: 0
}

.smart-filter-panel[filter-type=string] .case-sensitive {
    display: block;
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-filter-panel-vertical-offset) - 5px);
    margin-top: 5px
}

.smart-filter-panel[filter-type=boolean] smart-filter-builder {
    --smart-filter-builder-item-width: 34px
}

.smart-filter-panel[filter-type=boolean] smart-filter-builder .smart-editors-container,
.smart-filter-panel[filter-type=boolean] smart-filter-builder .smart-filter-value {
    min-width: 0;
    min-width: auto
}

.smart-filter-panel[filter-type=boolean] smart-filter-builder .smart-value-container {
    width: 100px
}

.smart-filter-panel[filter-type=boolean] smart-filter-builder .smart-editors-container[open] .smart-check-box-editor {
    width: 100%
}

.smart-filter-panel[right-to-left] {
    direction: rtl
}

.smart-filter-panel[right-to-left] smart-tree.standard-excel smart-tree-item:not([level="1"])>.smart-tree-item-label-container {
    margin-left: unset;
    margin-right: -30px
}

.smart-filter-panel span.case-sensitive.smart-icon {
    border: 1px solid transparent;
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    margin-left: 5px;
    padding: 5px;
    position: relative
}

.smart-filter-panel span.case-sensitive.smart-icon.smart-icon-font-size:after {
    content: "\\f088";
    content: var(--smart-icon-fontsize)
}

.smart-filter-panel span.case-sensitive.smart-icon:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: 1px solid var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-filter-panel span.case-sensitive.smart-icon.active,
.smart-filter-panel span.case-sensitive.smart-icon:active {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    left: -3px;
    margin-right: 5px;
    position: relative
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-contains:after {
    content: "\\f063";
    content: var(--smart-icon-contains)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-starts-with:after {
    content: "\\f064";
    content: var(--smart-icon-starts_with)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-ends-with:after {
    content: "\\f065";
    content: var(--smart-icon-ends_with)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-does-not-contain:after {
    content: "\\f066";
    content: var(--smart-icon-does_not_contain)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-equal:after {
    content: "\\f52c";
    content: var(--smart-icon-equals)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-greater-than:after {
    content: "\\f531";
    content: var(--smart-icon-greater-than)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-greater-than-equal:after {
    content: "\\f532";
    content: var(--smart-icon-greater-than-equal)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-less-than:after {
    content: "\\f536";
    content: var(--smart-icon-less-than)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-less-than-equal:after {
    content: "\\f537";
    content: var(--smart-icon-less-than-equal)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-not-equal:after {
    content: "\\f53e";
    content: var(--smart-icon-not-equal)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-between:after {
    content: "\\f06a";
    content: var(--smart-icon-between)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-empty:after,
.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-not-empty:after {
    content: "\\f096";
    content: var(--smart-icon-check-empty);
    position: relative;
    top: 1px
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-not-empty:before {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-size: 10px;
    left: calc(50% - 4px);
    position: absolute;
    top: calc(50% - 5px)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-null:after {
    content: "\\f10c";
    content: var(--smart-icon-circle-empty)
}

.smart-filter-panel-list-drop-down-menu.smart-input-drop-down-menu ul li span.smart-icon.smart-icon-not-null:after {
    content: "\\f111";
    content: var(--smart-icon-circle)
}

smart-gantt-chart {
    contain: content;
    display: block;
    height: 600px;
    height: var(--smart-gantt-chart-default-height);
    width: auto;
    width: var(--smart-gantt-chart-default-width)
}

.smart-gantt-chart .smart-splitter,
smart-gantt-chart .smart-splitter {
    border: none;
    border-radius: 0;
    border-radius: initial;
    height: 100%;
    width: 100%
}

.smart-gantt-chart smart-table,
smart-gantt-chart smart-table {
    --smart-table-row-height: var(--smart-gantt-chart-task-default-height);
    --smart-table-header-footer-height: var(--smart-gantt-chart-filter-row-height);
    height: 100%;
    width: 100%
}

.smart-gantt-chart.smart-container,
smart-gantt-chart>.smart-container {
    --smart-scroll-bar-default-height: 100%;
    --smart-scroll-bar-default-width: 100%;
    --smart-gantt-chart-task-timeline-content-height: calc(var(--smart-gantt-chart-task-default-height)*2);
    --smart-gantt-chart-task-splitter-bar-fit-size: var(--smart-gantt-chart-task-timeline-content-height);
    --smart-gantt-chart-resource-splitter-bar-fit-size: calc(var(--smart-gantt-chart-resource-timeline-content-height) + var(--smart-gantt-chart-task-default-height));
    --smart-gantt-chart-baseline-size: calc(var(--smart-gantt-chart-task-default-height)/var(--smart-gantt-chart-baseline-proportion));
    overflow: hidden
}

.smart-gantt-chart.smart-container:not(.hscroll),
smart-gantt-chart>.smart-container:not(.hscroll) {
    margin-bottom: -1px
}

.smart-gantt-chart.smart-container:not(.hscroll)[show-resource-panel],
smart-gantt-chart>.smart-container:not(.hscroll)[show-resource-panel] {
    margin-bottom: -4px
}

.smart-gantt-chart .smart-task-splitter>.smart-resize-trigger-container,
.smart-gantt-chart.smart-container .smart-splitter>.smart-resize-trigger-container,
smart-gantt-chart>.smart-container .smart-splitter>.smart-resize-trigger-container {
    margin-bottom: -2px
}

.smart-gantt-chart smart-splitter {
    --smart-splitter-bar-size: 5px
}

.smart-gantt-chart .smart-task-splitter smart-splitter-item>.smart-container,
.smart-gantt-chart .smart-task-splitter smart-splitter-item>.smart-container>.smart-content {
    overflow: hidden
}

.smart-gantt-chart smart-splitter-bar .smart-splitter-resize-button {
    display: none
}

.smart-gantt-chart smart-scroll-viewer {
    border: none;
    height: 100%;
    padding: initial;
    width: 100%
}

.smart-gantt-chart .smart-table {
    --smart-table-cell-padding: var(--smart-gantt-chart-task-bar-fill-padding)
}

.smart-gantt-chart .smart-table.smart-task-table {
    --smart-table-column-header-height: calc(var(--smart-gantt-chart-task-default-height)*2 - var(--smart-border-width)/2)
}

.smart-gantt-chart .smart-table.smart-resource-table {
    --smart-table-column-header-height: calc(var(--smart-gantt-chart-task-default-height) - var(--smart-border-width)/2)
}

.smart-gantt-chart .smart-table>.smart-container {
    border: initial
}

.smart-gantt-chart .smart-table[hide-selection-column] tr td {
    background: inherit
}

.smart-gantt-chart .smart-table[hide-selection-column] tr[aria-selected=true] td {
    background: transparent none repeat 0 0/auto auto padding-box border-box scroll;
    background: initial
}

.smart-gantt-chart .smart-table thead tr th,
.smart-gantt-chart .smart-table thead tr th.smart-table-select-all.freeze-near {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-gantt-chart .smart-table .smart-table-virtualization-container .smart-scroll-viewer-content-container {
    display: block
}

.smart-gantt-chart .smart-table td.tree-cell>div .hierarchy-arrow:after {
    display: inline;
    display: initial
}

.smart-gantt-chart .smart-table td div,
.smart-gantt-chart .smart-table td span {
    line-height: inherit
}

.smart-gantt-chart .smart-table td.tree-cell>div div:nth-child(2) {
    line-height: 1rem
}

.smart-gantt-chart .smart-table thead tr th {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.smart-gantt-chart .smart-table tbody tr {
    cursor: pointer;
    text-overflow: ellipsis;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    white-space: nowrap
}

.smart-gantt-chart .smart-table tbody tr td {
    line-height: 100%
}

.smart-gantt-chart .smart-table tbody tr[unused] td {
    border: initial
}

.smart-gantt-chart .smart-table tbody tr[focus] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-gantt-chart .smart-table tbody tr[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-gantt-chart .smart-table tbody tr[aria-selected=true] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-gantt-chart .smart-table td {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    border-top: none
}

.smart-gantt-chart .smart-table td[data-field=overdue]:after {
    align-items: center;
    color: #b00020;
    color: var(--smart-gantt-chart-deadline-color);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 1.25em;
    height: 100%;
    left: 0;
    padding-left: 12px;
    padding-left: var(--smart-table-cell-padding);
    padding-right: 12px;
    padding-right: var(--smart-table-cell-padding);
    pointer-events: none;
    position: absolute;
    top: 0
}

.smart-gantt-chart .smart-table td[data-field=overdue][overdue]:after {
    content: "\\e805";
    content: var(--smart-gantt-chart-deadline-icon)
}

.smart-gantt-chart .smart-table[freeze-footer] .smart-table-container:focus td[focus]:after {
    height: 100%
}

@-moz-document url-prefix() {
    .smart-gantt-chart .smart-table.smart-task-table {
        --smart-table-column-header-height: calc(var(--smart-gantt-chart-task-default-height)*2)
    }

    .smart-gantt-chart .smart-table.smart-resource-table {
        --smart-table-column-header-height: var(--smart-gantt-chart-task-default-height)
    }

    .smart-gantt-chart .smart-table[freeze-footer] .smart-table-container:focus td[focus]:after {
        top: 0
    }
}

.smart-gantt-chart[group-by-resources] .smart-table tbody tr[role=group],
.smart-gantt-chart[group-by-resources] .smart-table tbody tr[role=group] .selection-checkbox {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: auto
}

.smart-gantt-chart[group-by-resources] .smart-table tbody tr[role=group] .selection-checkbox {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.smart-gantt-chart[group-by-resources] .smart-table tbody tr[role=group] .selection-checkbox:after,
.smart-gantt-chart[group-by-resources] .smart-table tbody tr[role=group] .selection-checkbox:before {
    content: normal
}

.smart-gantt-chart[resource-filtering] .smart-resource-splitter .smart-timeline-header:before,
.smart-gantt-chart[task-filtering] .smart-task-splitter .smart-timeline-header:before,
.smart-gantt-chart[task-filtering][filter-row] .smart-task-splitter .smart-timeline-header:after {
    content: ""
}

.smart-gantt-chart.smart-container,
.smart-gantt-chart>.smart-container {
    position: relative
}

.smart-gantt-chart.smart-container.hscroll>smart-splitter,
.smart-gantt-chart>.smart-container.hscroll>smart-splitter {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-gantt-chart.smart-container>.smart-popup-window-modal,
.smart-gantt-chart>.smart-container>.smart-popup-window-modal {
    background-color: #ccc;
    background-color: var(--smart-disabled);
    left: 0;
    min-height: 100%;
    opacity: .5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9998;
    z-index: calc(var(--smart-editor-drop-down-z-index) - 1)
}

.smart-gantt-chart .smart-splitter>.smart-container>smart-splitter-bar>.smart-container {
    -webkit-transform: scaleX(5);
    transform: scaleX(5);
    -webkit-transform-origin: left;
    transform-origin: left
}

.smart-gantt-chart .smart-splitter:not([dragged]) smart-splitter-bar.smart-element {
    background-color: #e0e0e0;
    background-color: var(--smart-border)
}

.smart-gantt-chart .smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar>.smart-container {
    -webkit-transform: scaleY(2.5);
    transform: scaleY(2.5);
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-gantt-chart .smart-timeline {
    height: 100%;
    overflow: hidden;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart .smart-timeline[task-bar-hovered],
.smart-gantt-chart .smart-timeline[task-bar-hovered] .smart-timeline-task.project .smart-timeline-task-fill,
.smart-gantt-chart .smart-timeline[task-bar-hovered] .smart-timeline-task.task .smart-timeline-task-fill {
    cursor: e-resize
}

.smart-gantt-chart[task-filtering][hide-timeline-header-details] .smart-task-splitter .smart-timeline-view-cells .smart-timeline-view-cell {
    border-top: initial
}

.smart-gantt-chart[task-filtering][hide-timeline-header-details] .smart-task-splitter .smart-timeline-content-container {
    height: calc(100% - 60px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-filter-row-height))
}

.smart-gantt-chart[task-filtering] .smart-task-splitter .smart-timeline-content-container {
    height: calc(100% - 90px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height)*2 - var(--smart-gantt-chart-filter-row-height))
}

.smart-gantt-chart[resource-filtering] .smart-resource-splitter {
    --smart-splitter-bar-fit-size: calc(var(--smart-gantt-chart-resource-splitter-bar-fit-size) + var(--smart-gantt-chart-filter-row-height))
}

.smart-gantt-chart[task-filtering][filter-row] .smart-task-splitter .smart-timeline-header:before {
    content: none
}

.smart-gantt-chart .smart-timeline-header {
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-timeline-header:after,
.smart-gantt-chart .smart-timeline-header:before {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border) solid var(--smart-border-width);
    box-sizing: border-box;
    display: block;
    height: 30px;
    height: var(--smart-gantt-chart-filter-row-height);
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    width: 100%
}

.smart-gantt-chart .smart-timeline-header .smart-timeline-header-content {
    width: 100%
}

.smart-gantt-chart .smart-timeline-content-container {
    height: calc(100% - 60px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height)*2);
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-timeline-content {
    height: 100%;
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-timeline-content:empty:after {
    align-items: center;
    content: "Нет результатов";
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    justify-content: center;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart .smart-timeline-content .smart-timeline-task:not(.milestone)[disable-resize] .smart-task-container:after,
.smart-gantt-chart .smart-timeline-content .smart-timeline-task:not(.milestone)[disable-resize]:after {
    content: none
}

.smart-gantt-chart .smart-timeline-container {
    display: inline-block;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-timeline-scroll-bar {
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-timeline-scroll-bar:after {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    content: "";
    height: 18px;
    height: var(--smart-scroll-bar-size);
    left: 100%;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-gantt-chart .smart-timeline-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-gantt-chart .smart-timeline-scroll-bar.smart-resource-scroll-bar[orientation=vertical] {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height));
    top: 30px;
    top: var(--smart-gantt-chart-task-default-height);
    z-index: 1
}

.smart-gantt-chart .smart-timeline-scroll-bar.smart-resource-scroll-bar[orientation=vertical]:before {
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    top: -30px;
    top: calc(var(--smart-gantt-chart-task-default-height)*-1)
}

.smart-gantt-chart .smart-timeline-scroll-bar[orientation=vertical] {
    height: calc(100% - 60px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height)*2);
    position: absolute;
    right: 0;
    top: 60px;
    top: calc(var(--smart-gantt-chart-task-default-height)*2);
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-gantt-chart .smart-timeline-scroll-bar[orientation=vertical]:before {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-top: none;
    box-sizing: border-box;
    content: "";
    height: 60px;
    height: calc(var(--smart-gantt-chart-task-default-height)*2);
    left: 0;
    position: absolute;
    top: -60px;
    top: calc(var(--smart-gantt-chart-task-default-height)*-2);
    width: 100%
}

.smart-gantt-chart[show-baseline] .smart-timeline-task.milestone .smart-task-container:after,
.smart-gantt-chart[show-baseline] .smart-timeline-task.milestone .smart-task-container:before {
    border-bottom: calc(var(--smart-gantt-chart-task-default-height)/2 - var(--smart-gantt-chart-baseline-size)/2) solid transparent;
    border-top: calc(var(--smart-gantt-chart-task-default-height)/2 - var(--smart-gantt-chart-baseline-size)/2) solid transparent
}

.smart-gantt-chart .smart-timeline-scroll-bar[orientation=vertical][disabled]:after {
    height: 100%;
    left: 0
}

.smart-gantt-chart[show-baseline] .smart-timeline-task {
    height: calc(30px - var(--smart-gantt-chart-baseline-size));
    height: calc(var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-baseline-size))
}

.smart-gantt-chart[show-baseline] .smart-timeline-task .smart-task-container {
    padding-bottom: 2.5px;
    padding-bottom: calc(var(--smart-gantt-chart-task-bar-fill-padding)/2)
}

.smart-gantt-chart[show-baseline] .smart-timeline-task.milestone .smart-task-container:after {
    border-left: calc(var(--smart-gantt-chart-task-default-height)/2 - var(--smart-gantt-chart-baseline-size)/2) solid var(--smart-gantt-chart-milestone-color)
}

.smart-gantt-chart[show-baseline] .smart-timeline-task.milestone .smart-task-container:before {
    border-right: calc(var(--smart-gantt-chart-task-default-height)/2 - var(--smart-gantt-chart-baseline-size)/2) solid var(--smart-gantt-chart-milestone-color);
    left: calc(-15px - var(--smart-gantt-chart-baseline-size)/2*-1);
    left: calc(var(--smart-gantt-chart-task-default-height)/2*-1 - var(--smart-gantt-chart-baseline-size)/2*-1)
}

.smart-gantt-chart[show-baseline] .smart-task-connection-point {
    top: calc(15px - var(--smart-gantt-chart-baseline-size)/2);
    top: calc(var(--smart-gantt-chart-task-default-height)/2 - var(--smart-gantt-chart-baseline-size)/2)
}

.smart-gantt-chart[show-baseline] .smart-task-connection-point.end,
.smart-gantt-chart[show-baseline] .smart-task-connection-point.start {
    height: 10px;
    height: calc(var(--smart-gantt-chart-task-default-height)/3);
    width: 10px;
    width: calc(var(--smart-gantt-chart-task-default-height)/3)
}

.smart-gantt-chart[show-baseline] .smart-task-connection-point.end {
    right: -15px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart[show-baseline] .smart-task-connection-point.start {
    left: -15px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart .smart-timeline-task {
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    position: absolute
}

.smart-gantt-chart .smart-timeline-task:empty {
    height: 0
}

.smart-gantt-chart .smart-timeline-task .smart-timeline-task-progress-thumb:after {
    border-bottom: 10px solid rgba(0, 0, 0, .55);
    border-bottom: var(--smart-gantt-chart-timeline-task-progress-thumb-size) solid var(--smart-gantt-chart-task-thumb-color);
    border-left: 10px solid transparent;
    border-left: var(--smart-gantt-chart-timeline-task-progress-thumb-size) solid transparent;
    border-right: 10px solid transparent;
    border-right: var(--smart-gantt-chart-timeline-task-progress-thumb-size) solid transparent;
    bottom: -2.5px;
    bottom: calc(var(--smart-gantt-chart-task-bar-fill-padding)*-1/2);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, .55);
    box-shadow: 0 1px 0 0 var(--smart-gantt-chart-task-thumb-color);
    content: "";
    left: -10px;
    left: calc(var(--smart-gantt-chart-timeline-task-progress-thumb-size)*-1);
    position: absolute;
    z-index: 1
}

.smart-gantt-chart .smart-timeline-task:not(.milestone) .smart-task-container:after,
.smart-gantt-chart .smart-timeline-task:not(.milestone):after {
    background-color: #fff;
    background-color: var(--smart-gantt-chart-timeline-task-resize-indicator-color);
    box-shadow: 0 0 0 1px #333;
    box-shadow: 0 0 0 1px var(--smart-gantt-chart-timeline-task-resize-indicator-border-color);
    height: 4px;
    height: var(--smart-gantt-chart-timeline-task-resize-indicator-width);
    pointer-events: none;
    position: absolute;
    top: calc(50% - 2px);
    top: calc(50% - var(--smart-gantt-chart-timeline-task-resize-indicator-width)/2);
    -webkit-transform: scale(0);
    transform: scale(0);
    width: 4px;
    width: var(--smart-gantt-chart-timeline-task-resize-indicator-width)
}

.smart-gantt-chart .smart-timeline-task.task .smart-timeline-task-label {
    color: var(--smart-gantt-chart-task-label-color)
}

.smart-gantt-chart .smart-timeline-task.task[selected] .smart-timeline-task-label {
    color: var(--smart-gantt-chart-task-label-color-selected)
}

.smart-gantt-chart .smart-timeline-task.project .smart-timeline-task-label {
    color: #333;
    color: var(--smart-gantt-chart-project-label-color)
}

.smart-gantt-chart .smart-timeline-task.project[selected] .smart-timeline-task-label {
    color: #000;
    color: var(--smart-gantt-chart-project-label-color-selected)
}

.smart-gantt-chart .smart-timeline-task.project .smart-task-segments:before {
    content: normal
}

.smart-gantt-chart .smart-timeline-task:not(.milestone) {
    min-width: 5px;
    min-width: var(--smart-gantt-chart-timeline-task-min-width)
}

.smart-gantt-chart .smart-timeline-task:not(.milestone):after {
    content: "";
    left: calc(100% - 2px);
    left: calc(100% - var(--smart-gantt-chart-timeline-task-resize-indicator-width)/2)
}

.smart-gantt-chart .smart-timeline-task:not(.milestone) .smart-task-container:after {
    content: "";
    left: -2px;
    left: calc(var(--smart-gantt-chart-timeline-task-resize-indicator-width)*-1/2)
}

.smart-gantt-chart .smart-timeline-task[selected]:not([disable-resize]) .smart-task-container:after,
.smart-gantt-chart .smart-timeline-task[selected]:not([disable-resize]):after,
.smart-gantt-chart .smart-timeline-task[selected]:not([resource-group]) .smart-timeline-task-progress-thumb {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-gantt-chart .smart-timeline-task[selected]:not(.milestone) .smart-timeline-task-fill {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2)
}

.smart-gantt-chart .smart-timeline-task[connection-point=end] .smart-task-connection-feedback {
    left: 100%
}

.smart-gantt-chart .smart-timeline-task[disable-drag] {
    cursor: pointer
}

.smart-gantt-chart .smart-timeline-task[resource-group] {
    cursor: auto
}

.smart-gantt-chart .smart-timeline-task .smart-task-segment,
.smart-gantt-chart .smart-timeline-task .smart-task-segments {
    height: 100%;
    width: 100%
}

.smart-gantt-chart .smart-timeline-task .smart-task-segments {
    position: relative
}

.smart-gantt-chart .smart-timeline-task .smart-task-segments:before {
    border-bottom: 1px dashed #2bc3be;
    border-bottom: var(--smart-gantt-chart-segment-link-size) dashed var(--smart-gantt-chart-segment-link-color);
    box-sizing: border-box;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    top: calc(50% - .5px);
    top: calc(50% - var(--smart-gantt-chart-segment-link-size)/2);
    width: 100%
}

.smart-gantt-chart .smart-timeline-task .smart-task-segment {
    min-width: 5px;
    min-width: var(--smart-gantt-chart-timeline-task-min-width);
    position: absolute
}

.smart-gantt-chart .smart-timeline-task .smart-task-segment[deadline]:after {
    -webkit-margin-start: 10px;
    align-items: center;
    content: attr(deadline);
    display: flex;
    font-size: .8em;
    font-weight: 600;
    height: 100%;
    left: 100%;
    margin-inline-start: 10px;
    pointer-events: none;
    position: absolute;
    top: 0;
    white-space: nowrap
}

.smart-gantt-chart .smart-timeline-view-cells:empty:after,
.smart-gantt-chart .smart-timeline-view-details:empty:after {
    content: " - ";
    content: var(--smart-gantt-chart-header-placeholder)
}

.smart-gantt-chart .smart-timeline-task-progress {
    height: 100%;
    pointer-events: none;
    position: relative;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 100%
}

.smart-gantt-chart .smart-timeline-task-progress-thumb {
    cursor: e-resize;
    position: absolute;
    right: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom
}

.smart-gantt-chart .smart-timeline-task-fill {
    border-radius: 0;
    border-radius: var(--smart-gantt-chart-task-fill-border-radius);
    height: 100%;
    overflow: hidden;
    width: 100%
}

.smart-gantt-chart .smart-timeline-task-label {
    align-items: center;
    display: flex;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 2px 5px;
    padding: var(--smart-gantt-chart-task-label-padding);
    pointer-events: none;
    position: absolute;
    top: 0;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    width: 100%
}

.smart-gantt-chart .smart-timeline-view-cells:empty,
.smart-gantt-chart .smart-timeline-view-details:empty {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    justify-content: center
}

.smart-gantt-chart .smart-timeline-task-label>div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-gantt-chart .smart-timeline-task-cells {
    position: relative
}

.smart-gantt-chart .smart-timeline-view-details {
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    width: 100%
}

.smart-gantt-chart .smart-timeline-view-details:empty {
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart .smart-timeline-view-details .smart-timeline-view-cell {
    border-top: none;
    min-width: 0;
    min-width: auto
}

.smart-gantt-chart .smart-timeline-row .smart-timeline-cell,
.smart-gantt-chart .smart-timeline-view-cell {
    min-width: 70px;
    min-width: var(--smart-gantt-chart-timeline-cell-min-size);
    padding: 5px;
    padding: var(--smart-gantt-chart-task-bar-fill-padding)
}

.smart-gantt-chart .smart-timeline-view-details .smart-timeline-view-cell:not(:first-of-type) {
    border-left-color: transparent
}

.smart-gantt-chart .smart-timeline-view-cells {
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    width: 100%
}

.smart-gantt-chart .smart-timeline-view-cells:empty {
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart .smart-timeline-view-cells .smart-timeline-view-cell:last-of-type:after {
    border-right-color: transparent
}

.smart-gantt-chart .smart-timeline-view-cells .smart-timeline-view-cell:not(:first-of-type) {
    border-left-color: transparent
}

.smart-gantt-chart .smart-timeline-view-cells .smart-timeline-view-cell[weekend] {
    background: #eff5fd;
    background: var(--smart-gantt-chart-timeline-weekend-color)
}

.smart-gantt-chart .smart-timeline-view-cells .smart-timeline-view-cell[nonworking] {
    background: #f5f5f5;
    background: var(--smart-gantt-chart-timeline-nonworking-color)
}

.smart-gantt-chart .smart-timeline-view-cells div {
    border-bottom-color: #e0e0e0;
    border-bottom-color: var(--smart-border)
}

.smart-gantt-chart .smart-timeline-view-cell {
    align-items: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-color: transparent;
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    justify-content: center;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: auto;
    width: var(--smart-gantt-chart-timeline-cell-size)
}

.smart-gantt-chart .smart-timeline-view-cell:first-of-type {
    border-left: none
}

.smart-gantt-chart .smart-timeline-view-cell:last-of-type {
    border-right: none
}

.smart-gantt-chart .smart-timeline-view-cell>div {
    overflow: hidden;
    pointer-events: none;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-gantt-chart .smart-timeline-cells-container {
    width: 100%
}

.smart-gantt-chart .smart-timeline-deadlines-container:empty,
.smart-gantt-chart .smart-timeline-indicators-container:empty,
.smart-gantt-chart .smart-timeline-markers-container:empty {
    display: none
}

.smart-gantt-chart .smart-gantt-chart-date-marker {
    background: #005c99;
    background: var(--smart-gantt-chart-date-marker-background);
    border-left: 1px dashed #fff;
    border-left: var(--smart-gantt-chart-date-marker-width) dashed var(--smart-gantt-chart-date-marker-color);
    color: #fff;
    color: var(--smart-gantt-chart-date-marker-color);
    height: 100%;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 0
}

.smart-gantt-chart .smart-gantt-chart-date-marker .smart-gantt-chart-marker-label {
    -webkit-margin-start: 10px;
    -webkit-margin-start: var(--smart-gantt-chart-date-marker-h-offset);
    align-items: center;
    background: inherit;
    border-radius: 0;
    border-radius: var(--smart-gantt-chart-task-fill-border-radius);
    box-sizing: border-box;
    color: inherit;
    display: inline-flex;
    height: 25px;
    height: var(--smart-gantt-chart-date-marker-height);
    margin-inline-start: 10px;
    margin-inline-start: var(--smart-gantt-chart-date-marker-h-offset);
    padding: 5px;
    position: -webkit-sticky;
    position: sticky;
    top: 15%;
    top: var(--smart-gantt-chart-date-marker-v-offset);
    white-space: nowrap
}

.smart-gantt-chart .smart-gantt-chart-date-marker .smart-gantt-chart-marker-label:before {
    border-bottom: 12.5px solid transparent;
    border-bottom: calc(var(--smart-gantt-chart-date-marker-height)/2) solid transparent;
    border-right: 12.5px solid #005c99;
    border-right: calc(var(--smart-gantt-chart-date-marker-height)/2) solid var(--smart-gantt-chart-date-marker-background);
    border-top: 12.5px solid transparent;
    border-top: calc(var(--smart-gantt-chart-date-marker-height)/2) solid transparent;
    box-sizing: inherit;
    content: "";
    position: absolute;
    right: 100%
}

.smart-gantt-chart .smart-gantt-chart-task-indicator {
    align-items: center;
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    position: absolute;
    white-space: nowrap
}

.smart-gantt-chart .smart-gantt-chart-task-indicator.icon:before {
    -webkit-margin-end: 2.5px;
    content: normal;
    content: var(--smart-gantt-chart-indicator-icon);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    margin-inline-end: 2.5px
}

.smart-gantt-chart .smart-gantt-chart-task-deadline {
    align-items: center;
    display: inline-flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    justify-content: center;
    position: absolute;
    width: 1px
}

.smart-gantt-chart .smart-gantt-chart-task-deadline:before {
    color: #b00020;
    color: var(--smart-gantt-chart-deadline-color);
    content: "\\e805";
    content: var(--smart-gantt-chart-deadline-icon);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 1.25em
}

.smart-gantt-chart .smart-gantt-chart-task-baseline {
    background: rgba(166, 205, 87, .5);
    background: var(--smart-gantt-chart-baseline-background);
    background-clip: content-box;
    border-bottom: 5px solid transparent;
    border-bottom: var(--smart-gantt-chart-task-bar-fill-padding) solid transparent;
    border-top: 2.5px solid transparent;
    border-top: calc(var(--smart-gantt-chart-task-bar-fill-padding)/2) solid transparent;
    height: var(--smart-gantt-chart-baseline-size);
    max-height: 30px;
    max-height: var(--smart-gantt-chart-task-default-height);
    pointer-events: none;
    position: absolute;
    -webkit-transform: translateY(calc(30px - var(--smart-gantt-chart-baseline-size)));
    transform: translateY(calc(30px - var(--smart-gantt-chart-baseline-size)));
    -webkit-transform: translateY(calc(var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-baseline-size)));
    transform: translateY(calc(var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-baseline-size)))
}

.smart-gantt-chart .smart-gantt-chart-time-indicators-container {
    pointer-events: none
}

.smart-gantt-chart .smart-gantt-chart-time-indicators-container .smart-gantt-chart-current-time-indicator {
    background: #005c99;
    background: var(--smart-gantt-chart-current-time-indicator-background);
    height: 100%;
    position: absolute;
    width: 1px;
    width: var(--smart-gantt-chart-current-time-indicator-size)
}

.smart-gantt-chart .smart-gantt-chart-time-indicators-container .smart-gantt-chart-current-time-indicator:before {
    border-left: 7px solid transparent;
    border-left: var(--smart-gantt-chart-current-time-indicator-arrow-size) solid transparent;
    border-right: 7px solid transparent;
    border-right: var(--smart-gantt-chart-current-time-indicator-arrow-size) solid transparent;
    border-top: 7px solid #005c99;
    border-top: var(--smart-gantt-chart-current-time-indicator-arrow-size) solid var(--smart-gantt-chart-current-time-indicator-background);
    left: -6.5px;
    left: calc(var(--smart-gantt-chart-current-time-indicator-arrow-size)*-1 + var(--smart-gantt-chart-current-time-indicator-size)/2);
    position: absolute
}

.smart-gantt-chart .smart-gantt-chart-time-indicators-container .smart-gantt-chart-current-time-shader {
    background: hsla(0, 48%, 92%, .5);
    background: var(--smart-gantt-chart-shader-background);
    height: 100%;
    position: absolute
}

.smart-gantt-chart[current-time-indicator] .smart-gantt-chart-current-time-indicator:before {
    content: ""
}

.smart-gantt-chart[current-time-indicator] .smart-timeline-view-cell[current] {
    border-bottom: 2px solid #005c99;
    border-bottom: var(--smart-gantt-chart-current-time-indicator-header-size) solid var(--smart-gantt-chart-current-time-indicator-background)
}

.smart-gantt-chart .smart-timeline-row {
    background: transparent;
    background: var(--smart-gantt-chart-timeline-task-background-color);
    border-bottom-color: #e0e0e0;
    border-style: solid;
    border-width: 1px;
    border-bottom: solid var(--smart-border);
    border-top: initial;
    border-width: var(--smart-border-width);
    border-left: none;
    border-right: none;
    display: flex;
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    left: 0;
    position: absolute;
    width: inherit
}

.smart-gantt-chart .smart-timeline-row:first-of-type {
    border-left-color: #e0e0e0;
    border-left-color: var(--smart-border)
}

.smart-gantt-chart .smart-timeline-row:last-of-type {
    border-right-color: #e0e0e0;
    border-right-color: var(--smart-border)
}

.smart-gantt-chart .smart-timeline-row[hover] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover)
}

.smart-gantt-chart .smart-timeline-row[selected] {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected)
}

.smart-gantt-chart .smart-timeline-row .smart-timeline-cell {
    height: 100%;
    position: absolute;
    width: auto;
    width: var(--smart-gantt-chart-timeline-cell-size)
}

.smart-gantt-chart .smart-timeline-row .smart-timeline-cell:not(:last-of-type) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-gantt-chart .smart-timeline-row:not([hover]):not([selected]) .smart-timeline-cell[weekend] {
    background: #eff5fd;
    background: var(--smart-gantt-chart-timeline-weekend-color)
}

.smart-gantt-chart .smart-timeline-row:not([hover]):not([selected]) .smart-timeline-cell[nonworking] {
    background: #f5f5f5;
    background: var(--smart-gantt-chart-timeline-nonworking-color)
}

.smart-gantt-chart .smart-resource-splitter {
    --smart-splitter-bar-fit-size: var(--smart-gantt-chart-resource-splitter-bar-fit-size)
}

.smart-gantt-chart .smart-resource-splitter .smart-timeline-content {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height));
    overflow: hidden;
    position: relative
}

.smart-gantt-chart .smart-resource-splitter .smart-timeline-view-cells .smart-timeline-view-cell {
    border-top: none
}

.smart-gantt-chart .smart-resource-splitter .smart-timeline-row .smart-timeline-cell {
    padding: initial
}

.smart-gantt-chart .smart-resource-splitter-item>.smart-container>.smart-content {
    overflow: hidden
}

.smart-gantt-chart .smart-resource-splitter-item .smart-timeline-view-cells .smart-timeline-view-cell:after {
    height: var(--smart-gantt-chart-resource-timeline-content-height)
}

.smart-gantt-chart .smart-resource-splitter-item[show-header] .smart-resource-splitter {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-header-height))
}

.smart-gantt-chart .smart-resource-splitter-item .smart-timeline-cell:first-of-type .smart-resource-timeline-view-cell {
    left: 0;
    width: 100%
}

.smart-gantt-chart .smart-resource-panel-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border) solid var(--smart-border-width);
    height: 30px;
    height: var(--smart-gantt-chart-header-height);
    justify-content: center;
    width: 100%
}

.smart-gantt-chart .smart-resource-panel-header:empty {
    display: none
}

.smart-gantt-chart .smart-resource-timeline-view-cell {
    align-items: center;
    background: transparent;
    background: var(--smart-gantt-chart-timeline-task-background-color);
    border: none;
    bottom: 0;
    display: flex;
    height: 100%;
    justify-content: center;
    left: -1px;
    left: calc(var(--smart-border-width)*-1);
    position: absolute;
    width: calc(100% + 1px);
    width: calc(100% + var(--smart-border-width))
}

.smart-gantt-chart .smart-resource-timeline-view-cell:after {
    align-items: center;
    box-sizing: border-box;
    content: "";
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    overflow: hidden
}

.smart-gantt-chart .smart-task-panel-header:empty,
.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-view-details {
    display: none
}

.smart-gantt-chart .smart-resource-timeline-view-cell[load]:after {
    content: attr(load);
    -webkit-transform: scale(1) rotate(0);
    transform: scale(1) rotate(0)
}

.smart-gantt-chart .smart-resource-timeline-view-cell.warning[load]:after {
    background: #b00020;
    background: var(--smart-error);
    border-radius: 5px;
    color: #fff;
    color: var(--smart-error-color)
}

.smart-gantt-chart .smart-task-container {
    box-sizing: border-box;
    height: 100%;
    padding-bottom: 5px;
    padding-bottom: var(--smart-gantt-chart-task-bar-fill-padding);
    padding-top: 5px;
    padding-top: var(--smart-gantt-chart-task-bar-fill-padding);
    position: relative;
    width: 100%
}

.smart-gantt-chart .smart-task-panel-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    height: 30px;
    height: var(--smart-gantt-chart-header-height);
    justify-content: center;
    width: 100%
}

.smart-gantt-chart .smart-task-splitter {
    --smart-splitter-bar-fit-size: var(--smart-gantt-chart-task-splitter-bar-fit-size)
}

.smart-gantt-chart .smart-task-splitter-item>.smart-container>.smart-content {
    overflow: hidden
}

.smart-gantt-chart .smart-task-splitter-item[show-header] .smart-task-panel-header {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

.smart-gantt-chart .smart-task-splitter-item[show-header] .smart-task-splitter {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-header-height))
}

.smart-gantt-chart .smart-task-splitter-item[show-header] .smart-timeline-view-details .smart-timeline-view-cell {
    border-top: initial
}

.smart-gantt-chart .smart-task-connection {
    border: 1px solid #e6510a;
    border: var(--smart-gantt-chart-timeline-task-connection-width) var(--smart-gantt-chart-timeline-task-connection-style) var(--smart-gantt-chart-timeline-task-connection-color);
    cursor: pointer;
    position: absolute;
    top: 50%
}

.smart-gantt-chart .smart-task-connection:after {
    border: transparent;
    border-width: 10px;
    content: "";
    height: 100%;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%
}

.smart-gantt-chart .smart-task-connection[arrow-direction]:before {
    border-bottom: 5px solid transparent;
    border-bottom: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) transparent;
    border-left: 5px solid #e6510a;
    border-left: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    border-top: 5px solid transparent;
    border-top: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) transparent;
    content: "";
    left: calc(100% - 4px);
    left: calc(100% - var(--smart-gantt-chart-timeline-task-connection-arrow-width) + 1px);
    position: absolute;
    top: -5px;
    top: calc(var(--smart-gantt-chart-timeline-task-connection-arrow-width)*-1)
}

.smart-gantt-chart .smart-task-connection[arrow-direction=left]:before {
    border-left: none;
    border-right: 5px solid #e6510a;
    border-right: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    left: -1.5px;
    left: calc(var(--smart-gantt-chart-timeline-task-connection-arrow-width)*-1/2 + 1px)
}

.smart-gantt-chart .smart-task-connection[hover] {
    border-color: #e6510a;
    border-color: var(--smart-gantt-chart-timeline-task-connection-color-hover);
    box-shadow: 0 0 2.5px 0 #e6510a;
    box-shadow: 0 0 2.5px 0 var(--smart-gantt-chart-timeline-task-connection-color)
}

.smart-gantt-chart .smart-task-connection[hover]:before {
    border-left-color: #e6510a;
    border-left-color: var(--smart-gantt-chart-timeline-task-connection-color-hover);
    border-right-color: #e6510a;
    border-right-color: var(--smart-gantt-chart-timeline-task-connection-color-hover)
}

.smart-gantt-chart .smart-task-connection-point {
    background-color: #dedede;
    border: 1px solid #a9a9a9;
    border-radius: 50%;
    cursor: pointer;
    height: 15px;
    height: calc(var(--smart-gantt-chart-task-default-height)/2);
    position: absolute;
    top: 15px;
    top: calc(var(--smart-gantt-chart-task-default-height)/2);
    -webkit-transform: scale(0);
    transform: scale(0);
    width: 15px;
    width: calc(var(--smart-gantt-chart-task-default-height)/2)
}

.smart-gantt-chart .smart-task-connection-point.start {
    left: -20px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1/1.5)
}

.smart-gantt-chart .smart-task-connection-point.end {
    right: -20px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1/1.5)
}

.smart-gantt-chart .smart-task-connection-feedback {
    border: 1px dashed #e6510a;
    border: var(--smart-gantt-chart-timeline-task-connection-feedback-width) var(--smart-gantt-chart-timeline-task-connection-feedback-style) var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    pointer-events: none;
    position: absolute;
    top: 50%;
    -webkit-transform-origin: left;
    transform-origin: left;
    z-index: 1
}

.smart-gantt-chart .smart-task-connection-feedback:before {
    border-bottom: 5px solid transparent;
    border-bottom: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) transparent;
    border-left: 5px solid #e6510a;
    border-left: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    border-top: 5px solid transparent;
    border-top: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) transparent;
    content: "";
    left: calc(100% - 4px);
    left: calc(100% - var(--smart-gantt-chart-timeline-task-connection-arrow-width) + 1px);
    position: absolute;
    top: -5px;
    top: calc(var(--smart-gantt-chart-timeline-task-connection-arrow-width)*-1)
}

.smart-gantt-chart .milestone .smart-task-connection-feedback,
.smart-gantt-chart .milestone .smart-task-container:before {
    left: -15px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart .smart-task-bar-limiter {
    height: 100%;
    position: absolute;
    top: 0;
    width: 1px
}

.smart-gantt-chart .smart-task-bar-limiter.min {
    border: 1px dashed #90ee90;
    border: var(--smart-border-width) dashed #90ee90
}

.smart-gantt-chart .smart-task-bar-limiter.max {
    border: 1px dashed red;
    border: var(--smart-border-width) dashed red
}

.smart-gantt-chart .smart-task-bar-limiter.max-date,
.smart-gantt-chart .smart-task-bar-limiter.min-date {
    background-image: linear-gradient(135deg, rgba(255, 0, 0, .2) 25%, transparent 0, transparent 50%, rgba(255, 0, 0, .2) 0, rgba(255, 0, 0, .2) 75%, transparent 0, transparent);
    background-size: 1rem 1rem;
    border: 1px solid #fff
}

.smart-gantt-chart .milestone .smart-task-container:after,
.smart-gantt-chart .milestone .smart-task-container:before {
    border-bottom: 15px solid transparent;
    border-bottom: calc(var(--smart-gantt-chart-task-default-height)/2) solid transparent;
    border-top: 15px solid transparent;
    border-top: calc(var(--smart-gantt-chart-task-default-height)/2) solid transparent
}

.smart-gantt-chart .smart-task-bar-limiter.max-date {
    right: 0
}

.smart-gantt-chart .milestone {
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    padding: initial
}

.smart-gantt-chart .milestone .smart-task-container {
    padding: 0
}

.smart-gantt-chart .milestone .smart-task-container:after,
.smart-gantt-chart .milestone .smart-task-container:before {
    box-sizing: border-box;
    content: "";
    position: absolute;
    top: 0
}

.smart-gantt-chart .milestone .smart-task-container:before {
    border-right: 15px solid purple;
    border-right: calc(var(--smart-gantt-chart-task-default-height)/2) solid var(--smart-gantt-chart-milestone-color)
}

.smart-gantt-chart .milestone .smart-task-container:after {
    border-left: 15px solid purple;
    border-left: calc(var(--smart-gantt-chart-task-default-height)/2) solid var(--smart-gantt-chart-milestone-color)
}

.smart-gantt-chart .milestone .smart-task-connection-point.start {
    -webkit-transform: translateX(-15px) scale(0);
    transform: translateX(-15px) scale(0);
    -webkit-transform: translateX(calc(var(--smart-gantt-chart-task-default-height)*-1/2)) scale(0);
    transform: translateX(calc(var(--smart-gantt-chart-task-default-height)*-1/2)) scale(0)
}

.smart-gantt-chart .milestone .smart-task-connection-point.end {
    -webkit-transform: translateX(15px) scale(0);
    transform: translateX(15px) scale(0);
    -webkit-transform: translateX(calc(var(--smart-gantt-chart-task-default-height)/2)) scale(0);
    transform: translateX(calc(var(--smart-gantt-chart-task-default-height)/2)) scale(0)
}

.smart-gantt-chart .milestone[connection-point=end] .smart-task-connection-feedback {
    left: calc(100% + 15px);
    left: calc(100% + var(--smart-gantt-chart-task-default-height)/2)
}

.smart-gantt-chart .milestone .smart-task-segment {
    min-width: 0;
    min-width: auto
}

.smart-gantt-chart .project .smart-timeline-task-fill {
    background: #ffa558;
    background: var(--smart-gantt-chart-project-color)
}

.smart-gantt-chart .project .smart-timeline-task-progress {
    background: rgba(0, 0, 0, .15);
    background: var(--smart-gantt-chart-project-progress-color)
}

.smart-gantt-chart .task .smart-timeline-task-fill {
    background: #2bc3be;
    background: var(--smart-gantt-chart-task-color)
}

.smart-gantt-chart .task .smart-timeline-task-progress {
    background: rgba(0, 0, 0, .15);
    background: var(--smart-gantt-chart-task-progress-color)
}

.smart-gantt-chart:not([disable-task-drag]) .smart-timeline-task.milestone .smart-task-container:after,
.smart-gantt-chart:not([disable-task-drag]) .smart-timeline-task.milestone .smart-task-container:before,
.smart-gantt-chart:not([disable-task-drag]) .smart-timeline-task:not([disable-drag]) .smart-task-segment:not([disable-drag]) {
    cursor: move
}

.smart-gantt-chart:not([dragged]):not([resized]) .smart-timeline-task[hover]:not([resource-group]) .smart-task-connection-point,
.smart-gantt-chart:not([dragged]):not([resized]) .smart-timeline-task[selected]:not([resource-group]) .smart-task-connection-point {
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1)
}

.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left])[show-baseline] .smart-timeline-task.milestone[hover] .smart-task-connection-point.start,
.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left])[show-baseline] .smart-timeline-task.milestone[selected] .smart-task-connection-point.start {
    -webkit-transform: translate(-7.5px, -50%) scale(1);
    transform: translate(-7.5px, -50%) scale(1);
    -webkit-transform: translate(calc(var(--smart-gantt-chart-task-default-height)*-1/4), -50%) scale(1);
    transform: translate(calc(var(--smart-gantt-chart-task-default-height)*-1/4), -50%) scale(1)
}

.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left])[show-baseline] .smart-timeline-task.milestone[hover] .smart-task-connection-point.end,
.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left])[show-baseline] .smart-timeline-task.milestone[selected] .smart-task-connection-point.end {
    -webkit-transform: translate(7.5px, -50%) scale(1);
    transform: translate(7.5px, -50%) scale(1);
    -webkit-transform: translate(calc(var(--smart-gantt-chart-task-default-height)*1/4), -50%) scale(1);
    transform: translate(calc(var(--smart-gantt-chart-task-default-height)*1/4), -50%) scale(1)
}

.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left]) .smart-timeline-task.milestone[hover] .smart-task-connection-point.start,
.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left]) .smart-timeline-task.milestone[selected] .smart-task-connection-point.start {
    -webkit-transform: translate(-15px, -50%) scale(1);
    transform: translate(-15px, -50%) scale(1);
    -webkit-transform: translate(calc(var(--smart-gantt-chart-task-default-height)*-1/2), -50%) scale(1);
    transform: translate(calc(var(--smart-gantt-chart-task-default-height)*-1/2), -50%) scale(1)
}

.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left]) .smart-timeline-task.milestone[hover] .smart-task-connection-point.end,
.smart-gantt-chart:not([dragged]):not([resized]):not([right-to-left]) .smart-timeline-task.milestone[selected] .smart-task-connection-point.end {
    -webkit-transform: translate(15px, -50%) scale(1);
    transform: translate(15px, -50%) scale(1);
    -webkit-transform: translate(calc(var(--smart-gantt-chart-task-default-height)*1/2), -50%) scale(1);
    transform: translate(calc(var(--smart-gantt-chart-task-default-height)*1/2), -50%) scale(1)
}

.smart-gantt-chart:not([disable-task-progress-change]) .smart-timeline-task .smart-timeline-task-progress-thumb:after {
    cursor: pointer
}

.smart-gantt-chart:not([inverted]) .smart-timeline-scroll-bar[orientation=vertical]:before {
    border-right: none
}

.smart-gantt-chart:not([resource-timeline-mode=histogram]) .smart-resource-timeline-view-cell:not([load]):after {
    -webkit-transform: scale(0) rotate(1turn);
    transform: scale(0) rotate(1turn)
}

.smart-gantt-chart:not([resource-timeline-mode=histogram]) .smart-resource-timeline-view-cell:after {
    background: #8bc34a;
    background: var(--smart-success);
    border-radius: 50%;
    color: #fff;
    color: var(--smart-success-color);
    height: 25px;
    height: calc(var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-task-bar-fill-padding));
    line-height: 100%;
    width: 25px;
    width: calc(var(--smart-gantt-chart-task-default-height) - var(--smart-gantt-chart-task-bar-fill-padding))
}

.smart-gantt-chart:not([resource-timeline-mode=histogram]) .smart-timeline-row:first-of-type .smart-resource-timeline-view-cell {
    border-top: none
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell {
    background: rgba(0, 92, 153, .15);
    background: rgba(var(--smart-primary-rgb), .15);
    border: 1px solid #005c99;
    border: var(--smart-border-width) solid var(--smart-primary);
    border-bottom: none;
    height: 0;
    padding: 0
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell:after {
    bottom: 0;
    height: 28px;
    height: calc(var(--smart-gantt-chart-task-default-height) - 2px);
    width: 100%
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell:not([load]):after {
    content: "-"
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-left-border:before,
.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-right-border:before {
    bottom: 0;
    content: "";
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 1
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-left-border.warning:before,
.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-right-border.warning:before {
    left: auto;
    z-index: auto
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-right-border {
    border-right: none
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-right-border:before {
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border);
    left: 0
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-left-border {
    border-left: none
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.hide-left-border:before {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    left: -1px
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell[load] {
    border-bottom: none;
    border-top: 1px solid #005c99;
    border-top: var(--smart-border-width) solid var(--smart-primary)
}

.smart-gantt-chart[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell.warning[load]:after {
    border-radius: 0;
    border-radius: initial
}

.smart-gantt-chart:not([animation=none]) .smart-resource-timeline-view-cell[load]:after {
    transition: border-radius .2s cubic-bezier(.4, 0, .6, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: transform .2s cubic-bezier(.4, 0, .6, 1), border-radius .2s cubic-bezier(.4, 0, .6, 1);
    transition: transform .2s cubic-bezier(.4, 0, .6, 1), border-radius .2s cubic-bezier(.4, 0, .6, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-gantt-chart:not([animation=none])[resource-timeline-mode=histogram] .smart-resource-timeline-view-cell {
    transition: height .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-gantt-chart:not([animation=none])[show-progress-label] .smart-timeline-task-progress:after {
    transition: color .2s ease-in-out
}

.smart-gantt-chart.smart-container.vscroll .smart-timeline,
.smart-gantt-chart>.smart-container.vscroll .smart-timeline {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-gantt-chart[inverted] .smart-timeline-scroll-bar[orientation=vertical] {
    right: auto
}

.smart-gantt-chart[inverted] .smart-timeline-scroll-bar[orientation=vertical]:before {
    border-left: none
}

.smart-gantt-chart[inverted].smart-container.vscroll .smart-timeline,
.smart-gantt-chart[inverted]>.smart-container.vscroll .smart-timeline {
    margin-left: 18px;
    margin-left: var(--smart-scroll-bar-size)
}

.smart-gantt-chart[inverted].smart-container.vscroll .smart-timeline-scroll-bar:not([orientation=vertical]),
.smart-gantt-chart[inverted]>.smart-container.vscroll .smart-timeline-scroll-bar:not([orientation=vertical]) {
    left: 18px;
    left: calc(var(--smart-scroll-bar-size))
}

.smart-gantt-chart[inverted] .smart-timeline-scroll-bar:after {
    left: -18px;
    left: calc(var(--smart-scroll-bar-size)*-1);
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-gantt-chart[hide-timeline-header-details].smart-container,
.smart-gantt-chart[hide-timeline-header-details]>.smart-container {
    --smart-gantt-chart-task-timeline-content-height: var(--smart-gantt-chart-task-default-height)
}

.smart-gantt-chart[hide-timeline-header-details] .smart-task-splitter-item[show-header] .smart-timeline-view-cell {
    border-top: none
}

.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-view-cells {
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height)
}

.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-view-cells .smart-timeline-view-cell {
    border-top: initial
}

.smart-gantt-chart[hide-timeline-header-details] .smart-table {
    --smart-table-column-header-height: calc(var(--smart-gantt-chart-task-default-height) - var(--smart-border-width))
}

.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-content-container {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height))
}

.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-scroll-bar[orientation=vertical] {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-gantt-chart-task-default-height));
    top: 30px;
    top: var(--smart-gantt-chart-task-default-height)
}

.smart-gantt-chart[hide-timeline-header-details] .smart-timeline-scroll-bar[orientation=vertical]:before {
    height: 30px;
    height: var(--smart-gantt-chart-task-default-height);
    top: -30px;
    top: calc(var(--smart-gantt-chart-task-default-height)*-1)
}

.smart-gantt-chart[show-progress-label] .smart-timeline-task-progress[value]:after {
    align-items: center;
    color: var(--smart-gantt-chart-task-label-color);
    content: attr(value);
    display: flex;
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: inherit;
    font-weight: var(--smart-font-weight);
    height: 100%;
    padding: 0 10px;
    padding: var(--smart-gantt-chart-progress-label-padding)
}

.smart-gantt-chart[show-progress-label] .project .smart-task-segment[show-progress-label] .smart-timeline-task-label,
.smart-gantt-chart[show-progress-label] .task .smart-task-segment[show-progress-label] .smart-timeline-task-label {
    padding-left: 60px;
    padding-left: var(--smart-gantt-chart-progress-label-width)
}

.smart-gantt-chart[show-progress-label] [selected] .smart-timeline-task-progress:after {
    color: var(--smart-gantt-chart-task-label-color-selected)
}

.smart-gantt-chart[show-progress-label] .project .smart-timeline-task-progress:after {
    color: #333;
    color: var(--smart-gantt-chart-project-label-color)
}

.smart-gantt-chart[show-progress-label] .project[selected] .smart-timeline-task-progress:after {
    color: #000;
    color: var(--smart-gantt-chart-project-label-color-selected)
}

.smart-gantt-chart[connecting-task] .smart-task-connection {
    pointer-events: none
}

.smart-gantt-chart[auto-schedule][auto-schedule-strict-mode] .smart-timeline-task.milestone[connected] .smart-task-container:after,
.smart-gantt-chart[auto-schedule][auto-schedule-strict-mode] .smart-timeline-task.milestone[connected] .smart-task-container:before,
.smart-gantt-chart[auto-schedule][auto-schedule-strict-mode] .smart-timeline:not([task-bar-hovered]) .smart-timeline-task[connected] .smart-timeline-task-fill {
    cursor: auto
}

.smart-gantt-chart[dragged],
.smart-gantt-chart[resized] {
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart[modal] {
    pointer-events: none
}

.smart-gantt-chart[right-to-left] .smart-timeline-task-label {
    direction: rtl
}

.smart-gantt-chart[right-to-left] .milestone .smart-task-container {
    direction: ltr
}

.smart-gantt-chart[right-to-left]>.smart-container.vscroll .smart-timeline-scroll-bar:not([orientation=vertical]) {
    left: 18px;
    left: calc(var(--smart-scroll-bar-size))
}

.smart-gantt-chart[right-to-left]>.smart-container.vscroll .smart-timeline {
    margin-left: 18px;
    margin-left: var(--smart-scroll-bar-size)
}

.smart-gantt-chart[right-to-left] .smart-timeline-view-cell {
    direction: rtl
}

.smart-gantt-chart[right-to-left] .smart-timeline-view-cell:last-of-type {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-gantt-chart[right-to-left] .smart-timeline-view-cell:first-of-type {
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent;
    border-right: none
}

.smart-gantt-chart[right-to-left] .smart-timeline-row {
    left: auto;
    right: 0
}

.smart-gantt-chart[right-to-left] .smart-timeline-scroll-bar:after,
.smart-gantt-chart[right-to-left] .smart-timeline-task[connection-point=end] .smart-task-connection-feedback {
    left: auto;
    right: 100%
}

.smart-gantt-chart[right-to-left] .smart-timeline-row .smart-timeline-cell:first-of-type {
    border-right: initial
}

.smart-gantt-chart[right-to-left] .smart-timeline-row .smart-timeline-cell:not(:first-of-type) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-gantt-chart[right-to-left] .smart-timeline-scroll-bar[orientation=vertical]:after {
    left: -18px;
    left: calc(var(--smart-scroll-bar-size)*-1)
}

.smart-gantt-chart[right-to-left] .smart-task-connection-point.end {
    left: -20px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1/1.5);
    right: auto
}

.smart-gantt-chart[right-to-left] .smart-task-connection-point.start {
    left: auto;
    right: -20px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1/1.5)
}

.smart-gantt-chart[right-to-left] .smart-task-connection-feedback {
    -webkit-transform-origin: right;
    transform-origin: right
}

.smart-gantt-chart[right-to-left] .smart-task-connection-feedback:before {
    border-left: initial;
    border-right: 5px solid #e6510a;
    border-right: var(--smart-gantt-chart-timeline-task-connection-arrow-width) var(--smart-gantt-chart-timeline-task-connection-arrow-type) var(--smart-gantt-chart-timeline-task-connection-feedback-color);
    left: auto;
    right: calc(100% - 4px);
    right: calc(100% - var(--smart-gantt-chart-timeline-task-connection-arrow-width) + 1px)
}

.smart-gantt-chart[right-to-left] .smart-task-bar-limiter.max-date,
.smart-gantt-chart[right-to-left] .smart-task-bar-limiter.min-date {
    left: auto;
    right: var(--smart-gantt-chart-timeline-column-border-width)
}

.smart-gantt-chart[right-to-left] .smart-task-bar-limiter.max-date {
    left: 0
}

.smart-gantt-chart[right-to-left] .milestone .smart-task-connection-point.end {
    left: -34.5px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1*1.15);
    right: auto
}

.smart-gantt-chart[right-to-left] .milestone .smart-task-connection-point.start {
    left: auto;
    right: -34.5px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1*1.15)
}

.smart-gantt-chart[right-to-left] .milestone .smart-task-connection-feedback {
    left: auto;
    right: -15px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart[right-to-left] .milestone[connection-point=end] .smart-task-connection-feedback {
    right: calc(100% + 15px);
    right: calc(100% + var(--smart-gantt-chart-task-default-height)/2)
}

.smart-gantt-chart[right-to-left][show-baseline] .smart-task-connection-point.end {
    left: -15px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart[right-to-left][show-baseline] .smart-task-connection-point.start {
    right: -15px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1/2)
}

.smart-gantt-chart[right-to-left][show-baseline] .milestone .smart-task-connection-point.end {
    left: -22.5px;
    left: calc(var(--smart-gantt-chart-task-default-height)*-1*.75)
}

.smart-gantt-chart[right-to-left][show-baseline] .milestone .smart-task-connection-point.start {
    right: -22.5px;
    right: calc(var(--smart-gantt-chart-task-default-height)*-1*.75)
}

.smart-gantt-chart[right-to-left]:not([inverted]) .smart-timeline-scroll-bar[orientation=vertical] {
    left: 0;
    right: auto
}

.smart-gantt-chart[right-to-left]:not([inverted]) .smart-timeline-scroll-bar[orientation=vertical]:before {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border)
}

.smart-gantt-chart[right-to-left][inverted]>.smart-container.vscroll .smart-timeline {
    margin-right: 18px;
    margin-right: var(--smart-scroll-bar-size)
}

.smart-gantt-chart[right-to-left][inverted]>.smart-container.vscroll .smart-timeline-scroll-bar:not([orientation=vertical]) {
    left: auto
}

.smart-gantt-chart[right-to-left][inverted] .smart-timeline-scroll-bar:after {
    right: -18px;
    right: calc(var(--smart-scroll-bar-size)*-1)
}

.smart-gantt-chart[right-to-left][inverted] .smart-timeline-scroll-bar[orientation=vertical] {
    right: 0
}

.smart-gantt-chart[right-to-left][inverted] .smart-timeline-scroll-bar[orientation=vertical]:before {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    border-right: none
}

.smart-window.smart-gantt-chart-popup-window {
    --smart-window-header-height: var(--smart-gantt-chart-popup-window-header-height);
    --smart-window-footer-height: var(--smart-gantt-chart-popup-window-footer-height);
    --smart-window-header-footer-padding: 10px;
    --smart-window-default-height: auto;
    --smart-window-header-background: transparent;
    --smart-window-content-padding: 10px;
    max-height: 97vh;
    max-width: 97vw;
    min-height: 50px
}

.smart-window.smart-gantt-chart-popup-window .smart-content-container>.smart-content {
    align-items: normal
}

.smart-window.smart-gantt-chart-popup-window .smart-content-container>.smart-footer smart-button {
    --smart-button-padding: 0.2rem;
    height: 100%;
    width: 100%
}

.smart-window.smart-gantt-chart-popup-window .smart-popup-window-button.ok {
    grid-area: buttonOk
}

.smart-window.smart-gantt-chart-popup-window .smart-popup-window-button.cancel {
    grid-area: buttonCancel
}

.smart-window.smart-gantt-chart-popup-window .smart-popup-window-button.cancel .smart-icon:after {
    content: "\\1F5D9";
    content: var(--smart-icon-cancel)
}

.smart-window.smart-gantt-chart-popup-window .smart-popup-window-button.delete {
    grid-area: buttonDelete
}

.smart-window.smart-gantt-chart-popup-window .smart-popup-window-button.delete .smart-icon:after {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-window.smart-gantt-chart-popup-window .smart-tabs {
    height: 100%;
    min-height: 0;
    min-height: auto;
    width: 100%
}

.smart-window.smart-gantt-chart-popup-window .smart-tabs .smart-tabs-content-section,
.smart-window.smart-gantt-chart-popup-window .smart-tabs .smart-tabs-header-section {
    border: initial
}

.smart-window.smart-gantt-chart-popup-window .smart-tabs .smart-tabs-header-section {
    background: inherit
}

.smart-window.smart-gantt-chart-popup-window .smart-tabs .smart-tab-item>.smart-container {
    padding: 10px
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    display: grid;
    flex: calc(50% - 10px) 1
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-gantt-chart-label-container {
    align-items: center;
    display: flex;
    justify-content: space-between
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-popup-window-editor-toggle {
    -webkit-font-smoothing: antialiased;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    cursor: pointer;
    display: inline-flex;
    font-weight: 500;
    letter-spacing: .08929em;
    opacity: var(--smart-button-opacity);
    overflow: hidden;
    padding: 5px 20px;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    vertical-align: middle;
    white-space: nowrap
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-popup-window-editor-toggle:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-popup-window-editor-toggle:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-date-time-picker,
.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor .smart-drop-down-list {
    width: 100%
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor>b {
    text-align: center
}

.smart-window.smart-gantt-chart-popup-window .smart-gantt-chart-popup-window-editor input {
    height: 30px;
    height: var(--smart-editor-height)
}

.smart-window.smart-task-popup-window {
    --smart-window-default-width: var(--smart-gantt-chart-task-popup-window-default-width)
}

.smart-window.smart-task-popup-window .smart-content-container>.smart-footer {
    grid-column-gap: 2%;
    display: grid;
    grid-template-areas: "buttonOk buttonCancel . buttonDelete";
    grid-template-columns: 23% 23% 23% 23%
}

.smart-window.smart-task-popup-window .smart-content-container>.smart-footer .smart-icon {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 18px;
    height: 100%;
    margin-right: 2.5px;
    position: relative
}

.smart-window.smart-task-popup-window .smart-popup-window-button.ok .smart-icon:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

.smart-window.smart-task-popup-window .smart-tab-item[value=general]>.smart-container {
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    display: flex;
    flex-wrap: wrap
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-table {
    --smart-table-column-header-height: 40px;
    --smart-table-row-height: 35px;
    height: 100%;
    width: 100%
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-table th {
    font-weight: 600
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-table-buttons {
    grid-column-gap: 5px;
    display: grid;
    grid-template-columns: repeat(2, auto);
    justify-content: flex-end;
    margin-bottom: 5px
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-table-buttons smart-button {
    --smart-button-padding: 8px 16px 8px 8px;
    border: initial
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-table-buttons smart-button button:before {
    align-items: center;
    box-sizing: border-box;
    display: inline-flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    padding-right: 5px
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-table-buttons smart-button[action=add] button:before {
    content: "\\e803";
    content: var(--smart-icon-plus)
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-table-buttons smart-button[action=delete] button:before {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-validation-message {
    color: #b00020;
    color: var(--smart-error);
    display: inline-flex;
    font-style: italic;
    margin-top: 5px;
    white-space: pre-wrap
}

.smart-window.smart-task-popup-window .smart-tab-item .smart-gantt-window-validation-message:empty {
    display: none
}

.smart-window.smart-task-popup-window[right-to-left]>.smart-container>.smart-footer .smart-icon {
    margin-left: 2.5px
}

.smart-confirm-popup-window {
    --smart-window-default-width: var(--smart-gantt-chart-confirm-popup-window-default-width)
}

.smart-connection-popup-window {
    --smart-window-default-width: var(--smart-gantt-chart-connection-popup-window-default-width)
}

.smart-confirm-popup-window .smart-content-container>.smart-content,
.smart-connection-popup-window .smart-content-container>.smart-content {
    justify-content: center
}

.smart-confirm-popup-window .smart-content-container>.smart-footer,
.smart-connection-popup-window .smart-content-container>.smart-footer {
    grid-column-gap: 2%;
    display: grid;
    grid-template-areas: "buttonOk buttonCancel";
    grid-template-columns: 49% 49%
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {

    .smart-confirm-popup-window .smart-content-container>.smart-footer,
    .smart-connection-popup-window .smart-content-container>.smart-footer {
        align-content: start
    }
}

.smart-confirm-popup-window .smart-gantt-chart-popup-window-editor,
.smart-connection-popup-window .smart-gantt-chart-popup-window-editor {
    justify-items: center
}

.smart-gantt-chart-popup-window-editor .smart-input[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-gantt-chart-tooltip {
    --smart-tooltip-padding: 10px
}

.smart-gantt-chart-tooltip[visible] {
    pointer-events: none
}

.smart-gantt-chart-tooltip .smart-tooltip-content {
    flex-direction: column;
    text-align: left;
    white-space: nowrap
}

.smart-gantt-chart-tooltip .smart-tooltip-content label:not(:first-of-type) {
    margin-top: 5px
}

smart-gauge {
    fill: #5a5a5a;
    fill: var(--smart-background-color);
    display: block;
    height: 450px;
    height: var(--smart-gauge-default-height);
    min-height: 125px;
    min-width: 125px;
    width: 450px;
    width: var(--smart-gauge-default-width)
}

smart-gauge:focus {
    outline: 0
}

smart-gauge.smart-element {
    border: none
}

smart-gauge[disabled] {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-gauge[size-mode=auto] {
    min-height: 0;
    min-height: auto
}

.smart-gauge:focus .smart-needle,
.smart-gauge:focus .smart-needle-central-circle {
    fill: #005c99;
    fill: var(--smart-primary)
}

.smart-gauge .smart-container,
.smart-gauge.smart-container {
    border-radius: 50%;
    position: relative
}

.smart-gauge .drawContainer>svg {
    fill: initial;
    fill: var(--smart-gauge-label-fill-state);
    stroke: initial;
    stroke: var(--smart-gauge-label-stroke)
}

.smart-gauge .smart-needle,
.smart-gauge .smart-needle-central-circle {
    fill: #5a5a5a;
    fill: var(--smart-background-color)
}

.smart-gauge .smart-svg-container {
    height: 100%;
    touch-action: none;
    width: 100%
}

.smart-gauge .smart-tick {
    stroke: #e0e0e0;
    stroke: var(--smart-border);
    stroke-width: 1px;
    pointer-events: none;
    width: 15px
}

.smart-gauge .smart-tick-minor {
    width: 5px
}

.smart-gauge .smart-needle {
    height: 110px;
    width: 20px
}

.smart-gauge .smart-track {
    stroke: #e0e0e0;
    stroke: var(--smart-border);
    stroke-width: 2px;
    fill: #fefefe;
    fill: var(--smart-background);
    width: 15px
}

.smart-gauge .smart-value {
    stroke: #005c99;
    stroke: var(--smart-ui-state-border-active);
    stroke-width: 2px;
    fill: #005c99;
    fill: var(--smart-ui-state-active)
}

.smart-gauge .smart-line {
    stroke: #5a5a5a;
    stroke: var(--smart-background-color);
    stroke-width: 5px
}

.smart-gauge .smart-range {
    fill: #d8d8d8;
    width: 75px
}

.smart-gauge .smart-digital-display-container {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-gauge .smart-digital-display {
    --smart-numeric-text-box-background: transparent;
    --smart-numeric-text-box-text-align: center;
    color: #000;
    display: none;
    font-size: inherit;
    height: auto;
    left: 50%;
    pointer-events: auto;
    position: absolute;
    top: 75%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80px
}

.smart-gauge[dragged],
.smart-gauge[dragged] .smart-label {
    cursor: pointer
}

.smart-gauge[analog-display-type=fill][ticks-position=track] .smart-tick,
.smart-gauge[analog-display-type=line][ticks-position=track] .smart-tick {
    stroke: #f2f2f2
}

.smart-gauge[labels-visibility=endPoints] .smart-label-middle,
.smart-gauge[ticks-visibility=major] .smart-tick-minor {
    visibility: hidden
}

.smart-gauge[show-ranges][ranges] .smart-track {
    opacity: 0
}

.smart-gauge[show-unit] .smart-digital-display {
    --smart-numeric-text-box-text-align: right
}

.smart-gauge[show-unit] .smart-digital-display input.smart-input {
    border-right: none
}

.smart-gauge[digital-display] .smart-digital-display {
    display: inline-block
}

.smart-gauge[digital-display-position=top] .smart-digital-display {
    top: 25%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-gauge[digital-display-position=right] .smart-digital-display {
    left: 70%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-gauge[digital-display-position=left] .smart-digital-display {
    left: 30%
}

.smart-gauge[digital-display-position=center] .smart-digital-display,
.smart-gauge[digital-display-position=left] .smart-digital-display {
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-gauge[right-to-left] .smart-label,
.smart-gauge[right-to-left] .smart-label-middle {
    text-anchor: end;
    direction: rtl
}

.smart-grid-column-group,
.smart-grid-footer {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

header.smart-grid-pager {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

footer.smart-grid-pager {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0
}

.smart-grid-footer {
    border-color: #e0e0e0;
    border-top: 1px solid;
    border-color: var(--smart-border);
    height: 48px;
    height: var(--smart-grid-footer-height)
}

.smart-grid-group-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom-color: var(--smart-border);
    display: flex;
    height: 48px;
    height: var(--smart-grid-group-header-height);
    min-height: 48px;
    min-height: var(--smart-grid-group-header-height);
    overflow: hidden;
    position: relative;
    z-index: 99
}

.smart-grid-group-header .smart-breadcrumb {
    --smart-breadcrumb-item-height: 35px;
    background: 0 0;
    border: none;
    margin-top: 1px;
    padding: 0 0 0 5px;
    width: 100%
}

.smart-grid-group-header .smart-breadcrumb .smart-template-container .smart-breadcrumb-items .smart-breadcrumb-item {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    margin-top: 0
}

.smart-grid-group-header .smart-breadcrumb-item-label {
    align-content: center;
    display: flex;
    justify-content: center
}

.smart-grid-group-header .smart-breadcrumb-item-label .smart-grid-icon {
    font-size: 16px;
    font-weight: 700;
    margin-right: -10px
}

.smart-grid-column-group,
smart-grid-column {
    font-size: inherit;
    font-size: var(--smart-grid-column-font-size, inherit);
    font-weight: inherit;
    font-weight: var(--smart-grid-column-font-weight, inherit);
    text-overflow: ellipsis
}

.smart-grid-column-header.smart-columns-sticky {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-top: 1px solid #e0e0e0;
    border-top: 1px solid var(--smart-border);
    margin-top: -2px
}

.smart-grid-column-header .smart-arrow-down.smart-animate {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    transition: -webkit-transform .2s ease-out;
    transition: transform .2s ease-out;
    transition: transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-grid-column-header .smart-arrow-down.smart-animate:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-grid-column-header .top-right-corner {
    border-left-color: inherit;
    border-left-style: solid;
    border-left-width: 1px;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    width: 19px;
    width: calc(1px + var(--smart-scroll-bar-size));
    z-index: 1
}

.smart-grid-column-header .top-right-corner:first-child {
    left: -1px;
    z-index: 2
}

.smart-grid-column-header-cell-container {
    height: 100%;
    position: relative;
    z-index: 1
}

.smart-grid-column-header-cell-container:hover smart-grid-column[freeze][checkbox][auto-show] .smart-input {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    opacity: 1
}

.smart-grid-cell-container.far,
.smart-grid-column-header-cell-container.far {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-grid-freeze-splitter-size) solid var(--smart-border);
    right: 0
}

.smart-grid-column-header-cell-container.far,
.smart-grid-column-header-cell-container.near {
    box-sizing: content-box;
    position: absolute;
    z-index: 6
}

.smart-grid-column-header-cell-container.near {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-grid-freeze-splitter-size) solid var(--smart-border)
}

.smart-grid-column-header-cell-container.far {
    top: 0
}

.smart-grid-column-header-cell-container.far.vscroll {
    right: 18px;
    right: var(--smart-scroll-bar-size)
}

.smart-grid-column-header-cell-container.border-collapse.near {
    border-right: none;
    box-sizing: border-box
}

.smart-grid-column-header-cell-container.border-collapse.far {
    border-left: none;
    box-sizing: border-box
}

.smart-grid-column-group {
    border-style: solid;
    border-width: 0;
    height: 100%;
    overflow: hidden;
    position: absolute;
    white-space: nowrap
}

.smart-grid-column-group.smart-grid-column-border {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-width: 1px;
    border-width: var(--smart-border-width);
    border-top-width: 0
}

.smart-grid-column-group:not(.smart-grid-column-border):after {
    background: #e0e0e0;
    background: var(--smart-grid-column-horizontal-border, var(--smart-border));
    bottom: 0;
    content: "";
    height: 1px;
    height: var(--smart-border-width);
    position: absolute;
    width: 100%
}

.smart-grid-column-group:not(.smart-grid-column-border):after:not(.smart-grid-column-border-collapse):before {
    background: #e0e0e0;
    background: var(--smart-grid-column-vertical-border, var(--smart-border));
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 1px;
    width: var(--smart-border-width)
}

.smart-grid-column-menu {
    background: #f5f5f5;
    background: var(--smart-surface);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    height: auto;
    height: var(--smart-grid-column-menu-height);
    min-height: 60px;
    overflow: hidden;
    position: absolute;
    width: 200px;
    width: var(--smart-grid-column-menu-width);
    z-index: 9999
}

.smart-grid-column-menu smart-menu {
    border: none
}

.smart-grid-column-menu.smart-animate {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    transition: opacity .2s, -webkit-transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-grid-column-menu.smart-animate.smart-grid-download-menu {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    width: auto
}

.smart-grid-column-menu[right-to-left].smart-animate {
    -webkit-transform-origin: top right;
    transform-origin: top right
}

.smart-grid-column-menu[right-to-left] .smart-filter-panel .smart-filter-panel-button-container {
    flex-direction: row-reverse
}

.smart-grid-column-menu[right-to-left] .smart-filter-panel .smart-filter-panel-operator-list {
    position: relative
}

.smart-grid-column-menu smart-menu[mode=vertical] {
    height: 100%
}

.smart-grid-column-menu.open.smart-animate {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-grid-column-menu .smart-grid-icon {
    display: inline-block
}

.smart-grid-column-menu .smart-filter-container {
    background: #fefefe;
    background: var(--smart-background);
    height: auto;
    width: 100%
}

.smart-grid-column-menu .smart-filter-container smart-filter-panel {
    background: 0 0;
    border: none;
    width: 100%
}

.smart-grid-column-menu .smart-filter-container .smart-filter-panel smart-tree,
.smart-grid-column-menu .smart-filter-panel smart-filter-builder {
    height: 250px
}

.smart-grid-filter-footer {
    height: 48px;
    height: var(--smart-grid-filter-footer-height)
}

.smart-grid-icon {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    display: none;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    min-width: 0;
    text-decoration: inherit;
    text-transform: none;
    width: 23px;
    width: var(--smart-grid-column-buttons-width)
}

.smart-grid-icon.visible {
    display: inline-block !important;
    width: 20px
}

.smart-grid-icon.show {
    display: flex !important
}

.smart-grid-icon.smart-icon-link:before {
    content: "\\e831";
    content: var(--smart-icon-link)
}

.smart-grid-icon.smart-icon-mail:before {
    content: "\\e83c";
    content: var(--smart-icon-mail)
}

.smart-grid-icon.smart-icon-user:before {
    content: "\\e81f";
    content: var(--smart-icon-user)
}

.smart-grid-icon.smart-icon-list-ordered:before {
    content: "\\f0cb";
    content: var(--smart-icon-list-ordered)
}

.smart-grid-icon.smart-icon-list-unordered:before {
    content: "\\f0ca";
    content: var(--smart-icon-list-unordered)
}

.smart-grid-icon.smart-icon-plus:before {
    content: "\\e803";
    content: var(--smart-icon-plus)
}

.smart-grid-icon.smart-icon-image:before {
    content: "\\e827";
    content: var(--smart-icon-image)
}

.smart-grid-icon.smart-icon-plus-circled:before {
    content: "\\e810";
    content: var(--smart-icon-plus-circled)
}

.smart-grid-icon.smart-icon-docs:before {
    content: "\\f0c5";
    content: var(--smart-icon-docs)
}

.smart-grid-icon.smart-icon-minus:before {
    content: "\\e804";
    content: var(--smart-icon-minus)
}

.smart-grid-icon.smart-icon-resize-full:before {
    content: "\\e81c";
    content: var(--smart-icon-resize-full)
}

.smart-grid-icon.smart-icon-align-left:before {
    content: "\\e806";
    content: var(--smart-icon-align-left)
}

.smart-grid-icon.smart-icon-align-right:before {
    content: "\\e807";
    content: var(--smart-icon-align-right)
}

.smart-grid-icon.smart-icon-align-center:before {
    content: "\\e808";
    content: var(--smart-icon-align-center)
}

.smart-grid-icon.smart-icon-cancel:before {
    content: "\\1F5D9";
    content: var(--smart-icon-cancel)
}

.smart-grid-icon.smart-icon-cancel-circled:before {
    content: "\\e80e";
    content: var(--smart-icon-cancel-circled)
}

.smart-grid-icon.smart-icon-edit:before {
    content: "\\e82a";
    content: var(--smart-icon-edit)
}

.smart-grid-icon.smart-icon-mode-edit:before {
    content: "\\e909";
    content: var(--smart-icon-mode-edit)
}

.smart-grid-icon.smart-icon-sort:before {
    content: "\\e823";
    content: var(--smart-icon-sort)
}

.smart-grid-icon.smart-icon-delete:before {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-grid-icon.smart-icon-close:before {
    content: "\\1F5D9";
    content: var(--smart-icon-close)
}

.smart-grid-icon.smart-icon-search:before {
    content: "\\e828";
    content: var(--smart-icon-search)
}

.smart-grid-icon.smart-icon-settings:before {
    content: "\\e833";
    content: var(--smart-icon-settings)
}

.smart-grid-icon.smart-icon-visibility-off:before {
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

.smart-grid-icon.smart-icon-visibility-on:before {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-grid-icon.smart-icon-add-filter:before {
    content: "\\e82f";
    content: var(--smart-icon-add-filter)
}

.smart-grid-icon.smart-icon-duplicate:before {
    content: "\\e834";
    content: var(--smart-icon-duplicate)
}

.smart-grid-icon.smart-icon-check-empty:before {
    content: "\\f096";
    content: var(--smart-icon-check-empty)
}

.smart-grid-icon.smart-icon-check-squared:before {
    content: "\\e81b";
    content: var(--smart-icon-check-squared)
}

.smart-grid-icon.smart-icon-number:before {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    content: "#";
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-style: normal;
    font-variant: normal;
    font-weight: 700;
    padding-left: 2px
}

.smart-grid-icon.smart-icon-filter:before {
    content: "\\f0b0";
    content: var(--smart-icon-filter)
}

.smart-grid-icon.smart-icon-phone:before {
    content: "\\e83D";
    content: var(--smart-icon-phone)
}

.smart-grid-icon.smart-icon-lock:before {
    content: "\\e821";
    content: var(--smart-icon-lock)
}

.smart-grid-icon.smart-icon-tasks:before {
    content: "\\f0AE";
    content: var(--smart-icon-tasks)
}

.smart-grid-icon.smart-icon-table-alt:before {
    content: "\\f0CE";
    content: var(--smart-icon-table-alt)
}

.smart-grid-icon.smart-icon-kanban:before {
    content: "\\f181";
    content: var(--smart-icon-kanban)
}

.smart-grid-icon.smart-icon-card:before {
    content: "\\e83E";
    content: var(--smart-icon-card)
}

.smart-grid-icon.smart-icon-clock:before {
    content: "\\e837";
    content: var(--smart-icon-clock)
}

.smart-grid-icon.smart-icon-font:before {
    content: "\\f031";
    content: var(--smart-icon-font)
}

.smart-grid-icon.smart-icon-fontsize:before {
    content: "\\f088";
    content: var(--smart-icon-fontsize)
}

.smart-grid-icon.smart-icon-menu:before {
    content: "\\f0c9";
    content: var(--smart-icon-menu)
}

.smart-grid-icon.smart-icon-sort-down:before {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-grid-icon.smart-icon-sort-up:before {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-grid-icon.smart-icon-ellipsis-vert:before,
.smart-grid-icon.smart-icon-ellipsis:before {
    content: "\\f141";
    content: var(--smart-icon-ellipsis)
}

.smart-grid-icon.smart-icon-ellipsis-vert:before {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.smart-grid-icon.smart-icon-minus-squared:before {
    content: "\\f146";
    content: var(--smart-icon-minus-squared)
}

.smart-grid-icon.smart-icon-ok-squared:before {
    content: "\\f14a";
    content: var(--smart-icon-ok-squared)
}

.smart-grid-icon.smart-icon-sort-name-up:before {
    content: "\\f15d";
    content: var(--smart-icon-sort-name-up)
}

.smart-grid-icon.smart-icon-sort-name-down:before {
    content: "\\f15e";
    content: var(--smart-icon-sort-name-down)
}

.smart-grid-icon.smart-icon-sort-alt-up:before {
    content: "\\f160";
    content: var(--smart-icon-sort-alt-up)
}

.smart-grid-icon.smart-icon-sort-alt-down:before {
    content: "\\f161";
    content: var(--smart-icon-sort-alt-down)
}

.smart-grid-icon.smart-icon-sort-number-up:before {
    content: "\\f162";
    content: var(--smart-icon-sort-number-up)
}

.smart-grid-icon.smart-icon-sort-number-down:before {
    content: "\\f163";
    content: var(--smart-icon-sort-number-down)
}

.smart-grid-icon.smart-icon-group:before {
    content: "\\f247";
    content: var(--smart-icon-group)
}

.smart-grid-icon.smart-icon-ungroup:before {
    content: "\\f248";
    content: var(--smart-icon-ungroup)
}

.smart-grid-icon.smart-icon-reload:before {
    content: "\\e809";
    content: var(--smart-icon-reload)
}

.smart-grid-icon.smart-icon-contains:before {
    content: "\\f063";
    content: var(--smart-icon-contains)
}

.smart-grid-icon.smart-icon-starts-with:before {
    content: "\\f064";
    content: var(--smart-icon-starts_with)
}

.smart-grid-icon.smart-icon-ends-with:before {
    content: "\\f065";
    content: var(--smart-icon-ends_with)
}

.smart-grid-icon.smart-icon-does-not-contain:before {
    content: "\\f066";
    content: var(--smart-icon-does_not_contain)
}

.smart-grid-icon.smart-icon-equals:before {
    content: "\\f52c";
    content: var(--smart-icon-equals)
}

.smart-grid-icon.smart-icon-greater-than:before {
    content: "\\f531";
    content: var(--smart-icon-greater-than)
}

.smart-grid-icon.smart-icon-greater-than-equal:before {
    content: "\\f532";
    content: var(--smart-icon-greater-than-equal)
}

.smart-grid-icon.smart-icon-less-than:before {
    content: "\\f536";
    content: var(--smart-icon-less-than)
}

.smart-grid-icon.smart-icon-less-than-equal:before {
    content: "\\f537";
    content: var(--smart-icon-less-than-equal)
}

.smart-grid-icon.smart-icon-not-equal:before {
    content: "\\f53e";
    content: var(--smart-icon-not-equal)
}

.smart-grid-icon.smart-icon-percentage:before {
    content: "\\f541";
    content: var(--smart-icon-percentage)
}

.smart-grid-icon.smart-icon-grip-vertical:before {
    content: "\\f58e";
    content: var(--smart-icon-grip-vertical)
}

.smart-grid-icon.smart-icon-between:before {
    content: "\\f06a";
    content: var(--smart-icon-between)
}

.smart-grid-icon.smart-icon-bold:before {
    content: "\\e820";
    content: var(--smart-icon-bold)
}

.smart-grid-icon.smart-icon-italic:before {
    content: "\\e822";
    content: var(--smart-icon-italic)
}

.smart-grid-icon.smart-icon-underline:before {
    content: "\\f0cd";
    content: var(--smart-icon-underline)
}

.smart-grid-icon.smart-icon-color-background:before {
    content: "\\e830";
    content: var(--smart-icon-color-background)
}

.smart-grid-icon.smart-icon-calendar:before {
    content: "\\e829";
    content: var(--smart-icon-calendar)
}

.smart-grid-icon.smart-icon-attention:before {
    content: "\\e838";
    content: var(--smart-icon-attention)
}

.smart-grid-icon.smart-icon-help-circled:before {
    content: "\\e839";
    content: var(--smart-icon-help-circled)
}

.smart-grid-icon.smart-icon-star:before {
    content: "\\e801";
    content: var(--smart-icon-star)
}

.smart-grid-icon.smart-icon-attention-circled:before {
    content: "\\e805";
    content: var(--smart-icon-attention-circled)
}

.smart-grid-pager smart-pager {
    border: none;
    height: calc(100% - 10px);
    margin-left: 2px;
    margin-top: 5px;
    width: calc(100% - 10px)
}

.smart-grid-aggregate-footer {
    border-top-color: inherit;
    border-top-style: solid;
    border-top-width: 1px;
    bottom: 0;
    height: 48px;
    height: var(--smart-grid-aggregate-footer-height);
    position: absolute;
    width: 100%;
    z-index: 99
}

.smart-grid-loader {
    background-clip: padding-box;
    -webkit-background-clip: padding-box;
    border: 6px solid rgba(43, 51, 63, .1);
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    height: 40px;
    height: calc(var(--smart-loader-size) + 10px);
    left: 50%;
    margin: inherit;
    opacity: .85;
    position: absolute;
    text-align: left;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 40px;
    width: calc(var(--smart-loader-size) + 10px);
    z-index: 99
}

.smart-grid-loader:after,
.smart-grid-loader:before {
    -webkit-animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    border: transparent;
    border-radius: inherit;
    border-width: 6px;
    box-sizing: inherit;
    content: "";
    height: inherit;
    margin: -6px;
    opacity: 1;
    position: absolute;
    width: inherit
}

.smart-grid-loader[loading-indicator-position=top] {
    height: 30px;
    height: var(--smart-loader-size);
    width: 30px;
    width: var(--smart-loader-size)
}

.smart-grid-loader[loading-indicator-position=top] .smart-loader-container {
    top: 0
}

.smart-grid-loader[loading-indicator-position=bottom] .smart-loader-container {
    top: -10%
}

.smart-grid-loader[loading-indicator-position=bottom] .smart-loader-container,
.smart-grid-loader[loading-indicator-position=top] .smart-loader-container {
    -webkit-animation: smart-loader-container-pop-up-down .3s linear;
    animation: smart-loader-container-pop-up-down .3s linear;
    background-color: #fefefe;
    background-color: var(--smart-background);
    display: block;
    height: 10%;
    left: 20%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-grid-loader[loading-indicator-position=bottom] .smart-loader-label,
.smart-grid-loader[loading-indicator-position=top] .smart-loader-label {
    display: block;
    font-family: inherit;
    font-size: inherit;
    left: 60%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    vertical-align: middle;
    white-space: nowrap
}

.smart-grid-placeholder {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    display: flex;
    height: 100%;
    justify-content: center;
    min-height: 50px;
    text-align: center;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-grid-content.auto-height .smart-grid-placeholder {
    height: auto
}

.smart-grid-content.auto-height smart-grid-cell[addNewRow] {
    border-right: none
}

.smart-grid-special-cells-container {
    height: 100%;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-grid-sort-animation {
    transition-delay: 0;
    transition-timing-function: ease-in-out
}

.smart-grid-cell-container {
    height: 100%;
    position: relative
}

.smart-grid-cell-container.far,
.smart-grid-cell-container.near {
    box-sizing: content-box;
    position: absolute;
    z-index: 6
}

.smart-grid-cell-container.near {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-grid-freeze-splitter-size) solid var(--smart-border)
}

.smart-grid-cell-container.far {
    top: 0
}

.smart-grid-cell-container.far.vscroll {
    right: 18px;
    right: var(--smart-scroll-bar-size)
}

.smart-grid-cell-container.border-collapse.near {
    border-right: none;
    box-sizing: border-box
}

.smart-grid-cell-container.border-collapse.far {
    border-left: none;
    box-sizing: border-box
}

.smart-grid-cell-editor>* {
    --smart-border-top-left-radius: 0px;
    --smart-border-top-right-radius: 0px;
    --smart-border-bottom-left-radius: 0px;
    --smart-border-bottom-right-radius: 0px;
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    display: block;
    height: 100%;
    margin: 0;
    outline: 0;
    overflow: hidden;
    width: 100%
}

.smart-grid-cell-editor.smart-grid-date-time-picker-cell-editor,
.smart-grid-cell-editor.smart-grid-number-input-cell-editor,
.smart-grid-cell-editor.smart-grid-passowrd-input-cell-editor,
.smart-grid-cell-editor.smart-grid-phone-input-cell-editor {
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    font-size: inherit;
    font-weight: inherit
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor {
    display: flex;
    height: 100%;
    margin: 0;
    width: 100%
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .down,
.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 50%;
    justify-content: center;
    outline: 0;
    overflow: hidden
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .down:hover,
.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .down:active,
.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .down[active],
.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up:active,
.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up[active] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-grid-cell-editor.smart-grid-auto-complete-cell-editor,
.smart-grid-cell-editor.smart-grid-input-cell-editor,
.smart-grid-cell-editor.smart-grid-text-area-cell-editor {
    background: inherit;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
    width: 100%
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border)
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .up:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .nav .down:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-grid-cell-editor.smart-grid-text-area-cell-editor {
    border: none;
    border-radius: 0;
    display: flex;
    font-family: inherit;
    height: 100%
}

.smart-grid-cell-editor.smart-grid-input-cell-editor {
    border: none;
    border-radius: 0;
    height: 100%
}

.smart-grid-cell-editor.smart-grid-auto-complete-cell-editor {
    border: none;
    border-radius: 0;
    height: 100% !important
}

.smart-grid-cell-editor.smart-grid-auto-complete-cell-editor div,
.smart-grid-cell-editor.smart-grid-auto-complete-cell-editor input {
    border-radius: 0
}

.smart-grid-cell-editor>input[type=checkbox] {
    border: none;
    height: 16px;
    min-width: 16px;
    position: relative;
    top: 6px
}

.smart-grid-cell-content-popup {
    background: #005c99 !important;
    background: var(--smart-primary) !important;
    border: 1px solid #005c99 !important;
    border: 1px solid var(--smart-primary) !important;
    color: #fff !important;
    color: var(--smart-primary-color) !important;
    z-index: 9 !important
}

.smart-grid-cell-content-popup-content {
    box-shadow: none !important;
    padding: 6px 2px 6px 6px
}

.smart-grid-row-container {
    position: relative
}

.smart-grid-row-container.far,
.smart-grid-row-container.near {
    position: absolute;
    width: 100%;
    z-index: 7
}

.smart-grid-row-container.near {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-grid-freeze-splitter-size) solid var(--smart-border);
    box-sizing: content-box
}

.smart-grid-row-container.far {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-grid-freeze-splitter-size) solid var(--smart-border);
    box-sizing: content-box;
    z-index: 11
}

.smart-grid-row-drag-feedback {
    flex-direction: column;
    height: auto !important
}

.smart-grid-row-drag-feedback div {
    padding-top: 3px
}

.smart-grid-row-drag-feedback>div {
    align-items: flex-start;
    background-color: #fefefe;
    background-color: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    flex-direction: column;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 8px;
    max-height: 200px;
    overflow: hidden;
    padding: 3px;
    white-space: nowrap
}

.smart-grid-scroll-view {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-grid-scroll-view .smart-grid-row-container.far {
    bottom: -2px
}

.smart-grid-scroll-view.vscroll,
.smart-grid-scroll-view.vscroll .smart-grid-row-container.far,
.smart-grid-scroll-view.vscroll .smart-grid-row-container.near {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-grid-scroll-view.hscroll .smart-grid-row-container.far {
    bottom: 16px;
    bottom: calc(-2px + var(--smart-scroll-bar-size))
}

.smart-grid-summary-row-cell {
    background: #f5f5f5 !important;
    background: var(--smart-surface) !important;
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #323232 !important;
    color: var(--smart-surface-color) !important;
    opacity: 1 !important
}

.smart-grid-summary-row-cell button {
    display: none
}

.smart-grid-summary-row-cell .summary-value {
    align-items: center;
    display: flex;
    font-size: 11px;
    height: calc(100% - 2px);
    justify-content: flex-end;
    opacity: .75;
    width: 100%
}

.smart-grid-summary-row-cell .summary-value .placeholder,
.smart-grid-summary-row-cell .summary-value .smart-arrow-down {
    display: none
}

.smart-grid-summary-row-cell .summary-value.summary-chooser .placeholder,
.smart-grid-summary-row-cell .summary-value.summary-chooser .smart-arrow-down,
.smart-grid-summary-row-cell .summary-value:hover .placeholder,
.smart-grid-summary-row-cell .summary-value:hover .smart-arrow-down {
    display: inherit
}

.smart-grid-summary-row-cell .summary-value .label {
    margin-top: -3px
}

.smart-grid-summary-row-cell:before {
    display: none
}

.smart-grid-resize-mode {
    overflow: visible
}

.smart-grid-dialog-editor.add-column {
    align-items: center;
    display: flex;
    height: 30px;
    margin-bottom: 10px
}

.smart-grid-dialog-editor.radio-group {
    height: auto
}

.smart-grid-dialog-add-column .smart-grid-dialog-radio-field {
    width: 100%
}

.smart-grid-dialog-add-column .smart-grid-dialog-radio-field .smart-input {
    border-radius: 50% !important;
    margin-right: 10px
}

.smart-grid-dialog-add-column .smart-grid-dialog-radio-field .smart-input:after {
    content: "" !important
}

.smart-grid-dialog-add-column .smart-grid-dialog-radio-field .smart-input[checked]:after {
    content: "\\e818" !important;
    content: var(--smart-icon-radio) !important
}

.smart-grid-dialog-add-column .smart-grid-dialog-boolean-field {
    align-items: center;
    display: flex;
    margin-bottom: 5px
}

.smart-grid-dialog-add-column .smart-grid-dialog-boolean-field .smart-grid-dialog-editor {
    margin-bottom: 0;
    margin-right: 10px
}

.smart-grid-image-dialog {
    background: #fefefe;
    background: var(--smart-background);
    min-height: 400px !important;
    width: 500px !important
}

.smart-grid-image-dialog .smart-header {
    align-items: center;
    display: flex;
    justify-content: center
}

.smart-grid-image-dialog .tabs {
    display: flex;
    height: 30px;
    margin-bottom: 5px;
    overflow: hidden;
    transition: all .2s ease-in-out;
    width: 100%
}

.smart-grid-image-dialog .tabs .tab {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    width: 50%
}

.smart-grid-image-dialog .tabs .tab label {
    cursor: pointer
}

.smart-grid-image-dialog .tabs .tab.active {
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary);
    font-weight: 700
}

.smart-grid-image-dialog .preview {
    margin-top: 10px
}

.smart-grid-image-dialog .preview p {
    font-size: 10px;
    text-align: center
}

.smart-grid-image-dialog .preview .smart-icon-delete {
    margin: 5px
}

.smart-grid-image-dialog .preview .smart-icon-delete:hover {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-grid-image-dialog .preview .list {
    display: flex;
    flex-direction: row;
    max-height: 100px;
    max-width: 500px;
    overflow: auto
}

.smart-grid-image-dialog .preview .list .item {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    flex-direction: column;
    font-size: 10px;
    margin-right: 10px;
    max-width: 100px;
    min-width: 60px;
    overflow: hidden
}

.smart-grid-image-dialog .preview .list .item:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    width: 16px
}

.smart-grid-image-dialog .preview .list .item img {
    border: 2px solid transparent;
    height: 50px;
    min-height: 50px;
    width: 50px
}

.smart-grid-image-dialog .preview .list .item img:hover {
    border: 2px solid #005c99;
    border: 2px solid var(--smart-primary);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    cursor: pointer
}

.smart-grid-image-dialog .preview .list .item div {
    text-align: center;
    text-overflow: ellipsis
}

.smart-grid-image-dialog .url-zone {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 220px;
    justify-content: center
}

.smart-grid-image-dialog .url-zone .upload {
    display: flex;
    flex-direction: column
}

.smart-grid-image-dialog .url-zone .url-title {
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-size: 10px;
    margin-top: 10px
}

.smart-grid-image-dialog .url-zone .smart-input {
    text-align: center
}

.smart-grid-image-dialog .smart-grid-drop-zone {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border: 2px dashed rgba(0, 0, 0, .1);
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 220px;
    justify-content: center;
    outline: 0;
    text-align: center;
    transition: all .2s ease-out
}

.smart-grid-image-dialog .smart-grid-drop-zone .title {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: 500;
    height: 50px;
    margin-top: 20px
}

.smart-grid-image-dialog .smart-grid-drop-zone .title .smart-grid-icon {
    color: #005c99;
    color: var(--smart-primary);
    font-size: 24px;
    margin-bottom: 5px
}

.smart-grid-image-dialog .smart-grid-drop-zone .subtitle {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    margin-bottom: 20px;
    margin-top: 20px
}

.smart-grid-dialog-overlay {
    background: #333
}

.smart-grid-dialog-overlay,
.smart-grid-overlay {
    height: 100%;
    left: 0;
    opacity: .1;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100
}

.smart-grid-overlay {
    background: 0 0
}

.smart-grid-slider-dialog,
.smart-grid-text-area-dialog {
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    border-radius: 1px;
    box-shadow: 0 0 0 3px #005c99 !important;
    box-shadow: 0 0 0 3px var(--smart-primary) !important;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    min-height: 120px;
    min-width: 150px;
    overflow: visible;
    position: absolute;
    z-index: 99999
}

.smart-grid-slider-dialog.smart-grid-slider-dialog,
.smart-grid-text-area-dialog.smart-grid-slider-dialog {
    max-width: 200px;
    min-height: 60px;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-grid-slider-dialog .smart-grid-slider-container,
.smart-grid-slider-dialog .smart-grid-text-area-container,
.smart-grid-text-area-dialog .smart-grid-slider-container,
.smart-grid-text-area-dialog .smart-grid-text-area-container {
    height: 100%;
    overflow: hidden;
    width: 100%
}

.smart-grid-slider-dialog .smart-grid-slider-container,
.smart-grid-text-area-dialog .smart-grid-slider-container {
    box-sizing: border-box;
    display: flex;
    height: 100%;
    padding: 6px;
    position: absolute
}

.smart-grid-slider-dialog smart-scroll-bar[orientation=vertical],
.smart-grid-text-area-dialog smart-scroll-bar[orientation=vertical] {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 18px;
    width: var(--smart-scroll-bar-size)
}

.smart-grid-slider-dialog textarea,
.smart-grid-text-area-dialog textarea {
    background: inherit;
    border: none;
    box-sizing: border-box;
    color: inherit;
    height: 120px;
    min-height: 120px;
    outline: 0;
    overflow-x: hidden;
    padding: 3px 20px 3px 3px;
    resize: none;
    width: calc(100% + 18px);
    width: calc(100% + var(--smart-scroll-bar-size))
}

.smart-grid-validation-error {
    background: #b00020;
    background: var(--smart-error);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    color: #fff;
    color: var(--smart-error-color);
    height: auto;
    padding: 7px;
    position: absolute;
    width: auto;
    z-index: 99
}

.smart-selection-overlay {
    border: 2px solid #005c99;
    border: 2px solid var(--smart-primary);
    position: absolute;
    z-index: 10
}

.smart-selection-overlay-content {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    height: 100%;
    opacity: .2;
    width: 100%
}

.smart-selection-overlay-content:after {
    bottom: 0;
    content: "";
    cursor: move;
    height: 4px;
    position: absolute;
    width: calc(100% - 10px)
}

.smart-selection-overlay-border-content {
    border: 0 solid #fefefe;
    border: 0 solid var(--smart-background);
    height: 100%;
    width: 100%
}

.smart-selection-overlay-border-content.handle:after {
    background: #005c99;
    background: var(--smart-primary);
    border: 1px solid #fefefe;
    border: 1px solid var(--smart-background);
    bottom: -4px;
    content: "";
    cursor: crosshair;
    height: 4px;
    position: absolute;
    right: -4px;
    width: 4px
}

.smart-input-overlay {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border-radius: 100%;
    cursor: pointer;
    opacity: 0;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0);
    z-index: 9
}

.smart-input-overlay.smart-animate {
    transition: opacity .25s ease-in-out, -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out, opacity .25s ease-in-out;
    transition: transform .25s ease-in-out, opacity .25s ease-in-out, -webkit-transform .25s ease-in-out
}

.smart-input-overlay-on {
    opacity: .3;
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-window.smart-grid-dialog {
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: opacity .2s, -webkit-transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-window.smart-grid-dialog.smart-grid-dialog-add-column,
.smart-window.smart-grid-dialog.smart-grid-dialog-description {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-window.smart-grid-dialog.smart-grid-dialog-add-column .smart-header-notes,
.smart-window.smart-grid-dialog.smart-grid-dialog-description .smart-header-notes {
    display: block;
    margin-bottom: 10px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-add-column.center,
.smart-window.smart-grid-dialog.smart-grid-dialog-description.center {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: unset;
    transform-origin: unset
}

.smart-window.smart-grid-dialog.smart-grid-dialog-summary {
    --smart-window-content-padding: 0px;
    border-radius: 0;
    box-shadow: none;
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-window.smart-grid-dialog.smart-grid-dialog.disable-animation {
    transition: none
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row {
    width: 750px !important
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-column-info {
    display: grid;
    grid-template-columns: 25px 1fr 25px;
    padding: 10px 0
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-column-info.format {
    grid-template-columns: 25px 1fr;
    padding: 0
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-column-info.header {
    display: flex;
    flex-direction: row;
    font-size: 15px;
    font-size: calc(var(--smart-font-size) + 1px);
    font-weight: 700;
    justify-content: space-between
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .tabs {
    background: #fefefe;
    background: var(--smart-background);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    display: flex;
    height: 35px;
    margin-bottom: 10px;
    overflow: hidden;
    transition: all .2s ease-in-out;
    width: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .tabs .tab {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 8px 22px;
    text-transform: uppercase
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .tabs .tab.active {
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-content-container {
    width: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-next-button:after,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-prev-button:after {
    font-size: calc(100% - 2px)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-prev-button:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-next-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row [editor]:not([template=checkBox]) {
    max-width: none;
    width: auto
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout {
    grid-column-gap: 20px;
    -webkit-column-gap: 20px;
    column-gap: 20px;
    display: grid;
    grid-template-columns: 1fr 350px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-editors-container.many {
    grid-column-gap: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    overflow: hidden
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container>div {
    height: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .row {
    display: grid;
    grid-template-rows: 40px 40px 40px 40px 40px 1fr;
    height: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .history-row {
    padding: 5px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .history-layout {
    max-height: 500px;
    overflow: auto
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .history-user {
    align-items: center;
    display: grid;
    grid-template-columns: 35px 1fr 1fr
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .history-action {
    align-items: center;
    display: grid;
    grid-template-columns: 50% 50%;
    opacity: .8;
    padding-left: 35px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .history-action .detail {
    white-space: normal
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .smart-user {
    left: -3px;
    position: relative;
    top: 10px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .user-icon {
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    height: 30px;
    width: 30px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .user-icon.image:after {
    content: ""
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .user-icon:after {
    align-items: center;
    content: "\\e81f";
    content: var(--smart-icon-user);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 24px;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .user-name {
    font-weight: 700
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .time {
    opacity: .8
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-header {
    white-space: nowrap
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout {
    display: grid;
    flex-direction: column;
    grid-template-rows: 1fr auto;
    padding: 3px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comment {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-columns: 30px 1fr;
    margin: 10px;
    margin: var(--smart-data-view-padding)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comment .comment-header {
    grid-column-gap: 5px;
    grid-column-gap: calc(var(--smart-data-view-padding)/2);
    display: grid;
    grid-template-columns: 1fr auto auto;
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comment .remove-button {
    cursor: pointer;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    width: 16px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comment .remove-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comment .remove-button.enabled {
    visibility: visible
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .comments {
    max-height: 350px;
    min-height: 180px;
    overflow: auto
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .footer {
    box-sizing: border-box;
    display: flex;
    height: 45px;
    padding: 5px;
    transition: height .2s ease-in-out
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .footer.focus {
    height: 70px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .footer smart-text-area {
    border-radius: 0;
    height: 100%;
    width: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .comments-layout .footer smart-button {
    border-bottom-left-radius: 0;
    border-left-color: transparent;
    border-top-left-radius: 0;
    width: 100px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 5px;
    width: 300px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.font-group {
    grid-column-gap: 10px
}

.smart-grid.smart-container,
smart-grid {
    grid-column-gap: 0;
    grid-column-gap: var(--smart-grid-column-gap);
    contain: content
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.font-group .format:first-child {
    grid-column: 1/span 2
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.font-group .format:last-child {
    width: 100px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    display: flex;
    height: 30px;
    height: var(--smart-editor-height);
    justify-content: space-between;
    padding: 0;
    width: 100px
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .bold,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .italic,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .underline {
    border-bottom: 2px solid transparent;
    display: block;
    font-weight: 400;
    height: 100%;
    padding: 5px;
    transition: border .2s ease-in-out;
    width: 100%
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .bold:hover,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .italic:hover,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .underline:hover {
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary)
}

.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .bold.checked,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .italic.checked,
.smart-window.smart-grid-dialog.smart-grid-dialog-expand-row .smart-grid-edit-dialog-layout .smart-grid-edit-dialog-activity-container .format-layout.button-group .underline.checked {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-window.smart-grid-dialog .col-sm-6 {
    padding: 0
}

.smart-window.smart-grid-dialog>.smart-container .smart-header-section {
    cursor: default
}

.smart-window.smart-grid-dialog.open {
    opacity: 1;
    -webkit-transform: scale(1) !important;
    transform: scale(1) !important
}

.smart-window.smart-grid-dialog .smart-field-editor-error-label {
    color: #b00020;
    color: var(--smart-error);
    font-size: 10px
}

.smart-window.smart-grid-dialog [editor]:not([template=checkBox]) {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: 30px;
    max-width: 150px;
    overflow: hidden
}

.smart-window.smart-grid-dialog [editor][focus],
.smart-window.smart-grid-dialog [editor][focus] .smart-grid-cell-editor {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-window.smart-grid-dialog [editor][template=checkBox] {
    align-items: center;
    display: flex;
    height: 30px
}

.smart-window.smart-grid-dialog [editor]:not([template=checkBox]) .smart-grid-cell-editor {
    height: 100%;
    width: 100%
}

.smart-window.smart-grid-dialog>.smart-container>.smart-footer {
    height: auto
}

.smart-window.smart-grid-dialog .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px
}

.smart-window.smart-grid-dialog .column label {
    justify-content: flex-end;
    padding: 5px 0
}

.smart-window.smart-grid-dialog .smart-footer .smart-stack-layout {
    padding: 0 10px
}

smart-grid {
    grid-row-gap: 0;
    grid-row-gap: var(--smart-grid-row-gap);
    grid-template-columns: none;
    grid-template-columns: var(--smart-grid-template-columns);
    height: 400px;
    height: var(--smart-grid-default-height);
    visibility: hidden;
    width: 800px;
    width: var(--smart-grid-default-width)
}

smart-grid .smart-grid-cell-loading {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #f5f5f5;
    border: 1px solid var(--smart-surface);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: 10px;
    left: 10%;
    position: relative;
    top: calc(50% - 5px);
    width: 80%
}

smart-grid .smart-grid-add-column-button,
smart-grid .smart-grid-add-row-button {
    background: #f5f5f5;
    background: var(--smart-surface);
    bottom: 0;
    height: 30px;
    left: 0;
    opacity: 0;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: all .2s ease-in-out;
    width: 30px;
    z-index: 12
}

smart-grid .smart-grid-add-column-button.float,
smart-grid .smart-grid-add-row-button.float {
    background: #005c99;
    background: var(--smart-primary);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-radius: 50%;
    bottom: 5px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    color: #fff;
    color: var(--smart-primary-color);
    left: 5px
}

smart-grid .smart-grid-add-column-button.smart-grid-add-column-button,
smart-grid .smart-grid-add-row-button.smart-grid-add-column-button {
    left: auto;
    right: 5px;
    top: 55px
}

smart-grid .smart-grid-add-column-button.show,
smart-grid .smart-grid-add-row-button.show {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1)
}

smart-grid .smart-grid-add-column-button.show:active,
smart-grid .smart-grid-add-column-button.show:hover,
smart-grid .smart-grid-add-row-button.show:active,
smart-grid .smart-grid-add-row-button.show:hover {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-grid .smart-grid-add-column-button.show:active.float,
smart-grid .smart-grid-add-column-button.show:hover.float,
smart-grid .smart-grid-add-row-button.show:active.float,
smart-grid .smart-grid-add-row-button.show:hover.float {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6);
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
}

smart-grid.smart-kanban-view .smart-grid-add-row-button {
    display: none !important
}

smart-grid[appearance_allow-hover] smart-grid-cell:not([focus]):hover:not(.smart-add-new-column) {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid[appearance_allow-hover] smart-grid-cell:not([focus]):hover:not(.smart-add-new-column) .smart-label {
    background: #ebebeb !important;
    background: var(--smart-ui-state-hover) !important;
    color: #333 !important;
    color: var(--smart-ui-state-color-hover) !important
}

smart-grid[appearance_allow-hover]:not([selection_allow-cell-selection]) smart-grid-row:hover smart-grid-cell:not([focus]) {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid[appearance_allow-hover]:not([selection_allow-cell-selection]) smart-grid-row:hover smart-grid-cell:not([focus]) .smart-label {
    background: #ebebeb !important;
    background: var(--smart-ui-state-hover) !important;
    color: #333 !important;
    color: var(--smart-ui-state-color-hover) !important
}

smart-grid[tree] smart-grid-cell[has-toggle-button]:not([detail]) button[toggle-button] {
    padding-right: 14px
}

smart-grid.smart-element {
    visibility: inherit
}

smart-grid[grouped] {
    background-color: #f5f5f5;
    background-color: var(--smart-surface)
}

smart-grid:not([selection_allow-cell-selection]) smart-grid-row[focus] smart-grid-cell:not([editor]):not([header]),
smart-grid:not([selection_allow-cell-selection]) smart-grid-row[focus] smart-grid-cell:not([editor]):not([header]) .smart-label {
    background: #005c99 !important;
    background: var(--smart-primary) !important;
    border-color: #005c99 !important;
    border-color: var(--smart-primary) !important;
    color: #fff !important;
    color: var(--smart-primary-color) !important
}

smart-grid:not([selection_allow-cell-selection]) smart-grid-row[focus] smart-grid-cell:not([editor]):not([header]):before {
    background: #005c99;
    background: var(--smart-primary)
}

smart-grid[selection_allow-cell-selection] smart-grid-row[focus] smart-grid-cell[focus]:not([editor]):not([header]) {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-grid.smart-container {
    grid-row-gap: 0;
    grid-row-gap: var(--smart-grid-row-gap);
    grid-template-columns: none;
    grid-template-columns: var(--smart-grid-template-columns);
    visibility: hidden
}

.smart-grid.smart-container .smart-grid-header,
.smart-grid>.smart-container .smart-grid-header {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-bottom: 1px solid;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    height: 48px;
    height: var(--smart-grid-header-height);
    width: 100%
}

.smart-grid.smart-container .smart-grid-column-header,
.smart-grid>.smart-container .smart-grid-column-header {
    color: #323232;
    color: var(--smart-surface-color);
    height: 48px;
    height: var(--smart-grid-column-header-height);
    min-height: 30px;
    overflow: hidden;
    position: relative;
    z-index: 99
}

.smart-grid.smart-container .smart-grid-pager,
.smart-grid>.smart-container .smart-grid-pager {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom-color: inherit;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    color: #323232;
    color: var(--smart-surface-color);
    height: 48px;
    height: var(--smart-pager-default-height);
    overflow: hidden;
    width: 100%;
    z-index: 99
}

.smart-grid.smart-container .smart-grid-content,
.smart-grid>.smart-container .smart-grid-content {
    border: none;
    height: 100%;
    overflow: hidden;
    padding: 0;
    width: 100%
}

.smart-grid.smart-container.smart-grid-resize-mode,
.smart-grid>.smart-container.smart-grid-resize-mode {
    overflow: visible
}

.smart-grid.smart-element {
    visibility: inherit
}

.smart-grid[sorting_mode=many] smart-grid-column[sort-index] .smart-sort-button[order] {
    width: 40px
}

.smart-grid[sorting_mode=many] smart-grid-column[sort-index] .smart-sort-button:after {
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    color: #fff;
    color: var(--smart-primary-color);
    content: attr(order);
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 11px;
    height: 8px;
    justify-content: center;
    margin-left: 5px;
    padding: 5px
}

.smart-grid smart-grid-row .smart-grid-row-detail {
    background: #fefefe;
    background: var(--smart-background);
    border-bottom: 1px solid #e0e0e0;
    border-bottom-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    position: absolute;
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transform-origin: top;
    transform-origin: top;
    width: 100%;
    z-index: 3
}

.smart-grid smart-grid-row .smart-grid-row-detail>div {
    height: 100%;
    line-height: normal;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-grid smart-grid-column:not(.smart-grid-column-border).smart-grid-vertical-border-collapse:before,
.smart-grid smart-grid-row smart-grid-cell:not(.smart-grid-column-border).smart-grid-vertical-border-collapse:before {
    width: 0
}

.smart-grid smart-grid-column:not(.smart-grid-column-border).smart-grid-horizontal-border-collapse:after,
.smart-grid smart-grid-row smart-grid-cell:not(.smart-grid-column-border).smart-grid-horizontal-border-collapse:after {
    height: 0
}

.smart-grid smart-grid-row[has-detail] {
    transition: height .25s ease-in-out
}

.smart-grid smart-grid-row[has-detail] .smart-grid-row-detail.smart-animate {
    transition: height .25s ease-in-out, -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out, height .25s ease-in-out;
    transition: transform .25s ease-in-out, height .25s ease-in-out, -webkit-transform .25s ease-in-out
}

.smart-grid smart-grid-row[show-detail] .smart-grid-row-detail {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-grid smart-grid-row[unbound] smart-grid-cell {
    background: #f5f5f5;
    background: var(--smart-grid-cell-background-unbound);
    color: #323232;
    color: var(--smart-grid-cell-color-unbound)
}

.smart-grid smart-grid-cell.dragged,
.smart-grid smart-grid-column.dragged {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em
}

.smart-grid smart-grid-column .smart-grid-command-item {
    align-items: center;
    border-radius: 0;
    justify-content: center;
    padding: 0
}

.smart-grid smart-grid-column.afterTarget:last-child:after {
    right: 0
}

.smart-grid smart-grid-cell .smart-grid-command-item {
    overflow: hidden;
    padding: 0 3px
}

.smart-grid smart-scroll-bar {
    bottom: 0;
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    overflow: visible;
    position: absolute;
    touch-action: none;
    width: 100%;
    z-index: 11
}

.smart-grid smart-scroll-bar:after,
.smart-grid smart-scroll-bar:before {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    content: "";
    height: 18px;
    height: var(--smart-scroll-bar-size);
    position: absolute;
    top: 0
}

.smart-grid smart-scroll-bar:after {
    left: 100%;
    min-width: var(--smart-scroll-bar-far-size);
    width: 18px;
    width: var(--smart-scroll-bar-size)
}

.smart-grid smart-scroll-bar:before {
    left: calc(0px - var(--smart-scroll-bar-near-size));
    width: var(--smart-scroll-bar-near-size)
}

.smart-grid smart-scroll-bar.smart-element {
    border: none;
    border-radius: 0
}

.smart-grid smart-scroll-bar.bottom-corner-visible {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-grid smart-scroll-bar[orientation=vertical] {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    height: 100%;
    right: 0;
    top: 0;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-grid smart-scroll-bar[orientation=vertical]:before {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    height: var(--smart-scroll-bar-near-size);
    left: -1px;
    top: calc(0px - var(--smart-scroll-bar-near-size))
}

.smart-grid smart-scroll-bar[orientation=vertical]:after,
.smart-grid smart-scroll-bar[orientation=vertical]:before {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    content: "";
    position: absolute;
    width: 18px;
    width: var(--smart-scroll-bar-size)
}

.smart-grid smart-scroll-bar[orientation=vertical]:after {
    bottom: calc(0px - var(--smart-scroll-bar-far-size));
    height: 18px;
    height: var(--smart-scroll-bar-size);
    left: 0;
    min-height: var(--smart-scroll-bar-far-size);
    min-width: 0;
    top: auto;
    z-index: -1
}

.smart-grid smart-scroll-bar[orientation=vertical].bottom-corner-visible {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-grid .smart-data-view-header-drop-down {
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-grid .smart-data-view-header-drop-down.open {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-grid .smart-breadcrumb-items>.afterTarget:last-child:after,
.smart-grid .smart-breadcrumb-items>.target:before {
    content: "";
    display: none
}

.smart-grid .smart-grid-command-item {
    border: 1px solid transparent;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    cursor: pointer;
    display: flex;
    min-width: 25px;
    padding: 5px 8px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-grid .smart-grid-command-item:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: 1px solid var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-grid .smart-grid-command-item:active {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-grid .smart-grid-command-item .smart-grid-icon {
    display: flex;
    min-width: 16px;
    width: auto
}

.smart-grid .smart-grid-command-item span:last-child:not(:first-child) {
    margin-left: 4px
}

.smart-grid .smart-grid-command-bar {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-grid .smart-grid-command-bar .smart-grid-icon {
    display: flex
}

.smart-grid .smart-grid-row:not([leaf]) smart-grid-cell[group]:not([header]) div:not([content]) {
    visibility: hidden
}

.smart-grid .smart-grid-resize-line {
    background: #005c99;
    background: var(--smart-primary);
    opacity: .8;
    position: absolute;
    width: 1px;
    width: var(--smart-grid-resize-line-size);
    z-index: 99
}

.smart-grid .smart-grid-resize-line.row {
    height: 1px;
    height: var(--smart-grid-resize-line-size)
}

.smart-grid .smart-grid-resize-tooltip {
    background: #005c99;
    background: var(--smart-primary);
    bottom: 0;
    color: #fff;
    color: var(--smart-primary-color);
    padding: 5px;
    position: absolute;
    transition: width .2s ease-out;
    z-index: 99
}

.smart-grid .smart-grid-drag-line:after,
.smart-grid .smart-grid-drag-line:before {
    color: #005c99;
    color: var(--smart-primary);
    font-size: 16px;
    font-weight: 700;
    left: 0;
    margin-left: -7px;
    position: absolute
}

.smart-grid .smart-grid-drag-line {
    background: #005c99;
    background: var(--smart-primary);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    opacity: 1;
    position: absolute;
    transition: opacity .25s cubic-bezier(.6, .2, 0, .8);
    width: 2px;
    width: calc(var(--smart-grid-resize-line-size)*2);
    z-index: 199
}

.smart-grid .smart-grid-drag-line:after {
    bottom: 0;
    content: "\\e904";
    content: var(--smart-icon-arrow-up);
    margin-bottom: -11px
}

.smart-grid .smart-grid-drag-line:before {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    margin-top: -7px;
    top: 0
}

.smart-grid .smart-grid-drag-line.row {
    height: 2px;
    height: calc(var(--smart-grid-resize-line-size)*2)
}

.smart-grid .smart-grid-drag-line.row:after {
    bottom: 0;
    content: "\\e902";
    content: var(--smart-icon-arrow-left);
    font-weight: 700;
    left: auto;
    margin-bottom: -7px;
    margin-right: -7px;
    right: 0
}

.smart-grid .smart-grid-drag-line.row:before {
    content: "\\e903";
    content: var(--smart-icon-arrow-right);
    left: 0
}

.smart-grid[grouped] {
    background-color: #f5f5f5;
    background-color: var(--smart-surface)
}

.smart-grid[grouped] smart-grid-row[group]:not([summary])>.smart-grid-cell-container>smart-grid-cell .smart-label {
    align-items: center;
    padding: 5px 0 0;
    padding-top: calc(var(--smart-grid-group-row-vertical-offset)*1px)
}

.smart-grid[grouped] smart-grid-row[group][summary]>.smart-grid-cell-container>smart-grid-cell div[content] {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-top: none;
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[label] {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-left: 7px;
    width: 100%
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[label] div[header] {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    line-height: normal
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[label] div[summary] {
    line-height: normal;
    padding-right: 10px
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[label] div[summary] span {
    color: #323232;
    color: var(--smart-surface-color);
    font-size: 9px;
    font-weight: 500;
    opacity: .75
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[label] span[group] {
    color: #323232;
    color: var(--smart-surface-color);
    font-size: 11px;
    font-weight: 500;
    opacity: .75
}

.smart-grid[grouped] smart-grid-row[group][selected]>.smart-grid-cell-container>smart-grid-cell div[label] div[summary] span,
.smart-grid[grouped] smart-grid-row[group][selected]>.smart-grid-cell-container>smart-grid-cell div[label] span[group] {
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-grid[grouped] smart-grid-row[group][selected]>.smart-grid-cell-container>smart-grid-cell div[content] {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border: 1px solid rgba(0, 92, 153, .1);
    border: 1px solid var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell {
    background: #f5f5f5;
    background: var(--smart-surface)
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[content] {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-left: .5px solid #e0e0e0;
    border-left: calc(1px*var(--smart-grid-group-row-horizontal-offset)/(1 + var(--smart-grid-group-row-horizontal-offset))) solid var(--smart-border);
    border-right: none;
    border-top: .83333px solid #e0e0e0;
    border-top: calc(1px*var(--smart-grid-group-row-vertical-offset)/(1 + var(--smart-grid-group-row-vertical-offset))) solid var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    height: 100%;
    line-height: normal;
    width: 100%
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[content].smart-grid-column-border {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-radius);
    border-right: .5px solid #e0e0e0;
    border-right: calc(1px*var(--smart-grid-group-row-horizontal-offset)/(1 + var(--smart-grid-group-row-horizontal-offset))) solid var(--smart-border);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-radius)
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] div[content] {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-radius)
}

.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell:not(.smart-grid-column-border):after,
.smart-grid[grouped] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell:not(.smart-grid-column-border):before {
    display: none
}

.smart-grid[grouped] smart-grid-row[group][level="1"]>.smart-grid-cell-container>smart-grid-cell div[content],
.smart-grid[grouped] smart-grid-row[group][level="2"]>.smart-grid-cell-container>smart-grid-cell div[content] {
    background: #f5f5f5;
    background: var(--smart-surface)
}

.smart-grid[grouped] smart-grid-row>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] .smart-label {
    margin-left: 0;
    margin-left: calc(-1px + 1px*var(--smart-grid-group-row-horizontal-offset))
}

.smart-grid[grouped] smart-grid-row>.smart-grid-cell-container>smart-grid-cell:last-child {
    margin-left: 0;
    margin-left: calc(1px - 1px*var(--smart-grid-group-row-horizontal-offset))
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] .smart-label {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    padding: 0
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button]:after {
    visibility: hidden
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] div[content] {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    height: 100%;
    line-height: normal;
    width: 100%
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] div[content]:before {
    background: #e0e0e0;
    background: var(--smart-border);
    content: "";
    height: 100%;
    position: absolute;
    top: 0;
    width: .5px;
    width: calc(1px*var(--smart-grid-group-row-horizontal-offset)/(1 + var(--smart-grid-group-row-horizontal-offset)))
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button] div[content]:after {
    background: #e0e0e0;
    background: var(--smart-border);
    bottom: 0;
    content: "";
    height: 1px;
    height: var(--smart-border-width);
    position: absolute;
    width: 100%
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell[has-toggle-button][selected] div[content] {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-grid[grouped] smart-grid-row[leaf]:not([group])>.smart-grid-cell-container>smart-grid-cell.smart-grid-column-border {
    border-right-width: .5px;
    border-right-width: calc(1px*var(--smart-grid-group-row-horizontal-offset)/(1 + var(--smart-grid-group-row-horizontal-offset)))
}

.smart-grid[grouped] smart-grid-row:not([leaf])[group]>.smart-grid-cell-container>smart-grid-cell:not(.smart-grid-column-border):after,
.smart-grid[grouped] smart-grid-row:not([leaf])[group]>.smart-grid-cell-container>smart-grid-cell:not(.smart-grid-column-border):before {
    display: none
}

.smart-grid[grouped] smart-grid-row[expanded][leaf][group]>.smart-grid-cell-container>smart-grid-cell div[content] {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.smart-grid[grouped] smart-grid-row[leaf]>.smart-grid-cell-container>smart-grid-cell div[label] {
    align-items: center;
    display: flex;
    padding: 2px 7px;
    width: 100%
}

.smart-grid[grouped] smart-grid-row[leaf]>.smart-grid-cell-container>smart-grid-cell .align-right div[label] {
    justify-content: flex-end
}

.smart-grid[grouped] smart-grid-row[leaf]>.smart-grid-cell-container>smart-grid-cell .align-left div[label],
smart-grid-cell button[toggle-button]:after {
    justify-content: flex-start
}

.smart-grid[grouped] smart-grid-row[leaf]>.smart-grid-cell-container>smart-grid-cell .align-center div[label] {
    justify-content: center
}

.smart-grid[grouped] smart-grid-row[summary]>.smart-grid-cell-container>smart-grid-cell {
    color: #323232;
    color: var(--smart-surface-color);
    font-size: 9px;
    font-weight: 500;
    opacity: .75
}

.smart-grid[grouped] smart-grid-row[summary][selected]>.smart-grid-cell-container>smart-grid-cell {
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-grid[grouped] smart-grid-row[summary][group]>.smart-grid-cell-container>smart-grid-cell div[content] {
    border-radius: 0
}

.smart-grid[grouped][right-to-left] smart-grid-row[group]>.smart-grid-cell-container>smart-grid-cell div[content] {
    flex-direction: row-reverse
}

.smart-grid[tree] smart-grid-row[level]>.smart-grid-cell-container>smart-grid-cell div[content] {
    align-items: center;
    display: flex;
    height: 100%;
    line-height: normal;
    width: 100%
}

.smart-grid[tree] smart-grid-row[level]>.smart-grid-cell-container>smart-grid-cell div[content]>div[checkbox]:not(.smart-hidden) {
    margin-right: 7px
}

.smart-grid[tree][right-to-left] smart-grid-row[level]>.smart-grid-cell-container>smart-grid-cell div[content] {
    flex-direction: row-reverse
}

.smart-grid[tree][right-to-left] smart-grid-row[level]>.smart-grid-cell-container>smart-grid-cell div[content]>div[checkbox]:not(.smart-hidden) {
    margin-left: 5px;
    margin-right: 0
}

.smart-grid[appearance_allow-header-hover] smart-grid-cell[header]:hover,
.smart-grid[appearance_allow-header-hover] smart-grid-column:not(.top-far-corner):not(.top-near-corner)[header]:hover,
.smart-grid[appearance_allow-hover] smart-grid-row:hover smart-grid-cell:not(.smart-add-new-column) {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    cursor: default
}

.smart-grid[appearance_show-row-header-drag-icon] smart-grid-row smart-grid-cell[header]:not([detail])>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-drag-icon] smart-grid-row smart-grid-cell[header]:not([detail])>.smart-label:before {
    align-items: flex-end;
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    content: "\\f141";
    content: var(--smart-icon-ellipsis);
    cursor: move;
    display: flex;
    justify-content: center;
    left: 0;
    opacity: .25;
    position: absolute;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    width: 100%
}

.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit] smart-grid-cell[header]:not([detail])>.smart-label,
.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit][focus] smart-grid-cell[header]:not([detail])>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit] smart-grid-cell[header]:not([detail])>.smart-label:before,
.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit][focus] smart-grid-cell[header]:not([detail])>.smart-label:before {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    content: "\\e909";
    content: var(--smart-icon-mode-edit);
    left: 0;
    position: absolute;
    width: 100%
}

.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit] smart-grid-cell[header]:not([detail]):last-child>.smart-label,
.smart-grid[appearance_show-row-header-edit-icon] smart-grid-row[edit][focus] smart-grid-cell[header]:not([detail]):last-child>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-focus-icon] smart-grid-row[focus]:not([edit]) smart-grid-cell[header]:not([detail]):not(:hover)>.smart-label:before {
    content: "\\e903";
    content: var(--smart-icon-arrow-right)
}

.smart-grid[appearance_show-row-header-focus-icon] smart-grid-row[focus]:not([edit]) smart-grid-cell[header]:not([detail]):last-child>.smart-label,
.smart-grid[appearance_show-row-header-focus-icon] smart-grid-row[focus]:not([edit]) smart-grid-cell[header]:not([detail])>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-focus-icon] smart-grid-row[focus]:not([edit]) smart-grid-cell[header]:not([detail])>.smart-label:before {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    content: "\\f096";
    content: var(--smart-icon-check-empty);
    left: 0;
    position: absolute;
    width: 100%
}

.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail]):hover>.smart-label,
.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail])[selected]>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail]):hover>.smart-label:before,
.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail])[selected]>.smart-label:before {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    content: "\\f096";
    content: var(--smart-icon-check-empty);
    left: 0;
    position: absolute;
    width: 100%
}

.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail]):hover:last-child>.smart-label,
.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail])[selected]:last-child>.smart-label {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    left: 0;
    min-width: 0;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 0;
    width: 100%
}

.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail]):hover[selected]>.smart-label:before,
.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail])[selected][selected]>.smart-label:before {
    content: "\\e81b";
    content: var(--smart-icon-check-squared);
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-grid[appearance_show-row-header-select-icon][selection_enabled][selection_allow-row-header-selection] smart-grid-row smart-grid-cell[header]:not([detail])[selected]>.smart-label:before {
    content: "\\e81b";
    content: var(--smart-icon-check-squared);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-style: normal;
    font-weight: 400;
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-grid[right-to-left] smart-scroll-bar:after {
    left: auto;
    right: 100%
}

.smart-grid[right-to-left] smart-scroll-bar:before {
    left: 0
}

.smart-grid[right-to-left] smart-scroll-bar[orientation=vertical] {
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border);
    left: 0;
    right: auto
}

.smart-grid[right-to-left] smart-grid-column .smart-label.smart-animate {
    transition: left .25s ease, width .25s ease
}

.smart-grid[right-to-left] smart-grid-column .smart-label.one {
    left: 23px;
    left: var(--smart-grid-column-buttons-width)
}

.smart-grid[right-to-left] smart-grid-column .smart-label.two {
    left: 46px;
    left: calc(var(--smart-grid-column-buttons-width)*2)
}

.smart-grid[right-to-left] smart-grid-column .smart-label.three {
    left: 69px;
    left: calc(var(--smart-grid-column-buttons-width)*3)
}

.smart-grid[right-to-left] smart-grid-column .smart-label.four {
    left: 92px;
    left: calc(var(--smart-grid-column-buttons-width)*4)
}

.smart-grid[right-to-left] smart-grid-column .smart-label.five {
    left: 115px;
    left: calc(var(--smart-grid-column-buttons-width)*5)
}

.smart-grid[right-to-left] smart-grid-column .smart-label.six {
    left: 138px;
    left: calc(var(--smart-grid-column-buttons-width)*6)
}

.smart-grid[right-to-left] smart-grid-column .smart-buttons-group {
    flex-direction: row-reverse;
    left: 0;
    right: auto;
    -webkit-transform: translateX(-22.9px);
    transform: translateX(-22.9px);
    -webkit-transform: translateX(calc(.1px - var(--smart-grid-column-buttons-width)));
    transform: translateX(calc(.1px - var(--smart-grid-column-buttons-width)))
}

.smart-grid[right-to-left] smart-grid-column .smart-buttons-group.action {
    -webkit-transform: translateX(0);
    transform: translateX(0)
}

.smart-grid[right-to-left] smart-grid-column .smart-action-button {
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border)
}

.smart-grid[right-to-left] smart-grid-column.top-far-corner {
    left: 0;
    right: auto
}

.smart-grid[right-to-left] smart-grid-cell[has-toggle-button] .smart-label,
.smart-grid[right-to-left] smart-grid-cell[has-toggle-button] div[indent] {
    flex-direction: row-reverse
}

.smart-grid[right-to-left] .smart-grid-column-group:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before,
.smart-grid[right-to-left] smart-grid-cell:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before,
.smart-grid[right-to-left] smart-grid-column:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    left: auto;
    right: 0
}

.smart-grid.smart-container,
smart-grid>.smart-container {
    border: 0 solid transparent;
    height: 100%;
    margin-bottom: -3px;
    max-height: inherit;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 100%
}

smart-grid-row {
    cursor: default;
    display: block;
    height: 30px;
    height: var(--smart-grid-row-height);
    overflow: visible;
    padding: 0;
    position: relative
}

smart-grid-row:hover smart-grid-cell[checkbox][header][auto-show] .smart-input {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    opacity: 1
}

smart-grid-row smart-grid-cell[header] .smart-grid-cell-editor.smart-grid-input-cell-editor {
    background: #fefefe;
    background: var(--smart-background);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: calc(100% - 1px);
    left: 1px;
    padding-bottom: 0;
    padding-top: 0;
    position: absolute;
    top: 0;
    z-index: 10
}

smart-grid-row .smart-grid-row-sub-container {
    overflow: visible;
    position: relative;
    -webkit-transform-origin: top;
    transform-origin: top;
    width: 100%;
    z-index: 3
}

smart-grid-row .smart-grid-row-sub-container.smart-animate {
    transition: height .25s ease-in-out, -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out, height .25s ease-in-out;
    transition: transform .25s ease-in-out, height .25s ease-in-out, -webkit-transform .25s ease-in-out
}

smart-grid-row .smart-grid-command-bar {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    box-sizing: border-box;
    color: #323232;
    color: var(--smart-surface-color);
    height: calc(100% - 1px);
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: right;
    transform-origin: right;
    transition: -webkit-transform .25s ease;
    transition: transform .25s ease;
    transition: transform .25s ease, -webkit-transform .25s ease;
    z-index: 7
}

smart-grid-row .smart-grid-command-bar.show {
    -webkit-transform: scaleX(1);
    transform: scaleX(1)
}

smart-grid-row[edit] {
    z-index: 7
}

smart-grid-row[edit][error] {
    z-index: 101
}

smart-grid-row[edit][error] smart-grid-cell[editor] {
    border-color: #b00020;
    border-color: var(--smart-error)
}

smart-grid-row[filter=indeterminate] {
    opacity: .75
}

smart-grid-row.smart-animate {
    transition: margin-bottom .25s ease-in-out, height .25s ease-in-out
}

smart-grid-row:not([selected]) smart-grid-cell[selected]:not([selected=indeterminate]):not([header]):not(.smart-grid-column-border):after {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    opacity: .3;
    opacity: var(--smart-grid-cell-horizontal-border-opacity-selected, .3)
}

smart-grid-row[selected] smart-grid-cell[selected]:not([selected=indeterminate]):not([header]):not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    opacity: .3;
    opacity: var(--smart-grid-cell-vertical-border-opacity-selected, .3)
}

smart-grid-row[selected] smart-grid-cell[selected]:not([selected=indeterminate]):not([header]):not(.smart-grid-column-border):after {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    opacity: .3;
    opacity: var(--smart-grid-cell-horizontal-border-opacity-selected, .3)
}

smart-grid-row[selected] smart-grid-cell[header] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid-row[selected] smart-grid-cell[checkbox][header][auto-show] .smart-input {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    opacity: 1
}

smart-grid-row[selected]:not([selected=indeterminate]):not([selected=none]):before {
    top: -1px
}

smart-grid-row[selected]:not([selected=indeterminate]):not([selected=none]):after,
smart-grid-row[selected]:not([selected=indeterminate]):not([selected=none]):before {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    content: "";
    height: 1px;
    height: var(--smart-border-width);
    opacity: .3;
    opacity: var(--smart-grid-cell-horizontal-border-opacity-selected, .3);
    position: absolute;
    width: 100%
}

smart-grid-row[selected]:not([selected=indeterminate]):not([selected=none]):after {
    bottom: 0
}

smart-grid-row[selected]:not([selected=indeterminate]) smart-grid-cell[selected]:not([selected=indeterminate]):not([header]):not(.smart-grid-column-border):before {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    opacity: .3;
    opacity: var(--smart-grid-cell-vertical-border-opacity-selected, .3)
}

smart-grid-row[selected=none] smart-grid-cell {
    color: #ccc;
    color: var(--smart-disabled)
}

smart-grid-row[selected=indeterminate] smart-grid-cell[selected]:not([editor]) {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

smart-grid-row[selected=indeterminate] smart-grid-cell[selected][focus]:not([editor]):not([rowspan]):not([colspan]) {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    opacity: 1
}

smart-grid-row[alternation-index="0"] smart-grid-cell[editor]:not([selected]):not([header]):not([highlight]):not([freeze])>.smart-label,
smart-grid-row[alternation-index="1"] smart-grid-cell[editor]:not([selected]):not([header]):not([highlight]):not([freeze])>.smart-label,
smart-grid-row[alternation-index="3"] smart-grid-cell[editor]:not([selected]):not([header]):not([highlight]):not([freeze])>.smart-label,
smart-grid-row[alternation-index="4"] smart-grid-cell[editor]:not([selected]):not([header]):not([highlight]):not([freeze])>.smart-label {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    box-sizing: border-box;
    height: calc(100% - 1px);
    left: 1px;
    margin: 0;
    outline: 0;
    padding: 0;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: calc(100% - 1px)
}

smart-grid-cell,
smart-grid-column {
    border-style: solid;
    white-space: nowrap
}

smart-grid-row[alternation-index="0"] smart-grid-cell:not([selected]):not([header]):not([update]):not([delete]):not([add]):not([freeze]) .smart-label {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-grid-row[alternation-index="1"] smart-grid-cell:not([selected]):not([header]):not([update]):not([delete]):not([add]):not([freeze]) .smart-label {
    background-color: #f5f5f5;
    background-color: var(--smart-alternation-index0-background);
    border-color: #f5f5f5;
    border-color: var(--smart-alternation-index0-border);
    color: #323232;
    color: var(--smart-alternation-index0-color)
}

smart-grid-row[alternation-index="2"] smart-grid-cell:not([selected]):not([header]):not([update]):not([delete]):not([add]):not([freeze]) .smart-label {
    background-color: #9bbb59;
    background-color: var(--smart-alternation-index1-background);
    border-color: #9bbb59;
    border-color: var(--smart-alternation-index1-border);
    color: #111;
    color: var(--smart-alternation-index1-color)
}

smart-grid-row[alternation-index="3"] smart-grid-cell:not([selected]):not([header]):not([update]):not([delete]):not([add]):not([freeze]) .smart-label {
    background-color: #fc3752;
    background-color: var(--smart-alternation-index2-background);
    border-color: #fc3752;
    border-color: var(--smart-alternation-index2-border);
    color: #fff;
    color: var(--smart-alternation-index2-color)
}

smart-grid-row[alternation-index="4"] smart-grid-cell:not([selected]):not([header]):not([update]):not([delete]):not([add]):not([freeze]) .smart-label {
    background-color: var(--smart-alternation-index3-background);
    border-color: var(--smart-alternation-index3-border);
    color: var(--smart-alternation-index3-color)
}

smart-grid-column {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-width: 0;
    color: #323232;
    color: var(--smart-surface-color);
    cursor: default;
    display: flex;
    height: 100%;
    min-height: 30px;
    overflow: hidden;
    position: absolute
}

smart-grid-cell.smart-add-new-column:after,
smart-grid-cell.smart-add-new-column:before,
smart-grid-column .smart-icon {
    display: none
}

smart-grid-column[focus],
smart-grid-column[selected] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid-column[highlight],
smart-grid-column[highlight][freeze] {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-grid-column:hover .smart-action-button {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid-column:hover .smart-action-button div:after,
smart-grid-column:hover .smart-action-button div:before {
    background: #333;
    background: var(--smart-ui-state-color-hover)
}

smart-grid-column .smart-icon.show {
    display: flex !important;
    height: 100%;
    left: 4px;
    position: relative;
    width: 23px;
    width: var(--smart-grid-column-buttons-width)
}

smart-grid-column .smart-icon.show.smart-add-new-column {
    justify-content: center;
    left: 0;
    width: 100%
}

smart-grid-column .smart-icon .smart-grid-icon {
    display: flex
}

smart-grid-column .smart-label:not(.smart-input) {
    left: 0;
    position: relative
}

smart-grid-column .smart-label:not(.smart-input).smart-animate {
    transition: width .25s ease
}

smart-grid-column .smart-label:not(.smart-input).one {
    min-width: 30px;
    width: calc(100% - 23px);
    width: calc(100% - var(--smart-grid-column-buttons-width))
}

smart-grid-column .smart-label:not(.smart-input).two {
    min-width: 30px;
    width: calc(100% - 46px);
    width: calc(100% - var(--smart-grid-column-buttons-width)*2)
}

smart-grid-column .smart-label:not(.smart-input).three {
    min-width: 30px;
    width: calc(100% - 69px);
    width: calc(100% - var(--smart-grid-column-buttons-width)*3)
}

smart-grid-column .smart-label:not(.smart-input).four {
    min-width: 30px;
    width: calc(100% - 92px);
    width: calc(100% - var(--smart-grid-column-buttons-width)*4)
}

smart-grid-column .smart-label:not(.smart-input).five {
    min-width: 30px;
    width: calc(100% - 115px);
    width: calc(100% - var(--smart-grid-column-buttons-width)*5)
}

smart-grid-column .smart-label:not(.smart-input).six {
    min-width: 30px;
    width: calc(100% - 138px);
    width: calc(100% - var(--smart-grid-column-buttons-width)*6)
}

smart-grid-column .smart-buttons-group {
    display: flex;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-transform: translateX(23px);
    transform: translateX(23px);
    -webkit-transform: translateX(var(--smart-grid-column-buttons-width));
    transform: translateX(var(--smart-grid-column-buttons-width))
}

smart-grid-column .smart-buttons-group.smart-animate {
    transition: -webkit-transform .25s ease;
    transition: transform .25s ease;
    transition: transform .25s ease, -webkit-transform .25s ease
}

smart-grid-column .smart-buttons-group.action {
    -webkit-transform: translateX(0);
    transform: translateX(0)
}

smart-grid-column .smart-sort-button.asc,
smart-grid-column .smart-sort-button.desc {
    display: flex
}

smart-grid-column .smart-sort-button.asc:before,
smart-grid-column .smart-sort-button.desc:before {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    position: relative
}

smart-grid-column .smart-sort-button.asc:before {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

smart-grid-column .smart-sort-button.desc:before {
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

smart-grid-column .smart-filter-button.smart-animate:before,
smart-grid-column .smart-sort-button.smart-animate:before {
    transition: opacity .3s ease-out, -webkit-transform .2s ease-out;
    transition: transform .2s ease-out, opacity .3s ease-out;
    transition: transform .2s ease-out, opacity .3s ease-out, -webkit-transform .2s ease-out
}

smart-grid-column .smart-description-button {
    margin-right: 3px
}

smart-grid-column .smart-action-button {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex
}

smart-grid-column .smart-action-button div {
    background: 0 0;
    border-bottom: 2px solid;
    border-top: 2px solid;
    color: inherit;
    display: flex !important;
    font-size: 0;
    height: 12px;
    position: relative;
    transition: all .25s ease-in-out;
    width: 14px
}

smart-grid-column .smart-action-button div:after,
smart-grid-column .smart-action-button div:before {
    background: #323232;
    background: var(--smart-surface-color);
    content: "";
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out;
    transition: transform .25s ease-in-out, -webkit-transform .25s ease-in-out;
    width: 100%
}

smart-grid-column .smart-action-button.smart-animate {
    transition: width .25s ease
}

smart-grid-column .smart-action-button.active:before {
    -webkit-transform: translate(-50%, -50%) rotate(45deg);
    transform: translate(-50%, -50%) rotate(45deg)
}

smart-grid-column .smart-action-button.active:after {
    -webkit-transform: translate(-50%, -50%) rotate(-45deg);
    transform: translate(-50%, -50%) rotate(-45deg)
}

smart-grid-column .smart-grid-cell-editor.smart-grid-input-cell-editor {
    background: #fefefe;
    background: var(--smart-background);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: calc(100% - 1px);
    left: 1px;
    padding-bottom: 0;
    padding-top: 0;
    position: absolute;
    top: 0;
    z-index: 10
}

smart-grid-column[freeze] {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

smart-grid-column[aria-controls] .smart-action-button {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-grid-column[aria-controls] .smart-action-button div:after,
smart-grid-column[aria-controls] .smart-action-button div:before {
    background: #333;
    background: var(--smart-ui-state-color-focus)
}

smart-grid-column.smart-grid-column-border {
    border-width: 1px;
    border-width: var(--smart-border-width)
}

smart-grid-column.top-far-corner {
    position: absolute;
    right: 0;
    top: 0;
    width: 18px;
    width: var(--smart-scroll-bar-size);
    z-index: 1
}

smart-grid-column:not(.smart-grid-column-border):after {
    background: #e0e0e0;
    background: var(--smart-grid-column-horizontal-border, var(--smart-border))
}

smart-grid-column:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    background: #e0e0e0;
    background: var(--smart-border)
}

smart-grid-column:not(.smart-grid-column-border-collapse):before {
    background: #e0e0e0;
    background: var(--smart-grid-column-vertical-border, var(--smart-border))
}

smart-grid-cell,
smart-grid-cell .dropdownlist.dropdownlist .smart-arrow-down,
smart-grid-cell .list.dropdownlist .smart-arrow-down,
smart-grid-cell .tokens.dropdownlist .smart-arrow-down {
    background: #fefefe;
    background: var(--smart-background)
}

smart-grid-cell {
    border-width: 0;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-size: inherit;
    font-size: var(--smart-grid-cell-font-size, inherit);
    font-weight: inherit;
    font-weight: var(--smart-grid-cell-font-weight, inherit);
    height: 100%;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis
}

smart-grid-cell .wrap {
    white-space: normal
}

smart-grid-cell .nowrap,
smart-grid-cell .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.5
}

smart-grid-cell .nowrap {
    white-space: nowrap
}

smart-grid-cell .dropdownlist,
smart-grid-cell .list,
smart-grid-cell .tokens {
    padding-left: 6px
}

smart-grid-cell .dropdownlist .smart-token,
smart-grid-cell .list .smart-token,
smart-grid-cell .tokens .smart-token {
    display: inline-flex;
    line-height: 1.5;
    margin-bottom: 4px;
    margin-bottom: var(--smart-editor-label-padding)
}

smart-grid-cell .dropdownlist .smart-arrow-down,
smart-grid-cell .list .smart-arrow-down,
smart-grid-cell .tokens .smart-arrow-down {
    cursor: pointer;
    opacity: 0;
    width: 0
}

smart-grid-cell .dropdownlist.dropdownlist .smart-arrow-down,
smart-grid-cell .dropdownlist:hover .smart-arrow-down,
smart-grid-cell .list.dropdownlist .smart-arrow-down,
smart-grid-cell .list:hover .smart-arrow-down,
smart-grid-cell .tokens.dropdownlist .smart-arrow-down,
smart-grid-cell .tokens:hover .smart-arrow-down,
smart-grid-cell[focus] .list .smart-arrow-down,
smart-grid-cell[focus] .tokens .smart-arrow-down {
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    opacity: 1;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-grid-cell .images {
    display: grid;
    grid-template-columns: 1fr auto auto;
    height: 100%
}

smart-grid-cell .images .container {
    align-items: center;
    display: flex;
    height: calc(100% - 3px);
    overflow: hidden;
    padding-left: 5px
}

smart-grid-cell .images .arrowbtn {
    background: #f5f5f5;
    background: var(--smart-surface);
    width: 15px
}

smart-grid-cell .images .arrowbtn:hover {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer
}

smart-grid-cell .images img {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: 23px;
    margin-right: 3px;
    width: 23px
}

smart-grid-cell .images img:hover {
    border-color: #005c99;
    border-color: var(--smart-primary);
    cursor: pointer
}

smart-grid-cell .smart-grid-cell-editor {
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    height: 100%;
    margin: 0;
    width: 100%
}

smart-grid-cell.smart-grid-row-border {
    border-top-width: 1px;
    border-top-width: var(--smart-border-width)
}

smart-grid-cell.smart-grid-column-border {
    border-bottom-width: 1px;
    border-bottom-width: var(--smart-border-width);
    border-left-width: 1px;
    border-left-width: var(--smart-border-width);
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

smart-grid-cell.smart-add-new-column,
smart-grid-cell.smart-grid-filter-row-cell {
    background: #f5f5f5;
    background: var(--smart-surface)
}

smart-grid-cell.smart-grid-filter-row-cell {
    --smart-grid-cell-horizontal-border: transparent;
    border-color: #f5f5f5;
    border-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-type {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    justify-content: center;
    outline: 0;
    text-decoration: inherit;
    text-transform: none;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-value {
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    outline: 0;
    overflow: hidden;
    resize: none;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-value.smart-grid-number-input-cell-editor .nav {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border)
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-container {
    border: 1px solid transparent;
    display: flex;
    height: 100%;
    margin-left: 1px;
    width: calc(100% - 1px) !important
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-container[focus] {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #005c99;
    border-color: var(--smart-ui-state-border-active)
}

smart-grid-cell.smart-grid-filter-row-cell .smart-filter-input-container[focus] .smart-filter-input-value.smart-grid-number-input-cell-editor .nav {
    background: #fefefe;
    background: var(--smart-background)
}

smart-grid-cell.smart-grid-filter-row-cell[template=checkBox] .smart-filter-input-value.smart-grid-check-box-cell-editor {
    height: 14px;
    width: 14px
}

smart-grid-cell:not(.smart-grid-column-border):after {
    background: #e0e0e0;
    background: var(--smart-grid-cell-horizontal-border, var(--smart-border))
}

smart-grid-cell:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    background: #e0e0e0;
    background: var(--smart-grid-cell-vertical-border, var(--smart-border))
}

smart-grid-cell[has-toggle-button] .smart-label {
    flex-direction: unset;
    padding: 0
}

smart-grid-cell[has-toggle-button] .row-status {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    min-width: 20px;
    width: 20px
}

smart-grid-cell[has-toggle-button] .row-status:before {
    color: #323232;
    color: var(--smart-surface-color);
    content: "\\e802";
    content: var(--smart-icon-star-empty);
    opacity: .3;
    transition: opacity .2s ease-in-out
}

smart-grid-cell[has-toggle-button] .row-status:hover:before {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

smart-grid-cell[has-toggle-button] .row-status.starred:before {
    color: #005c99;
    color: var(--smart-primary);
    content: "\\e801";
    content: var(--smart-icon-star);
    opacity: 1
}

smart-grid-cell[has-toggle-button] .row-status.custom.starred:before,
smart-grid-cell[has-toggle-button] .row-status.custom:hover,
smart-grid-cell[has-toggle-button] .row-status.custom:hover:before {
    color: inherit
}

smart-grid-cell[has-toggle-button] .row-status.comments:after {
    background: #b00020;
    background: var(--smart-error);
    content: "";
    height: 10px;
    position: absolute;
    right: -5px;
    top: -5px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    width: 10px
}

smart-grid-cell[has-toggle-button] button[toggle-button] {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    background: 0 0;
    border: none;
    color: inherit;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    justify-content: center;
    min-width: 20px;
    outline: 0;
    padding: 0;
    text-decoration: inherit;
    text-transform: none;
    width: 20px
}

smart-grid-cell[has-toggle-button] button[toggle-button]:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

smart-grid-cell[has-toggle-button] button[toggle-button].row-detail.row-comments>div {
    color: #005c99;
    color: var(--smart-primary);
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 11px;
    font-weight: 700;
    justify-content: center
}

smart-grid-cell[has-toggle-button] button[toggle-button].row-detail.row-comments:before {
    background: #b00020;
    background: var(--smart-error);
    content: "";
    height: 10px;
    position: absolute;
    right: -5px;
    top: -5px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    width: 10px
}

smart-grid-cell[has-toggle-button] button[toggle-button].row-detail:after {
    color: #005c99;
    color: var(--smart-primary);
    content: "\\e81c";
    content: var(--smart-icon-resize-full);
    font-size: 13px
}

smart-grid-cell[has-toggle-button] button[toggle-button].row-detail:hover:after {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-radius: 50%;
    padding: 3px
}

smart-grid-cell[has-toggle-button] button[toggle-button][toggled]:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

smart-grid-cell[has-toggle-button] button[toggle-button].smart-animate:after {
    transition: -webkit-transform .25s ease-out;
    transition: transform .25s ease-out;
    transition: transform .25s ease-out, -webkit-transform .25s ease-out
}

smart-grid-cell[has-toggle-button] .smart-indent {
    height: 100%;
    left: 7px;
    position: relative;
    width: 14px
}

smart-grid-cell[has-toggle-button] .smart-indent:after {
    color: #5a5a5a;
    color: var(--smart-background-color);
    content: "-";
    height: 50%;
    visibility: hidden
}

smart-grid-cell[editor]>.smart-label:not(.smart-input),
smart-grid-cell[error]:not([row-editor])>.smart-label {
    box-sizing: border-box;
    height: calc(100% - 1px);
    outline: 0;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: calc(100% - 1px)
}

smart-grid-cell[has-toggle-button] .smart-indent:first-child {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    visibility: hidden
}

smart-grid-cell[has-toggle-button] .smart-label,
smart-grid-cell[has-toggle-button] div[indent] {
    display: flex
}

smart-grid-cell[command] .smart-label {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center
}

smart-grid-cell[command] .align-center {
    padding: 0
}

smart-grid-cell[header],
smart-grid-cell[header]:last-child {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color)
}

smart-grid-cell[header]:not(.smart-grid-column-border):after {
    background: #e0e0e0;
    background: var(--smart-grid-cell-header-horizontal-border, var(--smart-grid-cell-horizontal-border, var(--smart-border)))
}

smart-grid-cell[header]:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    background: #e0e0e0;
    background: var(--smart-grid-cell-header-vertical-border, var(--smart-grid-cell-vertical-border, var(--smart-border)))
}

smart-grid-cell[editor]>.smart-label:not(.smart-input) {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    margin: 0 0 0 1px;
    padding: 0
}

smart-grid-cell[selected]:not([editor]),
smart-grid-cell[selected][focus]:not([editor]):not([rowspan]):not([colspan]) {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

smart-grid-cell[freeze],
smart-grid-cell[selected][freeze]:not([editor]):not([rowspan]):not([colspan]) {
    background: #f5f5f5;
    background: var(--smart-grid-cell-background-freeze);
    color: #323232;
    color: var(--smart-grid-cell-color-freeze)
}

smart-grid-cell[editor][row-editor] {
    border: 0 solid #005c99;
    border-bottom: 1px solid #005c99;
    border-left: 1px solid #005c99;
    border-top: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-right-width: 0
}

smart-grid-cell[editor][row-editor] .smart-label:not(.smart-input) {
    border: 0 solid #005c99 !important;
    border: 0 solid var(--smart-primary) !important
}

smart-grid-cell[editor][row-editor]:first-child {
    border-left: 1px solid #005c99 !important;
    border-left: 1px solid var(--smart-primary) !important
}

smart-grid-cell[editor][row-editor]:last-child {
    border-right: 1px solid #005c99;
    border-right: 1px solid var(--smart-primary)
}

smart-grid-cell[editor][row-editor]~smart-grid-cell[editor][row-editor] {
    border-left: 0 solid #005c99;
    border-left: 0 solid var(--smart-primary)
}

smart-grid-cell[editor=dateTimePicker] {
    --smart-border-radius: 0px;
    --smart-border-top-left-radius: 0px;
    --smart-border-top-right-radius: 0px;
    --smart-border-bottom-left-radius: 0px;
    --smart-border-bottom-right-radius: 0px
}

smart-grid-cell[editor=checkBox] .smart-label {
    align-items: center;
    cursor: pointer;
    justify-content: center;
    padding-bottom: 0
}

smart-grid-cell[template] .smart-label {
    padding-left: 0;
    padding-right: 0
}

smart-grid-cell[template][template=autoNumber] .smart-label,
smart-grid-cell[template][template=createdTime] .smart-label,
smart-grid-cell[template][template=modifiedTime] .smart-label,
smart-grid-cell[template][template=password] .smart-label,
smart-grid-cell[template][template=phone] .smart-label {
    padding-left: 4px;
    padding-right: 2px
}

smart-grid-cell[template=checkBox] .smart-label {
    align-items: center;
    cursor: pointer;
    justify-content: center;
    padding-bottom: 0
}

smart-grid-cell[template=checkBox][readonly] .smart-label,
smart-grid-cell[template=checkBox][readonly] .smart-label:after {
    cursor: default
}

smart-grid-cell[selected][focus]:not([editor]):not([rowspan]):not([colspan]) {
    opacity: .8
}

smart-grid-cell[selected][freeze]:not([editor]):not([rowspan]):not([colspan]) {
    opacity: 1
}

smart-grid-cell[addNewRow] {
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border)
}

smart-grid-cell[addNewRow]:after {
    visibility: hidden
}

smart-grid-cell[colspan],
smart-grid-cell[rowspan] {
    background: #2d2d30;
    background: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color);
    padding: 0;
    z-index: 5
}

smart-grid-cell[error] {
    overflow: visible;
    z-index: 9999
}

smart-grid-cell[error]:not([row-editor])>.smart-label {
    border: 1px solid #b00020 !important;
    border: 1px solid var(--smart-error) !important;
    left: 1px;
    margin: 0;
    padding: 0
}

smart-grid-cell[sort] {
    background: #f5f5f5;
    background: var(--smart-grid-cell-background-sort);
    color: #323232;
    color: var(--smart-grid-cell-color-sort)
}

smart-grid-cell[filter] {
    background: #f5f5f5;
    background: var(--smart-grid-cell-background-filter);
    color: #323232;
    color: var(--smart-grid-cell-color-filter)
}

smart-grid-cell[update] {
    background: #d7f9c7;
    background: var(--smart-grid-cell-background-update);
    color: #333;
    color: var(--smart-grid-cell-color-update)
}

smart-grid-cell[add] {
    background: #fed59b;
    background: var(--smart-grid-cell-background-add);
    color: #333;
    color: var(--smart-grid-cell-color-add)
}

smart-grid-cell[delete] {
    background: #ffdcdc;
    background: var(--smart-grid-cell-background-delete);
    color: #333;
    color: var(--smart-grid-cell-color-delete)
}

smart-grid-cell[editor] {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-grid-cell[highlight] .smart-label {
    background: #fff1c8 !important;
    color: #333 !important
}

smart-grid-cell[highlight][highlight-data-field] {
    border-left: 1px solid #005c99;
    border-left: 1px solid var(--smart-primary);
    border-right: 1px solid #005c99;
    border-right: 1px solid var(--smart-primary)
}

smart-grid-cell[highlight][highlight-data-field]:first-child {
    border-left: 2px solid #005c99;
    border-left: 2px solid var(--smart-primary)
}

smart-grid-cell[group] {
    font-size: 12px
}

smart-grid-cell[group] span[summary],
smart-grid-cell[group] span[value] {
    font-weight: 600
}

smart-grid-cell>.smart-label:not(.smart-input),
smart-grid-column>.smart-label:not(.smart-input) {
    height: 100%;
    width: 100%
}

smart-grid-cell.rotate,
smart-grid-column.rotate {
    display: inline-block;
    left: 0;
    line-height: normal;
    position: absolute;
    top: 0;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    -webkit-transform-origin: 50% 50% 0;
    transform-origin: 50% 50% 0
}

smart-grid-cell .align-left,
smart-grid-column .align-left {
    overflow: hidden;
    padding-left: 7px;
    padding-right: 2px;
    text-align: left;
    text-overflow: ellipsis
}

smart-grid-cell .align-top,
smart-grid-column .align-top {
    align-items: flex-start;
    display: flex;
    line-height: normal
}

smart-grid-cell .align-bottom,
smart-grid-column .align-bottom {
    align-items: flex-end;
    display: flex;
    line-height: normal
}

smart-grid-cell .align-right,
smart-grid-column .align-right {
    overflow: hidden;
    padding-left: 2px;
    padding-right: 7px;
    text-align: right;
    text-overflow: ellipsis
}

smart-grid-cell .align-right.align-bottom,
smart-grid-column .align-right.align-bottom {
    flex-direction: column-reverse
}

smart-grid-cell .align-right.align-top,
smart-grid-column .align-right.align-top {
    align-items: flex-end;
    flex-direction: column
}

smart-grid-cell .align-center,
smart-grid-column .align-center {
    overflow: hidden;
    padding-left: 7px;
    padding-right: 7px;
    text-align: center;
    text-overflow: ellipsis
}

smart-grid-cell .align-center.align-bottom,
smart-grid-cell .align-center.align-top,
smart-grid-column .align-center.align-bottom,
smart-grid-column .align-center.align-top {
    margin-left: 50%;
    margin-right: 50%;
    padding-left: 0;
    padding-right: 0
}

smart-grid-cell .align-middle,
smart-grid-column .align-middle {
    align-items: center;
    display: flex
}

smart-grid-cell .align-center.align-middle,
smart-grid-column .align-center.align-middle {
    justify-content: center
}

smart-grid-cell.smart-grid-column-border,
smart-grid-column.smart-grid-column-border {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-width: 0
}

smart-grid-cell:not(.smart-grid-column-border):after,
smart-grid-column:not(.smart-grid-column-border):after {
    bottom: 0;
    content: "";
    height: 1px;
    height: var(--smart-border-width);
    position: absolute;
    width: 100%
}

smart-grid-cell:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before,
smart-grid-column:not(.smart-grid-column-border):not(.smart-grid-column-border-collapse):before {
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 1px;
    width: var(--smart-border-width)
}

.smart-grid-add-column-dialog-color-panel {
    width: 100%
}

.smart-grid-add-column-dialog-color-panel .smart-sortable {
    margin-bottom: 10px;
    max-height: 200px;
    overflow: auto;
    width: 100%
}

.smart-grid-add-column-dialog-color-panel .smart-sortable .smart-sortable-container {
    overflow: hidden
}

.smart-grid-add-column-dialog-color-panel .smart-sortable .smart-grid-add-column-dialog-color-item {
    align-items: center;
    display: flex;
    margin-left: 5%;
    margin-top: 10px;
    width: calc(100% - 25px)
}

.smart-grid-add-column-dialog-color-panel .smart-sortable .smart-grid-add-column-dialog-color-item smart-color-input .smart-color-box {
    border-radius: 50%
}

smart-menu.smart-grid-column-chooser-menu[checkboxes][checkable] smart-menu-item[level="1"] {
    flex-direction: row-reverse
}

smart-menu.smart-grid-column-chooser-menu[checkboxes][checkable] smart-menu-item[level="1"] .smart-menu-item-label-container {
    padding-left: 10px
}

smart-menu.smart-grid-column-chooser-menu[checkboxes][checkable] smart-menu-item[level="1"][checked] .smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

[check-boxes_visible] [has-toggle-button] .smart-label,
[check-boxes_visible] [has-toggle-button] .smart-label [checkbox],
[checkbox] .smart-label,
[checkbox] .smart-label [checkbox],
[editor=checkBox] .smart-label,
[editor=checkBox] .smart-label [checkbox],
[template=checkBox] .smart-label,
[template=checkBox] .smart-label [checkbox] {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding-bottom: 0
}

[check-boxes_visible] [has-toggle-button] .smart-input:not(.smart-grid-cell-editor),
[checkbox] .smart-input:not(.smart-grid-cell-editor),
[editor=checkBox] .smart-input:not(.smart-grid-cell-editor),
[template=checkBox] .smart-input:not(.smart-grid-cell-editor) {
    background-color: transparent;
    background-repeat: no-repeat;
    border-color: #e0e0e0;
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-sizing: content-box;
    box-sizing: initial;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-family: inherit;
    font-size: 12px;
    height: 14px;
    height: calc(-2px + var(--smart-check-box-default-size));
    line-height: 16px;
    line-height: var(--smart-check-box-default-size);
    outline: 0;
    padding: 2px;
    position: relative;
    width: 14px;
    width: calc(-2px + var(--smart-check-box-default-size))
}

[check-boxes_visible] [has-toggle-button] .smart-input:not(.smart-grid-cell-editor):after,
[checkbox] .smart-input:not(.smart-grid-cell-editor):after,
[editor=checkBox] .smart-input:not(.smart-grid-cell-editor):after,
[template=checkBox] .smart-input:not(.smart-grid-cell-editor):after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    content: inherit;
    cursor: pointer;
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    left: 0;
    outline: 0;
    position: absolute;
    text-align: center;
    text-decoration: inherit;
    text-transform: none;
    top: 2px;
    width: 100%
}

[check-boxes_visible] [has-toggle-button] .smart-input:not(.smart-grid-cell-editor):hover,
[checkbox] .smart-input:not(.smart-grid-cell-editor):hover,
[editor=checkBox] .smart-input:not(.smart-grid-cell-editor):hover,
[template=checkBox] .smart-input:not(.smart-grid-cell-editor):hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

[check-boxes_visible] [has-toggle-button] .smart-input:not(.smart-grid-cell-editor)[checked],
[checkbox] .smart-input:not(.smart-grid-cell-editor)[checked],
[editor=checkBox] .smart-input:not(.smart-grid-cell-editor)[checked],
[template=checkBox] .smart-input:not(.smart-grid-cell-editor)[checked] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

[check-boxes_visible] [has-toggle-button] .smart-input:not(.smart-grid-cell-editor)[checked]:after,
[checkbox] .smart-input:not(.smart-grid-cell-editor)[checked]:after,
[editor=checkBox] .smart-input:not(.smart-grid-cell-editor)[checked]:after,
[template=checkBox] .smart-input:not(.smart-grid-cell-editor)[checked]:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

[check-boxes_visible] [has-toggle-button] .smart-input.smart-grid-check-box-cell-editor,
[checkbox] .smart-input.smart-grid-check-box-cell-editor,
[editor=checkBox] .smart-input.smart-grid-check-box-cell-editor,
[template=checkBox] .smart-input.smart-grid-check-box-cell-editor {
    background-color: transparent;
    background-repeat: no-repeat;
    border-color: #e0e0e0;
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-sizing: content-box;
    box-sizing: initial;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-family: inherit;
    font-size: 12px;
    height: 14px;
    height: calc(-2px + var(--smart-check-box-default-size));
    line-height: 16px;
    line-height: var(--smart-check-box-default-size);
    outline: 0;
    padding: 2px;
    position: relative;
    width: 14px;
    width: calc(-2px + var(--smart-check-box-default-size))
}

[check-boxes_visible] [has-toggle-button] .smart-input.smart-grid-check-box-cell-editor:after,
[checkbox] .smart-input.smart-grid-check-box-cell-editor:after,
[editor=checkBox] .smart-input.smart-grid-check-box-cell-editor:after,
[template=checkBox] .smart-input.smart-grid-check-box-cell-editor:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    content: inherit;
    cursor: pointer;
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    left: 0;
    outline: 0;
    position: absolute;
    text-align: center;
    text-decoration: inherit;
    text-transform: none;
    top: 2px;
    width: 100%
}

[check-boxes_visible] [has-toggle-button] .smart-input.smart-grid-check-box-cell-editor:hover,
[checkbox] .smart-input.smart-grid-check-box-cell-editor:hover,
[editor=checkBox] .smart-input.smart-grid-check-box-cell-editor:hover,
[template=checkBox] .smart-input.smart-grid-check-box-cell-editor:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

[check-boxes_visible] [has-toggle-button] .smart-input.smart-grid-check-box-cell-editor[checked],
[checkbox] .smart-input.smart-grid-check-box-cell-editor[checked],
[editor=checkBox] .smart-input.smart-grid-check-box-cell-editor[checked],
[template=checkBox] .smart-input.smart-grid-check-box-cell-editor[checked],
smart-grid-cell[checkbox][selected] .smart-input:not(.smart-grid-cell-editor),
smart-grid-column[checkbox][selected] .smart-input:not(.smart-grid-cell-editor) {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

[check-boxes_visible] [has-toggle-button] .smart-input.smart-grid-check-box-cell-editor[checked]:after,
[checkbox] .smart-input.smart-grid-check-box-cell-editor[checked]:after,
[editor=checkBox] .smart-input.smart-grid-check-box-cell-editor[checked]:after,
[template=checkBox] .smart-input.smart-grid-check-box-cell-editor[checked]:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

smart-grid-cell[checkbox],
smart-grid-column[checkbox] {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding-bottom: 0
}

smart-grid-cell[checkbox][selected] .smart-input:not(.smart-grid-cell-editor):after,
smart-grid-column[checkbox][selected] .smart-input:not(.smart-grid-cell-editor):after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

smart-grid-cell[checkbox][checked=indeterminate]:after,
smart-grid-cell[checkbox][selected=indeterminate] .smart-input:not(.smart-grid-cell-editor):after,
smart-grid-column[checkbox][checked=indeterminate]:after,
smart-grid-column[checkbox][selected=indeterminate] .smart-input:not(.smart-grid-cell-editor):after {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active);
    top: 0
}

[has-toggle-button][selected] [checkbox] .smart-input[checked] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

[freeze][checkbox][auto-show] .smart-input {
    opacity: 0;
    transition: opacity .2s ease-in-out
}

[freeze][checkbox][auto-show][selected] .smart-input {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    opacity: 1
}

[radioButton][selected] .smart-input:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

[editor=checkBox] .smart-input {
    left: -1px
}

[editor=checkBox] .smart-input:focus {
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active)
}

[editor=checkBox]:not([readonly]) .smart-input:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-grid-row:not([selected]):not(:hover) [header][checkbox][auto-show]:not(:hover) .smart-input {
    opacity: 0;
    transition: opacity .2s ease-in-out
}

.smart-grid-dialog-editor[checkbox][checked=indeterminate] .smart-input:after,
.smart-grid-dialog-editor[checkbox][selected=indeterminate] .smart-input:after,
smart-grid-cell[checkbox][checked=indeterminate] .smart-input:after,
smart-grid-cell[checkbox][selected=indeterminate] .smart-input:after,
smart-grid-column[checkbox][checked=indeterminate] .smart-input:after,
smart-grid-column[checkbox][selected=indeterminate] .smart-input:after {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active);
    border-radius: 0;
    box-sizing: border-box;
    content: "";
    height: 70%;
    margin: 14%;
    top: 0;
    width: 70%
}

.smart-grid-dialog-editor div[checkbox] .smart-input[checked=indeterminate]:after,
smart-grid-cell div[checkbox] .smart-input[checked=indeterminate]:after,
smart-grid-column div[checkbox] .smart-input[checked=indeterminate]:after {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active);
    border-radius: 0;
    box-sizing: border-box;
    content: "";
    height: 70% !important;
    margin: 14%;
    top: 0 !important;
    width: 70% !important
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .smart-input,
.smart-grid-cell-editor.smart-grid-text-area-cell-editor .smart-input {
    background: inherit;
    border: none;
    border-radius: 0;
    color: inherit;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    resize: none;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .smart-input {
    height: 100%;
    text-align: right
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .smart-input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: textfield
}

.smart-grid-cell-editor.smart-grid-number-input-cell-editor .smart-input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0
}

.smart-slider-editor input[type=range] {
    -webkit-appearance: none;
    background: 0 0;
    outline: 0;
    width: 100%
}

.smart-slider-editor input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #005c99;
    background: var(--smart-primary);
    background-size: 18px 12px;
    border: 0;
    border-radius: 32px;
    box-shadow: 0 0 1px rgba(0, 0, 0, .06), 0 2px 2px rgba(0, 0, 20, .1);
    height: 32px;
    margin-top: -12px;
    -webkit-transition: box-shadow .2s;
    transition: box-shadow .2s;
    width: 32px
}

.smart-slider-editor input[type=range]:focus::-webkit-slider-thumb {
    box-shadow: 0 0 1px rgba(0, 0, 0, .06), 0 4px 2px rgba(0, 0, 20, .06), 0 4px 12px rgba(0, 0, 20, .25)
}

.smart-slider-editor input[type=range]::-moz-range-thumb {
    background: #005c99;
    background: var(--smart-primary);
    background-size: 18px 12px;
    border: 0;
    border-radius: 32px;
    box-shadow: 0 0 1px rgba(0, 0, 0, .06), 0 2px 2px rgba(0, 0, 20, .1);
    height: 32px;
    -moz-transition: box-shadow .2s;
    transition: box-shadow .2s;
    width: 32px
}

.smart-slider-editor input[type=range]:focus::-moz-range-thumb {
    box-shadow: 0 0 1px rgba(0, 0, 0, .06), 0 4px 2px rgba(0, 0, 20, .06), 0 4px 12px rgba(0, 0, 20, .25)
}

.smart-slider-editor input[type=range]::-webkit-slider-runnable-track {
    background: #fff;
    border: 0;
    border-radius: 8px;
    box-shadow: 0 0 0 1px hsla(0, 0%, 80%, .25);
    height: 8px;
    width: 100%
}

.smart-slider-editor input[type=range]:focus::-webkit-slider-runnable-track {
    box-shadow: 0 0 0 1px hsla(0, 0%, 80%, .75)
}

.smart-slider-editor input[type=range]::-moz-range-track {
    background: #fff;
    border: 0;
    border-radius: 8px;
    box-shadow: 0 0 0 1px hsla(0, 0%, 80%, .25);
    height: 8px;
    width: 100%
}

.smart-slider-editor input[type=range]:focus::-moz-range-track {
    box-shadow: 0 0 0 1px hsla(0, 0%, 80%, .75)
}

.smart-color-input-drop-down-menu.smart-grid-color-input .grid-samples-container {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.smart-color-input-drop-down-menu.smart-grid-color-input:not([animation=none]) .default-samples-container div {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-color-input-drop-down-menu.smart-grid-color-input .default-samples-container div {
    border: initial;
    border-radius: 50%;
    position: relative;
    -webkit-transform: scale(.95);
    transform: scale(.95)
}

.smart-color-input-drop-down-menu.smart-grid-color-input .default-samples-container div.selected {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-color-input-drop-down-menu.smart-grid-color-input .default-samples-container div.selected:not(.no-color):after {
    align-items: center;
    border-radius: inherit;
    color: #fff;
    color: var(--smart-secondary-color);
    content: "\\e908";
    content: var(--smart-icon-check);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-grid-color-input {
    --smart-input-drop-down-menu-width: auto
}

smart-column-panel,
smart-formatting-panel,
smart-group-panel,
smart-multi-column-filter-panel,
smart-sort-panel {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: auto;
    height: var(--smart-grid-panel-default-height);
    min-width: 375px;
    overflow: auto;
    padding: 10px;
    padding: var(--smart-grid-panel-padding);
    width: 450px;
    width: var(--smart-grid-panel-default-width)
}

.smart-column-panel[right-to-left] .toggle-visibility,
.smart-group-panel[close-button-position=right] .smart-grid-panel-item-close-button,
.smart-multi-column-filter-panel[close-button-position=right] .smart-grid-panel-item-close-button,
.smart-sort-panel[close-button-position=right] .smart-grid-panel-item-close-button {
    order: 1
}

.smart-group-panel .smart-grid-panel-item.dragged,
.smart-sort-panel .smart-grid-panel-item.dragged {
    opacity: .7
}

.smart-group-panel .smart-grid-panel-label-by,
.smart-sort-panel .smart-grid-panel-label-by {
    flex-grow: 1;
    overflow: hidden;
    padding: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 60px
}

.smart-group-panel .smart-grid-panel-field-container,
.smart-sort-panel .smart-grid-panel-field-container {
    flex-grow: 3;
    height: 100%;
    width: 100px
}

.smart-group-panel .smart-grid-panel-field-selection,
.smart-sort-panel .smart-grid-panel-field-selection {
    height: 100%;
    width: 100%
}

.smart-group-panel .smart-grid-panel-from,
.smart-sort-panel .smart-grid-panel-from {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    overflow: hidden;
    padding: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 40px
}

.smart-group-panel .smart-grid-panel-direction,
.smart-sort-panel .smart-grid-panel-direction {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: flex;
    flex-grow: 2;
    height: 100%;
    width: 115px
}

.smart-group-panel .smart-grid-panel-direction:focus,
.smart-sort-panel .smart-grid-panel-direction:focus {
    box-shadow: 0 0 0 1px #005c99;
    box-shadow: 0 0 0 1px var(--smart-primary);
    outline: 0
}

.smart-group-panel .smart-grid-panel-direction>div,
.smart-sort-panel .smart-grid-panel-direction>div {
    align-items: center;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: flex;
    height: calc(100% - 6px);
    justify-content: center;
    margin: 3px;
    width: calc(50% - 6px)
}

.smart-group-panel .smart-grid-panel-buttons-container .smart-grid-panel-apply-button,
.smart-multi-column-filter-panel .smart-grid-panel-buttons-container .smart-grid-panel-apply-button,
.smart-sort-panel .smart-grid-panel-buttons-container .smart-grid-panel-apply-button {
    margin-left: 5px
}

.smart-group-panel .smart-grid-panel-direction>div.selected,
.smart-sort-panel .smart-grid-panel-direction>div.selected {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-group-panel .smart-grid-panel-item-close-button,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button,
.smart-sort-panel .smart-grid-panel-item-close-button {
    justify-content: center;
    width: 20px
}

.smart-group-panel .smart-grid-panel-item-close-button:after,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button:after,
.smart-sort-panel .smart-grid-panel-item-close-button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

@media (pointer:coarse) {

    .smart-group-panel .smart-grid-panel-item-close-button:after,
    .smart-multi-column-filter-panel .smart-grid-panel-item-close-button:after,
    .smart-sort-panel .smart-grid-panel-item-close-button:after {
        font-size: 16px
    }
}

.smart-group-panel .smart-grid-panel-item-close-button:hover,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button:hover,
.smart-sort-panel .smart-grid-panel-item-close-button:hover {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected);
    cursor: pointer
}

.smart-group-panel .smart-grid-panel-item-close-button:active,
.smart-group-panel .smart-grid-panel-item-close-button:focus,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button:active,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button:focus,
.smart-sort-panel .smart-grid-panel-item-close-button:active,
.smart-sort-panel .smart-grid-panel-item-close-button:focus {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-group-panel .smart-grid-panel-item-close-button:focus,
.smart-multi-column-filter-panel .smart-grid-panel-item-close-button:focus,
.smart-sort-panel .smart-grid-panel-item-close-button:focus {
    outline: 0
}

.smart-group-panel .smart-grid-panel-item,
.smart-multi-column-filter-panel .smart-grid-panel-item,
.smart-sort-panel .smart-grid-panel-item {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    display: flex;
    height: 30px;
    height: var(--smart-grid-panel-item-height);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-grid-panel-vertical-offset)/2);
    margin-top: 5px;
    margin-top: calc(var(--smart-grid-panel-vertical-offset)/2);
    min-height: 30px;
    min-height: var(--smart-grid-panel-item-height);
    width: calc(100% - 25px);
    width: calc(100% - var(--smart-sortable-handle-size))
}

.smart-group-panel[close-button-position=right] .smart-sortable-container,
.smart-multi-column-filter-panel[close-button-position=right] .smart-sortable-container,
.smart-sort-panel[close-button-position=right] .smart-sortable-container {
    align-items: flex-end
}

.smart-column-panel .smart-grid-panel-container-footer,
.smart-group-panel .smart-grid-panel-container-footer,
.smart-multi-column-filter-panel .smart-grid-panel-container-footer,
.smart-sort-panel .smart-grid-panel-container-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between
}

.smart-column-panel .smart-grid-panel-buttons-container,
.smart-group-panel .smart-grid-panel-buttons-container,
.smart-multi-column-filter-panel .smart-grid-panel-buttons-container,
.smart-sort-panel .smart-grid-panel-buttons-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: auto
}

.smart-column-panel .smart-grid-panel-buttons-container span,
.smart-group-panel .smart-grid-panel-buttons-container span,
.smart-multi-column-filter-panel .smart-grid-panel-buttons-container span,
.smart-sort-panel .smart-grid-panel-buttons-container span {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-column-panel .smart-grid-panel-buttons-container span:hover,
.smart-group-panel .smart-grid-panel-buttons-container span:hover,
.smart-multi-column-filter-panel .smart-grid-panel-buttons-container span:hover,
.smart-sort-panel .smart-grid-panel-buttons-container span:hover {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected);
    cursor: pointer
}

.smart-column-panel .smart-grid-panel-buttons-container span:focus,
.smart-group-panel .smart-grid-panel-buttons-container span:focus,
.smart-multi-column-filter-panel .smart-grid-panel-buttons-container span:focus,
.smart-sort-panel .smart-grid-panel-buttons-container span:focus {
    outline: 0
}

.smart-sort-panel .smart-sortable-container {
    margin-bottom: 10px;
    margin-bottom: var(--smart-grid-panel-padding)
}

.smart-sort-panel .smart-sortable-container:empty:after {
    content: attr(no-sorting);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-grid-panel-vertical-offset)/2);
    margin-top: 5px;
    margin-top: calc(var(--smart-grid-panel-vertical-offset)/2);
    opacity: .7
}

.smart-sort-panel .smart-grid-panel-container-footer>smart-input {
    min-width: 215px;
    width: 40%
}

.smart-sort-panel .smart-grid-panel-item-close-button {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-multi-column-filter-panel>.smart-container {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-grid-panel-padding);
    display: grid;
    grid-auto-rows: 1fr -webkit-max-content;
    grid-auto-rows: 1fr max-content
}

.smart-multi-column-filter-panel .smart-filter-panel-items-container {
    overflow: auto;
    padding-top: 10px
}

.smart-multi-column-filter-panel .smart-filter-panel-items-container:empty:after {
    content: attr(no-filters);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-grid-panel-vertical-offset)/2);
    margin-top: 5px;
    margin-top: calc(var(--smart-grid-panel-vertical-offset)/2);
    opacity: .7
}

.smart-multi-column-filter-panel .smart-filter-panel-add-filter-button {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-multi-column-filter-panel .smart-filter-panel-add-filter-button:hover {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected);
    cursor: pointer
}

.smart-multi-column-filter-panel .smart-filter-panel-add-filter-button:focus {
    outline: 0
}

.smart-multi-column-filter-panel .smart-grid-panel-item {
    grid-gap: 10px;
    grid-gap: var(--smart-grid-panel-padding);
    -webkit-columns: 5;
    column-count: 5;
    display: grid;
    grid-template-columns: 15px 60px 2fr 3fr 3fr;
    grid-template-columns: var(--smart-multi-column-filter-panel-template-columns);
    width: 100%
}

.smart-multi-column-filter-panel .smart-grid-panel-item>* {
    width: 100%
}

.smart-multi-column-filter-panel .smart-grid-panel-item-close-button {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-multi-column-filter-panel[close-button-position=right] {
    --smart-multi-column-filter-panel-template-columns: 60px 2fr 3fr 3fr 15px
}

.smart-kanban-column-panel .smart-grid-panel-item:after,
.smart-kanban-column-panel .smart-grid-panel-item:before {
    display: none !important
}

.smart-group-panel .smart-sortable-container smart-column-panel smart-sortable {
    margin-bottom: 10px;
    margin-bottom: var(--smart-grid-panel-padding)
}

.smart-group-panel .smart-sortable-container:empty:after {
    content: attr(no-grouping);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-grid-panel-vertical-offset)/2);
    margin-top: 5px;
    margin-top: calc(var(--smart-grid-panel-vertical-offset)/2);
    opacity: .7
}

.smart-group-panel .smart-grid-panel-container-footer>smart-input {
    min-width: 215px;
    width: 40%
}

.smart-group-panel .smart-grid-panel-item-close-button {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-group-panel .smart-grid-panel-direction,
.smart-group-panel .smart-grid-panel-from {
    display: none
}

.smart-group-panel .smart-grid-panel-expand-collapse {
    justify-content: flex-end;
    margin-bottom: 10px;
    margin-top: 10px
}

.smart-group-panel .smart-group-panel-expand-button {
    margin-left: 15px
}

.smart-group-panel .smart-group-panel-collapse-button[active],
.smart-group-panel .smart-group-panel-expand-button[active] {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-format-panel .smart-grid-panel-buttons-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: auto
}

.smart-format-panel .smart-grid-panel-buttons-container span {
    align-items: center;
    display: flex;
    padding: 5px
}

.smart-format-panel .smart-grid-panel-buttons-container span:hover {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected);
    cursor: pointer
}

.smart-format-panel .smart-grid-panel-buttons-container .smart-grid-panel-apply-button {
    margin-left: 5px
}

.smart-format-panel.smart-grid-panel-container-footer {
    display: flex;
    flex-direction: row;
    height: 50px;
    justify-content: center;
    padding: 15px
}

.smart-column-panel {
    --smart-grid-panel-item-height: 20px;
    min-width: 100px
}

.smart-column-panel.smart-container,
.smart-column-panel>.smart-container {
    display: flex;
    flex-direction: column
}

.smart-column-panel smart-sortable {
    flex: 5 1;
    max-height: 350px;
    max-height: var(--smart-column-panel-drop-down-height);
    min-height: 50px;
    overflow: auto
}

.smart-column-panel .smart-column-panel-find-container {
    align-items: center;
    border-bottom: 2px solid #e0e0e0;
    border-bottom: 2px solid var(--smart-border);
    display: flex;
    height: 30px;
    height: var(--smart-editor-height);
    position: relative
}

.smart-column-panel .smart-column-panel-find-container input {
    background: var(--smart-grid-panel-background);
    border: none;
    color: var(--smart-grid-panel-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 100%;
    outline: 0;
    width: calc(100% - 16px)
}

.smart-column-panel .smart-column-panel-find-container .clear-button {
    cursor: pointer;
    width: 16px
}

.smart-column-panel .smart-column-panel-find-container .clear-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-cancel);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    justify-content: center
}

.smart-column-panel .smart-column-panel-find-container.no-results:after {
    content: attr(no-results);
    position: absolute;
    top: calc(100% + 10px)
}

.smart-column-panel .smart-column-panel-label {
    margin-left: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-column-panel .smart-column-panel-label.icon {
    padding-left: 30px;
    padding-left: var(--smart-column-icon-size);
    position: relative
}

.smart-column-panel .smart-column-panel-label.icon:after {
    background-position: 50%;
    background-repeat: no-repeat;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 30px;
    width: var(--smart-column-icon-size)
}

.smart-column-panel .smart-grid-panel-buttons-container {
    justify-content: center;
    margin-top: 3px;
    width: 100%
}

.smart-column-panel .smart-grid-panel-buttons-container .smart-grid-panel-apply-button {
    margin-left: 5px
}

.smart-column-panel .smart-grid-panel-container-footer {
    display: grid;
    grid-template-columns: auto auto
}

.smart-column-panel .toggle-visibility {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    justify-content: center;
    width: 16px
}

.smart-column-panel .toggle-visibility:after {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-column-panel .toggle-visibility:focus {
    color: #005c99;
    color: var(--smart-primary);
    outline: 0
}

.smart-column-panel .toggle-visibility.disable-toggle {
    opacity: .5;
    pointer-events: none
}

.smart-column-panel .toggle-visibility.hidden:after {
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

.smart-column-panel .clear-button:focus {
    color: #005c99;
    color: var(--smart-primary);
    outline: 0
}

.smart-column-panel .smart-grid-panel-item {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    display: flex;
    height: 30px;
    height: var(--smart-grid-panel-item-height);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-grid-panel-vertical-offset)/2);
    margin-top: 5px;
    margin-top: calc(var(--smart-grid-panel-vertical-offset)/2);
    min-height: 30px;
    min-height: var(--smart-grid-panel-item-height);
    width: calc(100% - 25px);
    width: calc(100% - var(--smart-sortable-handle-size))
}

.smart-column-panel .smart-grid-panel-item.group:after,
.smart-column-panel .smart-grid-panel-item.group:before {
    opacity: 0 !important;
    pointer-events: none
}

.smart-column-panel .smart-grid-panel-item.indent {
    padding-left: 12px
}

.smart-grid-panel-apply-button,
.smart-grid-panel-cancel-button {
    display: flex;
    min-width: 80px;
    padding: 5px 8px;
    text-transform: uppercase
}

.smart-grid-panel-reset-button {
    align-items: center;
    cursor: pointer;
    display: flex;
    text-decoration: underline;
    text-transform: uppercase
}

.smart-grid-panel-cancel-button {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-grid-panel-apply-button,
.smart-grid-panel-cancel-button {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    justify-content: center
}

.smart-grid-panel-apply-button {
    background: #005c99;
    background: var(--smart-primary);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-column-panel[right-to-left] .smart-column-panel-find-container {
    direction: rtl
}

.smart-column-panel[right-to-left] .smart-grid-panel-buttons-container {
    flex-direction: row-reverse
}

.smart-column-panel[right-to-left] .smart-grid-panel-item {
    justify-content: space-between;
    right: 25px;
    right: var(--smart-sortable-handle-size)
}

.smart-group-panel[right-to-left] .smart-grid-panel-buttons-container,
.smart-group-panel[right-to-left] .smart-grid-panel-direction,
.smart-sort-panel[right-to-left] .smart-grid-panel-buttons-container,
.smart-sort-panel[right-to-left] .smart-grid-panel-direction {
    flex-direction: row-reverse
}

.smart-group-panel[right-to-left] .smart-grid-panel-from,
.smart-group-panel[right-to-left] .smart-grid-panel-label-by,
.smart-group-panel[right-to-left] .smart-group-panel-apply-button,
.smart-group-panel[right-to-left] .smart-group-panel-cancel-button,
.smart-group-panel[right-to-left] .smart-group-panel-collapse-button,
.smart-group-panel[right-to-left] .smart-group-panel-expand-button {
    direction: rtl
}

.smart-group-panel[right-to-left] .smart-group-panel-expand-button {
    margin-left: 0;
    margin-right: 5px
}

.smart-group-panel[right-to-left] .smart-grid-panel-label-by {
    order: 3
}

.smart-group-panel[right-to-left] .smart-grid-panel-field-container {
    order: 2
}

.smart-group-panel[right-to-left] .smart-grid-panel-from {
    order: 1
}

.smart-group-panel[right-to-left] .smart-sortable .smart-sortable-items-parent {
    direction: unset
}

.smart-group-panel[right-to-left][close-button-position=right] .smart-grid-panel-item-close-button {
    order: 4
}

.smart-sort-panel[right-to-left] .smart-grid-panel-apply-button,
.smart-sort-panel[right-to-left] .smart-grid-panel-cancel-button {
    direction: rtl
}

.smart-sort-panel[right-to-left] .smart-grid-panel-label-by {
    order: 3
}

.smart-sort-panel[right-to-left] .smart-grid-panel-field-container {
    order: 2
}

.smart-sort-panel[right-to-left] .smart-grid-panel-from {
    order: 1
}

.smart-sort-panel[right-to-left] .smart-sortable .smart-sortable-items-parent {
    direction: unset
}

.smart-sort-panel[right-to-left][close-button-position=right] .smart-grid-panel-item-close-button {
    order: 4
}

.smart-multi-column-filter-panel[right-to-left] .smart-filter-panel-add-filter-button,
.smart-multi-column-filter-panel[right-to-left] .smart-filter-panel-items-container:empty,
.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-apply-button,
.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-cancel-button,
.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-item-close-button+div {
    direction: rtl
}

.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-item>.smart-grid-panel-item-close-button+div {
    order: 3
}

.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-item>.smart-input:first-of-type {
    order: 2
}

.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-item>.smart-input:nth-of-type(2) {
    order: 1
}

.smart-multi-column-filter-panel[right-to-left] .smart-grid-panel-buttons-container {
    flex-direction: row-reverse
}

.smart-multi-column-filter-panel[right-to-left][close-button-position=right] .smart-grid-panel-item-close-button {
    order: 4
}

.smart-data-view-header {
    grid-gap: 10px;
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    display: grid;
    grid-template-areas: "views customize filter sort format details delete . search";
    grid-template-columns: minmax(0, -webkit-max-content) minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content) 1fr 24px;
    grid-template-columns: minmax(0, max-content) minmax(50px, max-content) minmax(50px, max-content) minmax(50px, max-content) minmax(50px, max-content) minmax(50px, max-content) 1fr 24px;
    grid-template-rows: 100%;
    padding: 3px;
    position: relative
}

.smart-data-view-header-button {
    align-items: center;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    cursor: pointer;
    display: flex;
    height: 30px;
    justify-content: center;
    margin-top: 5px;
    padding: 5px 5px 5px 25px;
    position: relative
}

.smart-data-view-header-button:after {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    left: 8px;
    position: absolute
}

.smart-data-view-header-button:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-data-view-header-button:focus {
    outline: 1px solid #005c99;
    outline: var(--smart-primary) solid 1px
}

.smart-data-view-header-button:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-data-view-header-button[aria-expanded=true] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-data-view-header-button.smart-data-view-search-button:active {
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-data-view-header-button>div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-data-view-header-drop-down {
    background-color: #fefefe;
    background-color: var(--smart-background);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    height: auto;
    opacity: 1;
    position: absolute;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    z-index: 1000
}

.smart-data-view-header-drop-down smart-column-panel,
.smart-data-view-header-drop-down smart-multi-column-filter-panel,
.smart-data-view-header-drop-down smart-sort-panel {
    border: none;
    width: 100%
}

.smart-data-view-header-drop-down.smart-visibility-hidden {
    opacity: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-data-view-header-drop-down.customize-panel {
    width: 320px;
    width: var(--smart-data-view-customize-panel-width)
}

.smart-data-view-header-drop-down.filter-panel {
    width: 550px;
    width: var(--smart-data-view-filter-panel-width)
}

.smart-data-view-header-drop-down.format-panel {
    max-height: 320px;
    overflow: auto
}

.smart-data-view-header-drop-down.sort-panel {
    width: 450px;
    width: var(--smart-data-view-sort-panel-width)
}

.smart-data-view-header-drop-down.search-panel {
    padding: 10px;
    padding: var(--smart-data-view-padding);
    width: 250px;
    width: var(--smart-data-view-search-panel-width)
}

.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box {
    grid-gap: 2px;
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 16px;
    grid-template-rows: 100%
}

.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.matches {
    grid-template-columns: 1fr -webkit-max-content 16px 16px 16px;
    grid-template-columns: 1fr max-content 16px 16px 16px
}

.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.matches .smart-data-view-search-next,
.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.matches .smart-data-view-search-prev {
    display: flex
}

.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.matches .smart-data-view-search-label,
.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.no-matches .smart-data-view-search-label {
    display: block
}

.smart-data-view-header-drop-down.search-panel .smart-data-view-search-box.no-matches {
    grid-template-columns: 1fr -webkit-max-content 16px;
    grid-template-columns: 1fr max-content 16px
}

.smart-data-view-header-drop-down.search-panel input {
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    min-width: 0;
    outline: 0;
    padding: 0
}

.smart-data-view-search-box div:focus {
    outline: 1px solid #005c99;
    outline: var(--smart-primary) solid 1px
}

.smart-data-view-search-button {
    grid-area: search;
    margin-right: 0;
    padding: 0
}

.smart-data-view-search-button:after {
    content: "\\e828";
    content: var(--smart-icon-search)
}

.smart-data-view-customize-button {
    grid-area: customize
}

.smart-data-view-customize-button:after {
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

.smart-data-view-customize-button.hidden {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

.smart-data-view-delete-button {
    grid-area: delete
}

.smart-data-view-delete-button:after {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-data-view-details-button {
    grid-area: details
}

.smart-data-view-details-button:after {
    content: "\\e81c";
    content: var(--smart-icon-resize-full)
}

.smart-data-view-filter-button {
    grid-area: filter
}

.smart-data-view-filter-button:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter)
}

.smart-data-view-filter-button.filtered {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

.smart-data-view-sort-button {
    grid-area: sort
}

.smart-data-view-sort-button:after {
    content: "\\e823";
    content: var(--smart-icon-sort)
}

.smart-data-view-sort-button.sorted {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-data-view-group-button {
    grid-area: group
}

.smart-data-view-group-button:after {
    content: "\\f247";
    content: var(--smart-icon-group)
}

.smart-data-view-group-button.grouped {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-data-view-download-button.formatted,
.smart-data-view-format-button.formatted,
.smart-data-view-views-button.formatted {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-data-view-format-button {
    grid-area: format
}

.smart-data-view-format-button:after {
    content: "\\e800";
    content: var(--smart-icon-table)
}

.smart-data-view-download-button {
    grid-area: download
}

.smart-data-view-download-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    margin-left: 8px;
    position: static
}

.smart-data-view-download-button:before {
    content: "\\e836";
    content: var(--smart-icon-download-alt);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    left: 8px;
    position: absolute
}

.smart-data-view-views-button {
    grid-area: views
}

.smart-data-view-views-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    margin-left: 8px;
    position: static
}

.smart-data-view-views-button:before {
    content: "\\f0CE";
    content: var(--smart-icon-table-alt);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    left: 8px;
    position: absolute
}

.smart-data-view-views-button.kanban:before {
    content: "\\f181";
    content: var(--smart-icon-kanban)
}

.smart-grid-toolbar .smart-data-view-header {
    display: flex;
    height: 100%
}

.smart-grid-toolbar .smart-data-view-header-button {
    margin-right: 0
}

.smart-grid-toolbar .smart-data-view-header-button.smart-disabled {
    opacity: .5;
    pointer-events: none
}

.smart-grid-toolbar .smart-data-view-search-button {
    position: absolute;
    right: 30px;
    top: 0
}

.smart-card-view .smart-data-view-header-button,
.smart-kanban .smart-data-view-header-button {
    height: 100%;
    margin-top: 0
}

.smart-card-view:not([animation=none]) .smart-data-view-header-drop-down,
.smart-data-view-header-drop-down[owner],
.smart-kanban:not([animation=none]) .smart-data-view-header-drop-down {
    transition: height .2s ease-in, visibility .2s ease-in, opacity .2s ease-in, -webkit-transform .2s ease-in;
    transition: height .2s ease-in, transform .2s ease-in, visibility .2s ease-in, opacity .2s ease-in;
    transition: height .2s ease-in, transform .2s ease-in, visibility .2s ease-in, opacity .2s ease-in, -webkit-transform .2s ease-in
}

.smart-data-view-search-label {
    display: none;
    font-size: 11px;
    font-size: calc(var(--smart-font-size) - 3px);
    opacity: .7
}

.smart-data-view-search-next,
.smart-data-view-search-prev {
    align-items: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: none;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    height: 100%;
    justify-content: center
}

.smart-data-view-search-next:hover,
.smart-data-view-search-prev:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-data-view-search-next:active,
.smart-data-view-search-prev:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-data-view-search-prev:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-data-view-search-next:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-data-view-search-close {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    justify-content: center
}

.smart-data-view-search-close:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close)
}

.smart-data-view-search-close:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-data-view-search-close:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-data-view-found {
    outline: 4px solid #b2b2b2;
    outline: var(--smart-outline) solid 4px;
    outline-offset: -4px
}

.smart-data-view-highlighted {
    box-shadow: 0 0 23px 1px #005c99;
    box-shadow: 0 0 23px 1px var(--smart-primary);
    outline: 4px solid #005c99;
    outline: var(--smart-primary) solid 4px;
    outline-offset: -4px
}

[header-position=bottom] .smart-data-view-header-drop-down {
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

[right-to-left] .smart-data-view-header-drop-down.search-panel .smart-data-view-search-box {
    direction: rtl
}

[right-to-left] .smart-data-view-header {
    grid-template-areas: "search . sort filter customize";
    grid-template-columns: 24px 1fr minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content) minmax(50px, -webkit-max-content);
    grid-template-columns: 24px 1fr minmax(50px, max-content) minmax(50px, max-content) minmax(50px, max-content)
}

[right-to-left] .smart-data-view-header-button:not(.smart-data-view-search-button) {
    direction: rtl;
    padding-left: 5px;
    padding-right: 25px
}

[right-to-left] .smart-data-view-header-button:after {
    left: auto;
    right: 5px
}

.smart-formatting-panel {
    min-height: 150px;
    overflow: visible;
    padding: 0;
    width: 600px;
    width: var(--smart-formatting-panel-default-width)
}

.smart-formatting-panel>.smart-container {
    min-height: inherit;
    position: relative
}

.smart-formatting-panel .smart-formatting-panel-items-container {
    height: 100%;
    overflow: auto;
    padding: 0 20px;
    padding: 0 calc(var(--smart-grid-panel-padding)*2);
    width: 100%
}

.smart-formatting-panel .smart-formatting-panel-item>.format-label {
    grid-area: format-label;
    justify-self: end
}

.smart-formatting-panel .smart-formatting-panel-item>.font-family-input {
    grid-area: font-family-input
}

.smart-formatting-panel .smart-formatting-panel-item>.font-size-input {
    grid-area: font-size-input
}

.smart-formatting-panel .smart-formatting-panel-item>.popup-button {
    cursor: pointer;
    font-size: 20px;
    font-weight: 700;
    grid-area: popup-button;
    justify-content: center
}

.smart-formatting-panel .smart-formatting-panel-item>.popup-button,
.smart-formatting-panel .smart-formatting-panel-item>.preview {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    display: flex;
    height: 100%;
    width: 100%
}

.smart-formatting-panel .smart-formatting-panel-item>.preview {
    grid-area: preview;
    padding: 0 10px;
    padding: 0 var(--smart-grid-panel-padding)
}

.smart-formatting-panel .smart-add-new-button {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 50%;
    bottom: 5px;
    bottom: calc(var(--smart-grid-panel-padding) - 5px);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: block;
    height: 40px;
    height: var(--smart-formatting-panel-add-new-button-size);
    opacity: .3;
    position: absolute;
    right: 5px;
    right: calc(var(--smart-grid-panel-padding) - 5px);
    width: 40px;
    width: var(--smart-formatting-panel-add-new-button-size)
}

.smart-formatting-panel .smart-add-new-button:after {
    align-items: center;
    content: "+";
    display: flex;
    font-size: 35px;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-formatting-panel .smart-add-new-button:focus,
.smart-formatting-panel .smart-add-new-button:hover {
    opacity: 1;
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
}

.smart-formatting-panel .smart-add-new-button:focus {
    outline: 0
}

.smart-formatting-panel .close-button:focus,
.smart-formatting-panel .popup-button:focus,
.smart-formatting-panel-popup .colors-container:focus,
.smart-formatting-panel-popup .header>div:focus,
.smart-formatting-panel-popup input:focus {
    outline: 1px solid #005c99;
    outline: var(--smart-ui-state-border-active) solid var(--smart-border-width)
}

.smart-formatting-panel.scroll .smart-add-new-button {
    border-radius: 50%;
    right: 22px;
    right: calc(12px + var(--smart-grid-panel-padding))
}

.smart-formatting-panel:not([animation=none]) .smart-add-new-button {
    transition: opacity .2s ease-in, -webkit-transform .5s cubic-bezier(.81, .27, 0, .93);
    transition: transform .5s cubic-bezier(.81, .27, 0, .93), opacity .2s ease-in;
    transition: transform .5s cubic-bezier(.81, .27, 0, .93), opacity .2s ease-in, -webkit-transform .5s cubic-bezier(.81, .27, 0, .93)
}

.smart-formatting-panel[right-to-left] {
    direction: rtl
}

.smart-formatting-panel[right-to-left] .smart-add-new-button {
    left: 5px;
    left: calc(var(--smart-grid-panel-padding) - 5px);
    right: unset
}

.smart-formatting-panel[right-to-left].scroll .smart-add-new-button {
    left: 22px;
    left: calc(12px + var(--smart-grid-panel-padding))
}

.smart-formatting-panel-item {
    grid-gap: 10px;
    grid-gap: var(--smart-grid-panel-padding);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    display: grid;
    gap: 10px;
    gap: var(--smart-grid-panel-padding);
    grid-template-areas: "value-label columns-input condition-input condition-input first-value first-value first-value close-button","format-label font-family-input font-size-input popup-button preview preview preview close-button";
    grid-template-columns: auto 3fr 2fr 30px 1fr .5fr 1fr 1fr;
    grid-template-columns: auto 3fr 2fr var(--smart-formatting-panel-row-height) 1fr .5fr 1fr 1fr;
    grid-template-rows: 30px 30px;
    grid-template-rows: var(--smart-formatting-panel-row-height) var(--smart-formatting-panel-row-height);
    padding: 20px 0;
    padding: calc(var(--smart-grid-panel-padding)*2) 0;
    width: 100%
}

.smart-formatting-panel-item:last-child {
    border-bottom: none
}

.smart-formatting-panel-item>* {
    align-self: center;
    justify-self: center;
    max-height: none;
    max-width: none;
    min-height: 0;
    min-width: 0;
    width: auto
}

.smart-formatting-panel-item>.value-label {
    grid-area: value-label;
    justify-self: end
}

.smart-formatting-panel-item>.columns-input {
    grid-area: columns-input
}

.smart-formatting-panel-item>.condition-input {
    grid-area: condition-input
}

.smart-formatting-panel-item>.first-value {
    grid-area: first-value
}

.smart-formatting-panel-item>.ampersand {
    display: none;
    grid-area: ampersand
}

.smart-formatting-panel-item>.second-value {
    display: none;
    grid-area: second-value
}

.smart-formatting-panel-item>.close-button {
    grid-area: close-button;
    height: 16px;
    position: relative;
    width: 16px
}

.smart-formatting-panel-item>.close-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-size: 20px;
    height: 100%;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%
}

.smart-formatting-panel-item.between {
    grid-template-areas: "value-label columns-input condition-input condition-input first-value ampersand second-value close-button","format-label font-family-input font-size-input popup-button preview preview preview close-button"
}

.smart-formatting-panel-item.between>.ampersand,
.smart-formatting-panel-item.between>.second-value {
    display: block
}

.smart-formatting-panel-popup {
    grid-gap: 10px;
    grid-gap: var(--smart-grid-panel-padding);
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: var(--border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    display: grid;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    gap: 10px;
    gap: var(--smart-grid-panel-padding);
    grid-template-areas: "header header","code input","colors colors","apply cancel";
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 30px 30px auto 30px;
    grid-template-rows: var(--smart-formatting-panel-row-height) var(--smart-formatting-panel-row-height) auto var(--smart-formatting-panel-row-height);
    opacity: 1;
    padding: 10px;
    padding: var(--smart-grid-panel-padding);
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    width: 300px;
    width: var(--smart-formatting-panel-popup-width);
    z-index: 1003
}

.smart-formatting-panel-popup .header,
.smart-formatting-panel-popup input,
.smart-formatting-panel-popup>.color-code {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border)
}

.smart-formatting-panel-popup>.color-code {
    align-items: center;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    grid-area: code;
    height: 100%;
    padding: 10px;
    padding: var(--smart-grid-panel-padding);
    width: 100%
}

.smart-formatting-panel-popup .header {
    display: flex;
    grid-area: header
}

.smart-formatting-panel-popup .header>div {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-weight: 700;
    height: 100%;
    justify-content: center;
    text-transform: uppercase;
    width: 50%
}

.smart-formatting-panel-popup .header>div:first-child {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-formatting-panel-popup .header>.selected {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-formatting-panel-popup input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    cursor: pointer;
    grid-area: input;
    height: 100%;
    width: 100%
}

.smart-formatting-panel-popup input:focus {
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus)
}

.smart-formatting-panel-popup .colors-container {
    grid-gap: 3px;
    display: grid;
    gap: 3px;
    grid-area: colors;
    grid-auto-rows: 20px;
    grid-auto-rows: var(--smart-formatting-panel-color-box-height);
    grid-template-columns: repeat(8, 1fr);
    width: 100%
}

.smart-formatting-panel-popup .colors-container>div {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    cursor: pointer
}

.smart-formatting-panel-popup .colors-container>div.selected {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative
}

.smart-formatting-panel-popup .colors-container>div.selected:after {
    align-items: center;
    background-color: #5a5a5a;
    background-color: var(--smart-background-color);
    border-radius: 50%;
    color: #fefefe;
    color: var(--smart-background);
    content: "\\e908";
    content: var(--smart-icon-check);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-size: 20px;
    height: 100%;
    justify-content: center;
    opacity: 1;
    position: absolute;
    width: 20px;
    width: var(--smart-formatting-panel-color-box-height)
}

.smart-formatting-panel-popup>smart-button {
    --smart-button-padding: 0
}

.smart-formatting-panel-popup>.apply {
    grid-area: apply
}

.smart-formatting-panel-popup>.cancel {
    grid-area: cancel
}

.smart-formatting-panel-popup:not([animation=none]) {
    transition: opacity .2s ease-in-out, visibility .2s ease-in-out, -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out, opacity .2s ease-in-out, visibility .2s ease-in-out;
    transition: transform .2s ease-in-out, opacity .2s ease-in-out, visibility .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-formatting-panel-popup.smart-visibility-hidden {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0)
}

.input-group>.custom-select:not(:first-child),
.input-group>.form-control:not(:first-child),
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-append>smart-button,
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:first-child>smart-button:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.input-group-text,
.input-group>.input-group-prepend:not(:first-child)>smart-button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.input-group>.custom-select:not(:last-child),
.input-group>.form-control:not(:last-child),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
.input-group>.input-group-append:last-child>smart-button:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:not(:last-child)>.input-group-text,
.input-group>.input-group-append:not(:last-child)>smart-button,
.input-group>.input-group-prepend>.input-group-text,
.input-group>.input-group-prepend>smart-button {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.input-group smart-button[focus],
.input-group>.custom-file:focus,
.input-group>.custom-select:focus,
.input-group>.form-control:focus,
.input-group>.form-control[focus] {
    z-index: 3
}

.input-group-append,
.input-group-append .input-group-text+.input-group-text,
.input-group-append .input-group-text+smart-button,
.input-group-append smart-button+.input-group-text,
.input-group-append smart-button+smart-button,
.input-group-prepend .input-group-text+.input-group-text,
.input-group-prepend .input-group-text+smart-button,
.input-group-prepend smart-button+.input-group-text,
.input-group-prepend smart-button+smart-button,
.input-group>.custom-file+.custom-file,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.form-control,
.input-group>.custom-select+.custom-file,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.form-control,
.input-group>.form-control+.custom-file,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.form-control {
    margin-left: -1px
}

.form-control,
.input-group-text {
    line-height: 1.5;
    padding: .375rem .75rem
}

.input-group {
    align-items: stretch;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    position: relative
}

.input-group smart-input .smart-drop-down-button {
    border-left: none
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control {
    flex: 1 1 auto;
    margin-bottom: 0;
    position: relative;
    width: 1%
}

.input-group-append,
.input-group-prepend {
    box-sizing: border-box;
    display: flex;
    height: auto
}

.input-group-append>smart-button,
.input-group-prepend>smart-button {
    height: 100%
}

.input-group-prepend {
    margin-right: -1px
}

.input-group-text {
    align-items: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap
}

.form-control,
.smart-form {
    display: block;
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.form-control {
    background-clip: padding-box;
    -webkit-background-clip: padding-box;
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    color: #495057;
    height: auto;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    width: 100%
}

.form-control,
.form-control:focus,
.form-control[focus] {
    background-color: #fefefe;
    background-color: var(--smart-background)
}

.form-control:focus,
.form-control[focus] {
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: var(--smart-color);
    outline: 0
}

.smart-form {
    background: #fefefe;
    background: var(--smart-background);
    border: 0 solid #e0e0e0;
    border: 0 solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    overflow: visible;
    width: 600px
}

@media only screen and (max-width:600px) {
    .smart-form {
        width: 350px
    }
}

.smart-form-editor,
.smart-form-tab-strip[vertical] .smart-form-tab .smart-form-tab-label {
    width: 100%
}

.smart-form-row {
    box-sizing: border-box;
    padding: 5px 0
}

.smart-form-row .smart-form-control-label {
    align-items: center;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 12.6px;
    font-size: calc(var(--smart-font-size)*.9);
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-form-row .smart-form-control+.smart-form-label[required]:before,
.smart-form-row .smart-form-control-label[required]:after {
    color: #a94442;
    content: "*";
    font-size: 14px;
    margin-left: 2px;
    margin-right: 2px
}

.smart-form-row .smart-form-control {
    box-sizing: border-box;
    display: flex
}

.smart-form-row .smart-form-control+.smart-form-control-label[required]:after {
    content: ""
}

.smart-form-row-flex {
    display: flex
}

.smart-form-control .smart-form-control-addon {
    align-items: center;
    display: flex
}

.smart-form-control.left {
    justify-content: flex-start
}

.smart-form-control.center {
    justify-content: center
}

.smart-form-control.right {
    justify-content: flex-end
}

.smart-form-control[readonly] .smart-form-editor {
    pointer-events: none
}

.smart-form-control[readonly] .smart-form-editor .smart-calendar-button,
.smart-form-control[readonly] .smart-form-editor .smart-drop-down-button {
    visibility: hidden
}

.smart-form-control[readonly] .smart-form-editor div,
.smart-form-control[readonly] .smart-form-editor input,
.smart-form-control[readonly] .smart-form-editor span,
.smart-form-control[readonly] .smart-form-editor textarea {
    border: none !important
}

.smart-form-control[readonly] .smart-form-editor+.smart-form-control-addon,
.smart-form-control[readonly] .smart-form-editor+.smart-form-control-icon,
.smart-form-control[readonly] .smart-form-editor+div {
    visibility: hidden
}

.smart-form-control-icon:after {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #fff;
    color: var(--smart-secondary-color);
    content: attr(tooltip);
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    margin-top: 25px;
    opacity: 0;
    padding: 7px;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: opacity .2s ease-out, -webkit-transform .1s ease-out;
    transition: opacity .2s ease-out, transform .1s ease-out;
    transition: opacity .2s ease-out, transform .1s ease-out, -webkit-transform .1s ease-out;
    visibility: hidden;
    white-space: nowrap;
    z-index: 9
}

.smart-form-control-icon:hover:after {
    background: #2d2d30;
    background: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color);
    opacity: .9;
    -webkit-transform: scale(1);
    transform: scale(1);
    visibility: visible
}

.smart-form-control-label[readonly]:after {
    visibility: hidden
}

.smart-form-group .smart-form-group-content {
    display: grid;
    grid-template-columns: none
}

.smart-form-group[columns="2"]>.smart-form-group-content {
    grid-template-columns: 50% 50%
}

.smart-form-group[columns="3"]>.smart-form-group-content {
    grid-template-columns: 33% 33% 33%
}

.smart-form-group[columns="4"]>.smart-form-group-content {
    grid-template-columns: 25% 25% 25% 25%
}

.smart-form-group[columns="5"]>.smart-form-group-content {
    grid-template-columns: 20% 20% 20% 20% 20%
}

.smart-form-group[columns="6"]>.smart-form-group-content {
    grid-template-columns: 16.66% 16.66% 16.66% 16.66% 16.66% 16.66%
}

.smart-form-group-label {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 20px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    padding-top: 10px
}

.smart-form-group-label.center {
    display: flex;
    justify-content: center
}

.smart-form-group-buttons,
.smart-form-group-label.right {
    display: flex;
    justify-content: flex-end
}

.smart-form-group-buttons {
    padding-right: 30px
}

.smart-form-editor.smart-validation-success:not(smart-check-box):not([focus])>div.smart-container:after,
input.smart-form-editor.smart-valid:not(:focus)+.smart-success-label-like-after-element {
    display: none
}

.smart-form-group-buttons smart-button {
    margin-left: 20px
}

.smart-form-editor.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after {
    left: auto;
    right: 0;
    z-index: 9
}

.smart-form-editor.smart-number-input[focus]:not([drop-down-button-position=none]).smart-validation-error[focus] input,
.smart-form-editor.smart-number-input[focus]:not([drop-down-button-position=none]).smart-validation-success[focus] input,
.smart-form-editor.smart-numeric-text-box.smart-validation-error:not(smart-check-box)>div.smart-container input,
.smart-form-editor.smart-numeric-text-box.smart-validation-success:not(smart-check-box)[focus]>div.smart-container input,
.smart-form-editor.smart-numeric-text-box[focus][spin-buttons].smart-validation-error[focus] input,
.smart-form-editor.smart-numeric-text-box[focus][spin-buttons].smart-validation-success[focus] input {
    padding-right: 30px
}

.smart-form-editor.smart-combo-box.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-combo-box.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after,
.smart-form-editor.smart-date-time-picker.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-date-time-picker.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after,
.smart-form-editor.smart-drop-down-list.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-drop-down-list.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after,
.smart-form-editor.smart-number-input.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-number-input.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after,
.smart-form-editor.smart-numeric-text-box.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-form-editor.smart-numeric-text-box.smart-validation-success:not(smart-check-box)[focus]>div.smart-container:after {
    right: 20px
}

.smart-form-editor.smart-invalid+.smart-error-label-like-after-element,
.smart-form-editor.smart-valid+.smart-success-label-like-after-element {
    left: auto;
    right: 0;
    z-index: 9
}

input.smart-form-editor.smart-invalid+.smart-error-label-like-after-element,
input.smart-form-editor.smart-valid+.smart-success-label-like-after-element {
    right: 35px
}

.smart-form-tab {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    grid-row: 1;
    justify-content: center;
    min-width: 0;
    transition: background-color .2s ease-in-out
}

.smart-form-tab.selected {
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-form-tab.smart-invalid {
    border-bottom: 2px solid #b00020;
    border-bottom: 2px solid var(--smart-error);
    color: #b00020;
    color: var(--smart-error)
}

.smart-form-tab-strip {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    display: grid;
    grid-auto-columns: 1fr;
    height: 30px;
    margin-bottom: 10px;
    overflow: hidden
}

.smart-form-tab-strip .smart-form-tab .smart-form-tab-label {
    font-size: 15px;
    font-size: calc(var(--smart-font-size) + 1px);
    min-width: 0;
    overflow: hidden;
    padding: 5px;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-form-tab-strip .smart-form-tab:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-form-tab-strip[vertical] {
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    border-radius: 0;
    border-radius: initial;
    display: flex;
    flex-direction: column;
    height: auto;
    padding-bottom: 1px
}

.smart-form-tab-strip[vertical] .smart-form-tab {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 0;
    color: #323232;
    color: var(--smart-surface-color);
    justify-content: left;
    margin-bottom: -1px;
    overflow: hidden;
    padding: 10px
}

.smart-form-tab-strip[vertical] .smart-form-tab .smart-form-tab-button {
    float: right;
    font-size: 17px;
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    transition: -webkit-transform .3s ease-in-out;
    transition: transform .3s ease-in-out;
    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out
}

.smart-form-tab-strip[vertical] .smart-form-tab.selected {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus)
}

.smart-form-tab-strip[vertical] .smart-form-tab.selected .smart-form-tab-button {
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-form-tab-strip[vertical] .smart-form-tab.smart-invalid {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #b00020;
    color: var(--smart-error)
}

.smart-form-tab-strip[breadcrumb] {
    border: none
}

.smart-form-tab-strip[breadcrumb] .smart-form-tab {
    border-bottom: none
}

.smart-form-tab-strip[breadcrumb] .smart-form-tab .smart-form-tab-label {
    align-items: center;
    display: flex
}

.smart-form-tab-strip[breadcrumb] .smart-form-tab .smart-form-tab-label .circle {
    align-items: center;
    background: #2d2d30;
    background: var(--smart-secondary);
    border-radius: 100%;
    color: #fff;
    color: var(--smart-secondary-color);
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    height: 12px;
    justify-content: center;
    margin-right: 10px;
    padding: 5px;
    width: 12px
}

.smart-form-tab-strip[breadcrumb] .smart-form-tab.smart-invalid {
    color: var(--smart-color)
}

.smart-form-tab-strip[breadcrumb] .smart-form-tab.selected .smart-form-tab-label .circle {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-form-tab-control {
    display: none !important;
    padding: 0
}

.smart-form-tab-control.selected {
    display: grid !important;
    margin-bottom: -1px
}

.smart-form-tab-control.selected[vertical] {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    padding: 10px
}

.smart-form-options-horizontal {
    display: flex
}

smart-led {
    border-radius: 50%;
    display: inline-block;
    height: 30px;
    height: var(--smart-led-default-height);
    padding: 0;
    width: 30px;
    width: var(--smart-led-default-width)
}

smart-led .smart-container {
    cursor: pointer;
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative
}

smart-led .smart-ripple {
    background: #005c99;
    background: var(--smart-primary)
}

smart-led[focus] {
    outline: 0
}

smart-led[disabled] .smart-container {
    cursor: auto
}

smart-led[shape=square] {
    border-radius: 0
}

.smart-led.smart-container {
    cursor: pointer;
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative
}

.smart-led .smart-input {
    align-items: center;
    background-clip: content-box;
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 100%;
    border-width: 1px;
    box-sizing: border-box;
    display: flex;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    justify-content: center;
    min-height: 20px;
    min-width: 20px;
    outline: 0;
    padding: 4%;
    text-align: center;
    width: 100%
}

.smart-led .smart-false-content-container,
.smart-led .smart-indeterminate-content-container,
.smart-led .smart-true-content-container {
    align-items: center;
    border-radius: 50%;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%
}

.smart-led .smart-false-content-container {
    background-color: transparent;
    display: flex
}

.smart-led .smart-true-content-container {
    background-color: #005c99;
    background-color: var(--smart-primary);
    display: none
}

.smart-led .smart-indeterminate-content-container {
    background-color: #d3d3d3;
    display: none
}

.smart-led .smart-false-content,
.smart-led[checked] .smart-true-content {
    align-items: center;
    display: flex;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%
}

.smart-led .smart-false-content {
    justify-content: center
}

.smart-led[focus] .smart-input {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    border: 1px solid #e2e0e0;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-led:hover .smart-input {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    transition: background-color .1s linear
}

.smart-led.active .smart-input {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-led[checked] .smart-true-content {
    justify-content: center
}

.smart-led[checked] .smart-false-content-container {
    display: none
}

.smart-led[checked] .smart-true-content-container {
    display: flex
}

.smart-led[checked=null] .smart-indeterminate-content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%
}

.smart-led[checked=null] .smart-indeterminate-content-container {
    display: flex
}

.smart-led[checked=null] .smart-true-content-container {
    display: none
}

.smart-led[shape=square] .smart-false-content-container,
.smart-led[shape=square] .smart-indeterminate-content-container,
.smart-led[shape=square] .smart-input,
.smart-led[shape=square] .smart-true-content-container {
    border-radius: 0
}

.smart-led[right-to-left] .smart-false-content-container,
.smart-led[right-to-left] .smart-indeterminate-content-container,
.smart-led[right-to-left] .smart-true-content-container {
    direction: rtl
}

smart-list-box,
smart-list-item,
smart-list-items-group {
    visibility: hidden
}

smart-list-item.smart-element,
smart-list-items-group.smart-element {
    border: none;
    visibility: inherit
}

smart-list-item .smart-input,
smart-list-items-group .smart-input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    background-repeat: no-repeat;
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 2px;
    border-radius: var(--smart-list-item-check-box-radius);
    border-width: 1px;
    box-sizing: content-box;
    box-sizing: initial;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-family: inherit;
    height: 12px;
    height: calc(-4px + var(--smart-check-box-default-size));
    line-height: 16px;
    line-height: var(--smart-check-box-default-size);
    margin-left: 4px;
    margin-top: 8px;
    margin-top: calc(var(--smart-list-item-height)/2 - 10px);
    /*padding: 3px;*/
    position: absolute;
    top: 3px;
    top: var(--smart-list-item-vertical-offset);
    width: 12px;
    width: calc(-4px + var(--smart-check-box-default-size))
}

smart-list-item .smart-input:after,
smart-list-items-group .smart-input:after {
    align-content: center;
    content: "";
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    justify-content: center;
    margin-top: -2px
}

smart-list-item .smart-input.smart-hidden,
smart-list-items-group .smart-input.smart-hidden {
    display: none
}

smart-list-item[selected] .smart-input,
smart-list-items-group[selected] .smart-input {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-list-item[hover] .smart-input:hover,
smart-list-items-group[hover] .smart-input:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-list-item[display-mode=checkBox][selected] .smart-input:after,
smart-list-items-group[display-mode=checkBox][selected] .smart-input:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

smart-list-item {
    -webkit-font-smoothing: antialiased;
    align-items: center;
    background-color: inherit;
    display: flex;
    height: 39px;
    height: calc(var(--smart-list-item-height) + var(--smart-list-item-vertical-offset));
    letter-spacing: .00937em;
    outline: 0;
    padding: 0 5px;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

smart-list-item .smart-content,
smart-list-item .smart-overlay {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    height: calc(100% - 3px);
    height: calc(100% - var(--smart-list-item-vertical-offset));
    left: 0;
    overflow: hidden;
    top: 3px;
    top: var(--smart-list-item-vertical-offset);
    transition: opacity .28s ease-in-out;
    width: 100%
}

smart-list-item .smart-container {
    align-items: center;
    display: flex
}

smart-list-item .smart-overlay {
    background: #fefefe;
    background: var(--smart-background);
    display: inline-block;
    position: absolute
}

smart-list-item .smart-content {
    align-items: flex-start;
    border: 1px solid transparent;
    border-width: var(--smart-item-border-width);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    /*padding: 9px 12px;
    padding: var(--smart-list-item-padding);*/
    position: absolute;
    white-space: nowrap
}

smart-list-item .smart-content-details {
    font-size: 10px;
    margin-top: 2px;
    opacity: .5
}

smart-list-item .smart-input:before {
    background: #005c99 !important;
    background: var(--smart-primary) !important;
    border-radius: 100%;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    text-align: center;
    top: 2px;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: opacity .2s ease-in-out;
    width: 100%
}

smart-list-item.smart-header-item,
smart-list-item[grouped],
smart-list-items-group .smart-list-items-group-label {
    align-items: center;
    border-width: 1px;
    margin-bottom: 3px;
    margin-bottom: var(--smart-list-item-vertical-offset);
    top: 3px;
    top: var(--smart-list-item-vertical-offset)
}

smart-list-item .smart-ripple {
    background: var(--smart-list-item-color-active)
}

smart-list-item.smart-list-item-line-feedback {
    border-top: 1px dashed #2d2d30;
    border-top-color: var(--smart-secondary)
}

smart-list-item.smart-list-item-bottom-line-feedback {
    border-bottom: 1px dashed #2d2d30;
    border-bottom-color: var(--smart-secondary)
}

smart-list-item.smart-header-item,
smart-list-item[grouped] {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #f5f5f5;
    border-color: var(--smart-surface);
    border-style: solid;
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    text-transform: uppercase;
    text-transform: var(--smart-list-item-group-header-text-transform)
}

smart-list-item:focus,
smart-list-item:focus .smart-input {
    outline: 0
}

smart-list-item[hover] .smart-overlay {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover)
}

smart-list-item[hover] .smart-content {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

[type=list][opened][focus] smart-list-item[focus] .smart-content,
smart-list-box:focus smart-list-item[focus][selected] .smart-content {
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    /*color: var(--smart-ui-state-color-selected)*/
}

smart-list-item[selected] .smart-overlay {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected)
}

smart-list-item[selected] .smart-content {
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
   /* color: var(--smart-ui-state-color-selected)*/
}

smart-list-item[selected].smart-list-item-line-feedback {
    border-top: 1px dashed #2d2d30;
    border-top-color: var(--smart-secondary)
}

smart-list-item[selected].smart-list-item-bottom-line-feedback {
    border-bottom: 1px dashed #2d2d30;
    border-bottom-color: var(--smart-secondary)
}

smart-list-item[display-mode=checkBox] .smart-content,
smart-list-item[display-mode=checkBox] .smart-overlay,
smart-list-item[display-mode=radioButton] .smart-content,
smart-list-item[display-mode=radioButton] .smart-overlay {
    left: 32px;
    left: calc(16px + var(--smart-check-box-default-size));
    padding: 5px;
    width: calc(100% - 32px);
    width: calc(100% - 16px - var(--smart-check-box-default-size))
}

smart-list-item[display-mode=checkBox][selected][alternation-index="0"] .smart-overlay,
smart-list-item[display-mode=radioButton][selected][alternation-index="0"] .smart-overlay {
    background-color: #f5f5f5;
    background-color: var(--smart-alternation-index0-background);
    border-color: #f5f5f5;
    border-color: var(--smart-alternation-index0-border);
    color: #323232;
    color: var(--smart-alternation-index0-color)
}

smart-list-item[display-mode=checkBox][selected][alternation-index="1"] .smart-overlay,
smart-list-item[display-mode=radioButton][selected][alternation-index="1"] .smart-overlay {
    background-color: #9bbb59;
    background-color: var(--smart-alternation-index1-background);
    border-color: #9bbb59;
    border-color: var(--smart-alternation-index1-border);
    color: #111;
    color: var(--smart-alternation-index1-color)
}

smart-list-item[display-mode=checkBox][selected][alternation-index="2"] .smart-overlay,
smart-list-item[display-mode=radioButton][selected][alternation-index="2"] .smart-overlay {
    background-color: #fc3752;
    background-color: var(--smart-alternation-index2-background);
    border-color: #fc3752;
    border-color: var(--smart-alternation-index2-border);
    color: #fff;
    color: var(--smart-alternation-index2-color)
}

smart-list-item[display-mode=radioButton] .smart-input {
    border-radius: 100%
}

smart-list-item[display-mode=radioButton][selected] .smart-input:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

smart-list-items-group>.smart-container {
    height: auto
}

smart-list-items-group .smart-list-items-group-label {
    -webkit-font-smoothing: antialiased;
    background-color: inherit;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #f5f5f5;
    border-color: var(--smart-surface);
    border-radius: 0;
    border-radius: initial;
    border-style: solid;
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    height: 39px;
    height: calc(var(--smart-list-item-height) + var(--smart-list-item-vertical-offset));
    letter-spacing: .00937em;
    outline: 0;
    padding: 0 5px;
    position: relative;
    text-transform: capitalize;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

smart-list-items-group .smart-list-items-group-label .smart-container {
    align-items: center;
    display: flex
}

smart-list-items-group:focus .smart-input {
    outline: 0
}

smart-list-box {
    display: block;
     height: 250px;
    height: var(--smart-list-box-default-height);
  /* width: 250px;
    width: var(--smart-list-box-default-width)*/
    max-height: 250px
}

smart-list-box.smart-element {
    visibility: inherit
}

smart-list-box:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

smart-list-box:focus smart-list-item[focus] .smart-overlay {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus)
}

smart-list-box:focus smart-list-item[focus] .smart-content {
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-list-box:focus smart-list-item[focus][selected] .smart-overlay {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected)
}

smart-list-box smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-list-box.smart-container,
.smart-list-box>.smart-container {
    border: 0 solid gray;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-list-box smart-list-item.smart-header-item[hover] {
    color: inherit
}

.smart-list-box smart-list-item[alternation-index="0"] .smart-overlay {
    background-color: #f5f5f5;
    background-color: var(--smart-alternation-index0-background);
    border-color: #f5f5f5;
    border-color: var(--smart-alternation-index0-border);
    color: #323232;
    color: var(--smart-alternation-index0-color)
}

.smart-list-box smart-list-item[alternation-index="1"] .smart-overlay {
    background-color: #9bbb59;
    background-color: var(--smart-alternation-index1-background);
    border-color: #9bbb59;
    border-color: var(--smart-alternation-index1-border);
    color: #111;
    color: var(--smart-alternation-index1-color)
}

.smart-list-box smart-list-item[alternation-index="2"] .smart-overlay {
    background-color: #fc3752;
    background-color: var(--smart-alternation-index2-background);
    border-color: #fc3752;
    border-color: var(--smart-alternation-index2-border);
    color: #fff;
    color: var(--smart-alternation-index2-color)
}

.smart-list-box smart-scroll-bar {
    bottom: 0;
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    overflow: visible;
    position: absolute;
    width: 100%
}

.smart-list-box smart-scroll-bar:after {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    content: "";
    height: 18px;
    height: var(--smart-scroll-bar-size);
    left: 100%;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-list-box smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-list-box smart-scroll-bar[orientation=vertical] {
    height: 100%;
    right: 0;
    top: 0;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-list-box input {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: 100%;
    outline: medium none invert;
    outline: initial;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    padding-right: 25px;
    width: 100%
}

.smart-list-box input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-list-box .smart-list-box-filter-input-container {
    height: 30px;
    height: var(--smart-editor-height);
    margin-left: 5px;
    margin-top: 5px;
    position: relative;
    width: calc(100% - 10px);
}

.smart-list-box .smart-list-box-filter-input-container:after {
    align-items: center;

    content: "";
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 30px;
    height: var(--smart-text-box-default-height);
    justify-content: center;
    left: calc(100% - 25px);
    position: absolute;
    top: 0;
    width: 25px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjUlEQVR4nO2V30tTYRjHX+i63dYfIIUX3hUDr7ooQsnCcKZRFG7TbeKyTgiC9GORm1PnUZEzMTYlDDNENO0HZNbpIpkNNmRDGF0IsTB3zs6PoJvsG+9JZ3MqZ1Popgc+8PK+73k/PLzP+xxC/kchIcuyUxCEudXV1fcbzK+srNyQJKlIVdXT+SDLshHAoSyBoijFiqIgEHgFbnBWIxh8DTpXKIlE4g0hZEukquopulBp8sA8tKxBx3SO456jvNKFipoO3VgbWEiS9JMQUpQjqbnei+Z5aNAxnevqmUDJrXEcfzinm8tXvdq3hJASfZn4C8tE2S6RZfkYnfRzM+jsmtCg4/3cibJdQiOZTH7Y76HKXpLNTA6yupR87sTvn8aFqgcwXenUjc3Wu7vkn1XXADeFM+fv4azJnUVtLw/7izQcLxVYJr+g7BqbWTPXZ95JYdUVj32GwzGAm2/XM1lT7gQ+oc/3LLMvHA5/zHqM+VTXkH8Kd0eXsgSb1Ju7N7oE120wGE5ktZV8qovrn0TbWGJnibVH29Pa2mrN6cB7967pnBdfz4VyJbMqaqtcEMU0eJ4P7irRW13F7fOoHv+6JZj5juaOMOqsI3A2DkAQREQikeC+MqnI4MW5ag9MF++jzvYYzW3vYLGNwm5lsfZNwOLi4mDO/6TQ3iUKaTTZ+2G2PfkjanwKp6OflvEvhmGMGdHCwoIrHo9HY7HY0gbR4eHhRxaLpZplWcbn893eiZaWlgae50dSKUHLwOIY00SXqtqpBB6Px7n9egyEkKN/cZjojGg0GkitCdqdUIHXPQZRFH+UlpaW6z1DV4RCIb8kSeuSJGsClmX7CCFHDlRCg2GYk263u8loNJZtCn4DRYsVEQHQl2wAAAAASUVORK5CYII=) no-repeat;
}

.smart-list-box .smart-list-box-filter-input-container.vscroll {
    width: calc(100% - 28px);
    width: calc(100% - 10px - var(--smart-scroll-bar-size))
}

.smart-list-box .smart-list-items-container {
    background-color: transparent;
    height: calc(100% - 3px);
    height: calc(100% - var(--smart-list-item-vertical-offset));
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-list-box .smart-list-items-container input {
    background: transparent none repeat 0 0/auto auto padding-box border-box scroll;
    background: initial;
    background-color: #fefefe;
    background-color: var(--smart-background);
    background-size: auto auto;
    background-size: initial;
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    font-family: inherit;
    font-size: inherit;
    left: 5px;
    margin: 0;
    padding: 9px 12px;
    position: absolute;
    width: calc(100% - 5px)
}

.smart-list-box[right-to-left] .smart-list-items-container.vscroll .smart-list-items-inner-container,
.smart-list-box[right-to-left] .smart-list-items-inner-container {
    margin-right: 3px;
    margin-right: var(--smart-list-item-horizontal-offset)
}

.smart-list-box .smart-list-items-container.hscroll {
    height: calc(100% - 21px);
    height: calc(100% - var(--smart-scroll-bar-size) - var(--smart-list-item-vertical-offset))
}

.smart-list-box .smart-list-items-container.filter {
    height: calc(100% - 40px);
    height: calc(100% - var(--smart-text-box-default-height) - 10px)
}

.smart-list-box .smart-list-items-container.hscroll.filter {
    height: calc(100% - 61px);
    height: calc(100% - var(--smart-text-box-default-height) - var(--smart-scroll-bar-size) - 10px - var(--smart-list-item-vertical-offset))
}

.smart-list-box .smart-list-items-inner-container {
    background-color: transparent;
    display: block;
    height: 100%;
    position: relative;
    width: calc(100% - 6px);
    width: calc(100% - var(--smart-list-item-horizontal-offset)*2)
}

.smart-list-box .smart-placeholder {
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: transparent;
}

.smart-list-box .smart-content-label {
    border-radius: 0;
    border-radius: var(--smart-list-item-label-border-radius);
    padding: 0;
    padding: var(--smart-list-item-label-padding);
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

.smart-list-box[disabled] smart-list-item {
    color: inherit
}

.smart-list-box[horizontal-scroll-bar-visibility=hidden] smart-list-item .smart-content {
    white-space: normal
}

.smart-list-box[selection-mode=checkBox]:focus smart-list-item[focus][selected] .smart-input:before,
.smart-list-box[selection-mode=checkBox][focus] smart-list-item[focus][selected] .smart-input:before,
.smart-list-box[selection-mode=radioButton]:focus smart-list-item[focus][selected] .smart-input:before,
.smart-list-box[selection-mode=radioButton][focus] smart-list-item[focus][selected] .smart-input:before {
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    content: "";
    height: 30px;
    height: calc(var(--smart-check-box-default-size) + 14px);
    left: 50%;
    opacity: .3;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 30px;
    width: calc(var(--smart-check-box-default-size) + 14px);
    z-index: 1
}

.smart-list-box:not([right-to-left]) .smart-list-items-inner-container {
    margin-left: 3px;
    margin-left: var(--smart-list-item-horizontal-offset)
}

.smart-list-box[right-to-left] {
    direction: ltr
}

.smart-list-box[right-to-left] smart-scroll-bar {
    left: auto;
    right: 0
}

.smart-list-box[right-to-left] smart-scroll-bar:after {
    left: -100%
}

.smart-list-box[right-to-left] smart-scroll-bar[orientation=vertical] {
    left: 0;
    right: auto
}

.smart-list-box[right-to-left] smart-scroll-bar[orientation=vertical]:after {
    content: none
}

.smart-list-box[right-to-left] smart-list-item .smart-list-item-container {
    direction: rtl;
    left: 0
}

.smart-list-box[right-to-left] smart-list-item[display-mode=checkBox] .smart-overlay,
.smart-list-box[right-to-left] smart-list-item[display-mode=radioButton] .smart-overlay {
    left: 0
}

.smart-list-box[right-to-left] smart-list-items-group .smart-list-items-group-label {
    direction: rtl
}

.smart-list-box[right-to-left] .smart-list-box-filter-input-container.vscroll {
    left: auto;
    right: 0
}

.smart-list-box[right-to-left] .smart-list-items-container,
.smart-list-box[right-to-left] .smart-list-items-container input {
    direction: rtl
}

.smart-list-box[right-to-left] .smart-list-items-container.vscroll {
    left: 18px;
    left: var(--smart-scroll-bar-size);
    right: auto
}

[type=list][opened][focus] smart-list-item[focus] .smart-overlay {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected)
}

.smart-list-item-feedback {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border-color: var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: move;
    padding: 0;
    width: 200px;
    z-index: var(--smart-drop-down-z-index)
}

.smart-list-item-feedback smart-list-item {
    border: none;
    padding: 0
}

.smart-list-item-feedback smart-list-item .smart-overlay {
    background-color: inherit;
    border: none
}

.smart-list-item-feedback smart-list-item .smart-content {
    border-color: transparent;
    color: inherit
}

.smart-drop-down smart-list-box smart-scroll-bar[orientation=vertical] {
    height: 100%;
    right: 0;
    top: 0;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-popup.smart-list-item.smart-list-item-feedback[right-to-left] smart-list-item .smart-list-item-container {
    direction: rtl;
    left: 0
}

.smart-list-menu .smart-filter-input:focus,
.smart-list-menu-view.smart-drop-down-repositioned .smart-filter-input:focus,
smart-list-menu,
smart-tree .smart-filter-input:focus {
    outline: 0
}

smart-list-menu {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    height: 450px;
    height: var(--smart-list-menu-default-height);
    visibility: hidden;
    width: 450px;
    width: var(--smart-list-menu-default-width)
}

smart-list-menu:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-list-menu>.smart-container {
    display: flex;
    position: relative
}

smart-list-menu.smart-element {
    visibility: inherit
}

smart-list-menu .smart-ripple {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus)
}

smart-list-menu[minimized] {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: auto;
    overflow: visible
}

smart-list-menu[drop-down-position|=top] .smart-list-menu-view-minimized {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    top: -1px;
    top: calc(var(--smart-border-width)*-1);
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

smart-list-menu[drop-down-position$=left] .smart-list-menu-view-minimized {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

smart-list-menu:not([animation=none]) .smart-hamburger-icon-line {
    transition: visibility 20ms ease-in, width .2s ease-in, -webkit-transform .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in, -webkit-transform .2s ease-in
}

.smart-list-menu.smart-container {
    display: flex;
    position: relative
}

.smart-list-menu smart-menu-item[hover],
.smart-list-menu smart-menu-items-group[hover] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-list-menu .smart-hamburger-icon {
    cursor: pointer;
    flex-direction: column;
    float: none;
    justify-content: center;
    margin-top: 2px;
    width: 40px
}

.smart-list-menu .smart-hamburger-icon,
.smart-list-menu .smart-hamburger-icon .smart-hamburger-icon-custom-container {
    align-items: center;
    display: flex;
    height: 100%
}

.smart-list-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-top {
    -webkit-transform: translateX(4px) rotate(45deg);
    transform: translateX(4px) rotate(45deg);
    width: 29px
}

.smart-list-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-center {
    visibility: hidden
}

.smart-list-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-bottom {
    -webkit-transform: translateX(4px) rotate(-45deg);
    transform: translateX(4px) rotate(-45deg);
    width: 29px
}

.smart-list-menu .smart-hamburger-icon-line {
    background-color: #323232;
    background-color: var(--smart-surface-color);
    border-radius: 10px;
    height: 5px;
    margin-bottom: 5px;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 30px
}

.smart-list-menu .smart-hamburger-icon-line-bottom {
    margin-bottom: 0
}

.smart-list-menu .smart-list-menu-view-minimized {
    left: -1px;
    left: calc(var(--smart-border-width)*-1);
    top: calc(100% + 1px);
    top: calc(100% + var(--smart-border-width))
}

.smart-list-menu .smart-list-menu-view-minimized.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-list-menu[minimized] .smart-minimized-header {
    background: #f5f5f5;
    background: var(--smart-surface);
    justify-content: flex-end
}

.smart-list-menu[disabled] .smart-hamburger-icon,
.smart-list-menu[disabled] smart-menu-item,
.smart-list-menu[disabled] smart-menu-items-group {
    cursor: default
}

.smart-list-menu[minimize-icon-template] .smart-hamburger-icon {
    float: left;
    width: auto
}

.smart-list-menu:not([animation=none]) .smart-hamburger-icon-line {
    transition: visibility 20ms ease-in, width .2s ease-in, -webkit-transform .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in, -webkit-transform .2s ease-in
}

.smart-list-menu:not([animation=none]) .smart-list-menu-view-minimized {
    margin: 8px 0;
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-list-menu:not([animation=none]) .smart-list-menu-view-minimized.smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-list-menu[minimize-icon-template=null] .smart-hamburger-icon {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    float: none;
    height: 100%;
    justify-content: center;
    margin-top: 2px;
    width: 40px
}

.smart-list-menu-view-minimized.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position*=top],
.smart-list-menu[drop-down-position*=top] .smart-list-menu-view-minimized {
    margin: -8px 0
}

.smart-list-menu[drop-down-position|=top]:not([animation=none]) .smart-list-menu-view-minimized {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-list-menu[drop-down-position|=top]:not([animation=none]) .smart-list-menu-view-minimized.smart-visibility-hidden {
    -webkit-transform: translateY(-100%) scaleY(0);
    transform: translateY(-100%) scaleY(0)
}

.smart-list-menu smart-menu-item,
.smart-list-menu smart-menu-items-group,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-item,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-items-group {
    padding: 10px 0
}

.smart-list-menu smart-menu-item.smart-element,
.smart-list-menu smart-menu-items-group.smart-element,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-item.smart-element,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-items-group.smart-element {
    display: block;
    height: auto;
    overflow: hidden;
    width: 100%
}

.smart-list-menu smart-menu-item[separator]:last-child,
.smart-list-menu smart-menu-items-group.smart-menu-items-group-opened[separator],
.smart-list-menu smart-menu-items-group[separator]:last-child,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-item[separator]:last-child,
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-items-group.smart-menu-items-group-opened[separator],
.smart-list-menu-view.smart-drop-down-repositioned smart-menu-items-group[separator]:last-child {
    border-bottom: none
}

.smart-list-menu .smart-header,
.smart-list-menu-view.smart-drop-down-repositioned .smart-header {
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    border-bottom: 1px solid #005c99;
    border-bottom: var(--smart-border-width) solid var(--smart-primary);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    height: 48px;
    height: var(--smart-bar-height);
    justify-content: center;
    overflow: hidden;
    padding: 0 16px;
    position: relative;
    width: 100%;
    z-index: 3
}

.smart-list-menu .smart-header>smart-button,
.smart-list-menu-view.smart-drop-down-repositioned .smart-header>smart-button {
    background: inherit;
    border: inherit;
    color: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 50px
}

.smart-list-menu .smart-header>smart-button>.smart-button,
.smart-list-menu-view.smart-drop-down-repositioned .smart-header>smart-button>.smart-button {
    border: none
}

.smart-list-menu .smart-header>smart-button .smart-arrow:after,
.smart-list-menu-view.smart-drop-down-repositioned .smart-header>smart-button .smart-arrow:after {
    color: inherit;
    font-size: 11px;
    font-size: calc(var(--smart-font-size) - 3px)
}

.smart-list-menu .smart-menu-scroll-button,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-scroll-button {
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-background);
    border-left: none;
    border-radius: 0;
    border-right: none;
    color: var(--smart-scroll-bar-color);
    display: block;
    height: 32px;
    height: var(--smart-menu-scroll-button-size);
    width: 100%
}

.smart-list-menu .smart-menu-scroll-button>button,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-scroll-button>button {
    border: none;
    min-height: 0
}

.smart-list-menu .smart-menu-scroll-button:last-of-type,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-scroll-button:last-of-type {
    border-bottom: none
}

.smart-list-menu .smart-hidden,
.smart-list-menu-view.smart-drop-down-repositioned .smart-hidden {
    display: none !important
}

.smart-list-menu .smart-title,
.smart-list-menu-view.smart-drop-down-repositioned .smart-title {
    align-items: center;
    display: flex;
    font-size: 16px;
    font-size: calc(var(--smart-font-size) + 2px)
}

.smart-list-menu .smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-item-label-container {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    position: relative;
    width: 100%
}

.smart-list-menu .smart-menu-item-label-element,
.smart-list-menu .smart-menu-items-group-arrow,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-item-label-element,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-items-group-arrow {
    align-items: center;
    display: flex
}

.smart-list-menu .smart-menu-main-container,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-list-menu .smart-menu-main-container .smart-scroll-viewer-content-container,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container .smart-scroll-viewer-content-container {
    width: 100%
}

.smart-list-menu .smart-menu-main-container.header-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown {
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-bar-height))
}

.smart-list-menu .smart-menu-main-container.header-shown.scroll-buttons-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown.scroll-buttons-shown {
    height: calc(100% - 112px);
    height: calc(100% - var(--smart-bar-height) - var(--smart-menu-scroll-button-size)*2)
}

.smart-list-menu .smart-menu-main-container.header-shown.scroll-buttons-shown.one-button-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 80px);
    height: calc(100% - var(--smart-bar-height) - var(--smart-menu-scroll-button-size))
}

.smart-list-menu .smart-menu-main-container.header-shown.scroll-buttons-shown.one-button-shown.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown.scroll-buttons-shown.one-button-shown.filter-input-shown {
    height: calc(100% - 120px);
    height: calc(100% - var(--smart-bar-height) - var(--smart-menu-scroll-button-size) - var(--smart-text-box-default-height) - var(--smart-list-menu-filter-input-vertical-offset)*2)
}

.smart-list-menu .smart-menu-main-container.header-shown.scroll-buttons-shown.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown.scroll-buttons-shown.filter-input-shown {
    height: calc(100% - 152px);
    height: calc(100% - var(--smart-bar-height) - var(--smart-menu-scroll-button-size)*2 - var(--smart-text-box-default-height) - var(--smart-list-menu-filter-input-vertical-offset)*2)
}

.smart-list-menu .smart-menu-main-container.header-shown.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.header-shown.filter-input-shown {
    height: calc(100% - 88px);
    height: calc(100% - var(--smart-bar-height) - var(--smart-text-box-default-height) - var(--smart-list-menu-filter-input-vertical-offset)*2)
}

.smart-list-menu .smart-menu-main-container.scroll-buttons-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.scroll-buttons-shown {
    height: calc(100% - 64px);
    height: calc(100% - var(--smart-menu-scroll-button-size)*2)
}

.smart-list-menu .smart-menu-main-container.scroll-buttons-shown.one-button-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 32px);
    height: calc(100% - var(--smart-menu-scroll-button-size))
}

.smart-list-menu .smart-menu-main-container.scroll-buttons-shown.one-button-shown.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.scroll-buttons-shown.one-button-shown.filter-input-shown {
    height: calc(100% - 72px);
    height: calc(100% - var(--smart-menu-scroll-button-size) - var(--smart-text-box-default-height) - var(--smart-list-menu-filter-input-vertical-offset)*2)
}

.smart-list-menu .smart-menu-main-container.scroll-buttons-shown.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.scroll-buttons-shown.filter-input-shown {
    height: calc(100% - 104px);
    height: calc(100% - var(--smart-menu-scroll-button-size)*2 - var(--smart-text-box-default-height) - var(--smart-list-menu-filter-input-vertical-offset)*2)
}

.smart-list-menu .smart-menu-main-container.filter-input-shown,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.filter-input-shown {
    height: calc(100% - 30px);
    height: calc(100% - var(--smart-text-box-default-height))
}

.smart-list-menu .smart-menu-main-container.bounce-top,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.bounce-top {
    padding-top: 50px
}

.smart-list-menu .smart-menu-main-container.bounce-bottom,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-main-container.bounce-bottom {
    padding-bottom: 50px
}

.smart-list-menu .smart-menu-item-shortcut,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-item-shortcut {
    margin-left: 0
}

.smart-list-menu .smart-menu-drop-down,
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-drop-down {
    width: 100%
}

.smart-list-menu .smart-menu-drop-down[level="2"]:not(.smart-menu-minimized-items-container),
.smart-list-menu-view.smart-drop-down-repositioned .smart-menu-drop-down[level="2"]:not(.smart-menu-minimized-items-container) {
    margin: 0
}

.smart-list-menu .smart-tree-main-container,
.smart-list-menu-view.smart-drop-down-repositioned .smart-tree-main-container {
    height: 100%;
    overflow: hidden;
    padding: 3px;
    padding: var(--smart-tree-item-horizontal-offset);
    position: relative;
    width: 100%
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-items-group-opened,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-items-group.smart-element.smart-menu-items-group-opened,
.smart-list-menu:not([animation=none]) .smart-menu-items-group-opened {
    overflow: visible
}

.smart-list-menu .smart-list-menu-filter-input-container,
.smart-list-menu-view.smart-drop-down-repositioned .smart-list-menu-filter-input-container {
    font-size: inherit;
    height: 30px;
    height: calc(var(--smart-text-box-default-height));
    margin: 5px;
    position: relative;
    width: calc(100% - 10px)
}

.smart-list-menu .smart-list-menu-filter-input-container:after,
.smart-list-menu-view.smart-drop-down-repositioned .smart-list-menu-filter-input-container:after {
    align-items: center;
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 30px;
    height: var(--smart-text-box-default-height);
    justify-content: center;
    left: calc(100% - 25px);
    position: absolute;
    top: 0;
    width: 25px
}

.smart-list-menu .smart-filter-input,
.smart-list-menu-view.smart-drop-down-repositioned .smart-filter-input {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    font-size: inherit;
    height: 100%;
    padding-left: 4px;
    padding-left: var(--smart-editor-label-padding);
    padding-right: 29px;
    padding-right: calc(var(--smart-editor-label-padding) + 25px);
    width: 100%
}

.smart-list-menu .smart-filter-input::selection,
.smart-list-menu-view.smart-drop-down-repositioned .smart-filter-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

.smart-list-menu .smart-list-menu-group-label,
.smart-list-menu-view.smart-drop-down-repositioned .smart-list-menu-group-label {
    background-color: #ccc;
    background-color: var(--smart-disabled);
    color: #555;
    color: var(--smart-disabled-color);
    cursor: default;
    font-size: 15px;
    font-size: calc(var(--smart-font-size) + 1px);
    font-weight: 700;
    margin-bottom: 1px;
    padding: 10px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-list-menu .smart-scroll-viewer,
.smart-list-menu-view.smart-drop-down-repositioned .smart-scroll-viewer {
    border: none
}

.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable] smart-menu-items-group[level="1"]>.smart-menu-item-label-container,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][checkable] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][checkable] smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    padding-left: 35px
}

.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    left: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-list-menu-group-label,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-item,
.smart-list-menu:not([animation=none]) .smart-list-menu-group-label,
.smart-list-menu:not([animation=none]) smart-menu-item {
    position: relative
}

.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][check-mode=radioButton] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][check-mode=radioButton] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable][check-mode=radioButton] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable][check-mode=radioButton] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-list-menu-view.smart-drop-down-repositioned[animation=none].smart-visibility-hidden,
.smart-list-menu[animation=none].smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-list-menu-group-label,
.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-item-label-container,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-item,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-items-group,
.smart-list-menu:not([animation=none]) .smart-list-menu-group-label,
.smart-list-menu:not([animation=none]) .smart-menu-item-label-container,
.smart-list-menu:not([animation=none]) smart-menu-item,
.smart-list-menu:not([animation=none]) smart-menu-items-group {
    left: 0;
    transition: left .3s ease-in
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-list-menu-group-label.animate,
.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-item-label-container.animate,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-item.animate,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-items-group.animate,
.smart-list-menu:not([animation=none]) .smart-list-menu-group-label.animate,
.smart-list-menu:not([animation=none]) .smart-menu-item-label-container.animate,
.smart-list-menu:not([animation=none]) smart-menu-item.animate,
.smart-list-menu:not([animation=none]) smart-menu-items-group.animate {
    left: -100%
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-list-menu-group-label.right,
.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-item-label-container.right,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-item.right,
.smart-list-menu-view-minimized:not([animation=none]) smart-menu-items-group.right,
.smart-list-menu:not([animation=none]) .smart-list-menu-group-label.right,
.smart-list-menu:not([animation=none]) .smart-menu-item-label-container.right,
.smart-list-menu:not([animation=none]) smart-menu-item.right,
.smart-list-menu:not([animation=none]) smart-menu-items-group.right {
    left: -100%;
    transition: none
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-drop-down,
.smart-list-menu:not([animation=none]) .smart-menu-drop-down {
    left: 0;
    position: absolute;
    top: 0;
    transition: left .3s ease-in
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-drop-down.smart-hidden,
.smart-list-menu:not([animation=none]) .smart-menu-drop-down.smart-hidden {
    display: block !important;
    left: 100%
}

.smart-list-menu-view-minimized:not([animation=none]) .smart-menu-drop-down.no-transition,
.smart-list-menu:not([animation=none]) .smart-menu-drop-down.no-transition {
    transition: none
}

.smart-list-menu-view {
    height: 100%;
    overflow: hidden;
    width: 100%
}

.smart-list-menu-view.smart-list-menu-view-minimized {
    background-color: #fff;
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    height: 400px;
    height: var(--smart-editor-drop-down-height);
    left: -1px;
    left: calc(var(--smart-border-width)*-1);
    position: absolute;
    top: calc(100% + 1px);
    top: calc(100% + var(--smart-border-width));
    width: 300px;
    width: var(--smart-editor-drop-down-width)
}

.smart-list-menu-view-minimized:not([animation=none]) {
    margin: 8px 0;
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-list-menu-view-minimized:not([animation=none]).smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-list-menu-view-minimized.smart-drop-down-repositioned.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-list-menu-view-minimized[drop-down-position|=top]:not([animation=none]) {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-list-menu-view-minimized[drop-down-position|=top]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: translateY(-100%) scaleY(0);
    transform: translateY(-100%) scaleY(0)
}

.smart-list-menu-view-minimized:not([animation=none])[right-to-left] .smart-menu-drop-down.smart-hidden,
.smart-list-menu:not([animation=none])[right-to-left] .smart-menu-drop-down.smart-hidden {
    left: -100%
}

.smart-list-menu-view-minimized:not([animation=none])[right-to-left] .smart-list-menu-group-label.animate,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] .smart-list-menu-group-label.right,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] .smart-menu-item-label-container.animate,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] .smart-menu-item-label-container.right,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] smart-menu-item.animate,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] smart-menu-item.right,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] smart-menu-items-group.animate,
.smart-list-menu-view-minimized:not([animation=none])[right-to-left] smart-menu-items-group.right,
.smart-list-menu:not([animation=none])[right-to-left] .smart-list-menu-group-label.animate,
.smart-list-menu:not([animation=none])[right-to-left] .smart-list-menu-group-label.right,
.smart-list-menu:not([animation=none])[right-to-left] .smart-menu-item-label-container.animate,
.smart-list-menu:not([animation=none])[right-to-left] .smart-menu-item-label-container.right,
.smart-list-menu:not([animation=none])[right-to-left] smart-menu-item.animate,
.smart-list-menu:not([animation=none])[right-to-left] smart-menu-item.right,
.smart-list-menu:not([animation=none])[right-to-left] smart-menu-items-group.animate,
.smart-list-menu:not([animation=none])[right-to-left] smart-menu-items-group.right {
    left: 100%
}

.smart-list-menu-view.smart-drop-down-repositioned[right-to-left] .smart-filter-input,
.smart-list-menu[right-to-left] .smart-filter-input {
    direction: rtl;
    padding-left: 29px;
    padding-left: calc(var(--smart-editor-label-padding) + 25px);
    padding-right: 4px;
    padding-right: var(--smart-editor-label-padding)
}

.smart-list-menu-view.smart-drop-down-repositioned[right-to-left] .smart-list-menu-filter-input-container:after,
.smart-list-menu[right-to-left] .smart-list-menu-filter-input-container:after {
    left: 0
}

.smart-list-menu-view.smart-drop-down-repositioned[right-to-left] .smart-header>smart-button,
.smart-list-menu[right-to-left] .smart-header>smart-button {
    left: auto;
    right: 0
}

.smart-list-menu-view.smart-drop-down-repositioned[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow,
.smart-list-menu[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow {
    margin-left: 0
}

.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][right-to-left] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][right-to-left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][checkable][right-to-left] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][checkable][right-to-left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-list-menu[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container {
    padding-left: 0;
    padding-right: 35px
}

.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][right-to-left] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][checkable][right-to-left] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu-view.smart-drop-down-repositioned[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable][right-to-left] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][checkable][right-to-left] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-list-menu[checkboxes][right-to-left] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-list-menu[right-to-left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    margin-right: 0
}

.smart-list-menu[right-to-left] smart-menu-item .smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 100px
}

.smart-list-menu[right-to-left] .smart-menu-main-container {
    direction: rtl
}

.smart-list-menu[right-to-left] .smart-menu-items-group-arrow.right.smart-arrow-right {
    margin-left: 0;
    margin-right: 50px
}

.smart-list-menu[right-to-left]>.smart-container {
    flex-direction: row-reverse
}

.smart-list-menu[right-to-left] .smart-list-menu-view.smart-list-menu-view-minimized {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-list-menu[right-to-left][minimized] .smart-list-menu-view-minimized,
.smart-list-menu[right-to-left][mode=tree] .smart-list-menu-view-minimized {
    direction: rtl
}

.smart-list-menu-view-minimized[right-to-left] .smart-menu-item-shortcut,
.smart-list-menu-view-minimized[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow,
.smart-list-menu[right-to-left] .smart-list-menu-view-minimized .smart-menu-item-shortcut,
.smart-list-menu[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow,
.smart-list-menu[right-to-left][mode=dropDown] smart-menu-item[level="1"] .smart-menu-item-shortcut {
    margin-right: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned.smart-list-menu-view-minimized[right-to-left],
.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left] .smart-menu-item-container {
    direction: rtl
}

smart-masked-text-box {
  /*  height: 30px;
    height: var(--smart-text-box-default-height);
    width: 250px;
    width: var(--smart-text-box-default-width)*/
}

smart-masked-text-box.smart-element {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    overflow: visible
}

.smart-masked-text-box>.smart-container {
    position: relative
}

.smart-masked-text-box .smart-input {
    color: inherit;
    font-family: inherit;
    height: 100%;
    outline: 0;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-masked-text-box[right-to-left] .smart-container {
    direction: rtl
}

.smart-menu .smart-menu-drop-down,
smart-menu[mode=dropDown] {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    top: 0;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-menu .smart-element[level="2"]:last-child,
.smart-menu .smart-element[level="3"]:last-child,
.smart-menu:not([aria-orientation=horizontal]) .smart-element[level="1"]:last-child {
    margin-bottom: 4px;
    margin-bottom: var(--smart-border-radius)
}

smart-menu {
    height: 48px;
    height: var(--smart-menu-default-height);
    visibility: hidden;
    width: 400px;
    width: var(--smart-menu-default-width)
}

smart-menu:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

smart-menu>.smart-container {
    display: flex;
    position: relative
}

smart-menu smart-menu-item[level="1"][separator],
smart-menu smart-menu-item[separator][level]:last-child,
smart-menu smart-menu-items-group[level="1"][separator],
smart-menu smart-menu-items-group[separator][level]:last-child {
    border-bottom: none
}

smart-menu.smart-element {
    overflow: visible;
    visibility: inherit
}

smart-menu .smart-ripple {
    background: #005c99;
    background: var(--smart-primary)
}

smart-menu[aria-orientation=horizontal] {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color)
}

smart-menu[mode=dropDown],
smart-menu[mode=tree],
smart-menu[mode=vertical] {
    height: 400px;
    height: var(--smart-menu-vertical-default-height);
    width: 200px;
    width: var(--smart-menu-vertical-default-width)
}

smart-menu[mode=tree]:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

smart-menu[minimized] smart-menu-item[level="1"][separator],
smart-menu[minimized] smart-menu-items-group[level="1"][separator],
smart-menu[mode=dropDown] smart-menu-item[level="1"][separator],
smart-menu[mode=dropDown] smart-menu-items-group[level="1"][separator],
smart-menu[mode=tree] smart-menu-item[level="1"][separator],
smart-menu[mode=tree] smart-menu-items-group[level="1"][separator],
smart-menu[mode=vertical] smart-menu-item[level="1"][separator],
smart-menu[mode=vertical] smart-menu-items-group[level="1"][separator] {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border)
}

smart-menu[minimized][drop-down-position$=left] .smart-menu-minimized-items-container .smart-menu-item-label-container {
    flex-direction: row
}

smart-menu[mode=tree] {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

smart-menu[mode=dropDown],
smart-menu[mode=tree] {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-menu[mode=dropDown] {
    left: 0;
    position: absolute
}

smart-menu-item,
smart-menu-items-group {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: auto;
    justify-content: space-between;
    visibility: hidden;
    white-space: nowrap
}

smart-menu-item.smart-element,
smart-menu-items-group.smart-element {
    background: inherit;
    border-color: inherit;
    color: inherit;
    overflow: visible;
    visibility: inherit
}

smart-menu-item[hover],
smart-menu-items-group[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-menu-item[focus],
smart-menu-items-group[focus] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-menu-item[separator],
smart-menu-items-group[separator] {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border)
}

smart-menu-item .smart-menu-item-shortcut {
    margin-left: 100px;
    opacity: .5
}

smart-menu-item[template-applied] {
    cursor: default
}

smart-menu-item[disabled] {
    opacity: .5
}

smart-menu-items-group {
    position: relative
}

.smart-menu a {
    color: inherit
}

.smart-menu smart-menu-item[level="1"],
.smart-menu smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu smart-menu-items-group[level="1"],
.smart-menu smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    height: 100%
}

.smart-menu .smart-menu-drop-down {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    left: 100%;
    position: absolute
}

.smart-menu .smart-menu-drop-down .smart-menu-drop-down,
.smart-menu .smart-menu-drop-down .smart-menu-drop-down.smart-visibility-hidden {
    border: none
}

.smart-menu .smart-menu-drop-down.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-menu .smart-menu-drop-down[level="2"] {
    left: 0;
    top: 100%
}

.smart-menu .smart-menu-main-container {
    align-items: center;
    cursor: default;
    display: flex;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-menu .smart-menu-main-container>smart-menu-item[level="1"] .smart-menu-item-shortcut {
    display: none
}

.smart-menu .smart-menu-main-container.scroll-buttons-shown {
    overflow: hidden;
    width: calc(100% - 64px);
    width: calc(100% - var(--smart-menu-scroll-button-size)*2)
}

.smart-menu .smart-menu-main-container.scroll-buttons-shown.one-button-shown {
    width: calc(100% - 32px);
    width: calc(100% - var(--smart-menu-scroll-button-size))
}

.smart-menu .smart-menu-item-label-element {
    align-items: center;
    display: flex;
    overflow: hidden
}

.smart-menu .smart-menu-item-label-element>span {
    align-items: center;
    display: flex
}

.smart-menu .smart-element[level="2"]:first-child,
.smart-menu .smart-element[level="3"]:first-child {
    margin-top: 4px;
    margin-top: var(--smart-border-radius)
}

.smart-menu .smart-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    justify-content: center;
    padding: 0 16px;
    position: relative;
    width: 100%;
    z-index: 3
}

.smart-menu .smart-hamburger-icon {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    float: none;
    height: 100%;
    justify-content: center;
    width: 40px
}

.smart-menu-drop-down,
.smart-menu-item[template-applied],
.smart-menu[disabled] .smart-hamburger-icon,
.smart-menu[disabled] smart-menu-item,
.smart-menu[disabled] smart-menu-items-group {
    cursor: default
}

.smart-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-top {
    -webkit-transform: translateX(4px) rotate(45deg);
    transform: translateX(4px) rotate(45deg);
    width: 29px
}

.smart-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-center {
    visibility: hidden
}

.smart-menu .smart-hamburger-icon.smart-close-button>.smart-hamburger-icon-line-bottom {
    -webkit-transform: translateX(4px) rotate(-45deg);
    transform: translateX(4px) rotate(-45deg);
    width: 29px
}

.smart-menu .smart-hamburger-icon .smart-hamburger-icon-custom-container {
    align-items: center;
    display: flex;
    height: 100%
}

.smart-menu .smart-hamburger-icon-line {
    background-color: #757575;
    border-radius: 10px;
    height: 5px;
    margin-bottom: 5px;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 30px
}

.smart-menu .smart-hamburger-icon-line-bottom {
    margin-bottom: 0
}

.smart-menu .smart-menu-minimized-items-container .smart-menu-items-group-opened>.smart-menu-item-label-container {
    padding-bottom: 0
}

.smart-menu .smart-menu-minimized-items-container .smart-menu-drop-down.smart-visibility-hidden {
    height: 0;
    margin-top: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu .smart-menu-minimized-items-container.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-menu:not([mode=tree])[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container:after,
.smart-menu:not([mode=tree])[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container:after,
.smart-menu[minimized][checkboxes][checkable][drop-down-position$=left] .smart-menu-minimized-items-container>smart-menu-item>.smart-menu-item-label-container:after,
.smart-menu[minimized][checkboxes][checkable][drop-down-position$=left] .smart-menu-minimized-items-container>smart-menu-items-group>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu .smart-menu-item-label-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    /*padding: 10px;*/
    position: relative;
    width: 100%
}

.smart-menu .smart-menu-scroll-button {
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-button-background);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border);
    color: #505050;
    color: var(--smart-scroll-bar-button-color);
    display: block;
    height: 100%;
    min-height: 0;
    width: 32px;
    width: var(--smart-menu-scroll-button-size)
}

.smart-menu .smart-menu-scroll-button[hover] {
    background-color: #d2d2d2;
    background-color: var(--smart-scroll-bar-button-background-hover);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-hover);
    color: #505050;
    color: var(--smart-scroll-bar-button-color-hover)
}

.smart-menu .smart-menu-scroll-button[active] {
    background-color: #787878;
    background-color: var(--smart-scroll-bar-button-background-active);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-active);
    color: #fff;
    color: var(--smart-scroll-bar-button-color-active)
}

.smart-menu .smart-menu-scroll-button>button {
    border: none
}

.smart-menu .smart-hidden {
    display: none !important
}

.smart-menu.smart-container {
    display: flex;
    position: relative
}

.smart-menu:not([animation=none]) .smart-menu-drop-down,
.smart-menu:not([animation=none]) .smart-menu-minimized-items-container {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu:not([animation=none]) .smart-menu-drop-down.smart-visibility-hidden,
.smart-menu:not([animation=none]) .smart-menu-minimized-items-container.smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu:not([animation=none]) .smart-menu-minimized-items-container .smart-menu-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: height .2s ease-in
}

.smart-menu:not([animation=none]) .smart-menu-minimized-items-container .smart-menu-item-label-container>.smart-menu-items-group-arrow {
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu:not([animation=none]) .smart-hamburger-icon-line {
    transition: visibility 20ms ease-in, width .2s ease-in, -webkit-transform .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in;
    transition: visibility 20ms ease-in, transform .2s ease-in, width .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu[animation=none] .smart-menu-drop-down.smart-visibility-hidden,
.smart-menu[animation=none] .smart-menu-minimized-items-container.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-menu[drop-down-append-to]:not([drop-down-append-to=null]) .smart-menu-main-container {
    overflow: hidden
}

.smart-menu[overflow=hidden] .smart-menu-main-container {
    width: 100%
}

.smart-menu[overflow=hidden][mode]:not([mode=horizontal]) .smart-menu-main-container {
    height: 100%
}

.smart-menu[aria-orientation=horizontal] .smart-element[level="1"]:first-child {
    margin-left: 4px;
    margin-left: var(--smart-border-radius)
}

.smart-menu[aria-orientation=horizontal] .smart-element[level="1"]:last-child {
    margin-right: 4px;
    margin-right: var(--smart-border-radius)
}

.smart-menu:not([aria-orientation=horizontal]) .smart-element[level="1"]:first-child {
    margin-top: 4px;
    margin-top: var(--smart-border-radius)
}

.smart-menu[disabled][mode=dropDown]:not([animation=none]) {
    opacity: .55
}

.smart-menu[minimized] .smart-minimized-header {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    justify-content: flex-end
}

.smart-menu:not([mode=tree])[drop-down-position$=left] smart-menu-item:not([level="1"])>.smart-menu-item-label-container,
.smart-menu[minimized][drop-down-position$=left] .smart-menu-minimized-items-container .smart-menu-item-label-container,
.smart-menu[minimized][drop-down-position$=left]>.smart-container {
    flex-direction: row-reverse
}

.smart-menu[minimized][drop-down-position$=left] .smart-menu-minimized-items-container .smart-menu-items-group-arrow {
    margin: 0
}

.smart-menu[minimized][drop-down-position$=left] .smart-menu-minimized-items-container .smart-menu-drop-down {
    padding-left: 0;
    padding-right: 20px
}

.smart-menu:not([mode=tree])[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu:not([mode=tree])[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[minimized][checkboxes][checkable][drop-down-position$=left] .smart-menu-minimized-items-container>smart-menu-item>.smart-menu-item-label-container,
.smart-menu[minimized][checkboxes][checkable][drop-down-position$=left] .smart-menu-minimized-items-container>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[mode=dropDown][checkboxes][checkable][drop-down-position$=left] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu[mode=dropDown][checkboxes][checkable][drop-down-position$=left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container,
.smart-menu[mode=tree][minimized][checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu[mode=tree][minimized][checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[mode=vertical][checkboxes][checkable][drop-down-position$=left] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu[mode=vertical][checkboxes][checkable][drop-down-position$=left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    padding-left: 10px;
    padding-right: 35px
}

.smart-menu[minimize-icon-template] .smart-hamburger-icon {
    float: left;
    width: auto
}

.smart-menu[minimize-icon-template=null] .smart-hamburger-icon {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    float: none;
    height: 100%;
    justify-content: center;
    width: 40px
}

.smart-menu[mode]:not([mode=horizontal]) smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu[mode]:not([mode=horizontal]) smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    height: auto
}

.smart-menu[mode]:not([mode=horizontal]):not([mode=tree])[drop-down-position$=left] smart-menu-item>.smart-menu-item-label-container,
.smart-menu[mode]:not([mode=horizontal])[drop-down-position$=left] .smart-menu-main-container smart-menu-items-group>.smart-menu-item-label-container {
    flex-direction: row-reverse
}

.smart-menu[mode]:not([mode=horizontal])[drop-down-position$=left] .smart-menu-main-container smart-menu-items-group>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    margin-left: 0;
    margin-right: 50px;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-menu[mode]:not([mode=horizontal])[drop-down-position$=left] .smart-menu-main-container smart-menu-item>.smart-menu-item-label-container>.smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 100px
}

.smart-menu[mode]:not([mode=horizontal]):not([minimized]).smart-container,
.smart-menu[mode]:not([mode=horizontal]):not([minimized])>.smart-container {
    display: block
}

.smart-menu[mode=dropDown] .smart-menu-main-container,
.smart-menu[mode=vertical] .smart-menu-main-container {
    flex-direction: column
}

.smart-menu[mode=dropDown] .smart-menu-main-container.scroll-buttons-shown,
.smart-menu[mode=vertical] .smart-menu-main-container.scroll-buttons-shown {
    height: calc(100% - 64px);
    height: calc(100% - var(--smart-menu-scroll-button-size)*2);
    width: 100%
}

.smart-menu[mode=dropDown] .smart-menu-main-container.scroll-buttons-shown.one-button-shown,
.smart-menu[mode=vertical] .smart-menu-main-container.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 32px);
    height: calc(100% - var(--smart-menu-scroll-button-size));
    width: 100%
}

.smart-menu[mode=dropDown] .smart-menu-drop-down[level="2"],
.smart-menu[mode=vertical] .smart-menu-drop-down[level="2"] {
    left: 100%;
    top: 0
}

.smart-menu[mode=dropDown] smart-menu-item[level="1"],
.smart-menu[mode=dropDown] smart-menu-items-group[level="1"],
.smart-menu[mode=vertical] smart-menu-item[level="1"],
.smart-menu[mode=vertical] smart-menu-items-group[level="1"] {
    height: auto;
    width: 100%
}

.smart-menu[mode=dropDown] .smart-menu-scroll-button,
.smart-menu[mode=tree] .smart-menu-scroll-button,
.smart-menu[mode=vertical] .smart-menu-scroll-button {
    height: 32px;
    height: var(--smart-menu-scroll-button-size);
    width: 100%
}

.smart-menu[mode=dropDown] smart-menu-item[level="1"]>.smart-menu-item-label-element,
.smart-menu[mode=dropDown] smart-menu-items-group[level="1"]>.smart-menu-item-label-element,
.smart-menu[mode=vertical] smart-menu-item[level="1"]>.smart-menu-item-label-element,
.smart-menu[mode=vertical] smart-menu-items-group[level="1"]>.smart-menu-item-label-element {
    max-width: calc(100% - 10px)
}

.smart-menu[mode=dropDown][drop-down-position$=left] .smart-menu-drop-down[level="2"],
.smart-menu[mode=vertical][drop-down-position$=left] .smart-menu-drop-down[level="2"] {
    left: auto;
    right: 100%
}

.smart-menu[mode=dropDown][drop-down-position|=top] .smart-menu-drop-down,
.smart-menu[mode=vertical][drop-down-position|=top] .smart-menu-drop-down {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8)
}

.smart-menu[mode=dropDown][drop-down-position|=top] .smart-menu-drop-down[level="2"],
.smart-menu[mode=vertical][drop-down-position|=top] .smart-menu-drop-down[level="2"] {
    top: 100%
}

.smart-menu[mode=dropDown][drop-down-position=overlay-right] .smart-menu-drop-down[level="2"],
.smart-menu[mode=vertical][drop-down-position=overlay-right] .smart-menu-drop-down[level="2"] {
    left: 0
}

.smart-menu[mode=dropDown][drop-down-position=overlay-left] .smart-menu-drop-down[level="2"],
.smart-menu[mode=vertical][drop-down-position=overlay-left] .smart-menu-drop-down[level="2"] {
    right: 0
}

.smart-menu[mode=dropDown][checkboxes][checkable][drop-down-position$=left] smart-menu-item[level="1"]>.smart-menu-item-label-container:after,
.smart-menu[mode=dropDown][checkboxes][checkable][drop-down-position$=left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container:after,
.smart-menu[mode=vertical][checkboxes][checkable][drop-down-position$=left] smart-menu-item[level="1"]>.smart-menu-item-label-container:after,
.smart-menu[mode=vertical][checkboxes][checkable][drop-down-position$=left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu[mode=vertical] .smart-menu-drop-down:not(.smart-menu-minimized-items-container) {
    margin: 0 8px;
    margin: 0 calc(var(--smart-editor-drop-down-vertical-offset) + 3px)
}

.smart-menu[mode=vertical] .smart-menu-drop-down:not(.smart-menu-minimized-items-container) .smart-menu-drop-down {
    margin: 0
}

.smart-menu[mode=vertical] .smart-menu-main-container>smart-menu-item[level="1"] .smart-menu-item-shortcut {
    display: none
}

.smart-menu[mode=dropDown][drop-down-position$=left] .smart-menu-main-container smart-menu-item[level="1"]>.smart-menu-item-label-container>.smart-menu-item-shortcut {
    margin-right: 0
}

.smart-menu[mode=dropDown] smart-menu-item[level="1"] .smart-menu-item-shortcut {
    display: block;
    margin-left: 0
}

.smart-menu[mode=dropDown]:not([animation=none]) {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu[mode=dropDown]:not([animation=none]).smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-menu[mode=tree] smart-menu-item[level="1"] .smart-menu-item-shortcut {
    display: block
}

.smart-menu[mode=tree] .smart-menu-minimized-items-container.scroll-buttons-shown {
    height: calc(100% - 64px);
    height: calc(100% - var(--smart-menu-scroll-button-size)*2);
    width: 100%
}

.smart-menu[mode=tree] .smart-menu-minimized-items-container.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 32px);
    height: calc(100% - var(--smart-menu-scroll-button-size));
    width: 100%
}

.smart-menu[mode=tree]:not([minimized]) .smart-menu-minimized-items-container {
    box-shadow: none;
    height: 100%;
    left: 0;
    overflow: hidden;
    position: relative;
    top: 0;
    -webkit-transform: none;
    transform: none;
    width: 100%
}

.smart-menu[mode=tree]:not([minimized])[drop-down-position$=left] smart-menu-items-group:not([level="1"])>.smart-menu-item-label-container {
    flex-direction: row
}

.smart-menu[mode=tree][minimized][checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container:after,
.smart-menu[mode=tree][minimized][checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu[drop-down-position] .smart-menu-minimized-items-container .smart-menu-drop-down {
    box-shadow: none;
    height: auto;
    padding-left: 20px;
    position: static;
    -webkit-transform: none;
    transform: none;
    width: 100%
}

.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[checkboxes][checkable] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu[checkboxes][checkable] smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    padding-left: 35px
}

.smart-menu[drop-down-position*=overlay] .smart-menu-drop-down,
.smart-menu[drop-down-position*=overlay] .smart-menu-drop-down[level="2"] {
    margin: unset
}

.smart-menu-drop-down.smart-drop-down-repositioned.smart-drop-down-container[drop-down-position*=top],
.smart-menu[drop-down-position*=top] .smart-menu-drop-down,
.smart-menu[drop-down-position*=top] .smart-menu-drop-down[level="2"] {
    margin: -8px 0;
    margin: calc((var(--smart-editor-drop-down-vertical-offset) + 3px)*-1) 0
}

.smart-menu[drop-down-position|=overlay] .smart-menu-drop-down {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu[drop-down-position|=overlay] .smart-menu-drop-down[level="2"] {
    top: auto;
    -webkit-transform: none;
    -webkit-transform: initial;
    transform: none
}

.smart-menu[drop-down-position|=overlay]:not([animation=none]) .smart-menu-drop-down {
    -webkit-transform: translateY(-50%) scaleY(1);
    transform: translateY(-50%) scaleY(1);
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-menu[drop-down-position|=overlay]:not([animation=none]) .smart-menu-drop-down.smart-visibility-hidden {
    -webkit-transform: translateY(-50%) scaleY(0);
    transform: translateY(-50%) scaleY(0)
}

.smart-menu[drop-down-position|=overlay]:not([animation=none]) .smart-menu-drop-down[level="2"] {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-menu[drop-down-position|=overlay]:not([animation=none]) .smart-menu-drop-down[level="2"].smart-visibility-hidden {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu[drop-down-position|=top] .smart-menu-drop-down {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    top: 100%;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-menu[drop-down-position|=top] .smart-menu-drop-down[level="2"] {
    top: 0
}

.smart-menu[drop-down-position|=top] .smart-menu-minimized-items-container {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    top: -1px;
    top: calc(var(--smart-border-width)*-1);
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-menu[drop-down-position|=top]:not([animation=none]) .smart-menu-drop-down {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-menu[drop-down-position|=top]:not([animation=none]) .smart-menu-drop-down.smart-visibility-hidden,
.smart-menu[drop-down-position|=top]:not([animation=none]) .smart-menu-minimized-items-container.smart-visibility-hidden {
    -webkit-transform: translateY(-100%) scaleY(0);
    transform: translateY(-100%) scaleY(0)
}

.smart-menu[drop-down-position|=top]:not([animation=none]):not([mode=tree]) .smart-menu-minimized-items-container {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-menu[drop-down-position|=top][mode=dropDown]:not([animation=none]) .smart-menu-minimized-items-container .smart-menu-drop-down,
.smart-menu[drop-down-position|=top][mode=vertical]:not([animation=none]) .smart-menu-minimized-items-container .smart-menu-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-menu[drop-down-position$=left] .smart-menu-drop-down {
    left: auto;
    right: 100%
}

.smart-menu[drop-down-position$=left] .smart-menu-drop-down[level="2"] {
    left: auto;
    right: 0
}

.smart-menu[drop-down-position$=left] .smart-menu-main-container smart-menu-items-group:not([level="1"])>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    margin-left: 0;
    margin-right: 50px;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-menu[drop-down-position$=left] .smart-menu-main-container smart-menu-item:not([level="1"])>.smart-menu-item-label-container>.smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 100px
}

.smart-menu[drop-down-position$=left] smart-menu-items-group:not([level="1"])>.smart-menu-item-label-container {
    flex-direction: row-reverse
}

.smart-menu[drop-down-position$=left] .smart-menu-minimized-items-container {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-menu[drop-down-position=overlay-left] .smart-menu-main-container .smart-menu-drop-down:not([level="2"]) {
    left: auto;
    right: 0
}

.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    left: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-menu[checkboxes][checkable] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes][checkable] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    left: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu[checkboxes][checkable] smart-menu-item[level="1"][checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes][checkable] smart-menu-items-group[level="1"][checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes][checkable][check-mode=radioButton] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-menu[checkboxes][checkable][check-mode=radioButton] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-menu[checkboxes][mode=tree] .smart-menu-minimized-items-container smart-menu-items-group.smart-menu-items-group-opened>.smart-menu-item-label-container:after {
    top: calc(50% + 5px)
}

.smart-menu-items-group .smart-menu-items-group-arrow {
    font-family: var(--smart-family-icon);
    font-size: 11px;
    font-size: calc(var(--smart-font-size) - 3px);
    margin-left: 50px;
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-menu-items-group[level="1"]>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    margin-left: 10px
}

.smart-menu-item[template-applied] .smart-menu-item-label-container {
    overflow: visible
}

.smart-menu-item[template-applied] .smart-menu-item-label-element {
    display: block;
    overflow: visible;
    white-space: normal;
    width: 100%
}

.smart-menu-drop-down {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-menu-drop-down .smart-menu-drop-down {
    margin: 0
}

.smart-menu-drop-down[level="2"]:not(.smart-menu-minimized-items-container) {
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + 3px) 0
}

.smart-menu-drop-down[level="2"][mode=dropDown]:not(.smart-menu-minimized-items-container),
.smart-menu-drop-down[level="2"][mode=vertical]:not(.smart-menu-minimized-items-container) {
    margin: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position*=overlay],
.smart-menu-drop-down[drop-down-position*=overlay] {
    margin: unset
}

.smart-menu-drop-down.drop-down-height-set .smart-menu-scroll-button {
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-button-background);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border);
    color: #505050;
    color: var(--smart-scroll-bar-button-color);
    display: block;
    height: 32px;
    height: var(--smart-menu-scroll-button-size);
    min-height: 0;
    width: 100%
}

.smart-menu-drop-down.drop-down-height-set .smart-menu-scroll-button[hover] {
    background-color: #d2d2d2;
    background-color: var(--smart-scroll-bar-button-background-hover);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-hover);
    color: #505050;
    color: var(--smart-scroll-bar-button-color-hover)
}

.smart-menu-drop-down.drop-down-height-set .smart-menu-scroll-button[active] {
    background-color: #787878;
    background-color: var(--smart-scroll-bar-button-background-active);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-active);
    color: #fff;
    color: var(--smart-scroll-bar-button-color-active)
}

.smart-menu-drop-down.smart-drop-down-repositioned,
.smart-menu-minimized-items-container,
.smart-menu-minimized-items-container.smart-drop-down-repositioned .smart-menu-drop-down {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-menu-drop-down.drop-down-height-set .smart-menu-scroll-button>button {
    border: none
}

.smart-menu-drop-down.drop-down-height-set .smart-menu-main-container.scroll-buttons-shown {
    overflow: hidden;
    width: calc(100% - 64px);
    width: calc(100% - var(--smart-menu-scroll-button-size)*2)
}

.smart-menu-drop-down.drop-down-height-set[mode=dropDown] .smart-menu-scroll-button,
.smart-menu-drop-down.drop-down-height-set[mode=tree] .smart-menu-scroll-button,
.smart-menu-drop-down.drop-down-height-set[mode=vertical] .smart-menu-scroll-button {
    height: 32px;
    height: var(--smart-menu-scroll-button-size);
    width: 100%
}

.smart-menu-drop-down.drop-down-height-set>.smart-menu-item-container {
    height: 100%;
    overflow: hidden
}

.smart-menu-drop-down.drop-down-height-set>.smart-menu-item-container.scroll-buttons-shown {
    height: calc(100% - 64px);
    height: calc(100% - var(--smart-menu-scroll-button-size)*2)
}

.smart-menu-drop-down.drop-down-height-set>.smart-menu-item-container.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 32px);
    height: calc(100% - var(--smart-menu-scroll-button-size));
    width: 100%
}

.smart-menu-drop-down.drop-down-height-set>.smart-menu-item-container>smart-menu-items-group {
    position: static
}

.smart-menu-drop-down.smart-drop-down-repositioned {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    box-sizing: border-box;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    left: 100%;
    position: absolute;
    top: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned a {
    color: inherit
}

.smart-menu-drop-down.smart-drop-down-repositioned * {
    box-sizing: border-box
}

.smart-menu-drop-down.smart-drop-down-repositioned .smart-ripple {
    background: #005c99;
    background: var(--smart-primary)
}

.smart-menu-drop-down.smart-drop-down-repositioned .smart-menu-drop-down {
    border: none
}

.smart-menu-drop-down.smart-drop-down-repositioned .smart-menu-item-label-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    padding: 10px;
    position: relative;
    width: 100%
}

.smart-menu-drop-down.smart-drop-down-repositioned smart-menu-item[separator][level]:last-child,
.smart-menu-drop-down.smart-drop-down-repositioned smart-menu-items-group[separator][level]:last-child {
    border-bottom: none
}

.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container {
    padding-left: 35px
}

.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    left: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-drop-down.smart-drop-down-repositioned[checkboxes] .smart-menu-item-container[checkable][check-mode=radioButton]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-menu-drop-down.smart-drop-down-repositioned[level="2"] {
    left: 0;
    top: 100%
}

.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=vertical][level="2"] {
    left: 100%;
    top: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][drop-down-position|=top],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=vertical][drop-down-position|=top] {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][drop-down-position|=top][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=vertical][drop-down-position|=top][level="2"] {
    top: 100%;
    -webkit-transform: none;
    transform: none
}

.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][drop-down-position=overlay-right][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=vertical][drop-down-position=overlay-right][level="2"] {
    left: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][drop-down-position=overlay-left][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=vertical][drop-down-position=overlay-left][level="2"] {
    right: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position$=left],
.smart-menu-drop-down.smart-drop-down-repositioned[mode=dropDown][drop-down-position$=left][level="2"] {
    left: auto;
    right: 100%
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position$=left][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position=overlay-left]:not([level="2"]) {
    left: auto;
    right: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position|=overlay] {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position*=top] {
    margin: -8px 0;
    margin: calc((var(--smart-editor-drop-down-vertical-offset) + 3px)*-1) 0
}

.smart-menu-minimized-items-container .smart-menu-item-shortcut,
.smart-menu-minimized-items-container smart-menu-items-group .smart-menu-items-group-arrow {
    margin-left: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position|=top] {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    top: 100%;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position|=top][level="2"] {
    top: 0;
    -webkit-transform: none;
    transform: none
}

.smart-menu-drop-down.smart-drop-down-repositioned[animation=none].smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-menu-drop-down.smart-drop-down-repositioned.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.smart-menu-drop-down.smart-drop-down-repositioned .smart-hidden {
    display: none !important
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned.smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=top] {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=top].smart-visibility-hidden {
    -webkit-transform: translateY(-100%) scaleY(0);
    transform: translateY(-100%) scaleY(0)
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=top][level="2"] {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=top][level="2"].smart-visibility-hidden {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=overlay] {
    -webkit-transform: translateY(-50%) scaleY(1);
    transform: translateY(-50%) scaleY(1);
    -webkit-transform-origin: center;
    transform-origin: center
}

.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=overlay].smart-visibility-hidden {
    -webkit-transform: translateY(-50%) scaleY(0);
    transform: translateY(-50%) scaleY(0)
}

.smart-menu-drop-down:not(.smart-list-menu-view-minimized).smart-drop-down-repositioned[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-drop-down:not(.smart-list-menu-view-minimized).smart-drop-down-repositioned[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container {
    padding-left: 10px;
    padding-right: 35px
}

.smart-menu-drop-down:not(.smart-list-menu-view-minimized).smart-drop-down-repositioned[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container:after,
.smart-menu-drop-down:not(.smart-list-menu-view-minimized).smart-drop-down-repositioned[checkboxes][drop-down-position$=left] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu-minimized-items-container {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    left: -1px;
    left: calc(var(--smart-border-width)*-1);
    position: absolute;
    top: calc(100% + 1px);
    top: calc(100% + var(--smart-border-width))
}

.smart-menu-minimized-items-container smart-menu-items-group {
    display: flex;
    flex-direction: column;
    overflow: hidden
}

.smart-menu-minimized-items-container smart-menu-item[level],
.smart-menu-minimized-items-container smart-menu-items-group[level] {
    height: auto;
    margin: 0
}

.smart-menu-minimized-items-container .smart-menu-drop-down {
    border: none;
    box-shadow: none;
    height: auto;
    margin: 0;
    padding-left: 20px;
    position: static;
    -webkit-transform: none;
    transform: none;
    width: 100%
}

.smart-menu-minimized-items-container .smart-menu-drop-down.smart-visibility-hidden {
    border: none
}

.smart-menu-minimized-items-container .smart-menu-drop-down:not(.smart-menu-minimized-items-container) {
    margin: 0
}

.smart-menu-minimized-items-container .smart-menu-drop-down.drop-down-height-set>.smart-menu-item-container {
    overflow: visible;
    overflow: initial
}

.smart-menu-minimized-items-container.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position$=left] .smart-menu-drop-down .smart-menu-item-label-container>.smart-menu-item-shortcut {
    margin-right: 0
}

.smart-menu-minimized-items-container.smart-menu-drop-down.smart-drop-down-repositioned[drop-down-position|=overlay] {
    -webkit-transform: none;
    transform: none
}

.smart-menu-minimized-items-container.smart-menu-drop-down:not([animation=none]).smart-drop-down-repositioned[drop-down-position|=overlay] {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-menu-minimized-items-container.smart-menu-drop-down:not([animation=none]).smart-visibility-hidden.smart-drop-down-repositioned[drop-down-position|=overlay] {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu-minimized-items-container .smart-menu-item-label-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    padding: 10px;
    position: relative;
    width: 100%
}

.smart-menu-minimized-items-container .smart-menu-items-group-opened>.smart-menu-drop-down {
    margin-top: 10px
}

.smart-menu-minimized-items-container .smart-menu-items-group-opened>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-menu-minimized-items-container .smart-menu-item-label-element {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned {
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned .smart-menu-drop-down {
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    left: 100%;
    position: absolute;
    top: 0
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned .smart-menu-drop-down.smart-visibility-hidden {
    border: none;
    height: 0;
    margin-top: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned .smart-menu-items-group-opened>.smart-menu-item-label-container {
    padding-bottom: 0
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned[drop-down-position$=left] {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned[drop-down-position$=left] .smart-menu-items-group-arrow {
    margin: 0
}

.smart-drop-down.smart-menu-minimized-items-container,
.smart-menu-minimized-items-container[drop-down] {
    margin: 8px 0;
    margin: calc(var(--smart-editor-drop-down-vertical-offset) + 3px) 0
}

.smart-menu-minimized-items-container.smart-drop-down-repositioned[checkboxes] smart-menu-items-group.smart-menu-items-group-opened>.smart-menu-item-label-container:after {
    top: calc(50% + 5px)
}

.smart-menu-minimized-items-container:not([animation=none]) {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu-minimized-items-container:not([animation=none]) .smart-menu-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: height .2s ease-in
}

.smart-menu-minimized-items-container:not([animation=none]) .smart-menu-item-label-container>.smart-menu-items-group-arrow {
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-menu-minimized-items-container:not([animation=none]).smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-menu-minimized-items-container[drop-down-position] .smart-menu-drop-down {
    box-shadow: none;
    height: auto;
    padding-left: 20px;
    position: static;
    -webkit-transform: none;
    transform: none;
    width: 100%
}

.smart-menu-minimized-items-container[drop-down-position|=top] {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    top: -1px;
    top: calc(var(--smart-border-width)*-1);
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-menu-minimized-items-container[drop-down-position|=top]:not([animation=none]) {
    -webkit-transform: translateY(-100%) scaleY(1);
    transform: translateY(-100%) scaleY(1);
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-menu-minimized-items-container[drop-down-position|=top]:not([animation=none]).smart-visibility-hidden {
    -webkit-transform: translateY(-100%) scaleY(0);
    transform: translateY(-100%) scaleY(0)
}

.smart-menu-minimized-items-container[drop-down-position|=top][mode=dropDown]:not([animation=none]) .smart-menu-drop-down,
.smart-menu-minimized-items-container[drop-down-position|=top][mode=vertical]:not([animation=none]) .smart-menu-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-menu-minimized-items-container[drop-down-position$=left] .smart-menu-drop-down {
    padding-left: 0;
    padding-right: 20px
}

.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-items-group>.smart-menu-item-label-container {
    padding-left: 35px
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu-minimized-items-container[checkboxes][checkable][drop-down-position$=left]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-minimized-items-container[checkboxes][checkable][drop-down-position$=left]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu-minimized-items-container[right-to-left][checkboxes][checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu-minimized-items-container[right-to-left][checkboxes][checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-item>.smart-menu-item-label-container,
.smart-menu[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group>.smart-menu-item-label-container,
.smart-menu[right-to-left][checkboxes][checkable] smart-menu-item[level="1"]>.smart-menu-item-label-container,
.smart-menu[right-to-left][checkboxes][checkable] smart-menu-items-group[level="1"]>.smart-menu-item-label-container {
    padding-left: 10px;
    padding-right: 35px
}

.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    left: 10px;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-item[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[checkboxes][checkable]>smart-menu-items-group[checked][check-type=radioButton]>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[checkboxes][checkable][check-mode=radioButton]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[checkboxes][checkable][check-mode=radioButton]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-menu-minimized-items-container[checkboxes][checkable][drop-down-position$=left]>smart-menu-item>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[checkboxes][checkable][drop-down-position$=left]>smart-menu-items-group>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-date-time-picker .smart-date-time-drop-down.smart-visibility-hidden.not-in-view {
    left: -9999px;
    top: -9999px;
    transition: none
}

.minus:after {
    content: "\\e804";
    content: var(--smart-icon-minus);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-menu[right-to-left] .smart-menu-main-container {
    direction: rtl
}

.smart-menu[right-to-left] .smart-menu-minimized-items-container {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-menu[right-to-left] .smart-menu-minimized-items-container .smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 0
}

.smart-menu[right-to-left] .smart-menu-items-group-arrow.right.smart-arrow-right {
    margin-left: 0;
    margin-right: 50px
}

.smart-menu[right-to-left] .smart-menu-drop-down {
    left: auto;
    right: 100%
}

.smart-menu[right-to-left] .smart-menu-drop-down[level="2"] {
    right: 0
}

.smart-menu[right-to-left][mode=dropDown],
.smart-menu[right-to-left][mode=vertical] .smart-menu-drop-down[level="2"] {
    left: auto;
    right: 100%
}

.smart-menu[right-to-left] smart-menu-item .smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 100px
}

.smart-menu[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow {
    margin-left: 0;
    margin-right: 0
}

.smart-menu[right-to-left] smart-menu-items-group[level="1"]>.smart-menu-item-label-container>.smart-menu-items-group-arrow {
    margin-left: 0;
    margin-right: 10px
}

.smart-menu[right-to-left]:not([mode=tree])[drop-down-position$=left] smart-menu-item:not([level="1"])>.smart-menu-item-label-container,
.smart-menu[right-to-left][mode]:not([mode=horizontal]):not([mode=tree])[drop-down-position$=left] smart-menu-item>.smart-menu-item-label-container,
.smart-menu[right-to-left][mode]:not([mode=horizontal])[drop-down-position$=left] .smart-menu-main-container smart-menu-items-group>.smart-menu-item-label-container {
    flex-direction: row
}

.smart-menu[right-to-left][mode=tree] .smart-menu-minimized-items-container {
    direction: rtl
}

.smart-menu[right-to-left][mode=dropDown] smart-menu-item[level="1"] .smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 0
}

.smart-menu[right-to-left][drop-down-position$=left] smart-menu-items-group:not([level="1"])>.smart-menu-item-label-container {
    flex-direction: row
}

.smart-menu[right-to-left][drop-down-position$=right] .smart-menu-drop-down[level="2"],
.smart-menu[right-to-left][drop-down-position=overlay-right] .smart-menu-main-container .smart-menu-drop-down:not([level="2"]) {
    left: 0;
    right: auto
}

.smart-menu[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after,
.smart-menu[right-to-left][checkboxes][checkable] smart-menu-item[level="1"][checked]>.smart-menu-item-label-container:after,
.smart-menu[right-to-left][checkboxes][checkable] smart-menu-items-group[level="1"][checked]>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu[right-to-left][minimized] .smart-menu-minimized-items-container {
    direction: rtl
}

.smart-menu[right-to-left][minimized][drop-down-position$=left]>.smart-container {
    flex-direction: row
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left] {
    left: auto;
    right: 100%
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left] .smart-menu-item-container,
.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left].smart-menu-minimized-items-container {
    direction: rtl
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left] .smart-menu-items-group-arrow.right.smart-arrow-right {
    margin-left: 0;
    margin-right: 50px
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left] smart-menu-item .smart-menu-item-shortcut {
    margin-left: 0;
    margin-right: 100px
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][drop-down-position$=left][level="2"],
.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][drop-down-position=overlay-right]:not([level="2"]) {
    left: 0;
    right: auto
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][level="2"] {
    right: 0
}

.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-drop-down.smart-drop-down-repositioned[right-to-left][checkboxes] .smart-menu-item-container[checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

.smart-menu-minimized-items-container[right-to-left] {
    left: auto;
    right: 100%
}

.smart-menu-minimized-items-container[right-to-left] .smart-menu-item-shortcut,
.smart-menu-minimized-items-container[right-to-left] smart-menu-items-group .smart-menu-items-group-arrow {
    margin-left: 0;
    margin-right: 0
}

.smart-menu-minimized-items-container[right-to-left].smart-drop-down-repositioned {
    left: auto;
    right: -1px;
    right: calc(var(--smart-border-width)*-1)
}

.smart-menu-minimized-items-container[right-to-left].smart-drop-down-repositioned .smart-menu-drop-down {
    left: auto;
    right: 100%
}

.smart-menu-minimized-items-container[right-to-left][checkboxes][checkable]>smart-menu-item[checked]>.smart-menu-item-label-container:after,
.smart-menu-minimized-items-container[right-to-left][checkboxes][checkable]>smart-menu-items-group[checked]>.smart-menu-item-label-container:after {
    left: auto;
    right: 10px
}

smart-multi-split-button {
    cursor: pointer;
    height: 30px;
    height: var(--smart-multi-split-button-default-height);
    overflow: visible;
    overflow: initial;
    visibility: hidden;
    width: 250px;
    width: var(--smart-multi-split-button-default-width)
}

smart-multi-split-button.smart-element {
    border-width: 0;
    overflow: visible;
    visibility: inherit
}

smart-multi-split-button[right-to-left] .smart-content,
smart-multi-split-button[right-to-left] .smart-hint,
smart-multi-split-button[right-to-left] .smart-label {
    direction: rtl
}

smart-multi-split-button[right-to-left] .smart-drop-down {
    direction: ltr
}

.smart-multi-split-button smart-list-box {
    border: initial;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    outline: 0;
    overflow: hidden;
    padding: initial;
    position: relative;
    width: 100%
}

.smart-multi-split-button .smart-buttons-container .smart-input .smart-token {
    cursor: pointer;
    margin: 0 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-multi-split-button .smart-drop-down.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top 0;
    transform-origin: left top 0;
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-multi-split-button .smart-template-container {
    height: 100%;
    width: 100%
}

.smart-multi-split-button .smart-multi-split-button-buttons {
    align-items: stretch;
    display: flex;
    height: 100%;
    justify-content: space-around;
    width: 100%
}

.smart-multi-split-button .smart-multi-split-button-buttons .smart-action-split-button {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-multi-split-button .smart-multi-split-button-buttons .smart-action-split-button[hover] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border: #ebebeb;
    border: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-multi-split-button .smart-multi-split-button-buttons .smart-action-split-button[active] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: #005c99;
    border: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-multi-split-button.primary {
    --smart-border: var(--smart-primary);
    --smart-outline: var(--smart-primary);
    --smart-surface: var(--smart-primary);
    --smart-surface-color: var(--smart-primary-color);
    --smart-ui-state-selected: rgba(var(--smart-primary-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-primary-color);
    --smart-ui-state-active: rgba(var(--smart-primary-rgb), .8);
    --smart-ui-state-color-active: var(--smart-primary-color);
    --smart-ui-state-hover: var(--smart-primary);
    --smart-ui-state-color-hover: var(--smart-primary-color);
    --smart-ui-state-border-selected: var(--smart-primary);
    --smart-ui-state-border-active: var(--smart-primary);
    --smart-ui-state-border-hover: var(--smart-primary)
}

.smart-multi-split-button.primary[hover] {
    --smart-surface: var(--smart-primary-color)
}

.smart-multi-split-button.secondary {
    --smart-border: var(--smart-secondary);
    --smart-outline: var(--smart-secondary);
    --smart-surface: var(--smart-secondary);
    --smart-surface-color: var(--smart-secondary-color);
    --smart-ui-state-selected: rgba(var(--smart-secondary-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-secondary-color);
    --smart-ui-state-active: rgba(var(--smart-secondary-rgb), .8);
    --smart-ui-state-color-active: var(--smart-secondary-color);
    --smart-ui-state-hover: var(--smart-secondary);
    --smart-ui-state-color-hover: var(--smart-secondary-color);
    --smart-ui-state-border-selected: var(--smart-secondary);
    --smart-ui-state-border-active: var(--smart-secondary);
    --smart-ui-state-border-hover: var(--smart-secondary)
}

.smart-multi-split-button.secondary[hover] {
    --smart-surface: var(--smart-secondary-color)
}

.smart-multi-split-button.success {
    --smart-border: var(--smart-success);
    --smart-outline: var(--smart-success);
    --smart-surface: var(--smart-success);
    --smart-surface-color: var(--smart-success-color);
    --smart-ui-state-selected: rgba(var(--smart-success-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-success-color);
    --smart-ui-state-active: rgba(var(--smart-success-rgb), .8);
    --smart-ui-state-color-active: var(--smart-success-color);
    --smart-ui-state-hover: var(--smart-success);
    --smart-ui-state-color-hover: var(--smart-success-color);
    --smart-ui-state-border-selected: var(--smart-success);
    --smart-ui-state-border-active: var(--smart-success);
    --smart-ui-state-border-hover: var(--smart-success)
}

.smart-multi-split-button.success[hover] {
    --smart-surface: var(--smart-success-color)
}

.smart-multi-split-button.error {
    --smart-border: var(--smart-error);
    --smart-outline: var(--smart-error);
    --smart-surface: var(--smart-error);
    --smart-surface-color: var(--smart-error-color);
    --smart-ui-state-selected: rgba(var(--smart-error-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-error-color);
    --smart-ui-state-active: rgba(var(--smart-error-rgb), .8);
    --smart-ui-state-color-active: var(--smart-error-color);
    --smart-ui-state-hover: var(--smart-error);
    --smart-ui-state-color-hover: var(--smart-error-color);
    --smart-ui-state-border-selected: var(--smart-error);
    --smart-ui-state-border-active: var(--smart-error);
    --smart-ui-state-border-hover: var(--smart-error)
}

.smart-multi-split-button.error[hover] {
    --smart-surface: var(--smart-error-color)
}

.smart-multi-split-button.info {
    --smart-border: var(--smart-info);
    --smart-outline: var(--smart-info);
    --smart-surface: var(--smart-info);
    --smart-surface-color: var(--smart-info-color);
    --smart-ui-state-selected: rgba(var(--smart-info-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-info-color);
    --smart-ui-state-active: rgba(var(--smart-info-rgb), .8);
    --smart-ui-state-color-active: var(--smart-info-color);
    --smart-ui-state-hover: var(--smart-info);
    --smart-ui-state-color-hover: var(--smart-info-color);
    --smart-ui-state-border-selected: var(--smart-info);
    --smart-ui-state-border-active: var(--smart-info);
    --smart-ui-state-border-hover: var(--smart-info)
}

.smart-multi-split-button.info[hover] {
    --smart-surface: var(--smart-info-color)
}

.smart-multi-split-button.warning {
    --smart-border: var(--smart-warning);
    --smart-outline: var(--smart-warning);
    --smart-surface: var(--smart-warning);
    --smart-surface-color: var(--smart-warning-color);
    --smart-ui-state-selected: rgba(var(--smart-warning-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-warning-color);
    --smart-ui-state-active: rgba(var(--smart-warning-rgb), .8);
    --smart-ui-state-color-active: var(--smart-warning-color);
    --smart-ui-state-hover: var(--smart-warning);
    --smart-ui-state-color-hover: var(--smart-warning-color);
    --smart-ui-state-border-selected: var(--smart-warning);
    --smart-ui-state-border-active: var(--smart-warning);
    --smart-ui-state-border-hover: var(--smart-warning)
}

.smart-multi-split-button.warning[hover] {
    --smart-surface: var(--smart-warning-color)
}

.smart-multi-split-button.light {
    --smart-border: var(--smart-light);
    --smart-outline: var(--smart-light);
    --smart-surface: var(--smart-light);
    --smart-surface-color: var(--smart-light-color);
    --smart-ui-state-selected: rgba(var(--smart-light-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-light-color);
    --smart-ui-state-active: rgba(var(--smart-light-rgb), .8);
    --smart-ui-state-color-active: var(--smart-light-color);
    --smart-ui-state-hover: var(--smart-light);
    --smart-ui-state-color-hover: var(--smart-light-color);
    --smart-ui-state-border-selected: var(--smart-light);
    --smart-ui-state-border-active: var(--smart-light);
    --smart-ui-state-border-hover: var(--smart-light)
}

.smart-multi-split-button.light[hover] {
    --smart-surface: var(--smart-light-color)
}

.smart-multi-split-button.dark {
    --smart-border: var(--smart-dark);
    --smart-outline: var(--smart-dark);
    --smart-surface: var(--smart-dark);
    --smart-surface-color: var(--smart-dark-color);
    --smart-ui-state-selected: rgba(var(--smart-dark-rgb), .8);
    --smart-ui-state-color-selected: var(--smart-dark-color);
    --smart-ui-state-active: rgba(var(--smart-dark-rgb), .8);
    --smart-ui-state-color-active: var(--smart-dark-color);
    --smart-ui-state-hover: var(--smart-dark);
    --smart-ui-state-color-hover: var(--smart-dark-color);
    --smart-ui-state-border-selected: var(--smart-dark);
    --smart-ui-state-border-active: var(--smart-dark);
    --smart-ui-state-border-hover: var(--smart-dark)
}

.smart-multi-split-button.dark[hover] {
    --smart-surface: var(--smart-dark-color)
}

.smart-multi-split-button[selection-display-mode=tokens] .smart-multi-split-button-unselect-button {
    pointer-events: auto
}

.smart-multi-split-button[selection-display-mode=plain] .smart-multi-split-button-unselect-button {
    pointer-events: none
}

smart-multiline-text-box.smart-element {
    background: 0 0;
    height: 300px;
    height: var(--smart-multiline-text-box-default-height);
    overflow: visible;
    overflow: initial;
    width: 250px;
    width: var(--smart-multiline-text-box-default-width)
}

smart-multiline-text-box[cols] {
    width: auto
}

smart-multiline-text-box[rows] {
    height: auto
}

.smart-multiline-text-box[hover] {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-multiline-text-box[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-multiline-text-box .smart-container>.smart-resize-trigger-container,
.smart-multiline-text-box .smart-inner-container>.smart-resize-trigger-container,
.smart-multiline-text-box>.smart-resize-trigger-container {
    margin-bottom: -1px
}

.smart-multiline-text-box.smart-drop-down-box.smart-container,
.smart-multiline-text-box.smart-drop-down-box>.smart-container,
.smart-multiline-text-box.smart-drop-down-box[label][hint]>.smart-container {
    display: block;
    max-height: inherit;
    overflow: visible
}

.smart-multiline-text-box .smart-inner-container,
.smart-multiline-text-box textarea {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    overflow: hidden;
    width: 100%
}

.smart-multiline-text-box smart-scroll-bar {
    display: none
}

.smart-multiline-text-box textarea {
    background-color: inherit;
    border: none;
    float: left;
    height: 100%;
    outline: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    resize: none
}

.smart-multiline-text-box textarea:not(.smart-text-box-hidden) {
    max-height: inherit
}

.smart-multiline-text-box textarea.smart-text-box-hidden {
    height: 0;
    left: 0;
    position: absolute;
    top: 0;
    visibility: hidden;
    width: 100%
}

.smart-multiline-text-box .smart-inner-container {
    height: 100%;
    max-height: inherit;
    position: relative
}

.smart-multiline-text-box .smart-initialization-value {
    display: none
}

.smart-multiline-text-box .smart-resize-element {
    background-clip: content-box;
    background-color: #d3d3d3;
    border: 1px solid #e0e0e0;
    border: var(--smart-border) solid var(--smart-border-width);
    bottom: 0;
    box-sizing: border-box;
    cursor: nw-resize;
    display: none;
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    padding: 2px 0 0 2px;
    position: absolute;
    right: 0;
    touch-action: none;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-multiline-text-box .smart-required-message {
    display: none
}

.smart-multiline-text-box .smart-container textarea,
.smart-multiline-text-box.smart-container textarea {
    height: 100%
}

.smart-multiline-text-box .smart-container.hscroll textarea,
.smart-multiline-text-box.smart-container.hscroll textarea {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-multiline-text-box .smart-container.hscroll smart-scroll-bar,
.smart-multiline-text-box.smart-container.hscroll smart-scroll-bar {
    display: block;
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    width: 100%
}

.smart-multiline-text-box .smart-container.hscroll smart-scroll-bar[orientation=vertical],
.smart-multiline-text-box.smart-container.hscroll smart-scroll-bar[orientation=vertical] {
    display: none
}

.smart-multiline-text-box .smart-container.vscroll textarea,
.smart-multiline-text-box.smart-container.vscroll textarea {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-multiline-text-box .smart-container.vscroll smart-scroll-bar[orientation=vertical],
.smart-multiline-text-box.smart-container.vscroll smart-scroll-bar[orientation=vertical] {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: block;
    float: right;
    height: 100%;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-multiline-text-box .smart-container.vscroll.hscroll smart-scroll-bar,
.smart-multiline-text-box.smart-container.vscroll.hscroll smart-scroll-bar {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-multiline-text-box .smart-container.vscroll.hscroll smart-scroll-bar[orientation=vertical],
.smart-multiline-text-box.smart-container.vscroll.hscroll smart-scroll-bar[orientation=vertical] {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-multiline-text-box[auto-expand] {
    height: auto;
    min-height: 30px;
    min-height: var(--smart-editor-height)
}

.smart-multiline-text-box[auto-expand] textarea.smart-text-box-hidden {
    height: 0
}

.smart-multiline-text-box[auto-capitalize=words] textarea {
    text-transform: capitalize
}

.smart-multiline-text-box[auto-capitalize=characters] textarea {
    text-transform: uppercase
}

.smart-multiline-text-box[display-mode=escaped] textarea {
    white-space: nowrap
}

.smart-multiline-text-box[cols] textarea,
.smart-multiline-text-box[rows] textarea {
    height: inherit;
    width: inherit
}

.smart-multiline-text-box[resizable] .smart-container.hscroll smart-scroll-bar,
.smart-multiline-text-box[resizable].smart-container.hscroll smart-scroll-bar {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-multiline-text-box[resizable] .smart-container.hscroll smart-scroll-bar smart-multiline-text-box .smart-container.vscroll.hscroll smart-scroll-bar,
.smart-multiline-text-box[resizable].smart-container.hscroll smart-scroll-bar smart-multiline-text-box .smart-container.vscroll.hscroll smart-scroll-bar {
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-multiline-text-box[resizable] .smart-container.vscroll smart-scroll-bar[orientation=vertical],
.smart-multiline-text-box[resizable].smart-container.vscroll smart-scroll-bar[orientation=vertical] {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size));
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-multiline-text-box[resizable] .smart-resize-element {
    display: block
}

.smart-multiline-text-box[resizable] .smart-resize,
.smart-multiline-text-box[resizable] .smart-resize textarea {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-multiline-text-box.outlined textarea {
    border: 1px solid #e0e0e0 !important;
    border: 1px solid var(--smart-border) !important;
    padding: 10px
}

.smart-multiline-text-box.outlined[focus] textarea {
    border: 1px solid #005c99 !important;
    border: 1px solid var(--smart-primary) !important;
    border-top: 1px solid transparent !important
}

.smart-multiline-text-box.outlined.smart-element {
    height: 300px;
    height: var(--smart-multiline-text-box-default-height)
}

.smart-multiline-text-box[right-to-left] textarea {
    float: right
}

.smart-multiline-text-box[right-to-left] .smart-container.vscroll smart-scroll-bar[orientation=vertical],
.smart-multiline-text-box[right-to-left].smart-container.vscroll smart-scroll-bar[orientation=vertical] {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-right-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-right-radius);
    border-top-right-radius: 0
}

smart-numeric-text-box {
    height: 30px;
    height: var(--smart-numeric-text-box-default-height);
    width: 250px;
    width: var(--smart-numeric-text-box-default-width)
}

smart-numeric-text-box .smart-container {
    border: none;
    display: flex;
    width: 100%
}

smart-numeric-text-box.smart-element {
    background: 0 0;
    border: none;
    overflow: visible
}

smart-numeric-text-box[spin-buttons][spin-buttons-position=left] .smart-spin-button.smart-element:first-child,
smart-numeric-text-box[spin-buttons][spin-buttons-position=left] .smart-spin-button.smart-element:last-child {
    border-right: none
}

smart-numeric-text-box[hint] .smart-hint,
smart-numeric-text-box[label] .smart-label {
    bottom: 100%;
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    vertical-align: baseline;
    vertical-align: initial;
    width: 100%
}

.smart-numeric-text-box {
    border: 1px solid #e0e0e0;
    border-color: var(--smart-border)
}

.smart-numeric-text-box:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-numeric-text-box * {
    box-sizing: border-box
}

.smart-numeric-text-box.smart-container {
    border: none;
    display: flex;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-numeric-text-box .smart-container {
    height: 100%;
    position: relative
}

.smart-numeric-text-box input.smart-input {
    -webkit-appearance: none;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border-color: var(--smart-border);
    border-right: var(--smart-border-width) solid var(--smart-border);
    color: inherit;
    font: inherit;
    height: 100%;
    outline: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    text-align: right;
    text-align: var(--smart-numeric-text-box-text-align);
    width: 100%
}

.smart-numeric-text-box .smart-spin-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    height: 50%;
    width: 100%
}

.smart-numeric-text-box .smart-spin-button:first-child {
    border-bottom: none
}

.smart-numeric-text-box .smart-spin-button.smart-element {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-radius: 0;
    color: #323232;
    color: var(--smart-surface-color);
    display: block;
    min-height: 0
}

.smart-numeric-text-box .smart-spin-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-numeric-text-box .smart-spin-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-numeric-text-box .smart-spin-button .smart-button {
    border: none;
    padding: 0
}

.smart-numeric-text-box .smart-numeric-text-box-component {
    border-color: #e0e0e0;
    border-width: 1px;
    border-left-width: 1px;
    border-right-width: var(--smart-border-width);
    border: var(--smart-border-width) solid var(--smart-border);
    border-right: 0 solid var(--smart-border)
}

.smart-numeric-text-box .smart-input-addon {
    border: 1px solid #e0e0e0;
    border-color: var(--smart-border)
}

.smart-numeric-text-box .smart-spin-buttons-container {
    border: none;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-numeric-text-box .smart-numeric-text-box-drop-down {
    width: 100%
}

.smart-numeric-text-box .smart-numeric-text-box-radix-display.smart-numeric-text-box-pressed-component,
.smart-numeric-text-box .smart-numeric-text-box-radix-display.smart-numeric-text-box-pressed-component[hover] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-numeric-text-box .smart-numeric-text-box-unit-display {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-width: 1px 0;
    border-bottom-width: var(--smart-border-width);
    border-right-width: 0;
    border-top-width: var(--smart-border-width);
    overflow: hidden;
    width: 27px;
    width: var(--smart-numeric-text-box-default-unit-display-width)
}

.smart-numeric-text-box .smart-numeric-text-box-unit-display[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-numeric-text-box .smart-arrow {
    position: relative
}

.smart-numeric-text-box .smart-hint,
.smart-numeric-text-box .smart-label {
    display: none;
    position: absolute
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden) {
    border-radius: 0
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-left,
.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-left .smart-spin-button.smart-repeat-button-element {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    overflow: hidden
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-left .smart-spin-button.smart-element:first-child {
    border-bottom-left-radius: 0
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-left .smart-spin-button.smart-element:last-child {
    border-top-left-radius: 0
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-right,
.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-right .smart-spin-button.smart-element {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    overflow: hidden
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-right .smart-spin-button.smart-element:first-child {
    border-bottom-right-radius: 0
}

.smart-numeric-text-box .smart-numeric-text-box-component:not(.smart-hidden).smart-numeric-text-box-component-border-right .smart-spin-button.smart-element:last-child {
    border-top-right-radius: 0
}

.smart-numeric-text-box[drop-down-enabled] .smart-numeric-text-box-radix-display {
    cursor: pointer
}

.smart-numeric-text-box[drop-down-enabled] .smart-numeric-text-box-radix-display[hover]:not([aria-expanded=true]) {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-numeric-text-box:not([animation=none])[hint] .smart-hint {
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-numeric-text-box:not([animation=none])[hint][focus] .smart-hint {
    transition: opacity .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-numeric-text-box:not([animation=none]) .smart-numeric-text-box-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-numeric-text-box[focus] .smart-input-addon,
.smart-numeric-text-box[focus] .smart-spin-button,
.smart-numeric-text-box[focus] input.smart-input {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-numeric-text-box[hint] .smart-hint {
    bottom: auto;
    opacity: 0;
    top: 100%
}

.smart-numeric-text-box[hint][focus] .smart-hint {
    opacity: 1
}

.smart-numeric-text-box[radix-display-position=right]:not([spin-buttons]) .smart-numeric-text-box-radix-display,
.smart-numeric-text-box[radix-display-position=right][spin-buttons][spin-buttons-position=left] .smart-numeric-text-box-radix-display {
    border-left-width: 0;
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-numeric-text-box[disabled],
.smart-numeric-text-box[value=-Infinity] .smart-spin-buttons-container,
.smart-numeric-text-box[value=Infinity] .smart-spin-buttons-container,
.smart-numeric-text-box[value=NaN] .smart-spin-buttons-container,
.smart-numeric-text-box[value=null] .smart-numeric-text-box-radix-display {
    cursor: default;
    opacity: .55
}

.smart-numeric-text-box[spin-buttons] input.smart-input {
    border-right-width: 0;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-numeric-text-box[radix-display] input.smart-input {
    width: 88%;
    width: calc(100% - var(--smart-numeric-text-box-default-radix-display-width))
}

.smart-numeric-text-box[show-unit] input.smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-numeric-text-box-default-unit-display-width))
}

.smart-numeric-text-box[spin-buttons][radix-display] input.smart-input {
    width: calc(88% - 27px);
    width: calc(100% - var(--smart-editor-addon-width) - var(--smart-numeric-text-box-default-radix-display-width))
}

.smart-numeric-text-box[spin-buttons][show-unit] input.smart-input {
    width: calc(100% - 54px);
    width: calc(100% - var(--smart-editor-addon-width) - var(--smart-numeric-text-box-default-unit-display-width))
}

.smart-numeric-text-box[radix-display][show-unit] input.smart-input {
    width: calc(88% - 27px);
    width: calc(100% - var(--smart-numeric-text-box-default-radix-display-width) - var(--smart-numeric-text-box-default-unit-display-width))
}

.smart-numeric-text-box[spin-buttons][radix-display][show-unit] input.smart-input {
    width: calc(88% - 54px);
    width: calc(100% - var(--smart-numeric-text-box-default-unit-display-width) - var(--smart-editor-addon-width) - var(--smart-numeric-text-box-default-radix-display-width))
}

.smart-numeric-text-box[spin-buttons] .smart-spin-buttons-container {
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-numeric-text-box[spin-buttons][spin-buttons-position=left] .smart-spin-buttons-container {
    border-right-width: 0
}

.smart-numeric-text-box[spin-buttons][spin-buttons-position=left] input.smart-input {
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-numeric-text-box[spin-buttons][spin-buttons-position=left][show-unit] input.smart-input {
    border-right-width: 0
}

.smart-numeric-text-box[spin-buttons][spin-buttons-position=left][show-unit] .smart-numeric-text-box-unit-display {
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-numeric-text-box[show-unit] input.smart-input,
.smart-numeric-text-box[spin-buttons][show-unit] .smart-numeric-text-box-unit-display {
    border-right-width: 0
}

.smart-numeric-text-box[show-unit] .smart-numeric-text-box-unit-display {
    border-right-width: 1px;
    border-right-width: var(--smart-border-width)
}

.smart-numeric-text-box.underlined {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0 0 1px
}

.smart-numeric-text-box.underlined input {
    border-width: 0 0 1px
}

.smart-numeric-text-box.underlined input:focus {
    border: none
}

.smart-numeric-text-box.underlined .smart-drop-down-button,
.smart-numeric-text-box.underlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-radius: 0;
    border-width: 0 0 1px
}

.smart-numeric-text-box.underlined .smart-drop-down-button[active],
.smart-numeric-text-box.underlined .smart-drop-down-button[hover],
.smart-numeric-text-box.underlined .smart-spin-button[active],
.smart-numeric-text-box.underlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-numeric-text-box.underlined .smart-hint {
    bottom: 0;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block !important;
    font-size: 75%;
    left: 0;
    margin-top: -14px;
    margin-top: calc(0px - var(--smart-font-size));
    opacity: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: color .2s, font-size .2s, line-height .2s, margin-top .2s, opacity .1s, top .2s
}

.smart-numeric-text-box.underlined .smart-hint:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    bottom: -2px;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: bottom center;
    transform-origin: bottom center;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s;
    width: 100%
}

.smart-numeric-text-box.underlined:not([focus]) .smart-hint {
    margin-top: 0
}

.smart-numeric-text-box.underlined[focus] .smart-drop-down-button {
    border-bottom-color: transparent;
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-numeric-text-box.underlined[focus] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-numeric-text-box.underlined[focus] .smart-hint:after {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-numeric-text-box.underlined[focus] .smart-spin-button {
    border-bottom-color: transparent
}

.smart-numeric-text-box.outlined {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    height: auto;
    min-height: 0
}

.smart-numeric-text-box.outlined input {
    border: 0;
    display: block;
    padding: 14px 0
}

.smart-numeric-text-box.outlined .smart-drop-down-button,
.smart-numeric-text-box.outlined .smart-spin-button {
    background: #fefefe;
    background: var(--smart-background);
    border-width: 0
}

.smart-numeric-text-box.outlined .smart-drop-down-button[active],
.smart-numeric-text-box.outlined .smart-drop-down-button[hover],
.smart-numeric-text-box.outlined .smart-spin-button[active],
.smart-numeric-text-box.outlined .smart-spin-button[hover] {
    background: #fefefe;
    background: var(--smart-background);
    color: #005c99;
    color: var(--smart-ui-state-active)
}

.smart-numeric-text-box.outlined .smart-drop-down-button {
    padding: 8px 0
}

.smart-numeric-text-box.outlined .smart-hint {
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: text;
    display: flex !important;
    font-size: 75%;
    left: 0;
    line-height: 15px;
    margin-top: -6px;
    max-height: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    transition: color .2s, font-size .2s, opacity .1s, font-size .2s, line-height .2s;
    width: 100%
}

.smart-numeric-text-box.outlined .smart-hint:after,
.smart-numeric-text-box.outlined .smart-hint:before {
    border-top: 1px solid;
    border-top-color: #e0e0e0 !important;
    border-top-color: var(--smart-border) !important;
    box-shadow: inset 0 1px transparent;
    box-sizing: border-box;
    content: "";
    display: block;
    height: 8px;
    margin-top: 6px;
    min-width: 10px;
    pointer-events: none;
    transition: border-color .2s, box-shadow .2s
}

.smart-numeric-text-box.outlined .smart-hint:before {
    border-left: 1px solid transparent;
    border-radius: 4px 0;
    border-radius: var(--smart-border-radius) 0;
    margin-right: 4px
}

.smart-numeric-text-box.outlined .smart-hint:after {
    border-radius: 0 4px;
    border-radius: 0 var(--smart-border-radius);
    border-right: 1px solid transparent;
    flex-grow: 1;
    margin-left: 4px
}

.smart-numeric-text-box.outlined:not([focus]) .smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 48px;
    opacity: 0
}

.smart-numeric-text-box.outlined[focus] {
    border-color: #005c99;
    border-color: var(--smart-primary);
    border-top-color: transparent !important
}

.smart-numeric-text-box.outlined[focus] .smart-drop-down-button {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-numeric-text-box.outlined[focus] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.smart-numeric-text-box.outlined[focus] .smart-hint:after,
.smart-numeric-text-box.outlined[focus] .smart-hint:before {
    border-top-color: #005c99 !important;
    border-top-color: var(--smart-primary) !important
}

.smart-numeric-text-box-radix-display {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    justify-content: center;
    width: 12%;
    width: var(--smart-numeric-text-box-default-radix-display-width)
}

.smart-numeric-text-box-radix-display,
.smart-numeric-text-box-unit-display {
    align-items: center;
    cursor: default;
    display: flex
}

.smart-numeric-text-box-drop-down {
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: auto;
    list-style-type: none;
    opacity: 1;
    padding: 2px;
    position: absolute;
    top: 100%;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    z-index: 9999
}

.smart-numeric-text-box-drop-down .smart-list-item {
    border: 1px solid transparent;
    cursor: pointer;
    margin: 1px;
    padding: 4px 8px;
    word-break: break-all
}

.smart-numeric-text-box-drop-down .smart-list-item:hover,
.smart-numeric-text-box-drop-down .smart-list-item[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-numeric-text-box-drop-down.smart-visibility-hidden {
    opacity: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-numeric-text-box-drop-down.smart-drop-down-repositioned:not([animation=none]) {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-numeric-text-box-pressed-component {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-numeric-text-box[right-to-left]>.smart-container {
    direction: ltr
}

smart-numeric-text-box[right-to-left] .smart-hint,
smart-numeric-text-box[right-to-left] .smart-label,
smart-numeric-text-box[right-to-left] .smart-numeric-text-box-drop-down,
smart-numeric-text-box[right-to-left] .smart-numeric-text-box-radix-display,
smart-numeric-text-box[right-to-left] input.smart-input {
    direction: rtl
}

smart-numeric-text-box[right-to-left] .smart-numeric-text-box-unit-display {
    direction: rtl;
    flex-direction: row-reverse
}

.smart-numeric-text-box-drop-down.smart-drop-down-repositioned[right-to-left] {
    direction: rtl
}

.smart-pager-middle-buttons-container {
    height: 100%;
    order: 1
}

.smart-pager-far-buttons-container {
    height: 100%;
    order: 2
}

.smart-pager-far-buttons-container.near {
    order: 0
}

.smart-pager-far-buttons-container.far {
    order: 2
}

.smart-pager-input-and-label-container {
    order: 3
}

.smart-pager-input-and-label-container.near {
    order: -2
}

.smart-pager-size-selector-and-label-container {
    order: 4
}

.smart-pager-size-selector-and-label-container.near {
    order: -1
}

.smart-pager-summary-container {
    order: 5
}

.smart-pager-summary-container.near {
    order: -2
}

.smart-pager-near-buttons-container {
    height: 100%;
    order: 0
}

.smart-pager-near-buttons-container.near {
    order: 0
}

.smart-pager-near-buttons-container.far {
    order: 2
}

smart-pager {
    --smart-item-border-radius: 100%;
    --smart-item-border-top-left-radius: 100%;
    --smart-item-border-top-right-radius: 100%;
    --smart-item-border-bottom-left-radius: 100%;
    --smart-item-border-bottom-right-radius: 100%;
    height: 48px;
    height: var(--smart-pager-default-height);
    justify-content: center;
    min-width: 300px;
    padding: 2px;
    padding: var(--smart-pager-padding)
}

smart-pager.smart-element {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-radius: 0;
    color: #323232;
    color: var(--smart-surface-color);
    overflow: visible
}

smart-pager:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-pager.smart-container,
smart-pager>.smart-container {
    align-items: center;
    display: flex;
    flex-direction: row
}

smart-pager .smart-pager-far-buttons-container,
smart-pager .smart-pager-input-and-label-container,
smart-pager .smart-pager-middle-buttons-container,
smart-pager .smart-pager-near-buttons-container,
smart-pager .smart-pager-size-selector-and-label-container,
smart-pager .smart-pager-summary-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 4px
}

smart-pager .smart-pager-page-index-selectors-container {
    align-items: center;
    color: var(--smart-pager-color);
    display: flex;
    height: 100%;
    outline: 0;
    width: auto
}

smart-pager .smart-pager-page-index-selectors-container:focus .smart-pager-page-index-selector[selected] {
    text-decoration: underline
}

smart-pager .smart-pager-label {
    align-items: center;
    border: none;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

smart-pager .smart-pager-button,
smart-pager .smart-pager-page-index-selector {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    display: flex;
    font-family: inherit;
    font-size: inherit;
    overflow: hidden;
    position: relative
}

smart-pager .smart-pager-label span {
    padding: 2px
}

smart-pager .smart-pager-button {
    align-items: center;
    height: 32px;
    height: var(--smart-pager-button-height);
    justify-content: center;
    width: "auto";
    width: var(--smart-pager-button-width)
}

smart-pager .smart-pager-button:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-pager .smart-pager-button:active {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-pager .smart-pager-button:active .smart-ripple {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active)
}

smart-pager .smart-pager-button[disabled] {
    opacity: .55
}

smart-pager .smart-pager-button .smart-ripple {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active)
}

smart-pager .smart-pager-page-index-selector {
    align-items: center;
    cursor: pointer;
    flex-grow: 1;
    height: 32px;
    height: var(--smart-pager-page-index-selector-height);
    justify-content: center;
    margin-left: 8px;
    margin-left: var(--smart-pager-page-index-selector-horizontal-offset);
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 32px;
    width: var(--smart-pager-page-index-selector-width)
}

smart-pager .smart-pager-page-index-selector:first-child {
    margin-left: -1px
}

smart-pager .smart-pager-page-index-selector:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-pager .smart-pager-page-index-selector .smart-ripple,
smart-pager .smart-pager-page-index-selector[selected] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active)
}

smart-pager .smart-pager-page-index-selector[selected] {
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-pager .smart-pager-page-index-selector[selected] .smart-ripple {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active)
}

smart-pager .smart-page-size-selector,
smart-pager .smart-pager-input {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-pager .smart-next-ellipsis-button,
smart-pager .smart-previous-ellipsis-button {
    height: 32px;
    height: var(--smart-pager-page-index-ellipsis-selector-height);
    width: 32px;
    width: var(--smart-pager-page-index-ellipsis-selector-width)
}

smart-pager .smart-page-size-selector {
    --smart-item-border-top-left-radius: var(--smart-border-radius);
    --smart-item-border-top-right-radius: var(--smart-border-radius);
    --smart-item-border-bottom-left-radius: var(--smart-border-radius);
    --smart-item-border-bottom-right-radius: var(--smart-border-radius);
    width: 60px;
    width: var(--smart-pager-page-size-selector-width)
}

smart-pager .smart-pager-input {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    box-sizing: border-box;
    height: 30px;
    height: var(--smart-text-box-default-height);
    margin: 0 5px;
    padding: 0 4px;
    padding: 0 var(--smart-editor-label-padding);
    width: 50px;
    width: var(--smart-pager-input-width)
}

smart-pager:not([show-navigation-button-labels]) .smart-pager-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    width: 32px;
    width: var(--smart-pager-page-index-selector-width)
}

smart-pager[disabled] .smart-pager-page-index-selector {
    cursor: default;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-pager[right-to-left] .smart-pager-far-buttons-container,
smart-pager[right-to-left] .smart-pager-input-and-label-container,
smart-pager[right-to-left] .smart-pager-label,
smart-pager[right-to-left] .smart-pager-middle-buttons-container,
smart-pager[right-to-left] .smart-pager-near-buttons-container,
smart-pager[right-to-left] .smart-pager-page-index-selectors-container,
smart-pager[right-to-left] .smart-pager-size-selector-and-label-container,
smart-pager[right-to-left]>.smart-container {
    flex-direction: row-reverse
}

smart-pager[right-to-left] .smart-arrow-left-first:after,
smart-pager[right-to-left] .smart-arrow-left:after,
smart-pager[right-to-left] .smart-arrow-right-last:after,
smart-pager[right-to-left] .smart-arrow-right:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transform-origin: center;
    transform-origin: center
}

smart-pager[right-to-left] .smart-first-button,
smart-pager[right-to-left] .smart-last-button,
smart-pager[right-to-left] .smart-next-page-button,
smart-pager[right-to-left] .smart-pager-input,
smart-pager[right-to-left] .smart-pager-label,
smart-pager[right-to-left] .smart-pager-label>span,
smart-pager[right-to-left] .smart-pager-page-index-selector,
smart-pager[right-to-left] .smart-previous-page-button {
    direction: rtl
}

smart-password-text-box {
    display: block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    width: 250px;
    width: var(--smart-text-box-default-width)
}

smart-password-text-box.smart-element {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    overflow: visible
}

.smart-password-text-box>.smart-container {
    position: relative
}

.smart-password-text-box .smart-content,
.smart-password-text-box .smart-content .smart-input {
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-password-text-box .smart-content .smart-input::-ms-reveal {
    display: none
}

.smart-password-text-box .smart-password-icon {
    align-items: center;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: inherit;
    height: 100%;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 30px
}

.smart-password-text-box .smart-password-icon:after {
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-password-text-box .smart-password-icon.smart-hidden {
    display: none
}

.smart-password-text-box smart-tooltip {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit
}

.smart-password-text-box .smart-hint,
.smart-password-text-box .smart-label {
    display: none;
    position: absolute
}

.smart-password-text-box[hint] .smart-hint,
.smart-password-text-box[label] .smart-label {
    bottom: 100%;
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    vertical-align: baseline;
    vertical-align: initial;
    width: 100%
}

.smart-password-text-box[hint] .smart-hint {
    bottom: auto;
    opacity: 0;
    top: 100%;
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-password-text-box[hint][focus] .smart-hint {
    opacity: 1;
    transition: opacity .2s cubic-bezier(.4, 0, .2, 1)
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {
    @supports (-webkit-appearance:none) {

        .smart-password-text-box .smart-hint,
        .smart-password-text-box .smart-hint:after {
            transition-duration: .1s
        }
    }
}

.smart-password-text-box[show-password-strength] .smart-password-short input:focus,
.smart-password-text-box[show-password-strength]:focus .smart-password-short input {
    border-color: #b00020;
    border-color: var(--smart-error)
}

.smart-password-text-box[show-password-strength] .smart-password-weak input:focus,
.smart-password-text-box[show-password-strength]:focus .smart-password-weak input {
    border-color: orange
}

.smart-password-text-box[show-password-strength] .smart-password-far input:focus,
.smart-password-text-box[show-password-strength]:focus .smart-password-far input {
    border-color: #ff0
}

.smart-password-text-box[show-password-strength] .smart-password-good input:focus,
.smart-password-text-box[show-password-strength]:focus .smart-password-good input {
    border-color: #00bfff
}

.smart-password-text-box[show-password-strength] .smart-password-strong input:focus,
.smart-password-text-box[show-password-strength]:focus .smart-password-strong input {
    border-color: #8bc34a;
    border-color: var(--smart-success)
}

.smart-password-text-box[right-to-left] .smart-hint,
.smart-password-text-box[right-to-left] .smart-label,
.smart-password-text-box[right-to-left]>.smart-container {
    direction: rtl
}

.smart-password-text-box[right-to-left] smart-tooltip {
    direction: ltr
}

.smart-password-text-box[right-to-left] .smart-password-icon {
    left: 0;
    right: auto
}

.smart-pivot-table tfoot td,
.smart-pivot-table thead th {
    font-weight: 700
}

.smart-pivot-table thead th:not(:last-child):not(.last-visible) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table tbody tr td {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-pivot-table tbody tr.collapsed {
    height: 0
}

.smart-pivot-table tbody tr.collapsed td {
    border-top-color: transparent;
    border-top-width: 0;
    line-height: 0;
    padding-bottom: 0;
    padding-top: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-pivot-table tbody tr.no-height td {
    line-height: 0
}

.smart-pivot-table th.align-left>.wrapper {
    justify-content: flex-start
}

.smart-pivot-table th.align-center>.wrapper {
    justify-content: center
}

.smart-pivot-table th.align-right>.wrapper {
    justify-content: flex-end
}

.smart-pivot-table tr td {
    line-height: 23px;
    line-height: calc(var(--smart-table-row-height) - var(--smart-table-cell-padding)*2 - var(--smart-border-width));
    white-space: nowrap
}

.smart-pivot-table tr:last-child:not(:first-child) .smart-pivot-table-grouping-header,
.smart-pivot-table tr:last-child:not(:first-child) .smart-pivot-table-total-header {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table tr:not(:last-child) .smart-pivot-table-grouping-header,
.smart-pivot-table tr:not(:last-child) .smart-pivot-table-selection-header,
.smart-pivot-table tr:not(:last-child) .smart-pivot-table-total-header {
    border-bottom: none
}

.smart-pivot-table td.align-left {
    text-align: left
}

.smart-pivot-table td.align-center {
    text-align: center
}

.smart-pivot-table td.align-right {
    text-align: right
}

.smart-pivot-table td.sort-by {
    position: relative
}

.smart-pivot-table td.sort-by:before {
    align-items: center;
    content: "\\e83f";
    content: var(--smart-icon-up);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: flex-end;
    opacity: 0;
    position: absolute;
    right: 12px;
    right: var(--smart-table-cell-padding);
    top: 0;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    visibility: hidden
}

.smart-pivot-table td.sort-by.asc:before,
.smart-pivot-table td.sort-by.desc:before {
    opacity: 1;
    visibility: visible
}

.smart-pivot-table td[selection-detail]:before {
    -webkit-font-feature-settings: "smcp";
    font-feature-settings: "smcp";
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color);
    content: attr(selection-detail);
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-variant: small-caps;
    left: 0;
    opacity: .8;
    padding: 3px;
    pointer-events: none;
    position: absolute;
    top: 100%
}

.smart-pivot-table td[selection-detail][detail-position-x=right]:before {
    left: unset;
    right: 0
}

.smart-pivot-table td[selection-detail][detail-position-y=top]:before {
    top: 0;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-pivot-table .smart-pivot-table-main-container {
    height: 100%;
    overflow: auto;
    width: 100%
}

.smart-pivot-table .smart-pivot-table-main-container.prevent-scroll {
    overflow: hidden
}

.smart-pivot-table .smart-pivot-table-selection-header {
    border-top: none
}

.smart-pivot-table .smart-pivot-table-total-header {
    border-top: none;
    width: 200px;
    width: var(--smart-pivot-table-cell-width)
}

.smart-pivot-table .smart-pivot-table-grouping-header {
    border-top: none;
    width: 250px;
    width: var(--smart-pivot-table-secondary-group-width)
}

.smart-pivot-table .smart-pivot-table-toolbar {
    border: none;
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    display: none;
    height: 48px;
    height: var(--smart-table-row-height)
}

.smart-pivot-table .smart-pivot-table-toolbar smart-breadcrumb .smart-breadcrumb-items .smart-breadcrumb-item {
    height: calc(100% - 10px);
    height: calc(100% - var(--smart-breadcrumb-padding))
}

.smart-pivot-table .smart-pivot-table-row-group-breadcrumb:before {
    content: "\\e806";
    content: var(--smart-icon-align-left);
    -webkit-transform: scale(-1);
    transform: scale(-1)
}

.smart-pivot-table:not([right-to-left]) td.sort-by.desc:before,
.smart-pivot-table[right-to-left] td.sort-by.asc:before {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg)
}

.smart-pivot-table .smart-pivot-table-pivot-breadcrumb {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-radius: 0
}

.smart-pivot-table .smart-pivot-table-pivot-breadcrumb:before {
    content: "\\e819";
    content: var(--smart-icon-refresh)
}

.smart-pivot-table .empty {
    border-top: none
}

.smart-pivot-table .total-arrow {
    cursor: pointer;
    display: inline-flex;
    height: 16px;
    height: var(--smart-table-arrow-size);
    margin-left: 5px;
    margin-left: var(--smart-table-arrow-margin);
    width: 16px;
    width: var(--smart-table-arrow-size)
}

.smart-pivot-table .total-arrow:focus {
    border: 1px solid #333;
    border: 1px solid var(--smart-ui-state-color-focus);
    border-radius: 50%;
    color: #333;
    color: var(--smart-ui-state-color-focus);
    outline: 0
}

.smart-pivot-table .smart-pivot-panel {
    border-bottom: none;
    border-right: none;
    border-top: none;
    height: 100%;
    width: 100%
}

.smart-pivot-table smart-breadcrumb {
    border: none;
    height: 100%;
    padding-left: 30px;
    padding-left: calc(var(--smart-breadcrumb-padding)*3);
    position: relative;
    width: unset
}

.smart-pivot-table smart-breadcrumb:before {
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    width: 30px;
    width: calc(var(--smart-breadcrumb-padding)*3)
}

.smart-pivot-table smart-breadcrumb>.smart-container {
    position: relative
}

.smart-pivot-table smart-breadcrumb>.smart-container.drop-target:after {
    border: 2px dashed #005c99;
    border: 2px dashed var(--smart-primary);
    box-sizing: border-box;
    content: "";
    height: calc(100% + 10px);
    height: calc(100% + var(--smart-breadcrumb-padding));
    left: -30px;
    left: calc(var(--smart-breadcrumb-padding)*-3);
    position: absolute;
    top: 0;
    width: calc(100% + 40px);
    width: calc(100% + var(--smart-breadcrumb-padding)*4)
}

.smart-pivot-table smart-breadcrumb .smart-breadcrumb-items,
.smart-pivot-table smart-breadcrumb .smart-template-container {
    height: 100%
}

.smart-pivot-table smart-breadcrumb .smart-breadcrumb-item {
    height: calc(100% - 10px);
    height: calc(100% - var(--smart-breadcrumb-padding))
}

.smart-pivot-table smart-breadcrumb .smart-breadcrumb-placeholder {
    font-style: italic;
    left: 0;
    position: absolute;
    top: 10px;
    top: var(--smart-breadcrumb-padding)
}

.smart-pivot-table [selection-detail] {
    overflow: visible;
    position: relative;
    z-index: 1
}

.smart-pivot-table:not([animation=none]) tbody tr {
    transition: height .2s ease-in-out
}

.smart-pivot-table:not([animation=none]) tr td {
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, border-top-color .2s ease-in-out, -webkit-transform .2s ease-in-out;
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, transform .2s ease-in-out, border-top-color .2s ease-in-out;
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, transform .2s ease-in-out, border-top-color .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-pivot-table:not([designer]) .smart-pivot-table-designer-container {
    display: none
}

.smart-pivot-table[group-layout=classic] .smart-pivot-table-grouping-header {
    width: 150px;
    width: calc(var(--smart-pivot-table-cell-width)*.75)
}

.smart-pivot-table[group-layout=classic] tbody td.expanded:not(.main)+td[data-field^=group]:not(.main),
.smart-pivot-table[group-layout=classic] tbody td:not(.expanded)+td[data-field^=group]:not(.main) {
    font-size: 0
}

.smart-pivot-table[group-layout=classic] .hierarchy-arrow:after {
    content: "\\e803";
    content: var(--smart-icon-plus)
}

.smart-pivot-table[group-layout=classic] td.expanded .hierarchy-arrow:after {
    content: "\\e804";
    content: var(--smart-icon-minus)
}

.smart-pivot-table[designer]>.smart-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    grid-template-columns: 1fr var(--smart-pivot-panel-width);
    grid-template-rows: 100%
}

.smart-pivot-table[designer] .smart-pivot-table-designer-container {
    display: block;
    height: 100%
}

.smart-pivot-table[designer-position=near]>.smart-container {
    grid-template-columns: 300px 1fr;
    grid-template-columns: var(--smart-pivot-panel-width) 1fr
}

.smart-pivot-table[designer-position=near] .smart-pivot-table-main-container {
    order: 1
}

.smart-pivot-table[designer-position=near]:not([right-to-left]) .smart-pivot-panel {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table[toolbar]>.smart-container {
    display: flex;
    flex-direction: column
}

.smart-pivot-table[toolbar] .smart-pivot-table-main-container {
    grid-area: main;
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-table-row-height))
}

.smart-pivot-table[toolbar] .smart-pivot-table-toolbar {
    grid-gap: 10px;
    grid-gap: var(--smart-pivot-panel-padding);
    display: grid;
    gap: 10px;
    gap: var(--smart-pivot-panel-padding);
    grid-area: toolbar;
    grid-template-columns: 1fr 1fr 48px 48px;
    grid-template-columns: 1fr 1fr var(--smart-table-row-height) var(--smart-table-row-height)
}

.smart-pivot-table[toolbar] .smart-pivot-table-designer-container {
    grid-area: designer;
    max-height: unset;
    min-height: 0
}

.smart-pivot-table[toolbar][designer]>.smart-container {
    display: grid;
    grid-template-areas: "toolbar toolbar","main designer";
    grid-template-columns: 1fr 300px;
    grid-template-columns: 1fr var(--smart-pivot-panel-width);
    grid-template-rows: 48px 1fr;
    grid-template-rows: var(--smart-table-row-height) 1fr
}

.smart-pivot-table[toolbar][designer] .smart-pivot-table-toolbar {
    grid-template-columns: 1fr 1fr 48px;
    grid-template-columns: 1fr 1fr var(--smart-table-row-height)
}

.smart-pivot-table[toolbar][designer] .smart-table-toolbar-button.fields {
    display: none
}

.smart-pivot-table[toolbar][designer] .smart-pivot-table-main-container {
    height: 100%;
    width: 100%
}

.smart-pivot-table[toolbar][designer][designer-position=near]>.smart-container {
    grid-template-areas: "toolbar toolbar","designer main";
    grid-template-columns: 300px 1fr;
    grid-template-columns: var(--smart-pivot-panel-width) 1fr
}

.smart-pivot-table[selection][selection-mode=cell] tbody td {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-pivot-table[selection][selection-mode=cell] tbody td.selected {
    background-color: rgba(0, 92, 153, .8);
    background-color: rgba(var(--smart-primary-rgb), .8);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-pivot-table[right-to-left] thead th:not(:last-child) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: none
}

.smart-pivot-table[right-to-left] .smart-pivot-table-pivot-breadcrumb,
.smart-pivot-table[right-to-left]:not([designer-position=near]) .smart-pivot-panel {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table[right-to-left] th.expanded .total-arrow {
    -webkit-transform: none;
    transform: none
}

.smart-pivot-table[right-to-left] smart-breadcrumb {
    padding-left: 10px;
    padding-left: var(--smart-breadcrumb-padding);
    padding-right: 30px;
    padding-right: calc(var(--smart-breadcrumb-padding)*3)
}

.smart-pivot-panel .smart-accordion smart-accordion-item .smart-accordion-item-content,
.smart-pivot-panel smart-accordion-item .smart-content-container {
    padding: 0
}

.smart-pivot-table[right-to-left] smart-breadcrumb:before {
    left: unset;
    right: 0
}

.smart-pivot-table[right-to-left] .total-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-pivot-table[right-to-left][selection]:not([selection-mode=cell]) thead th:first-child {
    border-left: none
}

.smart-table[column-reorder] th[data-field].smart-pivot-table-total-header,
.smart-table[column-reorder][column-totals] th[data-field] {
    cursor: unset
}

.smart-table[freeze-header] thead tr:nth-child(4)>th {
    top: 168px;
    top: calc(var(--smart-table-column-header-height)*3)
}

.smart-table[freeze-header] thead tr:nth-child(5)>th {
    top: 224px;
    top: calc(var(--smart-table-column-header-height)*4)
}

.smart-table[freeze-header] thead tr:nth-child(6)>th {
    top: 280px;
    top: calc(var(--smart-table-column-header-height)*5)
}

.smart-table[freeze-header] thead tr:nth-child(7)>th {
    top: 336px;
    top: calc(var(--smart-table-column-header-height)*6)
}

.smart-table[freeze-header] thead tr:nth-child(8)>th {
    top: 392px;
    top: calc(var(--smart-table-column-header-height)*7)
}

.smart-table[freeze-header] thead tr:nth-child(9)>th {
    top: 448px;
    top: calc(var(--smart-table-column-header-height)*8)
}

.smart-table[freeze-header] thead tr:nth-child(10)>th {
    top: 504px;
    top: calc(var(--smart-table-column-header-height)*9)
}

.smart-table-window.drill-down {
    --smart-window-default-width: 750px;
    --smart-window-footer-padding: 0;
    --smart-window-footer-height: 0px
}

.smart-table-window.drill-down .smart-content-container>.smart-content>div {
    grid-gap: 10px;
    grid-gap: var(--smart-pivot-panel-padding);
    display: grid;
    gap: 10px;
    gap: var(--smart-pivot-panel-padding);
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr;
    height: 100%;
    width: 100%
}

.smart-table-window.drill-down .drill-down-details,
.smart-table-window[right-to-left].fields smart-pivot-panel .smart-pivot-panel-tab-item {
    display: flex
}

.smart-table-window.drill-down .smart-content strong {
    margin-left: 3.33333px;
    margin-left: calc(var(--smart-pivot-panel-padding)/3);
    margin-right: 10px;
    margin-right: var(--smart-pivot-panel-padding)
}

.smart-table-window.drill-down smart-table {
    min-height: 0
}

.smart-table-window.fields {
    --smart-window-footer-padding: 0;
    --smart-window-footer-height: 0px;
    --smart-window-default-width: 600px;
    --smart-window-default-height: 800px
}

.smart-table-window.fields smart-pivot-panel {
    height: 100%;
    width: 100%
}

.smart-table-window.fields smart-pivot-panel>.smart-container {
    grid-template-columns: unset;
    grid-template-rows: auto 1fr
}

.smart-table-window.fields smart-pivot-panel>.smart-container>div:first-child {
    order: 1
}

.smart-table-window.fields smart-pivot-panel>.smart-container>div:nth-child(2) {
    order: 0
}

.smart-table-window.fields smart-pivot-panel .smart-filter-panel .smart-filter-panel-button-container>smart-button {
    width: 40%
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-columns-view {
    grid-template-rows: 2fr 1fr 1fr 1fr
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tabs {
    border-left: none;
    -webkit-writing-mode: unset;
    -ms-writing-mode: unset;
    writing-mode: unset
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item {
    border-bottom-width: 2px;
    border-bottom-width: calc(var(--smart-border-width)*2);
    border-left-color: transparent;
    border-left-width: 1px;
    border-left-width: var(--smart-border-width);
    height: auto
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item:first-child {
    margin-right: 10px;
    margin-right: var(--smart-pivot-panel-padding);
    margin-top: 0
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item:focus {
    border-color: #333;
    border-color: var(--smart-ui-state-color-focus)
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item.selected {
    border-bottom-color: #005c99;
    border-bottom-color: var(--smart-primary)
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item.selected:focus {
    border-color: #333 #333 #005c99;
    border-color: var(--smart-ui-state-color-focus) var(--smart-ui-state-color-focus) var(--smart-primary)
}

.smart-table-window.fields smart-pivot-panel .smart-pivot-panel-tab-item .icon {
    margin-bottom: 0;
    margin-right: 3px
}

.smart-table-window.fields:not([animation=none]) smart-pivot-panel .smart-pivot-panel-tab-item {
    transition: border-bottom-color .3s ease-out
}

.smart-table-window[right-to-left].drill-down .smart-content strong {
    margin-left: 10px;
    margin-left: var(--smart-pivot-panel-padding);
    margin-right: 3.33333px;
    margin-right: calc(var(--smart-pivot-panel-padding)/3)
}

.smart-table-window[right-to-left].fields smart-pivot-panel .smart-pivot-panel-tab-item,
.smart-table-window[right-to-left].fields smart-pivot-panel .smart-pivot-panel-tabs {
    flex-direction: row-reverse
}

.smart-table-window[right-to-left].fields smart-pivot-panel .smart-pivot-panel-tab-item:first-child {
    margin-left: 10px;
    margin-left: var(--smart-pivot-panel-padding);
    margin-right: 0
}

.smart-table-window[right-to-left].fields smart-pivot-panel .smart-pivot-panel-tab-item .icon {
    margin-left: 3px;
    margin-right: 0
}

.smart-pivot-panel .smart-pivot-panel-label .icon,
.smart-pivot-panel smart-tree-item .settings-icon {
    margin-right: 5px;
    margin-right: calc(var(--smart-pivot-panel-padding)/2)
}

.smart-window.smart-table-window.drill-down .smart-content-container>.smart-footer,
.smart-window.smart-table-window.fields .smart-content-container>.smart-footer {
    display: none
}

.smart-pivot-panel {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    height: 800px;
    height: var(--smart-pivot-panel-default-height);
    width: 300px;
    width: var(--smart-pivot-panel-width)
}

.smart-pivot-panel>.smart-container {
    display: grid;
    grid-template-columns: 1fr auto;
    min-height: 0;
    min-width: 0
}

.smart-pivot-panel>.smart-container>div:first-child {
    min-height: 0
}

.smart-pivot-panel>.smart-container .check-box {
    left: unset;
    position: relative;
    -webkit-transform: none;
    transform: none
}

.smart-pivot-panel smart-accordion-item.filtered .smart-label {
    color: #005c99;
    color: var(--smart-primary);
    position: relative
}

.smart-pivot-panel .icon:before,
.smart-pivot-panel smart-accordion-item.filtered .smart-label:before,
.smart-pivot-panel smart-tree-item .settings-icon:before {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    color: inherit;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    text-decoration: inherit
}

.smart-pivot-panel smart-accordion-item.filtered .smart-label:before {
    align-items: center;
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    display: flex;
    flex-wrap: wrap;
    font-style: normal;
    justify-content: center;
    position: absolute;
    right: calc(100% + 5px);
    right: calc(100% + var(--smart-pivot-panel-padding)/2);
    text-transform: none;
    width: 16px
}

.smart-pivot-panel smart-tree-item .settings-icon:before {
    align-items: center;
    content: "\\e833";
    content: var(--smart-icon-settings);
    display: flex;
    flex-wrap: wrap;
    font-style: normal;
    justify-content: center;
    position: relative;
    text-transform: none;
    width: 100%
}

.smart-pivot-panel smart-accordion,
.smart-pivot-panel smart-filter-panel {
    height: 100%;
    width: 100%
}

.smart-pivot-panel smart-filter-panel>.smart-container {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-pivot-panel-padding);
    display: grid;
    grid-template-rows: auto 1fr auto;
    row-gap: 10px;
    row-gap: var(--smart-pivot-panel-padding)
}

.smart-pivot-panel smart-filter-panel>.smart-container>div:nth-child(2) {
    min-height: 0
}

.smart-pivot-panel smart-filter-panel>.smart-container smart-tree {
    height: 100%
}

.smart-pivot-panel smart-tree.smart-element {
    visibility: inherit
}

.smart-pivot-panel smart-tree:focus {
    border-color: #333;
    border-color: var(--smart-ui-state-color-focus)
}

.smart-pivot-panel .icon:before {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-style: normal;
    justify-content: center;
    position: relative;
    text-transform: none;
    width: 100%
}

.smart-pivot-panel .smart-pivot-panel-tabs {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    display: flex;
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-pivot-panel .smart-pivot-panel-tab-item {
    align-items: center;
    border: 1px solid transparent;
    border-left: calc(var(--smart-border-width)*2) solid transparent;
    cursor: pointer;
    display: flex;
    height: 150px;
    height: var(--smart-pivot-panel-tab-item-height);
    justify-content: center;
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-pivot-panel-padding);
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-pivot-panel .smart-pivot-panel-tab-item:first-child {
    margin-top: 10px;
    margin-top: var(--smart-pivot-panel-padding)
}

.smart-pivot-panel .smart-pivot-panel-tab-item:first-child .icon:before {
    content: "\\e800";
    content: var(--smart-icon-table)
}

.smart-pivot-panel .smart-pivot-panel-tab-item:nth-child(2) .icon:before {
    content: "\\f0b0";
    content: var(--smart-icon-filter)
}

.smart-pivot-panel .smart-pivot-panel-tab-item:hover {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-pivot-panel .smart-pivot-panel-tab-item:focus {
    border-color: #333;
    border-color: var(--smart-ui-state-color-focus);
    outline: 0
}

.smart-pivot-panel .smart-pivot-panel-tab-item.selected {
    border-left-color: #005c99;
    border-left-color: var(--smart-primary)
}

.smart-pivot-panel .smart-pivot-panel-tab-item.selected:focus {
    border-color: #333 #333 #333 #005c99;
    border-color: var(--smart-ui-state-color-focus) var(--smart-ui-state-color-focus) var(--smart-ui-state-color-focus) var(--smart-primary)
}

.smart-pivot-panel .smart-pivot-panel-tab-item .icon {
    margin-bottom: 3px
}

.smart-pivot-panel .smart-pivot-panel-columns-view {
    display: grid;
    grid-template-rows: 3fr 1fr 1fr 1fr;
    height: 100%;
    min-height: 0;
    min-width: 0;
    width: 100%
}

.smart-pivot-panel .smart-pivot-panel-columns-view smart-tree {
    border-color: transparent;
    height: 100%;
    width: 100%
}

.smart-pivot-panel .smart-pivot-panel-active-columns {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    display: grid;
    grid-template-rows: auto 1fr;
    min-height: 0;
    min-width: 0
}

.smart-pivot-panel .smart-pivot-panel-active-columns smart-tree-item .smart-tree-item-label-element>span {
    display: flex
}

.smart-pivot-panel .smart-pivot-panel-label {
    background: #005c99;
    background: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    padding: 10px;
    padding: var(--smart-pivot-panel-padding)
}

.smart-pivot-panel .smart-pivot-panel-row-groups-label .icon:before {
    content: "\\e806";
    content: var(--smart-icon-align-left);
    -webkit-transform: scale(-1);
    transform: scale(-1)
}

.smart-pivot-panel .smart-pivot-panel-summaries-label .icon:before {
    content: "\\f01a";
    content: var(--smart-icon-math)
}

.smart-pivot-panel .smart-pivot-panel-pivots-label .icon:before {
    content: "\\e819";
    content: var(--smart-icon-refresh)
}

.smart-pivot-panel .smart-pivot-panel-columns-container {
    min-height: 0;
    overflow: auto
}

.smart-pivot-panel .smart-pivot-panel-filters-view {
    height: 100%
}

.smart-pivot-panel:not([animation=none]) .smart-pivot-panel-tab-item {
    transition: border-left-color .3s ease-out
}

.smart-pivot-panel[inverted]>.smart-container {
    grid-template-columns: auto 1fr
}

.smart-pivot-panel[inverted]>.smart-container>div:first-child {
    order: 1
}

.smart-pivot-panel[inverted] .smart-pivot-panel-tabs {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-panel[inverted] .smart-pivot-panel-tab-item {
    border-left: 1px solid transparent;
    border-right-width: 2px;
    border-right-width: calc(var(--smart-border-width)*2)
}

.smart-pivot-panel[inverted] .smart-pivot-panel-tab-item span:nth-child(2) {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-pivot-panel[inverted] .smart-pivot-panel-tab-item.selected {
    border-right-color: #005c99;
    border-right-color: var(--smart-primary)
}

.smart-pivot-panel[inverted] .smart-pivot-panel-tab-item.selected:focus {
    border-color: #333 #005c99 #333 #333;
    border-color: var(--smart-ui-state-color-focus) var(--smart-primary) var(--smart-ui-state-color-focus) var(--smart-ui-state-color-focus)
}

.smart-pivot-panel[inverted]:not([animation=none]) .smart-pivot-panel-tab-item {
    transition: border-right-color .3s ease-out
}

.smart-pivot-panel[right-to-left] {
    direction: ltr
}

.smart-pivot-panel[right-to-left] .smart-pivot-panel-tab-item>span:nth-child(2),
.smart-pivot-panel[right-to-left]>.smart-container>div:first-child {
    direction: rtl
}

.smart-pivot-panel[right-to-left] .smart-pivot-panel-label .icon,
.smart-pivot-panel[right-to-left] smart-tree-item .settings-icon {
    margin-left: 5px;
    margin-left: calc(var(--smart-pivot-panel-padding)/2);
    margin-right: 0
}

.smart-window.smart-pivot-window {
    --smart-window-default-height: 190px
}

.smart-window.smart-pivot-window .smart-content-container>.smart-content {
    grid-gap: 10px;
    grid-gap: var(--smart-pivot-panel-padding);
    display: grid;
    gap: 10px;
    gap: var(--smart-pivot-panel-padding);
    grid-auto-rows: -webkit-max-content;
    grid-auto-rows: max-content;
    grid-template-columns: minmax(175px, auto) 1fr;
    min-width: 0
}

.smart-window.smart-pivot-window .smart-content-container>.smart-footer {
    align-items: center;
    display: flex;
    justify-content: space-evenly
}

.smart-window.smart-pivot-window .smart-content-container>.smart-footer smart-button {
    --smart-button-padding: 0;
    height: 100%;
    width: 40%
}

.smart-window.smart-pivot-window .smart-content .category.label {
    font-weight: 700;
    grid-column-end: 3;
    grid-column-start: 1;
    text-decoration: underline
}

.smart-window.smart-pivot-window smart-input {
    width: 100%
}

.smart-window.smart-pivot-window.summary {
    --smart-window-default-height: 500px
}

.smart-window.smart-pivot-window:not(.summary) .summary {
    display: none
}

.smart-breadcrumb-feedback.cancel:after {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color);
    content: "\\e832";
    content: var(--smart-icon-block)
}

.smart-breadcrumb-feedback.delete:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-breadcrumb-feedback.pivot:after {
    content: "\\e819";
    content: var(--smart-icon-refresh)
}

.smart-breadcrumb-feedback.row-group:after {
    content: "\\e806";
    content: var(--smart-icon-align-left);
    -webkit-transform: scale(-1);
    transform: scale(-1)
}

.smart-breadcrumb-feedback.summary:after {
    content: "\\f01a";
    content: var(--smart-icon-math)
}

.smart-tree-item-feedback.forbidden {
    border-color: #b00020;
    border-color: var(--smart-error);
    color: #b00020;
    color: var(--smart-error)
}

.smart-tree-item-feedback.forbidden:before {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    content: "\\e832";
    content: var(--smart-icon-block);
    display: flex;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    margin-right: 5px;
    margin-right: calc(var(--smart-pivot-panel-padding)/2);
    position: relative;
    text-decoration: inherit;
    text-transform: none;
    width: 100%
}

.smart-power-button {
    border-radius: 100%;
    display: inline-block;
    height: 30px;
    height: var(--smart-power-button-default-width);
    padding: 0;
    width: 30px;
    width: var(--smart-power-button-default-width)
}

.smart-power-button .smart-input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 100%;
    border-width: 1px;
    box-sizing: border-box;
    display: block;
    height: 100%;
    min-height: 30px;
    min-height: var(--smart-power-button-default-width);
    min-width: 30px;
    min-width: var(--smart-power-button-default-width);
    outline: 0;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-power-button .smart-input:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    content: "\\e811";
    content: var(--smart-icon-power);
    display: flex;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-size: 20px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    text-decoration: inherit;
    text-transform: none;
    width: 100%
}

.smart-power-button .smart-container {
    cursor: pointer;
    display: flex;
    height: 100%;
    position: relative
}

.smart-power-button .smart-animation {
    pointer-events: none
}

.smart-power-button[focus] {
    outline: 0
}

.smart-power-button[focus] .smart-input {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    border: 1px solid #e2e0e0;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus);
    outline: 0
}

.smart-power-button:hover .smart-input {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    transition: background-color .1s linear
}

.smart-power-button:active .smart-input {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    transition: background-color .1s linear
}

.smart-power-button[disabled] .smart-container {
    cursor: auto
}

.smart-power-button[checked] .smart-input {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-power-button[checked] .smart-input:after {
    color: #fff
}

.smart-power-button[readonly].active .smart-input,
.smart-power-button[readonly]:active .smart-input,
.smart-power-button[readonly]:hover .smart-input {
    background: var(--smart-button-background);
    border: var(--smart-border-width) solid var(--smart-button-border);
    color: #000;
    color: initial;
    transition: none
}

smart-power-button.active .smart-input {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: var(--smart-border-width) solid var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    transition: background-color .1s linear
}

smart-power-button.raised {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2)
}

smart-power-button[right-to-left]>.smart-container>.smart-input {
    direction: rtl
}

smart-circular-progress-bar.smart-element,
smart-progress-bar.smart-element {
    border: none
}

smart-circular-progress-bar.smart-element:focus>.smart-container,
smart-progress-bar.smart-element:focus>.smart-container {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-circular-progress-bar.smart-container,
smart-circular-progress-bar>.smart-container,
smart-progress-bar.smart-container,
smart-progress-bar>.smart-container {
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    color: #5a5a5a;
    color: var(--smart-background-color);
    overflow: hidden;
    position: relative
}

smart-circular-progress-bar .smart-label,
smart-progress-bar .smart-label {
    color: #5a5a5a;
    color: var(--smart-background-color);
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

smart-circular-progress-bar[right-to-left] .smart-label,
smart-progress-bar[right-to-left] .smart-label {
    direction: rtl
}

smart-progress-bar {
    height: 30px;
    height: var(--smart-progress-bar-default-height);
    width: 250px;
    width: var(--smart-progress-bar-default-width)
}

smart-progress-bar .smart-label {
    color: #b2b2b2;
    color: var(--smart-outline);
    width: auto
}

smart-progress-bar .smart-value {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-ui-state-border-active);
    box-sizing: border-box;
    height: 100%;
    outline: 0;
    position: absolute;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 100%
}

smart-progress-bar .smart-value.smart-value-animation {
    -webkit-animation: indeterminate 3s linear infinite;
    animation: indeterminate 3s linear infinite
}

smart-progress-bar.primary .smart-value {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary)
}

smart-progress-bar.secondary .smart-value {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border: 1px solid #2d2d30;
    border: 1px solid var(--smart-secondary)
}

smart-progress-bar.success .smart-value {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    border: 1px solid #8bc34a;
    border: 1px solid var(--smart-success)
}

smart-progress-bar.info .smart-value {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    border: 1px solid #5cc0de;
    border: 1px solid var(--smart-info)
}

smart-progress-bar.warning .smart-value {
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    border: 1px solid #f0ad4e;
    border: 1px solid var(--smart-warning)
}

smart-progress-bar.error .smart-value {
    background-color: #b00020;
    background-color: var(--smart-error);
    border: 1px solid #b00020;
    border: 1px solid var(--smart-error)
}

smart-progress-bar.light .smart-value {
    background-color: #fff;
    background-color: var(--smart-light);
    border: 1px solid #fff;
    border: 1px solid var(--smart-light)
}

smart-progress-bar.dark .smart-value {
    background-color: #222;
    background-color: var(--smart-dark);
    border: 1px solid #222;
    border: 1px solid var(--smart-dark)
}

smart-progress-bar:not([animation=none]) .smart-value {
    transition: .2s ease-in-out
}

smart-progress-bar[inverted] .smart-value,
smart-progress-bar[orientation][inverted] .smart-value {
    -webkit-transform-origin: right;
    transform-origin: right
}

smart-progress-bar[inverted] .smart-value.smart-value-animation {
    -webkit-animation: indeterminate-inverted 3s linear infinite;
    animation: indeterminate-inverted 3s linear infinite
}

smart-progress-bar[orientation] .smart-value {
    -webkit-transform-origin: left;
    transform-origin: left
}

smart-progress-bar[orientation=vertical] {
    height: 250px;
    height: var(--smart-progress-bar-default-width);
    width: 30px;
    width: var(--smart-progress-bar-default-height)
}

smart-progress-bar[orientation=vertical][inverted] .smart-value {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom
}

smart-progress-bar[orientation=vertical] .smart-value {
    -webkit-transform-origin: left top;
    transform-origin: left top
}

smart-progress-bar[orientation=vertical] .smart-value.smart-value-animation {
    -webkit-animation: indeterminate-vertical 3s linear infinite;
    animation: indeterminate-vertical 3s linear infinite
}

smart-progress-bar[orientation=vertical] .smart-label {
    width: 100%
}

smart-progress-bar[inverted][orientation=vertical] .smart-value.smart-value-animation {
    -webkit-animation: indeterminate-vertical-inverted 3s linear infinite;
    animation: indeterminate-vertical-inverted 3s linear infinite
}

smart-progress-bar[right-to-left]:not([orientation=vertical]) .smart-value,
smart-progress-bar[right-to-left][orientation=horizontal] .smart-value {
    -webkit-transform-origin: right;
    transform-origin: right
}

smart-progress-bar[right-to-left]:not([orientation=vertical])[inverted] .smart-value,
smart-progress-bar[right-to-left][orientation=horizontal][inverted] .smart-value {
    -webkit-transform-origin: left;
    transform-origin: left
}

smart-progress-bar[right-to-left]:not([orientation=vertical]) .smart-value.smart-value-animation,
smart-progress-bar[right-to-left][orientation=horizontal] .smart-value.smart-value-animation {
    -webkit-animation: indeterminate-inverted 3s linear infinite;
    animation: indeterminate-inverted 3s linear infinite
}

smart-progress-bar[right-to-left][inverted]:not([orientation=vertical]) .smart-value.smart-value-animation,
smart-progress-bar[right-to-left][inverted][orientation=horizontal] .smart-value.smart-value-animation {
    -webkit-animation: indeterminate 3s linear infinite;
    animation: indeterminate 3s linear infinite
}

smart-circular-progress-bar {
    height: 250px;
    height: var(--smart-circular-progress-bar-default-size);
    width: 250px;
    width: var(--smart-circular-progress-bar-default-size)
}

smart-circular-progress-bar.smart-container,
smart-circular-progress-bar>.smart-container {
    border-radius: 50%
}

smart-circular-progress-bar .smart-value-animation-ms {
    stroke-dashoffset: 114
}

smart-circular-progress-bar svg:first-of-type {
    border-radius: 50%;
    pointer-events: none;
    position: absolute
}

smart-circular-progress-bar svg:first-of-type .smart-value.smart-value-animation {
    -webkit-animation: circle 2s linear infinite;
    animation: circle 2s linear infinite
}

smart-circular-progress-bar .smart-label-container {
    background-color: transparent;
    border-color: #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 50%;
    border-width: 1px;
    box-sizing: content-box;
    height: 80%;
    height: calc(100% - var(--smart-circular-progress-bar-fill-size));
    left: 50%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80%;
    width: calc(100% - var(--smart-circular-progress-bar-fill-size))
}

smart-circular-progress-bar .smart-value,
smart-circular-progress-bar .smart-value-path {
    stroke-width: 20%;
    stroke-width: var(--smart-circular-progress-bar-fill-size);
    fill: transparent;
    stroke-dasharray: 314.159
}

smart-circular-progress-bar .smart-value {
    stroke: #005c99;
    stroke: var(--smart-ui-state-active)
}

smart-circular-progress-bar .smart-value-path {
    stroke-dashoffset: 0;
    stroke: transparent
}

smart-circular-progress-bar.primary .smart-value {
    stroke: #005c99;
    stroke: var(--smart-primary)
}

smart-circular-progress-bar.secondary .smart-value {
    stroke: #2d2d30;
    stroke: var(--smart-secondary)
}

smart-circular-progress-bar.success .smart-value {
    stroke: #8bc34a;
    stroke: var(--smart-success)
}

smart-circular-progress-bar.info .smart-value {
    stroke: #5cc0de;
    stroke: var(--smart-info)
}

smart-circular-progress-bar.warning .smart-value {
    stroke: #f0ad4e;
    stroke: var(--smart-warning)
}

smart-circular-progress-bar.error .smart-value {
    stroke: #b00020;
    stroke: var(--smart-error)
}

smart-circular-progress-bar.light .smart-value {
    stroke: #fff;
    stroke: var(--smart-light)
}

smart-circular-progress-bar.dark .smart-value {
    stroke: #222;
    stroke: var(--smart-dark)
}

smart-circular-progress-bar:not([animation=none]) .smart-value {
    transition: stroke-dashoffset 1s linear
}

smart-circular-progress-bar[inverted] svg:first-of-type .smart-value.smart-value-animation {
    -webkit-animation: circle-inverted 2s linear infinite;
    animation: circle-inverted 2s linear infinite
}

smart-circular-progress-bar[indeterminate][inverted] svg:first-of-type,
smart-circular-progress-bar[value=null][inverted] svg:first-of-type {
    -webkit-animation: rotate-circle-inverted 1s linear infinite;
    animation: rotate-circle-inverted 1s linear infinite
}

smart-circular-progress-bar[indeterminate] svg:first-of-type,
smart-circular-progress-bar[value=null] svg:first-of-type {
    -webkit-animation: rotate-circle 1s linear infinite;
    animation: rotate-circle 1s linear infinite
}

smart-circular-progress-bar[right-to-left][inverted] svg:first-of-type .smart-value.smart-value-animation {
    -webkit-animation: circle 2s linear infinite;
    animation: circle 2s linear infinite
}

smart-circular-progress-bar[right-to-left] svg:first-of-type .smart-value.smart-value-animation {
    -webkit-animation: circle-inverted 2s linear infinite;
    animation: circle-inverted 2s linear infinite
}

smart-circular-progress-bar[right-to-left][indeterminate] svg:first-of-type,
smart-circular-progress-bar[right-to-left][value=null] svg:first-of-type {
    -webkit-animation: rotate-circle-inverted 1s linear infinite;
    animation: rotate-circle-inverted 1s linear infinite
}

smart-circular-progress-bar[right-to-left][indeterminate][inverted] svg:first-of-type,
smart-circular-progress-bar[right-to-left][value=null][inverted] svg:first-of-type {
    -webkit-animation: rotate-circle 1s linear infinite;
    animation: rotate-circle 1s linear infinite
}

.barber-shop-effect .smart-value {
    -webkit-animation: stripes 10s linear infinite;
    animation: stripes 10s linear infinite;
    -webkit-animation-direction: normal;
    animation-direction: normal;
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 75%, transparent 0, transparent);
    background-position: 0 -244rem;
    background-size: 5rem 5rem
}

.barber-shop-effect[inverted] .smart-value,
.barber-shop-effect[orientation=vertical] .smart-value,
.barber-shop-effect[right-to-left] .smart-value {
    animation-direction: reverse
}

.barber-shop-effect[right-to-left][inverted] .smart-value {
    -webkit-animation-direction: normal;
    animation-direction: normal
}

@-webkit-keyframes stripes {
    0% {
        background-position: 0 0
    }

    to {
        background-position: 60rem 0
    }
}

@keyframes stripes {
    0% {
        background-position: 0 0
    }

    to {
        background-position: 60rem 0
    }
}

@-webkit-keyframes indeterminate {
    0% {
        left: -100%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    20% {
        left: -40%;
        -webkit-transform: scaleX(.3);
        transform: scaleX(.3);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    35% {
        left: 35%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    50% {
        left: 75%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    55% {
        left: 100%;
        -webkit-transform: scaleX(.7);
        transform: scaleX(.7);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    55.99% {
        left: 100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    56% {
        left: -100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    56.99% {
        left: -100%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    75% {
        left: -5%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    80% {
        left: 30%;
        -webkit-transform: scaleX(.5);
        transform: scaleX(.5);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    85% {
        left: 50%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    90% {
        left: 75%;
        -webkit-transform: scaleX(.3);
        transform: scaleX(.3);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    95% {
        left: 95%;
        -webkit-transform: scaleX(.2);
        transform: scaleX(.2);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    98% {
        left: 100%;
        -webkit-transform: scaleX(.2);
        transform: scaleX(.2);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    99.99% {
        left: 100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    to {
        left: -100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }
}

@keyframes indeterminate {
    0% {
        left: -100%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    20% {
        left: -40%;
        -webkit-transform: scaleX(.3);
        transform: scaleX(.3);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    35% {
        left: 35%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    50% {
        left: 75%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    55% {
        left: 100%;
        -webkit-transform: scaleX(.7);
        transform: scaleX(.7);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    55.99% {
        left: 100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    56% {
        left: -100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    56.99% {
        left: -100%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    75% {
        left: -5%;
        -webkit-transform: scaleX(.6);
        transform: scaleX(.6);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    80% {
        left: 30%;
        -webkit-transform: scaleX(.5);
        transform: scaleX(.5);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    85% {
        left: 50%;
        -webkit-transform: scaleX(.4);
        transform: scaleX(.4);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    90% {
        left: 75%;
        -webkit-transform: scaleX(.3);
        transform: scaleX(.3);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    95% {
        left: 95%;
        -webkit-transform: scaleX(.2);
        transform: scaleX(.2);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    98% {
        left: 100%;
        -webkit-transform: scaleX(.2);
        transform: scaleX(.2);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    99.99% {
        left: 100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }

    to {
        left: -100%;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        -webkit-transform-origin: left;
        transform-origin: left
    }
}

@-webkit-keyframes indeterminate-vertical {
    0% {
        bottom: -100%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    20% {
        bottom: -40%;
        -webkit-transform: scaleY(.3);
        transform: scaleY(.3);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    35% {
        bottom: 35%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    50% {
        bottom: 75%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    55% {
        bottom: 100%;
        -webkit-transform: scaleY(.7);
        transform: scaleY(.7);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    55.99% {
        bottom: 100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    56% {
        bottom: -100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    56.99% {
        bottom: -100%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    75% {
        bottom: -5%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    80% {
        bottom: 30%;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    85% {
        bottom: 50%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    90% {
        bottom: 75%;
        -webkit-transform: scaleY(.3);
        transform: scaleY(.3);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    95% {
        bottom: 95%;
        -webkit-transform: scaleY(.2);
        transform: scaleY(.2);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    98% {
        bottom: 100%;
        -webkit-transform: scaleY(.2);
        transform: scaleY(.2);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    99.99% {
        bottom: 100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    to {
        bottom: -100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }
}

@keyframes indeterminate-vertical {
    0% {
        bottom: -100%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    20% {
        bottom: -40%;
        -webkit-transform: scaleY(.3);
        transform: scaleY(.3);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    35% {
        bottom: 35%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    50% {
        bottom: 75%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    55% {
        bottom: 100%;
        -webkit-transform: scaleY(.7);
        transform: scaleY(.7);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    55.99% {
        bottom: 100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    56% {
        bottom: -100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    56.99% {
        bottom: -100%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    75% {
        bottom: -5%;
        -webkit-transform: scaleY(.6);
        transform: scaleY(.6);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    80% {
        bottom: 30%;
        -webkit-transform: scaleY(.5);
        transform: scaleY(.5);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    85% {
        bottom: 50%;
        -webkit-transform: scaleY(.4);
        transform: scaleY(.4);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    90% {
        bottom: 75%;
        -webkit-transform: scaleY(.3);
        transform: scaleY(.3);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    95% {
        bottom: 95%;
        -webkit-transform: scaleY(.2);
        transform: scaleY(.2);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    98% {
        bottom: 100%;
        -webkit-transform: scaleY(.2);
        transform: scaleY(.2);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    99.99% {
        bottom: 100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }

    to {
        bottom: -100%;
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: bottom;
        transform-origin: bottom
    }
}

@-webkit-keyframes circle {
    0% {
        stroke-dashoffset: 314
    }

    5% {
        stroke-dashoffset: 164
    }

    25% {
        stroke-dashoffset: 104
    }
}

@keyframes circle {
    0% {
        stroke-dashoffset: 314
    }

    5% {
        stroke-dashoffset: 164
    }

    25% {
        stroke-dashoffset: 104
    }
}

@-webkit-keyframes circle-inverted {
    0% {
        stroke-dashoffset: -314
    }

    5% {
        stroke-dashoffset: -164
    }

    25% {
        stroke-dashoffset: -104
    }
}

@keyframes circle-inverted {
    0% {
        stroke-dashoffset: -314
    }

    5% {
        stroke-dashoffset: -164
    }

    25% {
        stroke-dashoffset: -104
    }
}

@-webkit-keyframes rotate-circle {
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg)
    }

    75% {
        -webkit-transform: rotate(270deg);
        transform: rotate(270deg)
    }

    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes rotate-circle {
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg)
    }

    75% {
        -webkit-transform: rotate(270deg);
        transform: rotate(270deg)
    }

    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@-webkit-keyframes rotate-circle-inverted {
    50% {
        -webkit-transform: rotate(-180deg);
        transform: rotate(-180deg)
    }

    75% {
        -webkit-transform: rotate(-270deg);
        transform: rotate(-270deg)
    }

    to {
        -webkit-transform: rotate(-1turn);
        transform: rotate(-1turn)
    }
}

@keyframes rotate-circle-inverted {
    50% {
        -webkit-transform: rotate(-180deg);
        transform: rotate(-180deg)
    }

    75% {
        -webkit-transform: rotate(-270deg);
        transform: rotate(-270deg)
    }

    to {
        -webkit-transform: rotate(-1turn);
        transform: rotate(-1turn)
    }
}

smart-query-builder {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    display: block;
    height: auto;
    height: var(--smart-query-builder-default-height);
    min-width: 100px;
    min-width: var(--smart-query-builder-min-width);
    width: auto;
    width: var(--smart-query-builder-default-width)
}

smart-query-builder.smart-element {
    overflow: visible
}

smart-query-builder[allow-drag] .smart-filter-group-condition:after,
smart-query-builder[allow-drag] .smart-filter-group-condition:before {
    content: "\\f141";
    content: var(--smart-icon-ellipsis);
    font-weight: 400
}

smart-query-builder[dragging] .smart-filter-group-condition:after,
smart-query-builder[dragging] .smart-filter-group-condition:before {
    content: none
}

.smart-query-builder {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-query-builder.smart-container,
.smart-query-builder>.smart-container {
    overflow: visible;
    position: relative
}

.smart-query-builder.smart-container>.smart-inner-container,
.smart-query-builder>.smart-container>.smart-inner-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-query-builder smart-menu.smart-conditions-menu:not([animation=none]) {
    height: auto;
    padding: 2px;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    width: auto
}

.smart-query-builder smart-menu.smart-conditions-menu.smart-visibility-hidden:not([animation=none]) {
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-query-builder smart-menu[mode=dropDown] {
    --smart-menu-vertical-default-width: auto;
    --smart-menu-vertical-default-height: auto
}

.smart-query-builder smart-scroll-viewer {
    border: none;
    height: 100%;
    padding: 5px;
    padding: var(--smart-query-builder-content-padding);
    position: relative;
    width: 100%
}

.smart-query-builder .smart-content-container>.smart-filter-group:first-child>.smart-filter-group-operator {
    display: none
}

.smart-query-builder .smart-query-builder-label {
    font-weight: 700;
    margin: 5px 0 10px 5px;
    margin: var(--smart-query-builder-content-padding) 0 calc(var(--smart-query-builder-content-padding)*2) var(--smart-query-builder-content-padding);
    opacity: .75
}

.smart-query-builder .filter-builder-item {
    align-items: center;
    border: none;
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    cursor: pointer;
    display: flex;
    margin-left: 10px;
    margin-left: calc(var(--smart-filter-builder-item-margin)/2);
    margin-right: 10px;
    margin-right: calc(var(--smart-filter-builder-item-margin)/2);
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height)
}

.smart-query-builder .filter-builder-item .smart-value-container {
    padding-left: 4px;
    padding-left: var(--smart-editor-label-padding)
}

.smart-query-builder .filter-builder-item[edited] {
    border: none
}

.smart-query-builder .filter-builder-item[edited] .smart-value-container {
    display: none
}

.smart-query-builder .filter-builder-item[placeholder] {
    font-style: italic;
    opacity: .75
}

.smart-query-builder .filter-builder-item[placeholder] .smart-value-container {
    padding-right: 2px
}

.smart-query-builder .smart-conditions-menu {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-query-builder .smart-conditions-menu:focus {
    border: var(--smart-menu-border-width) solid var(--smart-menu-border)
}

.smart-query-builder .smart-conditions-menu smart-menu-item {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-query-builder .smart-conditions-menu smart-menu-item:first-child {
    margin-bottom: 1px
}

.smart-query-builder .smart-conditions-menu smart-menu-item.hover {
    background-color: var(--smart-menu-item-background-focus);
    border-color: var(--smart-menu-item-border-focus);
    color: var(--smart-menu-item-color-focus)
}

.smart-query-builder .smart-editors-container>* {
    min-width: 100px;
    width: 125px;
    width: var(--smart-query-builder-editor-width)
}

.smart-query-builder .smart-editors-container smart-numeric-text-box input.smart-input {
    text-align: left
}

.smart-query-builder .smart-editors-container smart-input .arrow {
    transition: none
}

.smart-query-builder .smart-editors-container .smart-custom-editor>* {
    pointer-events: all;
    width: 100%
}

.smart-query-builder .smart-editors-container[open] .smart-check-box-editor {
    align-self: center;
    display: flex;
    height: 30px;
    justify-self: center;
    margin-left: auto;
    margin-right: auto;
    width: 30px
}

.smart-query-builder .smart-editors-container[open] .smart-check-box-editor.smart-hidden {
    display: none
}

.smart-query-builder .smart-editors-container[open] smart-check-box {
    display: block
}

.smart-query-builder .smart-filter-group {
    align-items: flex-start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    width: 100%
}

.smart-query-builder .smart-filter-group:last-of-type .smart-filter-add-btn {
    display: inline;
    display: initial
}

.smart-query-builder .smart-filter-group:not(:first-of-type) {
    margin-top: 15px;
    margin-top: var(--smart-filter-builder-group-margin)
}

.smart-query-builder .smart-filter-group .smart-filter-add-btn,
.smart-query-builder .smart-filter-group[max-level] .smart-filter-add-btn,
.smart-query-builder .smart-filter-group[node-id="0"] .smart-filter-group-operator {
    display: none
}

.smart-query-builder .smart-filter-group-condition {
    box-sizing: border-box;
    display: flex;
    margin-bottom: 5px;
    margin-bottom: var(--smart-filter-builder-group-condition-margin);
    position: relative;
    white-space: nowrap;
    width: 100%
}

.smart-query-builder .smart-filter-group-condition:after,
.smart-query-builder .smart-filter-group-condition:before {
    align-items: flex-end;
    content: none;
    cursor: move;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 12px;
    font-weight: 800;
    height: 10px;
    justify-content: center;
    line-height: 1rem;
    margin-right: 6px;
    opacity: .25;
    position: absolute;
    right: 100%;
    top: 10px;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    width: auto
}

.smart-query-builder .smart-filter-group-condition:after {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-query-builder .smart-filter-group-condition.dragged {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em
}

.smart-query-builder .smart-filter-group-condition[limit-selection]:after,
.smart-query-builder .smart-filter-group-condition[limit-selection]:before {
    content: none
}

.smart-query-builder .smart-filter-group-condition[limit-selection] .filter-builder-item:not(.smart-filter-field-name) {
    pointer-events: none
}

.smart-query-builder .smart-filter-group-condition-container {
    border-left: 4px solid #e0e0e0;
    border-left: var(--smart-filter-builder-group-container-border) solid var(--smart-border);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-left: 13px;
    margin-left: calc(var(--smart-filter-builder-group-condition-margin)*3 - var(--smart-filter-builder-group-container-border)/2);
    padding-left: 30px;
    padding-left: calc(var(--smart-filter-builder-group-condition-margin)*6);
    white-space: nowrap;
    width: calc(100% - 16.33333px);
    width: calc(100% - var(--smart-filter-builder-group-condition-margin)*3 - var(--smart-filter-builder-group-container-border)/3)
}

.smart-query-builder .smart-filter-group-operator {
    background: #005c99;
    background: var(--smart-primary);
    border: none;
    border-radius: 50px;
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    margin-right: 0;
    min-width: 50px;
    text-transform: uppercase;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-query-builder .smart-filter-group-operator:not(:empty) {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    margin-bottom: calc(var(--smart-filter-builder-group-condition-margin)*2);
    padding: 4px
}

.smart-query-builder .smart-filter-nested-operator {
    align-self: flex-start;
    cursor: pointer;
    font-weight: 600;
    margin-bottom: 15px;
    margin-bottom: calc(var(--smart-filter-builder-group-condition-margin)*3);
    margin-left: -20px;
    margin-left: calc(var(--smart-filter-builder-item-margin)*-1);
    margin-top: 15px;
    margin-top: calc(var(--smart-filter-builder-group-condition-margin)*3);
    opacity: .5;
    text-transform: uppercase;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-query-builder .smart-filter-group-operation {
    background: #005c99;
    background: var(--smart-primary);
    border: none;
    border-radius: 50px;
    color: #fff;
    color: var(--smart-primary-color);
    margin-right: 0;
    min-width: 50px;
    text-transform: uppercase;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-query-builder .smart-filter-delete-btn {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    justify-content: center;
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height);
    min-width: 30px;
    min-width: var(--smart-filter-builder-row-height);
    opacity: .25
}

.smart-query-builder .smart-filter-delete-btn:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: 800;
    height: 0;
    justify-content: center;
    width: 100%
}

.smart-query-builder .smart-filter-add-btn,
.smart-query-builder .smart-filter-add-condition-btn {
    display: flex;
    min-height: 30px;
    min-height: var(--smart-filter-builder-row-height);
    width: 30px;
    width: var(--smart-filter-builder-row-height)
}

.smart-query-builder .smart-filter-delete-btn:hover {
    opacity: .6
}

.smart-query-builder .smart-filter-delete-btn:active {
    opacity: 1
}

.smart-query-builder .smart-filter-add-btn {
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    box-sizing: border-box;
    color: #fff;
    color: var(--smart-primary-color);
    font-size: 16px;
    height: 30px;
    height: var(--smart-filter-builder-row-height);
    justify-content: center;
    line-height: 1rem;
    margin-bottom: 10px;
    margin-bottom: calc(var(--smart-filter-builder-group-condition-margin)*2);
    margin-top: 10px;
    margin-top: calc(var(--smart-filter-builder-group-condition-margin)*2);
    min-width: 30px;
    min-width: var(--smart-filter-builder-row-height);
    opacity: 1
}

@media only screen and (min-device-width:768px) and (max-device-width:1024px) {
    .smart-query-builder .smart-filter-add-btn {
        padding-bottom: 7px
    }
}

.smart-query-builder .smart-filter-add-btn:after {
    align-items: center;
    content: "+";
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 30px;
    font-weight: 800;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-query-builder .smart-filter-add-condition-btn {
    align-items: flex-end;
    border-left: 1.6px dashed #e0e0e0;
    border-left: calc(var(--smart-filter-builder-group-container-border)/2.5) dashed var(--smart-border);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    font-size: 16px;
    justify-content: flex-start;
    margin-left: 14.2px;
    margin-left: calc(var(--smart-filter-builder-group-condition-margin)*3 - var(--smart-filter-builder-group-container-border)/5);
    min-width: 50px;
    opacity: 1;
    padding-left: 30px;
    padding-left: calc(var(--smart-filter-builder-group-condition-margin)*6);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-query-builder .smart-filter-add-condition-btn>div {
    padding-left: 10px;
    padding-left: calc(var(--smart-filter-builder-item-margin)/2);
    position: relative
}

.smart-query-builder .smart-filter-add-condition-btn>div:before {
    align-items: center;
    content: "+";
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 20px;
    font-weight: 800;
    height: 100%;
    justify-content: center;
    margin-right: 5px;
    position: absolute;
    right: 100%;
    top: 0;
    width: auto
}

.smart-query-builder .smart-filter-add-condition-btn[limit-selection] {
    opacity: .75;
    pointer-events: none
}

.smart-query-builder .smart-filter-value {
    min-width: 100px;
    padding: 0;
    text-overflow: ellipsis;
    width: 125px;
    width: var(--smart-query-builder-editor-width)
}

.smart-query-builder .smart-filter-value[edited] {
    background-color: transparent;
    padding: 0
}

.smart-query-builder .smart-filter-value .smart-value-container {
    align-items: center;
    display: flex;
    height: 100%;
    margin: 0;
    overflow: hidden;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-query-builder .smart-filter-value .smart-value-container>span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-query-builder .smart-filter-operation {
    min-width: 100px;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 125px;
    width: var(--smart-query-builder-editor-width)
}

.smart-query-builder .smart-filter-operation .smart-value-container {
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-query-builder .smart-filter-operation:not([edited]):after {
    align-items: center;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    justify-content: center;
    outline: 0;
    overflow: hidden;
    position: absolute;
    right: -1px;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-query-builder .smart-filter-field-name {
    min-width: 100px;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 125px;
    width: var(--smart-query-builder-editor-width)
}

.smart-query-builder .smart-filter-field-name .smart-value-container {
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-query-builder .smart-filter-builder-icon {
    align-items: center;
    border-right: 1px solid gray;
    display: flex;
    font-weight: 700;
    height: 100%;
    justify-content: center;
    margin-right: 5px;
    width: 40px
}

.smart-query-builder .smart-filter-builder-menu-item {
    height: 100%
}

.smart-query-builder .smart-hidden {
    display: none
}

.smart-query-builder .smart-scrollable-outer-container {
    height: 100%;
    width: 100%
}

.smart-query-builder .smart-scroll-viewer-content-container {
    padding: initial;
    vertical-align: top
}

.smart-query-builder .drop-target.bottom:after,
.smart-query-builder .drop-target.top:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    box-sizing: border-box;
    content: "";
    height: 5px;
    height: var(--smart-filter-builder-group-condition-margin);
    left: 0;
    opacity: .75;
    pointer-events: none;
    position: absolute;
    -webkit-transform: none;
    transform: none;
    width: 100%
}

.smart-query-builder .drop-target.bottom:after {
    top: calc(100% + 3px)
}

.smart-query-builder .drop-target.top:after {
    top: -5px;
    top: calc(var(--smart-filter-builder-group-condition-margin)*-1)
}

.smart-query-builder .mac .smart-filter-add-btn:after,
.smart-query-builder .mac .smart-filter-add-condition-btn>div:before {
    align-items: stretch;
    line-height: 80%
}

.smart-query-builder[show-field-name-arrow] .smart-filter-field-name:not([edited]):after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    display: flex;
    height: 100%;
    outline: 0;
    position: absolute;
    right: -1px;
    top: 1px;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-query-builder-drag-feedback {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 26px;
    opacity: .75;
    padding: 5px;
    position: absolute;
    white-space: nowrap;
    z-index: 10000
}

.smart-query-builder-drag-feedback:after {
    content: "\\f0c5";
    content: var(--smart-icon-docs);
    height: 100%;
    left: 0;
    position: relative;
    top: 0;
    width: 100%
}

.smart-input-drop-down-menu .icon:after {
    align-items: center;
    display: flex;
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    font-weight: 700;
    justify-content: center
}

.smart-input-drop-down-menu .icon.equals:after {
    content: "="
}

.smart-input-drop-down-menu .icon.notequals:after {
    content: "≠"
}

.smart-input-drop-down-menu .icon.greaterthan:after {
    content: ">"
}

.smart-input-drop-down-menu .icon.greaterthanorequal:after {
    content: "≥"
}

.smart-input-drop-down-menu .icon.lessthan:after {
    content: "<"
}

.smart-input-drop-down-menu .icon.lessthanorequal:after {
    content: "≤"
}

.smart-input-drop-down-menu .icon.startswith:after {
    content: "a|bc"
}

.smart-input-drop-down-menu .icon.endswith:after {
    content: "ab|c"
}

.smart-input-drop-down-menu .icon.contains:after {
    content: "abc"
}

.smart-input-drop-down-menu .icon.notcontains:after {
    content: "!abc"
}

.smart-input-drop-down-menu .icon.isblank:after {
    content: "□"
}

.smart-input-drop-down-menu .icon.isnotblank:after {
    content: "■"
}

.smart-query-builder-drag-feedback[right-to-left],
smart-query-builder[right-to-left] .smart-filter-group {
    direction: rtl
}

smart-query-builder[right-to-left] .smart-filter-group-condition-container {
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    margin-left: 0;
    margin-right: 13px;
    margin-right: calc(var(--smart-filter-builder-group-condition-margin)*3 - var(--smart-filter-builder-group-container-border)/2);
    padding-left: 0;
    padding-right: 30px;
    padding-right: calc(var(--smart-filter-builder-group-condition-margin)*6)
}

smart-query-builder[right-to-left] .smart-filter-nested-operator {
    margin-left: 0;
    margin-right: -20px;
    margin-right: calc(var(--smart-filter-builder-item-margin)*-1)
}

smart-query-builder[right-to-left] .smart-filter-group-condition:after,
smart-query-builder[right-to-left] .smart-filter-group-condition:before {
    left: 100%;
    margin: 0 0 0 6px;
    right: auto
}

smart-query-builder[right-to-left] .smart-filter-add-condition-btn {
    border-left: initial;
    border-right: .4px dashed #e0e0e0;
    border-right: calc(var(--smart-border-width)/2.5) dashed var(--smart-border);
    margin-left: 0;
    margin-right: 14.8px;
    margin-right: calc(var(--smart-filter-builder-group-condition-margin)*3 - var(--smart-border-width)/5);
    padding-left: 0;
    padding-right: 30px;
    padding-right: calc(var(--smart-filter-builder-group-condition-margin)*6)
}

smart-query-builder[right-to-left] .smart-filter-add-condition-btn>div {
    padding-left: 0;
    padding-right: 10px;
    padding-right: calc(var(--smart-filter-builder-item-margin)/2)
}

smart-query-builder[right-to-left] .smart-filter-add-condition-btn>div:before {
    left: 100%;
    right: auto
}

smart-query-builder[right-to-left] .smart-filter-operation:not([edited]):after {
    left: -1px;
    right: auto
}

smart-query-builder[right-to-left] .drop-target.bottom:after,
smart-query-builder[right-to-left] .drop-target.top:after {
    left: auto;
    right: 0
}

.smart-rating .rating-star:after {
    color: #005c99;
    color: var(--smart-primary);
    content: "\\e801";
    content: var(--smart-icon-star);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 100%;
    top: 0;
    width: 100%
}

.smart-rating .rating-star.active.hover:after,
.smart-rating .rating-star.active:after,
.smart-rating .rating-star.hover:after {
    color: #2d2d30;
    color: var(--smart-secondary)
}

.smart-rating[right-to-left] #ratingStars {
    direction: rtl;
    display: flex
}

smart-scroll-bar {
    display: block;
    height: 18px;
    height: var(--smart-scroll-bar-default-height);
    touch-action: none;
    width: 250px;
    width: var(--smart-scroll-bar-default-width)
}

smart-scroll-bar .smart-thumb {
    background-clip: content-box;
    background-color: #c1c1c1;
    background-color: var(--smart-scroll-bar-thumb-background);
    border: 1px solid transparent;
    border-bottom-left-radius: 0;
    border-bottom-left-radius: var(--smart-scroll-bar-thumb-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-bottom-right-radius: var(--smart-scroll-bar-thumb-border-bottom-right-radius);
    border-color: var(--smart-scroll-bar-thumb-border);
    border-top-left-radius: 0;
    border-top-left-radius: var(--smart-scroll-bar-thumb-border-top-left-radius);
    border-top-right-radius: 0;
    border-top-right-radius: var(--smart-scroll-bar-thumb-border-top-right-radius);
    box-sizing: border-box;
    cursor: default;
    height: 100%;
    height: var(--smart-scroll-bar-thumb-size);
    padding: 1px 0;
    padding: var(--smart-scroll-bar-thumb-padding) 0;
    position: absolute;
    width: 40px
}

smart-scroll-bar .smart-thumb:hover {
    background-color: #a8a8a8;
    background-color: var(--smart-scroll-bar-thumb-background-hover);
    border-color: transparent;
    border-color: var(--smart-scroll-bar-thumb-border-hover)
}

smart-scroll-bar .smart-thumb:active {
    background-color: #787878;
    background-color: var(--smart-scroll-bar-thumb-background-active);
    border-color: transparent;
    border-color: var(--smart-scroll-bar-thumb-border-active)
}

smart-scroll-bar .smart-track {
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-track-background);
    float: left;
    height: 100%;
    position: relative;
    width: 100%
}

smart-scroll-bar .smart-scroll-button {
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-button-background);
    border: 1px solid #f1f1f1;
    border: 1px solid var(--smart-scroll-bar-button-border);
    border-radius: 0;
    color: #505050;
    color: var(--smart-scroll-bar-button-color);
    cursor: default;
    display: none;
    float: left;
    height: 100%;
    min-height: 0;
    padding: 0;
    width: 16px;
    width: var(--smart-scroll-button-size)
}

smart-scroll-bar .smart-scroll-button:hover {
    background-color: #d2d2d2;
    background-color: var(--smart-scroll-bar-button-background-hover);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-hover);
    color: #505050;
    color: var(--smart-scroll-bar-button-color-hover)
}

smart-scroll-bar .smart-scroll-button:active {
    background-color: #787878;
    background-color: var(--smart-scroll-bar-button-background-active);
    border-color: #f1f1f1;
    border-color: var(--smart-scroll-bar-button-border-active);
    color: #fff;
    color: var(--smart-scroll-bar-button-color-active)
}

smart-scroll-bar[show-buttons] .smart-track {
    width: calc(100% - 32px);
    width: calc(100% - var(--smart-scroll-button-size)*2)
}

smart-scroll-bar[show-buttons] .smart-scroll-button {
    display: block
}

smart-scroll-bar[spinner][show-buttons] .smart-track {
    display: none
}

smart-scroll-bar[spinner][show-buttons] .smart-scroll-button {
    width: 50%
}

smart-scroll-bar[discrete] {
    --smart-scroll-button-size: 0px;
    --smart-scroll-bar-size: 15px;
    --smart-scroll-bar-thumb-border-top-right-radius: 6px;
    --smart-scroll-bar-thumb-border-top-left-radius: 6px;
    --smart-scroll-bar-thumb-border-bottom-left-radius: 6px;
    --smart-scroll-bar-thumb-border-bottom-right-radius: 6px;
    --smart-scroll-bar-thumb-size: 100%;
    --smart-scroll-bar-thumb-padding: 3px;
    --smart-scroll-bar-default-width: var(--smart-editor-width);
    --smart-scroll-bar-default-height: var(--smart-scroll-bar-size);
    --smart-scroll-bar-background: #fafafa;
    --smart-scroll-bar-track-background: var(--smart-scroll-bar-background);
    --smart-scroll-bar-border: #f1f1f1;
    --smart-scroll-bar-thumb-background: #c1c1c1;
    --smart-scroll-bar-thumb-border: transparent
}

smart-scroll-bar[orientation=vertical] {
    height: 250px;
    height: var(--smart-scroll-bar-default-width);
    width: 18px;
    width: var(--smart-scroll-bar-default-height)
}

smart-scroll-bar[orientation=vertical] .smart-thumb {
    height: 40px;
    padding: 0 1px;
    padding: 0 var(--smart-scroll-bar-thumb-padding);
    top: 0;
    width: 100%;
    width: var(--smart-scroll-bar-thumb-size)
}

smart-scroll-bar[orientation=vertical] .smart-track {
    float: none;
    height: 100%;
    width: 100%
}

smart-scroll-bar[orientation=vertical] .smart-scroll-button {
    float: none;
    height: 16px;
    height: var(--smart-scroll-button-size);
    width: 100%
}

smart-scroll-bar[orientation=vertical][show-buttons] .smart-track {
    height: calc(100% - 32px);
    height: calc(100% - var(--smart-scroll-button-size)*2)
}

smart-scroll-bar[orientation=vertical][spinner] .smart-scroll-button {
    float: none;
    height: 50%;
    width: 100%
}

smart-scroll-viewer {
    display: block;
    height: 250px;
    height: var(--smart-list-box-default-height);
    max-height: none;
    max-height: var(--smart-scroll-viewer-max-height);
    max-width: none;
    max-width: var(--smart-scroll-viewer-max-width);
    min-height: none;
    min-height: var(--smart-scroll-viewer-min-height);
    min-width: none;
    min-width: var(--smart-scroll-viewer-min-width);
    padding: 3px;
    width: 250px;
    width: var(--smart-editor-width)
}

.smart-scroll-viewer.smart-container,
smart-scroll-viewer>.smart-container {
    border: none;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-scroll-viewer>.smart-container,
.smart-scroll-viewer>.smart-container>.smart-scroll-viewer-container {
    max-height: inherit;
    max-width: inherit;
    min-height: inherit;
    min-width: inherit
}

.smart-scroll-viewer smart-scroll-bar {
    bottom: 0;
    height: 18px;
    height: calc(var(--smart-scroll-bar-size));
    overflow: visible;
    position: absolute;
    width: 100%
}

.smart-scroll-viewer smart-scroll-bar:before {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    content: "";
    height: 18px;
    height: var(--smart-scroll-bar-size);
    left: 100%;
    position: absolute;
    width: 100%
}

.smart-scroll-viewer smart-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-scroll-viewer smart-scroll-bar[orientation=vertical] {
    height: 100%;
    right: 0;
    top: 0;
    width: 18px;
    width: calc(var(--smart-scroll-bar-size))
}

.smart-scroll-viewer smart-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-scroll-viewer .smart-scroll-viewer-container {
    background-color: transparent;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-scroll-viewer .smart-scroll-viewer-container.hscroll {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

.smart-scroll-viewer .smart-scroll-viewer-container.vscroll {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

.smart-scroll-viewer .smart-scroll-viewer-content-container {
    background-color: transparent;
    display: inline-block;
    height: auto;
    padding: 5px;
    position: relative;
    width: auto
}

.smart-scroll-viewer[right-to-left] .smart-scroll-viewer-container {
    direction: rtl;
    text-align: left;
    text-align: initial
}

.smart-scroll-viewer[right-to-left] .smart-scroll-viewer-container.vscroll,
.smart-scroll-viewer[right-to-left] smart-scroll-bar {
    left: 18px;
    left: var(--smart-scroll-bar-size);
    right: 0
}

.smart-scroll-viewer[right-to-left] smart-scroll-bar:after {
    left: -100%
}

.smart-scroll-viewer[right-to-left] smart-scroll-bar[orientation=vertical] {
    left: 0;
    right: auto
}

.smart-scroll-viewer[right-to-left] smart-scroll-bar[orientation=vertical]:after {
    content: none
}

.smart-slider[right-to-left] .smart-hint,
.smart-slider[right-to-left] .smart-label,
smart-slider[right-to-left] .smart-tooltip-content {
    direction: rtl
}

smart-slider {
    --smart-border-top-left-radius: 100%;
    --smart-border-top-right-radius: 100%;
    --smart-border-bottom-left-radius: 100%;
    --smart-border-bottom-right-radius: 100%;
    display: block;
    height: 35px;
    height: var(--smart-slider-default-height);
    width: 250px;
    width: var(--smart-slider-default-width)
}

smart-slider[orientation=vertical] {
    height: 250px;
    height: var(--smart-slider-default-width);
    width: 35px;
    width: var(--smart-slider-default-height)
}

smart-slider.smart-element {
    overflow: visible
}

.smart-slider .smart-track-container {
    height: 1px;
    height: var(--smart-slider-track-size);
    margin-bottom: 11.5px;
    margin-bottom: calc((var(--smart-slider-thumb-height) - var(--smart-slider-track-size))/2 + 2px);
    margin-top: 11.5px;
    margin-top: calc((var(--smart-slider-thumb-height) - var(--smart-slider-track-size))/2 + 2px);
    width: 100%
}

.smart-slider .smart-track {
    background-color: #ccc;
    background-color: var(--smart-disabled);
    float: left;
    height: 1px;
    height: var(--smart-slider-track-size);
    position: relative;
    width: 100%
}

.smart-slider .smart-thumb,
.smart-slider .smart-track {
    cursor: pointer;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none
}

.smart-slider .smart-thumb {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border: 1px solid #005c99;
    border: var(--smart-border-width) solid var(--smart-primary);
    border-bottom-left-radius: 15px;
    border-bottom-left-radius: var(--smart-slider-thumb-border-bottom-left-radius);
    border-bottom-right-radius: 15px;
    border-bottom-right-radius: var(--smart-slider-thumb-border-bottom-right-radius);
    border-top-left-radius: 15px;
    border-top-left-radius: var(--smart-slider-thumb-border-top-left-radius);
    border-top-right-radius: 15px;
    border-top-right-radius: var(--smart-slider-thumb-border-top-right-radius);
    height: 20px;
    height: var(--smart-slider-thumb-height);
    margin-left: -10px;
    margin-left: calc(var(--smart-slider-thumb-width)*-1/2);
    margin-top: -9.5px;
    margin-top: calc(var(--smart-slider-track-size)/2 - var(--smart-slider-thumb-height)/2);
    min-height: 1px;
    min-height: var(--smart-slider-track-size);
    min-width: 1px;
    min-width: var(--smart-slider-track-size);
    position: absolute;
    width: 20px;
    width: var(--smart-slider-thumb-width)
}

.smart-slider .smart-thumb:before {
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    content: "";
    display: block;
    height: 100%;
    opacity: .2;
    transition: .2s;
    width: 100%;
    z-index: -1
}

.smart-slider .smart-thumb[hover]:before {
    -webkit-animation: slider-thumb-effect 1s infinite;
    animation: slider-thumb-effect 1s infinite;
    -webkit-animation-delay: .1s;
    animation-delay: .1s;
    -webkit-transform: scale(3);
    transform: scale(3)
}

.smart-slider .smart-thumb.accessible {
    z-index: 1
}

.smart-slider .smart-thumb-label,
.smart-slider .smart-thumb~.smart-thumb {
    display: none
}

.smart-slider .smart-value {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    height: 1px;
    height: var(--smart-slider-track-size);
    position: absolute;
    width: 0
}

.smart-slider .smart-tooltip {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-radius: 0;
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 75%;
    height: 30px;
    height: var(--smart-slider-tooltip-height);
    justify-content: center;
    left: -21px;
    left: calc(var(--smart-slider-tooltip-width)*-1/2 + var(--smart-slider-thumb-width)/2 - 1px);
    opacity: .5;
    padding: 4px 12px;
    position: absolute;
    top: -52px;
    top: calc(var(--smart-slider-tooltip-height)*-1 - 22px);
    width: 60px;
    width: var(--smart-slider-tooltip-width)
}

.smart-slider .smart-scale.smart-hidden,
.smart-slider .smart-tooltip.smart-hidden {
    display: none
}

.smart-slider .smart-tooltip .smart-tooltip-content {
    background: inherit;
    background-color: inherit;
    border-color: inherit;
    color: inherit
}

.smart-slider .smart-tick {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    height: 10px;
    height: var(--smart-slider-tick-size);
    position: absolute;
    width: 1px
}

.smart-slider .smart-tick-minor {
    height: 5px;
    height: var(--smart-slider-minor-tick-size)
}

.smart-slider .smart-scale {
    height: calc(100% - 24px);
    height: calc(100% - var(--smart-slider-thumb-height) - 4px);
    margin-left: 1px;
    margin-left: var(--smart-border-width)
}

.smart-slider .smart-scale-near .smart-tick {
    bottom: 0
}

.smart-slider .smart-scale-near .smart-label {
    bottom: 12px;
    bottom: calc(var(--smart-slider-tick-size) + 2px)
}

.smart-slider .smart-scale-far .smart-tick {
    top: 0
}

.smart-slider .smart-scale-far .smart-label {
    top: 12px;
    top: calc(var(--smart-slider-tick-size) + 2px)
}

.smart-slider .smart-spin-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: block;
    float: left;
    height: 30px;
    height: var(--smart-slider-spin-button-height);
    margin-top: -14.5px;
    margin-top: calc(var(--smart-slider-track-size)/2 - var(--smart-slider-spin-button-height)/2);
    min-height: 0;
    padding: 0;
    position: relative;
    top: 0;
    width: 30px;
    width: var(--smart-slider-spin-button-width)
}

.smart-slider .smart-spin-button.smart-hidden,
.smart-slider:not([hint]) .smart-hint {
    display: none
}

.smart-slider .smart-spin-button .smart-button {
    min-height: 0;
    padding: 0
}

.smart-slider .smart-spin-button .smart-arrow {
    left: 1px;
    top: 1px
}

.smart-slider .smart-spin-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-slider .smart-spin-button[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-slider:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-slider:focus .smart-thumb:before {
    -webkit-animation: slider-thumb-effect 1s infinite;
    animation: slider-thumb-effect 1s infinite;
    -webkit-animation-delay: .1s;
    animation-delay: .1s;
    -webkit-transform: scale(3);
    transform: scale(3)
}

.smart-slider:not([animation=none]) .smart-thumb.enable-animation {
    transition: margin-left .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none]) .smart-value.enable-animation {
    transition: width .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none])[inverted] .smart-value.enable-animation,
.smart-slider:not([animation=none])[range-slider] .smart-value.enable-animation {
    transition: width .4s cubic-bezier(.25, .8, .25, 1), margin-left .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none])[orientation=vertical] .smart-thumb.enable-animation {
    transition: margin-top .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none])[orientation=vertical] .smart-value.enable-animation {
    transition: height .4s cubic-bezier(.25, .8, .25, 1), margin-top .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none])[orientation=vertical][inverted] .smart-value.enable-animation {
    transition: height .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider:not([animation=none])[orientation=vertical][range-slider] .smart-value.enable-animation {
    transition: height .4s cubic-bezier(.25, .8, .25, 1), margin-top .4s cubic-bezier(.25, .8, .25, 1)
}

.smart-slider[disabled] .smart-spin-button,
.smart-slider[disabled] .smart-thumb,
.smart-slider[disabled] .smart-track,
.smart-slider[disabled] .smart-value,
.smart-slider[readonly] .smart-spin-button,
.smart-slider[readonly] .smart-thumb,
.smart-slider[readonly] .smart-track,
.smart-slider[readonly] .smart-value {
    cursor: default
}

.smart-slider[hint] .smart-hint {
    bottom: calc(100% + 2px);
    display: block;
    font-size: 12px;
    left: 0;
    pointer-events: none;
    position: absolute;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    width: 100%
}

.smart-slider[hint] .smart-hint:empty {
    display: none
}

.smart-slider[range-slider] .smart-thumb~.smart-thumb,
.smart-slider[show-thumb-label]:focus .smart-thumb-label {
    display: block
}

.smart-slider[hint][scale-position=both]:not([orientation=vertical]) .smart-hint {
    bottom: 150%
}

.smart-slider[ticks-position=track] .smart-scale-near .smart-label,
.smart-slider[ticks-visibility=none] .smart-scale-near .smart-label {
    bottom: 2px
}

.smart-slider[hint]:not([animation=none]) .smart-hint {
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-slider[value="0"] .smart-thumb {
    background-color: #e0e0e0;
    background-color: var(--smart-border);
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.smart-slider[value="0"] .smart-thumb:before {
    background: #e0e0e0;
    background: var(--smart-border)
}

.smart-slider[show-buttons] .smart-track-container {
    margin-bottom: 16.5px;
    margin-bottom: calc((var(--smart-slider-spin-button-height) - var(--smart-slider-track-size))/2 + 2px);
    margin-top: 16.5px;
    margin-top: calc((var(--smart-slider-spin-button-height) - var(--smart-slider-track-size))/2 + 2px)
}

.smart-slider[show-buttons] .smart-track {
    margin-left: 10px;
    margin-left: calc(var(--smart-slider-thumb-width)/2);
    margin-right: 10px;
    margin-right: calc(var(--smart-slider-thumb-width)/2);
    width: calc(100% - 80px);
    width: calc(100% - var(--smart-slider-spin-button-width)*2 - var(--smart-slider-thumb-width))
}

.smart-slider[show-buttons] .smart-scale {
    height: calc(100% - 34px);
    height: calc(100% - var(--smart-slider-spin-button-height) - 4px);
    margin-left: 41px;
    margin-left: calc(var(--smart-slider-spin-button-width) + var(--smart-slider-thumb-width)/2 + var(--smart-border-width));
    margin-right: 40px;
    margin-right: calc(var(--smart-slider-spin-button-width) + var(--smart-slider-thumb-width)/2)
}

.smart-slider[tooltip-position=far] .smart-tooltip {
    top: 21px;
    top: calc(var(--smart-slider-thumb-height) + 1px)
}

.smart-slider[scale-position=both] .smart-scale {
    height: calc(50% - 12px);
    height: calc((100% - var(--smart-slider-thumb-height))/2 - 2px)
}

.smart-slider[scale-position=both][show-buttons] .smart-scale {
    height: calc(50% - 17px);
    height: calc((100% - var(--smart-slider-spin-button-height))/2 - 2px)
}

.smart-slider[ticks-visibility=none] .smart-scale-far .smart-label {
    top: 2px
}

.smart-slider[ticks-position=track] .smart-tick {
    height: 100%
}

.smart-slider[ticks-position=track] .smart-tick-minor {
    height: 60%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-slider[ticks-position=track] .smart-scale-far .smart-label {
    top: 2px
}

.smart-slider[show-thumb-label] .smart-thumb {
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 9999
}

.smart-slider[show-thumb-label] .smart-thumb-label {
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 7px;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-slider[thumb-label-position=far] .smart-thumb {
    top: 0
}

.smart-slider[thumb-label-position=far]:focus .smart-thumb {
    top: 75px;
    top: calc(var(--smart-slider-default-height) + var(--smart-slider-thumb-width)*2)
}

.smart-slider[orientation=vertical].smart-container,
.smart-slider[orientation=vertical]>.smart-container {
    display: flex;
    flex-flow: row;
    justify-content: space-between
}

.smart-slider[orientation=vertical] .smart-thumb {
    margin-left: -9.5px;
    margin-left: calc(var(--smart-slider-track-size)/2 - var(--smart-slider-thumb-width)/2);
    margin-top: -10px;
    margin-top: calc(var(--smart-slider-thumb-height)*-1/2)
}

.smart-slider[orientation=vertical] .smart-track-container {
    float: left;
    height: 100%;
    margin-bottom: 0;
    margin-left: 11.5px;
    margin-left: calc((var(--smart-slider-thumb-width) - var(--smart-slider-track-size))/2 + 2px);
    margin-right: 11.5px;
    margin-right: calc((var(--smart-slider-thumb-width) - var(--smart-slider-track-size))/2 + 2px);
    margin-top: 0;
    width: 1px;
    width: var(--smart-slider-track-size);
    z-index: 1
}

.smart-slider[orientation=vertical] .smart-track {
    float: none;
    height: 100%;
    width: 1px;
    width: var(--smart-slider-track-size)
}

.smart-slider[orientation=vertical] .smart-value {
    height: 0;
    width: 1px;
    width: var(--smart-slider-track-size)
}

.smart-slider[orientation=vertical] .smart-scale {
    float: left;
    height: 100%;
    margin-top: 1px;
    margin-top: var(--smart-border-width);
    width: calc(100% - 22px);
    width: calc(100% - var(--smart-slider-thumb-width) - 2px)
}

.smart-slider[orientation=vertical] .smart-tooltip {
    left: -68px;
    left: calc(var(--smart-slider-tooltip-width)*-1 - 8px);
    top: -6px;
    top: calc(var(--smart-slider-tooltip-height)*-1/2 + var(--smart-slider-thumb-height)/2 - 1px)
}

.smart-slider[orientation=vertical] .smart-tick {
    height: 1px;
    width: 10px;
    width: var(--smart-slider-tick-size)
}

.smart-slider[orientation=vertical] .smart-tick-minor {
    width: 5px;
    width: var(--smart-slider-minor-tick-size)
}

.smart-slider[orientation=vertical] .smart-scale-near .smart-tick {
    right: 0
}

.smart-slider[orientation=vertical] .smart-scale-near .smart-label {
    bottom: auto;
    right: 12px;
    right: calc(var(--smart-slider-tick-size) + 2px)
}

.smart-slider[orientation=vertical][ticks-position=track] .smart-scale-near .smart-label,
.smart-slider[orientation=vertical][ticks-visibility=none] .smart-scale-near .smart-label {
    right: 2px
}

.smart-slider[orientation=vertical] .smart-scale-far .smart-label {
    left: 12px;
    left: calc(var(--smart-slider-tick-size) + 2px)
}

.smart-slider[orientation=vertical] .smart-spin-button {
    float: none;
    margin-left: -14.5px;
    margin-left: calc(var(--smart-slider-track-size)/2 - var(--smart-slider-spin-button-width)/2);
    margin-top: 0
}

.smart-slider[orientation=vertical][inverted] .smart-thumb {
    margin-top: 0
}

.smart-slider[orientation=vertical][scale-position=both] .smart-scale {
    width: calc(50% - 12px);
    width: calc((100% - var(--smart-slider-thumb-width))/2 - 2px)
}

.smart-slider[orientation=vertical][scale-position=both][show-buttons] .smart-scale {
    width: calc(50% - 15px);
    width: calc((100% - var(--smart-slider-spin-button-width))/2)
}

.smart-slider[orientation=vertical][show-buttons] .smart-track-container {
    margin-left: 16.5px;
    margin-left: calc((var(--smart-slider-spin-button-width) - var(--smart-slider-track-size))/2 + 2px);
    margin-right: 16.5px;
    margin-right: calc((var(--smart-slider-spin-button-width) - var(--smart-slider-track-size))/2 + 2px)
}

.smart-slider[orientation=vertical][show-buttons] .smart-track {
    margin-bottom: 10px;
    margin-bottom: calc(var(--smart-slider-thumb-height)/2);
    margin-top: 10px;
    margin-top: calc(var(--smart-slider-thumb-height)/2);
    width: 100%
}

.smart-slider[orientation=vertical][show-buttons] .smart-scale,
.smart-slider[orientation=vertical][show-buttons] .smart-track {
    height: calc(100% - 80px);
    height: calc(100% - var(--smart-slider-spin-button-height)*2 - var(--smart-slider-thumb-height));
    margin-left: 0;
    margin-right: 0
}

.smart-slider[orientation=vertical][show-buttons] .smart-scale {
    margin-top: 41px;
    margin-top: calc(var(--smart-slider-spin-button-height) + var(--smart-slider-thumb-height)/2 + var(--smart-border-width))
}

.smart-slider[orientation=vertical][tooltip-position=far] .smart-tooltip {
    left: 21px;
    left: calc(var(--smart-slider-thumb-width) + 1px)
}

.smart-slider[orientation=vertical][ticks-position=track] .smart-tick {
    height: 1px;
    width: 100%
}

.smart-slider[orientation=vertical][ticks-position=track] .smart-tick-minor {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 60%
}

.smart-slider[orientation=vertical][ticks-position=track] .smart-scale-far .smart-label,
.smart-slider[orientation=vertical][ticks-visibility=none] .smart-scale-far .smart-label {
    left: 2px
}

.smart-slider[orientation=vertical][thumb-label-position=far] .smart-thumb {
    left: 100%;
    top: calc(100% + 10px);
    top: calc(100% + var(--smart-slider-thumb-height)/2)
}

.smart-slider[right-to-left]:not([animation=none]) .smart-value.enable-animation {
    transition: width .4s cubic-bezier(.25, .8, .25, 1), margin-left .4s cubic-bezier(.25, .8, .25, 1)
}

@-webkit-keyframes slider-thumb-effect {

    0%,
    to {
        -webkit-transform: scale(3);
        transform: scale(3)
    }

    50% {
        -webkit-transform: scale(2.75);
        transform: scale(2.75)
    }
}

@keyframes slider-thumb-effect {

    0%,
    to {
        -webkit-transform: scale(3);
        transform: scale(3)
    }

    50% {
        -webkit-transform: scale(2.75);
        transform: scale(2.75)
    }
}

.smart-sortable {
    display: block
}

.smart-sortable .smart-sortable-items-parent {
    display: flex;
    flex-direction: column
}

.smart-sortable .smart-sortable-item {
    position: relative;
    -webkit-transform: translate(0);
    transform: translate(0)
}

.smart-sortable .smart-sortable-item.dragged {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    position: absolute;
    z-index: 9999999
}

.smart-sortable .smart-sortable-item.placeholder:after,
.smart-sortable .smart-sortable-item.placeholder:before {
    content: none
}

.smart-sortable:not([disabled]) .smart-sortable-item {
    touch-action: none
}

.smart-sortable[disabled] {
    opacity: .7;
    pointer-events: none
}

.smart-sortable:not([items]).smart-container,
.smart-sortable:not([items])>.smart-container {
    display: flex;
    flex-direction: column
}

.smart-sortable:not([items])[mode=horizontal]>.smart-container {
    flex-direction: row
}

.smart-sortable[dragged]>.smart-container {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-sortable[mode=horizontal] .smart-sortable-items-parent {
    flex-direction: row
}

.smart-sortable[handle-position=left] .smart-sortable-item:after,
.smart-sortable[handle-position=left] .smart-sortable-item:before {
    left: -25px !important;
    left: calc(var(--smart-sortable-handle-size)*-1) !important
}

.smart-sortable:not([animation=none]) .smart-sortable-item {
    transition: -webkit-transform .15s ease-in;
    transition: transform .15s ease-in;
    transition: transform .15s ease-in, -webkit-transform .15s ease-in
}

.smart-sortable:not([animation=none]) .smart-sortable-item.returning {
    transition: left .15s ease-in, top .15s ease-in
}

.smart-sortable:not([drag-mode=handle]):not([disabled]) .smart-sortable-item {
    cursor: grab
}

.smart-sortable[drag-mode=handle] .smart-sortable-item:after,
.smart-sortable[drag-mode=handle] .smart-sortable-item:before {
    align-items: flex-end;
    color: #5a5a5a;
    color: var(--smart-background-color);
    content: "\\f141";
    content: var(--smart-icon-ellipsis);
    cursor: grab;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 25px;
    height: var(--smart-sortable-handle-size);
    justify-content: center;
    left: 100%;
    line-height: 18px;
    line-height: calc(var(--smart-sortable-handle-size) - var(--smart-font-size)/2);
    opacity: 0;
    position: absolute;
    top: calc(50% - 12.5px);
    top: calc(50% - var(--smart-sortable-handle-size)/2);
    transition: visibility .2s ease-in, opacity .2s ease-in;
    visibility: hidden;
    width: 25px;
    width: var(--smart-sortable-handle-size)
}

.smart-sortable[drag-mode=handle] .smart-sortable-item.dragged:after,
.smart-sortable[drag-mode=handle] .smart-sortable-item.dragged:before,
.smart-sortable[drag-mode=handle][handle-visibility=visible]:not([disabled]) .smart-sortable-item:after,
.smart-sortable[drag-mode=handle][handle-visibility=visible]:not([disabled]) .smart-sortable-item:before {
    opacity: .5;
    visibility: visible
}

.smart-sortable[drag-mode=handle] .smart-sortable-item:before {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg)
}

.smart-sortable[drag-mode=handle] .smart-sortable-item:after {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.smart-sortable[drag-mode=handle]:not([disabled]) .smart-sortable-item:hover:after,
.smart-sortable[drag-mode=handle]:not([disabled]) .smart-sortable-item:hover:before {
    opacity: .5;
    visibility: visible;
    z-index: 9999999
}

.smart-sortable[drag-mode=handle][handle-position=bottom] .smart-sortable-item:after,
.smart-sortable[drag-mode=handle][handle-position=bottom] .smart-sortable-item:before,
.smart-sortable[drag-mode=handle][handle-position=top] .smart-sortable-item:after,
.smart-sortable[drag-mode=handle][handle-position=top] .smart-sortable-item:before {
    align-items: center;
    left: calc(50% - 12.5px);
    left: calc(50% - var(--smart-sortable-handle-size)/2);
    top: 100%;
    -webkit-transform: none;
    transform: none
}

.smart-sortable[drag-mode=handle][handle-position=bottom] .smart-sortable-item:after {
    align-items: flex-start
}

.smart-sortable[drag-mode=handle][handle-position=top] .smart-sortable-item:before {
    top: -25px;
    top: calc(var(--smart-sortable-handle-size)*-1)
}

.smart-sortable[drag-mode=handle][handle-position=top] .smart-sortable-item:after {
    align-items: flex-end;
    top: -25px;
    top: calc(var(--smart-sortable-handle-size)*-1)
}

.smart-sortable[right-to-left] .smart-column-panel-label,
.smart-sortable[right-to-left] .smart-sortable-items-parent {
    direction: rtl
}

smart-splitter {
    height: 450px;
    height: var(--smart-splitter-default-height);
    position: relative;
    width: 450px;
    width: var(--smart-splitter-default-width)
}

smart-splitter[dragged] {
    cursor: w-resize
}

smart-splitter[orientation=horizontal][dragged] {
    cursor: s-resize
}

smart-splitter-item>.smart-container {
    overflow: hidden;
    padding: 0;
    padding: var(--smart-splitter-item-padding);
    position: relative
}

.smart-splitter smart-splitter-bar {
    min-width: 5px;
    overflow: hidden;
    position: relative;
    touch-action: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 10px;
    width: var(--smart-splitter-bar-size)
}

.smart-splitter smart-splitter-bar>.smart-container {
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center
}

.smart-splitter smart-splitter-bar.smart-element {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #323232;
    border-color: var(--smart-surface-color);
    border-radius: 0;
    border-radius: initial;
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-splitter smart-splitter-bar[focus] .smart-splitter-resize-button>span,
.smart-splitter smart-splitter-bar[focus] .smart-splitter-resize-button>span:after,
.smart-splitter smart-splitter-bar[focus] .smart-splitter-resize-button>span:before {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active);
    border-color: #fff;
    border-color: var(--smart-ui-state-color-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-splitter smart-splitter-bar[focus].smart-element {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    outline: 0
}

.smart-splitter smart-splitter-bar[locked] .smart-splitter-resize-button>span {
    visibility: hidden
}

.smart-splitter smart-splitter-bar[locked] .smart-splitter-resize-button>span:after,
.smart-splitter smart-splitter-bar[locked] .smart-splitter-resize-button>span:before {
    content: none
}

.smart-splitter smart-splitter-bar[locked][hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-splitter smart-splitter-bar[locked][focus] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-splitter smart-splitter-bar[show-far-button] .smart-splitter-far-collapse-button,
.smart-splitter smart-splitter-bar[show-near-button] .smart-splitter-near-collapse-button {
    visibility: visible;
    width: 100%
}

.smart-splitter smart-splitter-bar[item-collapsed] {
    cursor: auto
}

.smart-splitter smart-splitter-bar[item-collapsed]>.smart-container {
    flex-direction: row
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-resize-button {
    display: none
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-resize-button>span:after,
.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-resize-button>span:before {
    content: normal
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-far-collapse-button>span,
.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-near-collapse-button>span {
    -webkit-transform: rotate(270deg);
    transform: rotate(90deg)
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-far-collapse-button.smart-visibility-hidden,
.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-near-collapse-button.smart-visibility-hidden {
    width: auto
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-near-collapse-button>span {
    -webkit-transform: translate(-50%, -50%) rotate(180deg);
    transform: translate(-50%, -50%) rotate(180deg)
}

.smart-splitter smart-splitter-bar[item-collapsed] .smart-splitter-far-collapse-button>span {
    -webkit-transform: translate(-50%, -50%) rotate(0deg);
    transform: translate(-50%, -50%) rotate(0deg)
}

.smart-splitter smart-splitter-item {
    overflow: hidden
}

.smart-splitter smart-splitter-item>.smart-container>.smart-content {
    height: 100%;
    overflow: auto;
    padding: 0;
    padding: var(--smart-splitter-item-content-padding);
    width: 100%
}

.smart-splitter smart-splitter-item.smart-element {
    background-color: inherit;
    border-radius: 0;
    border-radius: initial;
    color: inherit
}

.smart-splitter smart-splitter-item[collapsed] {
    overflow: hidden;
    padding: initial
}

.smart-splitter .smart-splitter {
    border: none;
    height: 100%;
    margin: 0;
    width: 100%
}

.smart-splitter .smart-splitter smart-splitter-bar {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-splitter>.smart-container {
    display: flex;
    overflow: inherit;
    position: relative
}

.smart-splitter>.smart-container>smart-splitter-item {
    flex-shrink: 0;
    height: 100%;
    width: auto;
    width: var(--smart-splitter-item-size)
}

.smart-splitter>.smart-container>smart-splitter-bar {
    flex-shrink: 0;
    height: 100%;
    height: var(--smart-splitter-bar-fit-size)
}

.smart-splitter>.smart-container>smart-splitter-bar[locked] {
    cursor: default
}

.smart-splitter>.smart-container>.smart-splitter-bar-feedback {
    flex-shrink: 0;
    height: 100%
}

.smart-splitter .smart-splitter-bar-feedback {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    min-width: 5px;
    opacity: .5;
    overflow: hidden;
    position: absolute;
    touch-action: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 10px;
    width: var(--smart-splitter-bar-size)
}

.smart-splitter .smart-splitter-bar-feedback.limit-reached {
    background-color: #b00020;
    background-color: var(--smart-error)
}

.smart-splitter .smart-splitter-resize-button {
    align-items: center;
    cursor: inherit;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 40px;
    justify-content: center;
    position: relative;
    width: 100%
}

.smart-splitter .smart-splitter-resize-button>span {
    background-color: #323232;
    background-color: var(--smart-surface-color);
    border: 1px solid #323232;
    border: 1px solid var(--smart-surface-color);
    border-radius: 50%;
    color: #323232;
    color: var(--smart-surface-color);
    cursor: inherit;
    height: 6px;
    width: 6px
}

.smart-splitter .smart-splitter-resize-button>span:after,
.smart-splitter .smart-splitter-resize-button>span:before {
    background-color: #323232;
    background-color: var(--smart-surface-color);
    border: 1px solid #323232;
    border: 1px solid var(--smart-surface-color);
    border-radius: 50%;
    color: #323232;
    color: var(--smart-surface-color);
    content: "";
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 4px;
    pointer-events: none;
    position: absolute;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 4px
}

.smart-splitter .smart-splitter-resize-button>span:before {
    left: 50%;
    top: calc(50% - 10px);
    top: calc(50% - var(--smart-splitter-bar-size))
}

.smart-splitter .smart-splitter-resize-button>span:after {
    left: 50%;
    top: calc(50% + 10px);
    top: calc(50% + var(--smart-splitter-bar-size))
}

.smart-splitter .smart-splitter-far-collapse-button,
.smart-splitter .smart-splitter-near-collapse-button {
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 20px;
    position: relative;
    visibility: hidden;
    width: 0
}

.smart-splitter .smart-splitter-far-collapse-button .smart-arrow,
.smart-splitter .smart-splitter-near-collapse-button .smart-arrow {
    height: auto;
    left: 50%;
    position: absolute;
    top: 50%;
    width: auto
}

.smart-splitter .smart-splitter-far-collapse-button .smart-arrow:after,
.smart-splitter .smart-splitter-near-collapse-button .smart-arrow:after {
    align-items: center;
    content: "\\00AB";

    display: flex;
    height: 100%;
    justify-content: center;
    line-height: normal;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-splitter .smart-splitter-far-collapse-button>span {
    -webkit-transform: translate(-50%, -50%) rotate(270deg);
    transform: translate(-50%, -50%) rotate(180deg)
}



.smart-splitter:not([readonly])>.smart-container>smart-splitter-bar[hover] {
    cursor: w-resize
}

.smart-splitter:not([dragged])>.smart-container>smart-splitter-bar:not([focus]) .smart-splitter-far-collapse-button,
.smart-splitter:not([dragged])>.smart-container>smart-splitter-bar:not([focus]) .smart-splitter-near-collapse-button {
    color: inherit
}

.smart-splitter:not([dragged])>.smart-container>smart-splitter-bar[hover]:not([item-collapsed]):not([focus]) .smart-splitter-far-collapse-button,
.smart-splitter:not([dragged])>.smart-container>smart-splitter-bar[hover]:not([item-collapsed]):not([focus]) .smart-splitter-near-collapse-button {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-splitter:not([dragged]) smart-splitter-bar.smart-element,
.smart-splitter:not([dragged]) smart-splitter-bar[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-splitter:not([dragged]) smart-splitter-bar[hover]:not([item-collapsed]):not([focus]) .smart-splitter-resize-button span,
.smart-splitter:not([dragged]) smart-splitter-bar[hover]:not([item-collapsed]):not([focus]) .smart-splitter-resize-button span:after,
.smart-splitter:not([dragged]) smart-splitter-bar[hover]:not([item-collapsed]):not([focus]) .smart-splitter-resize-button span:before {
    background-color: #333;
    background-color: var(--smart-ui-state-color-hover);
    border-color: #333;
    border-color: var(--smart-ui-state-color-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-splitter:not([dragged]) smart-splitter-bar[focus] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-splitter:not([dragged]) smart-splitter-bar[focus]:not([item-collapsed]) .smart-splitter-resize-button span,
.smart-splitter:not([dragged]) smart-splitter-bar[focus]:not([item-collapsed]) .smart-splitter-resize-button span:after,
.smart-splitter:not([dragged]) smart-splitter-bar[focus]:not([item-collapsed]) .smart-splitter-resize-button span:before {
    background-color: #fff;
    background-color: var(--smart-ui-state-color-active);
    border-color: #fff;
    border-color: var(--smart-ui-state-color-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-splitter:not([dragged]) smart-splitter-bar:not([item-collapsed]):not([focus]) .smart-splitter-far-collapse-button[hover],
.smart-splitter:not([dragged]) smart-splitter-bar:not([item-collapsed]):not([focus]) .smart-splitter-near-collapse-button[hover] {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-splitter[dragged] {
    cursor: w-resize;
    pointer-events: none;
    touch-action: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-splitter[dragged]:not([animation=none])>.smart-container>smart-splitter-item {
    transition: none
}

.smart-splitter[auto-fit-mode=overflow]>.smart-container {
    overflow: auto
}

.smart-splitter[orientation=horizontal]>.smart-container {
    flex-direction: column
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-item {
    height: auto;
    height: var(--smart-splitter-item-size);
    width: 100%
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar {
    height: 10px;
    height: var(--smart-splitter-bar-size) !important;
    min-height: 5px;
    width: 100%;
    width: var(--smart-splitter-bar-fit-size)
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar>.smart-container {
    flex-direction: row
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-far-collapse-button,
.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-near-collapse-button {
    height: 100%;
    width: 0
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-resize-button,
.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar[show-far-button] .smart-splitter-far-collapse-button,
.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar[show-near-button] .smart-splitter-near-collapse-button {
    height: 100%;
    width: 20px
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-far-collapse-button>span {
    -webkit-transform: translate(-50%, -45%) rotate(-90deg);
    transform: translate(-50%, -45%) rotate(-90deg)
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-near-collapse-button>span,
.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar[item-collapsed] .smart-splitter-far-collapse-button>span {
    -webkit-transform: translate(-50%, -50%) rotate(90deg);
    transform: translate(-50%, -50%) rotate(90deg)
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-resize-button>span:before {
    left: calc(50% - 10px);
    left: calc(50% - var(--smart-splitter-bar-size));
    top: 50%
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar .smart-splitter-resize-button>span:after {
    left: calc(50% + 10px);
    left: calc(50% + var(--smart-splitter-bar-size));
    top: 50%
}

.smart-splitter[orientation=horizontal]>.smart-container>smart-splitter-bar[item-collapsed] .smart-splitter-near-collapse-button>span {
    -webkit-transform: translate(-50%, -50%) rotate(0);
    transform: translate(-50%, -50%) rotate(-90deg)
}

.smart-splitter[orientation=horizontal]>.smart-container>.smart-splitter-bar-feedback {
    height: 10px;
    height: var(--smart-splitter-bar-size);
    min-height: 5px;
    width: 100%
}

.smart-splitter[orientation=horizontal] smart-splitter-item[collapsed] {
    min-height: 0;
    min-width: 0
}

.smart-splitter[orientation=horizontal]:not([resize-mode=none]):not([readonly])>.smart-container>smart-splitter-bar[hover]:not([locked]),
.smart-splitter[orientation=horizontal][dragged] {
    cursor: s-resize
}

.smart-splitter[resize-mode=none]>.smart-container>smart-splitter-bar {
    cursor: default
}

.smart-splitter[disabled]>.smart-container>smart-splitter-bar {
    border: none;
    box-shadow: none;
    cursor: default;
    outline: 0
}

.smart-splitter[dragging-not-allowed]>.smart-container>.smart-splitter-bar-feedback,
.smart-splitter[dragging-not-allowed]>.smart-container>smart-splitter-bar,
.smart-splitter[orientation][disabled]>.smart-container>smart-splitter-bar {
    cursor: default
}

.smart-splitter:not([animation=none]) .smart-splitter-far-collapse-button .smart-arrow,
.smart-splitter:not([animation=none]) .smart-splitter-near-collapse-button .smart-arrow {
    transition: -webkit-transform .2s ease-out;
    transition: transform .2s ease-out;
    transition: transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-splitter:not([animation=none])>.smart-container>smart-splitter-item.animate {
    transition: all .25s cubic-bezier(.4, 0, .2, 1)
}

.smart-splitter[orientation-change]:not([animation=none])>.smart-container>smart-splitter-item {
    transition: none
}

.smart-splitter[show-locked-items]>.smart-container>smart-splitter-item[locked]>.smart-container:after {
    content: "\\e821";
    content: var(--smart-icon-lock);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: calc(var(--smart-splitter-font-size)*2.5);
    left: 50%;
    opacity: .25;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-splitter[right-to-left] .smart-splitter>.smart-container {
    direction: ltr
}

.smart-splitter[right-to-left] smart-splitter-item>.smart-container>.smart-content {
    direction: rtl
}

smart-switch-button {
    height: 30px;
    height: var(--smart-switch-button-default-height);
    width: 40px;
    width: var(--smart-switch-button-default-width)
}

smart-switch-button[orientation=vertical] {
    height: 40px;
    height: var(--smart-switch-button-default-width);
    width: 30px;
    width: var(--smart-switch-button-default-height)
}

smart-switch-button.smart-element {
    background: 0 0;
    border: none;
    display: inline-block;
    overflow: visible
}

.smart-switch-button .smart-thumb {
    align-self: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 100%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    cursor: pointer;
    height: 22px;
    height: var(--smart-switch-button-thumb-size);
    order: 2;
    pointer-events: all;
    position: relative;
    width: 22px;
    width: var(--smart-switch-button-thumb-size)
}

.smart-switch-button .smart-thumb:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 100%;
    content: "";
    display: block;
    height: 200%;
    left: 50%;
    opacity: .2;
    position: absolute;
    top: 50%;
    -webkit-transform: scale(0) translate(-50%, -50%);
    transform: scale(0) translate(-50%, -50%);
    -webkit-transform-origin: left top;
    transform-origin: left top;
    transition: .2s;
    width: 200%
}

.smart-switch-button .smart-thumb:active:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in;
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button .smart-container {
    font-size: inherit;
    position: relative;
    touch-action: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none
}

.smart-switch-button .smart-container:before {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-radius: 10px;
    content: "";
    height: 50%;
    left: 5%;
    position: absolute;
    top: 25%;
    width: 90%
}

.smart-switch-button .smart-inner-container {
    color: inherit;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: flex-start;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: calc(200% - 22px);
    width: calc(200% - var(--smart-switch-button-thumb-size))
}

.smart-switch-button .smart-false-content,
.smart-switch-button .smart-true-content {
    box-sizing: border-box;
    color: inherit;
    display: inline-block;
    font-size: inherit;
    font-weight: inherit;
    text-align: center
}

.smart-switch-button .smart-false-content-container,
.smart-switch-button .smart-true-content-container {
    align-items: center;
    background-clip: content-box;
    color: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    padding: 2px 0;
    width: calc(50% - 11px);
    width: calc((100% - var(--smart-switch-button-thumb-size))/2)
}

.smart-switch-button .smart-true-content-container {
    order: 1
}

.smart-switch-button .smart-false-content-container,
.smart-switch-button[inverted] .smart-true-content-container {
    order: 3
}

.smart-switch-button:not([animation=none]) .smart-container:before {
    transition: opacity .2s ease-in-out, background .2s ease-in-out
}

.smart-switch-button:not([animation=none]):not([dragged]):not([checked=null]) .smart-inner-container {
    transition: left .2s ease-in-out
}

.smart-switch-button:not([animation=none])[orientation=vertical]:not([dragged]):not([checked=null]) .smart-inner-container {
    transition: top .2s ease-in-out
}

.smart-switch-button[hover] {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-hover)
}

.smart-switch-button:focus .smart-thumb,
.smart-switch-button[checked] .smart-thumb {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-switch-button:focus .smart-thumb:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in;
    background-color: #005c99;
    background-color: var(--smart-primary);
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[readonly] {
    pointer-events: none
}

.smart-switch-button[disabled] .smart-thumb:before {
    content: none
}

.smart-switch-button[checked] .smart-thumb:active:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[checked] .smart-container:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    opacity: .4
}

.smart-switch-button[checked] .smart-inner-container {
    left: calc(-100% - -22px);
    left: calc((100% - var(--smart-switch-button-thumb-size))*-1)
}

.smart-switch-button[checked]:focus .smart-thumb:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[checked][inverted] .smart-inner-container {
    left: 0
}

.smart-switch-button[checked=null] .smart-inner-container,
.smart-switch-button[checked=null][inverted] .smart-inner-container {
    left: calc(-50% + 11px);
    left: calc(-50% + var(--smart-switch-button-thumb-size)/2)
}

.smart-switch-button[checked]:not([animation=none]) .smart-thumb:active:before,
.smart-switch-button[checked]:not([animation=none]):focus .smart-thumb:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in
}

.smart-switch-button[checked][orientation=vertical] .smart-thumb {
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-switch-button[checked][orientation=vertical] .smart-thumb:active:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[checked][orientation=vertical] .smart-container:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    opacity: .4
}

.smart-switch-button[checked][orientation=vertical]:focus .smart-thumb:before {
    background-color: #005c99;
    background-color: var(--smart-primary);
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[checked][orientation=vertical]:not([animation=none]) .smart-thumb:active:before,
.smart-switch-button[checked][orientation=vertical]:not([animation=none]):focus .smart-thumb:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in
}

.smart-switch-button[checked=null] .smart-thumb {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.smart-switch-button[checked=null] .smart-false-content,
.smart-switch-button[checked=null] .smart-true-content {
    visibility: hidden
}

.smart-switch-button[checked=null] .smart-false-content-container,
.smart-switch-button[checked=null] .smart-true-content-container {
    color: transparent
}

.smart-switch-button[inverted] .smart-inner-container {
    left: calc(-100% - -22px);
    left: calc((100% - var(--smart-switch-button-thumb-size))*-1)
}

.smart-switch-button[inverted] .smart-false-content-container {
    order: 1
}

.smart-switch-button[orientation=vertical] .smart-thumb {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: var(--smart-elevation-2);
    height: 22px;
    height: var(--smart-switch-button-thumb-size);
    width: 22px;
    width: var(--smart-switch-button-thumb-size)
}

.smart-switch-button[orientation=vertical] .smart-thumb:before {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border)
}

.smart-switch-button[orientation=vertical] .smart-thumb:active:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in
}

.smart-switch-button[orientation=vertical] .smart-thumb:active:before,
.smart-switch-button[orientation=vertical] .smart-thumb:focus .smart-thumb:before {
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%)
}

.smart-switch-button[orientation=vertical] .smart-container:before {
    border-radius: 10px;
    content: "";
    height: 90%;
    left: 25%;
    position: absolute;
    top: 5%;
    width: 50%
}

.smart-switch-button[orientation=vertical] .smart-inner-container {
    flex-direction: column;
    height: calc(200% - 22px);
    height: calc(200% - var(--smart-switch-button-thumb-size));
    left: 0;
    top: 0;
    width: 100%
}

.smart-switch-button[orientation=vertical] .smart-false-content-container,
.smart-switch-button[orientation=vertical] .smart-true-content-container {
    height: calc(50% - 11px);
    height: calc((100% - var(--smart-switch-button-thumb-size))/2);
    padding: 0 2px;
    width: 100%
}

.smart-switch-button[orientation=vertical]:focus .smart-thumb:before {
    -webkit-animation: button-wave-effect .1s ease-in;
    animation: button-wave-effect .1s ease-in
}

.smart-switch-button[orientation=vertical][checked] .smart-inner-container {
    left: 0;
    top: calc(-100% - -22px);
    top: calc((100% - var(--smart-switch-button-thumb-size))*-1)
}

.smart-switch-button[orientation=vertical][checked][inverted] .smart-inner-container {
    top: 0
}

.smart-switch-button[orientation=vertical][checked=null] .smart-inner-container {
    top: calc(-50% + 11px);
    top: calc(-50% + var(--smart-switch-button-thumb-size)/2)
}

.smart-switch-button[orientation=vertical][checked=null][inverted] .smart-inner-container {
    left: 0;
    top: calc(-50% + 11px);
    top: calc(-50% + var(--smart-switch-button-thumb-size)/2)
}

.smart-switch-button[orientation=vertical][inverted] .smart-inner-container {
    left: 0;
    top: calc(-100% - -22px);
    top: calc((100% - var(--smart-switch-button-thumb-size))*-1)
}

.smart-switch-button[right-to-left][checked]:not([orientation=vertical]) .smart-inner-container,
.smart-switch-button[right-to-left][inverted]:not([orientation=vertical]) .smart-inner-container {
    left: 0
}

.smart-switch-button[right-to-left]:not([orientation=vertical]) .smart-inner-container,
.smart-switch-button[right-to-left][checked][inverted]:not([orientation=vertical]) .smart-inner-container {
    left: calc(-100% - -22px);
    left: calc((100% - var(--smart-switch-button-thumb-size))*-1)
}

.smart-switch-button[right-to-left][checked=null]:not([orientation=vertical]) .smart-inner-container {
    left: calc(-50% + 11px);
    left: calc(-50% + var(--smart-switch-button-thumb-size)/2)
}

@-webkit-keyframes button-wave-effect {
    0% {
        -webkit-transform: scale(.2) translate(-50%, -50%);
        transform: scale(.2) translate(-50%, -50%)
    }

    50% {
        -webkit-transform: scale(.5) translate(-50%, -50%);
        transform: scale(.5) translate(-50%, -50%)
    }

    to {
        -webkit-transform: scale(1) translate(-50%, -50%);
        transform: scale(1) translate(-50%, -50%)
    }
}

@keyframes button-wave-effect {
    0% {
        -webkit-transform: scale(.2) translate(-50%, -50%);
        transform: scale(.2) translate(-50%, -50%)
    }

    50% {
        -webkit-transform: scale(.5) translate(-50%, -50%);
        transform: scale(.5) translate(-50%, -50%)
    }

    to {
        -webkit-transform: scale(1) translate(-50%, -50%);
        transform: scale(1) translate(-50%, -50%)
    }
}

smart-table table:not(.smart-table-container) {
    display: none
}

smart-table tr.expanded .hierarchy-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-table {
    border-radius: 4px 4px 4px 4px;
    border-radius: var(--smart-border-top-left-radius) var(--smart-border-top-right-radius) var(--smart-border-bottom-right-radius) var(--smart-border-bottom-left-radius);
    display: block;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: auto;
    height: var(--smart-table-default-height);
    width: 100%;
    width: var(--smart-table-default-width)
}

.smart-table>.smart-container {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: inherit;
    max-height: inherit;
    overflow: auto;
    position: relative
}

.smart-table .smart-table {
    background-color: #fff
}

.smart-table table {
    border-collapse: collapse;
    border-radius: inherit;
    table-layout: fixed
}

.smart-table thead th {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    font-weight: 500;
    text-align: left
}

.smart-table thead th .sort-by {
    display: none;
    height: 16px;
    opacity: 0;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    visibility: hidden;
    width: 16px
}

.smart-table thead th .sort-by:before {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    content: "\\e83f";
    content: var(--smart-icon-up);
    display: flex;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    position: relative;
    text-decoration: inherit;
    text-transform: none;
    width: 100%
}

.smart-table thead th .sort-by:after {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 50%;
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    font-size: 8px;
    height: 50%;
    justify-content: center;
    left: 100%;
    padding: 3px;
    position: absolute;
    top: 0;
    width: 50%
}

.smart-table td,
.smart-table th {
    overflow: hidden;
    padding: 12px;
    padding: var(--smart-table-cell-padding);
    text-overflow: ellipsis;
    vertical-align: middle
}

.smart-table thead th .sort-by.asc,
.smart-table thead th .sort-by.desc {
    display: inline-block;
    opacity: 1;
    visibility: visible
}

.smart-table thead th .sort-by.desc:before {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg)
}

.smart-table thead th:not(.smart-table-select-all) {
    opacity: .9
}

.smart-table thead th.freeze-far,
.smart-table thead th.freeze-near {
    opacity: 1
}

.smart-table thead tr {
    height: 56px;
    height: var(--smart-table-column-header-height)
}

.smart-table thead tr:first-child th {
    border-top: none
}

.smart-table tbody tr {
    height: 48px;
    height: var(--smart-table-row-height)
}

.smart-table tbody tr.last-visible {
    height: unset
}

.smart-table tbody tr.last-visible.sized {
    box-shadow: inset 0 1px 0 0 #e0e0e0;
    box-shadow: inset 0 var(--smart-border-width) 0 0 var(--smart-border)
}

.smart-table tbody+tbody {
    border-top: 2px solid #e0e0e0;
    border-top: 2px solid var(--smart-border)
}

.smart-table tfoot tr {
    height: 48px;
    height: var(--smart-table-row-height)
}

.smart-table tfoot td {
    --smart-surface: var(--smart-background);
    --smart-surface-color: var(--smart-background-color);
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px)
}

.smart-table th,
.smart-table tr[row-id] td {
    white-space: nowrap
}

.smart-table th {
    border-top-color: #e0e0e0;
    border-top-width: 1px;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

.smart-table th:hover .column-menu,
.smart-table th[column-menu-button] .column-menu {
    height: 100%;
    overflow: hidden;
    position: absolute;
    right: 3px;
    text-overflow: ellipsis;
    width: 25px
}

.smart-table th:hover .column-menu:after,
.smart-table th[column-menu-button] .column-menu:after {
    color: #323232;
    color: var(--smart-surface-color);
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 16px;
    font-weight: 700;
    width: 100%
}

.smart-table th>.wrapper {
    align-items: center;
    display: flex;
    overflow: hidden;
    position: relative
}

.smart-table th>.wrapper>.label {
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-table th.smart-table-select-all {
    width: 48px;
    width: calc(var(--smart-check-box-default-size)*3)
}

.smart-table td.indeterminate>div:after,
.smart-table th.smart-table-select-all.indeterminate>div:after {
    content: "";
    height: 8px;
    height: calc(var(--smart-check-box-default-size)*.5);
    position: absolute;
    width: 8px;
    width: calc(var(--smart-check-box-default-size)*.5)
}

.smart-table th.smart-table-select-all.indeterminate>div {
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-table th.smart-table-select-all.indeterminate>div:after {
    background-color: #fff;
    background-color: var(--smart-primary-color)
}

.smart-table th.column-header {
    border-bottom: none;
    text-align: center
}

.smart-table th.column-header:empty {
    border-top: none
}

.smart-table td {
    border-top-color: #e0e0e0;
    border-top-width: 1px;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

.smart-table td div {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: normal;
    margin: 0;
    padding: 0
}

.smart-table td span {
    line-height: normal
}

.smart-table td.no-edit {
    background-color: rgba(0, 0, 0, .02)
}

.smart-table td.indeterminate>div {
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-table td.indeterminate>div:after {
    background-color: #fff;
    background-color: var(--smart-primary-color)
}

.smart-table td.editing {
    padding: 0
}

.smart-table td.editing .smart-table-editor {
    height: 100%;
    width: 100%
}

.smart-table td.editing .smart-table-editor.standard {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: none;
    font-family: inherit;
    font-size: inherit;
    padding: 12px;
    padding: var(--smart-table-cell-padding)
}

.smart-table .smart-table-toolbar-button:before,
.smart-table smart-pager .smart-pager-button:before {
    color: #fff;
    color: var(--smart-secondary-color);
    font-size: 10px;
    font-size: calc(var(--smart-font-size) - 4px);
    opacity: 0;
    padding: 7px
}

.smart-table td.editing .smart-table-editor.standard:focus {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    outline: 0
}

.smart-table td.group-header>div,
.smart-table td.tree-cell>div {
    align-items: center;
    display: flex;
    flex-direction: row
}

.smart-table td.tree-cell>div div:nth-child(2) {
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 21px);
    width: calc(100% - var(--smart-table-arrow-margin) - var(--smart-table-arrow-size))
}

.smart-table td.editing.invalid {
    overflow: visible;
    position: relative
}

.smart-table td.editing.invalid:before {
    background-color: #b00020;
    background-color: var(--smart-error);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #fff;
    color: var(--smart-secondary-color);
    content: attr(validation-message);
    font-size: 10px;
    font-size: calc(var(--smart-font-size) - 4px);
    opacity: 0;
    padding: 7px;
    position: absolute;
    top: -100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    visibility: hidden
}

.smart-table smart-pager .smart-pager-far-buttons-container,
.smart-table smart-pager .smart-pager-near-buttons-container {
    font-size: 28px;
    font-size: calc(var(--smart-font-size)*2)
}

.smart-table td.editing.invalid:hover:before {
    opacity: .7;
    -webkit-transform: scale(1);
    transform: scale(1);
    visibility: visible
}

.smart-table td.editing.invalid .smart-table-editor {
    border-color: #b00020;
    border-color: var(--smart-error)
}

.smart-table td.smart-table-select-row:hover,
.smart-table th.smart-table-select-all:hover {
    overflow: visible;
    z-index: 99
}

.smart-table td.smart-table-select-row>div,
.smart-table th.smart-table-select-all>div {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    height: var(--smart-check-box-default-size);
    justify-content: center;
    left: 50%;
    padding: 8px;
    position: absolute;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 16px;
    width: var(--smart-check-box-default-size)
}

.smart-table td.smart-table-select-row>div:before,
.smart-table th.smart-table-select-all>div:before {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-radius: 50%;
    content: "";
    height: 100%;
    opacity: .1;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: center;
    transform-origin: center;
    width: 100%
}

.smart-table td.smart-table-select-row>div:hover:before,
.smart-table th.smart-table-select-all>div:hover:before {
    -webkit-transform: scale(2.5);
    transform: scale(2.5)
}

.smart-table td.smart-table-select-row>div:hover:active:before,
.smart-table th.smart-table-select-all>div:hover:active:before {
    -webkit-animation-duration: .2s;
    animation-duration: .2s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-name: active;
    animation-name: active;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-table td.smart-table-select-row.selected>div,
.smart-table th.smart-table-select-all.selected>div {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-table td.smart-table-select-row.selected>div:after,
.smart-table th.smart-table-select-all.selected>div:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

.smart-table td.smart-table-select-row.selected>div:before,
.smart-table th.smart-table-select-all.selected>div:before {
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-table .smart-table-select-all.freeze-near {
    background-color: #fefefe;
    background-color: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.smart-table smart-pager.smart-element {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-bottom: none;
    border-left: none;
    border-right: none;
    bottom: 0;
    display: none;
    height: 56px;
    height: var(--smart-table-header-footer-height);
    left: 0;
    min-width: 0;
    position: -webkit-sticky;
    position: sticky
}

.smart-table smart-pager>.smart-container {
    justify-content: flex-end
}

.smart-table smart-pager .smart-pager-near-buttons-container.near {
    order: 2
}

.smart-table smart-pager .smart-pager-near-buttons-container.far {
    order: 3
}

.smart-table smart-pager .smart-pager-size-selector-and-label-container,
.smart-table[right-to-left] smart-pager .smart-pager-far-buttons-container {
    order: 0
}

.smart-table smart-pager .smart-pager-label {
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    opacity: .7
}

.smart-table smart-pager .smart-pager-summary-container.smart-pager-label {
    margin: 0 32px 0 24px;
    order: 1
}

.smart-table smart-pager .smart-pager-button:before {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    content: attr(tooltip);
    position: absolute;
    top: -125%;
    -webkit-transform: scale(0);
    transform: scale(0);
    visibility: hidden
}

.smart-table smart-pager .smart-pager-button:hover:before {
    opacity: .7;
    -webkit-transform: scale(1);
    transform: scale(1);
    visibility: visible
}

.smart-table .smart-pager .smart-pager-button {
    overflow: visible
}

.smart-table .smart-table-container:focus {
    outline: 0
}

.smart-table .smart-table-container:focus td[focus]:after {
    border: 1px solid #333;
    border: 1px solid var(--smart-ui-state-color-focus);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 1px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: calc(100% - 1px)
}

.smart-table .smart-table-container:focus td[focus]:not(.freeze-near):not(.freeze-far) {
    position: relative
}

.smart-table .smart-table-header {
    background-color: #fefefe;
    background-color: var(--smart-background);
    display: none;
    height: 56px;
    height: var(--smart-table-header-footer-height);
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2
}

.smart-table .smart-table-header .smart-input,
.smart-table .smart-table-header .smart-table-filter-template-container {
    display: none;
    height: 100%;
    width: 100%
}

.smart-table .smart-table-header .smart-table-toolbar-button.conditional-formatting {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-right: none;
    border-top: none;
    display: none;
    height: 100%;
    width: 56px;
    width: var(--smart-table-header-footer-height)
}

.smart-table .smart-table-header .smart-table-toolbar-button.conditional-formatting:before {
    left: unset;
    right: 0
}

.smart-table .smart-table-toolbar-button {
    --smart-border-top-left-radius: 0;
    --smart-border-top-right-radius: 0;
    --smart-border-bottom-left-radius: 0;
    --smart-border-bottom-right-radius: 0;
    --smart-button-padding: 0;
    border-bottom: none;
    border-top: none;
    min-height: 0;
    overflow: visible;
    position: relative
}

.smart-table .smart-table-toolbar-button:before {
    word-wrap: break-word;
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-sizing: border-box;
    content: attr(tooltip);
    left: -24px;
    left: calc(var(--smart-table-row-height)*-1/2);
    position: absolute;
    text-transform: none;
    top: 125%;
    -webkit-transform: scale(0);
    transform: scale(0);
    visibility: hidden;
    white-space: normal;
    width: 96px;
    width: calc(var(--smart-table-row-height)*2);
    z-index: 1000
}

.smart-table .smart-table-toolbar-button:after {
    align-items: center;
    content: "\\e800";
    content: var(--smart-icon-table);
    display: flex;
    font-family: smart-icons;
    font-size: 20px;
    height: 100%;
    justify-content: center;
    opacity: .4;
    pointer-events: none;
    position: absolute;
    width: 100%
}

.smart-table .smart-table-toolbar-button:hover:before {
    opacity: .7;
    -webkit-transform: scale(1);
    transform: scale(1);
    visibility: visible
}

.smart-table .smart-table-toolbar-button>button {
    overflow: hidden
}

.smart-table .smart-table-toolbar-button.conditional-formatting>button:after {
    align-items: center;
    content: "\\f537";
    content: var(--smart-icon-less-than-equal);
    display: flex;
    font-family: smart-icons;
    font-size: 16px;
    height: 100%;
    justify-content: center;
    left: 8px;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: 8px;
    width: 100%
}

.smart-table .smart-table-toolbar-button.fields {
    border-right: none
}

.smart-table .smart-table-toolbar-button.fields:before {
    left: unset;
    right: 0;
    width: 96px;
    width: calc(var(--smart-table-row-height)*2)
}

.smart-table .smart-table-toolbar-button.fields>button:after {
    align-items: center;
    content: "\\e833";
    content: var(--smart-icon-settings);
    display: flex;
    font-family: smart-icons;
    font-size: 16px;
    height: 100%;
    justify-content: center;
    left: 8px;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: 8px;
    width: 100%
}

.smart-table .smart-table-filter-row smart-button {
    --smart-button-padding: 0
}

.smart-table .smart-table-filter-row smart-button button:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    text-decoration: line-through;
    width: 100%
}

.smart-table .smart-table-filter-row>td>div {
    --smart-filter-row-content-height: calc(var(--smart-table-row-height) - var(--smart-table-cell-padding)*2 - var(--smart-border-width));
    grid-column-gap: 2px;
    -webkit-column-gap: 2px;
    column-gap: 2px;
    display: grid;
    grid-template-columns: 1fr var(--smart-filter-row-content-height) var(--smart-filter-row-content-height);
    grid-template-rows: 100%;
    height: var(--smart-filter-row-content-height)
}

.smart-table .smart-table-filter-row>td.no-filter {
    opacity: .6;
    pointer-events: none
}

.smart-table .smart-table-filter-row .filter-value {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: inherit;
    min-width: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding)
}

.smart-table .smart-table-filter-row .filter-value:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-table .smart-table-filter-row .filter-value:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-table .smart-table-filter-row .filter-value[type=number] {
    -webkit-appearance: none;
    -moz-appearance: textfield
}

.smart-table .smart-table-filter-row .filter-value::-webkit-inner-spin-button,
.smart-table .smart-table-filter-row .filter-value::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield
}

.smart-table .smart-table-filter-row .smart-input {
    --smart-editor-addon-width: 100%;
    --smart-editor-label-padding: 0;
    height: 100%;
    width: unset
}

.smart-table .smart-table-filter-row .smart-input .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-table .smart-table-filter-row .smart-input .smart-drop-down-button .arrow:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    -webkit-transform: none !important;
    transform: none !important
}

.smart-table .smart-table-row-detail {
    height: 48px;
    height: var(--smart-table-row-detail-height)
}

.smart-table .smart-table-row-detail>td {
    border: none;
    padding: 0
}

.smart-table .smart-table-row-detail .smart-table-detail-container {
    height: 24px;
    height: calc(var(--smart-table-row-detail-height) - var(--smart-table-cell-padding)*2);
    overflow: hidden;
    padding: 0 12px;
    padding: 0 var(--smart-table-cell-padding)
}

.smart-table .smart-table-row-detail.collapsed {
    height: 0
}

.smart-table .smart-table-row-detail.collapsed .smart-table-detail-container {
    height: 0;
    padding-bottom: 0;
    padding-top: 0
}

.smart-table .smart-table-cell-template {
    display: contents;
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-table .disable-select td.smart-table-select-row>div {
    opacity: .2;
    pointer-events: none
}

.smart-table .dragged,
.smart-table .drop-column {
    position: relative
}

.smart-table .drop-column:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    content: "";
    height: 100%;
    position: absolute;
    top: 0;
    width: 2px
}

.smart-table .freeze-far,
.smart-table .freeze-near {
    background-color: #fefefe;
    background-color: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    opacity: 1;
    position: -webkit-sticky;
    position: sticky;
    z-index: 1
}

.smart-table .drop-column.left:after {
    left: 0
}

.smart-table .drop-column.right:after {
    right: 0
}

.smart-table .freeze-near {
    box-shadow: 1px 0 0 0 #e0e0e0;
    box-shadow: 1px 0 0 0 var(--smart-border);
    left: 0
}

.smart-table .freeze-far {
    box-shadow: -1px 0 0 0 #e0e0e0;
    box-shadow: -1px 0 0 0 var(--smart-border);
    right: 0
}

.smart-table .smart-table-virtualization-container {
    border: none;
    height: 100%;
    padding: 0;
    width: 100%
}

.smart-table[conditional-formatting-button] .smart-table-container,
.smart-table[conditional-formatting-button] .smart-table-virtualization-container,
.smart-table[filtering]:not([filter-row]) .smart-table-container,
.smart-table[filtering]:not([filter-row]) .smart-table-virtualization-container,
.smart-table[paging] .smart-table-container,
.smart-table[paging] .smart-table-virtualization-container {
    height: calc(100% - 56px);
    height: calc(100% - var(--smart-table-header-footer-height))
}

.smart-table .smart-table-virtualization-container .smart-scroll-viewer-content-container {
    padding: 0
}

.smart-table .hierarchy-arrow {
    cursor: pointer;
    margin-right: 5px;
    margin-right: var(--smart-table-arrow-margin);
    width: 16px;
    width: var(--smart-table-arrow-size)
}

.smart-table .group-label-name {
    display: unset;
    display: var(--smart-table-group-name-display)
}

.smart-table .group-label-value {
    font-weight: 700
}

.smart-table .group-label-count {
    display: unset;
    display: var(--smart-table-group-count-display)
}

.smart-table .outline-level-1 {
    padding-left: 30px;
    padding-left: var(--smart-table-indent)
}

.smart-table .outline-level-1.tree-leaf {
    padding-left: 51px;
    padding-left: calc(var(--smart-table-indent) + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-2 {
    padding-left: 60px;
    padding-left: calc(var(--smart-table-indent)*2)
}

.smart-table .outline-level-2.tree-leaf {
    padding-left: 81px;
    padding-left: calc(var(--smart-table-indent)*2 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-3 {
    padding-left: 90px;
    padding-left: calc(var(--smart-table-indent)*3)
}

.smart-table .outline-level-3.tree-leaf {
    padding-left: 111px;
    padding-left: calc(var(--smart-table-indent)*3 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-4 {
    padding-left: 120px;
    padding-left: calc(var(--smart-table-indent)*4)
}

.smart-table .outline-level-4.tree-leaf {
    padding-left: 141px;
    padding-left: calc(var(--smart-table-indent)*4 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-5 {
    padding-left: 150px;
    padding-left: calc(var(--smart-table-indent)*5)
}

.smart-table .outline-level-5.tree-leaf {
    padding-left: 171px;
    padding-left: calc(var(--smart-table-indent)*5 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-6 {
    padding-left: 180px;
    padding-left: calc(var(--smart-table-indent)*6)
}

.smart-table .outline-level-6.tree-leaf {
    padding-left: 201px;
    padding-left: calc(var(--smart-table-indent)*6 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-7 {
    padding-left: 210px;
    padding-left: calc(var(--smart-table-indent)*7)
}

.smart-table .outline-level-7.tree-leaf {
    padding-left: 231px;
    padding-left: calc(var(--smart-table-indent)*7 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-8 {
    padding-left: 240px;
    padding-left: calc(var(--smart-table-indent)*8)
}

.smart-table .outline-level-8.tree-leaf {
    padding-left: 261px;
    padding-left: calc(var(--smart-table-indent)*8 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-9 {
    padding-left: 270px;
    padding-left: calc(var(--smart-table-indent)*9)
}

.smart-table .outline-level-9.tree-leaf {
    padding-left: 291px;
    padding-left: calc(var(--smart-table-indent)*9 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table .outline-level-10 {
    padding-left: 300px;
    padding-left: calc(var(--smart-table-indent)*10)
}

.smart-table .outline-level-10.tree-leaf {
    padding-left: 321px;
    padding-left: calc(var(--smart-table-indent)*10 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-1 {
    padding-right: 30px;
    padding-right: var(--smart-table-indent)
}

.smart-table[right-to-left] .outline-level-1.tree-leaf {
    padding-right: 51px;
    padding-right: calc(var(--smart-table-indent) + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-2 {
    padding-right: 60px;
    padding-right: calc(var(--smart-table-indent)*2)
}

.smart-table[right-to-left] .outline-level-2.tree-leaf {
    padding-right: 81px;
    padding-right: calc(var(--smart-table-indent)*2 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-3 {
    padding-right: 90px;
    padding-right: calc(var(--smart-table-indent)*3)
}

.smart-table[right-to-left] .outline-level-3.tree-leaf {
    padding-right: 111px;
    padding-right: calc(var(--smart-table-indent)*3 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-4 {
    padding-right: 120px;
    padding-right: calc(var(--smart-table-indent)*4)
}

.smart-table[right-to-left] .outline-level-4.tree-leaf {
    padding-right: 141px;
    padding-right: calc(var(--smart-table-indent)*4 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-5 {
    padding-right: 150px;
    padding-right: calc(var(--smart-table-indent)*5)
}

.smart-table[right-to-left] .outline-level-5.tree-leaf {
    padding-right: 171px;
    padding-right: calc(var(--smart-table-indent)*5 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-6 {
    padding-right: 180px;
    padding-right: calc(var(--smart-table-indent)*6)
}

.smart-table[right-to-left] .outline-level-6.tree-leaf {
    padding-right: 201px;
    padding-right: calc(var(--smart-table-indent)*6 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-7 {
    padding-right: 210px;
    padding-right: calc(var(--smart-table-indent)*7)
}

.smart-table[right-to-left] .outline-level-7.tree-leaf {
    padding-right: 231px;
    padding-right: calc(var(--smart-table-indent)*7 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-8 {
    padding-right: 240px;
    padding-right: calc(var(--smart-table-indent)*8)
}

.smart-table[right-to-left] .outline-level-8.tree-leaf {
    padding-right: 261px;
    padding-right: calc(var(--smart-table-indent)*8 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-9 {
    padding-right: 270px;
    padding-right: calc(var(--smart-table-indent)*9)
}

.smart-table[right-to-left] .outline-level-9.tree-leaf {
    padding-right: 291px;
    padding-right: calc(var(--smart-table-indent)*9 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table[right-to-left] .outline-level-10 {
    padding-right: 300px;
    padding-right: calc(var(--smart-table-indent)*10)
}

.smart-table[right-to-left] .outline-level-10.tree-leaf {
    padding-right: 321px;
    padding-right: calc(var(--smart-table-indent)*10 + var(--smart-table-arrow-size) + var(--smart-table-arrow-margin))
}

.smart-table.thead-dark table th {
    background-color: #212529;
    border-color: #32383e;
    color: #fff
}

.smart-table.thead-dark thead th .sort-by:before {
    color: #fff
}

.smart-table.thead-primary table th {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-table.thead-primary th.smart-table-select-all.selected>div,
.smart-table.thead-primary th.smart-table-select-all>div {
    border-color: #fff;
    border-color: var(--smart-primary-color)
}

.smart-table.thead-primary th.smart-table-select-all.indeterminate>div {
    background-color: #fff;
    background-color: var(--smart-primary-color)
}

.smart-table.thead-secondary table th {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-color: #2d2d30;
    border-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-table.thead-surface table th {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #f5f5f5;
    border-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-table.thead-light table th {
    background-color: #e9ecef;
    border-color: #dee2e6;
    color: #495057
}

.smart-table.table-dark table {
    background-color: #212529;
    color: #fff
}

.smart-table.table-dark thead th .sort-by:before {
    color: #fff
}

.smart-table.table-dark.table-bordered table {
    border: 0
}

.smart-table.table-dark.table-striped table tbody tr:nth-of-type(odd) {
    background-color: hsla(0, 0%, 100%, .05)
}

.smart-table.table-dark.table-hover table tbody tr:hover {
    background-color: hsla(0, 0%, 100%, .075)
}

.smart-table.table-bordered table {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border)
}

.smart-table.table-bordered table thead td,
.smart-table.table-bordered table thead th {
    border-bottom-width: 2px
}

.smart-table.table-bordered table td,
.smart-table.table-bordered table th {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border)
}

.smart-table.table-striped table tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05)
}

.smart-table.table-hover table tbody tr:hover {
    background-color: rgba(0, 0, 0, .075)
}

.smart-table.table-hover table .smart-table-primary:hover,
.smart-table.table-hover table .smart-table-primary:hover>td,
.smart-table.table-hover table .smart-table-primary:hover>th {
    background-color: #9fcdff
}

.smart-table.table-hover table .smart-table-secondary:hover,
.smart-table.table-hover table .smart-table-secondary:hover>td,
.smart-table.table-hover table .smart-table-secondary:hover>th {
    background-color: #c8cbcf
}

.smart-table.table-hover table .smart-table-success:hover,
.smart-table.table-hover table .smart-table-success:hover>td,
.smart-table.table-hover table .smart-table-success:hover>th {
    background-color: #b1dfbb
}

.smart-table.table-hover table .smart-table-info:hover,
.smart-table.table-hover table .smart-table-info:hover>td,
.smart-table.table-hover table .smart-table-info:hover>th {
    background-color: #abdde5
}

.smart-table.table-hover table .smart-table-warning:hover,
.smart-table.table-hover table .smart-table-warning:hover>td,
.smart-table.table-hover table .smart-table-warning:hover>th {
    background-color: #ffe8a1
}

.smart-table.table-hover table .smart-table-danger:hover,
.smart-table.table-hover table .smart-table-danger:hover>td,
.smart-table.table-hover table .smart-table-danger:hover>th {
    background-color: #f1b0b7
}

.smart-table.table-hover table .smart-table.table-light table:hover,
.smart-table.table-hover table .smart-table.table-light table:hover>td,
.smart-table.table-hover table .smart-table.table-light table:hover>th {
    background-color: #ececf6
}

.smart-table.table-hover table .smart-table.table-dark table:hover,
.smart-table.table-hover table .smart-table.table-dark table:hover>td,
.smart-table.table-hover table .smart-table.table-dark table:hover>th {
    background-color: #b9bbbe
}

.smart-table.table-hover table .smart-table-active:hover,
.smart-table.table-hover table .smart-table-active:hover>td,
.smart-table.table-hover table .smart-table-active:hover>th {
    background-color: rgba(0, 0, 0, .075)
}

.smart-table.no-border>.smart-container {
    border: none
}

.smart-table.table-elevation {
    border: none;
    border-radius: unset;
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8)
}

.smart-table:not([animation=none]) thead th .sort-by {
    transition: visibility .5s ease-out, opacity .5s ease-out
}

.smart-table:not([animation=none]) thead th .sort-by:before {
    transition: -webkit-transform .5s ease-out;
    transition: transform .5s ease-out;
    transition: transform .5s ease-out, -webkit-transform .5s ease-out
}

.smart-table:not([animation=none]) tr[row-id] td:not(.editing) {
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, border-top-color .2s ease-in-out, -webkit-transform .2s ease-in-out;
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, transform .2s ease-in-out, border-top-color .2s ease-in-out;
    transition: padding-top .2s ease-in-out, padding-bottom .2s ease-in-out, transform .2s ease-in-out, border-top-color .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-table:not([animation=none]) td.editing.invalid:before {
    transition: visibility .2s ease-in-out, opacity .2s ease-out, -webkit-transform .1s ease-out;
    transition: visibility .2s ease-in-out, opacity .2s ease-out, transform .1s ease-out;
    transition: visibility .2s ease-in-out, opacity .2s ease-out, transform .1s ease-out, -webkit-transform .1s ease-out
}

.smart-table:not([animation=none]) .smart-table-toolbar-button:before,
.smart-table:not([animation=none]) smart-pager .smart-pager-button:before {
    transition: visibility .2s ease-out, opacity .2s ease-out, -webkit-transform .1s ease-out;
    transition: visibility .2s ease-out, opacity .2s ease-out, transform .1s ease-out;
    transition: visibility .2s ease-out, opacity .2s ease-out, transform .1s ease-out, -webkit-transform .1s ease-out
}

.smart-table:not([animation=none]) .hierarchy-arrow {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-table:not([animation=none]):not([ignore-detail-animation]) .smart-table-row-detail {
    transition: height .2s ease-in-out
}

.smart-table:not([animation=none]):not([ignore-detail-animation]) .smart-table-row-detail .smart-table-detail-container {
    transition: height .2s ease-in-out, padding-top .2s ease-in-out, padding-bottom .2s ease-in-out
}

.smart-table[virtualization] {
    --smart-table-default-height: var(--smart-grid-default-height)
}

.smart-table[filtering] .smart-table-header {
    display: grid;
    grid-template-columns: 1fr
}

.smart-table[filtering] .smart-table-header .smart-input,
.smart-table[filtering] .smart-table-header .smart-table-filter-template-container {
    display: block
}

.smart-table[filtering][filter-row][conditional-formatting-button] .smart-table-header .smart-input,
.smart-table[filtering][filter-row][conditional-formatting-button] .smart-table-header .smart-table-filter-template-container {
    display: none
}

.smart-table[filtering][conditional-formatting-button] .smart-table-header {
    grid-template-columns: 1fr auto
}

.smart-table[conditional-formatting-button] .smart-table-header {
    display: grid
}

.smart-table[conditional-formatting-button] .smart-table-header .smart-table-toolbar-button.conditional-formatting {
    display: flex
}

.smart-table[conditional-formatting-button]:not([filtering]) .smart-table-header {
    grid-template-areas: ". button";
    grid-template-columns: 1fr auto
}

.smart-table[conditional-formatting-button]:not([filtering]) .smart-table-header .smart-table-toolbar-button.conditional-formatting {
    grid-area: button
}

.smart-table[conditional-formatting-button][filtering][filter-row] .smart-table-header {
    grid-template-areas: ". button";
    grid-template-columns: 1fr auto
}

.smart-table[conditional-formatting-button][filtering][filter-row] .smart-table-header .smart-table-toolbar-button.conditional-formatting {
    grid-area: button
}

.smart-table[paging] smart-pager {
    display: block;
    z-index: 1
}

.smart-table[paging][conditional-formatting-button] .smart-table-container,
.smart-table[paging][conditional-formatting-button] .smart-table-virtualization-container,
.smart-table[paging][filtering]:not([filter-row]) .smart-table-container,
.smart-table[paging][filtering]:not([filter-row]) .smart-table-virtualization-container {
    height: calc(100% - 112px);
    height: calc(100% - var(--smart-table-header-footer-height)*2)
}

.smart-table[column-reorder] thead th {
    touch-action: none
}

.smart-table[column-reorder] th[data-field] {
    cursor: move
}

.smart-table:not([column-resize]) .dragged:after {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em;
    content: "";
    height: 100%;
    left: 0;
    opacity: .8;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-table[column-resize] thead th {
    touch-action: none
}

.smart-table[column-resize] th[data-field]:after,
.smart-table[column-resize] th[data-field]:before {
    content: "";
    cursor: col-resize;
    height: 100%;
    position: absolute;
    top: 0;
    width: 5px
}

.smart-table[column-resize]:not([right-to-left]) th[locked]+th[data-field]:before,
.smart-table[column-resize]:not([right-to-left]) th[locked]:after,
.smart-table[column-resize]:not([selection]) th[data-field]:first-child:before,
.smart-table[column-resize][resize-max-reached] th[data-field]:after,
.smart-table[column-resize][resize-max-reached] th[data-field]:before,
.smart-table[column-resize][selection] th[data-field]:nth-child(2):before {
    content: none
}

.smart-table[column-resize] th[data-field]:before {
    left: 0
}

.smart-table[column-resize] th[data-field]:after {
    right: 0;
    width: 4px
}

.smart-table[column-resize]:not([freeze-header]) th[data-field]:not(.freeze-near):not(.freeze-far) {
    position: relative
}

@media (hover:none) {
    .smart-table[column-resize]:not(.resizing) th[data-field]:before {
        border-left: 1px solid rgba(0, 92, 153, .3);
        border-left: 1px solid rgba(var(--smart-primary-rgb), .3)
    }

    .smart-table[column-resize]:not(.resizing) th[data-field]:after {
        border-right: 1px solid rgba(0, 92, 153, .3);
        border-right: 1px solid rgba(var(--smart-primary-rgb), .3)
    }
}

@media (hover:hover) {
    .smart-table[column-resize]:not(.resizing) th[data-field]:hover:before {
        border-left: 1px solid rgba(0, 92, 153, .3);
        border-left: 1px solid rgba(var(--smart-primary-rgb), .3)
    }

    .smart-table[column-resize]:not(.resizing) th[data-field]:hover:after {
        border-right: 1px solid rgba(0, 92, 153, .3);
        border-right: 1px solid rgba(var(--smart-primary-rgb), .3)
    }
}

.smart-table[sort-mode=many] thead th .sort-by:after {
    content: attr(order)
}

.smart-table[loading] tbody td {
    opacity: 0
}

.smart-table[loading] smart-pager {
    pointer-events: none
}

.smart-table[freeze-header]:not([virtualization]) thead th {
    border-bottom: none;
    box-shadow: 0 1px 0 0 #e0e0e0;
    box-shadow: 0 1px 0 0 var(--smart-border);
    opacity: 1;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 100
}

.smart-table[freeze-header]:not([virtualization]) thead th.freeze-near {
    box-shadow: 1px 1px 0 0 #e0e0e0;
    box-shadow: 1px 1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-header]:not([virtualization]) thead th.freeze-far {
    box-shadow: -1px 1px 0 0 #e0e0e0;
    box-shadow: -1px 1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-header]:not([virtualization]) thead tr:nth-child(2)>th {
    top: 56px;
    top: var(--smart-table-column-header-height)
}

.smart-table[freeze-header]:not([virtualization]) thead tr:nth-child(3)>th {
    top: 112px;
    top: calc(var(--smart-table-column-header-height)*2)
}

.smart-table[freeze-header]:not([virtualization]) thead tr:nth-child(4)>th {
    top: 168px;
    top: calc(var(--smart-table-column-header-height)*3)
}

.smart-table[freeze-header]:not([virtualization]) thead tr:nth-child(5)>th {
    top: 224px;
    top: calc(var(--smart-table-column-header-height)*4)
}

.smart-table[freeze-header]:not([virtualization])[conditional-formatting-button] thead th,
.smart-table[freeze-header]:not([virtualization])[filtering]:not([filter-row]) thead th {
    top: 56px;
    top: var(--smart-table-header-footer-height)
}

.smart-table[freeze-header]:not([virtualization])[conditional-formatting-button] thead tr:nth-child(2)>th,
.smart-table[freeze-header]:not([virtualization])[filtering]:not([filter-row]) thead tr:nth-child(2)>th {
    top: 112px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height))
}

.smart-table[freeze-header]:not([virtualization])[conditional-formatting-button] thead tr:nth-child(3)>th,
.smart-table[freeze-header]:not([virtualization])[filtering]:not([filter-row]) thead tr:nth-child(3)>th {
    top: 168px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*2)
}

.smart-table[freeze-header]:not([virtualization])[conditional-formatting-button] thead tr:nth-child(4)>th,
.smart-table[freeze-header]:not([virtualization])[filtering]:not([filter-row]) thead tr:nth-child(4)>th {
    top: 224px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*3)
}

.smart-table[freeze-header]:not([virtualization])[conditional-formatting-button] thead tr:nth-child(5)>th,
.smart-table[freeze-header]:not([virtualization])[filtering]:not([filter-row]) thead tr:nth-child(5)>th {
    top: 280px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*4)
}

.smart-table[freeze-header][virtualization] thead {
    box-shadow: 0 1px 0 0 #e0e0e0;
    box-shadow: 0 1px 0 0 var(--smart-border);
    position: relative;
    top: 0;
    z-index: 200
}

.smart-table[freeze-header][virtualization] thead th {
    border-bottom: none;
    box-shadow: 0 1px 0 0 #e0e0e0;
    box-shadow: 0 1px 0 0 var(--smart-border);
    opacity: 1;
    position: relative;
    top: 0;
    z-index: 100
}

.smart-table[freeze-header][virtualization] thead th.sticky {
    position: -webkit-sticky;
    position: sticky
}

.smart-table[freeze-header][virtualization] thead th.freeze-near {
    box-shadow: 1px 1px 0 0 #e0e0e0;
    box-shadow: 1px 1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-header][virtualization] thead th.freeze-far {
    box-shadow: -1px 1px 0 0 #e0e0e0;
    box-shadow: -1px 1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-header][virtualization] thead tr:nth-child(2)>th {
    top: 56px;
    top: var(--smart-table-column-header-height)
}

.smart-table[freeze-header][virtualization] thead tr:nth-child(3)>th {
    top: 112px;
    top: calc(var(--smart-table-column-header-height)*2)
}

.smart-table[freeze-header][virtualization] thead tr:nth-child(4)>th {
    top: 168px;
    top: calc(var(--smart-table-column-header-height)*3)
}

.smart-table[freeze-header][virtualization] thead tr:nth-child(5)>th {
    top: 224px;
    top: calc(var(--smart-table-column-header-height)*4)
}

.smart-table[freeze-header][virtualization][conditional-formatting-button] thead th,
.smart-table[freeze-header][virtualization][filtering]:not([filter-row]) thead th {
    top: 56px;
    top: var(--smart-table-header-footer-height)
}

.smart-table[freeze-header][virtualization][conditional-formatting-button] thead tr:nth-child(2)>th,
.smart-table[freeze-header][virtualization][filtering]:not([filter-row]) thead tr:nth-child(2)>th {
    top: 112px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height))
}

.smart-table[freeze-header][virtualization][conditional-formatting-button] thead tr:nth-child(3)>th,
.smart-table[freeze-header][virtualization][filtering]:not([filter-row]) thead tr:nth-child(3)>th {
    top: 168px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*2)
}

.smart-table[freeze-header][virtualization][conditional-formatting-button] thead tr:nth-child(4)>th,
.smart-table[freeze-header][virtualization][filtering]:not([filter-row]) thead tr:nth-child(4)>th {
    top: 224px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*3)
}

.smart-table[freeze-header][virtualization][conditional-formatting-button] thead tr:nth-child(5)>th,
.smart-table[freeze-header][virtualization][filtering]:not([filter-row]) thead tr:nth-child(5)>th {
    top: 280px;
    top: calc(var(--smart-table-header-footer-height) + var(--smart-table-column-header-height)*4)
}

.smart-table[freeze-footer] tfoot td {
    border-top: none;
    bottom: 0;
    box-shadow: 0 -1px 0 0 #e0e0e0;
    box-shadow: 0 -1px 0 0 var(--smart-border);
    opacity: 1;
    position: -webkit-sticky;
    position: sticky;
    z-index: 100
}

.smart-table[freeze-footer] tfoot td.freeze-near {
    box-shadow: 1px -1px 0 0 #e0e0e0;
    box-shadow: 1px -1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-footer] tfoot td.freeze-far {
    box-shadow: -1px -1px 0 0 #e0e0e0;
    box-shadow: -1px -1px 0 0 var(--smart-border);
    z-index: 200
}

.smart-table[freeze-footer] tfoot tr:nth-last-child(2) td {
    bottom: 48px;
    bottom: var(--smart-table-row-height)
}

.smart-table[freeze-footer] tfoot tr:nth-last-child(3) td {
    bottom: 96px;
    bottom: calc(var(--smart-table-row-height)*2)
}

.smart-table[freeze-footer] .smart-table-container:focus td[focus]:after {
    height: calc(100% - 1px)
}

.smart-table[freeze-footer][paging] tfoot td {
    bottom: 56px;
    bottom: var(--smart-table-header-footer-height)
}

.smart-table[freeze-footer][paging] tfoot tr:nth-last-child(2) td {
    bottom: 104px;
    bottom: calc(var(--smart-table-row-height) + var(--smart-table-header-footer-height))
}

.smart-table[freeze-footer][paging] tfoot tr:nth-last-child(3) td {
    bottom: 152px;
    bottom: calc(var(--smart-table-row-height)*2 + var(--smart-table-header-footer-height))
}

.smart-table[row-detail-template] tr[row-id] {
    cursor: pointer
}

.smart-table[hierarchy] tr[row-id] td {
    -webkit-transform: scaleY(1);
    transform: scaleY(1)
}

.smart-table[hierarchy] tr[row-id].no-height td {
    line-height: 0
}

.smart-table[hierarchy] tr.collapsed[row-id] {
    height: 0
}

.smart-table[hierarchy] tr.collapsed[row-id] td {
    border-top-color: transparent;
    border-top-width: 0;
    line-height: 0;
    padding-bottom: 0;
    padding-top: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-table[column-groups][selection] th.empty,
.smart-table[column-groups][selection] th.smart-table-select-all,
.smart-table[virtualization] tr[unused] td {
    border-top: none
}

.smart-pivot-table th.expanded .total-arrow,
.smart-pivot-table:not([group-layout=classic]) tr.expanded .hierarchy-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-table[hierarchy]:not([animation=none]) tr[row-id] {
    transition: height .2s ease-in-out
}

.smart-table[modal] {
    position: relative
}

.smart-table[modal],
.smart-table[modal]:after {
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-table[modal]:after {
    background-color: #000;
    content: "";
    cursor: default;
    height: 100%;
    left: 0;
    opacity: .3;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100
}

.smart-table[toolbar][designer] .smart-table-toolbar-button.conditional-formatting {
    border-right: none
}

.smart-table[toolbar][designer] .smart-table-toolbar-button.conditional-formatting:before {
    left: unset;
    right: 0;
    width: 96px;
    width: calc(var(--smart-table-row-height)*2)
}

.smart-table[auto-size] table {
    table-layout: auto
}

.smart-table[column-groups]:not([right-to-left]) th:not(:last-child) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-table[virtualization] tr.last-row td {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

.smart-table[virtualization] tr[unused] {
    visibility: hidden
}

.smart-table[virtualization] tr.smart-table-filter-row td {
    background-color: #fefefe;
    background-color: var(--smart-background);
    box-shadow: 0 1px 0 0 #e0e0e0;
    box-shadow: 0 1px 0 0 var(--smart-border);
    position: -webkit-sticky;
    position: sticky;
    top: 56px;
    top: var(--smart-table-column-header-height)
}

.smart-table[virtualization][conditional-formatting-button] .smart-table-container,
.smart-table[virtualization][filtering]:not([filter-row]) .smart-table-container,
.smart-table[virtualization][paging] .smart-table-container,
.smart-table[virtualization][paging][conditional-formatting-button] .smart-table-container,
.smart-table[virtualization][paging][filtering]:not([filter-row]) .smart-table-container {
    height: 100%
}

.smart-table[virtualization][freeze-header][conditional-formatting-button] thead th,
.smart-table[virtualization][freeze-header][filtering]:not([filter-row]) thead th {
    top: 0
}

@media (max-width:575.98px) {
    .smart-table.table-responsive-sm {
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        display: block;
        overflow-x: auto;
        width: 100%
    }

    .smart-table.table-responsive-sm>.smart-table.table-bordered table {
        border: 0
    }
}

@media (max-width:767.98px) {
    .smart-table.table-responsive-md {
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        display: block;
        overflow-x: auto;
        width: 100%
    }

    .smart-table.table-responsive-md>.smart-table.table-bordered table {
        border: 0
    }
}

@media (max-width:991.98px) {
    .smart-table.table-responsive-lg {
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        display: block;
        overflow-x: auto;
        width: 100%
    }

    .smart-table.table-responsive-lg>.smart-table.table-bordered table {
        border: 0
    }
}

@media (max-width:1199.98px) {
    .smart-table.table-responsive-xl {
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        display: block;
        overflow-x: auto;
        width: 100%
    }

    .smart-table.table-responsive-xl>.smart-table.table-bordered table {
        border: 0
    }
}

.smart-table.table-responsive {
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    display: block;
    overflow-x: auto;
    width: 100%
}

.smart-table.table-responsive>.smart-table.table-bordered table {
    border: 0
}

@media only screen and (max-width:1280px) {
    .smart-table .priority-5 {
        display: none
    }
}

@media only screen and (max-width:1024px) {
    .smart-table .priority-4 {
        display: none
    }
}

@media only screen and (max-width:800px) {
    .smart-table .priority-3 {
        display: none
    }
}

@media only screen and (max-width:640px) {
    .smart-table .priority-2 {
        display: none
    }
}

@-moz-document url-prefix() {
    .smart-table thead th:not(.smart-table-select-all) {
        opacity: 1
    }

    .smart-table .freeze-far,
    .smart-table .freeze-near {
        box-shadow: 0 0 0 1px #e0e0e0;
        box-shadow: 0 0 0 1px var(--smart-border)
    }

    .smart-table .smart-table-container:focus td[focus]:after {
        height: calc(100% - 1px);
        top: 1px
    }

    .smart-table[freeze-header] thead th.empty,
    .smart-table[freeze-header] thead th:empty {
        box-shadow: -1px 0 0 0 #e0e0e0;
        box-shadow: -1px 0 0 0 var(--smart-border)
    }

    .smart-table[freeze-footer] .smart-table-container:focus td[focus]:after {
        height: calc(100% - 2px)
    }

    .smart-table[column-groups][freeze-header] thead th,
    .smart-table[right-to-left] .freeze-far,
    .smart-table[right-to-left] .freeze-near {
        box-shadow: 0 0 0 1px #e0e0e0;
        box-shadow: 0 0 0 1px var(--smart-border)
    }
}

.smart-table[hide-selection-column] th.smart-table-select-all {
    padding-left: 0;
    padding-right: 0;
    width: 0
}

.smart-table[hide-selection-column] td.smart-table-select-row,
.smart-table[hide-selection-column] td.smart-table-select-row .selection-checkbox,
.smart-table[hide-selection-column] th.smart-table-select-all>div {
    visibility: hidden
}

.smart-table[hide-selection-column] tr[aria-selected=true] td {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-table[right-to-left]>.smart-container {
    direction: rtl
}

.smart-table[right-to-left] thead th {
    text-align: right
}

.smart-table[right-to-left] thead th .sort-by:after {
    left: unset;
    right: 100%
}

.smart-table[right-to-left] th.column-header {
    text-align: center
}

.smart-table[right-to-left] td {
    text-align: left;
    text-align: initial
}

.smart-table[right-to-left] .smart-table-container:focus td[focus]:after {
    left: unset;
    right: 1px
}

.smart-table[right-to-left] .smart-table-header {
    left: unset;
    right: 0
}

.smart-table[right-to-left] .smart-table-header .smart-table-toolbar-button.conditional-formatting {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-table[right-to-left] .smart-table-header .smart-table-toolbar-button.conditional-formatting:before {
    left: 0;
    right: unset
}

.smart-table[right-to-left] .freeze-far {
    box-shadow: 1px 0 0 0 #e0e0e0;
    box-shadow: 1px 0 0 0 var(--smart-border);
    left: 0;
    right: unset
}

.smart-table[right-to-left] .freeze-near {
    box-shadow: -1px 0 0 0 #e0e0e0;
    box-shadow: -1px 0 0 0 var(--smart-border);
    left: unset;
    right: 0
}

.smart-table[right-to-left] smart-pager .smart-container {
    justify-content: flex-start
}

.smart-table[right-to-left] smart-pager .smart-pager-near-buttons-container {
    order: 1
}

.smart-table[right-to-left] smart-pager .smart-pager-summary-container.smart-pager-label {
    order: 2
}

.smart-table[right-to-left] smart-pager .smart-pager-size-selector-and-label-container {
    flex-direction: row;
    order: 3
}

.smart-table[right-to-left] .group-header,
.smart-table[right-to-left] .tree-cell,
.smart-table[right-to-left] .tree-leaf {
    padding-left: 12px;
    padding-left: var(--smart-table-cell-padding)
}

.smart-table[right-to-left] .hierarchy-arrow {
    margin-left: 5px;
    margin-left: var(--smart-table-arrow-margin);
    margin-right: unset
}

.smart-table[right-to-left][freeze-header] thead th.freeze-far {
    box-shadow: 1px 1px 0 0 #e0e0e0;
    box-shadow: 1px 1px 0 0 var(--smart-border)
}

.smart-table[right-to-left][freeze-header] thead th.freeze-near {
    box-shadow: -1px 1px 0 0 #e0e0e0;
    box-shadow: -1px 1px 0 0 var(--smart-border)
}

.smart-table[right-to-left][freeze-footer] tfoot td.freeze-far {
    box-shadow: 1px -1px 0 0 #e0e0e0;
    box-shadow: 1px -1px 0 0 var(--smart-border)
}

.smart-table[right-to-left][freeze-footer] tfoot td.freeze-near {
    box-shadow: -1px -1px 0 0 #e0e0e0;
    box-shadow: -1px -1px 0 0 var(--smart-border)
}

.smart-table[right-to-left][conditional-formatting-button]:not([filtering]) .smart-table-header {
    grid-template-areas: ". button";
    grid-template-columns: 1fr auto
}

.smart-table[right-to-left][filtering] .smart-table-header {
    grid-template-columns: 1fr
}

.smart-table[right-to-left][filtering][conditional-formatting-button] .smart-table-header {
    grid-template-columns: 1fr auto
}

.smart-table[right-to-left][column-resize] th[locked]+th[data-field]:after,
.smart-table[right-to-left][column-resize] th[locked]:before,
.smart-table[right-to-left][column-resize]:not([selection]) th[data-field]:first-child:after {
    content: none
}

.smart-table[right-to-left][column-resize]:not([selection]) th[data-field]:not([locked]):first-child:before {
    content: ""
}

.smart-table[right-to-left][column-resize][selection] th[data-field]:nth-child(2):after {
    content: none
}

.smart-table[right-to-left][column-resize][selection] th[data-field]:not([locked]):nth-child(2):before {
    content: ""
}

.smart-table[right-to-left][column-groups] th:not(:last-child) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table:not([animation=none]) .total-arrow {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

@-moz-document url-prefix() {

    .smart-pivot-table thead th:last-child,
    .smart-pivot-table thead th:not(:last-child) {
        border: none;
        box-shadow: 0 0 0 1px #e0e0e0;
        box-shadow: 0 0 0 1px var(--smart-border)
    }

    .smart-pivot-table tbody tr[row-id]:first-child td {
        border-top: none
    }

    .smart-pivot-table[freeze-header] thead th {
        box-shadow: 0 0 0 1px #e0e0e0;
        box-shadow: 0 0 0 1px var(--smart-border)
    }

    .smart-pivot-table[freeze-header] .smart-pivot-table-grouping-header:empty {
        box-shadow: -1px 0 0 0 #e0e0e0;
        box-shadow: -1px 0 0 0 var(--smart-border)
    }

    .smart-pivot-table[right-to-left] thead th:last-child,
    .smart-pivot-table[right-to-left] thead th:not(:last-child) {
        border: none;
        box-shadow: 0 0 0 1px #e0e0e0;
        box-shadow: 0 0 0 1px var(--smart-border)
    }
}

.smart-pivot-table[right-to-left] .smart-table-toolbar-button.fields,
.smart-pivot-table[right-to-left][toolbar][designer] .smart-table-toolbar-button.conditional-formatting {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

.smart-pivot-table[right-to-left] .smart-table-toolbar-button.fields:before,
.smart-pivot-table[right-to-left][toolbar][designer] .smart-table-toolbar-button.conditional-formatting:before {
    left: 0;
    right: unset
}

.smart-pivot-panel>.smart-container[modal] {
    pointer-events: none;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-pivot-panel>.smart-container[modal]:after {
    background-color: #000;
    content: "";
    cursor: default;
    height: 100%;
    left: 0;
    opacity: .3;
    pointer-events: none;
    position: absolute;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    z-index: 100
}

.smart-table-primary,
.smart-table-primary>td,
.smart-table-primary>th {
    background-color: #b8daff
}

.smart-table-secondary,
.smart-table-secondary>td,
.smart-table-secondary>th {
    background-color: #d6d8db
}

.smart-table-success,
.smart-table-success>td,
.smart-table-success>th {
    background-color: #c3e6cb
}

.smart-table-info,
.smart-table-info>td,
.smart-table-info>th {
    background-color: #bee5eb
}

.smart-table-warning,
.smart-table-warning>td,
.smart-table-warning>th {
    background-color: #ffeeba
}

.smart-table-danger,
.smart-table-danger>td,
.smart-table-danger>th {
    background-color: #f5c6cb
}

.smart-table.table-light table,
.smart-table.table-light table>td,
.smart-table.table-light table>th {
    background-color: #fdfdfe
}

.smart-table.table-dark table td,
.smart-table.table-dark table th,
.smart-table.table-dark table thead th {
    border-color: #32383e
}

.smart-table.table-dark table>td,
.smart-table.table-dark table>th {
    background-color: #212529
}

.smart-table-active,
.smart-table-active>td,
.smart-table-active>th {
    background-color: rgba(0, 0, 0, .075)
}

.smart-table-container {
    height: 100%;
    width: 100%
}

.smart-table-sm td,
.smart-table-sm th {
    padding: .3rem
}

.smart-table-feedback,
.smart-table-resize-feedback {
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    padding: 5px;
    position: absolute
}

.smart-table-feedback {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    font-size: 14px;
    font-size: var(--smart-font-size);
    opacity: .85;
    white-space: nowrap;
    z-index: 10000
}

.smart-table-resize-feedback {
    border-left: 1px dashed #005c99;
    border-left: 1px dashed var(--smart-primary);
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 700;
    z-index: 100
}

.smart-table-resize-feedback.static {
    border-left-style: solid
}

.smart-table-resize-feedback.max,
.smart-table-resize-feedback.min {
    border-left-color: #b00020;
    border-left-color: var(--smart-error)
}

.smart-table-window.conditional-formatting {
    --smart-window-default-width: 650px
}

.smart-table-window.conditional-formatting .smart-content-container>.smart-content,
.smart-table-window.conditional-formatting>.smart-container {
    overflow: visible
}

.smart-table-window.conditional-formatting smart-formatting-panel {
    border: none;
    height: 100%;
    width: 100%
}

.smart-table-window.smart-window.conditional-formatting {
    overflow: visible
}

.smart-table-window.smart-window .smart-content-container>.smart-footer {
    align-items: center;
    display: flex;
    justify-content: space-evenly
}

.smart-table-window.smart-window .smart-content-container>.smart-footer smart-button {
    --smart-button-padding: 0;
    height: 100%;
    width: 40%
}

.smart-table-column-menu {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    height: auto;
    left: 0;
    padding: 10px;
    position: absolute;
    top: 0;
    width: 200px;
    z-index: 9999
}

.smart-table-column-menu smart-button {
    --smart-button-padding: 0
}

.smart-table-column-menu smart-button button:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    text-decoration: line-through;
    width: 100%
}

.smart-table-column-menu.wrapper>div {
    --smart-filter-row-content-height: calc(var(--smart-table-row-height) - var(--smart-table-cell-padding)*2 - var(--smart-border-width));
    grid-column-gap: 2px;
    -webkit-column-gap: 2px;
    column-gap: 2px;
    display: grid;
    grid-template-columns: 1fr var(--smart-filter-row-content-height) var(--smart-filter-row-content-height);
    grid-template-rows: 100%;
    height: var(--smart-filter-row-content-height);
    position: relative
}

.smart-table-column-menu.wrapper .smart-table-menu-item {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 30px;
    margin-bottom: 5px;
    padding: 5px
}

.smart-table-column-menu.wrapper .smart-table-menu-item.smart-disabled {
    opacity: .5;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-table-column-menu.wrapper .smart-table-menu-item .label {
    padding: 5px
}

.smart-table-column-menu.wrapper .smart-table-menu-item:not(.filter-item):hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .menu-icon:after,
.smart-table-column-menu.wrapper .smart-table-menu-item.columns-item:after {
    color: #323232;
    color: var(--smart-surface-color);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    width: 100%
}

.smart-table-column-menu.wrapper .smart-table-menu-item .sort-asc:after {
    content: "\\f15d";
    content: var(--smart-icon-sort-name-up)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .sort-desc:after {
    content: "\\f15e";
    content: var(--smart-icon-sort-name-down)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .sort-remove:after {
    content: "\\f15d";
    content: var(--smart-icon-sort-name-up);
    text-decoration: line-through
}

.smart-table-column-menu.wrapper .smart-table-menu-item .reset:after {
    content: "\\e819";
    content: var(--smart-icon-refresh)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .columns:after {
    content: "\\e800";
    content: var(--smart-icon-table)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .filter-by:after {
    content: "\\e82f";
    content: var(--smart-icon-add-filter)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .filter-by-remove:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    text-decoration: line-through
}

.smart-table-column-menu.wrapper .smart-table-menu-item .column-item:after {
    content: "\\e81b";
    content: var(--smart-icon-check-squared)
}

.smart-table-column-menu.wrapper .smart-table-menu-item .column-item.off:after {
    content: "\\f096";
    content: var(--smart-icon-check-empty)
}

.smart-table-column-menu.wrapper .smart-table-menu-item.columns-item:after {
    align-items: center;
    content: "\\e903";
    content: var(--smart-icon-arrow-right);
    display: flex;
    justify-content: flex-end
}

.smart-table-column-menu.wrapper .smart-table-menu-item.filter-item {
    border-top: 1px solid #e0e0e0;
    border-top: 1px solid var(--smart-border);
    cursor: default;
    margin-bottom: 10px;
    padding-top: 20px
}

.smart-table-column-menu.wrapper.no-filter {
    opacity: .6;
    pointer-events: none
}

.smart-table-column-menu .filter-value {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: inherit;
    min-width: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding)
}

.smart-table-column-menu .filter-value:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-table-column-menu .filter-value:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-table-column-menu .filter-value[type=number] {
    -webkit-appearance: none;
    -moz-appearance: textfield
}

.smart-table-column-menu .filter-value::-webkit-inner-spin-button,
.smart-table-column-menu .filter-value::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield
}

.smart-table-column-menu .smart-input {
    --smart-editor-addon-width: 100%;
    --smart-editor-label-padding: 0;
    height: 100%;
    width: unset
}

.smart-table-column-menu .smart-input .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-table-column-menu .smart-input .smart-drop-down-button .arrow:after {
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    -webkit-transform: none !important;
    transform: none !important
}

@-webkit-keyframes active {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    to {
        -webkit-transform: scale(2.5);
        transform: scale(2.5)
    }
}

@keyframes active {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    to {
        -webkit-transform: scale(2.5);
        transform: scale(2.5)
    }
}

.smart-tabs .smart-tab-close-button,
.smart-tabs .smart-tab-group-arrow {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    text-align: center;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

smart-tabs {
    border: none;
    height: 450px;
    height: var(--smart-tabs-default-height);
    line-height: normal;
    overflow: visible;
    width: 450px;
    width: var(--smart-tabs-default-width)
}

smart-tabs.smart-element {
    background: 0 0;
    border: none
}

smart-tab-item {
    font-size: inherit;
    height: 100%;
    left: 0;
    outline: 0;
    overflow: auto;
    position: relative;
    top: 0;
    width: 100%
}

smart-tab-item>.smart-container {
    padding: 0px
}

smart-tab-item>.smart-container .smart-widget * {
    box-sizing: content-box;
    box-sizing: initial
}

smart-tab-item.smart-element {
    background: 0 0;
    border: none
}

smart-tab-item.animate {
    transition: left .5s cubic-bezier(.35, 0, .25, 1), top .5s cubic-bezier(.35, 0, .25, 1), visibility 2s cubic-bezier(.35, 0, .25, 1), opacity 2s cubic-bezier(.35, 0, .25, 1);
    transition: left var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1), top var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1), visibility 2s cubic-bezier(.35, 0, .25, 1), opacity 2s cubic-bezier(.35, 0, .25, 1)
}

smart-tab-item.smart-visibility-hidden {
    position: absolute;
    display:none;
}

smart-tab-item.smart-visibility-hidden .smart-container,
smart-tab-item.smart-visibility-hidden>.smart-container .smart-widget * {
    visibility: hidden
}

smart-tab-item.smart-visibility-hidden.animate .smart-container {
    visibility: visible;
    visibility: initial
}

smart-tab-items-group.smart-element {
    background: 0 0;
    border: none
}

.smart-tabs {
    outline: 0
}

.smart-tabs>.smart-container {
    display: flex;
    flex-direction: column;
    min-height: inherit;
    position: relative
}

.smart-tabs .smart-tabs-content-section,
.smart-tabs .smart-tabs-header-items {
    min-height: 0;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 27px;
}

.smart-tabs .smart-tabs-header-section {
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #f5f5f5;
    border: 0px solid var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color);
    padding: 0;
    padding: var(--smart-tabs-header-padding)
}

.smart-tabs .smart-tabs-header-items>.smart-drop-down-button {
    cursor: pointer;
    display: none;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    position: relative
}

.smart-tabs .smart-tabs-content-section {
    background: #fefefe;
    background: var(--smart-background);

    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    color: var(--smart-tabs-color);
    flex: 1 1 0;
    margin: 0;
    margin-top: var(--smart-tabs-header-offset)
}

.smart-tabs .smart-drop-down-button-drop-down,
.smart-tabs .smart-tab-group-drop-down {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    padding: 2px;
    white-space: nowrap;
    width: auto;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-tabs .smart-tabs-resize-token {
    background-color: #000;
    opacity: .5;
    position: absolute
}

.smart-tabs .smart-tab-header-controls:empty {
    display: none
}

.smart-tabs .smart-tab-group-container {
    color: inherit;
    cursor: pointer;
    display: inline-block;
    position: relative;
    text-transform: uppercase;
    text-transform: var(--smart-tab-item-text-transform)
}

.smart-tabs .smart-tab-group-container .smart-tab-label-text-container {
    margin-right: 18px
}

.smart-tabs .smart-tab-group-container[hover],
.smart-tabs .smart-tab-group-container[hover][focus] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-tabs .smart-tab-group-drop-down {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-radius: 4px;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: var(--smart-border-radius);
    border-top: none;
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: auto;
    position: absolute
}

.smart-tabs .smart-tab-group-drop-down .smart-tab-label-container {
    display: block;
    overflow: hidden;
    width: 100%
}

.smart-tabs .smart-tab-group-arrow {
    height: 27px;
    height: var(--smart-editor-addon-width);
    line-height: 27px;
    line-height: var(--smart-editor-addon-width);
    position: absolute;
    right: 2px;
    top: 50%;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-tabs .smart-tab-group-arrow:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-tabs .smart-tab-label-container {
    background-color: inherit;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-color: transparent;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    color: inherit;
    cursor: pointer;
    display: inline-block;
    margin-right: 5px;
    margin-right: var(--smart-tab-item-offset);
    position: relative;
    top:-7px;
}

.smart-tabs .smart-tab-label-container[selected],
.smart-tabs .smart-tab-label-container[selected][focus] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: var(--smart-item-border-selected);
    color: #005c99;
    color: var(--font-color-light)
}

.smart-tabs .smart-tab-label-container[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-tabs .smart-tab-label-container[hover],
.smart-tabs .smart-tab-label-container[hover][focus] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-tabs .smart-tab-label-text-wrapper {
    height: 100%;
    padding: 12px 16px;
    padding: var(--smart-tab-item-padding);
    position: relative;
    width: 100%
}

.smart-tabs .smart-tab-label-text-container {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-tabs .smart-tab-label-text-container.smart-close-button-enabled {
    margin-right: 18px
}

.smart-tabs .smart-tab-close-button {
    font-size: 10px;
    height: 27px;
    height: var(--smart-editor-addon-width);
    line-height: 27px;
    line-height: var(--smart-editor-addon-width);
    position: absolute;
    right: 2px;
    top: 50%;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-tabs .smart-tab-close-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-tabs .smart-tab-close-button[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border: 1px solid #ebebeb;
    border: 1px solid var(--smart-ui-state-border-hover);
    border-radius: 50%;
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-tabs .smart-drop-down-button-arrow {
    color: inherit;
    height: 10px;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 10px
}

.smart-tabs .smart-drop-down-button-arrow:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-tabs .smart-drop-down-button-drop-down {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-radius: 4px;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: var(--smart-border-radius);
    border-top: none;
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: auto;
    position: absolute;
    top: 100%
}

.smart-tabs .smart-drop-down-button-drop-down .smart-tab-label-container {
    display: block;
    overflow: hidden;
    padding: 12px 16px;
    padding: var(--smart-tab-item-padding);
    width: 100%
}

.smart-tabs .smart-add-new-tab[hover] {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-tabs .smart-nav-button {
    border-radius: 0;
    position: relative;
    z-index: 100
}

.smart-tabs .smart-nav-button>.smart-button {
    border: none;
    height: auto;
    padding: 0
}

.smart-tabs .ripple-agent {
    height: 100%;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-tabs .smart-ripple {
    background-color: #005c99;
    background-color: var(--smart-primary);
    opacity: .5
}

.smart-tabs:focus .smart-tabs-content-section,
.smart-tabs:focus .smart-tabs-header-section {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-tabs:focus .smart-tab-label-container[selected] {
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-tabs:focus .smart-add-new-tab[focus],
.smart-tabs:focus .smart-tab-group-container[focus],
.smart-tabs:focus .smart-tab-label-container[focus] {
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-tabs:not([animation=none]) smart-tab-item.right {
    left: 100%
}

.smart-tabs:not([animation=none]) smart-tab-item.left {
    left: -100%
}

.smart-tabs:not([animation=none]) smart-tab-item.top {
    top: -100%
}

.smart-tabs:not([animation=none]) smart-tab-item.bottom {
    top: 100%
}

.smart-tabs:not([animation=none]) .smart-tabs-selection-bar {
    transition: width .5s cubic-bezier(.35, 0, .25, 1), height .5s cubic-bezier(.35, 0, .25, 1), top .5s cubic-bezier(.35, 0, .25, 1), left .5s cubic-bezier(.35, 0, .25, 1);
    transition: width var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1), height var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1), top var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1), left var(--smart-tabs-animation-duration) cubic-bezier(.35, 0, .25, 1)
}

.smart-tabs:not([animation=none]) .smart-tabs-content-section:after {
    transition: opacity .2s ease-in
}

.smart-tabs[keyboard-navigate] {
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-tabs[collapsed] .smart-tabs-content-section {
    display: none;
    margin: 0
}

.smart-tabs[collapsed][horizontal] {
    height: auto;
    min-height: 0;
    min-height: auto
}

.smart-tabs[collapsed][vertical] {
    display: table-caption;
    min-width: 0;
    min-width: auto;
    width: auto
}

.smart-tabs[dragged],
.smart-tabs[dragged] .smart-tab-label-container {
    cursor: move
}

.smart-tabs[resizing][horizontal],
.smart-tabs[resizing][horizontal] .smart-tab-group-container,
.smart-tabs[resizing][horizontal] .smart-tab-label-container {
    cursor: e-resize
}

.smart-tabs[resizing][vertical],
.smart-tabs[resizing][vertical] .smart-tab-group-container,
.smart-tabs[resizing][vertical] .smart-tab-label-container {
    cursor: n-resize
}

.smart-tabs[disabled] .smart-nav-button,
.smart-tabs[disabled] .smart-tab-group-container,
.smart-tabs[disabled] .smart-tab-label-container,
.smart-tabs[disabled] .smart-tabs-header-items>.smart-drop-down-button,
.smart-tabs[readonly] .smart-nav-button,
.smart-tabs[readonly] .smart-tab-group-container,
.smart-tabs[readonly] .smart-tab-label-container,
.smart-tabs[readonly] .smart-tabs-header-items>.smart-drop-down-button {
    cursor: default
}

.smart-tabs[allow-toggle] .smart-tabs-content-section:after {
    align-items: center;
    content: "No Items Selected";
    display: flex;
    height: 100%;
    justify-content: center;
    left: 50%;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%
}

.smart-tabs[vertical]>.smart-container {
    flex-direction: row
}

.smart-tabs[vertical] .smart-tabs-header-section {
    height: 100%;
    min-height: 0;
    min-height: auto;
    width: auto
}

.smart-tabs[vertical] .smart-tabs-header-section.scroll-buttons-shown .smart-tab-strip {
    height: calc(100% - 40px);
    height: calc(100% - var(--smart-tabs-header-button-size)*2)
}

.smart-tabs[vertical] .smart-tabs-header-section.scroll-buttons-shown.one-button-shown .smart-tab-strip {
    height: calc(100% - 20px);
    height: calc(100% - var(--smart-tabs-header-button-size))
}

.smart-tabs[vertical] .smart-tabs-content-section,
.smart-tabs[vertical] .smart-tabs-header-items {
    height: 100%;
    min-height: 0;
    min-height: auto;
    width: auto
}

.smart-tabs[vertical] .smart-tabs-header-items>.smart-drop-down-button {
    background: 0 0;
    border: none;
    height: 20px;
    height: var(--smart-tabs-header-button-size);
    width: 100%
}

.smart-tabs[vertical] .smart-tab-strip {
    height: 100%
}

.smart-tabs[vertical] .smart-tab-strip>.smart-tab-label-container {
    border: none;
    border-right: 1px solid transparent;
    border-right: var(--smart-item-border-width) solid transparent;
    min-height: 20px
}

.smart-tabs[vertical] .smart-tab-strip>.smart-add-new-tab {
    min-height: 0;
    min-height: auto;
    min-width: 0;
    min-width: auto
}

.smart-tabs[vertical] .smart-tab-group-container {
    border: none;
    border-right: 1px solid transparent;
    border-right: var(--smart-item-border-width) solid transparent;
    display: block;
    min-height: 20px
}

.smart-tabs[vertical] .smart-tab-label-container {
    display: block
}

.smart-tabs[vertical] .smart-tab-label-container:last-child {
    margin-bottom: 0;
    margin-right: 0
}

.smart-tabs[tab-text-orientation=vertical] .smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[tab-text-orientation=vertical] .smart-tab-strip>.smart-tab-label-container .smart-tab-label-text-container.smart-close-button-enabled {
    margin-bottom: 18px;
    margin-right: 0
}

.smart-tabs[vertical] .smart-tab-group-drop-down {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

.smart-tabs[vertical] .smart-add-new-tab {
    text-align: center
}

.smart-tabs[vertical] .smart-add-new-tab>.smart-tab-label-text-wrapper {
    padding-left: 10px;
    padding-right: 10px
}

.smart-tabs[vertical] .smart-nav-button {
    background: 0 0;
    border: none;
    height: 20px;
    height: var(--smart-tabs-header-button-size);
    width: 100%
}

.smart-tabs[vertical] .smart-drop-down-button-drop-down {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    top: auto
}

.smart-tabs[vertical] .smart-tabs-resize-token {
    height: 3px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 100%
}

.smart-tabs[horizontal] .smart-tab-strip {
    min-height: 0;
    width: 100%
}

.smart-tabs[horizontal] .smart-tab-strip>.smart-tab-label-container {
    border: none;
    border-bottom: 1px solid transparent;
    border-bottom: var(--smart-item-border-width) solid transparent;
    min-width: 10px
}

.smart-tabs[horizontal] .smart-tab-strip>.smart-tab-label-container:first-child {
    margin-left: 5px;
    margin-left: var(--smart-tab-item-initial-offset)
}

.smart-tabs[horizontal] .smart-tab-group-container {
    min-width: 40px
}

.smart-tabs[horizontal] .smart-tabs-header-section.scroll-buttons-shown .smart-tab-strip {
    width: calc(100% - 40px);
    width: calc(100% - var(--smart-tabs-header-button-size)*2)
}

.smart-tabs[horizontal] .smart-tabs-header-section.scroll-buttons-shown.one-button-shown .smart-tab-strip {
    width: calc(100% - 20px);
    width: calc(100% - var(--smart-tabs-header-button-size))
}

.smart-tabs[horizontal] .smart-nav-button,
.smart-tabs[horizontal] .smart-tabs-header-items>.smart-drop-down-button {
    background: 0 0;
    border: none;
    width: 20px;
    width: var(--smart-tabs-header-button-size)
}

.smart-tabs[horizontal] .smart-tabs-resize-token {
    height: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 3px
}

.smart-tabs[tab-text-orientation=vertical] .smart-tab-group-arrow,
.smart-tabs[tab-text-orientation=vertical] .smart-tab-strip>.smart-tab-label-container>.smart-tab-close-button {
    bottom: 2px;
    left: 50%;
    right: auto;
    top: auto;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%)
}

.smart-tabs[tab-text-orientation=vertical] .smart-tab-group-drop-down {
    -webkit-writing-mode: horizontal-tb;
    -ms-writing-mode: lr-tb;
    writing-mode: horizontal-tb
}

.smart-tabs[tab-text-orientation=vertical][horizontal] .smart-tab-strip {
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-tabs[tab-text-orientation=vertical][horizontal] .smart-tab-group-container,
.smart-tabs[tab-text-orientation=vertical][horizontal] .smart-tab-strip>.smart-tab-label-container {
    display: block;
    min-width: 20px
}

.smart-tabs[tab-text-orientation=vertical][horizontal] .smart-tab-close-button {
    padding-left: 2px
}

.smart-tabs[tab-text-orientation=vertical][vertical] .smart-tab-strip {
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl
}

.smart-tabs[tab-text-orientation=vertical][vertical] .smart-tab-strip>.smart-tab-label-container {
    display: inline-block;
    min-height: 10px
}

.smart-tabs[tab-text-orientation=vertical][vertical] .smart-tab-group-container {
    display: inline-block;
    min-height: 40px
}

.smart-tabs[tab-text-orientation=vertical][vertical] .smart-tab-close-button,
.smart-tabs[tab-text-orientation=vertical][vertical] .smart-tab-group-arrow {
    padding-right: 1px
}

.smart-tabs[tab-text-orientation=vertical][tab-position=bottom] .smart-tab-group-container .smart-tab-label-text-container {
    margin-bottom: 0;
    margin-top: 18px
}

.smart-tabs[tab-text-orientation=vertical][tab-position=bottom] .smart-tab-group-arrow {
    bottom: auto;
    top: 2px
}

.smart-tabs[tab-text-orientation=vertical][tab-position=right] .smart-tab-group-container .smart-tab-label-text-container {
    margin-left: 0
}

.smart-tabs:not([tab-position=bottom]):not([tab-position=left]):not([tab-position=right]) .smart-tabs-header-section {
    border-bottom-width: 0
}

.smart-tabs[tab-position=hidden] .smart-tabs-header-section {
    display: none
}

.smart-tabs[tab-position=hidden] .smart-tabs-content-section {
    margin: 0
}

.smart-tabs[tab-position=right] .smart-tabs-selection-bar {
    left: 0;
    width: 2px
}

.smart-tabs[tab-position=right] .smart-tabs-header-section {
    border-left-width: 0
}

.smart-tabs[tab-position=right] .smart-tab-label-container {
    margin-bottom: 5px;
    margin-bottom: var(--smart-tab-item-offset);
    margin-left: 0;
    margin-right: 0;
    margin-top: 5px;
    margin-top: var(--smart-tab-item-initial-offset)
}

.smart-tabs[tab-position=right] .smart-tabs-content-section {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    margin: 0;
    margin: 0 var(--smart-tabs-header-offset) 0 0
}

.smart-tabs[tab-position=right] .smart-drop-down-button-drop-down,
.smart-tabs[tab-position=right] .smart-tab-group-drop-down {
    border-right: none;
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
}

.smart-tabs[tab-position=right] .smart-tab-group-container .smart-tab-label-text-container {
    margin-left: 12px;
    margin-right: 0
}

.smart-tabs[tab-position=right] .smart-tab-group-arrow {
    left: 0;
    right: auto
}

.smart-tabs[tab-position=bottom] .smart-tabs-selection-bar {
    height: 2px;
    top: 0
}

.smart-tabs[tab-position=bottom] .smart-tabs-header-section {
    border-top-width: 0
}

.smart-tabs[tab-position=bottom] .smart-drop-down-button-drop-down,
.smart-tabs[tab-position=bottom] .smart-tab-group-drop-down {
    border-bottom: none;
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%)
}

.smart-tabs[tab-position=bottom] .smart-tab-label-container {
    margin-right: 5px;
    margin-right: var(--smart-tab-item-offset)
    top:-1px;
}

.smart-tabs[tab-position=bottom] .smart-tabs-content-section {
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    margin: 0;
    margin: 0 0 var(--smart-tabs-header-offset)
}

.smart-tabs[tab-position=bottom] .smart-drop-down-button-drop-down {
    top: auto
}

.smart-tabs[tab-position=left] .smart-tabs-selection-bar {
    right: 0;
    width: 2px
}

.smart-tabs[tab-position=left] .smart-tabs-header-section {
    border-right-width: 0
}

.smart-tabs[tab-position=left] .smart-tab-label-container {
    margin-bottom: 5px;
    margin-bottom: var(--smart-tab-item-offset);
    margin-left: 0;
    margin-right: 0;
    margin-top: 5px;
    margin-top: var(--smart-tab-item-initial-offset)
}

.smart-tabs[tab-position=left] .smart-tabs-content-section {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    margin: 0;
    margin: 0 0 0 var(--smart-tabs-header-offset)
}

.smart-tabs[tab-position=left] .smart-tab-group-drop-down {
    border-left: none
}

.smart-tabs[tab-position=left] .smart-drop-down-button-drop-down {
    border-left: none;
    left: 100%
}

.smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][horizontal] .smart-tab-strip,
.smart-tabs[tab-layout=wrap][vertical] .smart-tab-strip {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap
}

.smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][vertical] .smart-tab-strip {
    display: block
}

.smart-tabs[tab-layout=scroll] .smart-tab-strip {
    overflow: hidden;
    white-space: nowrap
}

.smart-tabs[tab-layout=scroll] .smart-tabs-header-section .smart-nav-button.smart-hidden {
    display: none
}

.smart-tabs[tab-layout=scroll] .smart-tabs-header-section.scroll-buttons-shown .smart-nav-button,
.smart-tabs[tab-layout=scroll][horizontal] .smart-tabs-header-items,
.smart-tabs[tab-layout=scroll][horizontal] .smart-tabs-header-section {
    display: flex
}

.smart-tabs[tab-layout=shrink] .smart-tab-strip {
    overflow: hidden;
    white-space: nowrap
}

.smart-tabs[tab-layout=shrink] .smart-tab-strip>.smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[tab-layout=shrink] .smart-tab-strip>.smart-tab-label-container .smart-tab-label-text-container {
    overflow: hidden
}

.smart-tabs[tab-layout=shrink] .smart-tab-strip.shrink-tabs {
    display: table;
    table-layout: fixed
}

.smart-tabs[tab-layout=shrink] .smart-tab-strip.shrink-tabs>.smart-tab-group-container,
.smart-tabs[tab-layout=shrink] .smart-tab-strip.shrink-tabs>.smart-tab-label-container {
    display: table-cell;
    vertical-align: top
}

.smart-tabs[tab-layout=shrink] .smart-tab-strip.shrink-tabs>.smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[tab-layout=shrink] .smart-tab-strip.shrink-tabs>.smart-tab-label-container .smart-tab-label-text-container {
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-tabs[tab-layout=shrink][horizontal] .smart-tab-group-container,
.smart-tabs[tab-layout=shrink][horizontal] .smart-tab-strip>.smart-tab-label-container {
    min-width: 0;
    min-width: auto
}

.smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip {
    display: flex;
    flex-direction: column
}

.smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip>.smart-tab-group-container {
    display: flex
}

.smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip>.smart-tab-label-container {
    display: flex;
    min-height: 0;
    min-height: auto;
    overflow: hidden
}

.smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip.shrink-tabs-vertical>.smart-tab-group-container,
.smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip.shrink-tabs-vertical>.smart-tab-label-container {
    margin-bottom: 0;
    margin-top: 0
}

.smart-tabs[tab-layout=shrink][vertical] .smart-tab-group-container {
    min-height: 0;
    min-height: auto;
    overflow: hidden
}

.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical] .smart-tab-strip>.smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical] .smart-tab-strip>.smart-tab-label-container .smart-tab-label-text-container {
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical] .smart-tab-strip.shrink-tabs {
    -webkit-writing-mode: initial;
    -ms-writing-mode: initial;
    writing-mode: initial
}

.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical] .smart-tab-strip.shrink-tabs>.smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical] .smart-tab-strip.shrink-tabs>.smart-tab-label-container .smart-tab-label-text-container {
    width: 100%
}

.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][vertical] .smart-tab-strip {
    white-space: nowrap;
    -webkit-writing-mode: initial;
    -ms-writing-mode: initial;
    writing-mode: initial
}

@media screen and (-webkit-min-device-pixel-ratio:0) {
    .smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][vertical] .smart-tab-label-text-wrapper {
        display: flex;
        height: auto
    }
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {
    .smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][vertical] .smart-tab-label-text-wrapper {
        overflow: hidden
    }
}

.smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][horizontal] .smart-tab-strip.shrink-tabs>div>.smart-tab-label-text-wrapper {
    padding-left: 5px;
    padding-right: 5px
}

.smart-tabs[tab-layout=dropDown] .smart-tab-strip {
    overflow: hidden;
    white-space: nowrap
}

.smart-tabs[tab-layout=dropDown] .smart-tabs-header-items>.smart-drop-down-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: block
}

.smart-tabs[tab-layout=dropDown][horizontal] .smart-tabs-header-items,
.smart-tabs[tab-layout=dropDown][horizontal] .smart-tabs-header-section {
    display: flex
}

.smart-tabs[tab-layout=dropDown][horizontal] .smart-tab-strip {
    width: calc(100% - 20px);
    width: calc(100% - var(--smart-tabs-header-button-size))
}

.smart-tabs[tab-layout=dropDown][vertical] .smart-tab-strip {
    height: calc(100% - 20px);
    height: calc(100% - var(--smart-tabs-header-button-size))
}

.smart-tabs[selected-index] .smart-tabs-content-section:after {
    opacity: 0
}

.smart-tabs[selected-index=null] .smart-tabs-selection-bar {
    visibility: hidden
}

.smart-tabs[selected-index=null] .smart-tabs-content-section:after {
    opacity: 1
}

.smart-tabs[close-buttons][horizontal] .smart-tab-strip>.smart-tab-label-container {
    min-width: 40px
}

.smart-tabs[close-buttons][horizontal] .smart-tab-strip>.smart-add-new-tab {
    min-width: 0;
    min-width: auto
}

.smart-tabs[close-buttons][vertical] .smart-tab-strip>.smart-add-new-tab {
    min-height: 0;
    min-height: auto
}

.smart-tabs[close-buttons][tab-text-orientation=vertical][vertical] .smart-tab-strip>.smart-tab-label-container {
    min-height: 40px
}

@-moz-document url-prefix() {
    .smart-tabs .smart-tab-label-container .smart-tab-label-text-container-full-height {
        height: 100%
    }

    .smart-tabs .smart-tab-group-container .smart-tab-label-text-container-full-height {
        height: calc(100% - 10px)
    }

    .smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][horizontal] .smart-tab-strip {
        display: block;
        height: 100%;
        writing-mode: initial
    }

    .smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][horizontal] .smart-tab-strip>div {
        float: left;
        writing-mode: vertical-lr
    }

    .smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip,
    .smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip .smart-tab-label-text-wrapper,
    .smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip>.smart-tab-group-container,
    .smart-tabs[tab-layout=shrink][vertical] .smart-tab-strip>.smart-tab-label-container {
        display: block
    }
}

@supports (-ms-ime-align:auto) {
    .smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][horizontal] .smart-tab-strip {
        display: block;
        height: 100%;
        -webkit-writing-mode: initial;
        -ms-writing-mode: initial;
        writing-mode: initial
    }

    .smart-tabs[tab-layout=wrap][tab-text-orientation=vertical][horizontal] .smart-tab-strip>div {
        float: left;
        -webkit-writing-mode: vertical-lr;
        -ms-writing-mode: tb-lr;
        writing-mode: vertical-lr
    }

    .smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][horizontal] .smart-tab-strip {
        display: flex;
        height: 100%;
        -webkit-writing-mode: initial;
        -ms-writing-mode: initial;
        writing-mode: initial
    }

    .smart-tabs[tab-layout=shrink][tab-text-orientation=vertical][horizontal] .smart-tab-strip>div {
        -webkit-writing-mode: vertical-lr;
        -ms-writing-mode: tb-lr;
        writing-mode: vertical-lr
    }
}

.smart-tabs[right-to-left] .smart-tab-group-container,
.smart-tabs[right-to-left] .smart-tab-label-container,
.smart-tabs[right-to-left] smart-tab-item>.smart-container {
    direction: rtl
}

.smart-tabs[right-to-left][tab-text-orientation=vertical] .smart-tab-strip {
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl
}

.smart-tabs[right-to-left]:not([vertical]) .smart-tab-strip {
    direction: rtl;
    text-align: right
}

.smart-tabs[right-to-left]:not([vertical]) .smart-tab-strip>.smart-tab-label-container:last-child {
    margin-left: 0;
    margin-right: 5px;
    margin-right: var(--smart-tab-item-offset)
}

.smart-tabs[right-to-left]:not([vertical]) .smart-tab-strip>.smart-tab-label-container:first-child {
    margin-left: 0;
    margin-right: 0
}

.smart-tabs[right-to-left][tab-position=right]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-group-container .smart-tab-label-text-container {
    margin-left: 0;
    margin-right: 18px
}

.smart-tabs[right-to-left][tab-position=right]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-group-arrow {
    left: auto;
    right: 2px
}

.smart-tabs[right-to-left]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-group-container .smart-tab-label-text-container,
.smart-tabs[right-to-left]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-label-text-container.smart-close-button-enabled {
    margin-left: 18px;
    margin-right: 0
}

.smart-tabs[right-to-left]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-close-button,
.smart-tabs[right-to-left]:not([tab-text-orientation=vertical]):not([vertical]) .smart-tab-group-arrow {
    left: 2px;
    right: auto
}

.smart-tabs-selection-bar {
    background: #005c99;
    background: var(--smart-ui-state-color-selected);
    bottom: 0;
    height: 2px;
    position: absolute;
    z-index: 5
}

.smart-tank:focus,
smart-slider:focus {
    outline: 0
}

smart-slider.smart-element,
smart-tank.smart-element {
    background: 0 0;
    border: none;
    overflow: visible
}

.smart-tank[labels-visibility=endPoints] .smart-label-middle,
.smart-tank[labels-visibility=none] .smart-label,
smart-slider[labels-visibility=endPoints] .smart-label-middle,
smart-slider[labels-visibility=none] .smart-label {
    visibility: hidden
}

.smart-tank *,
smart-slider * {
    box-sizing: border-box
}

.smart-tank .smart-label,
smart-slider .smart-label {
    color: #5a5a5a;
    color: var(--smart-background-color);
    float: left;
    font-family: inherit;
    font-size: inherit;
    white-space: nowrap
}

smart-tank {
    height: 300px;
    height: var(--smart-tank-default-height);
    padding-left: 5px;
    padding-right: 5px;
    width: 250px;
    width: var(--smart-tank-default-width)
}

smart-tank.smart-scale-far .smart-tick {
    top: auto
}

smart-slider .smart-container {
    overflow: visible
}

smart-slider .smart-scale {
    pointer-events: none;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

smart-slider .smart-label {
    position: absolute
}

smart-slider .smart-tooltip {
    z-index: 1
}

smart-slider .smart-tooltip-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

smart-slider .smart-track-container {
    touch-action: none
}

smart-slider .smart-track-ticks-container {
    height: 100%;
    pointer-events: none;
    position: absolute;
    width: 100%
}

smart-slider[ticks-visibility=major] .smart-tick,
smart-slider[ticks-visibility=major] .smart-tick-minor,
smart-slider[ticks-visibility=none] .smart-tick,
smart-slider[ticks-visibility=none] .smart-tick-minor {
    display: none
}

.smart-tank .smart-container {
    overflow: visible
}

.smart-tank .smart-track {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: solid #e0e0e0;
    border: var(--smart-border) solid;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    border-width: var(--smart-border-width);
    float: left;
    height: 100%;
    margin: 0 2px;
    min-width: 6px;
    min-width: var(--smart-tank-minimum-track-size);
    position: relative;
    touch-action: none;
    width: calc(100% - 109px);
    width: calc(100% - var(--smart-tank-scale-size) - 4px)
}

.smart-tank .smart-track.track-hovered {
    cursor: pointer
}

.smart-tank .smart-track-ticks-container {
    height: 100%;
    pointer-events: none;
    position: absolute;
    width: 100%
}

.smart-tank .smart-value {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    height: 0;
    position: absolute;
    width: 100%
}

.smart-tank .smart-label {
    position: absolute
}

.smart-tank .smart-thumb {
    border-radius: 50%;
    display: none;
    height: 25px;
    height: var(--smart-tank-thumb-height);
    left: -50px;
    left: calc(var(--smart-tank-thumb-width)*-1*2);
    position: absolute;
    top: -12.5px;
    top: calc(var(--smart-tank-thumb-height)*-1/2);
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: -webkit-transform .2s ease-out;
    transition: transform .2s ease-out;
    transition: transform .2s ease-out, -webkit-transform .2s ease-out;
    width: 25px;
    width: var(--smart-tank-thumb-width)
}

.smart-tank .smart-thumb,
.smart-tank .smart-thumb:before {
    background-color: #005c99;
    background-color: var(--smart-primary)
}

.smart-tank .smart-thumb:before {
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-radius: 50% 0 50% 50%;
    content: "";
    display: block;
    height: 100%;
    -webkit-transform: scale(1.1) rotate(45deg);
    transform: scale(1.1) rotate(45deg);
    width: 100%
}

.smart-tank .smart-thumb-label-container {
    height: 25px;
    height: var(--smart-tank-thumb-height);
    left: 0;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    top: 0;
    width: 25px;
    width: var(--smart-tank-thumb-width)
}

.smart-tank .smart-scale {
    float: left;
    height: calc(100% - 1px);
    height: calc(100% - var(--smart-border-width));
    margin-left: 0;
    margin-top: 1px;
    margin-top: var(--smart-border-width);
    max-width: calc(100% - 10px);
    max-width: calc(100% - var(--smart-tank-minimum-track-size) - 4px);
    pointer-events: none;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 105px;
    width: var(--smart-tank-scale-size)
}

.smart-tank .smart-scale-near .smart-tick {
    bottom: auto;
    right: 0
}

.smart-tank .smart-scale-near .smart-label {
    bottom: auto;
    right: 12px;
    right: calc(var(--smart-tank-tick-size) + 2px)
}

.smart-tank .smart-scale-far .smart-label {
    left: 12px;
    left: calc(var(--smart-tank-tick-size) + 2px);
    top: auto
}

.smart-tank .smart-tooltip {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    height: 30px;
    height: var(--smart-tank-tooltip-height);
    justify-content: center;
    left: -90.5px;
    left: calc(var(--smart-tank-tooltip-width)*-1 - 10.5px);
    opacity: .7;
    padding: 5px;
    position: absolute;
    top: -15px;
    top: calc(var(--smart-tank-tooltip-height)*-1/2);
    width: 80px;
    width: var(--smart-tank-tooltip-width);
    z-index: 1
}

.smart-tank .smart-tooltip.smart-hidden,
.smart-tank:not([animation=none])[disabled] .bubble,
.smart-tank:not([animation=none])[inverted] .bubble,
.smart-tank:not([animation=none])[orientation=horizontal] .bubble,
.smart-tank[ticks-visibility=major] .smart-tick,
.smart-tank[ticks-visibility=major] .smart-tick-minor,
.smart-tank[ticks-visibility=none] .smart-tick,
.smart-tank[ticks-visibility=none] .smart-tick-minor {
    display: none
}

.smart-tank .smart-tooltip:before {
    border-bottom: 6px solid transparent;
    border-left: 6px solid #e0e0e0;
    border-left: 6px solid var(--smart-border);
    border-right: none;
    border-top: 6px solid transparent;
    content: "";
    height: 0;
    left: auto;
    position: absolute;
    right: -7px;
    top: calc(50% - 6px);
    width: 0
}

.smart-tank .smart-tooltip-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-tank .smart-tick {
    background-color: #5a5a5a;
    background-color: var(--smart-background-color);
    float: none;
    height: 1px;
    position: absolute;
    width: 10px;
    width: var(--smart-tank-tick-size)
}

.smart-tank .smart-tick-minor {
    height: 1px;
    width: 5px;
    width: var(--smart-tank-minor-tick-size)
}

.smart-tank:focus .smart-track {
    border-color: #b2b2b2;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-outline)
}

.smart-tank:active .smart-track {
    cursor: n-resize
}

.smart-tank:not([animation=none]) .smart-value {
    transition: height .15s ease-out, margin-top .15s ease-out
}

.smart-tank:not([animation=none]) .smart-value.disable-animation {
    transition: none
}

.smart-tank:not([animation=none]) .smart-bubble-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    touch-action: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-tank:not([animation=none]) .bubble {
    border-radius: 50%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, .2), inset 0 10px 25px 5px #fff;
    height: 50px;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 50px
}

.smart-tank:not([animation=none]) .bubble1 {
    -webkit-animation: animateBubble 12.5s linear infinite, sideWays 5s ease-in-out infinite alternate;
    animation: animateBubble 12.5s linear infinite, sideWays 5s ease-in-out infinite alternate;
    left: 10%;
    top: 40%;
    -webkit-transform: scale(.25);
    transform: scale(.25)
}

.smart-tank:not([animation=none]) .bubble2 {
    -webkit-animation: animateBubble 15s linear infinite, sideWays 4.5s ease-in-out infinite alternate;
    animation: animateBubble 15s linear infinite, sideWays 4.5s ease-in-out infinite alternate;
    left: 5%;
    top: 35%;
    -webkit-transform: scale(.2);
    transform: scale(.2)
}

.smart-tank:not([animation=none]) .bubble3 {
    -webkit-animation: animateBubble 10s linear infinite, sideWays 7s ease-in-out infinite alternate;
    animation: animateBubble 10s linear infinite, sideWays 7s ease-in-out infinite alternate;
    left: 0;
    top: 50%;
    -webkit-transform: scale(.3);
    transform: scale(.3)
}

.smart-tank:not([animation=none]) .bubble4 {
    -webkit-animation: animateBubble 7s linear infinite, sideWays 11s ease-in-out infinite alternate;
    animation: animateBubble 7s linear infinite, sideWays 11s ease-in-out infinite alternate;
    left: 10%;
    top: 60%;
    -webkit-transform: scale(.275);
    transform: scale(.275)
}

.smart-tank:not([animation=none]) .bubble5 {
    -webkit-animation: animateBubble 14.5s linear infinite, sideWays 8s ease-in-out infinite alternate;
    animation: animateBubble 14.5s linear infinite, sideWays 8s ease-in-out infinite alternate;
    left: 8%;
    top: 70%;
    -webkit-transform: scale(.35);
    transform: scale(.35)
}

.smart-tank[disabled] .smart-track.track-hovered,
.smart-tank[disabled]:active .smart-track,
.smart-tank[readonly] .smart-track.track-hovered,
.smart-tank[readonly]:active .smart-track {
    cursor: default
}

.smart-tank[inverted] .smart-thumb {
    margin-left: 0;
    margin-top: 0;
    top: calc(100% - 12.5px);
    top: calc(100% - var(--smart-tank-thumb-height)/2)
}

.smart-tank[inverted] .smart-tooltip {
    left: -90.5px;
    left: calc(var(--smart-tank-tooltip-width)*-1 - 10.5px);
    top: calc(100% - 15px);
    top: calc(100% - var(--smart-tank-tooltip-height)*1/2)
}

.smart-tank[inverted]:focus .smart-thumb {
    top: calc(100% - 12.5px);
    top: calc(100% - var(--smart-tank-thumb-height)/2)
}

.smart-tank[inverted][tooltip-position=far] .smart-tooltip {
    top: calc(100% - 15px);
    top: calc(100% - var(--smart-tank-tooltip-height)/2)
}

.smart-tank[inverted][tooltip-position=far][scale-position=none] .smart-tooltip {
    left: calc(-100% - 7px)
}

.smart-tank[inverted][tooltip-position=near] .smart-tooltip {
    left: -90.5px;
    left: calc(var(--smart-tank-tooltip-width)*-1 - 10.5px);
    top: calc(100% - 15px);
    top: calc(100% - var(--smart-tank-tooltip-height)/2)
}

.smart-tank[inverted][orientation=vertical] .smart-thumb {
    top: calc(100% - 12.5px);
    top: calc(100% - var(--smart-tank-thumb-height)/2)
}

.smart-tank[ticks-visibility=none] .smart-scale-near .smart-label {
    right: 2px
}

.smart-tank[ticks-visibility=none] .smart-scale-far .smart-label {
    left: 2px;
    top: auto
}

.smart-tank[ticks-position=track] .smart-tick {
    width: 100%
}

.smart-tank[ticks-position=track] .smart-tick-minor {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 80%
}

.smart-tank[ticks-position=track] .smart-scale-near .smart-label {
    right: 2px
}

.smart-tank[ticks-position=track] .smart-scale-far .smart-label {
    left: 2px;
    top: auto
}

.smart-tank[tooltip-position=far] .smart-tooltip {
    left: calc(100% + 10.5px);
    top: -15px;
    top: calc(var(--smart-tank-tooltip-height)*-1/2)
}

.smart-tank[tooltip-position=far] .smart-tooltip:before {
    border: 6px solid transparent;
    border-left: none;
    border-right-color: #e0e0e0;
    border-right: 6px solid var(--smart-border);
    left: -7px;
    top: calc(50% - 6px)
}

.smart-tank[show-thumb-label] .smart-thumb {
    display: inline;
    display: initial;
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2);
    overflow: visible
}

.smart-tank[show-thumb-label] .smart-thumb-label {
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: .65rem;
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-tank[show-thumb-label]:focus .smart-thumb {
    left: -39.5px;
    left: calc(var(--smart-tank-thumb-width)*-1 - var(--smart-tank-thumb-width)/2 - 2px);
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-tank[show-thumb-label]:not([animation=none]) .smart-thumb {
    transition: left .2s ease-in-out, top .2s ease-in-out, -webkit-transform .2s ease-out;
    transition: transform .2s ease-out, left .2s ease-in-out, top .2s ease-in-out;
    transition: transform .2s ease-out, left .2s ease-in-out, top .2s ease-in-out, -webkit-transform .2s ease-out
}

.smart-tank[show-thumb-label][thumb-label-position=far] .smart-thumb {
    left: calc(100% - 12.5px);
    left: calc(100% - var(--smart-tank-thumb-width)/2)
}

.smart-tank[show-thumb-label][orientation=horizontal] .smart-thumb {
    left: 100%;
    top: -12.5px;
    top: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[show-thumb-label][orientation=horizontal][inverted] .smart-thumb {
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[show-thumb-label][orientation=horizontal][thumb-label-position=far] .smart-thumb {
    left: 100%;
    top: calc(100% - 12.5px);
    top: calc(100% - var(--smart-tank-thumb-width)/2)
}

.smart-tank[show-thumb-label][orientation=horizontal][thumb-label-position=far][inverted] .smart-thumb {
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[show-thumb-label][orientation=horizontal][thumb-label-position=near] .smart-thumb {
    left: 100%;
    top: -12.5px;
    top: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[thumb-label-position=far] .smart-thumb:before {
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-radius: 50% 50% 50% 0
}

.smart-tank[thumb-label-position=far]:focus .smart-thumb {
    left: calc(100% + 14.5px);
    left: calc(100% + var(--smart-tank-thumb-width)/2 + 2px)
}

.smart-tank[scale-position=none] .smart-track {
    border: solid #e0e0e0;
    border: var(--smart-border) solid;
    border-width: 1px;
    border-width: var(--smart-border-width);
    height: 100%;
    margin: 0;
    position: relative;
    width: 100%
}

.smart-tank[scale-position=none]:focus .smart-track {
    border-color: #b2b2b2;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-outline)
}

.smart-tank[scale-position=none][tooltip-position=near] .smart-tooltip {
    top: -15px;
    top: calc(var(--smart-tank-tooltip-height)*-1/2)
}

.smart-tank[scale-position=both] .smart-track {
    width: calc(100% - 214px);
    width: calc(100% - var(--smart-tank-scale-size)*2 - 4px)
}

.smart-tank[scale-position=both] .smart-scale {
    height: 100%;
    max-width: 47%;
    width: 105px;
    width: var(--smart-tank-scale-size)
}

.smart-tank[orientation=vertical][thumb-label-position=far] .smart-thumb:before {
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    border-radius: 50% 50% 50% 0
}

.smart-tank[orientation=vertical]:not([animation=none]) .smart-value {
    transition: height .15s ease-out, margin-top .15s ease-out
}

.smart-tank[orientation=vertical]:not([animation=none]) .smart-value.disable-animation {
    transition: none
}

.smart-tank[orientation=horizontal] {
    padding: 5px 0
}

.smart-tank[orientation=horizontal]:active .smart-track {
    cursor: w-resize
}

.smart-tank[orientation=horizontal] .smart-track {
    background-color: transparent;
    height: calc(100% - 109px);
    height: calc(100% - var(--smart-tank-scale-size) - 4px);
    margin-bottom: 2px;
    margin-top: 2px;
    min-height: 6px;
    min-height: var(--smart-tank-minimum-track-size);
    width: 100%
}

.smart-tank[orientation=horizontal] .smart-value {
    height: 100%;
    width: 0
}

.smart-tank[orientation=horizontal] .smart-thumb {
    margin-left: -12.5px;
    margin-left: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[orientation=horizontal] .smart-thumb:before {
    border-radius: 50% 50% 0
}

.smart-tank[orientation=horizontal] .smart-scale {
    float: left;
    height: 105px;
    height: calc(var(--smart-tank-scale-size));
    margin-left: 1px;
    margin-left: var(--smart-border-width);
    width: 100%
}

.smart-tank[orientation=horizontal] .smart-scale-near .smart-tick {
    bottom: 0;
    right: auto
}

.smart-tank[orientation=horizontal] .smart-scale-near .smart-label {
    bottom: 12px;
    bottom: calc(var(--smart-tank-tick-size) + 2px);
    right: auto
}

.smart-tank[orientation=horizontal] .smart-scale-far .smart-tick {
    top: 0
}

.smart-tank[orientation=horizontal] .smart-scale-far .smart-label {
    left: auto;
    top: 12px;
    top: calc(var(--smart-tank-tick-size) + 2px)
}

.smart-tank[orientation=horizontal] .smart-tooltip {
    left: calc(100% - 40px);
    left: calc(100% - var(--smart-tank-tooltip-width)/2);
    top: -42px;
    top: calc(var(--smart-tank-tooltip-height)*-1 - 12px)
}

.smart-tank[orientation=horizontal] .smart-tooltip:before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #e0e0e0;
    border-top: 6px solid var(--smart-border);
    content: "";
    height: 0;
    left: 34px;
    left: calc(var(--smart-tank-tooltip-width)/2 - 6px);
    position: absolute;
    top: 100%;
    width: 0
}

.smart-tank[orientation=horizontal] .smart-tick {
    float: left;
    height: 10px;
    height: var(--smart-tank-tick-size);
    width: 1px
}

.smart-tank[orientation=horizontal] .smart-tick-minor {
    height: 5px;
    height: var(--smart-tank-minor-tick-size);
    width: 1px
}

.smart-tank[orientation=horizontal]:not([animation=none]) .smart-value {
    transition: width .15s ease-out, margin-left .15s ease-out
}

.smart-tank[orientation=horizontal]:not([animation=none]) .smart-value.disable-animation {
    transition: none
}

.smart-tank[orientation=horizontal][inverted] .smart-tooltip {
    left: -40px;
    left: calc(var(--smart-tank-tooltip-width)*-1/2);
    top: -42px;
    top: calc(var(--smart-tank-tooltip-height)*-1 - 12px)
}

.smart-tank[orientation=horizontal][inverted]:focus .smart-thumb {
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2)
}

.smart-tank[orientation=horizontal][inverted][tooltip-position=far] .smart-tooltip {
    left: -40px;
    left: calc(var(--smart-tank-tooltip-width)*-1/2);
    top: calc(100% + 12px)
}

.smart-tank[orientation=horizontal][ticks-visibility=none] .smart-scale-near .smart-label {
    bottom: 2px
}

.smart-tank[orientation=horizontal][ticks-visibility=none] .smart-scale-far .smart-label {
    left: auto;
    top: 2px
}

.smart-tank[orientation=horizontal][ticks-position=track] .smart-tick {
    height: 100%;
    width: 1px
}

.smart-tank[orientation=horizontal][ticks-position=track] .smart-tick-minor {
    height: 80%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%)
}

.smart-tank[orientation=horizontal][ticks-position=track] .smart-scale-near .smart-label {
    bottom: 2px
}

.smart-tank[orientation=horizontal][ticks-position=track] .smart-scale-far .smart-label {
    left: auto;
    top: 2px
}

.smart-tank[orientation=horizontal][tooltip-position=near][inverted] .smart-tooltip {
    left: -40px;
    left: calc(var(--smart-tank-tooltip-width)*-1/2);
    top: -42px;
    top: calc(var(--smart-tank-tooltip-height)*-1 - 12px)
}

.smart-tank[orientation=horizontal][tooltip-position=far] .smart-tooltip {
    left: calc(100% - 40px);
    left: calc(100% - var(--smart-tank-tooltip-width)/2);
    top: calc(100% + 12px)
}

.smart-tank[orientation=horizontal][tooltip-position=far] .smart-tooltip:before {
    border-bottom: 6px solid #e0e0e0;
    border-bottom: 6px solid var(--smart-border);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 0;
    left: 34px;
    left: calc(var(--smart-tank-tooltip-width)/2 - 6px);
    position: absolute;
    top: -7px
}

.smart-tank[orientation=horizontal][show-thumb-label]:focus .smart-thumb {
    left: 100%;
    top: -39.5px;
    top: calc(var(--smart-tank-thumb-height)*-1 - var(--smart-tank-thumb-height)/2 - 2px)
}

.smart-tank[orientation=horizontal][show-thumb-label][thumb-label-position=far]:focus .smart-thumb {
    top: calc(100% + 12.5px);
    top: calc(100% + var(--smart-tank-thumb-height)/2)
}

.smart-tank[orientation=horizontal][thumb-label-position=far] .smart-thumb:before {
    border-radius: 0 50% 50%
}

.smart-tank[orientation=horizontal][thumb-label-position=far]:focus .smart-thumb {
    left: 100%
}

.smart-tank[orientation=horizontal][scale-position=none] .smart-track {
    background-color: transparent;
    border: solid #e0e0e0;
    border: var(--smart-border) solid;
    border-width: 1px;
    border-width: var(--smart-border-width);
    height: 100%;
    margin-bottom: 0;
    margin-top: 0;
    position: relative;
    width: 100%
}

.smart-tank[orientation=horizontal][scale-position=both] .smart-track {
    height: calc(100% - 214px);
    height: calc(100% - var(--smart-tank-scale-size)*2 - 4px)
}

.smart-tank[orientation=horizontal][scale-position=both] .smart-scale {
    height: 105px;
    height: var(--smart-tank-scale-size);
    width: 100%
}

smart-tank[right-to-left] .smart-label,
smart-tank[right-to-left] .smart-tooltip-content {
    direction: rtl
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal] .smart-thumb {
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2);
    margin-left: 0
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][inverted] .smart-thumb {
    left: 100%;
    margin-left: -12.5px;
    margin-left: calc(var(--smart-tank-thumb-width)*-1/2)
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][thumb-label-position=far] .smart-thumb {
    left: -12.5px;
    left: calc(var(--smart-tank-thumb-width)*-1/2)
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][thumb-label-position=far][inverted] .smart-thumb {
    top: calc(100% - 12.5px);
    top: calc(100% - var(--smart-tank-thumb-width)/2)
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][thumb-label-position=far][inverted]:focus .smart-thumb {
    top: calc(100% + 12.5px);
    top: calc(100% + var(--smart-tank-thumb-height)/2)
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][thumb-label-position=near][inverted] .smart-thumb {
    top: -12.5px;
    top: calc(var(--smart-tank-thumb-width)*-1/2)
}

smart-tank[right-to-left][show-thumb-label][orientation=horizontal][thumb-label-position=near][inverted]:focus .smart-thumb {
    top: -39.5px;
    top: calc(var(--smart-tank-thumb-height)*-1 - var(--smart-tank-thumb-height)/2 - 2px)
}

@-webkit-keyframes sideWays {
    0% {
        margin-left: -10%
    }

    to {
        margin-left: 55%
    }
}

@keyframes sideWays {
    0% {
        margin-left: -10%
    }

    to {
        margin-left: 55%
    }
}

@-webkit-keyframes animateBubble {
    0% {
        margin-top: 100%
    }

    to {
        margin-top: -100%
    }
}

@keyframes animateBubble {
    0% {
        margin-top: 100%
    }

    to {
        margin-top: -100%
    }
}

.smart-input-drop-down-menu,
input.smart-input {
    color: #5a5a5a;
    color: var(--smart-background-color);
  /*  font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size)*/
    font: 300 13px/19px 'Open Sans','Helvetica Neue',helvetica,arial,verdana,sans-serif  !important;
}

input.smart-input {
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    box-sizing: border-box;
    height: 30px;
    height: var(--smart-editor-height);
    outline: 0;
    padding-bottom: 0;
    padding-left: 0;
  /*  padding-left: var(--smart-editor-label-padding);*/
    padding-right: 0;
   /* padding-right: var(--smart-editor-label-padding);*/
    padding-top: 0;
    text-align: var(--smart-text-box-text-align)
}

input.smart-input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

input.smart-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

input.smart-input:disabled {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

input.smart-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

textarea.smart-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

.smart-input-drop-down-menu {
    --smart-input-drop-down-menu-width: auto;
    --smart-input-drop-down-menu-height: 200px;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    display: block;
    float: left;
    height: auto;
    left: 0;
    margin: 3px;
    margin: var(--smart-list-item-vertical-offset) var(--smart-list-item-horizontal-offset);
    min-height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 2px;
    position: absolute;
    top: 100%;
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    width: auto;
    z-index: 999999;

}

.smart-input-drop-down-menu:not([animation=none]) {
    transition: opacity .2s, -webkit-transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-input-drop-down-menu.smart-container {
    box-shadow: none;
    margin: 0;
    padding: 0
}

.smart-input-drop-down-menu .smart-scroll-viewer-container,
.smart-input-drop-down-menu .smart-scroll-viewer-content-container,
.smart-input-drop-down-menu>.smart-container {
    max-height: calc(var(--smart-input-drop-down-menu-height) - 6px);
    width: var(--smart-input-drop-down-menu-width)
}

.smart-input-drop-down-menu .smart-scroll-viewer-content-container {
    max-height: none;
    padding: 0
}

.smart-input-drop-down-menu ul {
    height: auto;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%
}

.smart-input-drop-down-menu ul.scroll {
    width: calc(100% - 20px);
    width: calc(100% - var(--smart-scroll-bar-size) - 2px)
}

.smart-input-drop-down-menu ul li {
    padding-bottom: 1px
}

.smart-input-drop-down-menu ul li:last-child {
    padding-bottom: 0
}

.smart-input-drop-down-menu ul li a {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    clear: both;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    font-weight: 400;
    padding: 8px 12px;
    text-decoration: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-input-drop-down-menu ul li a:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-input-drop-down-menu ul li a.icon {
    padding-left: 30px;
    padding-left: var(--smart-column-icon-size);
    position: relative
}

.smart-input-drop-down-menu ul li a.icon:after {
    background-position: 50%;
    background-repeat: no-repeat;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 30px;
    width: var(--smart-column-icon-size)
}

.smart-input-drop-down-menu:not(.smart-check-input-drop-down-menu) li.active a {
    background: #e2e0e0;
    background: var(--smart-ui-state-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus);
    outline: 0;
    text-decoration: none
}

.smart-input-drop-down-menu[open] {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-multi-combo-input-scroll-viewer .smart-scroll-viewer-content-container {
    max-height: none;
    width: var(--smart-input-drop-down-menu-width)
}

.smart-multi-combo-input-scroll-viewer .smart-scroll-viewer-container,
.smart-multi-combo-input-scroll-viewer>.smart-container {
    max-height: calc(var(--smart-input-drop-down-menu-height) - 6px);
    width: var(--smart-input-drop-down-menu-width)
}

smart-text-area,
smart-text-box {
    width: 250px;
    width: var(--smart-text-box-default-width)
}

.smart-drop-down smart-list-item[focus] .smart-overlay {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus)
}

.smart-drop-down smart-list-item[focus] .smart-content {
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-drop-down smart-list-item[focus][selected] .smart-overlay {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected)
}

.smart-drop-down smart-list-item[focus][selected] .smart-content {
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-text-box:focus.hovered input,
smart-text-box input:hover,
smart-text-box:focus input.hovered,
smart-text-box[hover] input {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-text-box {
    --smart-outline: var(--smart-primary);
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible
}

smart-text-box input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

.smart-text-area textarea.smart-input,
smart-input,
smart-input.smart-element,
smart-text-area,
smart-text-box.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

smart-text-box[disabled] {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

smart-text-box input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-text-box .smart-container,
.smart-text-box input,
.smart-text-box.smart-container {
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-text-box>.smart-container>.smart-content {
    height: 100%
}

.smart-text-box>.smart-container>.smart-content>div {
    background-color: transparent;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    height: 100%;
    outline: 0;
    overflow: hidden;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    width: 100%
}

.smart-text-box>.smart-container>.smart-content>div>label {
    color: transparent
}

.smart-text-box>.smart-container>.smart-content>div:first-of-type {
    align-items: center;
    border: 1px solid transparent;
    border: var(--smart-border-width) solid transparent;
    display: flex;
    height: auto;
    max-height: none;
    min-height: 0;
    min-height: auto;
    opacity: .5;
    padding-bottom: 1px;
    padding-top: 1px;
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    width: auto
}

.smart-text-box[disabled] input,
.smart-text-box[readonly] input {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none
}

.smart-text-box .smart-hint,
.smart-text-box .smart-label {
    display: none;
    position: absolute
}

.smart-text-box[hint] .smart-hint,
.smart-text-box[label] .smart-label {
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    vertical-align: baseline;
    vertical-align: initial;
    width: 100%
}

.smart-text-box[label] .smart-label {
    bottom: 100%
}

.smart-text-box[hint] .smart-hint,
.smart-text-box[label] .smart-label {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none
}

.smart-text-box[hint] .smart-hint {
    bottom: auto;
    opacity: 0;
    top: 100%;
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

smart-input,
smart-number-input,
smart-text-area {
    display: inline-block;
    overflow: visible
}

.smart-text-box[hint][focus] .smart-hint {
    opacity: 1;
    transition: opacity .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-text-box .smart-drop-down {
    font-family: inherit
}

.smart-text-box[right-to-left] .smart-hint,
.smart-text-box[right-to-left] .smart-label,
.smart-text-box[right-to-left]>.smart-container>.smart-content {
    direction: rtl
}

smart-text-area {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    height: 45px;
    height: calc(var(--smart-text-box-default-height)*1.5)
}

smart-text-area textarea {
    margin: 0;
    resize: none
}

smart-text-area textarea.smart-input {
    border: none;
    text-overflow: ellipsis
}

.smart-text-area .smart-container {
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-text-area textarea.smart-input {
    border: none;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 100%;
    outline: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    text-align: var(--smart-text-box-text-align);
    width: 100%
}

smart-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    height: 30px;
    height: var(--smart-text-box-default-height);
    width: 250px;
    width: var(--smart-text-box-default-width)
}

.smart-input.smart-container,
smart-input>.smart-container {
    display: flex
}

smart-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-input:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-input[disabled] {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

smart-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-input .smart-container,
.smart-input.smart-container {
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-input .smart-drop-down-button {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #323232;
    color: var(--smart-surface-color);
    display: none;
    flex-direction: column;
    height: 100%;
    outline: 0;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-input .smart-drop-down-button .arrow {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    height: 100%;
    justify-content: center;
    outline: 0;
    overflow: hidden
}

.smart-input .smart-drop-down-button .arrow:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    transition: opacity .2s, -webkit-transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out;
    transition: opacity .2s, transform .2s ease-out, -webkit-transform .2s ease-out
}

.smart-input .smart-drop-down-button[open] .arrow:after {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg)
}

.smart-input .smart-input {
    border: none;
    height: 100%;
   /* padding: 4px;
   padding: var(--smart-editor-label-padding);*/
    width: 100%
}

.smart-input[drop-down-button-position=left] .smart-drop-down-button,
.smart-input[drop-down-button-position=right] .smart-drop-down-button {
    display: flex
}

.smart-input[drop-down-button-position=left] .smart-input,
.smart-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-input[drop-down-button-position=left][disabled] .smart-drop-down-button,
.smart-input[drop-down-button-position=right][disabled] .smart-drop-down-button {
    opacity: .5
}

.smart-input[drop-down-button-position=left] .smart-drop-down-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0;
    order: -1
}

.smart-input[drop-down-button-position=left] .smart-input {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0
}

.smart-input[drop-down-button-position=left][readonly] .smart-drop-down-button {
    border-right: none
}

.smart-input[drop-down-button-position=right] .smart-input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.smart-input[focus],
.smart-input[focus]:not([disabled]) .smart-drop-down-button {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-input[readonly] .smart-drop-down-button {
    border-left: none
}

.smart-input[readonly]:not(.underlined):not(.outlined) input.smart-input,
.smart-input[readonly]:not(.underlined):not(.outlined) textarea.smart-input {
    cursor: pointer;
    outline: 0;
    padding: 0 0 0 4px;
    padding-left: var(--smart-editor-label-padding)
}

.smart-input[readonly]:not(.underlined):not(.outlined):not([opened]):not(:active) input.smart-input,
.smart-input[readonly]:not(.underlined):not(.outlined):not([opened]):not(:active) textarea.smart-input {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-input:not([disabled]) .smart-drop-down-button:hover,
.smart-input:not([disabled])[readonly]:hover .smart-drop-down-button,
.smart-input:not([disabled])[readonly]:hover .smart-input {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-input:not([disabled]) .smart-drop-down-button:active,
.smart-input:not([disabled]) .smart-drop-down-button[open],
.smart-input:not([disabled])[readonly]:active .smart-drop-down-button,
.smart-input:not([disabled])[readonly]:active .smart-input,
.smart-input:not([disabled])[readonly][open] .smart-drop-down-button,
.smart-input:not([disabled])[readonly][open] .smart-input {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-number-input,
smart-number-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-input:not([disabled])[readonly]:active .smart-input::-webkit-input-placeholder,
.smart-input:not([disabled])[readonly][open] .smart-input::-webkit-input-placeholder {
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-input:not([disabled])[readonly]:active .smart-input::-moz-placeholder,
.smart-input:not([disabled])[readonly][open] .smart-input::-moz-placeholder {
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-input[disabled] .smart-drop-down-button .arrow {
    cursor: auto
}

.smart-input[right-to-left] .smart-input {
    direction: rtl
}

.smart-input[right-to-left][readonly] .smart-drop-down-button {
    border-right: none
}

.smart-input[right-to-left][readonly] .smart-input,
.smart-input[right-to-left][readonly]:not(.underlined):not(.outlined) .smart-input {
    padding-left: 0;
    padding-right: 4px;
    padding-right: var(--smart-editor-label-padding)
}

.smart-input-drop-down-menu[right-to-left] ul.scroll {
    width: 100%
}

.smart-input-drop-down-menu[right-to-left] li a.icon {
    padding-left: 0;
    padding-right: 30px;
    padding-right: var(--smart-column-icon-size)
}

.smart-input-drop-down-menu[right-to-left] li a.icon:after {
    left: auto;
    right: 0
}

smart-number-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    height: 30px;
    height: var(--smart-text-box-default-height);
    text-align: right;
    width: 250px;
    width: var(--smart-text-box-default-width)
}

smart-number-input>.smart-container {
    display: flex
}

.smart-number-input .nav,
.smart-number-input .nav.smart-drop-down-button:active,
.smart-number-input .nav.smart-drop-down-button:hover,
.smart-number-input .nav:active,
.smart-number-input .nav:hover {
    background: #f5f5f5;
    background: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

smart-number-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

.smart-multi-combo-input-drop-down-menu .smart-select-all,
.smart-number-input .nav .up {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-number-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-number-input .nav {
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-multi-input,
smart-password-input {
    width: 250px;
    width: var(--smart-text-box-default-width)
}

.smart-number-input .nav .down,
.smart-number-input .nav .up {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 50%;
    justify-content: center;
    outline: 0;
    overflow: hidden
}

.smart-check-input .smart-container,
.smart-multi-combo-input .smart-container,
.smart-multi-input .smart-container,
.smart-password-input .smart-container {
    font-family: inherit;
    overflow: visible;
    position: relative
}

.smart-number-input .nav .down:hover,
.smart-number-input .nav .up:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-number-input .nav .down:active,
.smart-number-input .nav .down[active],
.smart-number-input .nav .up:active,
.smart-number-input .nav .up[active] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-password-input,
smart-password-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-number-input .nav .up:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up)
}

.smart-number-input .nav .down:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-number-input[disabled] .nav .down,
.smart-number-input[disabled] .nav .up {
    pointer-events: none
}

.smart-number-input[right-to-left]>.smart-container {
    direction: rtl
}

.smart-number-input[right-to-left] .nav {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-right-radius);
    border-bottom-right-radius: 0;
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-right-radius);
    border-top-right-radius: 0;
    order: 0
}

.smart-number-input[right-to-left] .smart-input {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-number-input[right-to-left][focus] .nav {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-password-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible
}

smart-password-input>.smart-container {
    display: flex
}

smart-password-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

.smart-password-input input::-ms-clear,
.smart-password-input input::-ms-reveal {
    display: none
}

.smart-password-input .smart-container {
    color: inherit;
    height: 100%;
    width: 100%
}

.smart-password-input .smart-drop-down-button {
    background: 0 0;
    border-color: transparent;
    border-left: none;
    display: block
}

.smart-password-input .smart-drop-down-button:active,
.smart-password-input .smart-drop-down-button:hover,
.smart-password-input .smart-drop-down-button[active] {
    background: 0 0 !important;
    border-color: transparent !important;
    color: #005c99 !important;
    color: var(--smart-primary) !important
}

smart-multi-input,
smart-multi-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-password-input .smart-drop-down-button .arrow:after {
    color: #5a5a5a;
    color: var(--smart-background-color);
    content: "\\e90d";
    content: var(--smart-icon-visibility)
}

.smart-password-input .smart-drop-down-button .arrow.off:after {
    color: #5a5a5a;
    color: var(--smart-background-color);
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

smart-multi-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible
}

smart-multi-input>.smart-container {
    display: flex
}

smart-multi-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-multi-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-multi-input:focus,
smart-multi-input[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-multi-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-multi-input[disabled] {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

smart-multi-input[drop-down-button-position=left] .smart-input,
smart-multi-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-multi-input .smart-container {
    color: inherit;
    height: 100%;
    width: 100%
}

.smart-multi-input-drop-down-menu li a {
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent
}

.smart-multi-input-drop-down-menu:not(.smart-check-input-drop-down-menu) li.active a {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-bottom-left-radius: 0;
    border-left: 1px solid #005c99;
    border-left: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 0;
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

smart-multi-combo-input,
smart-multi-combo-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-multi-input-drop-down-menu[right-to-left] li a {
    border-left: none;
    border-right: 1px solid transparent;
    border-right: var(--smart-border-width) solid transparent
}

.smart-multi-input-drop-down-menu[right-to-left]:not(.smart-check-input-drop-down-menu) li.active a {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent;
    border-right: 1px solid #005c99;
    border-right: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

smart-multi-combo-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible;
    width: 250px;
    width: var(--smart-text-box-default-width)
}

smart-multi-combo-input>.smart-container {
    display: flex
}

smart-multi-combo-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-multi-combo-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-multi-combo-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-multi-combo-input[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-multi-combo-input {
    height: 30px;
    height: var(--smart-editor-height);
    min-height: 30px;
    min-height: var(--smart-editor-height)
}

.smart-multi-combo-input:not([input-tags-mode=one]) {
    height: auto !important
}

.smart-multi-combo-input .smart-container {
    color: inherit;
    height: 100%;
    width: 100%
}

.smart-multi-combo-input .smart-drop-down-button,
.smart-multi-combo-input .smart-drop-down-button .arrow,
.smart-multi-combo-input>.smart-container {
    min-height: 30px;
    min-height: var(--smart-editor-height)
}

.smart-multi-combo-input .smart-token {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 20px;
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: flex;
    height: 22px;
    margin: 4px 0 0 4px;
    margin: var(--smart-editor-label-padding) 0 0 var(--smart-editor-label-padding);
    padding: 1px 6px;
    position: relative;
    text-overflow: ellipsis;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-multi-combo-input .smart-token .smart-drop-down-list-selection-label {
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-multi-combo-input .smart-token .smart-drop-down-list-selection-image {
    align-items: center;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    display: flex;
    height: 20px;
    justify-content: center;
    margin-right: 4px;
    width: 20px
}

.smart-multi-combo-input .smart-action-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    min-height: 30px;
    min-height: var(--smart-editor-height);
    outline: 1px solid transparent;
    overflow: hidden;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-multi-combo-input .smart-drop-down-list-unselect-button {
    margin-left: 2px;
    margin-right: -2px;
    position: relative
}

.smart-multi-combo-input .smart-drop-down-list-unselect-button:after {
    align-items: center;
    background: rgba(0, 92, 153, .2);
    background: rgba(var(--smart-primary-rgb), .2);
    border-radius: 50%;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 20px;
    justify-content: center;
    -webkit-transform-origin: center;
    transform-origin: center;
    width: 20px
}

.smart-multi-combo-input.smart-input .smart-input {
    align-self: center;
    flex-grow: 1;
    margin: 0;
    max-height: 1rem;
    min-height: 100%;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    vertical-align: middle;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-multi-combo-input.smart-input .smart-drop-down-button {
    height: auto
}

.smart-multi-combo-input[drop-down-button-position=left] .smart-action-button,
.smart-multi-combo-input[drop-down-button-position=right] .smart-action-button {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-multi-combo-input[input-tags-mode=one] .smart-action-button {
    align-items: center
}

.smart-multi-combo-input[readonly] .smart-input {
    visibility: hidden
}

.smart-multi-combo-input[readonly]:hover .smart-action-button {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-multi-combo-input[hide-input-tags-close-button] .smart-drop-down-list-unselect-button:after {
    display: none
}

.smart-multi-combo-input[right-to-left] .smart-token {
    margin: 4px 4px 0 0;
    margin: var(--smart-editor-label-padding) var(--smart-editor-label-padding) 0 0;
    padding: 1px 6px 1px 2px
}

.smart-multi-combo-input[right-to-left] .smart-token:last-of-type {
    margin: 4px 4px 4px 0;
    margin: var(--smart-editor-label-padding) var(--smart-editor-label-padding) var(--smart-editor-label-padding) 0
}

.smart-multi-combo-input[right-to-left] .smart-action-button {
    direction: rtl
}

.smart-multi-combo-input[right-to-left] .smart-drop-down-list-unselect-button {
    margin: 0 5px 0 0
}

.smart-multi-combo-input-drop-down-menu .smart-scroll-viewer {
    border: initial;
    height: inherit;
    min-height: inherit;
    padding: initial;
    width: inherit
}

.smart-multi-combo-input-drop-down-menu .close-button:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    margin-left: 5px
}

.smart-multi-combo-input-drop-down-menu .add-new-item {
    grid-column-gap: 5px;
    display: grid;
    grid-template-columns: 1fr 30px;
    grid-template-columns: 1fr var(--smart-text-box-default-height);
    height: 36px;
    margin-left: 7px;
    margin-right: 7px
}

.smart-multi-combo-input-drop-down-menu .add-new-item input {
    height: 30px
}

.smart-multi-combo-input-drop-down-menu .add-new-item smart-button {
    align-content: center;
    height: 30px;
    justify-content: center
}

.smart-multi-combo-input-drop-down-menu .add-new-item button {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 0
}

.smart-multi-combo-input-drop-down-menu .add-new-item button:after {
    content: "\\e803";
    content: var(--smart-icon-plus);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-multi-combo-input-drop-down-menu .smart-select-all {
    height: auto
}

.smart-multi-combo-input-drop-down-menu[right-to-left]>ul {
    direction: rtl
}

.smart-multi-combo-input-drop-down-menu ul li a {
    align-items: center;
    display: flex
}

.smart-multi-combo-input-drop-down-menu ul li a .smart-drop-down-list-selection-image {
    align-items: center;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 50%;
    display: flex;
    height: 25px;
    justify-content: center;
    margin-right: 4px;
    width: 25px
}

.smart-multi-combo-input-drop-down-menu[pills] ul li:after,
.smart-multi-combo-input-drop-down-menu[pills] ul li:before,
.smart-multi-combo-input-drop-down-menu[single-select] ul li.selected:after,
.smart-multi-combo-input-drop-down-menu[single-select] ul li:after,
.smart-multi-combo-input-drop-down-menu[single-select] ul li:hover:after {
    display: none
}

.smart-multi-combo-input-drop-down-menu[single-select] ul li {
    cursor: pointer;
    height: 36px;
    margin-top: 1px
}

.smart-multi-combo-input-drop-down-menu[single-select] ul li a {
    height: 100%;
    padding: 0 0 0 6px
}

.smart-multi-combo-input-drop-down-menu[single-select] ul li.selected,
.smart-multi-combo-input-drop-down-menu[single-select] ul li:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-multi-combo-input-drop-down-menu[pills] ul li {
    height: 30px;
    margin-top: 1px
}

.smart-multi-combo-input-drop-down-menu[pills] ul li a {
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    border-radius: 15px;
    color: inherit;
    color: #fff;
    color: var(--smart-primary-color);
    display: inline-flex;
    height: auto;
    margin-left: 5px;
    margin-top: 5px;
    padding: 2px 10px
}

.smart-multi-combo-input-drop-down-menu[pills] ul li a .smart-drop-down-list-selection-image {
    height: 20px;
    width: 20px
}

.smart-multi-combo-input-drop-down-menu[pills] ul li.selected,
.smart-multi-combo-input-drop-down-menu[pills] ul li:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-check-input,
smart-check-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

.smart-multi-combo-input-drop-down-menu[pills] ul li.active.selected:before,
.smart-multi-combo-input-drop-down-menu[pills] ul li.selected:after,
.smart-multi-combo-input-drop-down-menu[pills] ul li:hover:after {
    display: none
}

smart-check-input {
    --smart-outline: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible;
    width: 250px;
    width: var(--smart-text-box-default-width)
}

smart-check-input>.smart-container {
    display: flex
}

smart-check-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-check-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-check-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-check-input[disabled] {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

smart-check-input:focus,
smart-check-input[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-check-input[drop-down-button-position=left] .smart-input,
smart-check-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-check-input .smart-container {
    color: inherit;
    height: 100%;
    width: 100%
}

.smart-check-input-drop-down-menu ul li {
    position: relative
}

.smart-check-input-drop-down-menu ul li:before {
    background-color: #fff;
    content: "";
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-check-input-drop-down-menu ul li:after {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    content: "";
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    height: var(--smart-check-box-default-size);
    justify-content: center;
    margin-left: 10px;
    padding: 1px;
    pointer-events: none;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 16px;
    width: var(--smart-check-box-default-size)
}

.smart-check-input-drop-down-menu ul li a {
    padding-left: 41px;
    padding-left: calc(var(--smart-tree-indent) + 25px)
}

.smart-check-input-drop-down-menu ul li.selected:after {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    content: "\\e908";
    content: var(--smart-icon-check)
}

.smart-check-input-drop-down-menu ul li.active.selected:before {
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    content: "";
    height: 32px;
    height: calc(var(--smart-check-box-default-size) + 16px);
    margin-left: 4px;
    opacity: .3;
    position: absolute;
    top: 50%;
    -webkit-transform: scale(1) translateY(-50%);
    transform: scale(1) translateY(-50%);
    -webkit-transform-origin: top;
    transform-origin: top;
    width: 32px;
    width: calc(var(--smart-check-box-default-size) + 16px)
}

smart-color-input,
smart-date-input,
smart-date-range-input,
smart-time-input {
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    width: 250px;
    width: var(--smart-text-box-default-width)
}

.smart-check-input-drop-down-menu ul li.active.focused a {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-bottom-left-radius: 0;
    border-left: 1px solid #005c99;
    border-left: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 0;
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-check-input-drop-down-menu ul li[indeterminate]:after {
    background-clip: content-box;
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    padding: 2px
}

.smart-check-input-drop-down-menu[inverted] ul li a,
.smart-check-input-drop-down-menu[right-to-left] ul li a {
    padding-left: 10px;
    padding-right: 41px;
    padding-right: calc(var(--smart-tree-indent) + 25px)
}

.smart-check-input-drop-down-menu[inverted] ul li:after {
    margin-left: 0;
    margin-right: 10px;
    right: 0
}

.smart-check-input-drop-down-menu[inverted] ul li.selected:before {
    right: 0
}

.smart-check-input-drop-down-menu[inverted] ul li.active.selected:before {
    margin-left: 0;
    margin-right: 4px
}

.smart-check-input-drop-down-menu:not([animation=none]) ul li:before {
    transition: -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out;
    transition: transform .25s ease-in-out, -webkit-transform .25s ease-in-out
}

.smart-check-input-drop-down-menu[right-to-left] ul li:after {
    margin-left: 0;
    margin-right: 10px
}

.smart-check-input-drop-down-menu[right-to-left] ul li.active.focused a {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent;
    border-right: 1px solid #005c99;
    border-right: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.smart-check-input-drop-down-menu[right-to-left] ul li.active.selected:before {
    margin-left: 0;
    margin-right: 4px
}

smart-color-input {
    --smart-outline: var(--smart-primary);
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    overflow: visible
}

smart-color-input[value-display-mode=colorBox] .smart-action-button {
    cursor: pointer
}

smart-date-input,
smart-date-range-input,
smart-time-input {
    --smart-outline: var(--smart-primary);
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    overflow: hidden
}

smart-date-input>.smart-container,
smart-date-range-input>.smart-container,
smart-time-input>.smart-container {
    display: flex
}

smart-date-input.smart-element,
smart-date-range-input.smart-element,
smart-time-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

smart-date-input[drop-down-button-position=left] .smart-input,
smart-date-input[drop-down-button-position=right] .smart-input,
smart-date-range-input[drop-down-button-position=left] .smart-input,
smart-date-range-input[drop-down-button-position=right] .smart-input,
smart-time-input[drop-down-button-position=left] .smart-input,
smart-time-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

smart-date-range-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-date-range-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-date-range-input:focus,
smart-date-range-input[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-time-box {
    display: block;
    height: auto;
    overflow: hidden;
    width: 300px
}

.smart-time-box .smart-timepicker {
    grid-column-gap: 5%;
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    display: grid;
    grid-template-columns: 60% 35%;
    padding: 10px
}

.smart-time-box[right-to-left] .smart-timepicker {
    direction: rtl
}

.smart-time-input.smart-input .smart-drop-down-button .arrow:after,
.smart-time-input.smart-input .smart-drop-down-button[open] .arrow:after {
    content: "\\e837";
    content: var(--smart-icon-clock);
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-timepicker .hour-selection,
.smart-timepicker .minute-selection {
    align-items: center;
    cursor: default;
    display: grid;
    grid-template-columns: repeat(5, 20%);
    grid-template-rows: repeat(6, auto);
    justify-content: center;
    justify-items: center;
    position: relative
}

.smart-timepicker .hour-selection .smart-calendar-cell,
.smart-timepicker .minute-selection .smart-calendar-cell {
    align-items: center;
    border-radius: 100%;
    box-sizing: border-box;
    display: flex;
    height: 32px;
    justify-content: center;
    line-height: 30px;
    line-height: var(--smart-calendar-cell-size);
    margin: initial;
    width: 32px
}

.smart-date-range-input-drop-down-menu .smart-done-button,
.smart-date-range-input-drop-down-menu .smart-today-button,
.smart-date-range-input-drop-down-menu smart-button:last-of-type {
    margin-right: 5px
}

.smart-timepicker .hour-selection .header,
.smart-timepicker .minute-selection .header {
    align-items: center;
    content: attr(header-label);
    display: flex;
    font-weight: 600;
    grid-column: 1/6;
    grid-row: 1/3;
    height: 30px;
    height: var(--smart-calendar-cell-size);
    justify-content: center;
    line-height: 28px;
    line-height: calc(var(--smart-calendar-cell-size) - 2px);
    width: 100%
}

.smart-timepicker .minute-selection {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    grid-template-columns: repeat(2, 50%)
}

.smart-timepicker .minute-selection .header {
    grid-column: span 2
}

.smart-timepicker .hour-selection:after,
.smart-timepicker .hour-selection:before {
    content: attr(am-label);
    display: flex;
    font-weight: 600;
    grid-column: 1;
    height: 30px;
    height: var(--smart-calendar-cell-size);
    justify-content: center;
    line-height: 28px;
    line-height: calc(var(--smart-calendar-cell-size) - 2px);
    width: 100%
}

.smart-date-range-input-drop-down-menu .smart-button-controls,
.smart-date-range-input-drop-down-menu .smart-timepicker-button:empty,
.smart-date-range-input-drop-down-menu .smart-timepicker-buttons {
    display: none
}

.smart-timepicker .hour-selection:after {
    content: attr(pm-label);
    grid-row: 4/9
}

.smart-date-input.smart-input .smart-drop-down-button .arrow:after,
.smart-date-input.smart-input .smart-drop-down-button[open] .arrow:after,
.smart-date-range-input.smart-input .smart-drop-down-button .arrow:after,
.smart-date-range-input.smart-input .smart-drop-down-button[open] .arrow:after {
    content: "\\e829";
    content: var(--smart-icon-calendar);
    -webkit-transform: rotate(0);
    transform: rotate(0)
}

.smart-date-range-input .smart-container {
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-date-range-input-drop-down-menu smart-button:first-of-type {
    margin-left: 5px
}

.smart-date-range-input-drop-down-menu .smart-calendar {
    --smart-calendar-default-height: auto;
    --smart-calendar-footer-height: 0px;
    height: 100%;
    min-width: 100%
}

.smart-date-range-input-drop-down-menu .smart-clear-button,
.smart-date-range-input-drop-down-menu .smart-done-button,
.smart-date-range-input-drop-down-menu .smart-today-button {
    --smart-button-padding: 5px;
    height: auto
}

.smart-date-range-input-drop-down-menu .smart-calendar-footer {
    flex-direction: column
}

.smart-date-range-input-drop-down-menu .smart-date-range-input-footer-controls {
    height: 100%;
    width: 100%
}

.smart-date-range-input-drop-down-menu .smart-timepicker-button {
    position: relative;
    white-space: nowrap
}

.smart-date-range-input-drop-down-menu .smart-timepicker-button:before {
    content: "\\e837";
    content: var(--smart-icon-clock);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-weight: inherit;
    font-weight: var(--smart-font-weight);
    height: 100%;
    margin: 0 4px;
    margin: 0 var(--smart-editor-label-padding)
}

.smart-date-range-input-drop-down-menu .smart-timepicker-button:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    cursor: pointer;
    opacity: var(--smart-button-opacity-hover);
    transition: background-color .1s linear, color .1s ease-in-out
}

.smart-date-range-input-drop-down-menu .smart-timepicker-button[selected] {
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-date-range-input-drop-down-menu .smart-icon-today:before {
    content: "\\e829";
    content: var(--smart-icon-calendar)
}

.smart-date-range-input-drop-down-menu .smart-icon-clear:before {
    content: "\\1F5D9";
    content: var(--smart-icon-cancel)
}

.smart-date-range-input-drop-down-menu .smart-timepicker {
    grid-column-gap: 5%;
    background: #fefefe;
    background: var(--smart-background);
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom: none;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 60% 35%;
    height: calc(100% - 36px);
    height: calc(100% - var(--smart-calendar-footer-height));
    padding: 10px;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-date-range-input-drop-down-menu[icons] smart-calendar,
.smart-date-range-input-drop-down-menu[timepicker] smart-calendar {
    --smart-calendar-footer-height: 30px
}

.smart-date-range-input-drop-down-menu[icons] .smart-timepicker-buttons,
.smart-date-range-input-drop-down-menu[timepicker] .smart-timepicker-buttons {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-around;
    width: 100%
}

.smart-date-range-input-drop-down-menu[timepicker][icons] .smart-date-range-input-footer-controls {
    grid-column-gap: 2%;
    display: grid;
    grid-template-columns: 60% 38%;
    justify-items: center
}

.smart-date-range-input-drop-down-menu.smart-input-drop-down-menu {
    height: auto;
    width: var(--smart-input-drop-down-menu-width)
}

.smart-date-range-input-drop-down-menu.smart-input-drop-down-menu.smart-date-input-drop-down-menu {
    height: 250px
}

.smart-date-range-input-drop-down-menu:not([timepicker]) .smart-timepicker-buttons {
    display: none
}

.smart-date-range-input-drop-down-menu:not([animation=none]) .smart-timepicker {
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: visibility .2s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .2, 1);
    transition: transform .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .2, 1);
    transition: transform .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-date-range-input-drop-down-menu:not([animation=none]) .smart-timepicker.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: visibility .2s cubic-bezier(.4, 0, .6, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: visibility .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: visibility .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .6, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-date-range-input-drop-down-menu[right-to-left] .smart-timepicker {
    direction: rtl
}

smart-country-input,
smart-phone-input {
    --smart-outline: var(--smart-primary);
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    display: inline-block;
    height: 30px;
    height: var(--smart-text-box-default-height);
    overflow: visible;
    width: 250px;
    width: var(--smart-text-box-default-width)
}

smart-country-input>.smart-container,
smart-phone-input>.smart-container {
    display: flex
}

smart-country-input.smart-element,
smart-phone-input.smart-element {
    background: #fefefe;
    background: var(--smart-background)
}

smart-country-input input::selection,
smart-phone-input input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

smart-country-input input.smart-input,
smart-phone-input input.smart-input {
    border: none;
    text-overflow: ellipsis
}

smart-country-input:focus,
smart-country-input[focus],
smart-phone-input:focus,
smart-phone-input[focus] {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

smart-country-input:hover,
smart-phone-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-country-input[disabled],
smart-phone-input[disabled] {
    border-color: #ccc;
    border-color: var(--smart-disabled);
    outline: 0
}

smart-country-input[drop-down-button-position=left] .smart-input,
smart-country-input[drop-down-button-position=right] .smart-input,
smart-phone-input[drop-down-button-position=left] .smart-input,
smart-phone-input[drop-down-button-position=right] .smart-input {
    width: calc(100% - 27px);
    width: calc(100% - var(--smart-editor-addon-width))
}

.smart-country-input .smart-container,
.smart-phone-input .smart-container {
    align-items: center;
    color: inherit;
    font-family: inherit;
    height: 100%;
    overflow: visible;
    position: relative;
    width: 100%
}

.smart-phone-input {
    --smart-editor-addon-width: 45px
}

.smart-phone-input.invalid-number .smart-container:after {
    color: #b00020;
    color: var(--smart-error)
}

.smart-phone-input .smart-container:after {
    color: #8bc34a;
    color: var(--smart-success);
    content: "\\e83D";
    content: var(--smart-icon-phone);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    padding-right: 5px
}

.smart-phone-input .smart-drop-down-button {
    align-items: center;
    background: 0 0;
    border-right: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-left: 2px
}

.smart-phone-input .smart-drop-down-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-flag-box {
    margin-right: 6px
}

.smart-flag-box .flag {
    width: 20px
}

.smart-flag-box .flag.be {
    width: 18px
}

.smart-flag-box .flag.ch {
    width: 15px
}

.smart-flag-box .flag.mc {
    width: 19px
}

.smart-flag-box .flag.ne {
    width: 18px
}

@media (-webkit-min-device-pixel-ratio:2),
(min-resolution:192dpi) {
    .smart-flag-box .flag {
        background-size: 5652px 15px
    }
}

.smart-flag-box .flag.ac {
    background-position: 0 0;
    height: 10px
}

.smart-flag-box .flag.ad {
    background-position: -22px 0;
    height: 14px
}

.smart-flag-box .flag.ae {
    background-position: -44px 0;
    height: 10px
}

.smart-flag-box .flag.af {
    background-position: -66px 0;
    height: 14px
}

.smart-flag-box .flag.ag {
    background-position: -88px 0;
    height: 14px
}

.smart-flag-box .flag.ai {
    background-position: -110px 0;
    height: 10px
}

.smart-flag-box .flag.al {
    background-position: -132px 0;
    height: 15px
}

.smart-flag-box .flag.am {
    background-position: -154px 0;
    height: 10px
}

.smart-flag-box .flag.ao {
    background-position: -176px 0;
    height: 14px
}

.smart-flag-box .flag.aq {
    background-position: -198px 0;
    height: 14px
}

.smart-flag-box .flag.ar {
    background-position: -220px 0;
    height: 13px
}

.smart-flag-box .flag.as {
    background-position: -242px 0;
    height: 10px
}

.smart-flag-box .flag.at {
    background-position: -264px 0;
    height: 14px
}

.smart-flag-box .flag.au {
    background-position: -286px 0;
    height: 10px
}

.smart-flag-box .flag.aw {
    background-position: -308px 0;
    height: 14px
}

.smart-flag-box .flag.ax {
    background-position: -330px 0;
    height: 13px
}

.smart-flag-box .flag.az {
    background-position: -352px 0;
    height: 10px
}

.smart-flag-box .flag.ba {
    background-position: -374px 0;
    height: 10px
}

.smart-flag-box .flag.bb {
    background-position: -396px 0;
    height: 14px
}

.smart-flag-box .flag.bd {
    background-position: -418px 0;
    height: 12px
}

.smart-flag-box .flag.be {
    background-position: -440px 0;
    height: 15px
}

.smart-flag-box .flag.bf {
    background-position: -460px 0;
    height: 14px
}

.smart-flag-box .flag.bg {
    background-position: -482px 0;
    height: 12px
}

.smart-flag-box .flag.bh {
    background-position: -504px 0;
    height: 12px
}

.smart-flag-box .flag.bi {
    background-position: -526px 0;
    height: 12px
}

.smart-flag-box .flag.bj {
    background-position: -548px 0;
    height: 14px
}

.smart-flag-box .flag.bl {
    background-position: -570px 0;
    height: 14px
}

.smart-flag-box .flag.bm {
    background-position: -592px 0;
    height: 10px
}

.smart-flag-box .flag.bn {
    background-position: -614px 0;
    height: 10px
}

.smart-flag-box .flag.bo {
    background-position: -636px 0;
    height: 14px
}

.smart-flag-box .flag.bq {
    background-position: -658px 0;
    height: 14px
}

.smart-flag-box .flag.br {
    background-position: -680px 0;
    height: 14px
}

.smart-flag-box .flag.bs {
    background-position: -702px 0;
    height: 10px
}

.smart-flag-box .flag.bt {
    background-position: -724px 0;
    height: 14px
}

.smart-flag-box .flag.bv {
    background-position: -746px 0;
    height: 15px
}

.smart-flag-box .flag.bw {
    background-position: -768px 0;
    height: 14px
}

.smart-flag-box .flag.by {
    background-position: -790px 0;
    height: 10px
}

.smart-flag-box .flag.bz {
    background-position: -812px 0;
    height: 14px
}

.smart-flag-box .flag.ca {
    background-position: -834px 0;
    height: 10px
}

.smart-flag-box .flag.cc {
    background-position: -856px 0;
    height: 10px
}

.smart-flag-box .flag.cd {
    background-position: -878px 0;
    height: 15px
}

.smart-flag-box .flag.cf {
    background-position: -900px 0;
    height: 14px
}

.smart-flag-box .flag.cg {
    background-position: -922px 0;
    height: 14px
}

.smart-flag-box .flag.ch {
    background-position: -944px 0;
    height: 15px
}

.smart-flag-box .flag.ci {
    background-position: -961px 0;
    height: 14px
}

.smart-flag-box .flag.ck {
    background-position: -983px 0;
    height: 10px
}

.smart-flag-box .flag.cl {
    background-position: -1005px 0;
    height: 14px
}

.smart-flag-box .flag.cm {
    background-position: -1027px 0;
    height: 14px
}

.smart-flag-box .flag.cn {
    background-position: -1049px 0;
    height: 14px
}

.smart-flag-box .flag.co {
    background-position: -1071px 0;
    height: 14px
}

.smart-flag-box .flag.cp {
    background-position: -1093px 0;
    height: 14px
}

.smart-flag-box .flag.cr {
    background-position: -1115px 0;
    height: 12px
}

.smart-flag-box .flag.cu {
    background-position: -1137px 0;
    height: 10px
}

.smart-flag-box .flag.cv {
    background-position: -1159px 0;
    height: 12px
}

.smart-flag-box .flag.cw {
    background-position: -1181px 0;
    height: 14px
}

.smart-flag-box .flag.cx {
    background-position: -1203px 0;
    height: 10px
}

.smart-flag-box .flag.cy {
    background-position: -1225px 0;
    height: 14px
}

.smart-flag-box .flag.cz {
    background-position: -1247px 0;
    height: 14px
}

.smart-flag-box .flag.de {
    background-position: -1269px 0;
    height: 12px
}

.smart-flag-box .flag.dg {
    background-position: -1291px 0;
    height: 10px
}

.smart-flag-box .flag.dj {
    background-position: -1313px 0;
    height: 14px
}

.smart-flag-box .flag.dk {
    background-position: -1335px 0;
    height: 15px
}

.smart-flag-box .flag.dm {
    background-position: -1357px 0;
    height: 10px
}

.smart-flag-box .flag.do {
    background-position: -1379px 0;
    height: 14px
}

.smart-flag-box .flag.dz {
    background-position: -1401px 0;
    height: 14px
}

.smart-flag-box .flag.ea {
    background-position: -1423px 0;
    height: 14px
}

.smart-flag-box .flag.ec {
    background-position: -1445px 0;
    height: 14px
}

.smart-flag-box .flag.ee {
    background-position: -1467px 0;
    height: 13px
}

.smart-flag-box .flag.eg {
    background-position: -1489px 0;
    height: 14px
}

.smart-flag-box .flag.eh {
    background-position: -1511px 0;
    height: 10px
}

.smart-flag-box .flag.er {
    background-position: -1533px 0;
    height: 10px
}

.smart-flag-box .flag.es {
    background-position: -1555px 0;
    height: 14px
}

.smart-flag-box .flag.et {
    background-position: -1577px 0;
    height: 10px
}

.smart-flag-box .flag.eu {
    background-position: -1599px 0;
    height: 14px
}

.smart-flag-box .flag.fi {
    background-position: -1621px 0;
    height: 12px
}

.smart-flag-box .flag.fj {
    background-position: -1643px 0;
    height: 10px
}

.smart-flag-box .flag.fk {
    background-position: -1665px 0;
    height: 10px
}

.smart-flag-box .flag.fm {
    background-position: -1687px 0;
    height: 11px
}

.smart-flag-box .flag.fo {
    background-position: -1709px 0;
    height: 15px
}

.smart-flag-box .flag.fr {
    background-position: -1731px 0;
    height: 14px
}

.smart-flag-box .flag.ga {
    background-position: -1753px 0;
    height: 15px
}

.smart-flag-box .flag.gb {
    background-position: -1775px 0;
    height: 10px
}

.smart-flag-box .flag.gd {
    background-position: -1797px 0;
    height: 12px
}

.smart-flag-box .flag.ge {
    background-position: -1819px 0;
    height: 14px
}

.smart-flag-box .flag.gf {
    background-position: -1841px 0;
    height: 14px
}

.smart-flag-box .flag.gg {
    background-position: -1863px 0;
    height: 14px
}

.smart-flag-box .flag.gh {
    background-position: -1885px 0;
    height: 14px
}

.smart-flag-box .flag.gi {
    background-position: -1907px 0;
    height: 10px
}

.smart-flag-box .flag.gl {
    background-position: -1929px 0;
    height: 14px
}

.smart-flag-box .flag.gm {
    background-position: -1951px 0;
    height: 14px
}

.smart-flag-box .flag.gn {
    background-position: -1973px 0;
    height: 14px
}

.smart-flag-box .flag.gp {
    background-position: -1995px 0;
    height: 14px
}

.smart-flag-box .flag.gq {
    background-position: -2017px 0;
    height: 14px
}

.smart-flag-box .flag.gr {
    background-position: -2039px 0;
    height: 14px
}

.smart-flag-box .flag.gs {
    background-position: -2061px 0;
    height: 10px
}

.smart-flag-box .flag.gt {
    background-position: -2083px 0;
    height: 13px
}

.smart-flag-box .flag.gu {
    background-position: -2105px 0;
    height: 11px
}

.smart-flag-box .flag.gw {
    background-position: -2127px 0;
    height: 10px
}

.smart-flag-box .flag.gy {
    background-position: -2149px 0;
    height: 12px
}

.smart-flag-box .flag.hk {
    background-position: -2171px 0;
    height: 14px
}

.smart-flag-box .flag.hm {
    background-position: -2193px 0;
    height: 10px
}

.smart-flag-box .flag.hn {
    background-position: -2215px 0;
    height: 10px
}

.smart-flag-box .flag.hr {
    background-position: -2237px 0;
    height: 10px
}

.smart-flag-box .flag.ht {
    background-position: -2259px 0;
    height: 12px
}

.smart-flag-box .flag.hu {
    background-position: -2281px 0;
    height: 10px
}

.smart-flag-box .flag.ic {
    background-position: -2303px 0;
    height: 14px
}

.smart-flag-box .flag.id {
    background-position: -2325px 0;
    height: 14px
}

.smart-flag-box .flag.ie {
    background-position: -2347px 0;
    height: 10px
}

.smart-flag-box .flag.il {
    background-position: -2369px 0;
    height: 15px
}

.smart-flag-box .flag.im {
    background-position: -2391px 0;
    height: 10px
}

.smart-flag-box .flag.in {
    background-position: -2413px 0;
    height: 14px
}

.smart-flag-box .flag.io {
    background-position: -2435px 0;
    height: 10px
}

.smart-flag-box .flag.iq {
    background-position: -2457px 0;
    height: 14px
}

.smart-flag-box .flag.ir {
    background-position: -2479px 0;
    height: 12px
}

.smart-flag-box .flag.is {
    background-position: -2501px 0;
    height: 15px
}

.smart-flag-box .flag.it {
    background-position: -2523px 0;
    height: 14px
}

.smart-flag-box .flag.je {
    background-position: -2545px 0;
    height: 12px
}

.smart-flag-box .flag.jm {
    background-position: -2567px 0;
    height: 10px
}

.smart-flag-box .flag.jo {
    background-position: -2589px 0;
    height: 10px
}

.smart-flag-box .flag.jp {
    background-position: -2611px 0;
    height: 14px
}

.smart-flag-box .flag.ke {
    background-position: -2633px 0;
    height: 14px
}

.smart-flag-box .flag.kg {
    background-position: -2655px 0;
    height: 12px
}

.smart-flag-box .flag.kh {
    background-position: -2677px 0;
    height: 13px
}

.smart-flag-box .flag.ki {
    background-position: -2699px 0;
    height: 10px
}

.smart-flag-box .flag.km {
    background-position: -2721px 0;
    height: 12px
}

.smart-flag-box .flag.kn {
    background-position: -2743px 0;
    height: 14px
}

.smart-flag-box .flag.kp {
    background-position: -2765px 0;
    height: 10px
}

.smart-flag-box .flag.kr {
    background-position: -2787px 0;
    height: 14px
}

.smart-flag-box .flag.kw {
    background-position: -2809px 0;
    height: 10px
}

.smart-flag-box .flag.ky {
    background-position: -2831px 0;
    height: 10px
}

.smart-flag-box .flag.kz {
    background-position: -2853px 0;
    height: 10px
}

.smart-flag-box .flag.la {
    background-position: -2875px 0;
    height: 14px
}

.smart-flag-box .flag.lb {
    background-position: -2897px 0;
    height: 14px
}

.smart-flag-box .flag.lc {
    background-position: -2919px 0;
    height: 10px
}

.smart-flag-box .flag.li {
    background-position: -2941px 0;
    height: 12px
}

.smart-flag-box .flag.lk {
    background-position: -2963px 0;
    height: 10px
}

.smart-flag-box .flag.lr {
    background-position: -2985px 0;
    height: 11px
}

.smart-flag-box .flag.ls {
    background-position: -3007px 0;
    height: 14px
}

.smart-flag-box .flag.lt {
    background-position: -3029px 0;
    height: 12px
}

.smart-flag-box .flag.lu {
    background-position: -3051px 0;
    height: 12px
}

.smart-flag-box .flag.lv {
    background-position: -3073px 0;
    height: 10px
}

.smart-flag-box .flag.ly {
    background-position: -3095px 0;
    height: 10px
}

.smart-flag-box .flag.ma {
    background-position: -3117px 0;
    height: 14px
}

.smart-flag-box .flag.mc {
    background-position: -3139px 0;
    height: 15px
}

.smart-flag-box .flag.md {
    background-position: -3160px 0;
    height: 10px
}

.smart-flag-box .flag.me {
    background-position: -3182px 0;
    height: 10px
}

.smart-flag-box .flag.mf {
    background-position: -3204px 0;
    height: 14px
}

.smart-flag-box .flag.mg {
    background-position: -3226px 0;
    height: 14px
}

.smart-flag-box .flag.mh {
    background-position: -3248px 0;
    height: 11px
}

.smart-flag-box .flag.mk {
    background-position: -3270px 0;
    height: 10px
}

.smart-flag-box .flag.ml {
    background-position: -3292px 0;
    height: 14px
}

.smart-flag-box .flag.mm {
    background-position: -3314px 0;
    height: 14px
}

.smart-flag-box .flag.mn {
    background-position: -3336px 0;
    height: 10px
}

.smart-flag-box .flag.mo {
    background-position: -3358px 0;
    height: 14px
}

.smart-flag-box .flag.mp {
    background-position: -3380px 0;
    height: 10px
}

.smart-flag-box .flag.mq {
    background-position: -3402px 0;
    height: 14px
}

.smart-flag-box .flag.mr {
    background-position: -3424px 0;
    height: 14px
}

.smart-flag-box .flag.ms {
    background-position: -3446px 0;
    height: 10px
}

.smart-flag-box .flag.mt {
    background-position: -3468px 0;
    height: 14px
}

.smart-flag-box .flag.mu {
    background-position: -3490px 0;
    height: 14px
}

.smart-flag-box .flag.mv {
    background-position: -3512px 0;
    height: 14px
}

.smart-flag-box .flag.mw {
    background-position: -3534px 0;
    height: 14px
}

.smart-flag-box .flag.mx {
    background-position: -3556px 0;
    height: 12px
}

.smart-flag-box .flag.my {
    background-position: -3578px 0;
    height: 10px
}

.smart-flag-box .flag.mz {
    background-position: -3600px 0;
    height: 14px
}

.smart-flag-box .flag.na {
    background-position: -3622px 0;
    height: 14px
}

.smart-flag-box .flag.nc {
    background-position: -3644px 0;
    height: 10px
}

.smart-flag-box .flag.ne {
    background-position: -3666px 0;
    height: 15px
}

.smart-flag-box .flag.nf {
    background-position: -3686px 0;
    height: 10px
}

.smart-flag-box .flag.ng {
    background-position: -3708px 0;
    height: 10px
}

.smart-flag-box .flag.ni {
    background-position: -3730px 0;
    height: 12px
}

.smart-flag-box .flag.nl {
    background-position: -3752px 0;
    height: 14px
}

.smart-flag-box .flag.no {
    background-position: -3774px 0;
    height: 15px
}

.smart-flag-box .flag.np {
    background-position: -3796px 0;
    height: 15px;
    width: 13px
}

.smart-flag-box .flag.nr {
    background-position: -3811px 0;
    height: 10px
}

.smart-flag-box .flag.nu {
    background-position: -3833px 0;
    height: 10px
}

.smart-flag-box .flag.nz {
    background-position: -3855px 0;
    height: 10px
}

.smart-flag-box .flag.om {
    background-position: -3877px 0;
    height: 10px
}

.smart-flag-box .flag.pa {
    background-position: -3899px 0;
    height: 14px
}

.smart-flag-box .flag.pe {
    background-position: -3921px 0;
    height: 14px
}

.smart-flag-box .flag.pf {
    background-position: -3943px 0;
    height: 14px
}

.smart-flag-box .flag.pg {
    background-position: -3965px 0;
    height: 15px
}

.smart-flag-box .flag.ph {
    background-position: -3987px 0;
    height: 10px
}

.smart-flag-box .flag.pk {
    background-position: -4009px 0;
    height: 14px
}

.smart-flag-box .flag.pl {
    background-position: -4031px 0;
    height: 13px
}

.smart-flag-box .flag.pm {
    background-position: -4053px 0;
    height: 14px
}

.smart-flag-box .flag.pn {
    background-position: -4075px 0;
    height: 10px
}

.smart-flag-box .flag.pr {
    background-position: -4097px 0;
    height: 14px
}

.smart-flag-box .flag.ps {
    background-position: -4119px 0;
    height: 10px
}

.smart-flag-box .flag.pt {
    background-position: -4141px 0;
    height: 14px
}

.smart-flag-box .flag.pw {
    background-position: -4163px 0;
    height: 13px
}

.smart-flag-box .flag.py {
    background-position: -4185px 0;
    height: 11px
}

.smart-flag-box .flag.qa {
    background-position: -4207px 0;
    height: 8px
}

.smart-flag-box .flag.re {
    background-position: -4229px 0;
    height: 14px
}

.smart-flag-box .flag.ro {
    background-position: -4251px 0;
    height: 14px
}

.smart-flag-box .flag.rs {
    background-position: -4273px 0;
    height: 14px
}

.smart-flag-box .flag.ru {
    background-position: -4295px 0;
    height: 14px
}

.smart-flag-box .flag.rw {
    background-position: -4317px 0;
    height: 14px
}

.smart-flag-box .flag.sa {
    background-position: -4339px 0;
    height: 14px
}

.smart-flag-box .flag.sb {
    background-position: -4361px 0;
    height: 10px
}

.smart-flag-box .flag.sc {
    background-position: -4383px 0;
    height: 10px
}

.smart-flag-box .flag.sd {
    background-position: -4405px 0;
    height: 10px
}

.smart-flag-box .flag.se {
    background-position: -4427px 0;
    height: 13px
}

.smart-flag-box .flag.sg {
    background-position: -4449px 0;
    height: 14px
}

.smart-flag-box .flag.sh {
    background-position: -4471px 0;
    height: 10px
}

.smart-flag-box .flag.si {
    background-position: -4493px 0;
    height: 10px
}

.smart-flag-box .flag.sj {
    background-position: -4515px 0;
    height: 15px
}

.smart-flag-box .flag.sk {
    background-position: -4537px 0;
    height: 14px
}

.smart-flag-box .flag.sl {
    background-position: -4559px 0;
    height: 14px
}

.smart-flag-box .flag.sm {
    background-position: -4581px 0;
    height: 15px
}

.smart-flag-box .flag.sn {
    background-position: -4603px 0;
    height: 14px
}

.smart-flag-box .flag.so {
    background-position: -4625px 0;
    height: 14px
}

.smart-flag-box .flag.sr {
    background-position: -4647px 0;
    height: 14px
}

.smart-flag-box .flag.ss {
    background-position: -4669px 0;
    height: 10px
}

.smart-flag-box .flag.st {
    background-position: -4691px 0;
    height: 10px
}

.smart-flag-box .flag.sv {
    background-position: -4713px 0;
    height: 12px
}

.smart-flag-box .flag.sx {
    background-position: -4735px 0;
    height: 14px
}

.smart-flag-box .flag.sy {
    background-position: -4757px 0;
    height: 14px
}

.smart-flag-box .flag.sz {
    background-position: -4779px 0;
    height: 14px
}

.smart-flag-box .flag.ta {
    background-position: -4801px 0;
    height: 10px
}

.smart-flag-box .flag.tc {
    background-position: -4823px 0;
    height: 10px
}

.smart-flag-box .flag.td {
    background-position: -4845px 0;
    height: 14px
}

.smart-flag-box .flag.tf {
    background-position: -4867px 0;
    height: 14px
}

.smart-flag-box .flag.tg {
    background-position: -4889px 0;
    height: 13px
}

.smart-flag-box .flag.th {
    background-position: -4911px 0;
    height: 14px
}

.smart-flag-box .flag.tj {
    background-position: -4933px 0;
    height: 10px
}

.smart-flag-box .flag.tk {
    background-position: -4955px 0;
    height: 10px
}

.smart-flag-box .flag.tl {
    background-position: -4977px 0;
    height: 10px
}

.smart-flag-box .flag.tm {
    background-position: -4999px 0;
    height: 14px
}

.smart-flag-box .flag.tn {
    background-position: -5021px 0;
    height: 14px
}

.smart-flag-box .flag.to {
    background-position: -5043px 0;
    height: 10px
}

.smart-flag-box .flag.tr {
    background-position: -5065px 0;
    height: 14px
}

.smart-flag-box .flag.tt {
    background-position: -5087px 0;
    height: 12px
}

.smart-flag-box .flag.tv {
    background-position: -5109px 0;
    height: 10px
}

.smart-flag-box .flag.tw {
    background-position: -5131px 0;
    height: 14px
}

.smart-flag-box .flag.tz {
    background-position: -5153px 0;
    height: 14px
}

.smart-flag-box .flag.ua {
    background-position: -5175px 0;
    height: 14px
}

.smart-flag-box .flag.ug {
    background-position: -5197px 0;
    height: 14px
}

.smart-flag-box .flag.um {
    background-position: -5219px 0;
    height: 11px
}

.smart-flag-box .flag.un {
    background-position: -5241px 0;
    height: 14px
}

.smart-flag-box .flag.us {
    background-position: -5263px 0;
    height: 11px
}

.smart-flag-box .flag.uy {
    background-position: -5285px 0;
    height: 14px
}

.smart-flag-box .flag.uz {
    background-position: -5307px 0;
    height: 10px
}

.smart-flag-box .flag.va {
    background-position: -5329px 0;
    height: 15px;
    width: 15px
}

.smart-flag-box .flag.vc {
    background-position: -5346px 0;
    height: 14px
}

.smart-flag-box .flag.ve {
    background-position: -5368px 0;
    height: 14px
}

.smart-flag-box .flag.vg {
    background-position: -5390px 0;
    height: 10px
}

.smart-flag-box .flag.vi {
    background-position: -5412px 0;
    height: 14px
}

.smart-flag-box .flag.vn {
    background-position: -5434px 0;
    height: 14px
}

.smart-flag-box .flag.vu {
    background-position: -5456px 0;
    height: 12px
}

.smart-flag-box .flag.wf {
    background-position: -5478px 0;
    height: 14px
}

.smart-flag-box .flag.ws {
    background-position: -5500px 0;
    height: 10px
}

.smart-flag-box .flag.xk {
    background-position: -5522px 0;
    height: 15px
}

.smart-flag-box .flag.ye {
    background-position: -5544px 0;
    height: 14px
}

.smart-flag-box .flag.yt {
    background-position: -5566px 0;
    height: 14px
}

.smart-flag-box .flag.za {
    background-position: -5588px 0;
    height: 14px
}

.smart-flag-box .flag.zm {
    background-position: -5610px 0;
    height: 14px
}

.smart-flag-box .flag.zw {
    background-position: -5632px 0;
    height: 10px
}

.smart-flag-box .flag {
    background-color: #dbdbdb;
    background-image: url(../../static/media/flags.007b2705c0a8f69dfdf6.png);
    background-position: 20px 0;
    background-repeat: no-repeat;
    box-shadow: 0 0 1px 0 #888;
    height: 15px
}

.smart-flag-box .flag.np {
    background-color: transparent
}

.smart-country-input-drop-down-menu ul li a,
.smart-phone-input-drop-down-menu ul li a {
    align-items: center;
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent;
    display: flex
}

.smart-country-input-drop-down-menu ul li .dial-code,
.smart-phone-input-drop-down-menu ul li .dial-code {
    margin-left: 6px;
    opacity: .5
}

.smart-country-input-drop-down-menu:not(.smart-check-input-drop-down-menu) li.active a,
.smart-phone-input-drop-down-menu:not(.smart-check-input-drop-down-menu) li.active a {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    border-bottom-left-radius: 0;
    border-left: 1px solid #005c99;
    border-left: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 0;
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-country-input-drop-down-menu[right-to-left] li a,
.smart-phone-input-drop-down-menu[right-to-left] li a {
    border-left: none;
    border-right: 1px solid transparent;
    border-right: var(--smart-border-width) solid transparent
}

.smart-country-input-drop-down-menu[right-to-left]:not(.smart-check-input-drop-down-menu) li.active a,
.smart-phone-input-drop-down-menu[right-to-left]:not(.smart-check-input-drop-down-menu) li.active a {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid transparent;
    border-left: var(--smart-border-width) solid transparent;
    border-right: 1px solid #005c99;
    border-right: var(--smart-border-width) solid var(--smart-primary);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.underlined.smart-input,
.underlined.smart-input .smart-drop-down-button,
.underlined.smart-text-box input.smart-input {
    border-left: none;
    border-right: none;
    border-top: none
}

.underlined.smart-input,
.underlined.smart-input[hover] {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

smart-check-input.underlined,
smart-date-range-input.underlined,
smart-input.underlined,
smart-multi-combo-input.underlined,
smart-multi-input.underlined,
smart-password-input.underlined,
smart-text-box.underlined {
    background-color: transparent
}

smart-date-input.underlined,
smart-date-range-input.underlined,
smart-time-input.underlined {
    overflow: visible
}

.underlined.smart-input {
    transition: border-bottom .2s, background-color .2s
}

.underlined.smart-input .smart-hint {
    bottom: 0;
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block !important;
    font-size: 75%;
    left: 0;
    margin-top: -14px;
    margin-top: calc(0px - var(--smart-font-size));
    opacity: 0;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: color .2s, font-size .2s, line-height .2s, margin-top .2s, opacity .3s, top .2s
}

.underlined.smart-input .smart-hint:after {
    background-color: #005c99;
    background-color: var(--smart-primary);
    bottom: -2px;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: bottom center;
    transform-origin: bottom center;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s, -webkit-transform .2s;
    width: 100%
}

.underlined.smart-input[hover] {
    border-bottom-color: #5a5a5a;
    border-bottom-color: var(--smart-background-color)
}

.underlined.smart-input[focus] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.underlined.smart-input[focus] .smart-hint:before {
    opacity: .12
}

.underlined.smart-input[focus] .smart-hint:after {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.underlined.smart-input .smart-input:not(:focus):-ms-input-placeholder+.smart-hint {
    font-size: inherit;
    margin-top: 0
}

.underlined.smart-input .smart-input:not(:focus):placeholder-shown+.smart-hint {
    font-size: inherit;
    margin-top: 0
}

.underlined.smart-input:not([readonly]) .smart-drop-down-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.underlined.smart-input:not([opened]) .smart-drop-down-button {
    background-color: transparent
}

.underlined.smart-input.smart-multi-combo-input:not([focus]) .smart-hint {
    margin-top: 0
}

.underlined.smart-input.smart-date-range-input[opened][drop-down-button-position=right]:not([readonly]) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.underlined.smart-input[readonly] .smart-input {
    background: #fefefe !important;
    background: var(--smart-background) !important;
    color: #5a5a5a !important;
    color: var(--smart-background-color) !important;
    cursor: pointer;
    opacity: .75
}

.underlined.smart-input[drop-down-button-position=left] .smart-drop-down-button {
    background: inherit;
    border-bottom-left-radius: 0;
    color: inherit
}

.underlined.smart-input[drop-down-button-position=left] .smart-hint {
    margin-left: 27px;
    margin-left: var(--smart-editor-addon-width)
}

.underlined.smart-input[drop-down-button-position=left][focus] .smart-hint:after {
    margin-left: -27px;
    margin-left: calc(0px - var(--smart-editor-addon-width));
    width: calc(100% + 27px);
    width: calc(100% + var(--smart-editor-addon-width))
}

.underlined.smart-input[drop-down-button-position=left][opened]:not([readonly]),
.underlined.smart-input[drop-down-button-position=left][opened]:not([readonly]) input {
    border-bottom-right-radius: 0
}

.underlined.smart-input[drop-down-button-position=right] .smart-drop-down-button {
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-right-radius: 0;
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.underlined.smart-input[drop-down-button-position=right][opened]:not([readonly]),
.underlined.smart-input[drop-down-button-position=right][opened]:not([readonly]) input {
    border-bottom-left-radius: 0
}

.underlined.smart-input.smart-invalid {
    border-bottom-color: rgba(176, 0, 32, .5);
    border-bottom-color: rgba(var(--smart-error-rgb), .5)
}

.underlined.smart-input.smart-invalid .smart-hint:after {
    background-color: #b00020;
    background-color: var(--smart-error)
}

.underlined.smart-text-box input.smart-input {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.underlined.smart-number-input .nav {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.underlined.smart-number-input .nav .up {
    border-bottom: none
}

smart-check-input.outlined,
smart-date-range-input.outlined,
smart-input.outlined,
smart-masked-text-box.outlined,
smart-multi-combo-input.outlined,
smart-multi-input.outlined,
smart-password-input.outlined,
smart-password-text-box.outlined,
smart-text-box.outlined {
    background-color: transparent
}

smart-date-input.outlined,
smart-date-range-input.outlined,
smart-time-input.outlined {
    overflow: visible
}

.outlined.smart-input {
    border: none;
    border-radius: 0;
    display: inline-block;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 50px;
    line-height: 1.5;
    margin: 0;
    overflow: hidden;
    padding-top: 6px;
    position: relative
}

.outlined.smart-input .smart-input {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    padding: 12px 13px;
    transition: border-color .2s;
    z-index: 5
}

.outlined.smart-input.smart-valid[focus] .smart-drop-down-button,
.outlined.smart-input.smart-valid[focus] .smart-input {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.outlined.smart-input.smart-valid[focus] .smart-drop-down-button {
    color: #005c99;
    color: var(--smart-primary)
}

.outlined.smart-input.smart-invalid .smart-drop-down-button,
.outlined.smart-input.smart-invalid .smart-input {
    border-color: rgba(176, 0, 32, .5);
    border-color: rgba(var(--smart-error-rgb), .5)
}

.outlined.smart-input.smart-invalid[focus] .smart-drop-down-button,
.outlined.smart-input.smart-invalid[focus] .smart-input {
    border-color: #b00020;
    border-color: var(--smart-error)
}

.outlined.smart-input.smart-invalid[focus] .smart-drop-down-button {
    color: #b00020;
    color: var(--smart-error)
}

.outlined.smart-input.smart-multi-combo-input .smart-input {
    border: none !important;
    padding: 0;
    z-index: auto
}

.outlined.smart-input.smart-multi-combo-input .smart-drop-down-button {
    padding: 0 !important
}

.outlined.smart-input.smart-multi-combo-input .smart-action-button {
    background: #fefefe;
    background: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    padding: 12px 13px;
    transition: border-color .2s;
    z-index: 5
}

.outlined.smart-input.smart-multi-combo-input[hint] .smart-action-button {
    border-top: 1px solid #fefefe;
    border-top: 1px solid var(--smart-background)
}

.outlined.smart-input.smart-multi-combo-input[focus] .smart-action-button {
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.outlined.smart-input.smart-multi-combo-input[focus][hint] .smart-action-button {
    border-top-color: #fefefe;
    border-top-color: var(--smart-background)
}

.outlined.smart-input.smart-multi-combo-input.smart-valid[focus] .smart-action-button,
.outlined.smart-input[focus] {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.outlined.smart-input.smart-multi-combo-input.smart-valid[focus] .smart-action-button.smart-valid {
    color: #005c99;
    color: var(--smart-primary)
}

.outlined.smart-input.smart-multi-combo-input.smart-invalid[focus] .smart-action-button.smart-invalid {
    color: #b00020;
    color: var(--smart-error)
}

.outlined.smart-input[drop-down-button-position=right] input {
    border-right: none
}

.outlined.smart-input[drop-down-button-position=right] .smart-drop-down-button {
    background: inherit;
    border-bottom: 1px solid #e0e0e0;
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    color: inherit;
    cursor: pointer;
    padding: 10px 0 9px;
    z-index: 6
}

.outlined.smart-input[drop-down-button-position=left] input {
    border-left: none
}

.outlined.smart-input[drop-down-button-position=left] .smart-drop-down-button {
    background: inherit;
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-left: 1px solid #e0e0e0;
    border-left: 1px solid var(--smart-border);
    border-right: none;
    color: inherit;
    cursor: pointer;
    padding: 10px 0;
    z-index: 6
}

.outlined.smart-input[hint] .smart-hint {
    border-color: #e0e0e0 !important;
    border-color: var(--smart-border) !important;
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: text;
    display: flex !important;
    font-size: 75%;
    left: 0;
    line-height: 15px;
    margin-top: -6px;
    max-height: 100%;
    position: absolute;
    top: 0;
    transition: color .2s, z-index .2s, font-size .2s, opacity .3s, font-size .2s, line-height .2s;
    white-space: nowrap;
    width: 100%;
    z-index: 7
}

.outlined.smart-input[hint] .smart-hint:after,
.outlined.smart-input[hint] .smart-hint:before {
    border-top: 1px solid;
    border-top-color: #e0e0e0 !important;
    border-top-color: var(--smart-border) !important;
    box-shadow: inset 0 1px transparent;
    box-sizing: border-box;
    content: "";
    display: block;
    height: 8px;
    margin-top: 6px;
    min-width: 10px;
    pointer-events: none;
    transition: border-color .2s, box-shadow .2s;
    z-index: 7
}

.outlined.smart-input[hint] .smart-hint:before {
    border-left: 1px solid transparent;
    border-radius: 4px 0;
    margin-right: 4px
}

.outlined.smart-input[hint] .smart-hint:after {
    border-radius: 0 4px;
    border-right: 1px solid transparent;
    flex-grow: 1;
    margin-left: 4px
}

.outlined.smart-input[hint][drop-down-button-position=left] .smart-hint:before {
    margin-right: 13px;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.outlined.smart-input[focus] {
    border-top-color: transparent !important;
    box-shadow: inset 1px 0 var(--smart-material-safari-helper1), inset -1px 0 var(--smart-material-safari-helper1), inset 0 -1px var(--smart-material-safari-helper1);
    outline: 0
}

.outlined.smart-input[focus] .smart-drop-down-button,
.outlined.smart-input[focus] .smart-input {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.outlined.smart-input[focus] .smart-drop-down-button {
    color: #005c99;
    color: var(--smart-primary)
}

.outlined.smart-input[focus][hint] .smart-input {
    border-top-color: #fefefe;
    border-top-color: var(--smart-background)
}

.outlined.smart-input[focus][hint] .smart-hint {
    color: #005c99;
    color: var(--smart-primary);
    opacity: 1
}

.outlined.smart-input[focus][hint] .smart-hint:after,
.outlined.smart-input[focus][hint] .smart-hint:before {
    border-top-color: #005c99 !important;
    border-top-color: var(--smart-primary) !important;
    box-shadow: none !important
}

.outlined.smart-input[hover] {
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-color: transparent
}

.outlined.smart-input[hover][hint] .smart-hint:before {
    border-top-color: #e0e0e0;
    border-top-color: var(--smart-border)
}

.outlined.smart-input[hover][hint]>input:not(:focus):-ms-input-placeholder,
.outlined.smart-input[hover][hint]>textarea:not(:focus):-ms-input-placeholder {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.outlined.smart-input[hover][hint]>input:not(:focus):placeholder-shown,
.outlined.smart-input[hover][hint]>textarea:not(:focus):placeholder-shown {
    border-color: #e0e0e0;
    border-color: var(--smart-border)
}

.outlined.smart-input[readonly] .smart-input {
    background: #fefefe !important;
    background: var(--smart-background) !important;
    color: #5a5a5a !important;
    color: var(--smart-background-color) !important;
    opacity: .75
}

.outlined.smart-input:not([focus]) .smart-input:not(:focus):-ms-input-placeholder {
    border-top: 1px solid #e0e0e0;
    border-top: 1px solid var(--smart-border);
    z-index: 5
}

.outlined.smart-input:not([focus]) .smart-input,
.outlined.smart-input:not([focus]) .smart-input:not(:focus):placeholder-shown {
    border-top: 1px solid #e0e0e0;
    border-top: 1px solid var(--smart-border);
    z-index: 5
}

.outlined.smart-input:not([focus]).smart-invalid .smart-input:not(:focus):-ms-input-placeholder {
    border-top: 1px solid rgba(176, 0, 32, .5);
    border-top: 1px solid rgba(var(--smart-error-rgb), .5);
    z-index: 5
}

.outlined.smart-input:not([focus]).smart-invalid .smart-input,
.outlined.smart-input:not([focus]).smart-invalid .smart-input:not(:focus):placeholder-shown {
    border-top: 1px solid rgba(176, 0, 32, .5);
    border-top: 1px solid rgba(var(--smart-error-rgb), .5);
    z-index: 5
}

.outlined.smart-input[hint] .smart-input:not(:focus):-ms-input-placeholder+.smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 60px;
    pointer-events: none;
    -ms-user-select: none;
    user-select: none;
    z-index: 2
}

.outlined.smart-input:not([focus]):not([value]).smart-multi-combo-input[hint] .smart-hint,
.outlined.smart-input[hint] .smart-input:not(:focus):placeholder-shown+.smart-hint,
.outlined.smart-input[hint]:not([focus]) .smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 60px;
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    z-index: 2
}

.outlined.smart-input.smart-invalid[focus] {
    border-color: #b00020;
    border-color: var(--smart-error)
}

.outlined.smart-input.smart-invalid[focus][hint] .smart-hint {
    color: #b00020;
    color: var(--smart-error)
}

.outlined.smart-input.smart-invalid[focus][hint] .smart-hint:after,
.outlined.smart-input.smart-invalid[focus][hint] .smart-hint:before {
    border-top-color: #b00020 !important;
    border-top-color: var(--smart-error) !important
}

.outlined.smart-input.smart-valid[focus] {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.outlined.smart-input.smart-valid[focus][hint] .smart-hint {
    color: #005c99;
    color: var(--smart-primary)
}

.outlined.smart-input.smart-valid[focus][hint] .smart-hint:after,
.outlined.smart-input.smart-valid[focus][hint] .smart-hint:before {
    border-top-color: #005c99 !important;
    border-top-color: var(--smart-primary) !important
}

.outlined.smart-text-area[hint] .smart-input:not(:focus):-ms-input-placeholder+.smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 30px;
    line-height: var(--smart-editor-height);
    opacity: 0;
    z-index: 2
}

.outlined.smart-text-area[hint] .smart-input:not(:focus):placeholder-shown+.smart-hint,
.outlined.smart-text-area[hint]:not([focus]) .smart-hint {
    font-size: 14px;
    font-size: var(--smart-font-size);
    line-height: 30px;
    line-height: var(--smart-editor-height);
    opacity: 0;
    z-index: 2
}

.outlined.smart-text-box input {
    border: none;
    padding: 7px
}

.outlined.smart-number-input .nav {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

.outlined.smart-number-input .nav .up {
    border-bottom: none
}

.outlined.smart-number-input[drop-down-button-position=left] .smart-drop-down-button,
.outlined.smart-number-input[drop-down-button-position=right] .smart-drop-down-button {
    padding: 0
}

.smart-invalid .outlined.smart-input.smart-multi-combo-input .smart-action-button {
    border-color: rgba(176, 0, 32, .5);
    border-color: rgba(var(--smart-error-rgb), .5)
}

.smart-invalid .outlined.smart-input.smart-multi-combo-input[focus] .smart-action-button {
    border-color: #b00020;
    border-color: var(--smart-error)
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {
    @supports (-webkit-appearance:none) {

        .smart-input .smart-hint,
        .smart-input .smart-hint:after,
        .smart-input .smart-input {
            transition-duration: .1s
        }
    }
}

.smart-time-picker {
    display: block;
    height: 360px;
    height: var(--smart-time-picker-default-height);
    line-height: normal;
    min-width: 250px;
    width: 250px;
    width: var(--smart-time-picker-default-width)
}

.smart-time-picker>.smart-container {
    height: 100%;
    width: 100%
}

.smart-time-picker .smart-main-container {
    background-color: #fefefe;
    background-color: var(--smart-background);
    height: calc(100% - 60px);
    height: calc(100% - var(--smart-calendar-title-height));
    padding: 2%;
    width: 100%
}

.smart-time-picker .smart-header {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    display: flex;
    height: 60px;
    height: var(--smart-calendar-title-height);
    justify-content: center;
    width: 100%
}

.smart-time-picker .smart-header:focus {
    outline: 1px solid #fefefe;
    outline: var(--smart-background) solid 1px
}

.smart-time-picker .smart-footer {
    display: none
}

.smart-time-picker .smart-svg-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-time-picker .smart-am-container,
.smart-time-picker .smart-hour-container,
.smart-time-picker .smart-minute-container,
.smart-time-picker .smart-pm-container {
    cursor: pointer;
    opacity: .5
}

.smart-time-picker .smart-hour-minute-container {
    display: flex;
    font-size: 50px
}

.smart-time-picker .smart-hour-minute-container div:nth-child(2) {
    opacity: .5
}

.smart-time-picker .smart-am-pm-container {
    margin-left: 10px
}

.smart-time-picker .smart-selected {
    opacity: 1
}

.smart-time-picker .smart-svg-picker {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-radius: 50%;
    box-sizing: content-box;
    position: relative;
    touch-action: none
}

.smart-time-picker .smart-svg-picker:focus {
    border: 1px solid #b2b2b2;
    border: 1px solid var(--smart-outline);
    outline: 0
}

.smart-time-picker .smart-svg-picker.animate {
    -webkit-animation: smart-time-picker-animation .5s linear;
    animation: smart-time-picker-animation .5s linear
}

.smart-time-picker .smart-label {
    fill: #5a5a5a;
    fill: var(--smart-background-color)
}

.smart-time-picker .smart-label.smart-selected {
    fill: #fff;
    fill: var(--smart-primary-color);
    stroke: #fff;
    stroke: var(--smart-primary-color);
    stroke-width: 0
}

.smart-time-picker .smart-needle,
.smart-time-picker .smart-needle-central-circle {
    fill: #005c99;
    fill: var(--smart-primary)
}

.smart-time-picker[disabled] .smart-am-container,
.smart-time-picker[disabled] .smart-hour-container,
.smart-time-picker[disabled] .smart-minute-container,
.smart-time-picker[disabled] .smart-pm-container,
.smart-time-picker[readonly] .smart-am-container,
.smart-time-picker[readonly] .smart-hour-container,
.smart-time-picker[readonly] .smart-minute-container,
.smart-time-picker[readonly] .smart-pm-container {
    cursor: default
}

.smart-time-picker[footer] .smart-footer {
    display: block;
    height: 30px;
    width: 100%
}

.smart-time-picker[footer] .smart-svg-container {
    height: calc(100% - 30px)
}

.smart-time-picker[view=landscape] {
    height: 250px;
    height: var(--smart-time-picker-default-width);
    min-width: 400px;
    width: 360px;
    width: var(--smart-time-picker-default-height)
}

.smart-time-picker[view=landscape]>.smart-container {
    display: flex
}

.smart-time-picker[view=landscape] .smart-header {
    flex-direction: column;
    height: 100%;
    width: 33%
}

.smart-time-picker[view=landscape] .smart-main-container {
    height: 100%;
    width: 67%
}

.smart-time-picker[view=landscape] .smart-am-pm-container {
    margin-left: 0
}

.smart-time-picker[right-to-left] .smart-footer,
.smart-time-picker[right-to-left] .smart-header {
    direction: rtl
}

.smart-time-picker[right-to-left] .smart-am-pm-container {
    margin: 0 10px 0 0
}

.smart-time-picker[right-to-left][view=landscape]>.smart-container {
    flex-direction: row-reverse
}

@-webkit-keyframes smart-time-picker-animation {

    0%,
    to {
        opacity: 1
    }

    25%,
    75% {
        opacity: .5
    }

    50% {
        opacity: 0
    }
}

@keyframes smart-time-picker-animation {

    0%,
    to {
        opacity: 1
    }

    25%,
    75% {
        opacity: .5
    }

    50% {
        opacity: 0
    }
}

.date-range{
    background-color: rgba(25, 118, 210, 0.12);
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-light{
    background-color: #eeeeee;
    border-radius:0;
    margin:0;
    width:40px;
}

.date-range-start{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-start-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
${
  theme === "light"
    ? `
    .Mui-selected{
    color: #000000 !important;
    background-color: rgb(220, 216, 204) !important;
    font-weight: 500;
    }
    `
    : `
    .Mui-selected{
    color: #fff;
    background-color: #1976d2;
    font-weight: 500;
    }
    `
}

.date-range-end{
    background-color: #1976d2 !important;
    border-radius: 0;
    margin:0;
    width:40px;
}
.date-range-end-light{
    background-color: rgb(220, 216, 204) !important;
    border-radius: 0;
    margin:0;
    width:40px;
}

.date-range-current{
    outline: 1px solid;
    }

smart-toast,
smart-toast .smart-toast-container {
    display: none;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-toast-container.smart-toast-container-bottom-left,
.smart-toast-container.smart-toast-container-bottom-right,
.smart-toast-container.smart-toast-container-custom,
.smart-toast-container.smart-toast-container-top-left,
.smart-toast-container.smart-toast-container-top-right {
    box-sizing: border-box;
    overflow-y: hidden;
    padding: 5px;
    position: fixed;
    width: 400px;
    width: var(--smart-toast-container-default-width);
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-toast-container.smart-toast-container-top-left {
    left: 0;
    top: 0
}

.smart-toast-container.smart-toast-container-top-right {
    right: 0;
    top: 0
}

.smart-toast-container.smart-toast-container-bottom-left {
    bottom: 0;
    left: 0
}

.smart-toast-container.smart-toast-container-bottom-right {
    bottom: 0;
    right: 0
}

.smart-toast-container.smart-toast-container-modal {
    height: 100%;
    width: 100%
}

.smart-toast-container.smart-toast-container-modal:not(:empty) {
    align-items: center;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-toast-container.smart-toast-container-modal .smart-toast-item {
    width: 200px
}

.smart-toast-item {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: block;
    margin-bottom: 2px;
    opacity: .8;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-toast-item:hover {
    opacity: 1
}

.smart-toast-item .smart-toast-item-header {
    display: flex;
    height: 20px;
    height: var(--smart-toast-header-height);
    justify-content: flex-end
}

.smart-toast-item .smart-toast-item-header .smart-toast-item-close-button {
    color: inherit;
    cursor: pointer;
    display: none;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 14px;
    height: var(--smart-font-size);
    margin: 5px;
    opacity: 1;
    position: relative;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 14px;
    width: var(--smart-font-size)
}

.smart-toast-item .smart-toast-item-container {
    align-items: center;
    display: flex;
    padding: 0 0 10px;
    position: relative;
    top: -4px
}

.smart-toast-item .smart-toast-item-container .smart-toast-item-icon {
    background-repeat: no-repeat;
    display: inline-block;
    height: 25px;
    margin: 0 15px;
    width: 25px
}

.smart-toast-item .smart-toast-item-container .smart-toast-item-icon:after {
    align-items: center;
    content: "";
    content: var(--smart-toast-item-icon);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 1.75em;
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-toast-item .smart-toast-item-container .smart-toast-item-content {
    color: inherit;
    display: inline-block;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    margin: 0 15px;
    opacity: 1;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    width: calc(100% - 110px)
}

.smart-toast-item[show-close-button] .smart-toast-item-header .smart-toast-item-close-button {
    display: block
}

.smart-toast-item[show-close-button] .smart-toast-item-header .smart-toast-item-close-button:after {
    color: inherit;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: inherit;
    left: 0;
    position: absolute;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-toast-item.primary,
.smart-toast-item.primary .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item[opened] {
    opacity: .8
}

.smart-toast-item[opened]:hover {
    opacity: 1
}

.smart-toast-item.blink {
    -webkit-animation: blink 1s ease-in infinite normal;
    animation: blink 1s ease-in infinite normal
}

.smart-toast-item.primary {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-toast-item.secondary {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border-color: #2d2d30;
    border-color: var(--smart-secondary);
    color: #fff;
    color: var(--smart-secondary-color)
}

.smart-toast-item.secondary .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.success {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    border-color: #8bc34a;
    border-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color)
}

.smart-toast-item.success .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.error {
    background-color: #b00020;
    background-color: var(--smart-error);
    border-color: #b00020;
    border-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color)
}

.smart-toast-item.error .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.info {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    border-color: #5cc0de;
    border-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color)
}

.smart-toast-item.info .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.warning {
    background-color: #f0ad4e;
    background-color: var(--smart-warning);
    border-color: #f0ad4e;
    border-color: var(--smart-warning);
    color: #fff;
    color: var(--smart-warning-color)
}

.smart-toast-item.warning .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.light {
    background-color: #fff;
    background-color: var(--smart-light);
    border-color: #fff;
    border-color: var(--smart-light);
    color: #222;
    color: var(--smart-light-color)
}

.smart-toast-item.light .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.dark {
    background-color: #222;
    background-color: var(--smart-dark);
    border-color: #222;
    border-color: var(--smart-dark);
    color: #fff;
    color: var(--smart-dark-color)
}

.smart-toast-item.dark .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-toast-item.mail {
    background-color: #337ab7;
    border-color: #337ab7;
    color: #fff
}

.smart-toast-item.mail .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff
}

.smart-toast-item.time {
    background-color: #363636;
    border-color: #363636;
    color: #fff
}

.smart-toast-item.time .smart-toast-item-header .smart-toast-item-close-button {
    color: #fff
}

.smart-toast-item.info .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-help-circled)
}

.smart-toast-item.warning .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-attention)
}

.smart-toast-item.success .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-check)
}

.smart-toast-item.error .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-block)
}

.smart-toast-item.mail .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-mail)
}

.smart-toast-item.time .smart-toast-item-icon:after {
    --smart-toast-item-icon: var(--smart-icon-clock)
}

.smart-toast-item[right-to-left]>.smart-container {
    direction: rtl
}

@-webkit-keyframes blink {
    50% {
        opacity: .5
    }
}

@keyframes blink {
    50% {
        opacity: .5
    }
}

.smart-toggle-box {
    cursor: pointer;
    display: inline-block;
    height: 30px;
    height: var(--smart-editor-height);
    outline: 0
}

.smart-toggle-box.smart-element {
    background: 0 0;
    border: none
}

.smart-toggle-box .smart-container,
.smart-toggle-box.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-toggle-box .smart-overlay,
.smart-toggle-box .smart-ripple {
    background: #005c99;
    background: var(--smart-primary)
}

.smart-toggle-box .smart-overlay {
    border-radius: 100%;
    box-sizing: content-box;
    height: 100%;
    left: 2px;
    margin: 0;
    opacity: 0;
    padding: 0;
    position: absolute;
    top: 0;
    transition: opacity .28s ease-in-out;
    width: 30px;
    width: var(--smart-editor-height)
}

.smart-toggle-box .smart-label {
    background: inherit;
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: inherit;
    margin: 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: auto
}

.smart-toggle-box.smart-check-box .smart-input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-sizing: content-box;
    box-sizing: initial;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: inline-block;
    height: 16px;
    height: var(--smart-check-box-default-size);
    margin: 0 0 0 8px;
    min-height: 16px;
    min-height: var(--smart-check-box-default-size);
    min-width: 16px;
    min-width: var(--smart-check-box-default-size);
    position: relative;

    width: 16px;
    width: var(--smart-check-box-default-size)
}

.smart-toggle-box.smart-check-box .smart-input:after {
    align-content: center;
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center
}

.smart-toggle-box.smart-check-box[checked] .smart-input:after {
    /*content: "\\e908";
    content: var(--smart-icon-check);*/
    font-weight: 100;
    pointer-events: none
}

.smart-toggle-box.smart-check-box[checked=null] .smart-input:after {
    content: "-";
    margin-top: -1px
}

.smart-toggle-box.smart-radio-button .smart-input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 100%;
    box-sizing: content-box;
    box-sizing: initial;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: inline-block;
    height: 16px;
    height: var(--smart-radio-button-default-size);
    margin: 0 0 0 8px;
    min-height: 16px;
    min-height: var(--smart-radio-button-default-size);
    min-width: 16px;
    min-width: var(--smart-radio-button-default-size);
    position: relative;
    width: 16px;
    width: var(--smart-radio-button-default-size)
}

.smart-toggle-box.smart-radio-button .smart-input:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    border-radius: 50%;
    color: inherit;
    content: "";
    font-style: normal;
    font-variant: normal;
    height: 50%;
    left: 50%;
    line-height: 100%;
    position: absolute;
    text-decoration: inherit;
    text-transform: none;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 50%
}

.smart-toggle-box.smart-radio-button[checked] .smart-input:after {
    background: #fff;
    background: var(--smart-primary-color);
    font-size: 15px;
    font-weight: 100
}

.smart-toggle-box.smart-radio-button[checked][hover]:not([focus]) .smart-input:after {
    background: #333;
    background: var(--smart-ui-state-color-hover)
}

.smart-toggle-box[active] .smart-input,
.smart-toggle-box[checked] .smart-input {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-toggle-box[active]:focus .smart-overlay,
.smart-toggle-box[active][focus] .smart-overlay {
    opacity: .4
}

.smart-toggle-box[hover] .smart-input {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-toggle-box:focus .smart-input,
.smart-toggle-box[focus] .smart-input {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    outline: 0;
    overflow: visible
}

.smart-toggle-box:focus .smart-overlay,
.smart-toggle-box[focus] .smart-overlay {
    opacity: .3
}

.smart-toggle-box[readonly],
.smart-toggle-box[readonly] .smart-input,
.smart-toggle-box[readonly] .smart-label {
    cursor: auto
}

.smart-toggle-box[check-mode=input] {
    cursor: default
}

.smart-toggle-box[check-mode=input] .smart-input,
.smart-toggle-box[check-mode=label] .smart-label {
    cursor: pointer
}

.smart-toggle-box[right-to-left] .smart-container,
.smart-toggle-box[right-to-left] .smart-hidden-input {
    direction: rtl
}

.smart-toggle-box[right-to-left] .smart-overlay {
    left: auto;
    right: 2px
}

.smart-toggle-box[right-to-left] .smart-input {
    margin: 0 8px 0 0
}

smart-tooltip {
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    opacity: 0;
    pointer-events: none;
    position: absolute;
    text-align: center;
    visibility: hidden;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

smart-tooltip.smart-element {
    background: 0 0;
    overflow: visible
}

smart-tooltip .smart-tooltip-content {
    background-color: #2d2d30;
    background-color: var(--smart-secondary);
    border: 1px solid #2d2d30;
    border: var(--smart-border-width) solid var(--smart-secondary);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6);
    color: #fff;
    color: var(--smart-secondary-color);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    height: 100%;
    opacity: .9;
    overflow: hidden;
    padding: 4px 8px;
    padding: var(--smart-tooltip-padding);
    text-overflow: ellipsis;
    width: 100%
}

smart-tooltip[arrow],
smart-tooltip[arrow][arrow-direction=bottom] {
    padding-bottom: 6px;
    padding-bottom: var(--smart-tooltip-arrow-width)
}

smart-tooltip.auto,
smart-tooltip.auto .smart-container,
smart-tooltip.auto .smart-tooltip-content {
    height: auto
}

smart-tooltip[arrow] .smart-tooltip-content:after,
smart-tooltip[arrow][arrow-direction=bottom] .smart-tooltip-content:after {
    border-left: 6px solid transparent;
    border-left: var(--smart-tooltip-arrow-width) solid transparent;
    border-right: 6px solid transparent;
    border-right: var(--smart-tooltip-arrow-width) solid transparent;
    border-top: 6px solid #2d2d30;
    border-top: var(--smart-tooltip-arrow-width) solid var(--smart-tooltip-arrow-color);
    bottom: 0;
    content: "";
    height: 0;
    left: calc(50% - 6px);
    left: calc(50% - var(--smart-tooltip-arrow-width));
    position: absolute;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-transform: translateX(var(--smart-tooltip-arrow-translate));
    transform: translateX(var(--smart-tooltip-arrow-translate));
    width: 0
}

smart-tooltip[visible] {
    opacity: 1;
    pointer-events: auto;
    visibility: visible
}

smart-tooltip[arrow][arrow-direction=top] {
    padding-bottom: 0;
    padding-top: 6px;
    padding-top: var(--smart-tooltip-arrow-width)
}

smart-tooltip[arrow][arrow-direction=top] .smart-tooltip-content:after {
    border-bottom: 6px solid #2d2d30;
    border-bottom: var(--smart-tooltip-arrow-width) solid var(--smart-tooltip-arrow-color);
    border-left: 6px solid transparent;
    border-left: var(--smart-tooltip-arrow-width) solid transparent;
    border-right: 6px solid transparent;
    border-right: var(--smart-tooltip-arrow-width) solid transparent;
    border-top: initial;
    bottom: calc(100% + 6px);
    bottom: calc(100% + var(--smart-tooltip-arrow-width));
    top: 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-transform: translateX(var(--smart-tooltip-arrow-translate));
    transform: translateX(var(--smart-tooltip-arrow-translate))
}

smart-tooltip[arrow][arrow-direction=left] {
    padding-bottom: 0;
    padding-left: 6px;
    padding-left: var(--smart-tooltip-arrow-width)
}

smart-tooltip[arrow][arrow-direction=left] .smart-tooltip-content:after {
    border-bottom: 6px solid transparent;
    border-bottom: var(--smart-tooltip-arrow-width) solid transparent;
    border-left: initial;
    border-right: 6px solid #2d2d30;
    border-right: var(--smart-tooltip-arrow-width) solid var(--smart-tooltip-arrow-color);
    border-top: 6px solid transparent;
    border-top: var(--smart-tooltip-arrow-width) solid transparent;
    left: 0;
    top: calc(50% - 6px);
    top: calc(50% - var(--smart-tooltip-arrow-width));
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-transform: translateY(var(--smart-tooltip-arrow-translate));
    transform: translateY(var(--smart-tooltip-arrow-translate))
}

smart-tooltip[arrow][arrow-direction=right] {
    padding-bottom: 0;
    padding-right: 6px;
    padding-right: var(--smart-tooltip-arrow-width)
}

smart-tooltip[arrow][arrow-direction=right] .smart-tooltip-content:after {
    border-bottom: 6px solid transparent;
    border-bottom: var(--smart-tooltip-arrow-width) solid transparent;
    border-left: 6px solid #2d2d30;
    border-left: var(--smart-tooltip-arrow-width) solid var(--smart-tooltip-arrow-color);
    border-right: initial;
    border-top: 6px solid transparent;
    border-top: var(--smart-tooltip-arrow-width) solid transparent;
    left: calc(100% - 6px);
    left: calc(100% - var(--smart-tooltip-arrow-width));
    top: calc(50% - 6px);
    top: calc(50% - var(--smart-tooltip-arrow-width));
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-transform: translateY(var(--smart-tooltip-arrow-translate));
    transform: translateY(var(--smart-tooltip-arrow-translate))
}

smart-tooltip:not([animation=none]) {
    transition: opacity .5s ease-in-out, visibility .5s ease-in-out
}

smart-tooltip[right-to-left] .smart-tooltip-content {
    direction: rtl
}

smart-tree {
    display: block;
    height: 450px;
    height: var(--smart-tree-default-height);
    overflow: hidden;
    visibility: hidden;
    width: 450px;
    width: var(--smart-tree-default-width)
}

.smart-tree.smart-container,
.smart-tree>.smart-container {
    display: flex;
    flex-direction: column;
    position: relative
}

.smart-tree.smart-element {
    visibility: inherit
}

.smart-tree smart-scroll-bar {
    overflow: hidden
}

.smart-tree smart-scroll-viewer {
    border: none;
    height: 100%;
    padding: 0;
    position: relative;
    width: 100%
}

.smart-tree smart-scroll-viewer.smart-scroll-viewer-element {
    border: none
}

.smart-tree smart-scroll-viewer.scroll-buttons-shown {
    height: calc(100% - 40px);
    height: calc(100% - var(--smart-tree-scroll-button-size)*2);
    width: 100%
}

.smart-tree smart-scroll-viewer.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 20px);
    height: calc(100% - var(--smart-tree-scroll-button-size));
    width: 100%
}

.smart-tree smart-tree-item,
.smart-tree smart-tree-items-group {
    align-items: center;
    cursor: pointer;
    height: auto;
    justify-content: space-between;
    position: relative;
    white-space: nowrap
}

.smart-tree .smart-tree-drop-down,
.smart-tree smart-tree-item[disabled],
.smart-tree smart-tree-item[template-applied],
.smart-tree smart-tree-items-group[disabled],
.smart-tree[disabled] smart-tree-item,
.smart-tree[disabled] smart-tree-items-group,
.smart-tree[display-loading-indicator] smart-tree-item,
.smart-tree[display-loading-indicator] smart-tree-items-group {
    cursor: default
}

.smart-tree smart-tree-item.smart-element,
.smart-tree smart-tree-items-group.smart-element {
    border: none
}

.smart-tree smart-tree-item[separator]:after,
.smart-tree smart-tree-items-group[separator]:after {
    background-color: rgba(0, 0, 0, .1);
    bottom: 0;
    content: "";
    height: 1px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%
}

.smart-tree smart-tree-item {
    display: block;
    overflow: hidden;
    padding-left: 0
}

.smart-tree smart-tree-item .smart-tree-item-shortcut {
    opacity: .5
}

.smart-tree smart-tree-items-group {
    display: flex;
    flex-direction: column;
    overflow: hidden
}

.smart-tree smart-tree-items-group>.smart-tree-item-label-container {
    justify-content: flex-start;
    overflow: hidden
}

.smart-tree smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    order: 1
}

.smart-tree smart-tree-items-group .smart-tree-items-group-arrow {
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 13px;
    justify-content: center;
    left: -7px;
    left: calc(1px - var(--smart-tree-indent)/2);
    line-height: 1;
    order: 0;
    position: relative;
    -webkit-transform: rotate(0);
    transform: rotate(0);
    width: 16px;
    width: var(--smart-tree-indent)
}

.smart-tree smart-tree-items-group .smart-tree-items-group-arrow:after {
    height: 100%;
    left: 0;
    position: relative;
    top: 0
}

.smart-tree smart-tree-items-group.filtered-child>.smart-tree-item-label-container>.smart-tree-item-label-element {
    font-weight: unset
}

.smart-tree .smart-tree-main-container {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-tree .smart-tree-items-group-opened>.smart-tree-item-label-container>.smart-tree-items-group-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-tree .smart-tree-item-label-element {
    align-items: center;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

.smart-tree .smart-tree-item-label-element>span {
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    display: flex;
    white-space: nowrap
}

.smart-tree .smart-tree-item-label-element>span>smart-button button {
    padding: initial
}

.smart-tree .smart-tree-item-label-element>span>i {
    vertical-align: middle
}

.smart-tree .smart-tree-item-label-container {
    align-items: center;
    display: flex;
    flex-direction: row;

    justify-content: space-between;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-tree .smart-tree-edit-input {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    margin: 0 3px;
    margin: 0 var(--smart-tree-item-horizontal-offset);
    outline: 0;
    position: absolute;
    width: calc(100% - 6px);
    width: calc(100% - var(--smart-tree-item-horizontal-offset)*2);
    z-index: 1
}

.smart-tree .smart-tree-edit-input::selection {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-tree .smart-tree-filter-input-container {
    display: none;
    font-size: inherit;
    height: 30px;
    height: calc(var(--smart-text-box-default-height));
    margin: 3px;
    margin: var(--smart-tree-item-vertical-offset) var(--smart-tree-item-horizontal-offset);
    position: relative;
    width: calc(100% - 6px);
    width: calc(100% - var(--smart-tree-item-horizontal-offset)*2)
}

.smart-tree .smart-tree-filter-input-container:after {
    align-items: center;
    content: "\\f0b0";
    content: var(--smart-icon-filter);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 30px;
    height: var(--smart-text-box-default-height);
    justify-content: center;
    left: calc(100% - 25px);
    position: absolute;
    top: 0;
    width: 25px
}

.smart-tree .smart-filter-input {
    background: inherit;
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    color: inherit;
    font-size: inherit;
    height: 100%;
    padding-left: 4px;
    padding-left: var(--smart-editor-label-padding);
    padding-right: 29px;
    padding-right: calc(var(--smart-editor-label-padding) + 25px);
    width: 100%
}

.smart-tree .smart-filter-input:focus {
    outline: 0
}

.smart-tree .smart-filter-input::selection {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-tree .smart-tree-scroll-button {
    --smart-button-padding: 0;
    background-color: #f1f1f1;
    background-color: var(--smart-scroll-bar-button-background);
    height: 20px;
    height: var(--smart-tree-scroll-button-size);
    width: 100%
}

.smart-tree .smart-tree-scroll-button>button {
    border: none
}

.smart-tree .smart-scroll-viewer-container .smart-tree-main-container {
    padding-left: 3px;
    padding-left: var(--smart-tree-item-horizontal-offset);
    padding-top: 3px;
    padding-top: var(--smart-tree-item-vertical-offset)
}

.smart-tree .smart-scroll-viewer-container .smart-tree-main-container,
.smart-tree .smart-scroll-viewer-container.vscroll .smart-tree-main-container {
    padding-right: 3px;
    padding-right: var(--smart-tree-item-horizontal-offset)
}

.smart-tree .smart-scroll-viewer-content-container {
    display: block;
    padding: 0
}

.smart-tree .smart-tree-drop-down {
    height: auto;
    -webkit-transform: none;
    transform: none;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    width: 100%
}

.smart-tree .smart-tree-drop-down.smart-visibility-hidden {
    height: 0;
    margin-top: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-tree .drop-target:after {
    border: 2px dashed #005c99;
    border: 2px dashed var(--smart-primary);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 0;
    opacity: .75;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-tree .drop-target.top:after {
    border: none;
    border-top: 2px dashed #005c99;
    border-top: 2px dashed var(--smart-primary)
}

.smart-tree .drop-target.bottom:after {
    border: none;
    border-bottom: 2px dashed #005c99;
    border-bottom: 2px dashed var(--smart-primary)
}

.smart-tree .smart-ripple {
    background: #005c99;
    background: var(--smart-primary)
}

.smart-tree .smart-hidden {
    display: none !important
}

.smart-tree[overflow=hidden],
.smart-tree[scroll-mode=scrollButtons] {
    --smart-scroll-bar-size: 0px
}

.smart-tree[selection-mode=checkBox] smart-tree-item>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox] smart-tree-items-group>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton] smart-tree-item>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton] smart-tree-items-group>.smart-tree-item-label-container:before {
    content: "";
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-tree[selection-mode=checkBox] smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=checkBox] smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton] smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton] smart-tree-items-group>.smart-tree-item-label-container:after {
    align-items: center;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    content: "";
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    height: var(--smart-check-box-default-size);
    justify-content: center;
    margin-left: 5px;
    padding: 1px;
    position: absolute;
    width: 16px;
    width: var(--smart-check-box-default-size)
}

.smart-tree[filterable] .smart-tree-filter-input-container,
.smart-tree[scroll-mode=scrollButtons] .smart-tree-scroll-button {
    display: block
}

.smart-tree[selection-mode=checkBox] smart-tree-item[selected][focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox] smart-tree-items-group[selected][focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton] smart-tree-item[selected][focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton] smart-tree-items-group[selected][focus]>.smart-tree-item-label-container:before {
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    content: "";
    height: 32px;
    height: calc(var(--smart-check-box-default-size) + 16px);
    margin-left: 5px;
    opacity: .3;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    width: 32px;
    width: calc(var(--smart-check-box-default-size) + 16px);
    z-index: 1
}

.smart-tree[selection-mode=checkBox][show-lines] smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton][show-lines] smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: 21px;
    margin-left: calc(var(--smart-tree-indent) + 5px)
}

.smart-tree[selection-mode=checkBox][show-lines] smart-tree-items-group[selected][focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][show-lines] smart-tree-items-group[selected][focus]>.smart-tree-item-label-container:before {
    margin-left: 16px;
    margin-left: calc(var(--smart-tree-indent))
}

.smart-tree[selection-mode=checkBox][show-lines] smart-tree-item[selected][focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][show-lines] smart-tree-item[selected][focus]>.smart-tree-item-label-container:before {
    margin-left: 0
}

.smart-tree[selection-mode=checkBox] smart-tree-item .smart-tree-item-label-element,
.smart-tree[selection-mode=checkBox] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-mode=radioButton] smart-tree-item .smart-tree-item-label-element,
.smart-tree[selection-mode=radioButton] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-left: 26px;
    padding-left: calc(var(--smart-tree-indent) + 10px)
}

.smart-tree[selection-mode=checkBox] .smart-tree-item-label-element>span,
.smart-tree[selection-mode=radioButton] .smart-tree-item-label-element>span {
    padding-left: 5px
}

.smart-tree[selection-mode=checkBox]:not([animation=none]) smart-tree-item>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox]:not([animation=none]) smart-tree-items-group>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton]:not([animation=none]) smart-tree-item>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton]:not([animation=none]) smart-tree-items-group>.smart-tree-item-label-container:before {
    transition: -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out;
    transition: transform .25s ease-in-out, -webkit-transform .25s ease-in-out
}

.smart-tree[selection-mode=checkBox][toggle-element-position=far] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox][toggle-element-position=far] smart-tree-items-group[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][toggle-element-position=far] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][toggle-element-position=far] smart-tree-items-group[focus]>.smart-tree-item-label-container:before {
    margin-left: -1px
}

.smart-tree[selection-mode=checkBox]:not([show-lines]) smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines]) smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: 21px;
    margin-left: calc(var(--smart-check-box-default-size) + 5px)
}

.smart-tree[selection-mode=checkBox]:not([show-lines]):not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=checkBox]:not([show-lines]):not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines]):not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines]):not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: 11px;
    margin-left: calc(var(--smart-check-box-default-size) - 5px)
}

.smart-tree[selection-mode=checkBox]:not([show-lines]):not([toggle-element-position=far]):not([right-to-left]) smart-tree-item .smart-tree-item-label-element>span,
.smart-tree[selection-mode=radioButton]:not([show-lines]):not([toggle-element-position=far]):not([right-to-left]) smart-tree-item .smart-tree-item-label-element>span {
    padding: 9px 12px;
    padding: var(--smart-tree-item-padding)
}

.smart-tree[selection-mode=checkBox]:not([show-lines])[right-to-left] smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines])[right-to-left] smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: -5px;
    margin-left: calc(var(--smart-check-box-default-size) - 21px)
}

.smart-tree[selection-mode=checkBox]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=checkBox]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: -9px;
    margin-left: calc(var(--smart-check-box-default-size) - 25px)
}

.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-item .smart-tree-item-label-element,
.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-item .smart-tree-item-label-element,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-left: 0;
    padding-right: 26px;
    padding-right: calc(var(--smart-tree-indent) + 10px)
}

.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-item>.smart-tree-item-label-container:after {
    margin-left: -5px
}

.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-items-group>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-items-group>.smart-tree-item-label-container:after {
    margin-left: -21px;
    margin-left: calc(-5px - var(--smart-check-box-default-size))
}

.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox][right-to-left] smart-tree-items-group[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left] smart-tree-items-group[focus]>.smart-tree-item-label-container:before {
    margin-left: -3px
}

.smart-tree[selection-mode=checkBox][right-to-left][show-lines] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox][right-to-left][toggle-element-position=far] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=checkBox][right-to-left][toggle-element-position=far] smart-tree-items-group[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left][show-lines] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left][toggle-element-position=far] smart-tree-item[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left][toggle-element-position=far] smart-tree-items-group[focus]>.smart-tree-item-label-container:before {
    margin-left: 1px
}

.smart-tree[selection-mode=checkBox][right-to-left][show-lines] smart-tree-items-group[focus]>.smart-tree-item-label-container:before,
.smart-tree[selection-mode=radioButton][right-to-left][show-lines] smart-tree-items-group[focus]>.smart-tree-item-label-container:before {
    margin-left: -15px;
    margin-left: calc(1px - var(--smart-check-box-default-size))
}

.smart-tree[selection-mode=radioButton] smart-tree-item>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton] smart-tree-items-group>.smart-tree-item-label-container:after {
    border-radius: 100%
}

.smart-tree[selection-mode=radioButton] smart-tree-item[selected]>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=radioButton] smart-tree-items-group[selected]>.smart-tree-item-label-container:after {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    content: "\\e818";
    content: var(--smart-icon-radio)
}

.smart-tree[selection-mode=checkBox] smart-tree-item[selected]>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=checkBox] smart-tree-items-group[selected]>.smart-tree-item-label-container:after {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    content: "\\e908";
    content: var(--smart-icon-check)
}

.smart-tree[selection-mode=checkBox] smart-tree-item[indeterminate]>.smart-tree-item-label-container:after,
.smart-tree[selection-mode=checkBox] smart-tree-items-group[indeterminate]>.smart-tree-item-label-container:after {
    background-clip: content-box;
    height: 15px;
    height: calc(var(--smart-check-box-default-size) - 1px);
    padding: 2px;
    width: 15px;
    width: calc(var(--smart-check-box-default-size) - 1px)
}

.smart-tree[filterable] smart-scroll-viewer {
    height: calc(100% - 36px);
    height: calc(100% - var(--smart-text-box-default-height) - var(--smart-tree-item-vertical-offset)*2)
}

.smart-tree[filterable] smart-scroll-viewer.scroll-buttons-shown {
    height: calc(100% - 76px);
    height: calc(100% - var(--smart-tree-scroll-button-size)*2 - var(--smart-text-box-default-height) - var(--smart-tree-item-vertical-offset)*2)
}

.smart-tree[filterable] smart-scroll-viewer.scroll-buttons-shown.one-button-shown {
    height: calc(100% - 56px);
    height: calc(100% - var(--smart-tree-scroll-button-size) - var(--smart-text-box-default-height) - var(--smart-tree-item-vertical-offset)*2)
}

.smart-tree[filter-applied] .smart-tree-item-label-element {
    font-weight: bolder
}

.smart-tree[filter-applied] smart-tree-items-group.hidden-children {
    cursor: not-allowed
}

.smart-tree:not([toggle-element-position=far]) smart-tree-items-group .smart-tree-items-group-arrow {
    opacity: 1;
    z-index: 1
}

.smart-tree[toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container {
    justify-content: space-between
}

.smart-tree[toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: 16px;
    margin-left: var(--smart-tree-indent);
    order: 0
}

.smart-tree[toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-items-group-arrow {
    order: 1
}

.smart-tree[toggle-element-position=far][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: 0;
    margin-right: 16px;
    margin-right: var(--smart-tree-indent)
}

.smart-tree:not([show-lines])[selection-mode=checkBox][toggle-element-position=far]:not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree:not([show-lines])[selection-mode=radioButton][toggle-element-position=far]:not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: 5px;
    margin-left: calc(var(--smart-tree-indent) - 11px)
}

.smart-tree:not([show-lines])[selection-mode=checkBox][toggle-element-position=far][right-to-left] smart-tree-item .smart-tree-item-label-element,
.smart-tree:not([show-lines])[selection-mode=checkBox][toggle-element-position=far][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree:not([show-lines])[selection-mode=radioButton][toggle-element-position=far][right-to-left] smart-tree-item .smart-tree-item-label-element,
.smart-tree:not([show-lines])[selection-mode=radioButton][toggle-element-position=far][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-right: 20px;
    padding-right: calc(var(--smart-tree-indent) + 4px)
}

.smart-tree:not([show-lines]):not([toggle-element-position=far]):not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: -4px
}

.smart-tree:not([show-lines]):not([toggle-element-position=far])[right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-right: -4px
}

.smart-tree:not([show-lines])[toggle-element-position=far]:not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: 12px;
    margin-left: calc(var(--smart-tree-indent) - 4px)
}

.smart-tree:not([show-lines])[toggle-element-position=far][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-right: 12px;
    margin-right: calc(var(--smart-tree-indent) - 4px)
}

.smart-tree:not([show-lines]):not([selection-display-mode=label]):not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    padding-left: 0
}

.smart-tree:not([show-lines]):not([selection-display-mode=label])[right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    padding-right: 0
}

.smart-tree[show-lines] smart-tree-item>.smart-tree-item-label-container,
.smart-tree[show-lines] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[show-lines] smart-tree-items-group>.smart-tree-item-label-container,
.smart-tree[show-lines] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    overflow: visible;
    position: relative
}

.smart-tree[show-lines] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element:before,
.smart-tree[show-lines] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    border-left: 1px dashed #e0e0e0;
    border-left: var(--smart-tree-lines-width) var(--smart-tree-lines-style) var(--smart-tree-lines-color);
    content: "";
    height: 300%;
    left: -16px;
    left: calc(0px - var(--smart-tree-indent));
    pointer-events: none;
    position: absolute
}

.smart-tree[show-lines] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element:after,
.smart-tree[show-lines] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element:after {
    border-top: 1px dashed #e0e0e0;
    border-top: var(--smart-tree-lines-width) var(--smart-tree-lines-style) var(--smart-tree-lines-color);
    content: "";
    left: -16px;
    left: calc(0px - var(--smart-tree-indent));
    pointer-events: none;
    position: absolute;
    width: 16px;
    width: var(--smart-tree-indent)
}

.smart-tree:not([selection-display-mode=label]) smart-tree-item,
.smart-tree:not([selection-display-mode=label]) smart-tree-items-group>.smart-tree-item-label-container,
.smart-tree[selection-display-mode=label] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-style: solid;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    border-width: 1px;
    border-width: var(--smart-item-border-width);
    margin-bottom: 3px;
    margin-bottom: var(--smart-tree-item-vertical-offset)
}

.smart-tree[show-lines] smart-tree-item.last-filtered-child>.smart-tree-item-label-container>.smart-tree-item-label-element:before,
.smart-tree[show-lines] smart-tree-item:last-child>.smart-tree-item-label-container>.smart-tree-item-label-element:before,
.smart-tree[show-lines] smart-tree-items-group.last-filtered-child>.smart-tree-item-label-container>.smart-tree-item-label-element:before,
.smart-tree[show-lines] smart-tree-items-group:last-child>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    height: 150%;
    top: -100%
}

.smart-tree[show-lines] smart-tree-item {
    padding-left: 16px;
    padding-left: var(--smart-tree-indent)
}

.smart-tree[show-lines] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    width: calc(100% - 16px);
    width: calc(100% - var(--smart-tree-indent))
}

.smart-tree[show-lines]:not([show-root-lines]) smart-tree-item[level="1"] .smart-tree-item-label-element:after,
.smart-tree[show-lines]:not([show-root-lines]) smart-tree-item[level="1"] .smart-tree-item-label-element:before,
.smart-tree[show-lines]:not([show-root-lines]) smart-tree-items-group[level="1"]>.smart-tree-item-label-container>.smart-tree-item-label-element:after,
.smart-tree[show-lines]:not([show-root-lines]) smart-tree-items-group[level="1"]>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    content: none
}

.smart-tree[show-lines][show-root-lines] smart-tree-item[level="1"] .smart-tree-item-label-element:after,
.smart-tree[show-lines][show-root-lines] smart-tree-item[level="1"] .smart-tree-item-label-element:before,
.smart-tree[show-lines][show-root-lines] smart-tree-items-group[level="1"]>.smart-tree-item-label-container>.smart-tree-item-label-element:after,
.smart-tree[show-lines][show-root-lines] smart-tree-items-group[level="1"]>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    pointer-events: none
}

.smart-tree[show-lines] .smart-tree-items-group-expanded:not(:last-child):not(.last-filtered-child)>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    height: 3000px;
    z-index: 1
}

.smart-tree[show-lines][right-to-left] smart-tree-item {
    padding-left: 0;
    padding-right: 16px;
    padding-right: var(--smart-tree-indent)
}

.smart-tree[show-lines][right-to-left] smart-tree-item .smart-tree-item-label-element:after,
.smart-tree[show-lines][right-to-left] smart-tree-item .smart-tree-item-label-element:before,
.smart-tree[show-lines][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element:after,
.smart-tree[show-lines][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element:before {
    left: auto;
    right: -16px;
    right: calc(0px - var(--smart-tree-indent))
}

.smart-tree:not([selection-display-mode=label]) smart-tree-item {
    border-color: transparent
}

.smart-tree:not([selection-display-mode=label]) smart-tree-item[focus] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-tree:not([selection-display-mode=label]) smart-tree-item[selected] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    /*color: var(--smart-ui-state-color-selected)*/
}

.smart-tree:not([selection-display-mode=label]) smart-tree-items-group>.smart-tree-item-label-container {
    border-color: transparent
}

.smart-tree:not([selection-display-mode=label]) smart-tree-items-group[focus]>.smart-tree-item-label-container {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-tree:not([selection-display-mode=label]) smart-tree-items-group[selected]>.smart-tree-item-label-container {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;

}

.smart-tree:not([selection-display-mode=label]):not([animation=none]) smart-tree-item,
.smart-tree:not([selection-display-mode=label]):not([animation=none]) smart-tree-items-group>.smart-tree-item-label-container {
    transition: color .28s ease-in-out, border-color .28s ease-in-out, background .28s ease-in-out
}

.smart-tree[selection-display-mode=label] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    border-color: transparent;
    margin-top: 3px;
    margin-top: var(--smart-tree-item-vertical-offset)
}

.smart-tree[selection-display-mode=label] smart-tree-item[focus]>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple),
.smart-tree[selection-display-mode=label] smart-tree-items-group[focus]>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple) {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-tree[selection-display-mode=label] smart-tree-items-group .smart-tree-items-group-arrow {
    top: calc(-.5px - var(--smart-tree-item-border-width)/2)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([right-to-left]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([right-to-left]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([right-to-left]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    margin-left: 5px;
    padding: 9px 12px;
    padding: var(--smart-tree-item-padding)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox][right-to-left] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=checkBox][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=radioButton][right-to-left] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label][selection-mode=radioButton][right-to-left] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    margin-right: 5px;
    padding: 9px 12px;
    padding: var(--smart-tree-item-padding)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines]):not([right-to-left]):not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines]):not([right-to-left]):not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-left: 31px;
    padding-left: calc(var(--smart-tree-indent) + 15px)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines]):not([right-to-left]):not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines]):not([right-to-left]):not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-left: 19px;
    padding-left: calc(var(--smart-tree-indent) + 3px)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines]):not([right-to-left])[toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines]):not([right-to-left])[toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-left: 0
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-right: 31px;
    padding-right: calc(var(--smart-tree-indent) + 15px)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines])[right-to-left]:not([toggle-element-position=far]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    padding-right: 19px;
    padding-right: calc(var(--smart-tree-indent) + 3px)
}

.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines])[right-to-left][toggle-element-position=far] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=checkBox]:not([show-lines])[right-to-left][toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines])[right-to-left][toggle-element-position=far] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element,
.smart-tree[selection-display-mode=label][selection-mode=radioButton]:not([show-lines])[right-to-left][toggle-element-position=far] smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element {
    margin-right: 5px
}

.smart-tree[selection-display-mode=label]:not([selection-mode=checkBox]):not([selection-mode=radioButton]) smart-tree-item[selected]>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple),
.smart-tree[selection-display-mode=label]:not([selection-mode=checkBox]):not([selection-mode=radioButton]) smart-tree-items-group[selected]>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple) {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-tree[selection-display-mode=label]:not([show-lines]):not([right-to-left]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    margin: 9px 12px;
    margin: var(--smart-tree-item-padding);
    margin-bottom: 3px;
    margin-bottom: var(--smart-tree-item-vertical-offset);
    margin-right: 0;
    margin-top: 3px;
    margin-top: var(--smart-tree-item-vertical-offset)
}

.smart-tree[selection-display-mode=label]:not([show-lines])[right-to-left] smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    margin: 9px 12px;
    margin: var(--smart-tree-item-padding);
    margin-bottom: 3px;
    margin-bottom: var(--smart-tree-item-vertical-offset);
    margin-left: 0;
    margin-top: 3px;
    margin-top: var(--smart-tree-item-vertical-offset)
}

.smart-tree[selection-display-mode=label]:not([animation=none]) smart-tree-item>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
.smart-tree[selection-display-mode=label]:not([animation=none]) smart-tree-items-group>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
    transition: color .28s ease-in-out, background .28s ease-in-out, border-color .28s ease-in-out
}

.smart-tree[selection-display-mode=label]:not([animation=none]) smart-tree-item[focus]:not([selected])>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple),
.smart-tree[selection-display-mode=label]:not([animation=none]) smart-tree-items-group[focus]:not([selected])>.smart-tree-item-label-container>.smart-tree-item-label-element>span:not(.smart-ripple) {
    transition: color .28s ease-in-out, border-color .28s ease-in-out, background .28s ease-in-out
}

.smart-tree[auto-hide-toggle-element] .hidden-arrows smart-tree-items-group .smart-tree-items-group-arrow {
    opacity: 0
}

.smart-tree:not([animation=none]) .smart-tree-drop-down {
    -webkit-transform-origin: top;
    transform-origin: top;
    transition: height .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: height .2s ease-in, transform .2s ease-in, visibility .2s ease-in;
    transition: height .2s ease-in, transform .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in
}

.smart-tree:not([animation=none]) .smart-tree-item-label-container>.smart-tree-items-group-arrow {
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-tree:not([animation=none])[auto-hide-toggle-element] .smart-tree-item-label-container>.smart-tree-items-group-arrow {
    transition: opacity .2s ease-in, -webkit-transform .2s ease-in;
    transition: transform .2s ease-in, opacity .2s ease-in;
    transition: transform .2s ease-in, opacity .2s ease-in, -webkit-transform .2s ease-in
}

@media (hover:hover) {

    .smart-tree[selection-mode=checkBox] smart-tree-item:hover>.smart-tree-item-label-container>.smart-tree-item-label-element span.smart-ripple,
    .smart-tree[selection-mode=checkBox] smart-tree-items-group>.smart-tree-item-label-container:hover>.smart-tree-item-label-element span.smart-ripple,
    .smart-tree[selection-mode=radioButton] smart-tree-item:hover>.smart-tree-item-label-container>.smart-tree-item-label-element span.smart-ripple,
    .smart-tree[selection-mode=radioButton] smart-tree-items-group>.smart-tree-item-label-container:hover>.smart-tree-item-label-element span.smart-ripple {
        background-color: rgba(0, 92, 153, .1);
        background-color: var(--smart-ui-state-selected)
    }

    .smart-tree[selection-mode=checkBox] smart-tree-item:hover>.smart-tree-item-label-container:after,
    .smart-tree[selection-mode=checkBox] smart-tree-items-group>.smart-tree-item-label-container:hover:after {
        background-color: #fefefe;
        background-color: var(--smart-background);
        border-color: #e0e0e0;
        border-color: var(--smart-border);
        color: #5a5a5a;
        color: var(--smart-background-color)
    }

    .smart-tree[selection-mode=checkBox] smart-tree-item[indeterminate]:not(:hover)>.smart-tree-item-label-container:after,
    .smart-tree[selection-mode=checkBox] smart-tree-items-group[indeterminate]>.smart-tree-item-label-container:not(:hover):after {
        background-color: rgba(0, 92, 153, .1);
        background-color: var(--smart-ui-state-selected)
    }

    .smart-tree[selection-mode=radioButton] smart-tree-item:not([selected]):hover>.smart-tree-item-label-container:after,
    .smart-tree[selection-mode=radioButton] smart-tree-items-group:not([selected])>.smart-tree-item-label-container:hover:after {
        background-color: #fefefe;
        background-color: var(--smart-background);
        border-color: #e0e0e0;
        border-color: var(--smart-border);
        color: #5a5a5a;
        color: var(--smart-background-color)
    }

    .smart-tree:not([selection-display-mode=label]) smart-tree-item:not([selected])[hover],
    .smart-tree:not([selection-display-mode=label]) smart-tree-items-group:not([selected])[hover]>.smart-tree-item-label-container,
    .smart-tree:not([selection-display-mode=label]):not([disable-hover]) smart-tree-item:not([selected]):hover,
    .smart-tree:not([selection-display-mode=label]):not([disable-hover]) smart-tree-items-group:not([selected])>.smart-tree-item-label-container:hover,
    .smart-tree[selection-display-mode=label] smart-tree-item:not([selected])[hover]>.smart-tree-item-label-container>.smart-tree-item-label-element>span,
    .smart-tree[selection-display-mode=label] smart-tree-items-group:not([selected])[hover]>.smart-tree-item-label-container,
    .smart-tree[selection-display-mode=label]:not([disable-hover]) smart-tree-item:not([selected]):hover>.smart-tree-item-label-container>.smart-tree-item-label-element>span {
        background-color: #ebebeb;
        background-color: var(--smart-ui-state-hover);
        border-color: #ebebeb;
        border-color: var(--smart-ui-state-border-hover);
        color: #333;
        color: var(--smart-ui-state-color-hover)
    }
}

.smart-tree[right-to-left] smart-tree-items-group .smart-tree-items-group-arrow {
    left: auto;
    right: -7px;
    right: calc(1px - var(--smart-tree-indent)/2)
}

.smart-tree[right-to-left] .smart-tree-filter-input-container:after {
    left: 0
}

.smart-tree[right-to-left] .smart-tree-item-label-container {
    flex-direction: row-reverse;
    overflow: visible;
    position: relative
}

.smart-tree[right-to-left] .smart-filter-input {
    direction: rtl;
    padding-left: 25px;
    padding-right: 1px
}

.smart-tree[right-to-left] .smart-tree-edit-input {
    direction: rtl
}

.smart-tree[right-to-left] .smart-tree-item-label-element {
    direction: rtl;
    overflow: visible;
    position: relative
}

.smart-tree-item-feedback {
    align-items: center;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: move;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    padding: 5px;
    position: absolute;
    white-space: nowrap;
    z-index: 10000
}

.smart-tree-item-feedback.multiple {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 26px
}

smart-window:not([opened]) {
    opacity: 0
}

.smart-window:not(.smart-container) {
    box-shadow: 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12), 0 11px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-24);
    display: block;
    height: 450px;
    height: var(--smart-window-default-height);
    left: calc(50% - 225px);
    left: calc(50% - var(--smart-window-default-width)/2);
    min-height: 48px;
    min-height: var(--smart-window-header-height);
    min-width: 250px;
    min-width: var(--smart-window-min-width);
    overflow: hidden;
    position: absolute;
    top: calc(50% - 225px);
    top: calc(50% - var(--smart-window-default-height)/2);
    width: 450px;
    width: var(--smart-window-default-width);
    z-index: 9998;
    z-index: calc(var(--smart-editor-drop-down-z-index) - 1)
}

.smart-window>.smart-container:not(.smart-window) {
    max-height: inherit
}

.smart-window .smart-content-container {
    display: flex;
    flex-direction: column;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    max-height: inherit;
    outline: 0;
    width: 100%
}

.smart-window .smart-content-container>.smart-header-section {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-window-header-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: move;
    display: flex;
    font-family: inherit;
    font-size: inherit;
    height: 48px;
    height: var(--smart-window-header-height);
    justify-content: space-between;
    line-height: normal;
    min-height: 48px;
    min-height: var(--smart-window-header-height);
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-window-header-padding);
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    width: 100%
}

.smart-window .smart-content-container>.smart-header-section>.smart-buttons-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center
}

.smart-window .smart-content-container>.smart-header-section>.smart-buttons-container button {
    background: 0 0;
    border: none;
    color: inherit;
    cursor: pointer;
    height: 24px;
    height: var(--smart-window-header-button-size);
    margin-left: 1px;
    margin-right: 1px;
    min-height: 0;
    outline: 0;
    padding: 0;
    position: relative;
    width: 24px;
    width: var(--smart-window-header-button-size)
}

.smart-window .smart-content-container>.smart-header-section>.smart-buttons-container button:active {
    background-color: transparent;
    background-color: initial;
    outline: 0
}

.smart-window .smart-content-container>.smart-content {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    display: flex;
    flex-direction: column;
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-window-header-height));
    overflow-y: auto;
    padding: 10px;
    padding: var(--smart-window-content-padding);
    width: 100%
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {
    .smart-window .smart-content-container>.smart-content {
        align-content: start
    }
}

.smart-window .smart-content-container>.smart-footer {
    background-color: transparent;
    background-color: initial;
    background: #f5f5f5;
    background: var(--smart-window-footer-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    font-family: inherit;
    font-size: inherit;
    height: 48px;
    height: var(--smart-window-footer-height);
    justify-content: center;
    line-height: normal;
    min-height: 48px;
    min-height: var(--smart-window-footer-height);
    padding: 6.5px;
    padding: var(--smart-window-footer-padding);
    position: relative;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    width: 100%
}

.smart-window .smart-content-container>.smart-footer:empty {
    display: none
}

.smart-window .smart-content-container.smart-window-resizing-left,
.smart-window .smart-content-container.smart-window-resizing-left>.smart-header-section,
.smart-window .smart-content-container.smart-window-resizing-right,
.smart-window .smart-content-container.smart-window-resizing-right>.smart-header-section {
    cursor: e-resize
}

.smart-window .smart-content-container.smart-window-resizing-bottom,
.smart-window .smart-content-container.smart-window-resizing-bottom>.smart-header-section,
.smart-window .smart-content-container.smart-window-resizing-top,
.smart-window .smart-content-container.smart-window-resizing-top>.smart-header-section {
    cursor: ns-resize
}

.smart-window .smart-content-container.smart-window-resizing-bottom-right,
.smart-window .smart-content-container.smart-window-resizing-bottom-right>.smart-header-section,
.smart-window .smart-content-container.smart-window-resizing-top-left,
.smart-window .smart-content-container.smart-window-resizing-top-left>.smart-header-section {
    cursor: se-resize
}

.smart-window .smart-content-container.smart-window-resizing-bottom-left,
.smart-window .smart-content-container.smart-window-resizing-bottom-left>.smart-header-section,
.smart-window .smart-content-container.smart-window-resizing-top-right,
.smart-window .smart-content-container.smart-window-resizing-top-right>.smart-header-section {
    cursor: sw-resize
}

.smart-window .smart-header-section>.smart-buttons-container button:after {
    align-items: center;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-window-header-icon-size);
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%
}

.smart-window.smart-tabs-window .smart-content-container>.smart-footer.smart-hidden,
.smart-window.smart-tabs-window .smart-content-container>.smart-header-section.smart-hidden,
.smart-window.smart-tabs-window[auto-hide] .smart-content-container>.smart-header-section,
.smart-window.smart-tabs-window[auto-hide] .smart-tabs-content-section,
.smart-window[header-position=none] .smart-content-container>.smart-header-section {
    display: none
}

.smart-window .smart-header-section>.smart-buttons-container button:first-of-type {
    margin-left: 0
}

.smart-window .smart-header-section>.smart-buttons-container button:last-of-type {
    margin-right: 0
}

.smart-window .smart-header-section>.smart-buttons-container button.hover {
    background-color: transparent;
    background-color: initial;
    color: #000;
    color: initial
}

.smart-window .smart-header-section .smart-close-button {
    /*content: "\\1F5D9";
    content: var(--smart-icon-close)*/
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9klEQVR4nO3Uy0vDQBDH8Q8SfIBetYgefCHqUXyApIKIf4YnzyoiGFofJ8E/WwITqCW22yaIh/5gWJbMzHdmZ7PM9F/VwQuKWEdZEbaemnwTX1jDJY7H2BIW8ImtFEA/OriesOsMbymOvah8GvVTnfKB/RyOavxWoupKWRPAI05qLkG5VtqfFiCG+BCQMukTdvzURRNABbmPboaTi2vaCNCJykvAac33vAlgNZLvYj6O66wtQIaPoWNZxDM22upgOSEuGdD7ZQatAV6xjcMU54F/YC9ix+ocdxGUx5s0ykqfA9yim1rRVQy2SHyu33EzQccz/aG+AYMPK7c7yNMTAAAAAElFTkSuQmCC) !important;
background-repeat: no-repeat !important;
background-position: center !important
}

.smart-window .smart-header-section .smart-collapse-button:after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down)
}

.smart-window .smart-header-section .smart-maximize-button {
   /* content: "\\1F5D6";
    content: var(--smart-icon-window-maximize)*/
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAoUlEQVR4nO2UQQqDMBBFH/UWpat2YaBddR8w6A16C2vXhXr5MjCCdONXCQj1w4cs/uTNkDCwa4sqgBfQA2/Rlu28dlJ2eeVuJlwDB6+7AU8FYN2khdP3aij6OQBX4AicvcvfKcIaQBTycQ3gIbyDZUyX3BOUuQGn3IB7bkD8T0AQvmlYArA9NFdJBXQeTkL3g4d8qwAKh3xmrut2tFl3bUhfDwYwFN0LLGkAAAAASUVORK5CYII=) !important;
background-repeat: no-repeat !important;
background-position: center !important

}

.smart-window .smart-header-section .smart-pin-button:after {
    content: "\\e80a";
    content: var(--smart-icon-window-pin)
}

.smart-window .smart-header-section .smart-minimize-button:after {
    content: "\\f2d1";
    content: var(--smart-icon-window-minimize)
}

.smart-window:focus,
.smart-window[focus] {
    border-color: #005c99;
    border-color: var(--smart-primary);
    box-shadow: 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12), 0 11px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-24);
    outline: 0
}

.smart-window:focus .smart-content-container>.smart-header-section,
.smart-window[focus] .smart-content-container>.smart-header-section {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-window[ontop] {
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-window:not([animation=none]) {
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .25s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .6, 1), left .2s cubic-bezier(.4, 0, .6, 1), visibility .2s cubic-bezier(.4, 0, .2, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .2, 1);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .25s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .6, 1), left .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .2, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .25s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .6, 1), left .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .2, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-window:not([animation=none]) .smart-header-section .smart-collapse-button:after,
.smart-window:not([animation=none]) .smart-header-section .smart-pin-button:after {
    transition: -webkit-transform .15s linear;
    transition: transform .15s linear;
    transition: transform .15s linear, -webkit-transform .15s linear
}

.smart-window:not([animation=none]).no-transition,
.smart-window:not([animation=none]).no-transition.smart-visibility-hidden {
    transition: none
}

.smart-window:not([animation=none]).smart-visibility-hidden,
.smart-window:not([animation=none]).smart-visibility-hidden[maximized] {
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .6, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), transform .2s cubic-bezier(.4, 0, .6, 1), min-height .25s cubic-bezier(.4, 0, .2, 1), min-width .25s cubic-bezier(.4, 0, .2, 1), opacity .25s cubic-bezier(.4, 0, .2, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-window:not([animation=none])[dragged] {
    opacity: .5;
    transition: none;
    z-index: 10000;
    z-index: calc(1 + var(--smart-editor-drop-down-z-index))
}

.smart-window:not([animation=none])[minimized] {
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), animation .2s cubic-bezier(.4, 0, .6);
    transition: width .2s cubic-bezier(.4, 0, .2, 1), height .2s cubic-bezier(.4, 0, .2, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), animation .2s cubic-bezier(.4, 0, .6), -webkit-animation .2s cubic-bezier(.4, 0, .6)
}

.smart-window.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-window.smart-tabs-window[collapsed][header-position=left],
.smart-window.smart-tabs-window[collapsed][header-position=right],
.smart-window.smart-tabs-window[maximized][collapsed][header-position=left],
.smart-window.smart-tabs-window[maximized][collapsed][header-position=right] {
    height: 450px;
    height: var(--smart-window-default-height);
    min-width: 0;
    min-width: auto;
    width: 48px;
    width: var(--smart-window-header-height)
}

.smart-window.smart-tabs-window[dragged] {
    pointer-events: none
}

.smart-window.smart-tabs-window[dragged] .smart-tab-label-container,
.smart-window.smart-tabs-window[dragged] .smart-tabs-header-section {
    cursor: move
}

.smart-window.smart-tabs-window .smart-content-container>.smart-content {
    background-color: #fefefe;
    background-color: var(--smart-background);
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-window-header-height));
    overflow: hidden;
    padding: 0;
    width: 100%
}

.smart-window.smart-tabs-window[active] .smart-content-container>.smart-header-section,
.smart-window.smart-tabs-window[dragged] .smart-content-container>.smart-header-section,
.smart-window.smart-tabs-window[focus] .smart-content-container>.smart-header-section,
.smart-window[active] .smart-content-container>.smart-header-section,
.smart-window[dragged] .smart-content-container>.smart-header-section {
    background-color: #005c99;
    background-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-window.smart-tabs-window smart-tabs {
    border: initial;
    height: 250px;
    min-height: 100%;
    outline: 0;
    padding: 0;
    width: 100%
}

.smart-window.smart-tabs-window smart-tabs .smart-tabs-header-items {
    width: 100%
}

.smart-window.smart-tabs-window smart-tabs[vertical] .smart-tabs-header-items {
    height: 100%;
    width: auto
}

.smart-window.smart-tabs-window .smart-tabs .smart-header {
    border: none
}

.smart-window.smart-tabs-window .smart-tabs-content-section {
    border: none;
    margin: initial
}

.smart-window.smart-tabs-window[auto-hide] {
    height: auto;
    min-height: 0;
    overflow: visible
}

.smart-window.smart-tabs-window[auto-hide] .smart-tabs {
    height: auto;
    min-height: 0;
    min-width: 0
}

.smart-window.smart-tabs-window[auto-hide] .smart-content-container>.smart-content {
    overflow: visible
}

.smart-window.smart-tabs-window[auto-hide] .smart-window {
    height: auto;
    width: auto
}

.smart-window.smart-tabs-window[auto-hide][tab-position=left],
.smart-window.smart-tabs-window[auto-hide][tab-position=left] smart-tabs,
.smart-window.smart-tabs-window[auto-hide][tab-position=right],
.smart-window.smart-tabs-window[auto-hide][tab-position=right] smart-tabs,
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=horizontal][tab-position=left],
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=horizontal][tab-position=left] smart-tabs,
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=horizontal][tab-position=right],
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=horizontal][tab-position=right] smart-tab,
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=vertical][tab-position=left],
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=vertical][tab-position=left] smart-tabs,
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=vertical][tab-position=right],
.smart-window.smart-tabs-window[auto-hide][tab-text-orientation=vertical][tab-position=right] smart-tabs {
    min-width: 0;
    width: auto
}

.smart-window.smart-tabs-window[tab-position=hidden] .smart-content-container>.smart-content {
    height: 100%
}

.smart-window[collapsed],
.smart-window[collapsed].smart-window-snapped-left,
.smart-window[collapsed].smart-window-snapped-right,
.smart-window[collapsed].smart-window-snapped-top,
.smart-window[collapsed][header-position=bottom].smart-window-snapped-left,
.smart-window[collapsed][header-position=bottom].smart-window-snapped-right,
.smart-window[collapsed][header-position=bottom].smart-window-snapped-top,
.smart-window[collapsed][header-position=top].smart-window-snapped-left,
.smart-window[collapsed][header-position=top].smart-window-snapped-right,
.smart-window[collapsed][header-position=top].smart-window-snapped-top {
    height: 48px;
    height: var(--smart-window-header-height)
}

.smart-window.smart-tabs-window smart-tab-item {
    padding: 5px;
    -ms-user-select: text;
    user-select: text;
    -webkit-user-select: text
}

.smart-window[minimized] {
    cursor: default;
    max-width: 250px;
    max-width: var(--smart-window-min-width);
    min-height: 48px;
    min-height: var(--smart-window-header-height)
}

.smart-window[minimized] .smart-content-container>.smart-header-section {
    cursor: default
}

.smart-window[minimized] .smart-content-container>.smart-content {
    padding: initial
}

.smart-window[minimized] .smart-minimize-button:after {
    content: "\\e817";
    content: var(--smart-icon-arrow-up-alt);
    margin-top: -1px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
}

.smart-window.smart-progress-window.smart-visibility-hidden smart-progress-bar,
.smart-window[maximized].smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-window[maximized] .smart-content-container>.smart-header-section {
    cursor: auto
}

.smart-window.smart-wait-window .smart-content-container>.smart-header-section,
.smart-window[pinned] .smart-content-container>.smart-header-section {
    cursor: default
}

.smart-window[maximized] .smart-header-section .smart-maximize-button {
    /*content: "\\f2d2";
    content: var(--smart-icon-window-restore);
    font-size: 100%*/
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEUlEQVR4nO3Uu0pDQRDG8R9YaGwkBIygoKjgrUgRsBASIaaw0lYfQiwEL8SAeAGtrBTB1/ABJTDI4TS7J2ks8sHHHs7O7H92dlmm+s/awDtuKvgR57mAO9TwgB5O8JaRd58LGKKf6RZWsYyPXMAgN7BK3mn08RVfMab8HC1sYzcFGAU3cRk+wlmi4llcxXcnBfiMnh6H+4Vx5EMsRKXb2Ir/w1zApH3v5ADmUS95LuYPovp2wQ18x072cgBrpQXaWIn5briobgGQPORBBJXv+WYCUFw0CVjEesmNTMAMXsY5g1phsf3S7pbwE2/RbRQ0UYtapbl6lduXCtwZM+9PT6qriYvc4FbhLcr1dZzbVMbSLxHNPrkA9N7sAAAAAElFTkSuQmCC) !important;
background-repeat: no-repeat !important;
background-position: center !important
}

.smart-window[collapsed] .smart-content-container.smart-window-resizing-bottom-left,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-bottom-left>.smart-header-section,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-bottom-right,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-bottom-right>.smart-header-section,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-top-left,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-top-left>.smart-header-section,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-top-right,
.smart-window[collapsed] .smart-content-container.smart-window-resizing-top-right>.smart-header-section,
.smart-window[disabled] .smart-header-section>.smart-buttons-container button {
    cursor: auto
}

.smart-window[pinned] .smart-header-section .smart-pin-button:after {
    content: "\\e80a";
    content: var(--smart-icon-window-pin);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
}

.smart-window[collapsed] .smart-header-section .smart-collapse-button:after {
    -webkit-transform: rotate(180deg) translateY(1px);
    transform: rotate(180deg) translateY(1px)
}

.smart-window[collapsed][header-position=left] .smart-content-container>.smart-footer,
.smart-window[collapsed][header-position=left] .smart-content-container>.smart-header-section,
.smart-window[collapsed][header-position=right] .smart-content-container>.smart-footer,
.smart-window[collapsed][header-position=right] .smart-content-container>.smart-header-section {
    min-width: 48px;
    min-width: var(--smart-window-header-height)
}

.smart-window[collapsed][header-position=left].smart-window-snapped-left,
.smart-window[collapsed][header-position=left].smart-window-snapped-right,
.smart-window[collapsed][header-position=left].smart-window-snapped-top,
.smart-window[collapsed][header-position=right].smart-window-snapped-left,
.smart-window[collapsed][header-position=right].smart-window-snapped-right,
.smart-window[collapsed][header-position=right].smart-window-snapped-top {
    height: 100%;
    min-width: 0;
    min-width: auto;
    width: 48px;
    width: var(--smart-window-header-height)
}

.smart-window[collapsed][maximized] {
    height: 48px;
    height: var(--smart-window-header-height)
}

.smart-window[resize-indicator] .smart-content-container:after,
.smart-window[resize-indicator] .smart-content-container:before {
    content: "\\e804";
    content: var(--smart-icon-minus);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    height: 10px;
    position: absolute;
    width: 10px
}

.smart-window[collapsed][maximized][header-position=left] .smart-content-container>.smart-footer,
.smart-window[collapsed][maximized][header-position=left] .smart-content-container>.smart-header-section,
.smart-window[collapsed][maximized][header-position=right] .smart-content-container>.smart-footer,
.smart-window[collapsed][maximized][header-position=right] .smart-content-container>.smart-header-section {
    min-width: 48px;
    min-width: var(--smart-window-header-height)
}

.smart-window[dragged] {
    opacity: .5;
    transition: none;
    z-index: 10000;
    z-index: calc(1 + var(--smart-editor-drop-down-z-index))
}

.smart-window[dragged] .smart-content-container,
.smart-window[resized] .smart-content-container {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none
}

.smart-window[resize-indicator] .smart-content-container:before {
    left: calc(100% - 10px);
    top: calc(100% - 13px);
    -webkit-transform: rotate(-45deg) scaleX(2);
    transform: rotate(-45deg) scaleX(2)
}

.smart-window[resize-indicator] .smart-content-container:after {
    left: calc(100% - 8px);
    top: calc(100% - 9px);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
}

.smart-window[resize-indicator][resize-mode=left] .smart-content-container:before,
.smart-window[resize-indicator][resize-mode=top] .smart-content-container:before {
    left: 5px;
    top: 0
}

.smart-window[resize-indicator][resize-mode=left] .smart-content-container:after,
.smart-window[resize-indicator][resize-mode=top] .smart-content-container:after {
    left: 5px;
    top: 4px
}

.smart-window[resize-indicator][collapsed] .smart-content-container:after,
.smart-window[resize-indicator][collapsed] .smart-content-container:before {
    content: ""
}

.smart-window[header-position=none] .smart-content-container>.smart-content {
    height: 100%
}

.smart-window[header-position=bottom] .smart-content-container {
    flex-direction: column-reverse
}

.smart-window[header-position=left] .smart-content-container {
    flex-direction: row
}

.smart-window[header-position=left] .smart-content-container .smart-header-section {
    flex-direction: column
}

.smart-window[header-position=left] .smart-content-container .smart-header-section .smart-collapse-button:after {
    -webkit-transform: rotate(275deg) translateY(1px);
    transform: rotate(275deg) translateY(1px)
}

.smart-window[header-position=left][collapsed] .smart-content-container .smart-header-section .smart-collapse-button:after,
.smart-window[header-position=right] .smart-content-container .smart-header-section .smart-collapse-button:after {
    -webkit-transform: rotate(90deg) translateY(1px);
    transform: rotate(90deg) translateY(1px)
}

.smart-window[header-position=left] .smart-content-container .smart-header-section>.smart-header {
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-window[header-position=left] .smart-content-container>.smart-footer,
.smart-window[header-position=left] .smart-content-container>.smart-header-section {
    height: 100%;
    min-width: 48px;
    min-width: var(--smart-window-header-height);
    width: 48px;
    width: var(--smart-window-header-height)
}

.smart-window[header-position=right] .smart-content-container {
    flex-direction: row-reverse
}

.smart-window[header-position=right] .smart-content-container .smart-header-section {
    flex-direction: column
}

.smart-window[header-position=right] .smart-content-container .smart-header-section>.smart-header {
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-window[header-position=right] .smart-content-container>.smart-footer,
.smart-window[header-position=right] .smart-content-container>.smart-header-section {
    height: 100%;
    min-width: 48px;
    min-width: var(--smart-window-header-height);
    width: 48px;
    width: var(--smart-window-header-height)
}

.smart-window[header-position=right][collapsed] .smart-content-container .smart-header-section .smart-collapse-button:after {
    -webkit-transform: rotate(275deg) translateY(1px);
    transform: rotate(275deg) translateY(1px)
}

.smart-window[header-position=left],
.smart-window[header-position=right] {
    min-height: 250px;
    min-height: var(--smart-window-min-width);
    min-width: 48px;
    min-width: var(--smart-window-header-height)
}

.smart-window[header-position=left].smart-window-snapped-left,
.smart-window[header-position=left].smart-window-snapped-right,
.smart-window[header-position=right].smart-window-snapped-left,
.smart-window[header-position=right].smart-window-snapped-right {
    height: 100%;
    width: 50%
}

.smart-window[header-position=left].smart-window-snapped-top,
.smart-window[header-position=right].smart-window-snapped-top {
    height: 100%;
    width: 100%
}

.smart-window[header-position=left][minimized],
.smart-window[header-position=right][minimized] {
    max-width: 48px;
    max-width: var(--smart-window-header-height)
}

.smart-window[header-position=left] .smart-content-container>.smart-content,
.smart-window[header-position=right] .smart-content-container>.smart-content {
    height: 100%
}

.smart-window[header-position=left] .smart-content-container>.smart-header-section .smart-buttons-container,
.smart-window[header-position=right] .smart-content-container>.smart-header-section .smart-buttons-container {
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center
}

.smart-window.smart-alert-window .smart-cancel-button,
.smart-window[footer-position=none] .smart-content-container>.smart-footer {
    display: none
}

.smart-window[header-position=left] .smart-content-container>.smart-header-section .smart-buttons-container button,
.smart-window[header-position=right] .smart-content-container>.smart-header-section .smart-buttons-container button {
    margin-left: 0;
    margin-top: 1px
}

.smart-window[header-position=left] .smart-content-container>.smart-header-section .smart-buttons-container button:first-of-type,
.smart-window[header-position=right] .smart-content-container>.smart-header-section .smart-buttons-container button:first-of-type {
    margin-top: 0
}

.smart-window[footer-template] .smart-content-container>.smart-content {
    height: calc(100% - 96px);
    height: calc(100% - var(--smart-window-header-height) - var(--smart-window-footer-height))
}

.smart-window[footer-template=null] .smart-content-container>.smart-content {
    height: calc(100% - 48px);
    height: calc(100% - var(--smart-window-header-height))
}

.smart-window.smart-window-snapped-left,
.smart-window.smart-window-snapped-right,
.smart-window.smart-window-snapped-top {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: none;
    height: 100%;
    z-index: 9999
}

.smart-window.smart-window-snapped-left[ontop],
.smart-window.smart-window-snapped-right[ontop],
.smart-window.smart-window-snapped-top[ontop] {
    box-shadow: none;
    z-index: 10000
}

.smart-window.smart-window-snapped-left,
.smart-window.smart-window-snapped-right {
    width: 50%
}

.smart-window.smart-window-snapped-top {
    width: 100%
}

.smart-window.smart-alert-window .smart-content-container>.smart-footer .smart-button,
.smart-window.smart-dialog-window .smart-content-container>.smart-footer .smart-button,
.smart-window.smart-multiline-prompt-window .smart-content-container>.smart-footer .smart-button,
.smart-window.smart-progress-window .smart-content-container>.smart-footer .smart-button,
.smart-window.smart-prompt-window .smart-content-container>.smart-footer .smart-button {
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: 1px;
    cursor: pointer;
    font-weight: 500;
    height: 100%;
    letter-spacing: .08929em;
    overflow: hidden;
    text-align: center;
    text-transform: uppercase;
    text-transform: var(--smart-button-text-transform);
    vertical-align: middle;
    width: 100px;
    width: var(--smart-window-footer-button-width)
}

.smart-window.smart-alert-window,
.smart-window.smart-dialog-window,
.smart-window.smart-prompt-window {
    left: calc(50% - 225px);
    left: calc(50% - var(--smart-window-default-width)/2);
    top: calc(50% - 225px);
    top: calc(50% - var(--smart-window-default-height)/2);
    width: 450px;
    width: var(--smart-window-default-width)
}

.smart-window.smart-alert-window,
.smart-window.smart-alert-window[collapsed][header-position=left],
.smart-window.smart-alert-window[collapsed][header-position=right],
.smart-window.smart-alert-window[collapsed][maximized][header-position=left],
.smart-window.smart-alert-window[collapsed][maximized][header-position=right],
.smart-window.smart-dialog-window,
.smart-window.smart-dialog-window[collapsed][header-position=left],
.smart-window.smart-dialog-window[collapsed][header-position=right],
.smart-window.smart-dialog-window[collapsed][maximized][header-position=left],
.smart-window.smart-dialog-window[collapsed][maximized][header-position=right],
.smart-window.smart-multiline-prompt-window,
.smart-window.smart-multiline-prompt-window[collapsed][header-position=left],
.smart-window.smart-multiline-prompt-window[collapsed][header-position=right],
.smart-window.smart-multiline-prompt-window[collapsed][maximized][header-position=left],
.smart-window.smart-multiline-prompt-window[collapsed][maximized][header-position=right],
.smart-window.smart-progress-window,
.smart-window.smart-prompt-window,
.smart-window.smart-prompt-window[collapsed][header-position=left],
.smart-window.smart-prompt-window[collapsed][header-position=right],
.smart-window.smart-prompt-window[collapsed][maximized][header-position=left],
.smart-window.smart-prompt-window[collapsed][maximized][header-position=right] {
    height: 450px;
    height: var(--smart-window-default-height)
}

.smart-window.smart-alert-window .smart-content-container>.smart-footer .smart-button:focus,
.smart-window.smart-dialog-window .smart-content-container>.smart-footer .smart-button:focus,
.smart-window.smart-multiline-prompt-window .smart-content-container>.smart-footer .smart-button:focus,
.smart-window.smart-progress-window .smart-content-container>.smart-footer .smart-button:focus,
.smart-window.smart-prompt-window .smart-content-container>.smart-footer .smart-button:focus {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus);
    opacity: var(--smart-button-opacity-focus)
}

.smart-window.smart-progress-window .smart-content-container>.smart-footer smart-progress-bar>.smart-container,
.smart-window.smart-progress-window smart-progress-bar .smart-value {
    border: initial
}

.smart-window.smart-alert-window .smart-content-container>.smart-footer button:first-child,
.smart-window.smart-dialog-window .smart-content-container>.smart-footer button:first-child {
    margin-right: 10px
}

.smart-window.smart-prompt-window .smart-content-container>.smart-content {
    align-items: flex-start;
    flex-direction: column-reverse
}

.smart-window.smart-prompt-window .smart-content-container>.smart-footer button:first-child {
    margin-right: 10px
}

.smart-window.smart-prompt-window smart-text-box {
    margin-top: 5px;
    width: 100%
}

.smart-window.smart-multiline-prompt-window {
    left: calc(50% - 225px);
    left: calc(50% - var(--smart-window-default-width)/2);
    top: calc(50% - 225px);
    top: calc(50% - var(--smart-window-default-height)/2);
    width: 450px;
    width: var(--smart-window-default-width)
}

.smart-window.smart-multiline-prompt-window smart-multiline-text-box {
    margin-top: 5px;
    width: 100%
}

.smart-window.smart-multiline-prompt-window .smart-content-container>.smart-content {
    align-items: flex-start;
    flex-direction: column-reverse
}

.smart-window.smart-multiline-prompt-window .smart-content-container>.smart-footer button:first-child {
    margin-right: 10px
}

.smart-window.smart-progress-window {
    left: calc(50% - 225px);
    left: calc(50% - var(--smart-window-default-width)/2);
    top: calc(50% - 225px);
    top: calc(50% - var(--smart-window-default-height)/2);
    width: 450px;
    width: var(--smart-window-default-width)
}

.smart-window.smart-progress-window smart-progress-bar.smart-visibility-hidden {
    transition: none
}

.smart-window.smart-progress-window .smart-content-container>.smart-content {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none
}

.smart-window.smart-progress-window .smart-content-container>.smart-footer smart-progress-bar {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    box-shadow: none;
    height: 100%;
    transition: opacity .25s ease-in, visibility .25s cubic-bezier(0, 0, .2, 1);
    width: 100%
}

.smart-window.smart-progress-window .smart-content-container>.smart-footer smart-progress-bar.smart-visibility-hidden {
    opacity: .5;
    transition: opacity .25s ease-out, visibility .25s cubic-bezier(0, 0, .2, 1)
}

.smart-window.smart-progress-window .smart-content-container>.smart-footer button.smart-button {
    background-color: hsla(0, 0%, 88%, .5);
    height: calc(100% - 13px);
    left: 6.5px;
    position: absolute;
    text-align: center;
    top: 6.5px;
    width: calc(100% - 13px)
}

.smart-window.smart-progress-window[collapsed][header-position=left],
.smart-window.smart-progress-window[collapsed][header-position=right],
.smart-window.smart-progress-window[collapsed][maximized][header-position=left],
.smart-window.smart-progress-window[collapsed][maximized][header-position=right],
.smart-window.smart-wait-window {
    height: 450px;
    height: var(--smart-window-default-height)
}

.smart-window.smart-progress-window .smart-content-container>.smart-footer button.smart-button.smart-visibility-hidden {
    top: 100%
}

.smart-window.smart-progress-window:not([animation=none]) .smart-content-container>.smart-footer button,
.smart-window.smart-progress-window:not([animation=none]) .smart-content-container>.smart-footer button.smart-visibility-hidden {
    transition: top .25s cubic-bezier(0, 0, .2, 1), visibility .25s cubic-bezier(0, 0, .2, 1)
}

.smart-window.smart-wait-window {
    left: calc(50% - 225px);
    left: calc(50% - var(--smart-window-default-width)/2);
    top: calc(50% - 225px);
    top: calc(50% - var(--smart-window-default-height)/2);
    width: 450px;
    width: var(--smart-window-default-width)
}

.smart-window.smart-wait-window .smart-content-container>.smart-content smart-progress-bar {
    height: 75%;
    width: 100%
}

.smart-window.smart-wait-window[collapsed][header-position=left],
.smart-window.smart-wait-window[collapsed][header-position=right],
.smart-window.smart-wait-window[collapsed][maximized][header-position=left],
.smart-window.smart-wait-window[collapsed][maximized][header-position=right] {
    height: 450px;
    height: var(--smart-window-default-height)
}

smart-window.smart-window[collapsed][header-position=left],
smart-window.smart-window[collapsed][header-position=right],
smart-window.smart-window[collapsed][maximized][header-position=left],
smart-window.smart-window[collapsed][maximized][header-position=right] {
    height: 450px;
    height: var(--smart-window-default-height);
    min-width: 0;
    min-width: auto;
    width: 48px;
    width: var(--smart-window-header-height)
}

.smart-modal {
    background-color: #ccc;
    background-color: var(--smart-disabled);
    left: 0;
    min-height: 100%;
    opacity: .5;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-window-resize-feedback {
    border: 2.5px solid #000;
    box-sizing: border-box;
    pointer-events: none;
    position: absolute;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    z-index: 10000
}

smart-docking-layout .smart-window-resize-feedback {
    border: 2.5px solid #d3d3d3
}

.smart-window-snap-bottom-feedback,
.smart-window-snap-left-feedback,
.smart-window-snap-right-feedback,
.smart-window-snap-top-feedback {
    -webkit-animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    animation: scaleIn .2s cubic-bezier(.4, 0, .2, 1);
    border-radius: 2px;
    bottom: 5px;
    box-shadow: 0 0 1px 1px #8a8a8a;
    height: calc(100% - 10px);
    opacity: .65;
    pointer-events: none;
    position: absolute;
    top: 5px;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: all 50ms cubic-bezier(.4, 0, .6, 1)
}

.smart-window-snap-bottom-feedback.smart-visibility-hidden,
.smart-window-snap-left-feedback.smart-visibility-hidden,
.smart-window-snap-right-feedback.smart-visibility-hidden,
.smart-window-snap-top-feedback.smart-visibility-hidden {
    -webkit-animation: scaleOut .2s cubic-bezier(.4, 0, .6, 1);
    animation: scaleOut .2s cubic-bezier(.4, 0, .6, 1);
    -webkit-transform: scale(0);
    transform: scale(0);
    transition: visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1);
    transition: animation .2s cubic-bezier(.4, 0, .6, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1);
    transition: animation .2s cubic-bezier(.4, 0, .6, 1), visibility .2s cubic-bezier(.4, 0, .6, 1), top .2s cubic-bezier(.4, 0, .2, 1), left .2s cubic-bezier(.4, 0, .2, 1), -webkit-animation .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-window-snap-right-feedback {
    left: calc(50% - 5px);
    -webkit-transform-origin: right;
    transform-origin: right;
    width: 50%
}

.smart-window-snap-left-feedback {
    left: 5px;
    -webkit-transform-origin: left;
    transform-origin: left;
    width: 50%
}

.smart-window-snap-bottom-feedback,
.smart-window-snap-top-feedback {
    left: 5px;
    -webkit-transform-origin: top;
    transform-origin: top;
    width: calc(100% - 10px)
}

@-webkit-keyframes scaleIn {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}

@keyframes scaleIn {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}

@-webkit-keyframes scaleOut {
    0% {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        -webkit-transform: scale(0);
        transform: scale(0)
    }
}

@keyframes scaleOut {
    0% {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        -webkit-transform: scale(0);
        transform: scale(0)
    }
}

@-webkit-keyframes scaleInRight {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}

@keyframes scaleInRight {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0)
    }

    50% {
        opacity: .5;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }

    to {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}

.smart-window[right-to-left] .smart-content-container>.smart-content,
.smart-window[right-to-left] .smart-content-container>.smart-footer,
.smart-window[right-to-left] .smart-content-container>.smart-header-section {
    direction: rtl
}

.smart-window[right-to-left][header-position=left] .smart-header-section>.smart-header,
.smart-window[right-to-left][header-position=right] .smart-header-section>.smart-header {
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl
}

.smart-window[right-to-left].smart-alert-window .smart-content-container>.smart-footer button:first-child,
.smart-window[right-to-left].smart-dialog-window .smart-content-container>.smart-footer button:first-child,
.smart-window[right-to-left].smart-multiline-prompt-window .smart-content-container>.smart-footer button:first-child,
.smart-window[right-to-left].smart-prompt-window .smart-content-container>.smart-footer button:first-child {
    margin-left: 10px;
    margin-right: 0
}

.smart-tabs-window[right-to-left] .smart-content-container>.smart-content {
    direction: ltr
}

.smart-grid-layout .col,
.smart-grid-layout .col-1,
.smart-grid-layout .col-10,
.smart-grid-layout .col-11,
.smart-grid-layout .col-12,
.smart-grid-layout .col-2,
.smart-grid-layout .col-3,
.smart-grid-layout .col-4,
.smart-grid-layout .col-5,
.smart-grid-layout .col-6,
.smart-grid-layout .col-7,
.smart-grid-layout .col-8,
.smart-grid-layout .col-9,
.smart-grid-layout .col-lg,
.smart-grid-layout .col-lg-1,
.smart-grid-layout .col-lg-10,
.smart-grid-layout .col-lg-11,
.smart-grid-layout .col-lg-12,
.smart-grid-layout .col-lg-2,
.smart-grid-layout .col-lg-3,
.smart-grid-layout .col-lg-4,
.smart-grid-layout .col-lg-5,
.smart-grid-layout .col-lg-6,
.smart-grid-layout .col-lg-7,
.smart-grid-layout .col-lg-8,
.smart-grid-layout .col-lg-9,
.smart-grid-layout .col-md,
.smart-grid-layout .col-md-1,
.smart-grid-layout .col-md-10,
.smart-grid-layout .col-md-11,
.smart-grid-layout .col-md-12,
.smart-grid-layout .col-md-2,
.smart-grid-layout .col-md-3,
.smart-grid-layout .col-md-4,
.smart-grid-layout .col-md-5,
.smart-grid-layout .col-md-6,
.smart-grid-layout .col-md-7,
.smart-grid-layout .col-md-8,
.smart-grid-layout .col-md-9,
.smart-grid-layout .col-sm,
.smart-grid-layout .col-sm-1,
.smart-grid-layout .col-sm-10,
.smart-grid-layout .col-sm-11,
.smart-grid-layout .col-sm-12,
.smart-grid-layout .col-sm-2,
.smart-grid-layout .col-sm-3,
.smart-grid-layout .col-sm-4,
.smart-grid-layout .col-sm-5,
.smart-grid-layout .col-sm-6,
.smart-grid-layout .col-sm-7,
.smart-grid-layout .col-sm-8,
.smart-grid-layout .col-sm-9,
.smart-grid-layout .col-xl,
.smart-grid-layout .col-xl-1,
.smart-grid-layout .col-xl-10,
.smart-grid-layout .col-xl-11,
.smart-grid-layout .col-xl-12,
.smart-grid-layout .col-xl-2,
.smart-grid-layout .col-xl-3,
.smart-grid-layout .col-xl-4,
.smart-grid-layout .col-xl-5,
.smart-grid-layout .col-xl-6,
.smart-grid-layout .col-xl-7,
.smart-grid-layout .col-xl-8,
.smart-grid-layout .col-xl-9 {
    box-sizing: border-box;
    grid-column: span 12;
    min-height: 1px;
    padding: 15px;
    position: relative;
    width: 100%
}

.smart-grid-layout,
.smart-grid-layout .row {
    grid-gap: 10px;
    grid-gap: var(--smart-grid-layout-row-gap);
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-grid-layout-col-gap);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    width: 100%;
    width: var(--smart-grid-layout-width)
}

.smart-grid-layout {
    grid-template-rows: none;
    grid-template-rows: var(--smart-grid-layout-rows);
    padding: 0
}

.smart-grid-layout .row {
    grid-column: span 12;
    margin-left: auto;
    margin-right: auto
}

.smart-grid-layout.no-gaps,
.smart-grid-layout.no-gaps .row {
    --smart-grid-row-gap: 0px;
    --smart-grid-column-gap: 0px;
    grid-columns-gap: 0;
    grid-gap: 0
}

.smart-grid-layout .order-0 {
    order: -1
}

.smart-grid-layout .order-1 {
    order: 0
}

.smart-grid-layout .order-2 {
    order: 1
}

.smart-grid-layout .order-3 {
    order: 2
}

.smart-grid-layout .order-4 {
    order: 3
}

.smart-grid-layout .order-5 {
    order: 4
}

.smart-grid-layout .order-6 {
    order: 5
}

.smart-grid-layout .order-7 {
    order: 6
}

.smart-grid-layout .order-8 {
    order: 7
}

.smart-grid-layout .order-9 {
    order: 8
}

.smart-grid-layout .order-10 {
    order: 9
}

.smart-grid-layout .order-11 {
    order: 10
}

.smart-grid-layout .order-12 {
    order: 11
}

.smart-grid-layout [span="1"] {
    grid-row: span 1
}

.smart-grid-layout [span="2"] {
    grid-row: span 2
}

.smart-grid-layout [span="3"] {
    grid-row: span 3
}

.smart-grid-layout [span="4"] {
    grid-row: span 4
}

.smart-grid-layout [span="5"] {
    grid-row: span 5
}

.smart-grid-layout [span="6"] {
    grid-row: span 6
}

.smart-grid-layout [span="7"] {
    grid-row: span 7
}

.smart-grid-layout [span="8"] {
    grid-row: span 8
}

.smart-grid-layout [span="9"] {
    grid-row: span 9
}

.smart-grid-layout [span="10"] {
    grid-row: span 10
}

.smart-grid-layout [span="11"] {
    grid-row: span 11
}

.smart-grid-layout [span="12"] {
    grid-row: span 12
}

.smart-grid-layout .col-1 {
    grid-column: span 1
}

.smart-grid-layout .col-2 {
    grid-column: span 2
}

.smart-grid-layout .col-3 {
    grid-column: span 3
}

.smart-grid-layout .col-4 {
    grid-column: span 4
}

.smart-grid-layout .col-5 {
    grid-column: span 5
}

.smart-grid-layout .col-6 {
    grid-column: span 6
}

.smart-grid-layout .col-7 {
    grid-column: span 7
}

.smart-grid-layout .col-8 {
    grid-column: span 8
}

.smart-grid-layout .col-9 {
    grid-column: span 9
}

.smart-grid-layout .col-10 {
    grid-column: span 10
}

.smart-grid-layout .col-11 {
    grid-column: span 11
}

.smart-grid-layout .col-12 {
    grid-column: span 12
}

@media (min-width:576px) {
    .smart-grid-layout.fixed {
        max-width: 540px
    }

    .smart-grid-layout .col-sm-1 {
        grid-column: span 1
    }

    .smart-grid-layout .col-sm-2 {
        grid-column: span 2
    }

    .smart-grid-layout .col-sm-3 {
        grid-column: span 3
    }

    .smart-grid-layout .col-sm-4 {
        grid-column: span 4
    }

    .smart-grid-layout .col-sm-5 {
        grid-column: span 5
    }

    .smart-grid-layout .col-sm-6 {
        grid-column: span 6
    }

    .smart-grid-layout .col-sm-7 {
        grid-column: span 7
    }

    .smart-grid-layout .col-sm-8 {
        grid-column: span 8
    }

    .smart-grid-layout .col-sm-9 {
        grid-column: span 9
    }

    .smart-grid-layout .col-sm-10 {
        grid-column: span 10
    }

    .smart-grid-layout .col-sm-11 {
        grid-column: span 11
    }

    .smart-grid-layout .col-sm-12 {
        grid-column: span 12
    }
}

@media (min-width:768px) {
    .smart-grid-layout.fixed {
        max-width: 720px
    }

    .smart-grid-layout .col-md-1 {
        grid-column: span 1
    }

    .smart-grid-layout .col-md-2 {
        grid-column: span 2
    }

    .smart-grid-layout .col-md-3 {
        grid-column: span 3
    }

    .smart-grid-layout .col-md-4 {
        grid-column: span 4
    }

    .smart-grid-layout .col-md-5 {
        grid-column: span 5
    }

    .smart-grid-layout .col-md-6 {
        grid-column: span 6
    }

    .smart-grid-layout .col-md-7 {
        grid-column: span 7
    }

    .smart-grid-layout .col-md-8 {
        grid-column: span 8
    }

    .smart-grid-layout .col-md-9 {
        grid-column: span 9
    }

    .smart-grid-layout .col-md-10 {
        grid-column: span 10
    }

    .smart-grid-layout .col-md-11 {
        grid-column: span 11
    }

    .smart-grid-layout .col-md-12 {
        grid-column: span 12
    }
}

@media (min-width:992px) {
    .smart-grid-layout.fixed {
        max-width: 960px
    }

    .smart-grid-layout .col-lg-1 {
        grid-column: span 1
    }

    .smart-grid-layout .col-lg-2 {
        grid-column: span 2
    }

    .smart-grid-layout .col-lg-3 {
        grid-column: span 3
    }

    .smart-grid-layout .col-lg-4 {
        grid-column: span 4
    }

    .smart-grid-layout .col-lg-5 {
        grid-column: span 5
    }

    .smart-grid-layout .col-lg-6 {
        grid-column: span 6
    }

    .smart-grid-layout .col-lg-7 {
        grid-column: span 7
    }

    .smart-grid-layout .col-lg-8 {
        grid-column: span 8
    }

    .smart-grid-layout .col-lg-9 {
        grid-column: span 9
    }

    .smart-grid-layout .col-lg-10 {
        grid-column: span 10
    }

    .smart-grid-layout .col-lg-11 {
        grid-column: span 11
    }

    .smart-grid-layout .col-lg-12 {
        grid-column: span 12
    }
}

@media (min-width:1200px) {
    .smart-grid-layout.fixed {
        max-width: 1140px
    }

    .smart-grid-layout .col-xl-1 {
        grid-column: span 1
    }

    .smart-grid-layout .col-xl-2 {
        grid-column: span 2
    }

    .smart-grid-layout .col-xl-3 {
        grid-column: span 3
    }

    .smart-grid-layout .col-xl-4 {
        grid-column: span 4
    }

    .smart-grid-layout .col-xl-5 {
        grid-column: span 5
    }

    .smart-grid-layout .col-xl-6 {
        grid-column: span 6
    }

    .smart-grid-layout .col-xl-7 {
        grid-column: span 7
    }

    .smart-grid-layout .col-xl-8 {
        grid-column: span 8
    }

    .smart-grid-layout .col-xl-9 {
        grid-column: span 9
    }

    .smart-grid-layout .col-xl-10 {
        grid-column: span 10
    }

    .smart-grid-layout .col-xl-11 {
        grid-column: span 11
    }

    .smart-grid-layout .col-xl-12 {
        grid-column: span 12
    }
}

.smart-stack-layout {
    align-items: baseline;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    padding: 15px;
    width: 100%
}

.smart-stack-layout .item {
    border-radius: 0;
    box-shadow: none;
    display: flex;
    min-width: 100px
}

.smart-stack-layout.vertical {
    flex-direction: column
}

.smart-stack-layout:not(.space-around):not(.space-evenly):not(.space-between):not(.vertical) .item:first-child {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-radius);
    border-top-right-radius: 0
}

.smart-stack-layout:not(.space-around):not(.space-evenly):not(.space-between):not(.vertical) .item:last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-radius)
}

.smart-stack-layout:not(.space-around):not(.space-evenly):not(.space-between).vertical .item:first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-radius)
}

.smart-stack-layout:not(.space-around):not(.space-evenly):not(.space-between).vertical .item:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.smart-stack-layout.spacing .item {
    margin: 0 6px
}

.smart-stack-layout.spacing.vertical .item {
    margin: 6px 0
}

.smart-stack-layout.spacing-2 .item {
    margin: 0 12px
}

.smart-stack-layout.spacing-2.vertical .item {
    margin: 12px 0
}

.smart-stack-layout.spacing-3 .item {
    margin: 0 24px
}

.smart-stack-layout.spacing-3.vertical .item {
    margin: 24px 0
}

.smart-stack-layout.spacing-4 .item {
    margin: 0 48px
}

.smart-stack-layout.spacing-4.vertical .item {
    margin: 48px 0
}

.smart-stack-layout.spacing-5 .item {
    margin: 0 64px
}

.smart-stack-layout.spacing-5.vertical .item {
    margin: 64px 0
}

.smart-stack-layout.spacing-6 .item {
    margin: 0 128px
}

.smart-stack-layout.spacing-6.vertical .item {
    margin: 128px 0
}

.smart-stack-layout.spacing-2:not(.vertical) .item:first-child,
.smart-stack-layout.spacing-3:not(.vertical) .item:first-child,
.smart-stack-layout.spacing-4:not(.vertical) .item:first-child,
.smart-stack-layout.spacing-5:not(.vertical) .item:first-child,
.smart-stack-layout.spacing-6:not(.vertical) .item:first-child,
.smart-stack-layout.spacing:not(.vertical) .item:first-child {
    margin-left: 0
}

.smart-stack-layout.spacing-2:not(.vertical) .item:last-child,
.smart-stack-layout.spacing-3:not(.vertical) .item:last-child,
.smart-stack-layout.spacing-4:not(.vertical) .item:last-child,
.smart-stack-layout.spacing-5:not(.vertical) .item:last-child,
.smart-stack-layout.spacing-6:not(.vertical) .item:last-child,
.smart-stack-layout.spacing:not(.vertical) .item:last-child {
    margin-right: 0
}

.smart-stack-layout.spacing-2.vertical .item:first-child,
.smart-stack-layout.spacing-3.vertical .item:first-child,
.smart-stack-layout.spacing-4.vertical .item:first-child,
.smart-stack-layout.spacing-5.vertical .item:first-child,
.smart-stack-layout.spacing-6.vertical .item:first-child,
.smart-stack-layout.spacing.vertical .item:first-child {
    margin-top: 0
}

.smart-stack-layout.spacing-2.vertical .item:last-child,
.smart-stack-layout.spacing-3.vertical .item:last-child,
.smart-stack-layout.spacing-4.vertical .item:last-child,
.smart-stack-layout.spacing-5.vertical .item:last-child,
.smart-stack-layout.spacing-6.vertical .item:last-child,
.smart-stack-layout.spacing.vertical .item:last-child {
    margin-bottom: 0
}

.smart-stack-layout .top,
.smart-stack-layout:not(.vertical).top {
    align-items: flex-start
}

.smart-stack-layout .right,
.smart-stack-layout:not(.vertical).right {
    justify-content: flex-end
}

.smart-stack-layout .bottom,
.smart-stack-layout:not(.vertical).bottom {
    align-items: flex-end
}

.smart-stack-layout .left,
.smart-stack-layout:not(.vertical).left {
    justify-content: flex-start
}

.smart-stack-layout .center,
.smart-stack-layout:not(.vertical).center {
    justify-content: center
}

.smart-stack-layout .middle,
.smart-stack-layout:not(.vertical).middle {
    align-items: center
}

.smart-stack-layout .space-between,
.smart-stack-layout.space-between {
    justify-content: space-between
}

.smart-stack-layout .space-evenly,
.smart-stack-layout.space-evenly {
    justify-content: space-evenly
}

.smart-stack-layout .space-around,
.smart-stack-layout.space-around {
    justify-content: space-around
}

.smart-stack-layout.vertical.top {
    justify-content: flex-start
}

.smart-stack-layout.vertical.right {
    align-items: flex-end
}

.smart-stack-layout.vertical.bottom {
    justify-content: flex-end
}

.smart-stack-layout.vertical.left {
    align-items: flex-start
}

.smart-stack-layout.vertical.center {
    align-items: center
}

.smart-stack-layout.vertical.middle {
    justify-content: center
}

.smart-stack-layout.stretch:not(.vertical) .item,
.smart-stack-layout.vertical.vertical-stretch .item {
    flex: 1 1
}

.smart-stack-layout.stretch:not(.vertical) .item.flex-2,
.smart-stack-layout.vertical.vertical-stretch .item.flex-2 {
    flex: 2 1
}

.smart-stack-layout.stretch:not(.vertical) .item.flex-3,
.smart-stack-layout.vertical.vertical-stretch .item.flex-3 {
    flex: 3 1
}

.smart-stack-layout.stretch:not(.vertical) .item.flex-4,
.smart-stack-layout.vertical.vertical-stretch .item.flex-4 {
    flex: 4 1
}

.smart-stack-layout.stretch:not(.vertical) .item.flex-5,
.smart-stack-layout.vertical.vertical-stretch .item.flex-5 {
    flex: 5 1
}

.smart-stack-layout.stretch:not(.vertical) .item.flex-6,
.smart-stack-layout.vertical.vertical-stretch .item.flex-6 {
    flex: 6 1
}

.smart-stack-layout.stretch.vertical,
.smart-stack-layout:not(.vertical).vertical-stretch {
    align-items: stretch
}

.smart-validation-error:not(smart-check-box)>div.smart-container:after,
.smart-validation-success:not(smart-check-box)>div.smart-container:after {
    align-items: center;
    border-radius: 50%;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: 700;
    height: 20px;
    justify-content: center;
    left: calc(100% + 20px);
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 20px
}

.smart-validation-error:not(.underlined):not(.outlined),
.smart-validation-error:not(.underlined):not(.outlined) input,
.smart-validation-error:not(.underlined):not(.outlined) span {
    border-color: #b00020 !important;
    border-color: var(--smart-error) !important;
    outline: 0
}

.smart-validation-error:not(smart-check-box)>div.smart-container:after {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color);
    content: "!"
}

.smart-success-label-like-after-element:after,
.smart-validation-success:not(smart-check-box)>div.smart-container:after {
    background-color: #8bc34a;
    background-color: var(--smart-success);
    color: #fff;
    color: var(--smart-success-color);
    content: "✓"
}

.smart-validation-error.smart-element:not(.outlined):not(.underlined) .smart-hint:after {
    background-color: #b00020;
    background-color: var(--smart-error)
}

.smart-validation-success.smart-element:not(.outlined):not(.underlined) .smart-hint:after {
    background-color: #8bc34a;
    background-color: var(--smart-success)
}

input[type=checkbox].smart-validation-error,
input[type=radio].smart-validation-error {
    outline: auto;
    outline-color: #b00020;
    outline-color: var(--smart-error)
}

input.smart-validation-error {
    border-style: solid;
    border-width: 1px
}

.smart-error-label-like-after-element:after,
.smart-success-label-like-after-element:after {
    align-items: center;
    border-radius: 50%;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: 700;
    height: 20px;
    justify-content: center;
    left: calc(50% + 15px);
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 20px
}

.smart-error-label-like-after-element,
.smart-success-label-like-after-element {
    position: relative
}

.smart-error-label-like-after-element:after {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color);
    content: "!"
}

.smart-validation-summary {
    color: #b00020;
    color: var(--smart-error);
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.smart-validation-summary span {
    display: block;
    margin-top: 5px
}

.smart-error-holder {
    background-color: #b00020;
    background-color: var(--smart-error);
    color: #fff;
    color: var(--smart-error-color);
    font-size: 14px;
    font-size: var(--smart-font-size);
    margin-top: 10px;
    padding: 10px;
    pointer-events: none;
    position: absolute;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-error-holder.smart-error-hint-position-right {
    white-space: nowrap
}

.smart-input-buttons-elements-holder {
    grid-column-gap: 2%;
    grid-column-gap: var(--smart-date-format-panel-smart-input-buttons-column-gap);
    display: grid;
    grid-template-columns: 1fr 150px;
    grid-template-columns: var(--smart-date-format-panel-smart-inputs-container-width) var(--smart-date-format-panel-apply-container-width);
    grid-template-rows: auto
}

.smart-input-and-add-formats-holder {
    align-items: baseline;
    border: 1px solid #ccc;
    border: var(--smart-date-format-panel-border-size) solid var(--smart-date-format-panel-border-color);
    border-radius: 4px;
    border-radius: var(--smart-date-format-panel-border-radius);
    display: grid;
    grid-template-columns: 94% 6%;
    grid-template-columns: var(--smart-date-format-panel-smart-inputs-holder-width) var(--smart-date-format-panel-add-format-holder-width);
    grid-template-rows: auto;
    justify-content: center
}

.smart-input-list-holder {
    padding: 2px;
    padding: var(--smart-date-format-panel-smart-inputs-list-holder-offset)
}

.smart-input-list-holder:empty {
    border: none
}

.smart-input-list-holder smart-input {
    display: inline-flex;
    height: 25px;
    height: var(--smart-date-format-panel-smart-input-height);
    margin: 4px;
    margin: var(--smart-date-format-panel-each-smart-input-offset)
}

.smart-input-list-holder .format-smart-input-list {
    width: 150px;
    width: var(--smart-date-format-panel-smart-input-format-width)
}

.smart-input-list-holder .sign-smart-input {
    width: 80px;
    width: var(--smart-date-format-panel-smart-input-sign-width)
}

.all-format-holders {
    width: 255px;
    width: var(--smart-date-format-panel-all-format-holders-width)
}

.format-holder {
    float: left;
    text-align: center;
    width: 120px;
    width: var(--smart-date-format-panel-each-add-format-holder-width)
}

.add-format-holder {
    align-self: normal;
    justify-self: end;
    margin: 5px;
    margin: var(--smart-date-format-panel-add-new-format-dropdown-offset)
}

.add-format-holder span.smart-drop-down-button {
    --smart-date-format-panel-smart-drop-down-button-border: transparent
}

.add-format-holder smart-button {
    font-size: var(--smart-date-format-panel-smart-font-size);
    min-width: 120px;
    min-width: var(--smart-date-format-panel-add-format-holder-button);
    width: auto
}

.use-format-button {
    margin: 0 auto;
    margin-top: var(--smart-date-format-panel-margin-from-the-top)
}

.use-format-button[disabled] {
    display: none
}

li[value=" "] a {
    height: calc(var(--smart-date-format-panel-smart-font-size) + 16px)
}

.date-time-format-list {
    margin: 15px 0 0;
    margin-top: var(--smart-date-format-panel-date-time-format-list-offset-top);
    max-height: 400px;
    max-height: var(--smart-date-format-panel-date-time-format-list-max-height);
    overflow-y: auto;
    padding: 0
}

.date-time-format {
    border: 1px solid #ccc;
    border: var(--smart-date-format-panel-border-size) solid var(--smart-date-format-panel-border-color);
    border-bottom: none;
    cursor: pointer;
    list-style-type: none;
    padding: 12px;
    padding: var(--smart-date-format-panel-each-date-time-format-offset);
    padding-left: 0;
    text-align: center
}

.date-time-format:last-child {
    border-bottom: 1px solid #ccc;
    border-bottom: var(--smart-date-format-panel-border-size) solid var(--smart-date-format-panel-border-color)
}

.date-time-format:hover {
    background: #f1f1f1
}

.text-tramsform-none {
    text-transform: none
}

.cboth {
    clear: both
}

.bold {
    font-weight: 700
}

.currency-format-panel-demo-container {
    border: 1px solid #ccc;
    border-radius: 4px;
    max-width: 960px;
    padding: 15px
}

.selected-currency-holder-and-apply-holder {
    grid-column-gap: 2%;
    grid-column-gap: var(--smart-currency-format-panel-header-holder-offset);
    display: grid;
    grid-template-columns: 1fr 125px;
    grid-template-columns: var(--smart-currency-format-panel-currency-holder-width) var(--smart-currency-format-panel-apply-button-width);
    grid-template-rows: auto
}

.input-currency-formats {
    width: 95%;
    width: var(--smart-currency-format-panel-currency-holder-dropdown-button-width)
}

.selected-currency-holder {
    align-items: baseline;
    border: 1px solid #ccc;
    border: var(--smart-currency-format-panel-border-size) solid var(--smart-currency-format-panel-border-color);
    border-radius: 4px;
    border-radius: var(--smart-currency-format-panel-border-radius);
    display: grid;
    grid-template-columns: 1fr 165px;
    grid-template-columns: var(--smart-currency-format-panel-currency-holder-input-width) var(--smart-currency-format-panel-currency-holder-dropdown-width);
    grid-template-rows: auto;
    justify-content: center;
    padding-bottom: 3px;
    padding-bottom: var(--smart-currency-format-panel-currency-holder-padding-bottom);
    padding-left: 5px;
    padding-left: var(--smart-currency-format-panel-currency-holder-padding-left);
    padding-top: 3px;
    padding-top: var(--smart-currency-format-panel-currency-holder-padding-top)
}

.selected-currency-holder .currency-sign-input-holder {
    width: auto
}

.selected-currency-holder .currency-sign-input-holder smart-text-box {
    width: 100%;
    width: var(--smart-currency-format-panel-currency-input-width)
}

.selected-currency-holder .currency-sign-input-holder smart-text-box input {
    border: none
}

.currency-item,
.currency-list {
    border: 1px solid #ccc;
    border: var(--smart-currency-format-panel-border-size) solid var(--smart-currency-format-panel-border-color)
}

.currency-list {
    margin: 15px 0 0;
    margin-top: var(--smart-currency-format-panel-currencies-margin-top);
    max-height: 400px;
    max-height: var(--smart-currency-format-panel-currencies-max-height);
    overflow-y: auto;
    padding: 0
}

.currency-item {
    border-bottom: none;
    border-left: 0;
    cursor: pointer;
    list-style-type: none;
    padding: 12px;
    padding: var(--smart-currency-format-panel-currencies-item-padding);
    padding-left: 10px;
    padding-left: var(--smart-currency-format-panel-currencies-left-padding)
}

.currency-item:last-child {
    border-bottom: 0
}

.currency-item:first-child {
    border-top: 0 !important
}

.currency-item:hover {
    background: #f1f1f1;
    background: var(--smart-currency-format-panel-currencies-hover-background)
}

.currency-item-default-format {
    color: #777;
    color: var(--smart-currency-format-panel-currencies-example-format-color);
    float: right
}

.smart-appearance,
.smart-data-validation-container,
.smart-on-invalid-data-container {
    grid-column-gap: 0;
    grid-template-columns: 20% 80%;
    grid-template-columns: var(--smart-validation-panel-description-width) var(--smart-validation-panel-content-width);
    grid-template-rows: auto
}

.smart-on-invalid-data-container {
    display: grid;
    margin-top: 10px;
    margin-top: var(--smart-validation-panel-invalid-data-vertical-offset)
}

.smart-appearance {
    display: grid;
    margin-top: 10px;
    margin-top: var(--smart-validation-panel-appearance-vertical-offset)
}

.smart-appearance .smart-checkbox-appearance {
    display: block
}

.smart-appearance .smart-appearance-text-box-value {
    display: inline-block;
    margin-top: 5px;
    margin-top: var(--smart-validation-panel-appearance-textbox-vertical-offset)
}

.smart-appearance .reset-appearance {
    color: #005c99;
    color: var(--smart-validation-panel-appearance-reset-button-color);
    cursor: pointer;
    display: inline-block;
    margin-left: 5px;
    margin-left: var(--smart-validation-panel-appearance-reset-button-left-offset);
    text-decoration: underline
}

.smart-data-validation-container {
    display: grid;
    margin-top: 10px;
    margin-top: var(--smart-validation-panel-criteria-container-vertical-offset)
}

.smart-data-validation-container .criteria-container {
    margin-top: 10px;
    margin-top: var(--smart-validation-panel-criteria-row-margin-top)
}

.smart-data-validation-container .right-elements {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap
}

.smart-data-validation-container .smart-criteria-container,
.smart-data-validation-container .smart-criteria-type-container {
    align-items: center;
    display: flex
}

.smart-data-validation-container .smart-input-criteria,
.smart-data-validation-container .smart-input-criteria-type {
    display: inline-block;
    margin-left: 2px;
    margin-left: var(--smart-validation-panel-criteria-container-input-horizontal-offset);
    margin-right: 2px;
    margin-right: var(--smart-validation-panel-criteria-container-input-horizontal-offset);
    width: 180px;
    width: var(--smart-validation-panel-criteria-container-input-width)
}

.smart-data-validation-container .smart-input-criteria-container {
    align-items: center;
    display: inline-flex;
    flex-direction: row
}

.smart-data-validation-container .smart-input-criteria-container smart-text-box {
    display: inline-block;
    margin-left: 2px;
    margin-left: var(--smart-validation-panel-criteria-container-textbox-horizontal-offset);
    margin-right: 2px;
    margin-right: var(--smart-validation-panel-criteria-container-textbox-horizontal-offset);
    width: 80px;
    width: var(--smart-validation-panel-criteria-container-textbox-width)
}

.smart-data-validation-container .smart-input-criteria-container smart-text-box:first-child {
    order: 1
}

.smart-data-validation-container .smart-input-criteria-container smart-text-box:nth-child(2) {
    order: 3
}

.smart-data-validation-container .smart-input-criteria-container .smart-text-between-inputs {
    margin: 5px;
    margin: var(--smart-validation-panel-criteria-container-text-between-inputs-offset);
    order: 2
}

.smart-criteria-container,
.smart-criteria-type-container,
.smart-input-criteria-container {
    margin-top: 10px;
    margin-top: var(--smart-validation-panel-criteria-row-margin-top)
}

.smart-footer-buttons {
    margin-top: 20px;
    margin-top: var(--smart-validation-panel-footer-vertical-offset)
}

.smart-footer-buttons smart-button {
    margin-left: 5px;
    margin-left: var(--smart-validation-panel-footer-button-horizontal-offset);
    margin-right: 5px;
    margin-right: var(--smart-validation-panel-footer-button-horizontal-offset)
}

.smart-footer-buttons smart-button.smart-remove-validation-footer-button {
    color: #188038;
    color: var(--smart-validation-panel-footer-remove-validation-button-color);
    font-weight: 700;
    width: auto
}

.smart-footer-buttons smart-button.smart-cancel-footer-button {
    color: #188038;
    color: var(--smart-validation-panel-footer-cancel-button-color);
    font-weight: 700
}

.smart-footer-buttons smart-button.smart-save-footer-button {
    background: #188038;
    background: var(--smart-validation-panel-footer-save-button-background);
    color: #fff;
    color: var(--smart-validation-panel-footer-save-button-color)
}

.smart-footer-buttons .right-elements {
    float: right
}

.right-elements-reset {
    align-items: center;
    display: flex
}

.smart-path-item,
.smart-path[hint]>.smart-container {
    align-items: flex-start
}

.smart-path .smart-drop-down-button,
.smart-path-item {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius)
}

.smart-path-item {
    border: 1px solid transparent;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    border-width: var(--smart-border-width);
    box-sizing: border-box;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    flex-direction: column;
    height: calc(100% - 3px);
    height: calc(100% - var(--smart-list-item-vertical-offset));
    justify-content: center;
    left: 0;
    overflow: hidden;
    padding: 9px 12px;
    position: relative;
    top: 0;
    transition: opacity .28s ease-in-out;
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    width: 100%
}

.smart-path-item .smart-ripple {
    background: #005c99;
    background: var(--smart-ui-state-active)
}

.smart-path-item[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none
}

.smart-path-item[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-path-item[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    opacity: 1
}

.smart-path-item[focus] {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color)
}

smart-path .smart-ripple {
    background: #005c99;
    background: var(--smart-ui-state-active)
}

.smart-path,
.smart-path.smart-container {
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    height: 30px;
    height: var(--smart-path-default-height);
    width: 250px;
    width: var(--smart-path-default-width)
}

.smart-path>.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-path .smart-content {
    cursor: pointer;
    display: flex;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-path .smart-content .smart-input::selection {
    background: #005c99;
    background: var(--smart-editor-selection);
    color: #fff;
    color: var(--smart-editor-selection-color)
}

.smart-path .smart-input,
.smart-path input.smart-input {
    background-color: inherit;
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    border-radius: 0;
    color: inherit;
    cursor: auto;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    margin: 0;
    min-height: 100%;
    outline: 1px solid transparent;
    text-align: start;
    text-align: var(--smart-path-text-align);
    vertical-align: middle;
    width: 100%
}

.smart-path .smart-input:focus {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #5a5a5a;
    color: var(--smart-background-color);
    outline: medium none invert;
    outline: initial
}

.smart-path .smart-input::-webkit-input-placeholder {
    color: #555;
    color: var(--smart-disabled-color);
    font-style: italic
}

.smart-path .smart-input::-webkit-input-placeholder,
.smart-path .smart-input::placeholder {
    color: #555;
    color: var(--smart-disabled-color);
    font-style: italic
}

.smart-path .smart-input[hover] {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-path .smart-input[position-absolute] {
    position: absolute
}

.smart-path div.smart-input {
    background: transparent none repeat 0 0/auto auto padding-box border-box scroll;
    background: initial;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 6px 3px;
    padding: calc(var(--smart-editor-label-padding) + var(--smart-border-width)*2) calc(var(--smart-editor-label-padding) - var(--smart-border-width));
    scrollbar-width: none
}

.smart-path .smart-path-input-wrapper,
.smart-path div.smart-input:after {
    padding: 0 4px;
    padding: 0 var(--smart-editor-label-padding);
    pointer-events: none;
    white-space: nowrap
}

.smart-path div.smart-input:after {
    align-items: center;
    color: #555;
    color: var(--smart-disabled-color);
    content: attr(placeholder);
    display: flex;
    font-size: var(--smart-arrow-size);
    font-style: italic;
    height: 100%;
    justify-content: normal;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-path div.smart-input[show-placeholder]:after {
    opacity: 1
}

.smart-path .smart-buttons-container {
    grid-column-gap: 5px;
    grid-column-gap: var(--smart-path-button-gap);
    display: grid;
    grid-template-columns: 27px minmax(0, 1fr) 27px;
    grid-template-columns: var(--smart-editor-addon-width) minmax(0, 1fr) var(--smart-editor-addon-width);
    width: 100%
}

.smart-path .smart-hint,
.smart-path .smart-label {
    display: none;
    position: absolute
}

.smart-path .smart-drop-down.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top 0;
    transform-origin: left top 0;
    transition: -webkit-transform .2s ease-in;
    transition: transform .2s ease-in;
    transition: transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-path .smart-browse-button,
.smart-path .smart-drop-down-button {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 10px;
    height: 100%;
    min-height: 30px;
    min-height: var(--smart-editor-height);
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    outline: 1px solid transparent;
    overflow: hidden;
    position: relative;
    transition: background-color .1s linear;
    -ms-user-select: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-path .smart-browse-button span,
.smart-path .smart-drop-down-button span {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    left: 50%;
    pointer-events: none;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%)
}

.smart-path .smart-browse-button span:not(.smart-ripple):after,
.smart-path .smart-drop-down-button span:not(.smart-ripple):after {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    top: 0;
    white-space: nowrap;
    width: 100%
}

.smart-path .smart-browse-button[hover],
.smart-path .smart-drop-down-button[hover] {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-path .smart-browse-button:active,
.smart-path .smart-browse-button[active],
.smart-path .smart-drop-down-button:active,
.smart-path .smart-drop-down-button[active] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-path .smart-drop-down-button {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0
}

.smart-path .smart-drop-down-button span:not(.smart-ripple):after {
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    font-size: var(--smart-arrow-size)
}

.smart-path .smart-browse-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-path .smart-browse-button span:not(.smart-ripple):after {
    content: "...";
    font-size: 1rem;
    font-weight: 600
}

.smart-path .smart-path-input-container {
    border-color: #e0e0e0;
    border-width: 1px;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 0;
    overflow: hidden;
    position: relative
}

.smart-path .smart-path-input-wrapper {
    left: 0;
    opacity: 0;
    outline: 0;
    position: absolute;
    text-align: start;
    text-align: var(--smart-path-text-align);
    top: 0;
    vertical-align: middle;
    visibility: hidden
}

.smart-path .smart-path-input-wrapper::-moz-focus-inner {
    border: 0
}

@-moz-document url-prefix() {
    .smart-path .smart-path-input-wrapper {
        line-height: 1rem
    }
}

.smart-path .smart-path-multiline-container {
    background-color: inherit;
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    border-radius: 0;
    color: inherit;
    cursor: auto;
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    margin: 0;
    min-height: 100%;
    outline: 1px solid transparent;
    overflow: hidden;
    padding: initial;
    position: relative;
    text-align: start;
    text-align: var(--smart-path-text-align);
    vertical-align: middle;
    width: 100%
}

.smart-path .smart-path-multiline-container .smart-input::-webkit-scrollbar {
    width: 0
}

.smart-path:not([animation=none])[hint] .smart-hint {
    transition: opacity .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-path:not([animation=none])[hint][focus] .smart-hint {
    transition: opacity .2s cubic-bezier(.4, 0, .2, 1)
}

.smart-path[readonly] .smart-input {
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none
}

.smart-path[indicator] .smart-input {
    background: #f5f5f5;
    background: var(--smart-surface)
}

.smart-path[disabled] .smart-browse-button,
.smart-path[disabled] .smart-drop-down-button,
.smart-path[disabled] input,
.smart-path[disabled]>.smart-container {
    background-color: transparent;
    background-color: initial;
    cursor: default
}

.smart-path[indicator] .smart-path-input-container {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-path[indicator] .smart-browse-button {
    display: none
}

.smart-path[indicator] .smart-buttons-container {
    grid-template-columns: 27px minmax(0, 1fr);
    grid-template-columns: var(--smart-editor-addon-width) minmax(0, 1fr)
}

.smart-path[disabled] input {
    -ms-user-select: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none
}

.smart-path[focus] .smart-path-input-container {
    background-color: #fefefe;
    background-color: var(--smart-background)
}

.smart-path[focus] .smart-browse-button,
.smart-path[focus] .smart-drop-down-button,
.smart-path[focus] .smart-path-input-container {
    border-color: #005c99;
    border-color: var(--smart-primary);
    color: #5a5a5a;
    color: var(--smart-background-color);
    outline: medium none invert;
    outline: initial
}

.smart-path[focus] .smart-browse-button,
.smart-path[focus] .smart-drop-down-button {
    background-color: #f5f5f5;
    background-color: var(--smart-surface)
}

.smart-path[label][hint]>.smart-container {
    align-items: center;
    display: flex;
    position: relative
}

.smart-path[hint] .smart-hint,
.smart-path[label] .smart-label {
    display: block;
    font-size: 12px;
    left: 0;
    line-height: normal;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-align: initial;
    vertical-align: baseline;
    vertical-align: initial;
    width: 100%
}

.smart-path[label]>.smart-container {
    align-items: flex-end
}

.smart-path[label] .smart-label {
    bottom: 100%
}

.smart-path[hint] .smart-hint,
.smart-path[label] .smart-label {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-path[hint] .smart-hint {
    bottom: auto;
    opacity: 0;
    top: 100%
}

.smart-path[hint][focus] .smart-hint {
    opacity: 1
}

.smart-path[opened] .smart-drop-down-button {
    background: #005c99;
    background: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-path[wrap] .smart-path-input-wrapper {
    padding-bottom: 6px;
    padding-bottom: calc(var(--smart-editor-label-padding) + var(--smart-border-width)*2);
    padding-top: 6px;
    padding-top: calc(var(--smart-editor-label-padding) + var(--smart-border-width)*2)
}

.smart-path.outlined {
    background-color: transparent;
    color: inherit
}

.smart-path.outlined[label] .smart-label {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: auto;
    left: 4px;
    left: var(--smart-editor-label-padding);
    min-height: 20px;
    top: -11px;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: all .2s ease;
    width: auto;
    z-index: 1
}

.smart-path.outlined[label][focus] .smart-label {
    color: #005c99;
    color: var(--smart-primary);
    -webkit-transform: scale(.8);
    transform: scale(.8)
}

.smart-path.outlined[hover] .smart-drop-down-button {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-path.underlined .smart-browse-button:after,
.smart-path.underlined .smart-drop-down-button:after,
.smart-path.underlined .smart-path-input-container:after {
    border-bottom: 1px solid #005c99;
    border-bottom-color: var(--smart-primary);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    transition: all .2s cubic-bezier(0, 0, .2, 1);
    width: 0
}

.smart-path.underlined .smart-browse-button,
.smart-path.underlined .smart-drop-down-button,
.smart-path.underlined .smart-input,
.smart-path.underlined .smart-path-input-container,
.smart-path.underlined[hover]:not([opened]) .smart-input {
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent
}

.smart-path.underlined {
    background-color: transparent;
    color: inherit
}

.smart-path.underlined .smart-browse-button[active],
.smart-path.underlined .smart-drop-down-button[active],
.smart-path.underlined .smart-input[active] {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-path.underlined:not([opened]) .smart-input,
.smart-path.underlined:not([opened]):not([hover]) .smart-browse-button,
.smart-path.underlined:not([opened]):not([hover]) .smart-drop-down-button {
    background-color: transparent;
    border-radius: 0;
    border-radius: initial;
    color: inherit
}

.smart-path.underlined:not([hover]) .smart-browse-button:focus,
.smart-path.underlined:not([hover]) .smart-drop-down-button:focus {
    box-shadow: none
}

.smart-path.underlined:not([hover]) .smart-input:focus {
    box-shadow: none;
    z-index: auto
}

.smart-path.underlined[hover]:not([opened]) .smart-input {
    background-color: transparent
}

.smart-path.underlined[focus] .smart-browse-button:after,
.smart-path.underlined[focus] .smart-drop-down-button:after,
.smart-path.underlined[focus] .smart-path-input-container:after {
    width: 100%
}

.smart-path.underlined[label] .smart-label {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    transition: all .2s cubic-bezier(0, 0, .2, 1)
}

.smart-path.underlined[label][value=""] .smart-label {
    bottom: 0
}

.smart-path.underlined[label][focus] .smart-label,
.smart-path.underlined[label][opened] .smart-label {
    bottom: 100%;
    color: #005c99;
    color: var(--smart-primary);
    -webkit-transform: scale(.8);
    transform: scale(.8)
}

.smart-path[right-to-left]>.smart-container {
    direction: rtl
}

.smart-path[right-to-left] .smart-browse-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.smart-path[right-to-left] .smart-drop-down-button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-left-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius)
}

.smart-path[right-to-left][indicator] .smart-path-input-container {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 0
}

.smart-drop-down.smart-drop-down-repositioned[right-to-left] {
    direction: rtl
}

.number-format-panel-demo-container {
    border: 1px solid #ccc;
    border-radius: 4px;
    max-width: 960px;
    padding: 15px
}

.selected-custom-number-format-holder-and-apply-holder {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-number-format-panel-header-holder-offset);
    display: grid;
    grid-template-columns: 1fr 125px;
    grid-template-columns: var(--smart-number-format-panel-selected-format-width) var(--smart-number-format-panel-apply-button-width);
    grid-template-rows: auto
}

.selected-custom-number-format-holder {
    border: 1px solid #ccc;
    border: var(--smart-number-format-panel-border-size) solid var(--smart-number-format-panel-border-color);
    border-radius: 4px;
    border-radius: var(--smart-number-format-panel-border-radius);
    display: block;
    padding-bottom: 3px;
    padding-bottom: var(--smart-number-format-panel-selected-format-padding-bottom);
    padding-left: 5px;
    padding-left: var(--smart-number-format-panel-selected-format-padding-left);
    padding-top: 3px;
    padding-top: var(--smart-number-format-panel-selected-format-padding-top)
}

.selected-custom-number-format-holder .custom-number-format-input-holder {
    width: auto
}

.selected-custom-number-format-holder .custom-number-format-input-holder smart-text-box {
    width: 100%;
    width: var(--smart-number-format-panel-header-input-width)
}

.selected-custom-number-format-holder .custom-number-format-input-holder smart-text-box input {
    border: none
}

.custom-number-format-item,
.custom-number-format-list {
    border: 1px solid #ccc;
    border: var(--smart-number-format-panel-border-size) solid var(--smart-number-format-panel-border-color)
}

.apply-button-holder .use-number-format-button {
    height: 100%
}

.sample-container {
    margin-left: 5px;
    margin-left: var(--smart-number-format-panel-sample-container-horizontal-offset);
    margin-top: 15px;
    margin-top: var(--smart-number-format-panel-sample-container-vertical-offset)
}

.custom-number-format-list {
    margin: 15px 0 0;
    margin-top: var(--smart-number-format-panel-formats-list-margin-top);
    max-height: 400px;
    max-height: var(--smart-number-format-panel-formats-list-max-height);
    overflow-y: auto;
    padding: 0
}

.custom-number-format-item {
    border-bottom: none;
    border-left: 0;
    cursor: pointer;
    list-style-type: none;
    padding: 12px;
    padding: var(--smart-number-format-panel-formats-item-padding);
    padding-left: 10px;
    padding-left: var(--smart-number-format-panel-formats-item-left-padding)
}

.custom-number-format-item:last-child {
    border-bottom: 0
}

.custom-number-format-item:first-child {
    border-top: 0 !important
}

.custom-number-format-item:hover {
    background: #f1f1f1;
    background: var(--smart-number-format-panel-formats-item-hover-background)
}

.custom-number-format-item-default-format {
    color: #777;
    color: var(--smart-number-format-panel-formats-item-example-format-color);
    float: right
}

.smart-kanban {
    height: 500px;
    height: var(--smart-kanban-default-height);
    padding: 10px;
    padding: var(--smart-data-view-padding);
    width: 1200px;
    width: var(--smart-kanban-default-width)
}

.smart-kanban.smart-container,
.smart-kanban>.smart-container {
    position: relative
}

.smart-kanban.smart-container[modal],
.smart-kanban>.smart-container[modal] {
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.smart-kanban.smart-container[modal]:after,
.smart-kanban>.smart-container[modal]:after {
    background-color: #000;
    content: "";
    cursor: default;
    height: 100%;
    left: 0;
    opacity: .3;
    pointer-events: none;
    position: absolute;
    top: 0;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%
}

.smart-kanban .smart-kanban-body {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-rows: 100%;
    height: 100%;
    position: relative;
    width: 100%
}

.smart-kanban .smart-kanban-body>.smart-kanban-column {
    height: 100%;
    overflow: hidden
}

.smart-kanban .smart-kanban-column {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-rows: 35px 1fr;
    grid-template-rows: var(--smart-kanban-header-size) 1fr;
    min-height: 0
}

.smart-kanban .smart-kanban-column:not(.collapsed)>.smart-kanban-column-header {
    grid-template-columns: 1fr auto auto
}

.smart-kanban .smart-kanban-column.collapsed>.smart-kanban-column-header>.smart-kanban-column-header-label.pill .heading {
    padding: 8px 2px
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header {
    align-content: center;
    align-items: center;
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #323232;
    color: var(--smart-surface-color);
    display: grid;
    grid-template-columns: 1fr auto;
    min-width: 0;
    padding: 0 10px;
    padding: 0 var(--smart-data-view-padding)
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-label {
    font-size: 15px;
    font-size: calc(var(--smart-font-size) + 1px);
    font-weight: 700;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-label.pill {
    align-content: center;
    display: inline-flex;
    overflow: visible
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-label.pill .heading {
    align-items: center;
    border-radius: 12px;
    display: flex;
    font-size: 14px;
    font-size: var(--smart-font-size);
    font-weight: 500;
    min-width: 22px;
    padding: 2px 8px
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-label.pill .heading .summary {
    font-size: 10px;
    margin-left: 3px;
    opacity: .8
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-label.pending {
    overflow: visible;
    position: relative;
    visibility: hidden
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-arrow,
.smart-kanban .smart-kanban-column>.smart-kanban-column-header>.smart-kanban-column-header-add {
    display: none
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-content {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-rows: 1fr 3fr;
    min-height: 0
}

.smart-kanban .smart-kanban-column .smart-kanban-column-content-tasks:empty,
.smart-kanban .smart-kanban-column.collapsed>.smart-kanban-column-content {
    display: none
}

.smart-kanban .smart-kanban-column.has-swimlane,
.smart-kanban .smart-kanban-column>.smart-kanban-column-content.has-swimlane {
    grid-row-gap: 55px;
    grid-row-gap: calc(var(--smart-kanban-header-size) + var(--smart-data-view-padding)*2)
}

.smart-kanban .smart-kanban-column>.smart-kanban-column-content.no-sub-columns {
    grid-template-rows: 1fr
}

.smart-kanban .smart-kanban-column .smart-kanban-column-content-tasks {
    background-color: transparent;
    border: none;
    height: unset;
    max-height: unset;
    min-height: 0;
    min-width: unset;
    padding: 0;
    position: relative;
    width: unset
}

.smart-kanban .smart-kanban-column.collapsed {
    grid-template-rows: 1fr;
    width: 35px;
    width: var(--smart-kanban-header-size)
}

.smart-kanban .smart-kanban-column.collapsed>.smart-kanban-column-header {
    color: #005c99;
    color: var(--smart-primary);
    direction: ltr;
    padding: 10px 0;
    padding: var(--smart-data-view-padding) 0;
    width: 100%;
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr
}

.smart-kanban .smart-kanban-column.collapsed.has-swimlane>.smart-kanban-column-header>.smart-kanban-column-header-label {
    margin-top: 80px;
    margin-top: calc(var(--smart-kanban-header-size)*2 + var(--smart-data-view-padding))
}

.smart-kanban .smart-kanban-column.dragged .smart-kanban-column-header {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em
}

.smart-kanban .smart-kanban-column.drop-target {
    overflow: visible;
    position: relative
}

.smart-kanban .smart-kanban-column.drop-target.before:after {
    border-left: 3px dashed #005c99;
    border-left: var(--smart-kanban-color-band-width) dashed var(--smart-primary);
    left: -3px;
    left: calc(var(--smart-kanban-color-band-width)*-1);
    margin-left: -3px
}

.smart-kanban .smart-kanban-column.drop-target.after:after {
    border-right: 3px dashed #005c99;
    border-right: var(--smart-kanban-color-band-width) dashed var(--smart-primary);
    margin-left: 3px
}

.smart-kanban .smart-kanban-column[orientation=horizontal]>.smart-kanban-column-content>.smart-kanban-column-content-tasks>.smart-container>.smart-scroll-viewer-container>.smart-scroll-viewer-content-container {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    grid-template-columns: repeat(auto-fit, minmax(var(--smart-kanban-task-min-width), 1fr))
}

.smart-kanban .smart-kanban-column[orientation=horizontal]>.smart-kanban-column-content>.smart-kanban-column-content-tasks .drop-target.before:after {
    border-left: 3px dashed #fff;
    border-left: var(--smart-kanban-color-band-width) dashed var(--smart-primary-color);
    left: -3px;
    left: calc(var(--smart-kanban-color-band-width)*-1)
}

.smart-kanban .smart-kanban-column[orientation=horizontal]>.smart-kanban-column-content>.smart-kanban-column-content-tasks .drop-target.after:after {
    border-right: 2px dashed #005c99;
    border-right: 2px dashed var(--smart-primary)
}

.smart-kanban .smart-kanban-column[orientation=vertical]>.smart-kanban-column-content>.smart-kanban-column-content-tasks .drop-target.before:after {
    border-top: 2px dashed #005c99;
    border-top: 2px dashed var(--smart-primary)
}

.smart-kanban .smart-kanban-column[orientation=vertical]>.smart-kanban-column-content>.smart-kanban-column-content-tasks .drop-target.after:after {
    border-bottom: 2px dashed #005c99;
    border-bottom: 2px dashed var(--smart-primary)
}

.smart-kanban .smart-kanban-column-header:focus {
    border-color: #005c99;
    border-color: var(--smart-ui-state-border-active);
    outline: 0
}

.smart-kanban .smart-kanban-column-header-label.pending .smart-kanban-column-header-input {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: 13px;
    font-size: calc(var(--smart-font-size) - 1px);
    height: 120%;
    left: 0;
    outline: 0;
    padding: 4px;
    position: absolute;
    top: -10%;
    visibility: visible;
    width: 100%
}

.smart-kanban .smart-kanban-column-header-label.pending .smart-kanban-column-header-input:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-kanban .smart-kanban-column-header-label.pending .smart-kanban-column-header-input:focus {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-kanban .smart-kanban-column-header-label.pending.colors .smart-kanban-column-header-input {
    width: calc(100% - 30px)
}

.smart-kanban .smart-kanban-column-header-label.pending.colors smart-color-input {
    position: absolute;
    right: 2px;
    visibility: visible
}

.smart-kanban .smart-kanban-column-header-add:focus {
    color: #005c99;
    color: var(--smart-primary);
    outline: 0
}

.smart-kanban .smart-kanban-column-content-tasks:focus {
    outline: 0
}

.smart-kanban .smart-kanban-column-content-tasks:focus .smart-kanban-task[focus] {
    box-shadow: inset 0 0 1px 1px #005c99;
    box-shadow: inset 0 0 1px 1px var(--smart-primary)
}

.smart-kanban .smart-kanban-column-content-tasks>.smart-container>.smart-scroll-viewer-container>.smart-scroll-viewer-content-container {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-data-view-padding);
    display: grid;
    padding: 0
}

.smart-kanban .smart-kanban-column-content-columns {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    min-height: 0
}

.smart-kanban .smart-kanban-column-content-columns.has-tabs {
    grid-row-gap: 10px;
    grid-row-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-rows: 35px 1fr;
    grid-template-rows: var(--smart-kanban-header-size) 1fr;
    min-height: 0
}

.smart-kanban .smart-kanban-column-content-columns.has-tabs .smart-kanban-column {
    grid-template-rows: 1fr
}

.smart-kanban .smart-kanban-task.dragged {
    background-image: linear-gradient(45deg, rgba(0, 0, 0, .1) 25%, transparent 0, transparent 50%, rgba(0, 0, 0, .1) 0, rgba(0, 0, 0, .1) 75%, transparent 0, transparent);
    background-size: 3em 3em
}

.smart-kanban .smart-kanban-task[selected] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected)
}

.smart-kanban .smart-kanban-task-user:focus {
    border: 1px solid #005c99;
    border: 1px solid var(--smart-primary);
    outline: 0
}

.smart-kanban .smart-kanban-list:focus,
.smart-kanban .smart-kanban-task-actions:focus,
.smart-kanban .smart-kanban-task-comments:focus {
    outline: 1px solid #005c99;
    outline: var(--smart-primary) solid 1px
}

.smart-kanban .smart-kanban-task-actions:hover,
.smart-kanban .smart-kanban-task-comments:hover {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-kanban .smart-kanban-list {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    max-height: 400px;
    max-height: var(--smart-kanban-user-list-max-height);
    opacity: 1;
    overflow: auto;
    position: absolute;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top;
    transform-origin: top;
    width: 150px;
    width: var(--smart-kanban-user-list-width);
    z-index: 15
}

.smart-kanban .smart-kanban-list .item {
    align-items: center;
    cursor: pointer;
    display: flex;
    min-height: 40px;
    min-height: calc(var(--smart-kanban-user-icon-size) + 10px);
    padding: 5px 10px
}

.smart-kanban .smart-kanban-list .item:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-kanban .smart-kanban-list .item.selected {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-left: 3px solid #005c99;
    border-left: var(--smart-kanban-color-band-width) solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-ui-state-color-selected);
    padding-left: 7px
}

.smart-kanban .smart-kanban-list .item[disabled] {
    opacity: .55;
    pointer-events: none
}

.smart-kanban .smart-kanban-list .icon {
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    height: 30px;
    height: var(--smart-kanban-user-icon-size);
    margin-right: 10px;
    min-width: 30px;
    min-width: var(--smart-kanban-user-icon-size);
    width: 30px;
    width: var(--smart-kanban-user-icon-size)
}

.smart-kanban .smart-kanban-list .name {
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-kanban .smart-kanban-list.smart-visibility-hidden {
    opacity: 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0)
}

.smart-kanban .smart-kanban-list.actions.edit-comment .item[data-id="1"] {
    display: none
}

.smart-kanban .smart-kanban-list.comments {
    height: 400px;
    height: var(--smart-kanban-comments-list-height);
    max-height: 100%;
    width: 350px;
    width: var(--smart-kanban-comments-list-width)
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-comments {
    height: calc(100% - 50px);
    height: calc(100% - var(--smart-kanban-new-comment-height));
    overflow: auto
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    height: 50px;
    height: var(--smart-kanban-new-comment-height);
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-data-view-padding)
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment textarea {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: inherit;
    height: 100%;
    resize: none;
    width: 100%
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment textarea:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment textarea:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment textarea[disabled] {
    opacity: .5
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment smart-button {
    --smart-button-padding: 0;
    display: none;
    height: 30px;
    height: var(--smart-kanban-send-button-height);
    margin-left: auto
}

.smart-kanban .smart-kanban-list.comments .smart-kanban-new-comment smart-button[disabled] {
    cursor: not-allowed;
    pointer-events: unset
}

.smart-kanban .smart-kanban-list.comments.expanded .smart-kanban-comments {
    height: calc(100% - 175px);
    height: calc(100% - var(--smart-kanban-new-comment-height-expanded))
}

.smart-kanban .smart-kanban-list.comments.expanded .smart-kanban-new-comment {
    height: 175px;
    height: var(--smart-kanban-new-comment-height-expanded)
}

.smart-kanban .smart-kanban-list.comments.expanded .smart-kanban-new-comment textarea {
    display: block;
    height: calc(100% - 40px);
    height: calc(100% - var(--smart-data-view-padding) - var(--smart-kanban-send-button-height));
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-kanban .smart-kanban-list.comments.expanded .smart-kanban-new-comment smart-button {
    display: block
}

.smart-kanban .smart-data-view-header {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    height: 35px;
    height: var(--smart-kanban-header-size);
    min-width: 0
}

.smart-kanban .smart-kanban-add-new-column {
    cursor: pointer
}

.smart-kanban .smart-kanban-add-new-column-label {
    font-size: 15px;
    font-size: calc(var(--smart-font-size) + 1px);
    font-weight: 700
}

.smart-kanban .smart-kanban-add-new-column-label,
.smart-kanban .swimlane {
    align-items: center;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-kanban .swimlane {
    background-color: #005c99;
    background-color: var(--smart-primary);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #fff;
    color: var(--smart-primary-color);
    font-size: 16px;
    font-size: calc(var(--smart-font-size) + 2px);
    height: 35px;
    height: var(--smart-kanban-header-size);
    justify-content: center;
    min-width: 0;
    padding: 10px;
    padding: var(--smart-data-view-padding);
    position: absolute
}

.smart-kanban .drop-target:after {
    border: 2px dashed #005c99;
    border: 2px dashed var(--smart-primary);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 0;
    opacity: .75;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-kanban .drop-target.after:after,
.smart-kanban .drop-target.before:after {
    border: none
}

.smart-kanban .remove-button:focus {
    outline: 1px solid #005c99;
    outline: var(--smart-primary) solid 1px
}

.smart-kanban .comment {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-columns: 30px 1fr;
    grid-template-columns: var(--smart-kanban-user-icon-size) 1fr;
    margin: 10px;
    margin: var(--smart-data-view-padding)
}

.smart-kanban .comment .comment-header {
    grid-column-gap: 5px;
    grid-column-gap: calc(var(--smart-data-view-padding)/2);
    display: grid;
    grid-template-columns: 1fr auto auto;
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-kanban .comment .user-icon {
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    height: 30px;
    height: var(--smart-kanban-user-icon-size);
    width: 100%
}

.smart-kanban .comment .user-icon.empty {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 50%;
    display: flex;
    justify-content: center
}

.smart-kanban .comment .user-icon.empty:after {
    content: "\\e81f";
    content: var(--smart-icon-user);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 20px
}

.smart-kanban .comment .user-name {
    font-weight: 700
}

.smart-kanban .comment .time {
    opacity: .8
}

.smart-kanban .comment .remove-button {
    cursor: pointer;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    visibility: hidden;
    width: 16px
}

.smart-kanban .comment .remove-button:after {
    align-items: center;
    content: "\\f141";
    content: var(--smart-icon-ellipsis);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center
}

.smart-kanban .comment .remove-button.enabled {
    visibility: visible
}

.smart-kanban:not([right-to-left]) .smart-kanban-column.collapsed>.smart-kanban-column-header>.smart-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-kanban:not([animation=none]) .smart-kanban-list {
    transition: visibility .2s ease-in, opacity .2s ease-in, -webkit-transform .2s ease-in;
    transition: transform .2s ease-in, visibility .2s ease-in, opacity .2s ease-in;
    transition: transform .2s ease-in, visibility .2s ease-in, opacity .2s ease-in, -webkit-transform .2s ease-in
}

.smart-kanban:not([animation=none]) .smart-kanban-list.comments .smart-kanban-comments,
.smart-kanban:not([animation=none]) .smart-kanban-list.comments .smart-kanban-new-comment,
.smart-kanban:not([animation=none]) .smart-kanban-list.comments .smart-kanban-new-comment textarea {
    transition: height .2s ease-in
}

.smart-kanban[add-new-button] .smart-kanban-column[add-new-button]>.smart-kanban-column-header>.smart-kanban-column-header-add:after {
    content: "\\e810";
    content: var(--smart-icon-plus-circled);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    padding: 0 10px 10px 0
}

.smart-kanban[add-new-button] .smart-kanban-column[add-new-button]>.smart-kanban-column-header>.smart-kanban-column-header-add:hover {
    color: #005c99;
    color: var(--smart-primary);
    cursor: pointer
}

.smart-kanban[add-new-button] .smart-kanban-column[add-new-button]:not(.collapsed)>.smart-kanban-column-header[add-new-button] {
    grid-template-columns: auto 1fr auto auto
}

.smart-kanban[add-new-button] .smart-kanban-column[add-new-button]:not(.collapsed)>.smart-kanban-column-header[add-new-button]>.smart-kanban-column-header-add {
    display: block
}

.smart-kanban[add-new-button] .smart-kanban-add-new-button {
    align-content: center;
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-6);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: flex;
    font-size: 24px;
    height: 36px;
    justify-content: center;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    transition: box-shadow .2s ease-in-out, -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out, box-shadow .2s ease-in-out;
    transition: transform .2s ease-in-out, box-shadow .2s ease-in-out, -webkit-transform .2s ease-in-out;
    width: 36px
}

.smart-kanban[header-position=bottom] .smart-kanban-body,
.smart-kanban[header-position=top] .smart-kanban-body {
    height: calc(100% - 45px);
    height: calc(100% - var(--smart-kanban-header-size) - var(--smart-data-view-padding))
}

.smart-kanban[add-new-button] .smart-kanban-add-new-button:hover {
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
}

.smart-kanban[add-new-button] .smart-kanban-add-new-button:after {
    content: "\\e803";
    content: var(--smart-icon-plus);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px
}

.smart-kanban[add-new-button] .smart-kanban-add-new-button.show {
    opacity: 1
}

.smart-kanban[column-actions] .smart-kanban-column:not(.collapsed)>.smart-kanban-column-header[settings]>.smart-kanban-column-header-settings-button {
    display: block;
    margin-top: -1px;
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-kanban[column-actions] .smart-kanban-column:not(.collapsed)>.smart-kanban-column-header[settings]>.smart-kanban-column-header-settings-button:hover,
.smart-kanban[column-actions] .smart-kanban-column:not(.collapsed)>.smart-kanban-column-header[settings]>.smart-kanban-column-header-settings-button[aria-expanded] {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-kanban[column-actions] .smart-kanban-column:not(.collapsed)>.smart-kanban-column-header[settings]>.smart-kanban-column-header-settings-button:after {
    content: "\\f0c9";
    content: var(--smart-icon-menu);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    margin-left: 5px
}

.smart-kanban[column-actions] .smart-kanban-column:not(.collapsed):not([add-new-button])>.smart-kanban-column-header[settings] {
    grid-template-columns: 1fr auto auto auto
}

.smart-kanban[collapsible] .smart-kanban-column[collapsible]>.smart-kanban-column-header {
    cursor: pointer
}

.smart-kanban[collapsible] .smart-kanban-column[collapsible]>.smart-kanban-column-header:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-kanban[collapsible] .smart-kanban-column[collapsible]>.smart-kanban-column-header>.smart-arrow {
    display: block;
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-kanban[collapsible] .smart-kanban-column[collapsible]>.smart-kanban-column-header>.smart-arrow:hover {
    color: #005c99;
    color: var(--smart-primary);
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
}

.smart-kanban[task-position=leaf] .smart-kanban-column>.smart-kanban-column-content:not(.no-sub-columns) {
    grid-row-gap: 0;
    grid-template-rows: 0 1fr
}

.smart-kanban[user-list] .smart-kanban-task-user:hover {
    border: none;
    box-shadow: 0 0 4px 1px #005c99;
    box-shadow: 0 0 4px 1px var(--smart-primary)
}

.smart-kanban[header-position=top] .smart-data-view-header {
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-kanban[header-position=bottom] .smart-data-view-header {
    margin-top: 10px;
    margin-top: var(--smart-data-view-padding)
}

.smart-kanban[right-to-left] .smart-kanban-body,
.smart-kanban[right-to-left] .smart-kanban-column-header-label,
.smart-kanban[right-to-left] .swimlane {
    direction: rtl
}

.smart-kanban[right-to-left] .smart-kanban-column.collapsed>.smart-kanban-column-header>.smart-kanban-column-header-label {
    margin-bottom: auto
}

.smart-kanban[right-to-left] .smart-kanban-column:not(.collapsed) .smart-kanban-column-header .smart-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.smart-kanban[right-to-left] .smart-kanban-list {
    direction: rtl
}

.smart-kanban[right-to-left] .smart-kanban-list .icon {
    margin-left: 10px;
    margin-right: unset
}

.smart-kanban[right-to-left] .smart-kanban-list .item.selected {
    border-left: unset;
    border-right: 3px solid #005c99;
    border-right: var(--smart-kanban-color-band-width) solid var(--smart-primary);
    padding-left: 10px;
    padding-right: 7px
}

.smart-kanban[right-to-left][add-new-button] .smart-kanban-column[add-new-button]>.smart-kanban-column-header>.smart-kanban-column-header-add:after {
    padding: 0 0 10px 10px
}

.smart-data-view-header {
    height: 35px;
    height: var(--smart-kanban-header-size)
}

.smart-kanban-task {
    grid-row-gap: 5px;
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-left: 3px solid #005c99;
    border-left: var(--smart-kanban-color-band-width) solid var(--smart-primary);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    cursor: pointer;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 1fr auto auto;
    height: auto;
    min-height: 80px;
    min-height: var(--smart-kanban-task-min-height);
    min-width: 0;
    padding: 5px;
    position: relative;
    width: 100%
}

.smart-kanban-task .smart-kanban-task-custom-fields {
    display: grid;
    grid-template-columns: 1fr 1fr
}

.smart-kanban-task .smart-kanban-task-custom-fields .smart-kanban-task-field {
    display: flex;
    flex-direction: column;
    padding: 5px
}

.smart-kanban-task .smart-kanban-task-custom-fields .smart-kanban-task-field .smart-kanban-task-field-label {
    font-size: 12px;
    font-size: calc(var(--smart-font-size) - 2px);
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-card-view-vertical-offset)/3);
    opacity: .7;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase
}

.smart-kanban-task .smart-kanban-task-custom-fields .smart-kanban-task-field .smart-kanban-task-field-value {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word
}

.smart-kanban-task-input {
    background: 0 0;
    border: none !important;
    cursor: pointer;
    font-size: 13px !important;
    font-size: calc(var(--smart-font-size) - 1px) !important;
    height: 20px;
    opacity: .8;
    text-decoration: underline;
    width: 100%
}

.smart-kanban-task-input:active,
.smart-kanban-task-input:focus {
    cursor: auto;
    opacity: 1;
    text-decoration: none;
    text-decoration: initial
}

.smart-kanban-task-subtasks .smart-kanban-sub-task[selected] .label,
.smart-window.smart-kanban-window .checklist-editor smart-list-item[selected] .label {
    text-decoration: line-through
}

.smart-kanban-task-subtasks .smart-kanban-sub-task {
    grid-column-gap: 5px;
    display: grid;
    font-size: 13px !important;
    font-size: calc(var(--smart-font-size) - 1px) !important;
    grid-template-columns: 16px 1fr 16px;
    padding: 2px
}

.smart-kanban-task-subtasks .smart-kanban-sub-task:before {
    content: "\\f096";
    content: var(--smart-icon-check-empty);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-kanban-task-subtasks .smart-kanban-sub-task:hover .remove-subtask:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-kanban-task-subtasks .smart-kanban-sub-task.selected {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-kanban-task-subtasks .smart-kanban-sub-task.selected:before {
    content: "\\e81b";
    content: var(--smart-icon-check-squared)
}

.smart-kanban-task-content {
    grid-column-gap: 5px;
    display: grid;
    grid-template-columns: 1fr auto
}

.smart-kanban-task-text {
    max-height: 200px;
    max-height: var(--smart-kanban-text-max-height);
    overflow: auto;
    padding: 5px;
    word-break: break-word
}

.smart-kanban-task-text:after,
.smart-kanban-task-text:before {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-kanban-task-text:before {
    margin-right: 10px
}

.smart-kanban-task-text:after {
    margin-left: 10px
}

.smart-kanban-task-footer {
    grid-column-gap: 5px;
    align-items: center;
    display: grid;
    grid-template-columns: 1fr auto auto
}

.smart-kanban-task-due {
    display: none;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-kanban-task-due:not(:empty) {
    margin-top: 5px;
    margin-top: calc(var(--smart-data-view-padding)/2)
}

.smart-kanban-task-due.overdue {
    color: #b00020;
    color: var(--smart-error)
}

.smart-kanban-task-due.overdue:after {
    content: "\\e805";
    content: var(--smart-icon-attention-circled);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-kanban-task-info {
    display: grid;
    grid-template-rows: auto auto
}

.smart-kanban-task-checked {
    letter-spacing: 1px
}

.smart-kanban-task-progress {
    background-color: #005c99;
    background-color: var(--smart-primary);
    height: 20%;
    left: 0;
    position: absolute
}

.smart-kanban-task-progress.bottom {
    bottom: 0
}

.smart-kanban-task-progress-container {
    align-items: center;
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    display: none;
    height: 20px;
    justify-content: center;
    position: relative
}

.smart-kanban-task-user {
    display: none
}

.smart-kanban-task-user.empty:after {
    align-items: center;
    content: "\\e81f";
    content: var(--smart-icon-user);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 30px;
    font-size: var(--smart-kanban-user-icon-size);
    height: 100%;
    justify-content: center;
    width: 100%
}

.smart-kanban-task-tags {
    display: none
}

.smart-kanban-task-tag {
    background-color: rgba(0, 92, 153, .15);
    background-color: rgba(var(--smart-primary-rgb), .15);
    border-radius: 20px;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: inline-block;
    margin-right: 5px;
    padding: 5px
}

.smart-kanban-task-actions,
.smart-kanban-task-comments {
    display: none
}

.smart-kanban-task-actions:after {
    content: "\\e833";
    content: var(--smart-icon-settings);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-kanban-task-comments:after {
    content: "\\F0E5",attr(num);
    content: var(--smart-icon-comment);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    white-space: nowrap
}

.smart-kanban-feedback {
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: move;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    opacity: .9;
    position: absolute
}

.smart-kanban-feedback * {
    box-sizing: border-box
}

.smart-kanban-feedback .smart-kanban-task {
    pointer-events: none;
    position: absolute
}

.smart-kanban-feedback .smart-kanban-task,
.smart-kanban-feedback[column-drag] {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4)
}

.smart-kanban-feedback[column-drag] {
    border: none;
    height: auto;
    -webkit-transform: scale(.8);
    transform: scale(.8);
    -webkit-transform-origin: top left;
    transform-origin: top left
}

.smart-kanban-feedback[column-drag] .smart-kanban {
    border: none;
    overflow: visible
}

.smart-kanban-feedback[column-drag] .smart-kanban-task {
    box-shadow: none;
    position: static
}

.smart-kanban-feedback .smart-kanban-feedback-additional,
.smart-kanban-feedback .smart-kanban-feedback-additional.multiple:before {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .14), 0 4px 5px 0 rgba(0, 0, 0, .12), 0 1px 10px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-4);
    pointer-events: none;
    position: absolute
}

.smart-kanban-feedback .smart-kanban-feedback-additional {
    left: 8px;
    top: -8px
}

.smart-kanban-feedback .smart-kanban-feedback-additional.multiple {
    left: 16px;
    top: -16px
}

.smart-kanban-feedback .smart-kanban-feedback-additional.multiple:before {
    bottom: -9px;
    content: "";
    height: 100%;
    left: -9px;
    width: 100%
}

.smart-kanban-feedback .smart-kanban-feedback-additional+.smart-kanban-task:after {
    align-items: center;
    background-color: #005c99;
    background-color: var(--smart-primary);
    border-radius: 50%;
    color: #fff;
    color: var(--smart-primary-color);
    content: attr(num);
    display: flex;
    height: 20px;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px
}

.smart-kanban-feedback[right-to-left] .smart-kanban-task {
    direction: rtl
}

[task-progress] .smart-kanban-task-progress-container {
    display: flex
}

[task-user-icon] .smart-kanban-task-user {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 50%;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    height: 30px;
    height: var(--smart-kanban-user-icon-size);
    width: 30px;
    width: var(--smart-kanban-user-icon-size)
}

[task-tags] .smart-kanban-task-tags {
    display: flex;
    flex-direction: row;
    overflow: hidden
}

[task-actions] .smart-kanban-task-actions,
[task-comments] .smart-kanban-task-comments,
[task-due] .smart-kanban-task-due {
    display: block
}

[task-priority] .smart-kanban-task-text {
    align-items: center;
    display: flex
}

[task-priority] .smart-kanban-task-text .priority {
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    margin-left: 5px;
    width: 16px
}

[task-priority] .smart-kanban-task-text .priority.low {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%232666BE'%3E%3Cpath d='M2.738 7.002C1.966 5.67 2.928 4 4.468 4h15.063c1.54 0 2.503 1.669 1.731 3.002L13.731 20.01c-.77 1.33-2.691 1.33-3.462 0L2.738 7.002Z'/%3E%3C/svg%3E")
}

[task-priority] .smart-kanban-task-text .priority.average {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23005C99'%3E%3Cpath d='M12 5.99 19.53 19H4.47L12 5.99ZM2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18Z'/%3E%3C/svg%3E")
}

[task-priority] .smart-kanban-task-text .priority.high {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23DD5347'%3E%3Cpath d='M2.738 17.998C1.966 19.33 2.928 21 4.468 21h15.063c1.54 0 2.503-1.669 1.731-3.002L13.731 4.99c-.77-1.33-2.691-1.33-3.462 0L2.738 17.998Z'/%3E%3C/svg%3E")
}

[task-priority] .smart-kanban-task-text .priority.critical {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23AF0020'%3E%3Cpath d='M2.738 17.998C1.966 19.33 2.928 21 4.468 21h15.063c1.54 0 2.503-1.669 1.731-3.002L13.731 4.99c-.77-1.33-2.691-1.33-3.462 0L2.738 17.998ZM13.5 17.5a1.5 1.5 0 0 1-3 0 1.5 1.5 0 0 1 3 0Zm0-4a1.5 1.5 0 0 1-3 0v-4a1.5 1.5 0 0 1 3 0v4Z'/%3E%3C/svg%3E")
}

[right-to-left] .smart-kanban-task {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-right-radius);
    border-bottom-right-radius: 0;
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: 3px solid #005c99;
    border-right: var(--smart-kanban-color-band-width) solid var(--smart-primary);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-right-radius);
    border-top-right-radius: 0
}

[right-to-left] .smart-kanban-task-progress {
    left: unset;
    right: 0
}

.smart-window.smart-kanban-window {
    max-height: 800px;
    max-width: 700px;
    min-width: 700px !important;
    width: auto !important
}

.smart-window.smart-kanban-window .smart-kanban-tab-strip {
    background: inherit;
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    display: flex;
    height: 35px;
    margin-bottom: 10px
}

.smart-window.smart-kanban-window .smart-kanban-tab-strip .smart-kanban-tab {
    cursor: pointer;
    padding: 8px 22px;
    text-transform: uppercase
}

.smart-window.smart-kanban-window .smart-kanban-tab-strip .smart-kanban-tab.selected {
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-window.smart-kanban-window .details .layout {
    grid-column-gap: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr
}

.smart-window.smart-kanban-window .details .layout .description-editor {
    height: 91px
}

.smart-window.smart-kanban-window .details .layout .tags-editor {
    margin-top: 2px
}

.smart-window.smart-kanban-window .details .layout .text-editor {
    height: 32px
}

.smart-window.smart-kanban-window .smart-kanban-task-user {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 50%;
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: block;
    height: 30px;
    height: var(--smart-kanban-user-icon-size);
    width: 30px;
    width: var(--smart-kanban-user-icon-size)
}

.smart-window.smart-kanban-window .fields .smart-kanban-task-field-editor {
    width: 100%
}

.smart-window.smart-kanban-window .fields .editor-label {
    display: flex;
    justify-content: space-between
}

.smart-window.smart-kanban-window .fields .editor-label .icon {
    display: inline-block;
    height: 16px;
    width: 16px
}

.smart-window.smart-kanban-window .fields .editor-label .icon:before {
    content: "\\e90d";
    content: var(--smart-icon-visibility);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-window.smart-kanban-window .fields .editor-label .icon.hide:before {
    content: "\\e90e";
    content: var(--smart-icon-visibility-off)
}

.smart-window.smart-kanban-window .history-table {
    display: block !important;
    max-height: 400px;
    overflow: auto
}

.smart-window.smart-kanban-window .history-table table {
    border-collapse: collapse;
    width: 100%
}

.smart-window.smart-kanban-window .history-table table .smart-kanban-task-user-history {
    align-items: center;
    display: flex
}

.smart-window.smart-kanban-window .history-table table .smart-kanban-task-user-history .name {
    margin-left: 5px
}

.smart-window.smart-kanban-window .history-table table td,
.smart-window.smart-kanban-window .history-table table th {
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    padding: 8px
}

.smart-window.smart-kanban-window .history-table table tr:nth-child(2n) {
    background-color: #f5f5f5;
    background-color: var(--smart-surface);
    color: #323232;
    color: var(--smart-surface-color)
}

.smart-window.smart-kanban-window .history-table table tr:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-window.smart-kanban-window .history-table table th {
    background-color: #5cc0de;
    background-color: var(--smart-info);
    color: #fff;
    color: var(--smart-info-color);
    padding-bottom: 12px;
    padding-top: 12px;
    text-align: left
}

.smart-window.smart-kanban-window .comments {
    margin: 0 auto
}

.smart-window.smart-kanban-window .comments .comment {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-columns: 30px 1fr;
    grid-template-columns: var(--smart-kanban-user-icon-size) 1fr;
    margin: 10px;
    margin: var(--smart-data-view-padding)
}

.smart-window.smart-kanban-window .comments .comment .comment-header {
    grid-column-gap: 5px;
    grid-column-gap: calc(var(--smart-data-view-padding)/2);
    display: grid;
    grid-template-columns: 1fr auto auto;
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-window.smart-kanban-window .comments .comment .user-icon {
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    height: 30px;
    height: var(--smart-kanban-user-icon-size);
    width: 100%
}

.smart-window.smart-kanban-window .comments .comment .user-icon.empty {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 50%;
    display: flex;
    justify-content: center
}

.smart-window.smart-kanban-window .comments .comment .user-icon.empty:after {
    content: "\\e81f";
    content: var(--smart-icon-user);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 20px
}

.smart-window.smart-kanban-window .comments .comment .user-name {
    font-weight: 700
}

.smart-window.smart-kanban-window .comments .comment .time {
    opacity: .8
}

.smart-window.smart-kanban-window .comments .comment .remove-button {
    cursor: pointer;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    visibility: hidden;
    width: 16px
}

.smart-window.smart-kanban-window .comments .comment .remove-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center
}

.smart-window.smart-kanban-window .comments .comment .remove-button.enabled {
    visibility: visible
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments {
    height: 400px;
    height: var(--smart-kanban-comments-list-height);
    max-height: 100%;
    width: 350px;
    width: var(--smart-kanban-comments-list-width)
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-comments {
    overflow: auto
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment {
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-data-view-padding)
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment textarea {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-family: inherit;
    font-size: inherit;
    resize: none;
    width: 100%
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment textarea:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment textarea:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-window.smart-kanban-window .description-editor,
.smart-window.smart-kanban-window .new-subtask {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color);
    font-size: inherit
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment textarea[disabled] {
    opacity: .5
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment smart-button {
    --smart-button-padding: 0;
    display: block;
    height: 30px;
    height: var(--smart-kanban-send-button-height);
    margin-left: auto
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment smart-button[disabled] {
    cursor: not-allowed;
    pointer-events: unset
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-comments {
    height: calc(100% - 175px);
    height: calc(100% - var(--smart-kanban-new-comment-height-expanded))
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment {
    height: 175px;
    height: var(--smart-kanban-new-comment-height-expanded)
}

.smart-window.smart-kanban-window .comments .smart-kanban-list.comments .smart-kanban-new-comment textarea {
    display: block;
    height: calc(100% - 40px);
    height: calc(100% - var(--smart-data-view-padding) - var(--smart-kanban-send-button-height));
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding)
}

.smart-window.smart-kanban-window .edit,
.smart-window.smart-kanban-window .prompt {
    display: none
}

.smart-window.smart-kanban-window.prompt {
    --smart-window-default-width: 250px;
    --smart-window-default-height: 150px;
    min-height: 100px;
    min-width: 100px
}

.smart-window.smart-kanban-window.prompt .prompt {
    display: block;
    height: 100%;
    padding: 20px;
    width: 100%
}

.smart-window.smart-kanban-window.prompt .task-text {
    display: inline-block;
    font-weight: 700;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-window.smart-kanban-window.edit {
    --smart-numeric-text-box-default-unit-display-width: 20px
}

.smart-window.smart-kanban-window.edit .edit {
    display: block;
    height: 100%;
    width: 100%
}

.smart-window.smart-kanban-window .editor-label {
    margin-bottom: 5px;
    margin-bottom: calc(var(--smart-data-view-padding)/2);
    text-transform: uppercase
}

.smart-window.smart-kanban-window .editor-container {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto
}

.smart-window.smart-kanban-window .editor-container.single-column {
    grid-template-columns: 1fr
}

.smart-window.smart-kanban-window .editor {
    margin-bottom: 10px;
    margin-bottom: var(--smart-data-view-padding);
    width: 100%
}

.smart-window.smart-kanban-window .description-editor {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    font-family: inherit;
    min-height: 75px;
    resize: none
}

.smart-window.smart-kanban-window .description-editor:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-window.smart-kanban-window .description-editor:focus {
    border-color: #005c99;
    border-color: var(--smart-primary);
    outline: 0
}

.smart-window.smart-kanban-window .new-container {
    grid-column-gap: 10px;
    grid-column-gap: var(--smart-data-view-padding);
    display: grid;
    grid-template-columns: 1fr 30px;
    grid-template-columns: 1fr var(--smart-text-box-default-height);
    height: 30px;
    height: var(--smart-text-box-default-height)
}

.smart-window.smart-kanban-window .new-container>smart-button {
    --smart-button-padding: 0;
    height: unset;
    width: unset
}

.smart-window.smart-kanban-window .color-editor {
    width: 60px
}

.smart-window.smart-kanban-window .checklist-editor {
    border: none;
    height: auto
}

.smart-window.smart-kanban-window .checklist-editor smart-list-item .smart-overlay,
.smart-window.smart-kanban-window .checklist-editor smart-list-item[focus][selected] .smart-overlay {
    background-color: transparent
}

.smart-window.smart-kanban-window .checklist-editor smart-list-item .smart-list-item-container,
.smart-window.smart-kanban-window .checklist-editor smart-list-item[focus][selected] .smart-list-item-container {
    border-color: transparent
}

.smart-window.smart-kanban-window .checklist-editor .smart-kanban-sub-task {
    grid-column-gap: 5px;
    display: grid;
    grid-template-columns: auto auto
}

.smart-window.smart-kanban-window .checklist-editor .remove-subtask:after {
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon)
}

.smart-window.smart-kanban-window .new-subtask {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    font-family: inherit
}

.smart-window.smart-kanban-window .new-subtask:hover {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

.smart-window.smart-kanban-window .new-subtask:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline);
    outline: 0
}

.smart-window.smart-kanban-window .smart-content-container>.smart-footer {
    align-items: center;
    display: flex
}

.smart-window.smart-kanban-window .smart-footer smart-button {
    height: 100%;
    margin-right: 10px;
    min-width: 150px;
    width: auto
}

@media only screen and (max-width:600px) {
    .smart-window.smart-kanban-window {
        min-width: 300px !important
    }

    .smart-window.smart-kanban-window .details .layout {
        grid-template-columns: 1fr
    }
}

.smart-color-input-drop-down-menu.smart-kanban-color-input .grid-samples-container {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.smart-color-input-drop-down-menu.smart-kanban-color-input:not([animation=none]) .default-samples-container div {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

.smart-color-input-drop-down-menu.smart-kanban-color-input .default-samples-container div {
    border: initial;
    border-radius: 50%;
    position: relative;
    -webkit-transform: scale(.95);
    transform: scale(.95)
}

.smart-color-input-drop-down-menu.smart-kanban-color-input .default-samples-container div.selected {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-color-input-drop-down-menu.smart-kanban-color-input .default-samples-container div.selected:not(.no-color):after {
    align-items: center;
    border-radius: inherit;
    color: #fff;
    color: var(--smart-secondary-color);
    content: "\\e908";
    content: var(--smart-icon-check);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-kanban-color-input {
    --smart-input-drop-down-menu-width: auto
}

.smart-kanban-color-input.smart-color-picker {
    background: 0 0 !important
}

.smart-kanban-color-input .smart-action-button {
    background: 0 0 !important;
    border: none !important;
    width: 100%
}

.smart-kanban-color-input .smart-action-button .smart-color-box {
    border-radius: 50%
}

.smart-kanban-color-input .smart-drop-down-button {
    display: none
}

smart-layout {
    --smart-layout-buttons-border-radius: 50%;
    --smart-layout-context-menu-default-width: var(--smart-menu-vertical-default-width);
    --smart-layout-context-menu-default-height: auto;
    display: block;
    height: 600px;
    overflow: visible;
    overflow: initial;
    width: 600px
}

smart-layout>.smart-container {
    position: relative
}

smart-tab-layout-group[position=left] .smart-layout-tab,
smart-tab-layout-group[position=right] .smart-layout-tab {
    padding: 24px 12px
}

.smart-layout-tab,
smart-tab-layout-group[position=bottom] .smart-layout-tab,
smart-tab-layout-group[position=top] .smart-layout-tab {
    padding: 12px 24px
}

smart-tab-layout-group[position=left] .smart-layout-tab:after,
smart-tab-layout-group[position=right] .smart-layout-tab:after {
    border-radius: 0 8px 8px 0;
    bottom: 0;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: -1px;
    top: 0;
    -webkit-transform: perspective(5px) rotateY(2deg);
    transform: perspective(5px) rotateY(2deg);
    -webkit-transform-origin: left;
    transform-origin: left;
    transition: all .2s ease;
    width: 100%
}

smart-tab-layout-group[position=right] .smart-layout-tab label,
smart-tab-layout-group[position=right] .smart-layout-tab.selected .smart-close-button {
    margin-right: 5px
}

smart-tab-layout-group[position=left] .smart-layout-tab:after {
    border-radius: 0 8px 8px 0;
    right: 0
}

smart-tab-layout-group[position=left] .smart-layout-tab label,
smart-tab-layout-group[position=left] .smart-layout-tab.selected .smart-close-button {
    margin-left: -5px;
    -webkit-transform: rotateY(0);
    transform: rotateY(0)
}

smart-tab-layout-group[position=bottom] .smart-layout-tab:after {
    border-radius: 0 0 8px 8px;
    top: 0;
    -webkit-transform: perspective(5px) rotateX(-2deg);
    transform: perspective(5px) rotateX(-2deg);
    -webkit-transform-origin: top;
    transform-origin: top
}

smart-tab-layout-group[position=bottom] .smart-layout-tab label,
smart-tab-layout-group[position=bottom] .smart-layout-tab.selected .smart-close-button {
    margin-top: -5px
}

.smart-layout smart-layout-group {
    display: grid;
    overflow: hidden
}

.smart-layout smart-layout-group[data-id=root] {
    grid-template-columns: 1fr;
    height: 100%;
    overflow: hidden;
    width: 100%
}

.smart-layout smart-tab-layout-group {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border);
    display: grid;
    grid-template-rows: 35px 1fr;
    overflow: hidden
}

.smart-layout smart-tab-layout-group .smart-layout-tab-strip {
    background: #f5f5f5;
    background: var(--smart-surface);
    border-bottom: 2px solid #005c99;
    border-bottom: 2px solid var(--smart-primary);
    display: flex;
    overflow: hidden
}

.smart-layout smart-tab-layout-group[position=bottom] {
    grid-template-rows: 1fr 35px
}

.smart-layout smart-tab-layout-group[position=bottom]>.smart-layout-tab-strip {
    border: none;
    border-top: 2px solid #005c99;
    border-top: 2px solid var(--smart-primary)
}

.smart-layout smart-tab-layout-group[position=left] .smart-layout-tab-strip .smart-layout-tab .smart-close-button:after,
.smart-layout smart-tab-layout-group[position=right] .smart-layout-tab-strip .smart-layout-tab .smart-close-button:after {
    margin-left: 0;
    margin-top: 5px
}

.smart-layout smart-tab-layout-group[position=left] {
    grid-template-columns: 35px 1fr;
    grid-template-rows: none
}

.smart-layout smart-tab-layout-group[position=left]>.smart-layout-tab-strip {
    align-items: center;
    border: none;
    border-left: 2px solid #005c99;
    border-left: 2px solid var(--smart-primary);
    justify-content: flex-end;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl
}

.smart-layout smart-tab-layout-group[position=right] {
    grid-template-columns: 1fr 35px;
    grid-template-rows: none
}

.smart-layout smart-tab-layout-group[position=right]>.smart-layout-tab-strip {
    align-items: center;
    border: none;
    border-left: 2px solid #005c99;
    border-left: 2px solid var(--smart-primary);
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl
}

.smart-layout smart-tab-layout-group[orientation=vertical] {
    height: 100%
}

.smart-layout smart-tab-layout-group[orientation=horizontal] {
    width: 100%
}

.smart-layout smart-tab-layout-item {
    overflow: hidden
}

.smart-layout smart-tab-layout-item>smart-layout-group {
    height: 100%;
    width: 100%
}

.smart-layout .smart-layout-context-menu {
    background: #fefefe;
    background: var(--smart-background);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    color: #5a5a5a;
    color: var(--smart-background-color);
    height: var(--smart-layout-context-menu-default-height);
    opacity: 1;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    transform-origin: 0;
    -webkit-transform-origin: 0;
    width: var(--smart-layout-context-menu-default-width);
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-layout .smart-layout-context-menu.smart-visibility-hidden {
    opacity: .2;
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-layout .smart-layout-context-menu>div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 10px;
    width: 100%
}

.smart-layout .smart-layout-context-menu>div:not([disabled]) {
    cursor: pointer
}

.smart-layout .smart-layout-context-menu>div[hover] {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-layout .smart-layout-context-menu>div[disabled] {
    cursor: default;
    opacity: .5;
    pointer-events: none
}

.smart-layout .smart-layout-buttons-container {
    height: 100px;
    left: calc(50% - 50px);
    position: absolute;
    top: calc(50% - 50px);
    width: 100px;
    z-index: 9999
}

.smart-layout .smart-layout-buttons-container div {
    align-items: center;
    background: #005c99;
    background: var(--smart-primary);
    border-bottom-left-radius: var(--smart-layout-buttons-border-radius);
    border-bottom-right-radius: var(--smart-layout-buttons-border-radius);
    border-top-left-radius: var(--smart-layout-buttons-border-radius);
    border-top-right-radius: var(--smart-layout-buttons-border-radius);
    color: #fff;
    color: var(--smart-primary-color);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 27px;
    height: var(--smart-editor-addon-width);
    justify-content: center;
    left: calc(50% - 13.5px);
    left: calc(50% - var(--smart-editor-addon-width)/2);
    padding: 5px;
    position: absolute;
    touch-action: none;
    width: 27px;
    width: var(--smart-editor-addon-width);
    z-index: 1
}

.smart-layout .smart-layout-buttons-container div:after {
    content: "\\e803";
    content: var(--smart-icon-plus)
}

.smart-layout .smart-layout-buttons-container div:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    border-color: #005c99;
    border-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active);
    opacity: var(--smart-button-opacity-active)
}

.smart-layout .smart-layout-buttons-container div:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover);
    opacity: var(--smart-button-opacity-active)
}

.smart-layout .smart-layout-buttons-container div[position=rotate]:after {
    content: "\\e809";
    content: var(--smart-icon-reload)
}

.smart-layout .smart-layout-buttons-container div[position=center],
.smart-layout .smart-layout-buttons-container div[position=left] {
    top: calc(50% - 13.5px);
    top: calc(50% - var(--smart-editor-addon-width)/2)
}

.smart-layout .smart-layout-buttons-container div[position=left] {
    left: 0
}

.smart-layout .smart-layout-buttons-container div[position=right] {
    left: auto;
    right: 0;
    top: calc(50% - 13.5px);
    top: calc(50% - var(--smart-editor-addon-width)/2)
}

.smart-layout .smart-layout-buttons-container div[position=top] {
    top: 0
}

.smart-layout .smart-layout-buttons-container div[position=bottom] {
    bottom: 0
}

.smart-layout .smart-layout-drop-area {
    background: rgba(0, 92, 153, .2);
    background: rgba(var(--smart-primary-rgb), .2);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity .2s ease-in-out;
    width: 100%;
    z-index: 99
}

.smart-layout .smart-layout-item {
    background: #fefefe;
    background: var(--smart-background);
    border-bottom: 1px solid #e0e0e0;
    border-bottom: 1px solid var(--smart-border);
    border-right: 1px solid #e0e0e0;
    border-right: 1px solid var(--smart-border);
    height: auto;
    overflow: hidden
}

.smart-layout .smart-layout-item[hover] {
    overflow: hidden
}

.smart-layout [data-id] {
    position: relative
}

.smart-layout:not([animation=none]) .smart-layout-context-menu {
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, transform .2s ease-in, -webkit-transform .2s ease-in
}

.smart-layout:not([animation=none]) .smart-layout-buttons-container div:active,
.smart-layout:not([animation=none]) .smart-layout-buttons-container div:hover {
    transition: background-color .1s linear, box-shadow .28s ease-in-out
}

.smart-layout:not([animation=none]) .smart-layout-buttons-container div[position=left] {
    -webkit-animation: leftRight .2s ease-in;
    animation: leftRight .2s ease-in
}

.smart-layout:not([animation=none]) .smart-layout-buttons-container div[position=right] {
    -webkit-animation: rightLeft .2s ease-in;
    animation: rightLeft .2s ease-in
}

.smart-layout:not([animation=none]) .smart-layout-buttons-container div[position=top] {
    -webkit-animation: topBottom .2s ease-in;
    animation: topBottom .2s ease-in
}

.smart-layout :not([animation=none]) .smart-layout-buttons-container div[position=bottom] {
    -webkit-animation: bottomTop .2s ease-in;
    animation: bottomTop .2s ease-in
}

.smart-layout.outline .smart-layout-splitter {
    opacity: 1
}

.smart-layout .smart-layout-splitter {
    background: #e0e0e0;
    background: var(--smart-border);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity .2s ease-in-out;
    z-index: 999
}

.smart-layout .smart-layout-splitter:hover {
    border-color: #005c99;
    border-color: var(--smart-primary);
    border-style: dashed
}

.smart-layout .smart-layout-splitter:not([root-splitter]) {
    transition: opacity .2s ease-in-out, width .2s ease-in-out, height .2s ease-in-out
}

.smart-layout .smart-layout-splitter.active {
    background: #005c99;
    background: var(--smart-primary);
    border-color: #005c99;
    border-color: var(--smart-primary)
}

.smart-layout .smart-layout-splitter.error {
    background: #b00020;
    background: var(--smart-error);
    border-color: #b00020;
    border-color: var(--smart-error)
}

.smart-layout .smart-layout-splitter.horizontal {
    bottom: 0;
    cursor: s-resize;
    height: 1px;
    top: auto;
    width: 100%
}

.smart-layout .smart-layout-splitter.horizontal.last {
    bottom: auto;
    display: none;
    top: 0
}

.smart-layout .smart-layout-splitter.vertical {
    cursor: e-resize;
    height: 100%;
    left: auto;
    right: 0;
    width: 1px
}

.smart-layout .smart-layout-splitter.vertical.last {
    display: none;
    left: 0;
    right: auto
}

.smart-layout .smart-layout-group[hover]>.smart-layout-splitter.horizontal,
.smart-layout .smart-layout-group[hover]>.smart-layout-splitter.vertical,
.smart-layout .smart-layout-item[hover]>.smart-layout-splitter.horizontal,
.smart-layout .smart-layout-item[hover]>.smart-layout-splitter.vertical,
.smart-layout .smart-layout-splitter[drag].horizontal,
.smart-layout .smart-layout-splitter[drag].vertical {
    opacity: 1;
    z-index: 99
}

.smart-layout-tab {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    grid-row: 1;
    justify-content: center;
    min-width: 0;
    overflow: hidden;
    position: relative;
    transition: background-color .2s ease-in-out
}

.smart-layout-tab:after {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    bottom: 0;
    content: "";
    height: 120%;
    left: 0;
    position: absolute;
    right: 0;
    -webkit-transform: perspective(5px) rotateX(2deg);
    transform: perspective(5px) rotateX(2deg);
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
    transition: all .2s ease;
    width: 100%
}

.smart-layout-tab:hover {
    color: #005c99;
    color: var(--smart-primary)
}

.smart-layout-tab.selected {
    color: #fff;
    color: var(--smart-primary-color)
}

.smart-layout-tab.selected:after {
    background: #005c99;
    background: var(--smart-primary)
}

.smart-layout-tab.selected .smart-close-button {
    color: inherit;
    z-index: 10
}

.smart-layout-tab.selected .smart-close-button:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 16px;
    justify-content: center;
    margin-left: 5px;
    pointer-events: none;
    text-align: center;
    width: 16px
}

.smart-layout-tab label {
    color: inherit;
    cursor: pointer;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 9
}

.smart-layout-feedback {
    background: #fefefe;
    background: var(--smart-background);
    box-shadow: 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12), 0 11px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-24);
    height: 150px;
    left: 0;
    max-height: 150px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    top: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: top left;
    transform-origin: top left;
    transition: -webkit-transform .25s ease-in-out;
    transition: transform .25s ease-in-out;
    transition: transform .25s ease-in-out, -webkit-transform .25s ease-in-out;
    width: 300px
}

.smart-layout-feedback.dragging {
    -webkit-transform: scale(.5);
    transform: scale(.5)
}

.smart-layout-overlay {
    background: #000;
    height: 100%;
    left: 0;
    opacity: .01;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 999
}

@-webkit-keyframes topBottom {
    0% {
        top: -27px;
        top: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        top: 0
    }
}

@keyframes topBottom {
    0% {
        top: -27px;
        top: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        top: 0
    }
}

@-webkit-keyframes bottomTop {
    0% {
        bottom: -27px;
        bottom: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        bottom: 0
    }
}

@keyframes bottomTop {
    0% {
        bottom: -27px;
        bottom: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        bottom: 0
    }
}

@-webkit-keyframes leftRight {
    0% {
        left: -27px;
        left: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        left: 0
    }
}

@keyframes leftRight {
    0% {
        left: -27px;
        left: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        left: 0
    }
}

@-webkit-keyframes rightLeft {
    0% {
        right: -27px;
        right: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        right: 0
    }
}

@keyframes rightLeft {
    0% {
        right: -27px;
        right: calc(var(--smart-editor-addon-width)*-1)
    }

    to {
        right: 0
    }
}

smart-scheduler {
    --smart-scheduler-event-size: var(--smart-scheduler-event-size-basic);
    contain: content;
    display: block;
    height: auto;
    height: var(--smart-scheduler-default-height);
    width: auto;
    width: var(--smart-scheduler-default-width)
}

smart-scheduler.smart-container,
smart-scheduler>.smart-container {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 50px minmax(0, 1fr);
    grid-template-rows: var(--smart-scheduler-header-height) minmax(0, 1fr);
    margin-bottom: -2px;
    overflow: hidden
}

smart-scheduler.smart-container[show-footer],
smart-scheduler>.smart-container[show-footer] {
    grid-template-rows: 50px minmax(0, 1fr) 50px;
    grid-template-rows: var(--smart-scheduler-header-height) minmax(0, 1fr) var(--smart-scheduler-footer-height)
}

smart-scheduler.smart-container.hscroll .smart-scheduler-view,
smart-scheduler>.smart-container.hscroll .smart-scheduler-view {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

smart-scheduler.smart-container.vscroll .smart-scheduler-view,
smart-scheduler>.smart-container.vscroll .smart-scheduler-view {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

smart-scheduler .smart-scheduler-nav[current],
smart-scheduler .smart-scheduler-nav[next],
smart-scheduler .smart-scheduler-nav[prev],
smart-scheduler .smart-scheduler-nav[today] {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    display: inline-block;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: medium;
    font-weight: inherit;
    height: 100%;
    min-width: 30px;
    min-width: var(--smart-scheduler-header-navigation-button-size);
    position: relative;
    text-transform: none;
    width: 30px;
    width: var(--smart-scheduler-header-navigation-button-size)
}

smart-scheduler .smart-scheduler-nav[current]:after,
smart-scheduler .smart-scheduler-nav[next]:after,
smart-scheduler .smart-scheduler-nav[prev]:after {
    align-items: center;
    color: inherit;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

smart-scheduler .smart-scheduler-nav[current]:after {
    background: 0 0;
    color: inherit;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    left: auto;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    right: 0;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-scheduler .smart-scheduler-nav[today] {
    --smart-button-padding: 0 10px 0 10px;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    margin-right: 10px;
    width: 70px;
    width: var(--smart-scheduler-header-today-button-size)
}

smart-scheduler .smart-scheduler-nav[today] button {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-nav[next][focus] button,
smart-scheduler .smart-scheduler-nav[prev][focus] button {
    background-color: var(--smart-background-focus);
    outline: 0
}

smart-scheduler .smart-scheduler-nav[next] .smart-button,
smart-scheduler .smart-scheduler-nav[prev] .smart-button {
    border: none;
    border-radius: 0;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    min-height: 0;
    min-height: auto;
    padding: 0
}

smart-scheduler .smart-scheduler-header,
smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell[group-separator]:not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler .smart-scheduler-nav[prev]:after {
    content: "\\e902";
    content: var(--smart-icon-arrow-left)
}

smart-scheduler .smart-scheduler-nav[next]:after {
    content: "\\e903";
    content: var(--smart-icon-arrow-right)
}

smart-scheduler .smart-scheduler-header {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    display: grid;
    grid-template-areas: "date view";
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: 100%;
    height: 50px;
    height: var(--smart-scheduler-header-height);
    justify-content: start;
    width: 100%
}

smart-scheduler .smart-scheduler-footer:empty,
smart-scheduler .smart-scheduler-header:empty {
    display: none
}

smart-scheduler .smart-scheduler-header[responsive-mode] {
    grid-template-columns: repeat(2, auto)
}

smart-scheduler .smart-scheduler-footer {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border);
    height: 50px;
    height: var(--smart-scheduler-footer-height);
    justify-content: center;
    width: 100%
}

smart-scheduler .smart-scheduler-view {
    display: grid;
    grid-template-areas: "hHeader hHeader","vHeader content";
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
    height: 100%;
    outline: 0;
    overflow: hidden;
    position: relative;
    text-align: center
}

smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-vertical {
    display: grid;
    grid-template-columns: repeat(2, auto)
}

smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-groups-container {
    flex-direction: row
}

smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell-container[group-separator]:not(:last-of-type),
smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell:not(.scale)[group-separator]:not(:last-of-type),
smart-scheduler .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell[group-separator]:not(:last-of-type) {
    border-bottom-color: #b2b2b2;
    border-bottom-color: var(--smart-scheduler-timeline-group-separator-background);
    border-bottom-width: 1px;
    border-bottom-width: var(--smart-scheduler-timeline-group-separator-size)
}

smart-scheduler .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-groups-container {
    flex-direction: column
}

smart-scheduler .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-groups-container .smart-scheduler-cell-container:not(:last-of-type)>.smart-scheduler-cell {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-horizontal-line-color)
}

smart-scheduler .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell-container[group-separator]:not(:last-of-type),
smart-scheduler .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell:not(.scale)[group-separator]:not(:last-of-type),
smart-scheduler .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell[group-separator]:not(:last-of-type) {
    border-right-color: #b2b2b2;
    border-right-width: 1px;
    border-right: var(--smart-scheduler-timeline-group-separator-size) solid var(--smart-scheduler-timeline-group-separator-background)
}

smart-scheduler .smart-scheduler-view:focus .smart-scheduler-cell:not(.scale)[selected] {
    background: rgba(0, 92, 153, .1);
    background: var(--smart-ui-state-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

smart-scheduler .smart-scheduler-view:focus .smart-scheduler-cell:not(.scale)[selected=start] {
    background: #005c99;
    background: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

smart-scheduler .smart-scheduler-view[event-hovered=left],
smart-scheduler .smart-scheduler-view[event-hovered=left] .smart-scheduler-event-content,
smart-scheduler .smart-scheduler-view[event-hovered=right],
smart-scheduler .smart-scheduler-view[event-hovered=right] .smart-scheduler-event-content {
    cursor: e-resize
}

smart-scheduler .smart-scheduler-view[event-hovered=bottom],
smart-scheduler .smart-scheduler-view[event-hovered=bottom] .smart-scheduler-event-content,
smart-scheduler .smart-scheduler-view[event-hovered=top],
smart-scheduler .smart-scheduler-view[event-hovered=top] .smart-scheduler-event-content {
    cursor: n-resize
}

smart-scheduler .smart-scheduler-view[mobile] .smart-scheduler-content:not(.hide-overlay):after {
    content: "";
    display: block;
    height: 100%;
    position: fixed;
    width: 100%
}

smart-scheduler .smart-scheduler-view[mobile] .smart-scheduler-event[collector] {
    align-items: center;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    overflow: hidden
}

smart-scheduler .smart-scheduler-view[mobile] .smart-scheduler-event[collector] .smart-scheduler-event-content {
    height: 28px;
    height: var(--smart-scheduler-event-collector-mobile-size);
    width: 28px;
    width: var(--smart-scheduler-event-collector-mobile-size)
}

smart-scheduler .smart-scheduler-view-nav {
    align-items: center;
    display: flex;
    grid-area: view;
    height: 100%;
    justify-content: flex-end;
    overflow: hidden
}

smart-scheduler .smart-scheduler-view-nav .smart-scheduler-nav[next],
smart-scheduler .smart-scheduler-view-nav .smart-scheduler-nav[prev] {
    --smart-background: transparent;
    --smart-disabled: transparent;
    border: initial;
    border-radius: 0;
    border-radius: initial
}

smart-scheduler .smart-scheduler-view-nav[show-menu] {
    padding: 10px;
    padding: var(--smart-scheduler-header-padding)
}

smart-scheduler .smart-scheduler-view-nav.no-overflowing .smart-scheduler-items-container {
    overflow: hidden
}

smart-scheduler .smart-scheduler-view-header {
    box-shadow: none;
    box-shadow: var(--smart-scheduler-header-box-shadow);
    position: relative
}

smart-scheduler .smart-scheduler-view-header-vertical {
    display: grid;
    grid-area: vHeader;
    grid-template-columns: repeat(2, auto);
    height: 100%
}

smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-view-details {
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-details-size)
}

smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-groups-container {
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-group-size)
}

smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-cells {
    background: #fefefe;
    background: var(--smart-background);
    border: none;
    position: relative;
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-cells-size)
}

smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-cell {
    align-items: flex-start;
    min-width: 0;
    min-width: auto;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-cell>div {
    background: inherit;
    overflow: hidden;
    padding: initial;
    padding: var(--smart-scheduler-timeline-header-vertical-label-padding);
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-view-header-vertical-content {
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-horizontal {
    display: grid;
    grid-area: hHeader;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-view-details {
    height: 40px;
    height: var(--smart-scheduler-timeline-header-horizontal-details-size)
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-groups-container {
    height: 40px;
    height: var(--smart-scheduler-timeline-header-horizontal-group-size)
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-horizontal-line-color);
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    overflow: hidden;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-cells {
    display: flex;
    height: 40px;
    height: var(--smart-scheduler-timeline-header-horizontal-cells-size);
    min-height: inherit;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-cells .smart-scheduler-cell {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color);
    display: flex;
    height: 100%;
    min-height: inherit;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-cells .smart-scheduler-cell>div {
    overflow: hidden;
    padding: initial;
    padding: var(--smart-scheduler-timeline-header-horizontal-label-padding);
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-cells .smart-scheduler-cell:first-of-type {
    border-left: none
}

smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-view-groups-content {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler .smart-scheduler-view-header-horizontal-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-groups-container {
    display: flex;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-groups-container .smart-scheduler-cell-container {
    height: 100%;
    min-height: 0;
    min-height: auto;
    min-width: 0;
    min-width: auto;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-header-groups-container .smart-scheduler-cell {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color);
    height: 100%
}

smart-scheduler .smart-scheduler-view-time {
    display: flex;
    position: relative
}

smart-scheduler .smart-scheduler-view-all-day {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-day-week-view-hour-size) solid var(--smart-scheduler-day-week-view-hour-color);
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    height: 75px;
    height: var(--smart-scheduler-timeline-header-all-day-cells-size)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-cell[all-day] {
    border-left: initial;
    height: 100%
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event {
    height: 30px;
    height: var(--smart-scheduler-event-size);
    padding: 2px;
    padding: var(--smart-scheduler-event-padding-all-day)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event:after {
    left: calc(100% - 4px);
    left: calc(100% - var(--smart-scheduler-event-resize-indicator-size));
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event:before {
    left: 0;
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event .smart-scheduler-event-button {
    display: none
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event[repeating] .smart-scheduler-event-content[single-line] {
    grid-template-columns: repeat(2, auto) 30px;
    grid-template-columns: repeat(2, auto) var(--smart-scheduler-event-icon-size)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event-content {
    grid-template-columns: minmax(auto, 1fr)
}

smart-scheduler .smart-scheduler-view-all-day .smart-scheduler-event-content[single-line] {
    grid-column-gap: 5px;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    justify-content: space-between
}

smart-scheduler .smart-scheduler-event[exception] .smart-scheduler-event-content,
smart-scheduler .smart-scheduler-event[repeating] .smart-scheduler-event-content,
smart-scheduler .smart-scheduler-view-all-day[exception] .smart-scheduler-event-content,
smart-scheduler .smart-scheduler-view-all-day[repeating] .smart-scheduler-event-content {
    grid-template-columns: minmax(auto, 1fr) 30px;
    grid-template-columns: minmax(auto, 1fr) var(--smart-scheduler-event-icon-size)
}

smart-scheduler .smart-scheduler-view-all-day-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-all-day-label {
    align-items: center;
    display: flex;
    font-weight: 600;
    font-weight: var(--smart-scheduler-timeline-all-day-label-font-weight);
    height: 100%;
    justify-content: center;
    min-width: 100px;
    min-width: var(--smart-scheduler-timeline-header-vertical-cells-size);
    padding: 5px;
    padding: var(--smart-scheduler-timeline-header-cell-padding);
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

smart-scheduler .smart-scheduler-view-all-day-label>div {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-view-all-day-label-container {
    display: flex;
    flex-direction: column;
    overflow: hidden
}

smart-scheduler .smart-scheduler-view-details {
    display: flex;
    position: relative
}

smart-scheduler .smart-scheduler-view-details .smart-scheduler-cell {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    height: 100%;
    min-height: inherit;
    min-width: inherit
}

smart-scheduler .smart-scheduler-view-details .smart-scheduler-cell:not(:first-of-type) {
    border-left: none
}

smart-scheduler .smart-scheduler-view-container {
    position: relative
}

smart-scheduler .smart-scheduler-view-groups-label-container,
smart-scheduler .smart-scheduler-view-label-container {
    display: flex;
    height: 100%
}

smart-scheduler .smart-scheduler-view-groups-content {
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-items-button {
    --smart-button-text-transform: initial;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    height: 100%;
    overflow: hidden;
    -webkit-transform: scale(1);
    transform: scale(1);
    width: auto;
    width: var(--smart-scheduler-header-menu-button-size)
}

smart-scheduler .smart-scheduler-view-items-button:after {
    align-items: center;
    background: 0 0;
    color: inherit;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    height: 100%;
    justify-content: center;
    left: auto;
    min-width: 27px;
    min-width: var(--smart-editor-addon-width);
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

smart-scheduler .smart-scheduler-view-items-button button {
    align-items: center;
    border-radius: 0;
    border-radius: initial;
    display: flex;
    justify-content: center
}

smart-scheduler .smart-scheduler-view-items-button button>span {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-view-items-button:not([active]) button:active {
    background-color: inherit;
    border-color: inherit;
    color: inherit
}

smart-scheduler .smart-scheduler-view-items-button.smart-visibility-hidden {
    -webkit-transform: scale(0);
    transform: scale(0)
}

smart-scheduler[hide-other-month-days] .smart-scheduler-cell[other-month]>div {
    visibility: hidden
}

smart-scheduler .smart-scheduler-cells .smart-scheduler-cell:empty {
    display: none
}

smart-scheduler .smart-scheduler-cells .smart-scheduler-cell:not(:first-of-type) {
    border-left: none
}

smart-scheduler .smart-scheduler-cells div {
    border-bottom-color: #e0e0e0;
    border-bottom-color: var(--smart-border);
    pointer-events: none;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell.scale {
    height: 100%;
    min-height: 0;
    min-height: auto;
    min-width: 0;
    min-width: auto;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale)[restricted] {
    background: 0 -245rem/12px 12px linear-gradient(135deg, rgba(255, 0, 0, .15) 25%, transparent 0, transparent 50%, rgba(255, 0, 0, .15) 0, rgba(255, 0, 0, .15) 75%, transparent 0, transparent);
    background: var(--smart-scheduler-restricted-background)
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell[nonworking],
smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell[nonworking] .smart-scheduler-cell {
    background: #f5f5f5;
    background: var(--smart-scheduler-timeline-nonworking-color)
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell[weekend] {
    background: #fefefe;
    background: var(--smart-scheduler-timeline-weekend-color)
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding: initial;
    width: 100%
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale) {
    height: 100%;
    min-height: 0;
    min-height: auto;
    min-width: 0;
    min-width: auto;
    width: 100%
}

smart-scheduler .smart-scheduler-cell,
smart-scheduler .smart-scheduler-cell-container {
    min-width: var(--smart-scheduler-timeline-cell-min-size);
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-cell {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-color: transparent;
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    height: 50px;
    height: var(--smart-scheduler-timeline-cell-height);
    justify-content: center;
    min-height: 35px;
    min-height: var(--smart-scheduler-timeline-cell-min-height);
    padding: 5px;
    padding: var(--smart-scheduler-timeline-header-cell-padding);
    width: auto;
    width: var(--smart-scheduler-timeline-cell-width)
}

smart-scheduler .smart-scheduler-cell.smart-scheduler-feedback:after {
    background: transparent;
    background: var(--smart-scheduler-cell-feedback-background);
    border: 2px dashed #005c99;
    border: 2px dashed var(--smart-primary);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

smart-scheduler .smart-scheduler-cell[other-month] {
    background: #fefefe;
    background: var(--smart-background);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-scheduler .smart-scheduler-cell[other-month]>div {
    opacity: .5
}

smart-scheduler .smart-scheduler-cell.smart-scheduler-view-header-cell-feedback {
    height: auto;
    visibility: hidden;
    width: auto
}

smart-scheduler .smart-scheduler-cell-container {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-color: transparent;
    color: #323232;
    color: var(--smart-surface-color);
    display: flex;
    height: 50px;
    height: var(--smart-scheduler-timeline-cell-height);
    justify-content: center;
    min-height: 35px;
    min-height: var(--smart-scheduler-timeline-cell-min-height);
    padding: 5px;
    padding: var(--smart-scheduler-timeline-header-cell-padding);
    width: auto;
    width: var(--smart-scheduler-timeline-cell-width)
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-button,
smart-scheduler .smart-scheduler-events-container .smart-scheduler-event .smart-scheduler-event-button {
    display: none
}

smart-scheduler .smart-scheduler-event {
    -webkit-tap-highlight-color: transparent;
    border-radius: initial;
    border-radius: var(--smart-scheduler-event-border-radius);
    outline: 0;
    padding: 2px;
    padding: var(--smart-scheduler-event-padding-basic);
    position: absolute;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

smart-scheduler .smart-scheduler-event:after {
    left: calc(50% - 1px);
    left: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4);
    top: calc(100% - 4px);
    top: calc(100% - var(--smart-scheduler-event-resize-indicator-size))
}

smart-scheduler .smart-scheduler-event:before {
    left: calc(50% - 1px);
    left: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4);
    top: 0
}

smart-scheduler .smart-scheduler-event[focus]:not([collector]):after,
smart-scheduler .smart-scheduler-event[focus]:not([collector]):before,
smart-scheduler .smart-scheduler-event[hover]:not([collector]):after,
smart-scheduler .smart-scheduler-event[hover]:not([collector]):before {
    -webkit-transform: scale(1);
    transform: scale(1)
}

smart-scheduler .smart-scheduler-event:not([resized])[focus] .smart-scheduler-event-content {
    background: rgba(52, 121, 186, .9);
    background: var(--smart-scheduler-event-focus);
    color: #fff;
    color: var(--smart-scheduler-event-color-focus)
}

smart-scheduler .smart-scheduler-event:not([resized])[hover] .smart-scheduler-event-content {
    background: rgba(52, 121, 186, .8);
    background: var(--smart-scheduler-event-hover);
    color: #fff;
    color: var(--smart-scheduler-event-color-hover)
}

smart-scheduler .smart-scheduler-event:not([collector]):after,
smart-scheduler .smart-scheduler-event:not([collector]):before {
    background-color: #fff;
    background-color: var(--smart-scheduler-event-resize-indicator-color);
    box-shadow: 0 0 0 1px #333;
    box-shadow: 0 0 0 1px var(--smart-scheduler-event-resize-indicator-border-color);
    content: "";
    height: 4px;
    height: var(--smart-scheduler-event-resize-indicator-size);
    pointer-events: none;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0);
    width: 4px;
    width: var(--smart-scheduler-event-resize-indicator-size);
    z-index: 1
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-label {
    font-size: 14px;
    font-size: var(--smart-scheduler-event-label-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-label-font-weight);
    pointer-events: none;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-time {
    font-size: 11px;
    font-size: var(--smart-scheduler-event-time-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-time-font-weight);
    opacity: .7;
    opacity: var(--smart-scheduler-event-time-opacity);
    pointer-events: none;
    white-space: pre-wrap
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-content>div {
    align-self: flex-start;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-content>div:first-of-type {
    align-self: center
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-content:not([single-line])>div:not(:first-of-type) {
    grid-column: 1/span 2
}

smart-scheduler .smart-scheduler-event .smart-scheduler-event-content[single-line]>div {
    align-self: auto
}

smart-scheduler .smart-scheduler-event[resized] {
    opacity: .75;
    z-index: 10000
}

smart-scheduler .smart-scheduler-event[cut] .smart-scheduler-event-content {
    opacity: .75
}

smart-scheduler .smart-scheduler-event[collector] {
    border-radius: 20px;
    border-radius: var(--smart-scheduler-event-collector-border-radius);
    height: 24px;
    height: var(--smart-scheduler-event-collector-size);
    width: 24px;
    width: var(--smart-scheduler-event-collector-size)
}

smart-scheduler .smart-scheduler-event[collector] .smart-scheduler-event-content {
    grid-column-gap: 5px;
    background: #005c99;
    background: var(--smart-scheduler-event-collector-background);
    color: #fff;
    color: var(--smart-scheduler-event-collector-color);
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    justify-items: center;
    padding: 1px 5px
}

smart-scheduler .smart-scheduler-event[collector] .smart-scheduler-event-content>div {
    align-self: auto;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-event[collector][focus] .smart-scheduler-event-content {
    background: rgba(0, 92, 153, .9);
    background: var(--smart-scheduler-event-collector-focus);
    color: #fff;
    color: var(--smart-scheduler-event-collector-color-focus)
}

smart-scheduler .smart-scheduler-event[collector][hover] .smart-scheduler-event-content {
    background: rgba(0, 92, 153, .8);
    background: var(--smart-scheduler-event-collector-hover);
    color: #fff;
    color: var(--smart-scheduler-event-collector-color-hover)
}

smart-scheduler .smart-scheduler-event[repeating] .smart-scheduler-event-content:after {
    align-items: center;
    box-sizing: border-box;
    content: "\\e80b";
    content: var(--smart-icon-spin);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    line-height: 1rem;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    width: var(--smart-scheduler-event-icon-size)
}

smart-scheduler .smart-scheduler-event[repeating] .smart-scheduler-event-content[single-line] {
    grid-template-columns: repeat(2, auto) 30px;
    grid-template-columns: repeat(2, auto) var(--smart-scheduler-event-icon-size)
}

smart-scheduler .smart-scheduler-event[repeating][exception] .smart-scheduler-event-content:after {
    content: "\\e805";
    content: var(--smart-icon-attention-circled)
}

smart-scheduler .smart-scheduler-event[status] .smart-scheduler-event-content:before {
    background: transparent;
    background: var(--smart-scheduler-status-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 20px;
    box-shadow: 0 0 0 .5px #fefefe;
    box-shadow: 0 0 0 .5px var(--smart-background);
    box-sizing: border-box;
    content: "";
    display: block;
    height: 100%;
    overflow: hidden;
    position: absolute;
    width: 7px;
    width: var(--smart-scheduler-status-size)
}

smart-scheduler .smart-scheduler-event[status=free] .smart-scheduler-event-content:before {
    background: #fff;
    background: var(--smart-scheduler-status-free-background)
}

smart-scheduler .smart-scheduler-event[status=busy] .smart-scheduler-event-content:before {
    background: #dc3545;
    background: var(--smart-scheduler-status-busy-background)
}

smart-scheduler .smart-scheduler-event[status=outOfOffice] .smart-scheduler-event-content:before {
    background: #00a9e6;
    background: var(--smart-scheduler-status-out-of-office-background)
}

smart-scheduler .smart-scheduler-event[status=tentative] .smart-scheduler-event-content:before {
    background: 0 -244rem/5rem 5rem linear-gradient(45deg, #fd7e14 25%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 50%, #fd7e14 0, #fd7e14 75%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2));
    background: var(--smart-scheduler-status-tentative-background)
}

smart-scheduler .smart-scheduler-event[exception] .smart-scheduler-event-button,
smart-scheduler .smart-scheduler-event[repeating] .smart-scheduler-event-button {
    display: none
}

smart-scheduler .smart-scheduler-event:not([repeating]) .smart-scheduler-event-content:not([single-line])>div {
    grid-column: 1/span 2
}

smart-scheduler .smart-scheduler-event-content {
    grid-row-gap: 2px;
    align-items: center;
    background: #3479ba;
    background: var(--smart-scheduler-event-background);
    border-radius: inherit;
    color: #fff;
    color: var(--smart-scheduler-event-color);
    cursor: pointer;
    display: grid;
    grid-template-columns: minmax(auto, 1fr);
    grid-template-rows: -webkit-min-content minmax(auto, 1fr);
    grid-template-rows: min-content minmax(auto, 1fr);
    height: 100%;
    justify-content: flex-start;
    justify-items: flex-start;
    max-height: 100%;
    overflow: hidden;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-event-content[single-line] {
    grid-column-gap: 5px;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    justify-content: space-between
}

smart-scheduler .smart-scheduler-date-nav {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    background-clip: content-box;
    display: flex;
    grid-area: date;
    height: 100%;
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-scheduler-header-padding)
}

smart-scheduler .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    --smart-button-padding: 0 10px 0 10px;
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    max-width: auto;
    max-width: var(--smart-scheduler-header-date-button-max-size);
    width: auto
}

smart-scheduler .smart-scheduler-date-nav .smart-scheduler-nav[current] .smart-button {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-time-zone {
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 5px;
    padding: var(--smart-scheduler-timeline-header-cell-padding);
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-cells-size)
}

smart-scheduler .smart-scheduler-time-zone>div {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-time-zone-container {
    align-items: center;
    display: flex;
    height: 100%
}

smart-scheduler .smart-scheduler-time-zone-container:empty {
    display: none
}

smart-scheduler .smart-scheduler-current-time-indicator {
    background: #005c99;
    background: var(--smart-scheduler-current-time-indicator-background);
    height: 1px;
    height: var(--smart-scheduler-current-time-indicator-size);
    pointer-events: none;
    position: absolute;
    width: 1px;
    width: var(--smart-scheduler-current-time-indicator-size)
}

smart-scheduler .smart-scheduler-items-container {
    align-items: center;
    display: flex;
    height: 100%;
    outline: 0;
    position: relative
}

smart-scheduler .smart-scheduler-items-container .smart-scheduler-item[selected] {
    background: #fefefe;
    background: var(--smart-background);
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top: 1px solid #e0e0e0;
    border-top: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler .smart-scheduler-items-container:focus .smart-scheduler-item[selected] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

smart-scheduler .smart-scheduler-items-container .smart-scheduler-item {
    align-items: center;
    border: 1px solid transparent;
    border: var(--smart-border-width) solid transparent;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 10px;
    padding: var(--smart-scheduler-header-padding);
    position: relative;
    width: auto;
    width: var(--smart-scheduler-item-size)
}

smart-scheduler .smart-scheduler-items-container .smart-scheduler-item:last-of-type {
    border-right: none
}

smart-scheduler .smart-scheduler-item>div {
    align-items: center;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-groups-container {
    display: flex;
    height: 100%;
    overflow: hidden;
    width: 100%
}

smart-scheduler .smart-scheduler-groups-container .smart-scheduler-cell {
    font-weight: 600;
    font-weight: var(--smart-scheduler-timeline-all-day-label-font-weight);
    min-height: inherit;
    min-width: inherit;
    white-space: nowrap;
    white-space: var(--smart-scheduler-timeline-group-white-space)
}

smart-scheduler .smart-scheduler-groups-container .smart-scheduler-cell>div {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler .smart-scheduler-groups-container .smart-scheduler-cell:not(:first-of-type) {
    border-left: none
}

smart-scheduler .smart-scheduler-scrollable-container {
    background: transparent;
    background: var(--smart-scheduler-view-background);
    display: grid;
    grid-area: content;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-content .smart-scheduler-cell[nonworking],
smart-scheduler[view-type=month] .smart-scheduler-content .smart-scheduler-cell[nonworking][other-month]:not([selected]) {
    background: #f5f5f5;
    background: var(--smart-scheduler-timeline-nonworking-color)
}

smart-scheduler .smart-scheduler-content {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-content .smart-scheduler-cell[weekend] {
    background: #fefefe;
    background: var(--smart-scheduler-timeline-weekend-color)
}

smart-scheduler .smart-scheduler-view-scroll-bar {
    height: 18px;
    height: var(--smart-scroll-bar-size);
    overflow: visible;
    position: relative;
    width: 100%
}

smart-scheduler .smart-scheduler-view-scroll-bar:after {
    background: #f1f1f1;
    background: var(--smart-scroll-bar-background);
    content: "";
    height: 18px;
    height: var(--smart-scroll-bar-size);
    left: 100%;
    position: absolute;
    top: 0;
    width: 100%
}

smart-scheduler .smart-scheduler-view-scroll-bar.bottom-corner {
    width: calc(100% - 18px);
    width: calc(100% - var(--smart-scroll-bar-size))
}

smart-scheduler .smart-scheduler-view-scroll-bar[orientation=vertical] {
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 18px;
    width: var(--smart-scroll-bar-size)
}

smart-scheduler .smart-scheduler-view-scroll-bar[orientation=vertical].bottom-corner {
    height: calc(100% - 18px);
    height: calc(100% - var(--smart-scroll-bar-size))
}

smart-scheduler .smart-scheduler-tooltip {
    pointer-events: none;
    -webkit-transform: scale(0);
    transform: scale(0)
}

smart-scheduler .smart-toast-container-custom.smart-toast-container {
    height: auto;
    max-height: 100%;
    max-width: 100%;
    right: 0;
    top: 0;
    width: 400px;
    width: var(--smart-scheduler-toast-default-width)
}

smart-scheduler .smart-toast-container-custom.smart-toast-container .smart-toast-item {
    border-radius: 5px;
    height: 50px;
    height: var(--smart-scheduler-toast-default-height)
}

smart-scheduler .smart-toast-container-custom.smart-toast-container .smart-toast-item>.smart-container {
    display: flex;
    flex-direction: row-reverse
}

smart-scheduler .smart-toast-container-custom.smart-toast-container .smart-toast-item .smart-toast-item-container {
    padding: initial;
    top: auto;
    width: 100%
}

smart-scheduler .smart-scheduler-legend {
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    display: flex;
    grid-area: legend;
    height: 100%;
    width: 100%
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-item {
    grid-row-gap: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    padding: 10px;
    padding: var(--smart-scheduler-header-padding)
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-items {
    display: flex
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item {
    grid-column-gap: 5px;
    align-items: center;
    display: flex;
    outline: medium none invert;
    outline: initial;
    overflow: hidden;
    position: relative;
    white-space: nowrap
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item:hover {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item:before {
    background-color: #3479ba;
    background-color: var(--smart-scheduler-legend-item-background);
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border);
    border-radius: 4px;
    border-radius: var(--smart-border-radius);
    box-sizing: border-box;
    content: "";
    display: flex;
    height: 16px;
    height: var(--smart-check-box-default-size);
    min-height: 16px;
    min-height: var(--smart-check-box-default-size);
    min-width: 16px;
    min-width: var(--smart-check-box-default-size);
    width: 16px;
    width: var(--smart-check-box-default-size)
}

smart-scheduler:not([view-type=day]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-groups-container .smart-scheduler-cell-container:not(:last-of-type)>.smart-scheduler-cell,
smart-scheduler:not([view-type^=timeline]) .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color)
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item:not(:first-of-type) {
    margin-left: 20px
}

smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item>span {
    overflow: hidden;
    pointer-events: none;
    text-overflow: ellipsis
}

@media only screen and (min-device-width:320px) and (max-device-width:900px) {
    smart-scheduler .smart-scheduler-legend .smart-scheduler-legend-res-item>span {
        width: 0
    }
}

smart-scheduler .smart-scheduler-window-modal {
    background-color: #ccc;
    background-color: var(--smart-disabled);
    left: 0;
    min-height: 100%;
    opacity: .5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9998;
    z-index: calc(var(--smart-editor-drop-down-z-index) - 1)
}

smart-scheduler .smart-scheduler-shade-section {
    background: hsla(0, 48%, 92%, .5);
    background: var(--smart-scheduler-shader-background);
    pointer-events: none;
    position: absolute
}

smart-scheduler .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale)>div,
smart-scheduler .smart-scheduler-item>div,
smart-scheduler .smart-scheduler-view-all-day-label,
smart-scheduler .smart-scheduler-view-header-horizontal .smart-scheduler-cell,
smart-scheduler .smart-scheduler-view-header-vertical .smart-scheduler-cell {
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

smart-scheduler:not([animation=none]) .smart-scheduler-legend .smart-scheduler-legend-res-item:before {
    transition: background .2s linear, border .2s linear
}

smart-scheduler:not([animation=none]) .smart-scheduler-event:after,
smart-scheduler:not([animation=none]) .smart-scheduler-event:before {
    transition: -webkit-transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: transform .2s cubic-bezier(.4, 0, .6, 1);
    transition: transform .2s cubic-bezier(.4, 0, .6, 1), -webkit-transform .2s cubic-bezier(.4, 0, .6, 1)
}

.smart-color-input-drop-down-menu.smart-scheduler-color-input:not([animation=none]) .default-samples-container div,
smart-scheduler:not([animation=none]) .smart-scheduler-view-items-button {
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out
}

smart-scheduler:not([animation=none]) .smart-scheduler-items-container .smart-scheduler-item {
    transition: border-top .2s ease-in-out
}

smart-scheduler:not([event-render-mode=classic]) .smart-scheduler-event {
    padding-right: 0
}

smart-scheduler:not([disable-date-menu]):not([right-to-left]) .smart-scheduler-nav[current] button,
smart-scheduler:not([disable-view-menu]):not([right-to-left]) .smart-scheduler-view-items-button button {
    padding-right: 27px;
    padding-right: var(--smart-editor-addon-width)
}

smart-scheduler:not([view-type^=timeline]) .smart-scheduler-cells-container .smart-scheduler-cell.scale:not(:last-of-type) {
    border-bottom: 1px solid hsla(0, 48%, 92%, .5);
    border-bottom: var(--smart-border-width) solid rgba(var(--smart-border-rgb), .5)
}

smart-scheduler:not([view-type^=timeline]) .smart-scheduler-cells-container .smart-scheduler-cell-container:not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-horizontal-line-color)
}

smart-scheduler:not([view-type^=timeline]) .smart-scheduler-view-header-horizontal .smart-scheduler-time-zone {
    height: 100%;
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-cells-size)
}

smart-scheduler:not([view-type^=timeline]) .smart-scheduler-current-time-indicator:before {
    border-bottom: 7px solid transparent;
    border-bottom: var(--smart-scheduler-current-time-indicator-arrow-size) solid transparent;
    border-left: 7px solid #005c99;
    border-left: var(--smart-scheduler-current-time-indicator-arrow-size) solid var(--smart-scheduler-current-time-indicator-background);
    border-top: 7px solid transparent;
    border-top: var(--smart-scheduler-current-time-indicator-arrow-size) solid transparent;
    left: 0;
    top: -6.5px;
    top: calc(var(--smart-scheduler-current-time-indicator-arrow-size)*-1 + var(--smart-scheduler-current-time-indicator-size)/2)
}

smart-scheduler:not([view-type=timelineDay]) .smart-scheduler-view-header-horizontal .smart-scheduler-cells:not(:last-of-type) .smart-scheduler-cell,
smart-scheduler[view-type^=timeline] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler:not([view-type^=timeline]) .smart-scheduler-event {
    width: 30px;
    width: var(--smart-scheduler-event-size)
}

smart-scheduler:not([view-type=timelineWeek]) .smart-scheduler-view-details,
smart-scheduler:not([view-type=timelineWeek]) .smart-scheduler-view-details-label:empty {
    display: none
}

smart-scheduler:not([view-type=day]) .smart-scheduler-view-header-cell-feedback,
smart-scheduler:not([view-type=day]):not([view-type=agenda]) .smart-scheduler-view-header-vertical .smart-scheduler-cell,
smart-scheduler:not([view-type=day]):not([view-type^=timeline]) .smart-scheduler-view-label-container:empty {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type]:not([view-type=day]) .smart-scheduler-view-all-day-label,
smart-scheduler[view-type]:not([view-type=day]):not([view-type=agenda]) .smart-scheduler-time-zone:last-of-type,
smart-scheduler[view-type^=timeline] .smart-scheduler-time-zone,
smart-scheduler[view-type^=timeline] .smart-scheduler-view[show-vertical-header][show-group-header=horizontal] .smart-scheduler-view-details-label {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color)
}

smart-scheduler:not([view-type=month]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-label-container:before {
    content: "";
    display: flex;
    height: 100%;
    width: 100px;
    width: var(--smart-scheduler-timeline-header-vertical-group-size)
}

smart-scheduler[view-type=day] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-current-time-indicator:not(:first-of-type):before,
smart-scheduler[view-type^=timeline] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-current-time-indicator:not(:first-of-type):before {
    content: none
}

smart-scheduler:not([view-type=agenda])[group-by-date] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-vertical .smart-scheduler-view-time .smart-scheduler-cell:not([group-separator])>div,
smart-scheduler[view-type=timelineWeek] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-details-label,
smart-scheduler[view-type^=timeline] .smart-scheduler-view-all-day {
    display: none
}

smart-scheduler:not([view-type=month]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-all-day-label-container {
    margin-left: 100px;
    margin-left: var(--smart-scheduler-timeline-header-vertical-group-size)
}

smart-scheduler:not([view-type=agenda]) .smart-scheduler-view-header-vertical-content .smart-scheduler-cell:not(:first-of-type)>div {
    -webkit-transform: translateY(calc(-50% - 5px));
    transform: translateY(calc(-50% - 5px));
    -webkit-transform: translateY(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)));
    transform: translateY(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)))
}

smart-scheduler:not([view-type=agenda]) .smart-scheduler-event[status] .smart-scheduler-event-content {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding-left: 12px;
    padding-left: calc(var(--smart-scheduler-status-size) + var(--smart-scheduler-status-padding))
}

smart-scheduler:not([view-type=agenda]) .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):hover,
smart-scheduler:not([view-type=agenda]) .smart-scheduler-view-all-day .smart-scheduler-cell:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

smart-scheduler[view-type^=timeline] {
    --smart-scheduler-event-size: var(--smart-scheduler-event-size-timeline)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view-label-container {
    flex-direction: column
}

smart-scheduler[view-type^=timeline] .smart-scheduler-cells .smart-scheduler-cell>div {
    overflow: hidden;
    text-overflow: ellipsis
}

smart-scheduler[view-type=agenda] .smart-scheduler-cells-container .smart-scheduler-cell-container,
smart-scheduler[view-type^=timeline][group-by-date] .smart-scheduler-view-header-horizontal-content .smart-scheduler-cell {
    overflow: visible;
    overflow: initial
}

smart-scheduler[view-type^=timeline] .smart-scheduler-time-zone {
    height: 40px;
    height: var(--smart-scheduler-timeline-header-horizontal-cells-size)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view:not([show-vertical-header]) {
    --smart-scheduler-timeline-header-vertical-cells-size: 0
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-label-container {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-vertical {
    grid-template-columns: auto 0
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    grid-template-columns: 100px minmax(0, 1fr);
    grid-template-columns: var(--smart-scheduler-timeline-header-vertical-group-size) minmax(0, 1fr)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-time-zone-container {
    flex-direction: column;
    height: auto
}

smart-scheduler[view-type^=timeline] .smart-scheduler-view-time {
    flex-direction: column
}

smart-scheduler[view-type^=timeline] .smart-scheduler-event {
    height: 30px;
    height: var(--smart-scheduler-event-size);
    padding: 2px;
    padding: var(--smart-scheduler-event-padding-timeline)
}

smart-scheduler[view-type=month]:not([event-render-mode=classic]) .smart-scheduler-event,
smart-scheduler[view-type^=timeline]:not([event-render-mode=classic]) .smart-scheduler-event {
    padding-bottom: 0
}

smart-scheduler[view-type^=timeline] .smart-scheduler-event:after {
    left: calc(100% - 4px);
    left: calc(100% - var(--smart-scheduler-event-resize-indicator-size));
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-event:before {
    left: 0;
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-cells-container .smart-scheduler-cell.scale:not(:last-of-type) {
    border-right: 1px solid hsla(0, 48%, 92%, .5);
    border-right: var(--smart-border-width) solid rgba(var(--smart-border-rgb), .5)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-cells-container .smart-scheduler-cell-container {
    flex-direction: row
}

smart-scheduler[view-type^=timeline] .smart-scheduler-cells-container .smart-scheduler-cell-container:not(:last-of-type) {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color)
}

smart-scheduler[view-type^=timeline] .smart-scheduler-current-time-indicator:before {
    border-left: 7px solid transparent;
    border-left: var(--smart-scheduler-current-time-indicator-arrow-size) solid transparent;
    border-right: 7px solid transparent;
    border-right: var(--smart-scheduler-current-time-indicator-arrow-size) solid transparent;
    border-top: 7px solid #005c99;
    border-top: var(--smart-scheduler-current-time-indicator-arrow-size) solid var(--smart-scheduler-current-time-indicator-background);
    left: -6.5px;
    left: calc(var(--smart-scheduler-current-time-indicator-arrow-size)*-1 + var(--smart-scheduler-current-time-indicator-size)/2)
}

smart-scheduler[view-type=timelineWeek] .smart-scheduler-view[show-vertical-header] .smart-scheduler-view-details-label {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type=day] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type),
smart-scheduler[view-type=day] .smart-scheduler-view-header-horizontal .smart-scheduler-cell,
smart-scheduler[view-type=week] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type),
smart-scheduler[view-type=week] .smart-scheduler-view-header-horizontal .smart-scheduler-cell {
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-scheduler-day-week-view-vertical-line-size) solid var(--smart-scheduler-day-week-view-vertical-line-color)
}

smart-scheduler[view-type=timelineWeek] .smart-scheduler-view-label-container {
    display: flex;
    flex-direction: column
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-horizontal .smart-scheduler-view-all-day,
smart-scheduler[view-type=day] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container,
smart-scheduler[view-type=month] .smart-scheduler-view-header-horizontal .smart-scheduler-view-all-day,
smart-scheduler[view-type=month] .smart-scheduler-view-header-vertical-content,
smart-scheduler[view-type=month] .smart-scheduler-view:not([show-group-header=vertical]) .smart-scheduler-view-header-vertical,
smart-scheduler[view-type=month] .smart-scheduler-view:not([show-group-header=vertical]) .smart-scheduler-view-label-container,
smart-scheduler[view-type=timelineWeek] .smart-scheduler-view-details:empty {
    display: none
}

smart-scheduler[view-type=timelineWeek] .smart-scheduler-view-details-label {
    height: 40px;
    height: var(--smart-scheduler-timeline-header-horizontal-details-size);
    width: 100%
}

smart-scheduler[view-type=day] .smart-scheduler-view {
    grid-template-rows: auto minmax(0, 1fr)
}

smart-scheduler[view-type=day] .smart-scheduler-cells-container .smart-scheduler-cell-container:not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-day-week-view-hour-size) solid var(--smart-scheduler-day-week-view-hour-color)
}

smart-scheduler[view-type=day] .smart-scheduler-view-header-horizontal .smart-scheduler-view-groups-label-container {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type=week] .smart-scheduler-cells-container .smart-scheduler-cell-container:not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-scheduler-day-week-view-hour-size) solid var(--smart-scheduler-day-week-view-hour-color)
}

smart-scheduler[view-type=month] .smart-scheduler-event {
    height: 30px;
    height: var(--smart-scheduler-event-size)
}

smart-scheduler[view-type=month] .smart-scheduler-event:after {
    left: calc(100% - 4px);
    left: calc(100% - var(--smart-scheduler-event-resize-indicator-size));
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler[view-type=month] .smart-scheduler-event:before {
    left: 0;
    top: calc(50% - 1px);
    top: calc(50% - var(--smart-scheduler-event-resize-indicator-size)/4)
}

smart-scheduler[view-type=month] .smart-scheduler-content {
    grid-template-columns: 100%
}

smart-scheduler[view-type=month] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale) {
    align-items: flex-start;
    justify-content: flex-end
}

smart-scheduler[view-type=month] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale)[today]>div:not([class]) {
    background: #005c99;
    background: var(--smart-primary);
    border-radius: 50%;
    box-shadow: 0 0 0 2px #005c99;
    box-shadow: 0 0 0 2px var(--smart-primary);
    color: #fff;
    color: var(--smart-primary-color);
    height: 16px;
    height: calc(var(--smart-scheduler-month-view-number-size)/1.5);
    width: 16px;
    width: calc(var(--smart-scheduler-month-view-number-size)/1.5)
}

smart-scheduler[view-type=month] .smart-scheduler-scrollable-container {
    grid-template-columns: 100%
}

smart-scheduler[view-type=month] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-vertical {
    grid-template-columns: auto 0
}

smart-scheduler[view-type=month] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    grid-template-columns: 100px minmax(0, 1fr);
    grid-template-columns: var(--smart-scheduler-timeline-header-vertical-group-size) minmax(0, 1fr)
}

smart-scheduler[view-type=month] .smart-scheduler-view:not([mobile]) .smart-scheduler-event[collector] {
    padding-right: 29px;
    padding-right: calc(var(--smart-scheduler-month-view-number-size) + 5px)
}

smart-scheduler[view-type=month] .smart-scheduler-view:not([mobile]) .smart-scheduler-event[collector][first-month-day] {
    padding-right: 49px;
    padding-right: calc(var(--smart-scheduler-month-view-number-size) + 25px)
}

smart-scheduler[view-type=month] .smart-scheduler-view-all-day,
smart-scheduler[view-type=month] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    grid-template-columns: minmax(0, 1fr)
}

smart-scheduler[view-type=agenda] {
    --smart-scheduler-timeline-header-vertical-label-padding: 0 0 0 25%;
    --smart-scheduler-event-time-font-weight: 600
}

smart-scheduler[view-type=agenda] .smart-scheduler-cells-container .smart-scheduler-cell-container:not([separator]) {
    border: none
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-vertical .smart-scheduler-cell {
    justify-content: flex-start
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-vertical .smart-scheduler-cell>div {
    text-align: left
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-horizontal {
    grid-template-rows: auto minmax(0, 1fr)
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    border: none;
    height: 0
}

smart-scheduler[view-type=agenda] .smart-scheduler-view-header-horizontal .smart-scheduler-view-groups-label-container {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type=agenda] .smart-scheduler-cells-container .smart-scheduler-cell-container[separator]:last-of-type>.smart-scheduler-cell:after,
smart-scheduler[view-type=agenda] .smart-scheduler-view-header-vertical .smart-scheduler-cell[separator]:last-of-type>.smart-scheduler-cell:after {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    box-sizing: border-box;
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 1px;
    top: var(--smart-border-width);
    width: 100%
}

smart-scheduler[view-type=agenda] .smart-scheduler-cells-container .smart-scheduler-cell-container[separator]:not(:last-of-type),
smart-scheduler[view-type=agenda] .smart-scheduler-view-header-vertical .smart-scheduler-cell[separator]:not(:last-of-type) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[view-type=agenda] .smart-scheduler-cell.smart-scheduler-view-header-cell-feedback {
    padding: 10px;
    padding: calc(var(--smart-scheduler-timeline-header-cell-padding)*2)
}

smart-scheduler[view-type=agenda] .smart-scheduler-view.no-agenda:after {
    align-items: center;
    content: attr(agenda-placeholder);
    display: flex;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    width: 100%
}

smart-scheduler[disable-resize] .smart-scheduler-event:not([collector]):after,
smart-scheduler[disable-resize] .smart-scheduler-event:not([collector]):before,
smart-scheduler[view-type=agenda] .smart-scheduler-event:not([collector]):not([disable-resize]):after,
smart-scheduler[view-type=agenda] .smart-scheduler-event:not([collector]):not([disable-resize]):before,
smart-scheduler[view-type=agenda] .smart-scheduler-event[status] .smart-scheduler-event-content:before {
    content: normal
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time .smart-scheduler-cell:not([show-label])>div,
smart-scheduler[hide-all-day] .smart-scheduler-view-all-day,
smart-scheduler[hide-today-button] .smart-scheduler-nav[today] {
    display: none
}

smart-scheduler[view-type=agenda] .smart-scheduler-event {
    padding: 5px;
    padding: var(--smart-scheduler-event-padding-agenda)
}

.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[interval],
.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[type],
smart-scheduler[right-to-left]:not([disable-date-menu]) .smart-scheduler-nav[current] button,
smart-scheduler[right-to-left]:not([disable-view-menu]) .smart-scheduler-view-items-button button {
    padding-left: 27px;
    padding-left: var(--smart-editor-addon-width)
}

smart-scheduler[view-type=agenda] .smart-scheduler-event .smart-scheduler-event-time {
    font-size: 14px;
    font-size: var(--smart-scheduler-event-time-font-size-agenda);
    font-weight: 600;
    font-weight: var(--smart-scheduler-event-time-font-weight-agenda);
    opacity: 1;
    opacity: var(--smart-scheduler-event-time-opacity-agenda)
}

smart-scheduler[view-type=agenda]:not([event-render-mode=classic]) .smart-scheduler-event {
    padding-bottom: 0
}

smart-scheduler:not([filterable]) .smart-scheduler-legend {
    cursor: default;
    opacity: .55;
    pointer-events: none
}

smart-scheduler[filterable] .smart-scheduler-legend .smart-scheduler-legend-res-item {
    cursor: pointer;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

smart-scheduler[filterable] .smart-scheduler-legend .smart-scheduler-legend-res-item:hover:before {
    border-color: #ebebeb;
    border-color: var(--smart-ui-state-border-hover)
}

smart-scheduler[filterable] .smart-scheduler-legend .smart-scheduler-legend-res-item:focus:before {
    border-color: #005c99;
    border-color: var(--smart-primary)
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time .smart-scheduler-cell:not([group-separator]),
smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-vertical .smart-scheduler-view-time .smart-scheduler-cell {
    border-right: initial
}

smart-scheduler[filterable] .smart-scheduler-legend .smart-scheduler-legend-res-item[unselected]:before {
    background: 0 0
}

smart-scheduler[filterable] .smart-scheduler-legend .smart-scheduler-legend-res-item[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time-container {
    border-bottom: initial
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell[show-label] {
    justify-content: flex-start
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell[show-label]>div {
    -webkit-transform: translateX(calc(-50% - 5px));
    transform: translateX(calc(-50% - 5px));
    -webkit-transform: translateX(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)));
    transform: translateX(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)))
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell[show-label=offset]>div {
    margin-left: calc(-50% - 5px);
    margin-left: var(--smart-scheduler-timeline-group-header-offset)
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell[show-label]>div {
    -webkit-transform: translateY(calc(-50% - 5px));
    transform: translateY(calc(-50% - 5px));
    -webkit-transform: translateY(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)));
    transform: translateY(calc(-50% - var(--smart-scheduler-timeline-header-cell-padding)))
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-cell[show-label=offset]>div {
    margin-top: calc(-50% - 5px);
    margin-top: var(--smart-scheduler-timeline-group-header-offset)
}

smart-scheduler[group-by-date] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-groups-container .smart-scheduler-cell {
    align-items: center
}

smart-scheduler[group-by-date] .smart-scheduler-view-header-horizontal .smart-scheduler-groups-container,
smart-scheduler[group-by-date]:not([view-type^=timeline]) .smart-scheduler-view-header-vertical .smart-scheduler-groups-container {
    order: 1
}

smart-scheduler[group-by-date] .smart-scheduler-view-all-day {
    order: 2
}

smart-scheduler[group-by-date] .smart-scheduler-view-header-horizontal .smart-scheduler-view-groups-label-container,
smart-scheduler[group-by-date]:not([view-type=agenda]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-groups-container .smart-scheduler-cell:not([group-separator]) {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[current-time-indicator] .smart-scheduler-view-header-horizontal .smart-scheduler-cell[current] {
    border-bottom: 2px solid #005c99;
    border-bottom: var(--smart-scheduler-current-time-indicator-header-size) solid var(--smart-scheduler-current-time-indicator-background);
    color: #005c99;
    color: var(--smart-scheduler-current-time-indicator-background)
}

smart-scheduler[current-time-indicator] .smart-scheduler-view-header-vertical .smart-scheduler-cell[current] {
    border-right: 2px solid #005c99;
    border-right: var(--smart-scheduler-current-time-indicator-header-size) solid var(--smart-scheduler-current-time-indicator-background);
    color: #005c99;
    color: var(--smart-scheduler-current-time-indicator-background)
}

smart-scheduler[current-time-indicator] .smart-scheduler-current-time-indicator:before {
    content: "";
    position: absolute
}

smart-scheduler[disable-date-menu] .smart-scheduler-nav[current]:after,
smart-scheduler[disable-view-menu] .smart-scheduler-view-items-button:after {
    content: normal
}

smart-scheduler[resized] {
    touch-action: none
}

smart-scheduler[resized] .smart-scheduler-cell[restricted]:hover {
    cursor: no-drop
}

smart-scheduler[resized] .smart-scheduler-event {
    pointer-events: none
}

smart-scheduler[dragged] {
    touch-action: none
}

smart-scheduler[dragged] .smart-scheduler-events-container,
smart-scheduler[modal] .smart-scheduler-footer,
smart-scheduler[modal] .smart-scheduler-header,
smart-scheduler[modal] .smart-scheduler-view-container {
    pointer-events: none
}

smart-scheduler[disable-date-menu] .smart-scheduler-nav[current] {
    cursor: auto
}

smart-scheduler[disable-date-menu] .smart-scheduler-nav[current] .smart-ripple {
    visibility: hidden
}

smart-scheduler[disable-date-menu] .smart-scheduler-nav[current][focus],
smart-scheduler[disable-date-menu] .smart-scheduler-nav[current][hover],
smart-scheduler[disable-date-menu] .smart-scheduler-view-items-button[focus],
smart-scheduler[disable-date-menu] .smart-scheduler-view-items-button[hover] {
    background: 0 0;
    color: #5a5a5a;
    color: var(--smart-background-color)
}

smart-scheduler[disable-view-menu] .smart-scheduler-view-items-button {
    border: initial;
    cursor: auto
}

smart-scheduler[disable-view-menu] .smart-scheduler-view-items-button .smart-ripple {
    visibility: hidden
}

smart-scheduler[time-ruler-ticks][view-type=day] .smart-scheduler-view-header-vertical .smart-scheduler-cells:last-of-type .smart-scheduler-cell:not(:last-of-type):after,
smart-scheduler[time-ruler-ticks][view-type=week] .smart-scheduler-view-header-vertical .smart-scheduler-cells:last-of-type .smart-scheduler-cell:not(:last-of-type):after {
    background: #e0e0e0;
    background: var(--smart-scheduler-day-week-view-hour-color);
    bottom: 0;
    content: "";
    height: 1px;
    height: var(--smart-scheduler-day-week-view-hour-size);
    position: absolute;
    right: 0;
    width: 10px;
    width: var(--smart-scheduler-time-ruler-tick-size)
}

smart-scheduler[legend-location=header] {
    --smart-scheduler-header-height: auto
}

smart-scheduler[legend-location=header] .smart-scheduler-header {
    grid-template-areas: "date view","legend legend";
    grid-template-rows: auto minmax(0, 1fr)
}

smart-scheduler[legend-position=far] .smart-scheduler-legend {
    justify-content: flex-end
}

smart-scheduler[scroll-buttons-position=both] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    order: 1
}

smart-scheduler[scroll-buttons-position=both] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    order: 2
}

smart-scheduler[scroll-buttons-position=both] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    order: 3
}

smart-scheduler[scroll-buttons-position=both][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    border-radius: 0;
    border-radius: initial
}

smart-scheduler[scroll-buttons-position=both][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 0;
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius)
}

smart-scheduler[scroll-buttons-position=far] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    order: 1
}

smart-scheduler[scroll-buttons-position=far] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    order: 3
}

smart-scheduler[scroll-buttons-position=far] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    order: 2
}

smart-scheduler[scroll-buttons-position=far][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 0
}

smart-scheduler[scroll-buttons-position=far][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next],
smart-scheduler[scroll-buttons-position=far][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    border-bottom-left-radius: 0;
    border-left: initial;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-left-radius: 0
}

smart-scheduler[scroll-buttons-position=far][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius)
}

smart-scheduler[scroll-buttons-position=near] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    order: 1
}

smart-scheduler[scroll-buttons-position=near] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    order: 2
}

smart-scheduler[scroll-buttons-position=near][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    order: 3
}

smart-scheduler[scroll-buttons-position=near][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    border-bottom-right-radius: 0;
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: initial;
    border-top-right-radius: 0
}

smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[next],
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    border-radius: 50%
}

smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[current],
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[next],
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    border: initial
}

smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    margin-left: 10px
}

smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[current]:not([focus]),
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[next]:not([active]):not([focus]),
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-date-nav .smart-scheduler-nav[prev]:not([active]):not([focus]),
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-nav[today]:not([focus]),
smart-scheduler:not([header-navigation-style=raised]) .smart-scheduler-view-items-button:not([focus]) {
    background: 0 0
}

smart-scheduler[header-date-position=far] .smart-scheduler-header {
    grid-template-areas: "view date";
    grid-template-columns: 1fr auto
}

smart-scheduler[header-view-position=near] .smart-scheduler-view-nav {
    justify-content: flex-start
}

smart-scheduler[header-view-position=near] .smart-scheduler-view-items-button {
    order: 2
}

smart-scheduler[header-view-position=near] .smart-scheduler-items-container .smart-scheduler-item:first-of-type,
smart-scheduler[header-view-position=near] .smart-scheduler-items-container .smart-scheduler-item:first-of-type[selected] {
    border-left: none
}

smart-scheduler[header-view-position=near] .smart-scheduler-items-container .smart-scheduler-item[selected] {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 0;
    border-right: initial;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 0
}

smart-scheduler[header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: initial;
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

smart-scheduler[header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    border-radius: 0;
    border-radius: initial;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius)
}

smart-scheduler[header-navigation-style=raised] .smart-scheduler-nav[today],
smart-scheduler[header-navigation-style=raised] .smart-scheduler-view-items-button {
    background: #fefefe;
    background: var(--smart-background)
}

smart-scheduler[view-selector-type=tabs] .smart-scheduler-view-items-button {
    position: absolute
}

smart-scheduler[view-selector-type=auto] .smart-scheduler-header,
smart-scheduler[view-selector-type=tabs] .smart-scheduler-header {
    grid-template-areas: "date . view"
}

smart-scheduler:not([right-to-left]) .smart-scheduler-view-header-horizontal .smart-scheduler-cell:last-of-type {
    border-right: none
}

smart-scheduler[right-to-left] .smart-scheduler-header,
smart-scheduler[right-to-left] .smart-scheduler-view {
    direction: rtl
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[today] {
    order: 1
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    order: 2
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[prev]:after {
    content: "\\e903";
    content: var(--smart-icon-arrow-right)
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    order: 3
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[next]:after {
    content: "\\e902";
    content: var(--smart-icon-arrow-left)
}

smart-scheduler[right-to-left] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    order: 4
}

smart-scheduler[right-to-left].smart-container.vscroll .smart-scheduler-view,
smart-scheduler[right-to-left]>.smart-container.vscroll .smart-scheduler-view {
    margin-left: 18px;
    margin-left: var(--smart-scroll-bar-size)
}

smart-scheduler[right-to-left].smart-container.vscroll .smart-scheduler-view-scroll-bar:not([orientation=vertical]),
smart-scheduler[right-to-left]>.smart-container.vscroll .smart-scheduler-view-scroll-bar:not([orientation=vertical]) {
    left: 18px;
    left: var(--smart-scroll-bar-size)
}

smart-scheduler[right-to-left] .smart-scheduler-view-scroll-bar[orientation=vertical] {
    left: 0;
    right: auto
}

smart-scheduler[right-to-left] .smart-scheduler-view-scroll-bar[orientation=vertical]:before {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[right-to-left] .smart-scheduler-view-scroll-bar[orientation=vertical]:after {
    left: auto;
    left: -18px;
    left: calc(var(--smart-scroll-bar-size)*-1);
    right: 100%
}

smart-scheduler[right-to-left][view-type=day] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type),
smart-scheduler[right-to-left][view-type=week] .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-scheduler-day-week-view-vertical-line-size) solid var(--smart-scheduler-day-week-view-vertical-line-color);
    border-right: initial
}

smart-scheduler[right-to-left]:not([view-type^=timeline]) .smart-scheduler-cells-container .smart-scheduler-cell:not(.scale):not(:last-of-type),
smart-scheduler[right-to-left][view-type]:not([view-type=day]) .smart-scheduler-view-all-day-label,
smart-scheduler[right-to-left][view-type]:not([view-type=day]):not([view-type=agenda]) .smart-scheduler-time-zone:last-of-type,
smart-scheduler[right-to-left][view-type^=timeline] .smart-scheduler-time-zone,
smart-scheduler[right-to-left][view-type^=timeline] .smart-scheduler-view[show-vertical-header][show-group-header=horizontal] .smart-scheduler-view-details-label {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color);
    border-right: initial
}

smart-scheduler[right-to-left]:not([view-type=day]) .smart-scheduler-view-header-cell-feedback,
smart-scheduler[right-to-left]:not([view-type=day]):not([view-type=agenda]) .smart-scheduler-view-header-vertical .smart-scheduler-cell,
smart-scheduler[right-to-left]:not([view-type=day]):not([view-type^=timeline]) .smart-scheduler-view-label-container:empty,
smart-scheduler[right-to-left][view-type^=timeline] .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-label-container {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: initial
}

smart-scheduler[right-to-left] .smart-scheduler-view-all-day .smart-scheduler-cell[all-day]:not(:last-of-type),
smart-scheduler[right-to-left] .smart-scheduler-view-details .smart-scheduler-cell:not(:last-of-type),
smart-scheduler[right-to-left] .smart-scheduler-view-header-horizontal .smart-scheduler-cell:not(:last-of-type) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-scheduler-day-week-view-vertical-line-size) solid var(--smart-scheduler-day-week-view-vertical-line-color);
    border-right: initial
}

smart-scheduler[right-to-left] .smart-scheduler-view-all-day .smart-scheduler-cell[all-day]:last-of-type,
smart-scheduler[right-to-left] .smart-scheduler-view-header-horizontal .smart-scheduler-cell:last-of-type {
    border-right: initial
}

smart-scheduler[right-to-left]:not([view-type=day]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-header-groups-container .smart-scheduler-cell-container:not(:last-of-type)>.smart-scheduler-cell,
smart-scheduler[right-to-left][view-type^=timeline] .smart-scheduler-cells-container .smart-scheduler-cell-container:not(:last-of-type) {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-scheduler-view-line-size) solid var(--smart-scheduler-view-vertical-line-color);
    border-right: initial
}

smart-scheduler[right-to-left] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell-container[group-separator]:not(:last-of-type),
smart-scheduler[right-to-left] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell:not(.scale)[group-separator]:not(:last-of-type),
smart-scheduler[right-to-left] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-cell[group-separator]:not(:last-of-type) {
    border-left-color: #b2b2b2;
    border-left-color: var(--smart-scheduler-timeline-group-separator-background);
    border-left-width: 1px;
    border-left-width: var(--smart-scheduler-timeline-group-separator-size);
    border-right-color: initial;
    border-right-width: medium
}

smart-scheduler[right-to-left][group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time .smart-scheduler-cell:not([group-separator]) {
    border-left: initial
}

smart-scheduler[right-to-left][group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time .smart-scheduler-cell[show-label=offset]>div {
    margin-left: 0;
    margin-right: calc(-50% - 5px);
    margin-right: var(--smart-scheduler-timeline-group-header-offset)
}

smart-scheduler[right-to-left][group-by-date] .smart-scheduler-view[show-group-header=horizontal] .smart-scheduler-view-header-horizontal .smart-scheduler-view-time .smart-scheduler-cell[show-label]>div {
    -webkit-transform: translateX(calc(50% + 5px));
    transform: translateX(calc(50% + 5px));
    -webkit-transform: translateX(calc(50% + var(--smart-scheduler-timeline-header-cell-padding)));
    transform: translateX(calc(50% + var(--smart-scheduler-timeline-header-cell-padding)))
}

smart-scheduler[right-to-left] .smart-scheduler-nav[current]:after,
smart-scheduler[right-to-left] .smart-scheduler-view-items-button:after {
    left: 0;
    right: auto
}

smart-scheduler[right-to-left][view-type=agenda] {
    --smart-scheduler-timeline-header-vertical-label-padding: 0 25% 0 0
}

smart-scheduler[right-to-left][view-type=agenda] .smart-scheduler-view-header-vertical .smart-scheduler-cell>div {
    text-align: right
}

smart-scheduler[right-to-left][view-type=month] .smart-scheduler-view:not([mobile]) .smart-scheduler-event[collector] {
    padding-left: 29px;
    padding-left: calc(var(--smart-scheduler-month-view-number-size) + 5px);
    padding-right: 0
}

smart-scheduler[right-to-left][view-type=month] .smart-scheduler-view:not([mobile]) .smart-scheduler-event[collector][first-month-day] {
    padding-left: 49px;
    padding-left: calc(var(--smart-scheduler-month-view-number-size) + 25px)
}

smart-scheduler[right-to-left] .smart-toast-container-custom {
    left: 0;
    right: auto
}

smart-scheduler[right-to-left]:not([view-type=agenda]) .smart-scheduler-event[status] .smart-scheduler-event-content {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 0;
    border-top-right-radius: 5px;
    padding-left: 0;
    padding-right: 12px;
    padding-right: calc(var(--smart-scheduler-status-size) + var(--smart-scheduler-status-padding))
}

smart-scheduler[right-to-left]:not([view-type=month]) .smart-scheduler-view[show-group-header=vertical] .smart-scheduler-view-all-day-label-container {
    margin-left: 0;
    margin-right: 100px;
    margin-right: var(--smart-scheduler-timeline-header-vertical-group-size)
}

smart-scheduler[right-to-left][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[current] {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-right-radius);
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-right-radius);
    border-top-right-radius: 0
}

smart-scheduler[right-to-left][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[prev] {
    border-bottom-left-radius: 0;
    border-left: initial;
    border-top-left-radius: 0
}

smart-scheduler[right-to-left][header-navigation-style=raised] .smart-scheduler-date-nav .smart-scheduler-nav[next] {
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-left-radius);
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-left-radius)
}

smart-scheduler[right-to-left] .smart-scheduler-nav[today] {
    margin-left: 10px;
    margin-right: 0
}

smart-scheduler[right-to-left] .smart-scheduler-event[repeating] .smart-scheduler-event-content:after {
    left: 0;
    right: auto
}

smart-scheduler[right-to-left][view-type=timelineWeek] .smart-scheduler-view[show-vertical-header] .smart-scheduler-view-details-label {
    border-left: 1px solid #e0e0e0;
    border-left: var(--smart-border-width) solid var(--smart-border);
    border-right: initial
}

smart-scheduler[right-to-left] .smart-scheduler-items-container .smart-scheduler-item:last-of-type {
    border-left: none;
    border-right: 1px solid #e0e0e0;
    border-right: var(--smart-border-width) solid var(--smart-border)
}

smart-scheduler[right-to-left] .smart-scheduler-legend {
    direction: rtl
}

@-moz-document url-prefix() {
    .smart-scheduler .smart-scheduler-view[mobile] .smart-scheduler-content:not(.hide-overlay):after {
        display: none
    }
}

.smart-scheduler-window {
    --smart-window-default-width: auto;
    --smart-window-default-height: auto;
    --smart-window-header-height: var(--smart-scheduler-window-header-height);
    --smart-window-footer-height: var(--smart-scheduler-window-footer-height);
    --smart-window-header-footer-padding: 10px;
    --smart-window-header-background: transparent;
    --smart-window-footer-padding: 10px;
    --smart-window-content-padding: 20px;
    max-height: 100vh;
    max-width: 100vw
}

.smart-scheduler-window[mobile] {
    border-radius: 0;
    border-radius: initial
}

.smart-scheduler-window.smart-window.confirm .smart-scheduler-confirm-label {
    width: 450px;
    width: var(--smart-box-width)
}

.smart-scheduler-window.smart-window.confirm .smart-content-container>.smart-content {
    grid-row-gap: 0;
    display: grid;
    grid-template-columns: 100%;
    justify-content: center
}

.smart-scheduler-window.smart-window .smart-scheduler-window-content-wrapper,
.smart-scheduler-window.smart-window.confirm .smart-content-container>.smart-content {
    grid-template-rows: auto minmax(auto, 1fr);
    justify-items: center;
    justify-items: safe center;
    padding: 10px;
    padding: var(--smart-window-content-padding);
    width: 100%
}

.smart-scheduler-window.smart-window .smart-scheduler-window-content-wrapper,
.smart-scheduler-window.smart-window .smart-scheduler-window-main,
.smart-scheduler-window.smart-window .smart-scheduler-window-repeat {
    grid-row-gap: 10px;
    display: grid;
    grid-template-columns: 100%;
    justify-content: center
}

.smart-scheduler-window.smart-window .smart-content-container>.smart-content {
    align-items: flex-start;
    padding: initial
}

.smart-scheduler-window.smart-window .smart-scheduler-window-main,
.smart-scheduler-window.smart-window .smart-scheduler-window-repeat {
    width: 450px;
    width: var(--smart-box-width)
}

.smart-scheduler-window.smart-window[horizontal] .smart-scheduler-window-content-wrapper {
    grid-column-gap: 20px;
    grid-template-columns: repeat(2, auto)
}

.smart-scheduler-window.smart-window .smart-scheduler-window-repeat [multiple] {
    grid-template-columns: minmax(0, 1fr)
}

.smart-scheduler-window.smart-window .smart-scheduler-window-repeat [multiple] .smart-scheduler-window-editor {
    grid-template-columns: auto auto minmax(0, 1fr)
}

.smart-color-input-drop-down-menu.smart-scheduler-color-input .grid-samples-container,
.smart-scheduler-window .smart-scheduler-window-editor[multiple] {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.smart-scheduler-window .smart-content-container,
.smart-scheduler-window>.smart-container {
    max-height: inherit
}

.smart-scheduler-window [multiple] .smart-scheduler-window-editor {
    align-items: center;
    justify-content: flex-start
}

.smart-scheduler-window [multiple] .smart-scheduler-window-editor:nth-child(2n),
.smart-scheduler-window [multiple] .smart-scheduler-window-editor:nth-child(odd):not(:first-of-type):not(:last-of-type),
.smart-scheduler-window [multiple] .smart-scheduler-window-editor[type=repeat] {
    justify-content: flex-end
}

.smart-scheduler-window .smart-content-container>.smart-footer {
    display: flex
}

@media not all and (-webkit-min-device-pixel-ratio:0),
not all and (min-resolution:0.001dpcm) {
    .smart-scheduler-window .smart-content-container>.smart-footer {
        align-content: start
    }
}

.smart-scheduler-window .smart-content-container>.smart-footer smart-button {
    --smart-button-padding: 0.2rem 16px;
    height: 100%;
    width: 100%
}

.smart-scheduler-window .smart-content-container>.smart-footer smart-button:not(:first-of-type) {
    -webkit-margin-start: 2%;
    margin-inline-start: 2%
}

.smart-scheduler-window .smart-content-container>.smart-footer .smart-icon {
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 18px;
    height: 100%;
    margin-right: 2.5px;
    position: relative
}

.smart-scheduler-window .smart-scheduler-window-button.ok .smart-icon:after {
    content: "\\e908";
    content: var(--smart-icon-check)
}

.smart-scheduler-window .smart-scheduler-window-button.cancel {
    grid-area: buttonCancel
}

.smart-scheduler-window .smart-scheduler-window-button.cancel .smart-icon:after {
    content: "\\1F5D9";
    content: var(--smart-icon-cancel)
}

.smart-scheduler-window .smart-scheduler-window-button.delete .smart-icon:after {
    content: "\\e826";
    content: var(--smart-icon-delete)
}

.smart-scheduler-window .smart-scheduler-window-editor {
    grid-row-gap: 5px;
    grid-column-gap: 10px;
    display: grid
}

.smart-scheduler-window .smart-scheduler-window-editor[type=allDay],
.smart-scheduler-window .smart-scheduler-window-editor[type=repeat] {
    grid-column-gap: 0
}

.smart-scheduler-window .smart-scheduler-window-editor[multiple] .smart-color-input[event-editor] {
    --smart-border-radius: 50%;
    width: auto
}

.smart-scheduler-window .smart-scheduler-window-editor .smart-date-time-picker,
.smart-scheduler-window .smart-scheduler-window-editor .smart-drop-down-list,
.smart-scheduler-window .smart-scheduler-window-editor>.smart-input {
    width: 100%
}

.smart-scheduler-window .smart-scheduler-window-editor .smart-switch-button {
    margin: auto 10px
}

.smart-scheduler-window .smart-scheduler-window-editor>b {
    text-align: center
}

.smart-scheduler-window .smart-scheduler-window-editor>.smart-number-input {
    width: 100px
}

.smart-scheduler-window .smart-scheduler-window-editor input:not(.smart-input) {
    height: 30px;
    height: var(--smart-editor-height)
}

.smart-scheduler-window .smart-scheduler-window-editor .smart-input[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-scheduler-window .smart-scheduler-window-main [multiple] .smart-scheduler-window-editor:not([type^=date]):not([resource-type]) {
    grid-template-columns: repeat(2, auto)
}

.smart-scheduler-window .smart-scheduler-window-repeat [multiple] .smart-scheduler-window-editor[type=repeatEnd] {
    grid-template-columns: none
}

.smart-scheduler-tooltip {
    --smart-tooltip-arrow-color: var(--smart-background);
    --smart-tooltip-padding: 4px
}

.smart-scheduler-tooltip.smart-tooltip .smart-tooltip-content {
    background-color: #fefefe;
    background-color: var(--smart-background);
    border: none;
    color: var(--smart-color);
    opacity: 1
}

.smart-scheduler-tooltip .smart-calendar {
    border: initial;
    border-radius: 0;
    border-radius: initial;
    direction: ltr
}

.smart-scheduler-tooltip .smart-calendar .smart-calendar-header {
    border: 1px solid #e0e0e0;
    border: var(--smart-border-width) solid var(--smart-border)
}

.smart-scheduler-tooltip .smart-scheduler-items-container {
    flex-direction: column;
    outline: 0
}

.smart-scheduler-tooltip .smart-scheduler-items-container:focus .smart-scheduler-item[selected] {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    border-color: #e2e0e0;
    border-color: var(--smart-ui-state-border-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-scheduler-tooltip .smart-scheduler-item {
    cursor: pointer;
    height: auto;
    padding-right: 24px;
    padding-right: calc(var(--smart-scheduler-shortcut-size) - 4px);
    position: relative;
    width: 100%
}

.smart-scheduler-tooltip .smart-scheduler-item:after {
    align-items: center;
    box-sizing: border-box;
    content: attr(shortcut-key);
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0 6px 0 10px;
    opacity: .5;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    white-space: nowrap;
    width: 28px;
    width: var(--smart-scheduler-shortcut-size)
}

.smart-scheduler-tooltip .smart-scheduler-item:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-scheduler-tooltip .smart-scheduler-item[checkable]:after {
    content: "";
    left: 0;
    margin: initial;
    opacity: 1;
    right: auto
}

.smart-scheduler-tooltip .smart-scheduler-item[checkable]>div {
    padding-left: 28px;
    padding-left: var(--smart-scheduler-shortcut-size);
    padding-right: 0
}

.smart-scheduler-tooltip .smart-scheduler-item[checkable][checked]:after {
    content: "\\e908";
    content: var(--smart-icon-check);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size)
}

.smart-scheduler-tooltip .smart-scheduler-item[separator] {
    margin-top: 15px;
    position: relative
}

.smart-scheduler-tooltip .smart-scheduler-item[separator]:before {
    border-bottom: 1px solid #e0e0e0;
    border-bottom: var(--smart-border-width) solid var(--smart-border);
    bottom: 100%;
    content: "";
    display: flex;
    left: 0;
    margin: 7px 0;
    position: absolute;
    width: 100%
}

.smart-scheduler-tooltip .smart-scheduler-item>div {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    padding: 10px 28px 10px 12px;
    padding: 10px var(--smart-scheduler-shortcut-size) 10px 12px;
    position: relative;
    text-overflow: ellipsis;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
    width: 100%
}

.smart-scheduler-tooltip .smart-scheduler-event {
    grid-column-gap: 10px;
    --smart-scheduler-event-focus: var(--smart-ui-state-focus);
    --smart-scheduler-event-color-focus: var(--smart-ui-state-color-focus);
    --smart-scheduler-event-hover: var(--smart-ui-state-hover);
    --smart-scheduler-event-color-hover: var(--smart-ui-state-color-hover);
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    cursor: pointer;
    display: grid;
    grid-template-columns: 20px minmax(0, 1fr) 30px;
    grid-template-columns: 20px minmax(0, 1fr) var(--smart-scheduler-event-button-size);
    height: 50px !important;
    height: var(--smart-scheduler-event-item-size) !important;
    justify-content: center;
    left: auto !important;
    outline: 0;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    position: relative;
    right: auto !important;
    top: auto !important;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    width: 100% !important
}

.smart-scheduler-tooltip .smart-scheduler-event:before {
    align-items: center;
    background: #3479ba;
    background: var(--smart-scheduler-event-background);
    border-radius: 50%;
    box-sizing: border-box;
    content: "";
    display: flex;
    height: 20px;
    justify-content: center;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    pointer-events: none;
    width: 20px
}

.smart-scheduler-tooltip .smart-scheduler-event:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-scheduler-tooltip .smart-scheduler-event[hover] .smart-scheduler-event-button:hover {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-scheduler-tooltip .smart-scheduler-event .smart-scheduler-event-content {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-scheduler-tooltip .smart-scheduler-event .smart-scheduler-event-content>div {
    align-self: flex-start;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-scheduler-tooltip .smart-scheduler-context-menu {
    align-items: center;
    display: grid;
    height: 100%;
    justify-content: flex-start;
    width: 100%
}

.smart-scheduler-tooltip .smart-scheduler-context-menu .smart-scheduler-context-menu-item {
    align-items: center;
    background: #fefefe;
    background: var(--smart-background);
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-item-border-bottom-left-radius);
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-item-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-item-border-top-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-item-border-top-right-radius);
    color: #5a5a5a;
    color: var(--smart-background-color);
    display: flex;
    height: 36px;
    height: var(--smart-list-item-height);
    padding: 9px 12px;
    padding: var(--smart-list-item-padding);
    text-overflow: ellipsis;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap
}

.smart-notification-panel .smart-notification-item .smart-button[delete]:active,
.smart-notification-panel .smart-notification-item .smart-button[delete]:hover,
.smart-scheduler-tooltip .smart-scheduler-event-button:hover {
    background-color: #ebebeb;
    background-color: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-scheduler-tooltip .smart-scheduler-context-menu .smart-scheduler-context-menu-item:hover {
    background: #ebebeb;
    background: var(--smart-ui-state-hover);
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-scheduler-tooltip .smart-scheduler-context-menu .smart-scheduler-context-menu-item[selected],
.smart-scheduler-tooltip .smart-scheduler-event[selected],
.smart-scheduler-tooltip .smart-scheduler-item[selected] {
    background-color: rgba(0, 92, 153, .1);
    background-color: var(--smart-ui-state-selected);
    border-color: rgba(0, 92, 153, .1);
    border-color: var(--smart-ui-state-border-selected);
    color: #005c99;
    color: var(--smart-ui-state-color-selected)
}

.smart-scheduler-tooltip .smart-scheduler-context-menu .smart-scheduler-context-menu-item[disabled],
.smart-scheduler-tooltip .smart-scheduler-event[disabled],
.smart-scheduler-tooltip .smart-scheduler-item[disabled] {
    cursor: default;
    opacity: .55;
    pointer-events: none
}

.smart-scheduler-tooltip .smart-scheduler-collector-event-list {
    height: 100%;
    width: 100%
}

.smart-scheduler-tooltip .smart-scroll-viewer {
    --smart-scroll-viewer-max-height: var(--smart-scheduler-context-menu-max-height);
    --smart-scroll-viewer-max-width: var(--smart-scheduler-context-menu-max-width);
    --smart-list-box-default-height: auto;
    border: initial;
    padding: initial;
    width: auto
}

.smart-notification-panel .smart-notification-item .smart-input,
.smart-scheduler-tooltip .smart-scheduler-event-button {
    border-bottom-left-radius: 4px;
    border-bottom-left-radius: var(--smart-border-bottom-left-radius);
    border-top-right-radius: 4px;
    border-top-right-radius: var(--smart-border-top-right-radius);
    outline: 0
}

.smart-scheduler-tooltip .smart-scroll-viewer .smart-scroll-viewer-container.vscroll .smart-scheduler-context-menu {
    padding-right: 18px;
    padding-right: var(--smart-scroll-bar-size)
}

.smart-scheduler-tooltip .smart-scroll-viewer .smart-scroll-viewer-container .smart-scroll-viewer-content-container {
    padding: initial
}

.smart-scheduler-tooltip .smart-scheduler-event-button {
    align-items: center;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-color: #e0e0e0;
    border-color: var(--smart-border);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    display: flex;
    height: var(--smart-scheduler-collector-item-button-size);
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: var(--smart-scheduler-collector-item-button-size)
}

.smart-scheduler-tooltip .smart-scheduler-event-button:active {
    background-color: #005c99;
    background-color: var(--smart-ui-state-active);
    color: #fff;
    color: var(--smart-ui-state-color-active)
}

.smart-scheduler-tooltip .smart-scheduler-event-button:focus {
    background-color: #e2e0e0;
    background-color: var(--smart-ui-state-focus);
    color: #333;
    color: var(--smart-ui-state-color-focus)
}

.smart-scheduler-tooltip .smart-scheduler-event-button:before {
    box-sizing: border-box;
    content: "\\e826";
    content: var(--smart-icon-delete);
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 18px;
    font-size: var(--smart-button-large-font-size);
    pointer-events: none;
    position: absolute
}

.smart-scheduler-tooltip .smart-scheduler-event-label {
    font-size: 14px;
    font-size: var(--smart-scheduler-event-label-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-label-font-weight);
    pointer-events: none;
    white-space: nowrap
}

.smart-scheduler-tooltip .smart-scheduler-event-time {
    font-size: 11px;
    font-size: var(--smart-scheduler-event-time-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-time-font-weight);
    opacity: .7;
    opacity: var(--smart-scheduler-event-time-opacity);
    pointer-events: none;
    white-space: nowrap
}

.smart-scheduler-tooltip:not([animation=none]) {
    -webkit-animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    animation: smart-drop-down-list-smart-animate-closing .2s ease-in;
    transition: opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in;
    transition: animation .2s ease-in, opacity .2s ease-in, visibility .2s ease-in, -webkit-animation .2s ease-in
}

.smart-scheduler-tooltip:not([animation=none])[visible] {
    -webkit-animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    animation: smart-drop-down-list-smart-animate-opening .2s ease-out;
    transition: opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out;
    transition: animation .2s ease-out, opacity .2s ease-out, visibility .2s ease-out, -webkit-animation .2s ease-out
}

.smart-scheduler-tooltip:not([arrow-direction]),
.smart-scheduler-tooltip[arrow-direction=bottom] {
    -webkit-transform-origin: bottom;
    transform-origin: bottom
}

.smart-scheduler-tooltip:not([arrow]),
.smart-scheduler-tooltip[arrow-direction=top] {
    -webkit-transform-origin: top;
    transform-origin: top
}

.smart-scheduler-tooltip[right-to-left] .smart-scheduler-item {
    padding-left: 24px;
    padding-left: calc(var(--smart-scheduler-shortcut-size) - 4px);
    padding-right: 0
}

.smart-scheduler-tooltip[right-to-left] .smart-scheduler-item:after {
    left: 0;
    margin: 0 10px 0 6px;
    right: auto
}

.smart-scheduler-tooltip[right-to-left] .smart-scheduler-item>div {
    padding: 10px 12px 10px 28px;
    padding: 10px 12px 10px var(--smart-scheduler-shortcut-size)
}

.smart-scheduler-drag-feedback {
    -webkit-tap-highlight-color: transparent;
    background: 0 0;
    border-radius: initial;
    border-radius: var(--smart-scheduler-event-border-radius);
    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 3px rgba(0, 0, 0, .12), 0 4px 15px 0 rgba(0, 0, 0, .2);
    box-shadow: var(--smart-elevation-8);
    box-sizing: border-box;
    cursor: move;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    opacity: .75;
    outline: 0;
    padding: initial;
    pointer-events: none;
    position: absolute;
    text-align: center;
    z-index: 10000
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content {
    grid-row-gap: 2px;
    align-items: center;
    background: #3479ba;
    background: var(--smart-scheduler-event-background);
    border-radius: inherit;
    box-sizing: border-box;
    color: #fff;
    color: var(--smart-scheduler-event-color);
    cursor: pointer;
    display: grid;
    grid-template-rows: -webkit-min-content minmax(auto, 1fr);
    grid-template-rows: min-content minmax(auto, 1fr);
    height: 100%;
    justify-content: flex-start;
    justify-items: flex-start;
    max-height: 100%;
    overflow: hidden;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    position: relative;
    width: 100%
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content[single-line] {
    grid-column-gap: 5px;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    justify-content: space-between
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content[single-line]>div {
    align-self: auto
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content:not([single-line])>div:not(:first-of-type) {
    grid-column: 1/span 2
}

.smart-scheduler-drag-feedback .smart-scheduler-event-label {
    font-size: 14px;
    font-size: var(--smart-scheduler-event-label-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-label-font-weight);
    pointer-events: none;
    white-space: nowrap
}

.smart-scheduler-drag-feedback .smart-scheduler-event-time {
    font-size: 11px;
    font-size: var(--smart-scheduler-event-time-font-size);
    font-weight: 300;
    font-weight: var(--smart-scheduler-event-time-font-weight);
    opacity: .7;
    opacity: var(--smart-scheduler-event-time-opacity);
    pointer-events: none;
    white-space: pre-wrap
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content {
    grid-template-columns: minmax(auto, 1fr)
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content>div {
    align-self: flex-start;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis
}

.smart-scheduler-drag-feedback .smart-scheduler-event-content>div:first-of-type {
    align-self: center
}

.smart-scheduler-drag-feedback[status] .smart-scheduler-event-content:before {
    background: transparent;
    background: var(--smart-scheduler-status-background);
    border: 1px solid #e0e0e0;
    border: 1px solid var(--smart-border);
    border-radius: 20px;
    box-shadow: 0 0 0 .5px #fefefe;
    box-shadow: 0 0 0 .5px var(--smart-background);
    box-sizing: border-box;
    content: "";
    display: block;
    height: 100%;
    overflow: hidden;
    position: absolute;
    width: 7px;
    width: var(--smart-scheduler-status-size)
}

.smart-scheduler-drag-feedback[status]:not([view-type=agenda]) .smart-scheduler-event-content {
    padding-left: 12px;
    padding-left: calc(var(--smart-scheduler-status-size) + var(--smart-scheduler-status-padding))
}

.smart-scheduler-drag-feedback[status=free] .smart-scheduler-event-content:before {
    background: #fff;
    background: var(--smart-scheduler-status-free-background)
}

.smart-scheduler-drag-feedback[status=busy] .smart-scheduler-event-content:before {
    background: #dc3545;
    background: var(--smart-scheduler-status-busy-background)
}

.smart-scheduler-drag-feedback[status=outOfOffice] .smart-scheduler-event-content:before {
    background: #00a9e6;
    background: var(--smart-scheduler-status-out-of-office-background)
}

.smart-scheduler-drag-feedback[status=tentative] .smart-scheduler-event-content:before {
    background: 0 -244rem/5rem 5rem linear-gradient(45deg, #fd7e14 25%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2) 50%, #fd7e14 0, #fd7e14 75%, rgba(0, 0, 0, .2) 0, rgba(0, 0, 0, .2));
    background: var(--smart-scheduler-status-tentative-background)
}

.smart-scheduler-drag-feedback[view-type=agenda] .smart-scheduler-event-time {
    font-size: 14px;
    font-size: var(--smart-scheduler-event-time-font-size-agenda);
    font-weight: 600;
    font-weight: var(--smart-scheduler-event-time-font-weight-agenda);
    opacity: 1;
    opacity: var(--smart-scheduler-event-time-opacity-agenda)
}

.smart-scheduler-drag-feedback[view-type=agenda] .smart-scheduler-event,
.smart-scheduler-drag-feedback[view-type=agenda] .smart-scheduler-event-content>div {
    padding: 5px;
    padding: var(--smart-scheduler-event-padding-agenda)
}

.smart-scheduler-drag-feedback[view-type=agenda][status] .smart-scheduler-event-content:before {
    content: normal
}

.smart-scheduler-drag-feedback:not([view-type^=timeline]) {
    width: 30px;
    width: var(--smart-scheduler-event-size)
}

.smart-scheduler-drag-feedback:not([view-type^=timeline]) .smart-scheduler-event-content>div {
    padding: 2px;
    padding: var(--smart-scheduler-event-padding-basic)
}

.smart-scheduler-drag-feedback[view-type^=timeline] .smart-scheduler-event-content>div {
    padding: 2px;
    padding: var(--smart-scheduler-event-padding-timeline)
}

.smart-scheduler-drag-feedback[mobile]:not([view-type^=timeline]) {
    min-width: 60px;
    min-width: var(--smart-scheduler-event-size-timeline)
}

.smart-scheduler-drag-feedback[exception] .smart-scheduler-event-content,
.smart-scheduler-drag-feedback[repeating] .smart-scheduler-event-content {
    grid-template-columns: minmax(auto, 1fr) 30px;
    grid-template-columns: minmax(auto, 1fr) var(--smart-scheduler-event-icon-size)
}

.smart-scheduler-drag-feedback:not([repeating]) .smart-scheduler-event-content:not([single-line])>div {
    grid-column: 1/span 2
}

.smart-scheduler-drag-feedback[repeating] .smart-scheduler-event-content:after {
    align-items: center;
    box-sizing: border-box;
    content: "\\e80b";
    content: var(--smart-icon-spin);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    justify-content: center;
    line-height: 1rem;
    padding: 5px;
    padding: var(--smart-scheduler-event-content-padding);
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    width: var(--smart-scheduler-event-icon-size)
}

.smart-scheduler-drag-feedback[repeating] .smart-scheduler-event-content[single-line] {
    grid-template-columns: repeat(2, auto) 30px;
    grid-template-columns: repeat(2, auto) var(--smart-scheduler-event-icon-size)
}

.smart-scheduler-drag-feedback[repeating][exception] .smart-scheduler-event-content:after {
    content: "\\e805";
    content: var(--smart-icon-attention-circled)
}

.smart-scheduler-drag-feedback[right-to-left] {
    direction: rtl
}

.smart-scheduler-drag-feedback[right-to-left]:not([view-type=agenda])[status] .smart-scheduler-event-content {
    padding-left: 0;
    padding-right: 12px;
    padding-right: calc(var(--smart-scheduler-status-size) + var(--smart-scheduler-status-padding))
}

.smart-scheduler-drag-feedback[right-to-left][repeating] .smart-scheduler-event-content:after {
    left: 0;
    right: auto
}

.smart-dragging-disabled {
    cursor: no-drop
}

.smart-notification-panel {
    contain: content;
    display: inline-block;
    height: auto;
    max-height: 100px;
    width: auto
}

.smart-notification-panel:focus {
    border-color: #b2b2b2;
    border-color: var(--smart-outline)
}

.smart-notification-panel.smart-container,
.smart-notification-panel>.smart-container {
    max-height: inherit;
    overflow: auto;
    padding: 4px;
    padding: var(--smart-editor-label-padding)
}

.smart-notification-panel .smart-notification-container {
    display: flex;
    flex-direction: column;
    width: 100%
}

.smart-notification-panel .smart-notification-container:empty {
    display: none
}

.smart-notification-panel .smart-notification-item,
.smart-notification-panel .smart-notification-placeholder {
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none
}

.smart-notification-panel .smart-notification-item {
    grid-column-gap: 10px;
    align-items: center;
    display: inline-grid;
    grid-template-columns: repeat(4, minmax(0, 1fr)) 30px;
    grid-template-columns: repeat(4, minmax(0, 1fr)) var(--smart-editor-height);
    justify-items: center;
    padding: 0 0 4px;
    padding: 0 0 var(--smart-editor-label-padding)
}

.smart-notification-panel .smart-notification-item .smart-input {
    align-items: center;
    background: #f5f5f5;
    background: var(--smart-surface);
    border: 1px solid transparent;
    border: var(--smart-border-width) solid transparent;
    border-bottom-right-radius: 4px;
    border-bottom-right-radius: var(--smart-border-bottom-right-radius);
    border-top-left-radius: 4px;
    border-top-left-radius: var(--smart-border-top-left-radius);
    color: #323232;
    color: var(--smart-surface-color);
    cursor: pointer;
    display: inline-flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 30px;
    height: var(--smart-editor-height);
    overflow: hidden;
    padding: 4px;
    padding: var(--smart-editor-label-padding);
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%
}

.smart-notification-panel .smart-notification-item .smart-input[interval]:after,
.smart-notification-panel .smart-notification-item .smart-input[interval]:before,
.smart-notification-panel .smart-notification-item .smart-input[type]:after {
    align-items: center;
    box-sizing: border-box;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    height: 100%;
    justify-content: center;
    outline: 0;
    overflow: hidden;
    position: absolute;
    right: -1px;
    top: 1px;
    width: 27px;
    width: var(--smart-editor-addon-width)
}

.smart-notification-panel .smart-notification-item .smart-input[interval]:before {
    border-bottom: 1px solid transparent;
    border-bottom: var(--smart-border-width) solid transparent;
    content: "\\e904";
    content: var(--smart-icon-arrow-up);
    height: 50%;
    top: 0
}

.smart-notification-panel .smart-notification-item .smart-input[interval]:after {
    bottom: 0;
    content: "\\e901";
    content: var(--smart-icon-arrow-down);
    height: 50%;
    top: auto
}

.smart-notification-panel .smart-notification-item .smart-button[delete] {
    align-items: center;
    border-radius: 50%;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 30px;
    height: var(--smart-editor-height);
    justify-content: center;
    opacity: .25;
    outline: 0;
    position: relative;
    width: 30px;
    width: var(--smart-editor-height)
}

.smart-notification-panel .smart-notification-item .smart-button[delete]:after {
    align-items: center;
    content: "\\1F5D9";
    content: var(--smart-icon-close);
    cursor: pointer;
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: 14px;
    font-size: var(--smart-font-size);
    height: 0;
    justify-content: center;
    width: 100%
}

.smart-notification-panel .smart-notification-placeholder,
.smart-notification-panel .smart-notification-placeholder .smart-input {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    font-family: Roboto, Helvetica Neue, sans-serif;
    font-family: var(--smart-font-family);
    font-size: 14px;
    font-size: var(--smart-font-size);
    outline: 0
}

.smart-notification-panel .smart-notification-item .smart-button[delete]:hover {
    opacity: .6
}

.smart-notification-panel .smart-notification-item .smart-button[delete]:active {
    opacity: 1
}

.smart-notification-panel .smart-notification-item .smart-button[delete]:focus,
.smart-notification-panel .smart-notification-item .smart-input:focus {
    box-shadow: 0 0 0 1px #b2b2b2;
    box-shadow: 0 0 0 1px var(--smart-outline)
}

.smart-notification-panel .smart-notification-placeholder {
    border-bottom: 1px solid #005c99;
    border-bottom: var(--smart-border-width) solid var(--smart-primary);
    color: #005c99;
    color: var(--smart-primary)
}

.smart-notification-panel .smart-notification-placeholder .smart-input {
    border: 1px solid transparent;
    border: var(--smart-border-width) solid transparent
}

.smart-notification-panel .smart-notification-placeholder:hover {
    color: #333;
    color: var(--smart-ui-state-color-hover)
}

.smart-notification-panel .smart-notification-editor {
    background: #fefefe;
    background: var(--smart-background);
    color: #5a5a5a;
    color: var(--smart-background-color);
    position: absolute
}

.smart-notification-panel label {
    align-items: center;
    display: inline-flex;
    justify-content: center
}

.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[interval] {
    padding-left: 31px;
    padding-left: calc(var(--smart-editor-addon-width) + var(--smart-editor-label-padding))
}

.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[interval]:after,
.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[interval]:before,
.smart-notification-panel[right-to-left] .smart-notification-item .smart-input[type]:after {
    left: -1px;
    right: auto
}

.smart-scheduler-loading-container .smart-loader-label {
    margin-left: 5px;
    margin-top: 35px;
    margin-top: calc(5px + var(--smart-loader-size))
}

.smart-scheduler-loader,
.smart-scheduler-loading-container .smart-loader-label {
    left: 50%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 99
}

.smart-scheduler-loader {
    background-clip: padding-box;
    border: 6px solid rgba(43, 51, 63, .1);
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    height: 40px;
    height: calc(var(--smart-loader-size) + 10px);
    margin: inherit;
    opacity: .85;
    text-align: left;
    width: 40px;
    width: calc(var(--smart-loader-size) + 10px)
}

.smart-scheduler-loader:after,
.smart-scheduler-loader:before {
    -webkit-animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    border: transparent;
    border-radius: inherit;
    border-width: 6px;
    box-sizing: inherit;
    content: "";
    height: inherit;
    margin: -6px;
    opacity: 1;
    position: absolute;
    width: inherit
}

.smart-color-input-drop-down-menu.smart-scheduler-color-input .default-samples-container div {
    border: initial;
    border-radius: 50%;
    position: relative;
    -webkit-transform: scale(.95);
    transform: scale(.95)
}

.smart-color-input-drop-down-menu.smart-scheduler-color-input .default-samples-container div.selected {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.smart-color-input-drop-down-menu.smart-scheduler-color-input .default-samples-container div.selected:not(.no-color):after {
    align-items: center;
    border-radius: inherit;
    color: #fff;
    color: var(--smart-secondary-color);
    content: "\\e908";
    content: var(--smart-icon-check);
    display: flex;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.smart-scheduler-color-input {
    --smart-input-drop-down-menu-width: auto
}

.drawContainer,
.smart-arrow,
.smart-container {
    height: 100%;
    width: 100%
}

.smart-container {
    display: block;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    outline: 0;
    padding: 0
}

.smart-container,
.smart-container * {
    box-sizing: border-box
}

.smart-drop-down,
.smart-popup {
    box-sizing: border-box;
    list-style-type: none;
    margin: 5px 0;
    margin: var(--smart-editor-drop-down-vertical-offset) 0;
    position: absolute;
    z-index: 9999;
    z-index: var(--smart-editor-drop-down-z-index)
}

.smart-icons {
    word-wrap: normal;
    -webkit-font-smoothing: antialiased;
    direction: ltr;
    display: inline-block;
    font-family: smart-icons;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 1;
    text-transform: none;
    white-space: nowrap
}

.smart-arrow {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 1em 1em
}

.smart-arrow-down:after,
.smart-arrow-left-first:after,
.smart-arrow-left:after,
.smart-arrow-right-last:after,
.smart-arrow-right:after,
.smart-arrow-up:after {
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    align-items: center;
    color: inherit;
    display: flex;
    flex-wrap: wrap;
    font-family: smart-icons;
    font-family: var(--smart-font-family-icon);
    font-size: var(--smart-arrow-size);
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    height: 100%;
    justify-content: center;
    position: relative;
    text-decoration: inherit;
    text-transform: none;
    width: 100%
}

.smart-arrow-up:after {
    content: "\\e904";
    content: var(--smart-icon-arrow-up);
    top: -1px
}

.smart-arrow-down:after {
    content: "";
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAfElEQVRIie3PsQ3CQBBE0QemG9oxEfRByJHRBhF1EFATgZFM4pOQsI3Ouoz98eyfWYIg+MW2UmaUhBf2M5kWHS5TgfXM8RMNrhMlLW7YDNlFHNH7/iQv73FaKh8rOWBXU55Jg7D7kKda8kz+pGh5U1DwwAp3nIumBcGf8wYS/R0c31jcewAAAABJRU5ErkJggg==');
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 19px;
}

.smart-arrow-left:after {
    content: "\\e902";
}
.smart-arrow-left-first:after {
    content: "\\e900";
    content: var(--smart-icon-first-page)
}

.smart-arrow-right-last:after {
    content: "\\e905";
    content: var(--smart-icon-last-page)
}

.smart-arrow-right:after {
    content: "\\e903";
}

.drawContainer {
    position: relative
}

.smart-ripple {
    -webkit-animation: ripple .35s linear;
    animation: ripple .35s linear;
    border: none;
    border-radius: 50%;
    display: block;
    opacity: .5;
    pointer-events: none;
    position: absolute;
    -webkit-transform: scale(0);
    transform: scale(0)
}

.smart-ripple.smart-animate {
    -webkit-animation: ripple .65s linear;
    animation: ripple .65s linear;
    position: absolute
}

@-webkit-keyframes ripple {
    to {
        opacity: 0;
        -webkit-transform: scale(2.5);
        transform: scale(2.5)
    }
}

@keyframes ripple {
    to {
        opacity: 0;
        -webkit-transform: scale(2.5);
        transform: scale(2.5)
    }
}

.smart-overlay {
    pointer-events: none
}

.smart-unselectable {
    -webkit-user-select: none;
    -ms-user-select: none;
    -moz-user-select: none
}

.smart-hidden {
    display: none !important
}

.smart-visibility-hidden {
    visibility: hidden !important
}

.smart-element-init {
    visibility: hidden
}

.smart-element-ready {
    overflow: hidden
}

.smart-shown {
    display: block
}

.smart-resize-trigger,
.smart-resize-trigger-shrink {
    left: 0;
    position: absolute;
    top: 0;
    transition: 0s
}

.smart-resize-trigger-shrink {
    height: 200%;
    width: 200%
}

.smart-resize-trigger-container {
    display: block;
    height: 100%;
    left: 0;
    min-height: 1px;
    overflow: hidden;
    pointer-events: none;
    position: relative;
    top: -100%;
    visibility: hidden;
    width: 100%;
    z-index: -1
}

.smart-list-menu-view.smart-drop-down-repositioned .smart-loader,
smart-card-view .smart-loader,
smart-grid .smart-loader,
smart-list-box .smart-loader,
smart-list-menu .smart-loader,
smart-table .smart-loader,
smart-tree .smart-loader {
    background-clip: padding-box;
    border: 6px solid rgba(43, 51, 63, .1);
    border-radius: 50%;
    box-sizing: border-box;
    display: block;
    height: 40px;
    height: calc(var(--smart-loader-size) + 10px);
    left: 50%;
    margin: inherit;
    opacity: .85;
    position: absolute;
    text-align: left;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 40px;
    width: calc(var(--smart-loader-size) + 10px);
    z-index: 10
}

.smart-list-menu-view.smart-drop-down-repositioned .smart-loader:after,
.smart-list-menu-view.smart-drop-down-repositioned .smart-loader:before,
smart-card-view .smart-loader:after,
smart-card-view .smart-loader:before,
smart-grid .smart-loader:after,
smart-grid .smart-loader:before,
smart-list-box .smart-loader:after,
smart-list-box .smart-loader:before,
smart-list-menu .smart-loader:after,
smart-list-menu .smart-loader:before,
smart-table .smart-loader:after,
smart-table .smart-loader:before,
smart-tree .smart-loader:after,
smart-tree .smart-loader:before {
    -webkit-animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    animation: smart-loader-spin 1.1s cubic-bezier(.6, .2, 0, .8) infinite, smart-loader-spin-fade 1.1s linear infinite;
    border: 6px solid transparent;
    border-radius: inherit;
    box-sizing: inherit;
    content: "";
    height: inherit;
    margin: -6px;
    opacity: 1;
    position: absolute;
    width: inherit
}

.smart-list-menu-view.smart-drop-down-repositioned .smart-loader.smart-hidden,
smart-card-view .smart-loader.smart-hidden,
smart-grid .smart-loader.smart-hidden,
smart-list-box .smart-loader.smart-hidden,
smart-list-menu .smart-loader.smart-hidden,
smart-table .smart-loader.smart-hidden,
smart-tree .smart-loader.smart-hidden {
    display: none
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=bottom] .smart-loader,
.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=top] .smart-loader,
smart-grid[loading-indicator-position=bottom] .smart-loader,
smart-grid[loading-indicator-position=top] .smart-loader,
smart-list-box[loading-indicator-position=bottom] .smart-loader,
smart-list-box[loading-indicator-position=top] .smart-loader,
smart-list-menu[loading-indicator-position=bottom] .smart-loader,
smart-list-menu[loading-indicator-position=top] .smart-loader,
smart-tree[loading-indicator-position=bottom] .smart-loader,
smart-tree[loading-indicator-position=top] .smart-loader {
    height: 30px;
    height: var(--smart-loader-size);
    left: 20%;
    width: 30px;
    width: var(--smart-loader-size)
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=bottom] .smart-loader-container,
.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=top] .smart-loader-container,
smart-grid[loading-indicator-position=bottom] .smart-loader-container,
smart-grid[loading-indicator-position=top] .smart-loader-container,
smart-list-box[loading-indicator-position=bottom] .smart-loader-container,
smart-list-box[loading-indicator-position=top] .smart-loader-container,
smart-list-menu[loading-indicator-position=bottom] .smart-loader-container,
smart-list-menu[loading-indicator-position=top] .smart-loader-container,
smart-tree[loading-indicator-position=bottom] .smart-loader-container,
smart-tree[loading-indicator-position=top] .smart-loader-container {
    -webkit-animation: smart-loader-container-pop-up-down .3s linear;
    animation: smart-loader-container-pop-up-down .3s linear;
    background-color: #f2f2f2;
    display: block;
    height: 10%;
    overflow: hidden;
    position: relative;
    width: 100%
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=bottom] .smart-loader-container.smart-hidden,
.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=top] .smart-loader-container.smart-hidden,
smart-grid[loading-indicator-position=bottom] .smart-loader-container.smart-hidden,
smart-grid[loading-indicator-position=top] .smart-loader-container.smart-hidden,
smart-list-box[loading-indicator-position=bottom] .smart-loader-container.smart-hidden,
smart-list-box[loading-indicator-position=top] .smart-loader-container.smart-hidden,
smart-list-menu[loading-indicator-position=bottom] .smart-loader-container.smart-hidden,
smart-list-menu[loading-indicator-position=top] .smart-loader-container.smart-hidden,
smart-tree[loading-indicator-position=bottom] .smart-loader-container.smart-hidden,
smart-tree[loading-indicator-position=top] .smart-loader-container.smart-hidden {
    display: none
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=bottom] .smart-loader-label,
.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=top] .smart-loader-label,
smart-grid[loading-indicator-position=bottom] .smart-loader-label,
smart-grid[loading-indicator-position=top] .smart-loader-label,
smart-list-box[loading-indicator-position=bottom] .smart-loader-label,
smart-list-box[loading-indicator-position=top] .smart-loader-label,
smart-list-menu[loading-indicator-position=bottom] .smart-loader-label,
smart-list-menu[loading-indicator-position=top] .smart-loader-label,
smart-tree[loading-indicator-position=bottom] .smart-loader-label,
smart-tree[loading-indicator-position=top] .smart-loader-label {
    display: block;
    font-family: inherit;
    font-size: inherit;
    left: 60%;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    vertical-align: middle;
    white-space: nowrap
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=top] .smart-loader-container,
smart-grid[loading-indicator-position=top] .smart-loader-container,
smart-list-box[loading-indicator-position=top] .smart-loader-container,
smart-list-menu[loading-indicator-position=top] .smart-loader-container,
smart-tree[loading-indicator-position=top] .smart-loader-container {
    -webkit-animation: smart-loader-container-pop-up-top .3s linear;
    animation: smart-loader-container-pop-up-top .3s linear;
    position: absolute;
    top: 0
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=bottom] .smart-loader-container,
smart-grid[loading-indicator-position=bottom] .smart-loader-container,
smart-list-box[loading-indicator-position=bottom] .smart-loader-container,
smart-list-menu[loading-indicator-position=bottom] .smart-loader-container,
smart-tree[loading-indicator-position=bottom] .smart-loader-container {
    top: -10%
}

.smart-list-menu-view.smart-drop-down-repositioned[loading-indicator-position=center] .smart-loader,
smart-grid[loading-indicator-position=center] .smart-loader,
smart-list-box[loading-indicator-position=center] .smart-loader,
smart-list-menu[loading-indicator-position=center] .smart-loader,
smart-tree[loading-indicator-position=center] .smart-loader {
    height: 40px;
    height: calc(var(--smart-loader-size) + 10px);
    width: 40px;
    width: calc(var(--smart-loader-size) + 10px)
}

smart-grid[disabled] .smart-loader:after,
smart-grid[disabled] .smart-loader:before,
smart-list-box[disabled] .smart-loader:after,
smart-list-box[disabled] .smart-loader:before,
smart-list-menu[disabled] .smart-loader:after,
smart-list-menu[disabled] .smart-loader:before,
smart-tree[disabled] .smart-loader:after,
smart-tree[disabled] .smart-loader:before {
    -webkit-animation: none;
    animation: none
}

@-webkit-keyframes smart-loader-container-pop-up-down {
    0% {
        top: 0
    }

    20% {
        top: -2%
    }

    35% {
        top: -6%
    }

    60% {
        top: -8%
    }

    to {
        top: -10%
    }
}

@keyframes smart-loader-container-pop-up-down {
    0% {
        top: 0
    }

    20% {
        top: -2%
    }

    35% {
        top: -6%
    }

    60% {
        top: -8%
    }

    to {
        top: -10%
    }
}

@-webkit-keyframes smart-loader-container-pop-up-top {
    0% {
        top: -10%
    }

    20% {
        top: -8%
    }

    35% {
        top: -6%
    }

    60% {
        top: -2%
    }

    to {
        top: 0
    }
}

@keyframes smart-loader-container-pop-up-top {
    0% {
        top: -10%
    }

    20% {
        top: -8%
    }

    35% {
        top: -6%
    }

    60% {
        top: -2%
    }

    to {
        top: 0
    }
}

@-webkit-keyframes smart-loader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes smart-loader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@-webkit-keyframes smart-loader-spin-fade {

    0%,
    20%,
    60%,
    to {
        border-top-color: #7a7a7a
    }

    35% {
        border-top-color: transparent
    }
}

@keyframes smart-loader-spin-fade {

    0%,
    20%,
    60%,
    to {
        border-top-color: #7a7a7a
    }

    35% {
        border-top-color: transparent
    }
}

.smart-right-to-left {
    direction: rtl
}

.smart-micro {
    font-size: 9px
}

.smart-caps {
    letter-spacing: .1em;
    text-transform: uppercase
}

.smart-strong {
    font-weight: 500
}

.smart-truncate {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.smart-flex-auto {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0
}

.smart-flex {
    align-items: center;
    display: flex
}

.smart-quiet {
    opacity: .75
}

.smart-dragging,
.smart-dragging * {
    cursor: move !important
}
input[type=date]::-webkit-calendar-picker-indicator {
    background-image: url("data:image/svg+xml;base64,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");
  }
   `}
    </style>
  );
}

export { StyleSmartWebcomponents };
